
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("M3hWz", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeletonInteractiveSSR", () => $3b55a543569211e8$export$fa4a5af93371d2d1);
/*
 * An interactive version of the search input skeleton which allows users to
 * type into the skeleton's input. The state of the skeleton input is saved in
 * the browser's storage (specifically within window.inputSkeletonState).
 *
 * This component is intended to be used for server side rendering only as
 * the event listeners for the input are attached via a HTML script tag.
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $aDlrJ = parcelRequire("aDlrJ");
var $eSS4z = parcelRequire("eSS4z");
const $3b55a543569211e8$export$fa4a5af93371d2d1 = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eSS4z.ThemeProvider), {
        partialSearchCSS: props.theme,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aDlrJ.SearchInputSkeletonInteractiveSSR), {
            ...props
        })
    });
};

});
parcelRegister("aDlrJ", function(module, exports) {

$parcel$export(module.exports, "SearchInputSkeletonInteractiveSSR", () => $a560394ad49f84af$export$ed08cb5579938462);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $fwSxy = parcelRequire("fwSxy");

var $iSHbD = parcelRequire("iSHbD");

var $2wQTl = parcelRequire("2wQTl");

var $eSS4z = parcelRequire("eSS4z");
const $a560394ad49f84af$export$ed08cb5579938462 = ({ advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes, shouldFillContainer: shouldFillContainer })=>{
    const theme = (0, $eSS4z.useTheme)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRsearchInputWrapper), {
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            id: "ssr-search-input-popout-container",
            "data-ssr-placeholder": "search-input",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fwSxy.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false,
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            dangerouslySetInnerHTML: {
                                __html: (0, $2wQTl.script)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};

});
parcelRegister("2wQTl", function(module, exports) {

$parcel$export(module.exports, "script", () => $da2d6e1979a6c520$export$bc237d627614fc48);
/* eslint-disable */ // @ts-ignore
const $da2d6e1979a6c520$export$bc237d627614fc48 = `(function(document,window){var _a;var getWeakRef=function(queryId){var element=document.getElementById(queryId);if(!element){return null}return new WeakRef(element)};var currentInput=getWeakRef("ssr-search-input");var container=getWeakRef("ssr-input-container");var topContainer=getWeakRef("ssr-search-input-popout-container");var iconWrapper=getWeakRef("ssr-search-icon-wrapper");var formContainer=getWeakRef("ssr-form-container");var pageWidth=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;if(window["inputSkeletonState"]){for(var _i=0,_b=window["inputSkeletonState"].listeners;_i<_b.length;_i++){var listener=_b[_i];var target=listener[0],event_1=listener[1],handler=listener[2];target.removeEventListener(event_1,handler)}window["inputSkeletonState"].listeners=[]}function setExpandedStyles(){var _a,_b,_c,_d,_e,_f;(_a=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_a===void 0?void 0:_a.setAttribute("style","color: rgb(9, 30, 66);");if(pageWidth<=1130){(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_c=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_d=container===null||container===void 0?void 0:container.deref())===null||_d===void 0?void 0:_d.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}else{(_e=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_e===void 0?void 0:_e.setAttribute("style","position: absolute; right:0px; z-index:300;");(_f=container===null||container===void 0?void 0:container.deref())===null||_f===void 0?void 0:_f.setAttribute("style","width: 780px;")}}function resetInputSkeleton(){window["inputSkeletonState"]={query:"",placeholder:"",isFocused:false,selectionStart:0,selectionEnd:0,selectionDirection:"none",listeners:[]}}if(window["inputSkeletonState"]){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(window.inputSkeletonState.isFocused&&inputRef){inputRef.value=window.inputSkeletonState.query;inputRef.placeholder=window.inputSkeletonState.placeholder;inputRef.focus();inputRef.setSelectionRange(window.inputSkeletonState.selectionStart,window.inputSkeletonState.selectionEnd,window.inputSkeletonState.selectionDirection);setExpandedStyles()}}else{resetInputSkeleton()}var queryValue=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!queryValue){var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){inputRef.value=queryValue}}var mediaQuery=window.matchMedia("(max-width: 1130px)");function handleSmallScreen(){var _a,_b,_c;if(window["inputSkeletonState"]){if(window.inputSkeletonState.isFocused){(_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.setAttribute("style","position: absolute;right: 0px;z-index: 300;");(_b=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_b===void 0?void 0:_b.setAttribute("style","position: fixed;z-index: 300;left: calc((100% - 780px) / 2);");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.setAttribute("style","position: relative;max-width: 100%;width: 780px;")}}}(_a=mediaQuery===null||mediaQuery===void 0?void 0:mediaQuery.addEventListener)===null||_a===void 0?void 0:_a.call(mediaQuery,"change",function(){return handleSmallScreen()});function changeHandler(e){var input=e.target;if(window.inputSkeletonState){window.inputSkeletonState.query=input===null||input===void 0?void 0:input.value;if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"){window.sessionStorage.setItem("atlassian.search-dialog-query",input.value)}var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none"}}}function focusHandler(e){if(window.inputSkeletonState){window.inputSkeletonState.isFocused=true;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){window.inputSkeletonState.placeholder=inputRef.placeholder}}setExpandedStyles()}function blurClickHandler(e){var _a,_b,_c,_d,_e;var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(!inputRef){return}if(currentInput&&e.target===inputRef&&window.inputSkeletonState){window.inputSkeletonState.selectionStart=inputRef.selectionStart||0;window.inputSkeletonState.selectionEnd=inputRef.selectionEnd||0;window.inputSkeletonState.selectionDirection=inputRef.selectionDirection||"none";if(!((_a=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_a===void 0?void 0:_a.hasAttribute("style"))){window.inputSkeletonState.isFocused=true;setExpandedStyles()}}if(currentInput&&e.target!==inputRef){resetInputSkeleton();var sessionQuery=window.sessionStorage.getItem("atlassian.search-dialog-query");if(window.sessionStorage.getItem("atlassian.search-dialog-sticky")==="true"&&!!sessionQuery){inputRef.value=sessionQuery}else{inputRef.value=""}(_b=topContainer===null||topContainer===void 0?void 0:topContainer.deref())===null||_b===void 0?void 0:_b.removeAttribute("style");(_c=container===null||container===void 0?void 0:container.deref())===null||_c===void 0?void 0:_c.removeAttribute("style");(_d=iconWrapper===null||iconWrapper===void 0?void 0:iconWrapper.deref())===null||_d===void 0?void 0:_d.removeAttribute("style");inputRef.removeAttribute("style");(_e=formContainer===null||formContainer===void 0?void 0:formContainer.deref())===null||_e===void 0?void 0:_e.removeAttribute("style")}}function addListener(target,event,handler){var _a;target.addEventListener(event,handler);(_a=window===null||window===void 0?void 0:window.inputSkeletonState)===null||_a===void 0?void 0:_a.listeners.push([target,event,handler])}{var inputRef=currentInput===null||currentInput===void 0?void 0:currentInput.deref();if(inputRef){addListener(inputRef,"input",changeHandler);addListener(inputRef,"select",changeHandler);addListener(inputRef,"keydown",changeHandler);addListener(inputRef,"focus",focusHandler)}}addListener(document,"click",blurClickHandler)})(document,window);`;

});



parcelRegister("fsMoS", function(module, exports) {

$parcel$export(module.exports, "NavigationSearchDialog", () => $350bb53b739c1971$export$8d31f534ef9d9122);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $iPfZG = parcelRequire("iPfZG");

var $5izcQ = parcelRequire("5izcQ");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $eO2QR = parcelRequire("eO2QR");

var $dIouf = parcelRequire("dIouf");

var $1YXTQ = parcelRequire("1YXTQ");

var $ge2sX = parcelRequire("ge2sX");

var $ljm2R = parcelRequire("ljm2R");

var $ep3mz = parcelRequire("ep3mz");

var $dPJCf = parcelRequire("dPJCf");

var $gz8ZY = parcelRequire("gz8ZY");

var $9wGTI = parcelRequire("9wGTI");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

var $lqqdh = parcelRequire("lqqdh");

var $cuRlJ = parcelRequire("cuRlJ");

var $2Fqwa = parcelRequire("2Fqwa");

var $f4L2T = parcelRequire("f4L2T");

var $escKD = parcelRequire("escKD");

var $kPjLK = parcelRequire("kPjLK");

var $7Fvok = parcelRequire("7Fvok");

var $lI5WA = parcelRequire("lI5WA");

var $5bPOK = parcelRequire("5bPOK");
const $350bb53b739c1971$export$c0d6ac131d4391b9 = 'search-spotlight';
const $350bb53b739c1971$export$3ae94a2503e890a1 = (date)=>{
    const timeAgo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1YXTQ.TimeAgo), {
        date: date,
        dateFormatOptions: {
            month: 'short'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...(0, $lI5WA.i18n).lastUpdatedDate,
        values: {
            datetime: timeAgo
        }
    });
};
const $350bb53b739c1971$var$analyticsContainerStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $350bb53b739c1971$var$NavigationSearchDialogWithRouter = ({ theme: theme, shouldFillContainer: shouldFillContainer, intl: intl, clearStickySearchRef: clearStickySearchRef })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const searchInputRef = (0, $gwFzn.useRef)(null);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const openDialog = (e)=>{
        if (e) {
            e.preventDefault(); //prevent shortcut key from being added to search input
            searchInputRef.current?.focus();
        }
        setIsOpen(true);
    };
    const closeDialog = ()=>{
        setIsOpen(false);
    };
    const onResultLinkClick = ()=>{
        closeDialog();
    };
    const onNavigate = (url)=>{
        closeDialog();
        push(url);
    };
    const onInteractiveSkeletonEnter = (0, $kPjLK.generateInteractiveSkeletonOnEnter)(push);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'search',
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: isNav4Enabled ? '4' : '3'
                }
            }
        }).fire();
    };
    const getRootSearchDialog = ({ ref: ref, ...rest }, clientProviderConfig)=>{
        const { cloudId: cloudId, aggregatorUrl: aggregatorUrl } = clientProviderConfig;
        const interactiveSkeleton = {
            onEnter: onInteractiveSkeletonEnter,
            placeholder: intl.formatMessage((0, $lI5WA.i18n).placeholder)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
            name: $350bb53b739c1971$export$c0d6ac131d4391b9
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $350bb53b739c1971$var$analyticsContainerStyles,
            onClick: fireClickAnalytics,
            "data-vc": "app-navigation-search-dialog",
            "data-ssr-placeholder-replace": "search-input"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eO2QR.AddActivationIdWrapper), {
            channel: "fabric-elements",
            targetActionSubjects: [
                'postQuerySearchResults',
                'cachedResults'
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7Fvok.ExtensibleCrossProductSearchDialog), {
            jiraFeatures: {
                hasSoftwareAccess: true
            },
            forwardRef: ref,
            setIsExpanded: (value)=>value ? openDialog(null) : closeDialog(),
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl,
            onNavigateSecondary: (href)=>{
                // eslint-disable-next-line no-restricted-syntax
                window.location.assign(href);
            },
            features: {
                jiraFeatures: rest.jiraFeatures,
                confluenceFeatures: rest.confluenceFeatures,
                interactiveSkeleton: interactiveSkeleton
            },
            clearStickySearchRef: clearStickySearchRef,
            ...rest
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iPfZG.default), {
            engagementId: $350bb53b739c1971$export$c0d6ac131d4391b9
        }));
    };
    const getSearchDialog = (searchDialogProps, clientProviderConfig)=>{
        const autoAddCurrentSpaceIsEnabled = false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ep3mz.PageSubscriber), null, ({ spaceKey: spaceKey })=>{
            return !!spaceKey && autoAddCurrentSpaceIsEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f4L2T.CurrentSpaceContext), {
                spaceKey: spaceKey
            }, ({ currentSpace: currentSpace, loading: loading })=>{
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kPjLK.InteractiveSearchInputSkeleton), {
                    theme: searchDialogProps.theme,
                    shouldFillContainer: searchDialogProps.shouldFillContainer
                });
                else {
                    const currentSpaceValid = currentSpace && Object.values(currentSpace).every((v)=>v !== undefined);
                    return getRootSearchDialog({
                        ...searchDialogProps,
                        confluenceFeatures: {
                            currentSpace: currentSpaceValid ? currentSpace : undefined
                        }
                    }, clientProviderConfig);
                }
            }) : getRootSearchDialog({
                ...searchDialogProps
            }, clientProviderConfig);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ge2sX.SessionData), null, ({ cloudId: cloudId, userId: userId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lqqdh.ClientProvider), {
            cloudId: cloudId,
            userId: userId,
            useUrsForPeopleSearch: false
        }, ({ clientProviderConfig: clientProviderConfig })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
                attribution: (0, $dIouf.Attribution).DISCO,
                modal: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Fqwa.UserContext), null, ({ data: data, isLoading: isLoading })=>{
                return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kPjLK.InteractiveSearchInputSkeleton), {
                    theme: theme,
                    shouldFillContainer: shouldFillContainer
                }) : getSearchDialog({
                    isExpanded: isOpen,
                    onOpen: openDialog,
                    onClose: closeDialog,
                    linkComponent: (0, $cuRlJ.getResultLinkComponent)(onResultLinkClick),
                    formatDate: $350bb53b739c1971$export$3ae94a2503e890a1,
                    ref: searchInputRef,
                    theme: theme,
                    user: {
                        name: data && data.name,
                        email: data && data.email,
                        id: data && data.id
                    },
                    onNavigate: onNavigate,
                    shouldFillContainer: shouldFillContainer
                }, clientProviderConfig);
            })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? [
            (0, $ljm2R.NAVIGATION_SLASH_SHORTCUT),
            (0, $ljm2R.NAVIGATION_SHORTCUT)
        ] : undefined,
        accelerator: (0, $ljm2R.isMac)() ? (0, $ljm2R.UNIVERSAL_NAVIGATION_SHORTCUT_MAC) : (0, $ljm2R.UNIVERSAL_NAVIGATION_SHORTCUT_WIN),
        listener: openDialog,
        isAppNavigationShortcut: true
    }));
};
const $350bb53b739c1971$var$NavigationSearchDialogInternal = (0, $js7oX.default)($350bb53b739c1971$var$NavigationSearchDialogWithRouter);
const $350bb53b739c1971$export$8d31f534ef9d9122 = (props)=>{
    const [isQuickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    return isQuickFindEnabled && (0, $9wGTI.fg)('quick_find_refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $escKD.QuickFindNav3), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($350bb53b739c1971$var$NavigationSearchDialogInternal, props);
};

});
parcelRegister("eO2QR", function(module, exports) {

$parcel$export(module.exports, "AddActivationIdWrapper", () => $236feafa6fe3ed5c$export$80d66f5e04b5ca9e);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $iSamx = parcelRequire("iSamx");
const $236feafa6fe3ed5c$export$80d66f5e04b5ca9e = ({ channel: channel, targetActionSubjects: targetActionSubjects, children: children })=>{
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const eventUpdater = (payload)=>{
        let data = payload.data || payload;
        if (!targetActionSubjects || targetActionSubjects.includes(data.actionSubjectId) || targetActionSubjects.includes(data.actionSubject)) data = {
            ...data,
            attributes: {
                ...data.attributes,
                activationId: activationId
            }
        };
        if (payload.data) {
            if (payload.data !== data) return {
                ...payload,
                data: data
            };
            return payload;
        }
        return data;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iSamx.AddAttributesWrapper), {
        eventUpdater: eventUpdater,
        channel: channel || '*'
    }, children);
};

});

parcelRegister("lqqdh", function(module, exports) {

$parcel$export(module.exports, "ClientProvider", () => $ed5c1b85ee8abc07$export$5d91bb6ce8e0f47);

var $gwFzn = parcelRequire("gwFzn");

var $15B7D = parcelRequire("15B7D");
var $91yhh = parcelRequire("91yhh");
var $6clwF = parcelRequire("6clwF");

var $jlIaF = parcelRequire("jlIaF");

var $5bPOK = parcelRequire("5bPOK");
const $ed5c1b85ee8abc07$export$5d91bb6ce8e0f47 = ({ userId: userId, cloudId: cloudId, children: children, useUrsForPeopleSearch: useUrsForPeopleSearch })=>{
    const clientProviderConfig = {
        isUserAnonymous: !userId,
        aggregatorUrl: '/gateway/api/xpsearch-aggregator',
        collaborationGraphUrl: '/gateway/api/collaboration',
        cloudId: cloudId,
        accountId: userId,
        useUrsForPeopleSearch: useUrsForPeopleSearch
    };
    const [quickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $91yhh.ExperimentProvider), {
        quickFindEnabled: quickFindEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $15B7D.ConfluenceClientsProvider), {
        config: {
            ...clientProviderConfig,
            baseUrl: (0, $jlIaF.CONTEXT_PATH),
            scopes: undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6clwF.JiraSearchClientProvider), {
        ...clientProviderConfig,
        baseUrl: `${window.location.protocol}//${window.location.hostname}`
    }, children({
        clientProviderConfig: clientProviderConfig
    }))));
};

});
parcelRegister("15B7D", function(module, exports) {

$parcel$export(module.exports, "ConfluenceClientsProvider", () => $06b7bb550af38e43$export$43e8a9214cb124ba);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5wJ53 = parcelRequire("5wJ53");

var $csnse = parcelRequire("csnse");

var $aAuSn = parcelRequire("aAuSn");

var $heWLv = parcelRequire("heWLv");

var $cfEFl = parcelRequire("cfEFl");
var $kfImN = parcelRequire("kfImN");

var $9HkI0 = parcelRequire("9HkI0");
const $06b7bb550af38e43$var$defaultCollaborationGraphConfig = {
    collaborationGraphUrl: 'gateway/api/collaboration',
    useCollaborationGraphForRecents: false
};
const $06b7bb550af38e43$var$getSearchClientWithConfig = (0, $csnse.default)((config, collabGraphClient)=>new (0, $5wJ53.ConfluenceSearchClient)(config, collabGraphClient), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $06b7bb550af38e43$var$getRecentsClientWithConfig = (0, $csnse.default)((config, collabGraphClient)=>new (0, $heWLv.ConfluenceRecentsClient)(config, collabGraphClient), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $06b7bb550af38e43$var$getCollabGraphClientWithConfig = (0, $csnse.default)((config)=>new (0, $cfEFl.CollaborationGraphClient)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        collabGraphSessionId: config.collabGraphSessionId,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $06b7bb550af38e43$export$5a44dbd630fde657 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});
const $06b7bb550af38e43$var$MISSING_PROVIDER_ERROR = new Error(`Could not find all required Clients, make sure ConfluenceClientsProvider is created further up the tree`);
//Will generate a session id to be sent to the CG endpoint as well as the frontend analytics
//This is created here as CG results are cached inside search dialog and is not invoked for subsequent use actions
const $06b7bb550af38e43$var$COLLABORATION_GRAPH_SESSION_ID = (0, $9HkI0.v4)();
const $06b7bb550af38e43$export$413dca1b70dbb4a7 = (Component)=>{
    return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($06b7bb550af38e43$export$5a44dbd630fde657.Consumer, {
            children: ({ searchClient: searchClient, recentClient: recentClient, cloudId: cloudId, siteUrl: siteUrl = '', sites: sites, collabGraphSessionId: collabGraphSessionId })=>{
                if (!searchClient || !recentClient) throw $06b7bb550af38e43$var$MISSING_PROVIDER_ERROR;
                const { ...rest } = props;
                return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    ...rest,
                    searchClient: searchClient,
                    recentClient: recentClient,
                    cloudId: cloudId,
                    collabGraphSessionId: collabGraphSessionId,
                    siteUrl: siteUrl,
                    sites: sites
                });
            }
        });
};
const $06b7bb550af38e43$export$43e8a9214cb124ba = ({ children: children, config: config })=>{
    const { baseUrl: baseUrl, cloudId: cloudId, collaborationGraphUrl: collaborationGraphUrl, aggregatorUrl: aggregatorUrl, isUserAnonymous: isUserAnonymous, useCollaborationGraphForRecents: useCollaborationGraphForRecents, recentItemsSupplier: recentItemsSupplier, sites: sites = [], collabGraphSessionId: collabGraphSessionId, scopes: scopes, useGraphQLClient: useGraphQLClient, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl } = {
        ...$06b7bb550af38e43$var$defaultCollaborationGraphConfig,
        ...config
    };
    const siteUrl = (0, $kfImN.extractSiteUrl)(config);
    const collabGraphClient = $06b7bb550af38e43$var$getCollabGraphClientWithConfig({
        collaborationGraphUrl: collaborationGraphUrl,
        cloudId: cloudId,
        isMultiSite: sites.length > 1,
        sites: sites,
        collabGraphSessionId: collabGraphSessionId
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($06b7bb550af38e43$export$5a44dbd630fde657.Provider, {
        value: {
            searchClient: $06b7bb550af38e43$var$getSearchClientWithConfig({
                isUserAnonymous: isUserAnonymous,
                url: aggregatorUrl,
                cloudId: cloudId,
                isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                siteMasterList: sites,
                scopes: scopes,
                useGraphQLClient: useGraphQLClient
            }, collabGraphClient),
            recentClient: $06b7bb550af38e43$var$getRecentsClientWithConfig({
                url: baseUrl,
                isCollaborationGraphEnabled: useCollaborationGraphForRecents,
                recentItemsSupplier: recentItemsSupplier,
                useRecentWork: useRecentWork,
                recentWorkAPIUrl: recentWorkAPIUrl
            }, collabGraphClient),
            collabGraphClient: collabGraphClient,
            siteUrl: siteUrl,
            cloudId: cloudId,
            sites: sites,
            collabGraphSessionId: $06b7bb550af38e43$var$COLLABORATION_GRAPH_SESSION_ID
        },
        children: children
    });
};
const $06b7bb550af38e43$export$4823a6cc022cca16 = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($06b7bb550af38e43$export$5a44dbd630fde657);
    if (!context.searchClient || !context.recentClient) throw $06b7bb550af38e43$var$MISSING_PROVIDER_ERROR;
    return context;
};
const $06b7bb550af38e43$export$376c08f4921c6b8d = ()=>{
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($06b7bb550af38e43$export$5a44dbd630fde657);
    return context.recentClient;
};

});
parcelRegister("5wJ53", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSearchClient", () => $da2db4559cce8604$export$2bdc82bf1cf036b4);

var $czt8s = parcelRequire("czt8s");

var $jV49M = parcelRequire("jV49M");

var $12cJV = parcelRequire("12cJV");
var $c3kEC = parcelRequire("c3kEC");

var $jXnBe = parcelRequire("jXnBe");

var $3NyIw = parcelRequire("3NyIw");

var $kfImN = parcelRequire("kfImN");

var $6TCTf = parcelRequire("6TCTf");
var $cMXX8 = parcelRequire("cMXX8");
const $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
const $da2db4559cce8604$var$EMPTY_RESULT_PROMISE = Promise.resolve({
    items: [],
    timings: 0
});
class $da2db4559cce8604$export$2bdc82bf1cf036b4 {
    /**
   * Makes a search across all relevant scopes.
   */ search(query, filters, context, queryVersion, sites) {
        const modelParams = [
            {
                '@type': 'queryParams',
                queryVersion: queryVersion
            }
        ];
        if (filters.length > 0) return this.searchWithFilters(query, filters, context, modelParams, sites);
        if (this.useGraphQLClient) // TODO: convert this response to expected confluence search response
        this.graphQLClient.search({
            query: query,
            context: context,
            entities: (0, $6TCTf.CONFLUENCE_ITEM_ENTITIES),
            modelParams: modelParams,
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        const scopes = [
            this.scopes.itemScope,
            this.scopes.spaceScope,
            this.scopes.ursUserScope
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: modelParams,
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
            filters: [],
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        const allResults = {
            [(0, $jXnBe.Scope).ConfluencePageBlogAttachment]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope(this.scopes.itemScope), requestDurationMs))),
            [(0, $jXnBe.Scope).ConfluenceSpace]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope(this.scopes.spaceScope), requestDurationMs))),
            [(0, $jXnBe.Scope).UserConfluence]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope(this.scopes.ursUserScope), requestDurationMs, sites.length > 0)))
        };
        return allResults;
    }
    searchSpaces(query, context, sites) {
        const scopes = [
            (0, $jXnBe.Scope).ConfluenceSpace
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: [],
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.SPACE_RESULT_LIMIT,
            filters: [],
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        return (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfSpace(response.retrieveScope((0, $jXnBe.Scope).ConfluenceSpace), requestDurationMs)));
    }
    searchUsers(query, context, sites) {
        const scopes = [
            (0, $jXnBe.Scope).UserConfluence
        ];
        const responseAndTiming = this.aggregatorClient.search({
            query: query,
            context: context,
            scopes: scopes,
            modelParams: [],
            resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
            filters: [],
            experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
            sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
        });
        return (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, $jXnBe.Scope).UserConfluence), requestDurationMs, sites.length > 0)));
    }
    getRecentPeople(context, sites) {
        const { fromCache: fromCache, value: value } = this.bootstrapPeopleCache.get(context, sites);
        return new (0, $czt8s.CancellablePromise)(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    /**
   * Check the user permissions for the given list of products.
   */ async getProductPermissions(products) {
        if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE);
        return this.permissionsDataCache;
    }
    async getAbTestData() {
        if (this.abTestDataCache) return this.abTestDataCache;
        const abTest = await this.aggregatorClient.getAbTestData((0, $jXnBe.Scope).ConfluencePageBlogAttachment, $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE);
        this.abTestDataCache = abTest;
        return abTest;
    }
    mapConfItem(response, timings) {
        if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $jXnBe.Scope).ConfluencePageBlogAttachment}`);
        if (response.error) throw (0, $c3kEC.responseErrorToError)(response.error);
        function removeHighlightTags(text) {
            return text.replace(/@@@hl@@@|@@@endhl@@@/g, '');
        }
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ const items = response.results.map((item)=>({
                resultId: item.content.id,
                // content always available for pages/blogs/attachments // TODO
                name: removeHighlightTags(item.title),
                href: `${item.baseUrl}${item.url}`,
                containerName: item.container.title,
                analyticsType: (0, $jXnBe.ResultConfluence),
                contentType: `confluence-${item.content.type}`,
                resultType: (0, $jXnBe.ConfluenceObjectResult),
                containerId: item.content.space && item.content.space.id ? item.content.space.id : 'UNAVAILABLE',
                spaceId: item.container.id,
                iconClass: item.iconCssClass,
                lastModified: item.lastModified,
                isRecentResult: false
            }));
        /* eslint-enable */ return {
            items: items,
            totalSize: response.size !== undefined ? response.size : response.results.length,
            timings: timings
        };
    }
    mapConfSpace(response, timings) {
        if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $jXnBe.Scope).ConfluenceSpace}`);
        if (response.error) throw (0, $c3kEC.responseErrorToError)(response.error);
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ const items = response.results.map((item)=>({
                resultId: item.id,
                avatarUrl: `${item.baseUrl}${item.space.icon.path}`,
                name: item.container.title,
                href: `${item.baseUrl || ''}${item.container.displayUrl}`,
                analyticsType: (0, $jXnBe.ResultConfluence),
                resultType: (0, $jXnBe.GenericContainerResult),
                contentType: (0, $jXnBe.ConfluenceSpace),
                key: item.space.key,
                // TODO
                id: item.id
            }));
        /* eslint-enable */ return {
            items: items,
            timings: timings
        };
    }
    constructor(config, collabGraphClient){
        this.aggregatorClient = void 0;
        this.graphQLClient = void 0;
        this.siteMasterList = void 0;
        this.collaborationGraphClient = void 0;
        this.isCollabGraphEnabled = void 0;
        this.isUserAnonymous = void 0;
        this.useGraphQLClient = void 0;
        this.scopes = void 0;
        this.bootstrapPeopleCache = void 0;
        this.abTestDataCache = null;
        this.permissionsDataCache = null;
        this.searchWithFilters = (query, filters, context, modelParams, sites)=>{
            const scopes = [
                (0, $jXnBe.Scope).ConfluencePageBlogAttachment
            ];
            const allFilters = [];
            let baseSpaceFilters = null;
            let baseUserFilters = null;
            let baseTimeFilters = null;
            // TODO: GraphQL queries with filters
            filters.forEach((filter)=>{
                switch(filter.type){
                    case 'space':
                        if (!baseSpaceFilters) {
                            baseSpaceFilters = {
                                '@type': 'spaces',
                                spaceKeys: []
                            };
                            allFilters.push(baseSpaceFilters);
                        }
                        baseSpaceFilters.spaceKeys.push(filter.id);
                        break;
                    case 'contributor':
                        if (!baseUserFilters) {
                            baseUserFilters = {
                                '@type': 'contributors',
                                accountIds: []
                            };
                            allFilters.push(baseUserFilters);
                        }
                        baseUserFilters.accountIds.push(filter.id);
                        break;
                    case 'lastModified':
                        if (!baseTimeFilters) {
                            baseTimeFilters = {
                                '@type': 'lastModified',
                                from: filter.id
                            };
                            allFilters.push(baseTimeFilters);
                        }
                        break;
                    default:
                        break;
                }
            });
            const responseAndTiming = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: modelParams,
                resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT,
                filters: allFilters,
                experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            const results = {
                [(0, $jXnBe.Scope).ConfluencePageBlogAttachment]: (0, $czt8s.CancellablePromise).from(responseAndTiming.then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapConfItem(response.retrieveScope((0, $jXnBe.Scope).ConfluencePageBlogAttachment), requestDurationMs))),
                [(0, $jXnBe.Scope).ConfluenceSpace]: (0, $czt8s.CancellablePromise).from($da2db4559cce8604$var$EMPTY_RESULT_PROMISE),
                [(0, $jXnBe.Scope).UserConfluence]: (0, $czt8s.CancellablePromise).from($da2db4559cce8604$var$EMPTY_RESULT_PROMISE)
            };
            return results;
        };
        this.recentPeopleSupplier = (context, sites)=>{
            if (this.isUserAnonymous) return Promise.resolve({
                items: [],
                timings: 0
            });
            if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getUsers().then((response)=>this.mapCollabGraphPeople(response));
            return this.aggregatorClient.search({
                query: '',
                context: context,
                scopes: [
                    (0, $jXnBe.Scope).UserConfluence
                ],
                modelParams: [],
                resultLimit: $da2db4559cce8604$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT,
                experience: $da2db4559cce8604$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites?.map((s)=>s.cloudId)
            }).then(({ response: response, requestDurationMs: requestDurationMs })=>this.mapUrsPeople(response.retrieveScope((0, $jXnBe.Scope).UserConfluence), requestDurationMs, sites.length > 0));
        };
        this.mapUrsPeople = (response, timings, isMultiSite)=>{
            if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $jXnBe.Scope).UserConfluence}`);
            if (response.error) throw (0, $c3kEC.responseErrorToError)(response.error);
            const items = response.results.map((item)=>({
                    resultType: (0, $jXnBe.PersonResult),
                    resultId: `people-${item.id}`,
                    userId: item.id,
                    name: item.name,
                    href: (0, $kfImN.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
                    avatarUrl: item.avatarUrl,
                    contentType: (0, $jXnBe.Person),
                    analyticsType: (0, $jXnBe.ResultPerson),
                    mentionName: item.nickname || '',
                    presenceMessage: ''
                }));
            return {
                items: (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(items, (item)=>item.resultId),
                timings: timings
            };
        };
        this.mapCollabGraphPeople = (response)=>{
            const items = response.collaborationGraphEntities.map((item)=>({
                    resultId: item.userProfile.account_id,
                    userId: item.userProfile.account_id,
                    name: item.userProfile.name,
                    href: `${(0, $kfImN.mapTenantIdToSiteUrl)(item.siteId, this.siteMasterList)}/people/${item.userProfile.account_id}`,
                    analyticsType: (0, $jXnBe.RecentPerson),
                    mentionName: item.userProfile.name,
                    presenceMessage: item.userProfile.name,
                    resultType: (0, $jXnBe.PersonResult),
                    avatarUrl: item.userProfile.picture,
                    contentType: (0, $jXnBe.Person)
                }));
            return {
                items: items,
                timings: response.timings
            };
        };
        const { siteMasterList: siteMasterList, scopes: _scopes } = config;
        this.aggregatorClient = new (0, $12cJV.AggregatorClient)(config);
        this.graphQLClient = new (0, $cMXX8.GraphQLClient)(config);
        this.isUserAnonymous = config.isUserAnonymous;
        this.useGraphQLClient = config.useGraphQLClient || false;
        this.bootstrapPeopleCache = new (0, $3NyIw.SimpleCache)(this.recentPeopleSupplier);
        this.siteMasterList = siteMasterList;
        this.collaborationGraphClient = collabGraphClient;
        this.isCollabGraphEnabled = config.isCollaborationGraphEnabled;
        this.scopes = {
            itemScope: _scopes?.itemScope ? _scopes.itemScope : (0, $jXnBe.Scope).ConfluencePageBlogAttachment,
            spaceScope: _scopes?.spaceScope ? _scopes.spaceScope : (0, $jXnBe.Scope).ConfluenceSpace,
            ursUserScope: _scopes?.ursUserScope ? _scopes.ursUserScope : (0, $jXnBe.Scope).UserConfluence
        };
    }
}
$da2db4559cce8604$export$2bdc82bf1cf036b4.ITEM_RESULT_LIMIT = 30;
$da2db4559cce8604$export$2bdc82bf1cf036b4.SPACE_RESULT_LIMIT = 10;
$da2db4559cce8604$export$2bdc82bf1cf036b4.PEOPLE_RESULT_LIMIT = 10;

});
parcelRegister("12cJV", function(module, exports) {

$parcel$export(module.exports, "AggregatorClient", () => $160b24ddcdce5168$export$842695bca69eca86);

var $dwp40 = parcelRequire("dwp40");

var $9Nzn7 = parcelRequire("9Nzn7");

var $kfImN = parcelRequire("kfImN");

var $dxrRk = parcelRequire("dxrRk");

var $bKLey = parcelRequire("bKLey");
class $160b24ddcdce5168$export$842695bca69eca86 {
    async getAbTestData(scope, experience, product) {
        const body = {
            cloudId: this.cloudId,
            scopes: [
                scope
            ],
            experience: experience,
            product: product
        };
        const response = await this.makePostRequest($160b24ddcdce5168$export$842695bca69eca86.EXPERIMENT_URL_PATH, body);
        const scopeWithAbTest = response.scopes.find((s)=>s.id === scope);
        const abTestPromise = scopeWithAbTest ? Promise.resolve(scopeWithAbTest.abTest) : Promise.resolve(null);
        return abTestPromise;
    }
    /**
   * Get a list of permitted scopes for the supplied product.
   *
   * Consumers should favour {@link batchedGetExtensibleProductPermission}, to batch
   * multiple scopes calls into one. {@link getProductScopes} may be used when a caller
   * explicitly wants a separate REST call to fetch scopes. One example may be if a product
   * has different scopes caching rules to other products.
   *
   * @param productId the product id to lookup scopes for
   * @param experience the experience this UI represents
   * @returns a promise of a list of scopes for the supplied product
   */ async getProductScopes(productId, experience) {
        const productScopeMap = await this.getGenericProductPermissions({
            productIds: [
                productId
            ],
            experience: experience
        });
        return productScopeMap.get(productId) || [];
    }
    /**
   * Returns a list of {@link Products} which the user should see in the dialog
   *
   * @deprecated consumers should use {@link batchedGetExtensibleProductPermission} to fetch product scopes, or
   * {@link getProductScopes} to force a separate call to fetch a single product's scopes.
   *
   */ async getProductPermissions(products, experience) {
        const lowercaseProductIds = products.map((p)=>p.toLowerCase());
        const productScopeMap = await this.getGenericProductPermissions({
            productIds: lowercaseProductIds,
            experience: experience
        });
        return lowercaseProductIds.filter((product)=>productScopeMap.get(product)?.length).map((product)=>product.toUpperCase());
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [], sourceProduct: sourceProduct }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, $kfImN.limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn,
            experimentId: this.backendExperiment?.experimentId,
            shadowExperimentId: this.backendExperiment?.shadowExperimentId,
            ...sourceProduct ? {
                sourceProduct: sourceProduct
            } : {}
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $9Nzn7.timed)(this.makePostRequest($160b24ddcdce5168$export$842695bca69eca86.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList, backendExperiment: backendExperiment }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.backendExperiment = void 0;
        this.getAggregatorConfig = ()=>{
            return {
                url: this.serviceConfig.url,
                cloudId: this.cloudId,
                siteMasterList: this.siteMasterList
            };
        };
        this.getGenericProductPermissions = async (args)=>{
            return (0, $bKLey.getFetchProductPermissions)(this.makeGetRequest)(args.productIds, this.cloudId, args.experience);
        };
        this.batchedGetExtensibleProductPermission = (0, $dxrRk.batchMethod)((args)=>{
            const emptyProductPermissions = {
                productIds: [],
                experience: ''
            };
            if (args.length === 0) return emptyProductPermissions;
            return args.reduce((acc, arg)=>{
                return {
                    productIds: [
                        ...acc.productIds,
                        ...arg.productIds
                    ],
                    experience: arg.experience
                };
            }, emptyProductPermissions);
        }, this.getGenericProductPermissions, (response, id)=>response.get(id) || []);
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.makeGetRequest = (path)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
        this.backendExperiment = backendExperiment;
    }
}
// Static URLs
$160b24ddcdce5168$export$842695bca69eca86.EXPERIMENT_URL_PATH = 'experiment/v1';
$160b24ddcdce5168$export$842695bca69eca86.QUICKSEARCH_API_URL = 'quicksearch/v1';

});
parcelRegister("9Nzn7", function(module, exports) {

$parcel$export(module.exports, "timed", () => $f0a7768b8895b419$export$d35186a762cd39c8);
const $f0a7768b8895b419$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};

});

parcelRegister("kfImN", function(module, exports) {

$parcel$export(module.exports, "extractSiteUrl", () => $1e46ba23978c04a9$export$c9a345fa92182d1c);
$parcel$export(module.exports, "mapTenantIdToSiteUrl", () => $1e46ba23978c04a9$export$fdb149c8c29e67a2);
$parcel$export(module.exports, "extractSiteIdBySiteUrl", () => $1e46ba23978c04a9$export$4be99cb40bcf5aef);
$parcel$export(module.exports, "generatePeopleProfileUrl", () => $1e46ba23978c04a9$export$ca98b3a6d1ea77f3);
$parcel$export(module.exports, "limitToMaxSiteUsage", () => $1e46ba23978c04a9$export$ba81234f3ab84a86);
const $1e46ba23978c04a9$export$c9a345fa92182d1c = ({ siteUrl: siteUrl, sites: sites })=>{
    if (siteUrl) return siteUrl;
    if (sites && sites.length > 0) return sites[0].siteUrl;
    return '';
};
const $1e46ba23978c04a9$export$fdb149c8c29e67a2 = (siteId, sites)=>{
    const matchingSite = sites.find((site)=>site.cloudId === siteId);
    return matchingSite ? matchingSite.siteUrl : '';
};
const $1e46ba23978c04a9$export$4be99cb40bcf5aef = (absSiteUrl, sites = [])=>{
    const baseUrlRegex = /^(http(s)?:\/\/[^\/]+)/;
    const urlRegexMatches = absSiteUrl.match(baseUrlRegex);
    if (!urlRegexMatches) return '';
    const baseUrl = urlRegexMatches[0];
    const matchingSite = sites.find((site)=>site.siteUrl === baseUrl);
    return matchingSite ? matchingSite.cloudId : '';
};
const $1e46ba23978c04a9$export$ca98b3a6d1ea77f3 = (isMultiSite, absoluteUrl = '', accountId, contextPath = '')=>{
    if (isMultiSite && absoluteUrl) return absoluteUrl;
    return contextPath ? `/${contextPath}/people/${accountId}` : `/people/${accountId}`;
};
const $1e46ba23978c04a9$var$MAX_SITES_INITIAL_QUERY = 3;
const $1e46ba23978c04a9$export$ba81234f3ab84a86 = (sites = [])=>{
    return sites.slice(0, $1e46ba23978c04a9$var$MAX_SITES_INITIAL_QUERY);
};

});

parcelRegister("dxrRk", function(module, exports) {

$parcel$export(module.exports, "batchMethod", () => $0d4ef05ab28cb343$export$198da76335167312);

var $2jjxD = parcelRequire("2jjxD");
const $0d4ef05ab28cb343$export$198da76335167312 = (argumentResolver, finalFn, successfulResponseMapper, debounceTime = 100)=>{
    const batchMap = {};
    const timedFn = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(()=>{
        const inFlightRequestsMap = {
            ...batchMap
        };
        const keys = Object.keys(inFlightRequestsMap);
        const args = keys.map((key)=>inFlightRequestsMap[key].arg);
        finalFn(argumentResolver(args)).then((response)=>{
            keys.forEach((key)=>{
                inFlightRequestsMap[key].resolve(successfulResponseMapper(response, key));
            });
        }).catch(()=>{
            keys.forEach((product)=>{
                inFlightRequestsMap[product].reject();
            });
        }).finally(()=>keys.forEach((key)=>delete batchMap[key]));
    }, debounceTime);
    return (id, arg)=>{
        const promise = new Promise((resolve, reject)=>{
            batchMap[id] = {
                resolve: resolve,
                reject: reject,
                arg: arg
            };
        });
        timedFn();
        return promise;
    };
};

});

parcelRegister("bKLey", function(module, exports) {

$parcel$export(module.exports, "getFetchProductPermissions", () => $73ef07e649cb3d00$export$b756f4e692ecc8f);
const $73ef07e649cb3d00$var$SCOPES_API_URL = 'scopes/v1';
const $73ef07e649cb3d00$export$b756f4e692ecc8f = (makeRequest)=>async (productIds, cloudId, experience)=>{
        if (productIds.length === 0) return Promise.resolve(new Map());
        try {
            const productParams = productIds.map((productId)=>[
                    'productId',
                    productId
                ]);
            const params = new URLSearchParams([
                [
                    'experience',
                    experience
                ],
                ...productParams
            ]);
            const path = `${$73ef07e649cb3d00$var$SCOPES_API_URL}/${cloudId}?${params.toString()}`;
            const response = await makeRequest(path);
            return new Map(Object.keys(response.products).map((product)=>[
                    product,
                    response.products[product]
                ]));
        } catch (e) {
            return new Map();
        }
    };

});


parcelRegister("c3kEC", function(module, exports) {

$parcel$export(module.exports, "responseErrorToError", () => $62cd9cdd84f4378e$export$59a963eec12b52ed);
function $62cd9cdd84f4378e$export$59a963eec12b52ed(responseError) {
    let stringRepresentation = 'undefined';
    // Check if error response has a nested 'message' object, if so we use that instead.
    const error = responseError.message ? responseError.message : responseError;
    if (error) {
        // Convert it to string directly by default
        stringRepresentation = String(error);
        // If the error is an object we will try to JSON parse it
        if (typeof error === 'object') try {
            // Try to parse it as JSON
            stringRepresentation = JSON.stringify(responseError);
        } catch  {
        // Swallow all stringify errors
        }
    }
    return new Error(stringRepresentation);
}

});

parcelRegister("jXnBe", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $42a3e378fee7fe01$export$775b6bb06e53a214);
$parcel$export(module.exports, "GenericContainerResult", () => $42a3e378fee7fe01$export$6ec00f56b27cdc1d);
$parcel$export(module.exports, "PersonResult", () => $42a3e378fee7fe01$export$ca1a50bc869949e);
$parcel$export(module.exports, "ConfluenceObjectResult", () => $42a3e378fee7fe01$export$a99961038e9d5471);
$parcel$export(module.exports, "RecentConfluence", () => $42a3e378fee7fe01$export$18c69de2b4aa679c);
$parcel$export(module.exports, "ResultConfluence", () => $42a3e378fee7fe01$export$dc31f0db54ab1a30);
$parcel$export(module.exports, "RecentPerson", () => $42a3e378fee7fe01$export$cb8b6c470492bee8);
$parcel$export(module.exports, "ResultPerson", () => $42a3e378fee7fe01$export$ebb42dafe7a39a20);
$parcel$export(module.exports, "ConfluenceSpace", () => $42a3e378fee7fe01$export$8ee8726ca4e2f8bd);
$parcel$export(module.exports, "Person", () => $42a3e378fee7fe01$export$d0e824889e01c751);
var $42a3e378fee7fe01$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    return Scope;
}({});
const $42a3e378fee7fe01$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $42a3e378fee7fe01$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $42a3e378fee7fe01$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $42a3e378fee7fe01$export$80a5be864676016b = 'confluence.space';
const $42a3e378fee7fe01$export$70542451ad6057d2 = 'urs.user-confluence';
const $42a3e378fee7fe01$export$6ec00f56b27cdc1d = 'generic-container-result';
const $42a3e378fee7fe01$export$ca1a50bc869949e = 'person-result';
const $42a3e378fee7fe01$export$a99961038e9d5471 = 'confluence-object-result';
const $42a3e378fee7fe01$export$18c69de2b4aa679c = 'recent-confluence';
const $42a3e378fee7fe01$export$dc31f0db54ab1a30 = 'result-confluence';
const $42a3e378fee7fe01$export$cb8b6c470492bee8 = 'recent-person';
const $42a3e378fee7fe01$export$ebb42dafe7a39a20 = 'result-person';
const $42a3e378fee7fe01$export$602b44a55c824e30 = 'advanced-search-confluence';
const $42a3e378fee7fe01$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $42a3e378fee7fe01$export$bbd1709e62826142 = 'confluence-page';
const $42a3e378fee7fe01$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $42a3e378fee7fe01$export$b441f0c13fd510b9 = 'confluence-attachment';
const $42a3e378fee7fe01$export$8ee8726ca4e2f8bd = 'confluence-space';
const $42a3e378fee7fe01$export$d0e824889e01c751 = 'person';

});

parcelRegister("3NyIw", function(module, exports) {

$parcel$export(module.exports, "SimpleCache", () => $d9c68f16ddda70b9$export$de40364712978bcb);
// A imperfect workaround to represent variadic parameters (varargs) in typescript
class $d9c68f16ddda70b9$export$de40364712978bcb {
    get(...args) {
        if (!this.currentValue || Date.now() >= this.nextCacheRefreshTime) {
            this.updateNextRefreshTime();
            let exception = new Error('');
            try {
                const result = this.supplier(...args);
                this.currentValue = result;
                if (this.currentValue) return {
                    fromCache: false,
                    value: this.currentValue
                };
            } catch (e) {
                // If there's an error we will return the last good value but will attempt again on the next get()
                this.invalidate();
                exception = e;
            }
            if (!this.currentValue) throw new Error(`Failed to initialise a value for the cache: ${exception?.stack}`);
        }
        return {
            fromCache: true,
            value: this.currentValue
        };
    }
    /**
   * Calls the given supplier and caches the value. If the value is a promise
   * which rejects, the cache will be invalidated and a subsequent call to
   * this function will call the supplier again.
   * @param args
   * @returns
   */ getAsync(...args) {
        const { fromCache: fromCache, value: value } = this.get(...args);
        // When the cached value is a promise which rejects, invalidate the cache
        Promise.resolve(value).catch(()=>this.invalidate());
        return {
            fromCache: fromCache,
            value: value
        };
    }
    invalidate() {
        this.nextCacheRefreshTime = Date.now();
    }
    updateNextRefreshTime() {
        this.nextCacheRefreshTime = Date.now() + this.timeoutMs;
    }
    /**
   * @param initialValue The initial value, if undefined then the first get() call when initiate the cache value
   *
   * @param supplier The callback that will be called if the cache times out or if no existing value exists for the cache.
   *                 In the case that the supplier throws an exception the error will not be cached. If there's an error
   *                    we will instead return the last known good value but will attempt to refresh the cache again the next time
   *                    get() is called.
   *                 Any parameters passed into get() will be passed through to supplier. Unlike memoize the cache does not
   *                    care about the parameters and will not be invalidated if these parameters change.
   *
   * @param timeoutMs The time to wait before allowing the cache to refresh, this defaults to 15 mins.
   */ constructor(supplier, initialValue = null, timeoutMs = $d9c68f16ddda70b9$export$de40364712978bcb.DEFAULT_TIMEOUT_IN_MS){
        this.timeoutMs = void 0;
        this.nextCacheRefreshTime = Date.now();
        this.currentValue = void 0;
        this.supplier = void 0;
        this.timeoutMs = timeoutMs;
        this.supplier = supplier;
        this.currentValue = null;
        if (initialValue) {
            this.currentValue = initialValue;
            this.updateNextRefreshTime();
        }
    }
}
$d9c68f16ddda70b9$export$de40364712978bcb.DEFAULT_TIMEOUT_IN_MS = 900000;

});

parcelRegister("6TCTf", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_ITEM_ENTITIES", () => $8a95e0dcc4ebe080$export$8c5e9a2b7d8e96fa);
$parcel$export(module.exports, "SEARCH_QUERY", () => $8a95e0dcc4ebe080$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "sitesToLocations", () => $8a95e0dcc4ebe080$export$13404986e7746e72);
const $8a95e0dcc4ebe080$export$8c5e9a2b7d8e96fa = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:blogpost'
];
const $8a95e0dcc4ebe080$export$f8e8a5f34f6ea725 = `
query($query: String, $entities:[String!]!, $locations: [String!]!, $confluenceFilters: SearchConfluenceFilter, $experience: String!){
  search{
    search(
      query: $query
      filters: {entities: $entities, locations: $locations, confluenceFilters: $confluenceFilters}
      analytics: {searchSessionId: "graphql"}
      experience: $experience
    ) {
      edges {
        node {
          id
          title
          url
          description
          type
          lastModifiedDate
          __typename
          ... on SearchConfluencePageBlogAttachment {
            type
            space {
              key
              iconUrl
            }
          }
        }
      }
    }
  }
}`;
const $8a95e0dcc4ebe080$export$13404986e7746e72 = (sites, cloudId)=>{
    const cloudIds = sites.length > 0 ? sites : [
        cloudId
    ];
    const locations = cloudIds.map((cloudId)=>`ari:cloud:confluence::site/${cloudId}`);
    return locations;
};
const $8a95e0dcc4ebe080$export$2351037d7dbc8a11 = (filters)=>{
    return {
        spaceFilter: filters.filter((filter)=>filter.type === 'space').map((filter)=>filter.id),
        contributorsFilter: filters.filter((filter)=>filter.type === 'contributor').map((filter)=>filter.id)
    };
};

});

parcelRegister("cMXX8", function(module, exports) {

$parcel$export(module.exports, "GraphQLClient", () => $f42a017b762dc955$export$b0f268a6eae2cdf1);

var $dwp40 = parcelRequire("dwp40");

var $9Nzn7 = parcelRequire("9Nzn7");

var $kfImN = parcelRequire("kfImN");

var $6TCTf = parcelRequire("6TCTf");
class $f42a017b762dc955$export$b0f268a6eae2cdf1 {
    async search({ query: query, context: // todo
    context, entities: entities, modelParams: // todo
    modelParams, resultLimit: // todo
    resultLimit, filters: filters, experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : (0, $kfImN.limitToMaxSiteUsage)(this.siteMasterList).map((site)=>site.cloudId);
        const locations = (0, $6TCTf.sitesToLocations)(cloudIdsToFilterOn, cloudId);
        const body = {
            query: (0, $6TCTf.SEARCH_QUERY),
            variables: {
                locations: locations,
                entities: entities,
                query: query,
                confluenceFilters: filters,
                experience: experience
            }
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $9Nzn7.timed)(this.makePostRequest($f42a017b762dc955$export$b0f268a6eae2cdf1.GRAPHQL_API_URL, body));
        return {
            response: {
                rawData: response
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
// Static URLs
$f42a017b762dc955$export$b0f268a6eae2cdf1.GRAPHQL_API_URL = 'graphql';

});


parcelRegister("heWLv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceRecentsClient", () => $effb6ad10ca37aba$export$2c04424b0b9ef0ac);

var $dwp40 = parcelRequire("dwp40");

var $czt8s = parcelRequire("czt8s");

var $1TPG8 = parcelRequire("1TPG8");

var $9Nzn7 = parcelRequire("9Nzn7");

var $3NyIw = parcelRequire("3NyIw");

var $jXnBe = parcelRequire("jXnBe");
const $effb6ad10ca37aba$export$be774cfa50234d6d = 'rest/recentlyviewed/1.0/recent';
const $effb6ad10ca37aba$export$d8751bf2ebec9fba = 'rest/recentlyviewed/1.0/recent/spaces';
const $effb6ad10ca37aba$var$RECENT_PAGES_LIMIT = 200;
const $effb6ad10ca37aba$var$RECENT_SPACE_LIMIT = 5;

class $effb6ad10ca37aba$export$2c04424b0b9ef0ac {
    getRecent(cache) {
        const { fromCache: fromCache, value: value } = cache.get();
        return (0, $czt8s.CancellablePromise).from(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    getRecentItems() {
        return this.getRecent(this.recentItemCache);
    }
    getRecentSpaces() {
        return this.getRecent(this.recentSpaceCache);
    }
    createRecentRequestPromise(path, queryParams) {
        const options = {
            path: path,
            queryParams: queryParams
        };
        const requestPromise = (0, $dwp40.utils).requestService(this.serviceConfig, options);
        return (0, $9Nzn7.timed)(requestPromise);
    }
    constructor({ url: url, isCollaborationGraphEnabled: isCollaborationGraphEnabled, recentItemsSupplier: recentItemsSupplier, useRecentWork: useRecentWork, recentWorkAPIUrl: recentWorkAPIUrl }, collabGraphClient){
        this.baseUrl = void 0;
        this.serviceConfig = void 0;
        this.recentItemCache = void 0;
        this.recentSpaceCache = void 0;
        this.isCollabGraphEnabled = void 0;
        this.collaborationGraphClient = void 0;
        this.useRecentWork = void 0;
        this.recentWorkAPIUrl = void 0;
        this.recentItemsSupplier = async ()=>{
            if (this.useRecentWork) {
                const { createActivityClient: createActivityClient } = await (parcelRequire("lVwKT"));
                const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentWorkAPIUrl);
                const { viewed: viewed } = await activityClient.fetchActivities([
                    250
                ], {
                    products: [
                        'confluence'
                    ]
                }, [
                    'viewed'
                ]);
                const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$effb6ad10ca37aba$var$recentWorkItemToResult(item));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: 0
                };
            } else {
                const baseUrl = this.serviceConfig.url;
                const recentPagesPromiseWithTimings = this.createRecentRequestPromise($effb6ad10ca37aba$export$be774cfa50234d6d, {
                    limit: $effb6ad10ca37aba$var$RECENT_PAGES_LIMIT
                });
                const { result: result, durationMs: durationMs } = await recentPagesPromiseWithTimings;
                const items = result.filter((page)=>!!page.title).map((recentPage)=>$effb6ad10ca37aba$var$recentPageToResult(recentPage, baseUrl));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: durationMs
                };
            }
        };
        this.recentSpacesSupplier = ()=>{
            if (this.isCollabGraphEnabled) return this.collaborationGraphClient.getContainers([
                (0, $1TPG8.SpaceContainerType)
            ]).then((response)=>$effb6ad10ca37aba$var$mapCollabGraphContainer(response));
            else {
                const recentSpacesPromise = this.createRecentRequestPromise($effb6ad10ca37aba$export$d8751bf2ebec9fba, {
                    limit: $effb6ad10ca37aba$var$RECENT_SPACE_LIMIT
                });
                return recentSpacesPromise.then(({ result: result, durationMs: durationMs })=>({
                        items: result.map((recentSpace)=>$effb6ad10ca37aba$var$recentSpaceToResult(recentSpace, `${this.baseUrl}/spaces/${recentSpace.key}`)),
                        timings: durationMs
                    }));
            }
        };
        this.serviceConfig = {
            url: url
        };
        this.baseUrl = url;
        this.recentItemCache = new (0, $3NyIw.SimpleCache)(recentItemsSupplier || this.recentItemsSupplier);
        this.recentSpaceCache = new (0, $3NyIw.SimpleCache)(this.recentSpacesSupplier);
        this.collaborationGraphClient = collabGraphClient;
        this.isCollabGraphEnabled = isCollaborationGraphEnabled;
        this.useRecentWork = useRecentWork || false;
        this.recentWorkAPIUrl = recentWorkAPIUrl;
    }
}
function $effb6ad10ca37aba$var$recentWorkItemToResult(recentItem) {
    const { object: object, containers: containers } = recentItem;
    return {
        resultId: object.id,
        containerName: containers[0].name,
        containerId: '',
        resultType: (0, $jXnBe.ConfluenceObjectResult),
        isRecentResult: true,
        name: object.name || '',
        // Failsafe. All items should have a name.
        href: object.url,
        contentType: `confluence-${object.type}`,
        lastModified: undefined,
        // not available
        analyticsType: (0, $jXnBe.RecentConfluence)
    };
}
function $effb6ad10ca37aba$var$recentPageToResult(recentPage, baseUrl) {
    return {
        resultId: String(recentPage.id),
        name: recentPage.title || '',
        // This is a failsafe, there should be a filter to drop pages with no titles
        href: `${baseUrl}${recentPage.url}`,
        containerName: recentPage.space,
        analyticsType: (0, $jXnBe.RecentConfluence),
        resultType: (0, $jXnBe.ConfluenceObjectResult),
        contentType: `confluence-${recentPage.contentType}`,
        iconClass: recentPage.iconClass,
        containerId: recentPage.spaceId.toString(),
        isRecentResult: true,
        lastModified: undefined,
        // not available for recent results
        spaceId: recentPage.spaceId?.toString()
    };
}
function $effb6ad10ca37aba$var$recentSpaceToResult(recentSpace, href) {
    return {
        resultId: recentSpace.id,
        name: recentSpace.name,
        key: recentSpace.key,
        href: href,
        avatarUrl: recentSpace.icon,
        analyticsType: (0, $jXnBe.RecentConfluence),
        resultType: (0, $jXnBe.GenericContainerResult),
        contentType: (0, $jXnBe.ConfluenceSpace),
        id: recentSpace.id
    };
}
function $effb6ad10ca37aba$var$mapCollabGraphContainer(response) {
    const items = response.collaborationGraphEntities.map((item)=>({
            id: item.containerDetails?.id,
            key: item.containerDetails?.key,
            icon: item.containerDetails?.iconUrl,
            name: item.containerDetails?.name,
            url: item.containerDetails?.url,
            siteId: item.siteId
        })).filter((space)=>space.id !== undefined).map((space)=>$effb6ad10ca37aba$var$recentSpaceToResult(space, space.url));
    return {
        items: items,
        timings: response.timings
    };
}

});
parcelRegister("1TPG8", function(module, exports) {

$parcel$export(module.exports, "SpaceContainerType", () => $efe8e1453cb04fa5$export$e28d152a38023114);
const $efe8e1453cb04fa5$export$e28d152a38023114 = 'confluenceSpace';
const $efe8e1453cb04fa5$export$b9a68081b849a9ab = 'jiraProject';

});

parcelRegister("lVwKT", function(module, exports) {

let $ff68545e13f3c187$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ff68545e13f3c187$var$load("jCu7l"),
    $ff68545e13f3c187$var$load("c6MKV"),
    $ff68545e13f3c187$var$load("efZH2")
]).then(()=>parcelRequire('mS2VM'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("cfEFl", function(module, exports) {

$parcel$export(module.exports, "MAX_CG_RESULTS", () => $6e4dcee96054a2d9$export$8b133b5f27893e80);
$parcel$export(module.exports, "CONTEXT_USER_ID", () => $6e4dcee96054a2d9$export$886facd7f1fb825b);
$parcel$export(module.exports, "QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT", () => $6e4dcee96054a2d9$export$c4871241365cf270);
$parcel$export(module.exports, "CollaborationGraphClient", () => $6e4dcee96054a2d9$export$cd5b4a06db0ea4e2);

var $1Qx68 = parcelRequire("1Qx68");

var $45ZOs = parcelRequire("45ZOs");
const $6e4dcee96054a2d9$export$8b133b5f27893e80 = 10;
const $6e4dcee96054a2d9$export$886facd7f1fb825b = 'context';
const $6e4dcee96054a2d9$export$c4871241365cf270 = 'quickSearch';
class $6e4dcee96054a2d9$export$cd5b4a06db0ea4e2 {
    constructor(config){
        this.isMultiSite = void 0;
        this.cloudId = void 0;
        this.sites = void 0;
        this.collabGraphSingleSite = void 0;
        this.collabGraphMultiSite = void 0;
        this.getContainers = (containerTypes, sites = [])=>{
            if (this.isMultiSite) return this.collabGraphMultiSite.getContainers({
                selectedSites: sites,
                containerTypes: containerTypes,
                allSites: this.sites.length > 0 ? this.sites : [
                    {
                        cloudId: this.cloudId
                    }
                ]
            });
            else return this.collabGraphSingleSite.getContainers({
                containerTypes: containerTypes,
                cloudId: this.cloudId
            });
        };
        this.getUsers = (sites = [])=>{
            if (this.isMultiSite) return this.collabGraphMultiSite.getUsers({
                allSites: this.sites.length > 0 ? this.sites : [
                    {
                        cloudId: this.cloudId
                    }
                ],
                selectedSites: sites
            });
            else return this.collabGraphSingleSite.getUsers({
                cloudId: this.cloudId
            });
        };
        this.collabGraphSingleSite = new (0, $1Qx68.CollaborationGraphSingleSite)(config);
        this.collabGraphMultiSite = new (0, $45ZOs.CollaborationGraphMultiSite)(config);
        this.isMultiSite = config.isMultiSite;
        this.cloudId = config.cloudId;
        this.sites = config.sites;
    }
}

});
parcelRegister("1Qx68", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraphSingleSite", () => $a937e9fff7ff80c1$export$75acaca275e7d34b);

var $4M3aT = parcelRequire("4M3aT");

var $cfEFl = parcelRequire("cfEFl");
class $a937e9fff7ff80c1$export$75acaca275e7d34b extends (0, $4M3aT.CollaborationGraph) {
    getUsers(arg) {
        return this.usersCache.get(arg).value;
    }
    getContainers({ containerTypes: containerTypes, cloudId: cloudId }) {
        return this.containersCache.get({
            containerTypes: containerTypes,
            cloudId: cloudId
        }).value;
    }
    async getContainersSupplier({ containerTypes: containerTypes, cloudId: cloudId }) {
        const body = {
            containerTypes: containerTypes,
            context: {
                principalId: (0, $cfEFl.CONTEXT_USER_ID),
                siteId: cloudId,
                contextType: (0, $cfEFl.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
            },
            maxNumberOfResults: (0, $cfEFl.MAX_CG_RESULTS),
            userId: (0, $cfEFl.CONTEXT_USER_ID),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: cloudId
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    async getUsersSupplier({ cloudId: cloudId = '', collabGraphSessionId: collabGraphSessionId = '' }) {
        const body = {
            context: {
                principalId: (0, $cfEFl.CONTEXT_USER_ID),
                siteId: cloudId,
                sessionId: collabGraphSessionId,
                contextType: (0, $cfEFl.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
            },
            maxNumberOfResults: (0, $cfEFl.MAX_CG_RESULTS),
            userId: (0, $cfEFl.CONTEXT_USER_ID),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: cloudId
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    constructor({ collaborationGraphUrl: url }){
        super({
            url: url
        });
        this.CONTAINER_URL_PATH = 'v1/collaborationgraph/user/container';
        this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
    }
}

});
parcelRegister("4M3aT", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraph", () => $2d835650f472091b$export$d4989257696242c9);

var $dwp40 = parcelRequire("dwp40");

var $3NyIw = parcelRequire("3NyIw");

var $9Nzn7 = parcelRequire("9Nzn7");
class $2d835650f472091b$export$d4989257696242c9 {
    async makeRequest(path, body) {
        const options = {
            path: path,
            requestInit: {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(body)
            }
        };
        return (0, $9Nzn7.timed)((0, $dwp40.utils).requestService(this.serviceConfig, options));
    }
    constructor({ url: url }){
        this.CONTAINER_URL_PATH = void 0;
        this.USER_URL_PATH = void 0;
        this.containersCache = void 0;
        this.usersCache = void 0;
        this.serviceConfig = void 0;
        this.serviceConfig = {
            url: url
        };
        this.getContainersSupplier = this.getContainersSupplier.bind(this);
        this.getUsersSupplier = this.getUsersSupplier.bind(this);
        this.containersCache = new (0, $3NyIw.SimpleCache)(this.getContainersSupplier);
        this.usersCache = new (0, $3NyIw.SimpleCache)(this.getUsersSupplier);
    }
}

});


parcelRegister("45ZOs", function(module, exports) {

$parcel$export(module.exports, "CollaborationGraphMultiSite", () => $5787685b349c0701$export$6150ad6d7e95f129);

var $jV49M = parcelRequire("jV49M");

var $4M3aT = parcelRequire("4M3aT");

var $cfEFl = parcelRequire("cfEFl");

var $kfImN = parcelRequire("kfImN");
const $5787685b349c0701$var$mergeUsers = (prevResult, nextResult)=>({
        timings: Math.max(prevResult.timings, nextResult.timings),
        collaborationGraphEntities: (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(prevResult.collaborationGraphEntities.concat(nextResult.collaborationGraphEntities), (user)=>user.id)
    });
const $5787685b349c0701$var$emptyUserResponse = {
    timings: 0,
    collaborationGraphEntities: []
};
class $5787685b349c0701$export$6150ad6d7e95f129 extends (0, $4M3aT.CollaborationGraph) {
    async getContainersSupplier(arg) {
        const body = {
            containerTypes: arg.containerTypes,
            context: {
                principalId: (0, $cfEFl.CONTEXT_USER_ID),
                siteIds: arg.cloudIds,
                contextType: (0, $cfEFl.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
            },
            maxNumberOfResults: (0, $cfEFl.MAX_CG_RESULTS),
            userId: (0, $cfEFl.CONTEXT_USER_ID),
            expanded: true
        };
        const { result: result, durationMs: durationMs } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
        result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>{
            return {
                ...cgEntity,
                siteId: (0, $kfImN.extractSiteIdBySiteUrl)(cgEntity.containerDetails.url, arg.allSites)
            };
        });
        return {
            ...result,
            timings: durationMs
        };
    }
    async getUsersSupplier(arg) {
        const results = arg.cloudIds.map(async (cloudId)=>{
            const body = {
                context: {
                    principalId: (0, $cfEFl.CONTEXT_USER_ID),
                    siteId: cloudId,
                    contextType: (0, $cfEFl.QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT)
                },
                maxNumberOfResults: (0, $cfEFl.MAX_CG_RESULTS),
                userId: (0, $cfEFl.CONTEXT_USER_ID),
                expanded: true
            };
            const { result: result, durationMs: durationMs } = await this.makeRequest(this.USER_URL_PATH, body);
            result.collaborationGraphEntities = result.collaborationGraphEntities.map((cgEntity)=>({
                    ...cgEntity,
                    siteId: cloudId
                }));
            return {
                ...result,
                timings: durationMs
            };
        });
        return Promise.all(results).then((values)=>values.reduce($5787685b349c0701$var$mergeUsers, $5787685b349c0701$var$emptyUserResponse));
    }
    getUsers({ allSites: allSites, selectedSites: selectedSites }) {
        if (selectedSites.length === 0) return this.usersCache.get({
            cloudIds: (0, $kfImN.limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId)
        }).value;
        else return this.getUsersSupplier({
            cloudIds: selectedSites.map((site)=>site.cloudId)
        });
    }
    getContainers({ allSites: allSites, selectedSites: selectedSites, containerTypes: containerTypes }) {
        if (selectedSites.length === 0) return this.containersCache.get({
            cloudIds: (0, $kfImN.limitToMaxSiteUsage)(allSites).map((site)=>site.cloudId),
            containerTypes: containerTypes
        }).value;
        else return this.getContainersSupplier({
            cloudIds: selectedSites.map((site)=>site.cloudId),
            containerTypes: containerTypes,
            allSites: allSites
        });
    }
    constructor(config){
        super({
            url: config.collaborationGraphUrl
        });
        this.CONTAINER_URL_PATH = 'v1/collaborationgraph/multitenant/user/container';
        this.USER_URL_PATH = 'v1/collaborationgraph/user/user';
    }
}

});



parcelRegister("91yhh", function(module, exports) {

$parcel$export(module.exports, "ExperimentProvider", () => $c9b4bbfb0318c1b1$export$ce7a53bcef5d6aee);
$parcel$export(module.exports, "useExperiments", () => $c9b4bbfb0318c1b1$export$d98589668c6e11a9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iA4lt = parcelRequire("iA4lt");
var $gkXKl = parcelRequire("gkXKl");
var $4OGlb = parcelRequire("4OGlb");
const $c9b4bbfb0318c1b1$export$ce7a53bcef5d6aee = ({ quickFindEnabled: quickFindEnabled, children: children })=>{
    const layerName = quickFindEnabled ? (0, $4OGlb.STATSIG_QUICK_FIND_LAYER) : undefined;
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = (0, $gwFzn.useMemo)(()=>(0, $gkXKl.getMutuallyExclusiveExperiment)(layerName), [
        layerName
    ]);
    let frontendExperiments;
    if (quickFindEnabled) {
        const exampleFrontendExperiment = (0, $iA4lt.getFrontendExperiment)({
            abTestId: 'fe_search_experiment'
        });
        frontendExperiments = {
            // the mutually exclusive frontend experiment
            ...frontendExperiment?.abTestId && {
                [frontendExperiment.abTestId]: frontendExperiment
            },
            // add other frontend experiments that can be run alongside backend experiments here
            [exampleFrontendExperiment.abTestId]: exampleFrontendExperiment
        };
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)($c9b4bbfb0318c1b1$var$ExperimentContext.Provider, {
        value: {
            backendExperiment: backendExperiment,
            frontendExperiments: frontendExperiments
        },
        children: children
    });
};
const $c9b4bbfb0318c1b1$var$ExperimentContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    backendExperiment: undefined,
    frontendExperiments: undefined
});
const $c9b4bbfb0318c1b1$export$d98589668c6e11a9 = ()=>{
    return (0, $gwFzn.useContext)($c9b4bbfb0318c1b1$var$ExperimentContext);
};

});

parcelRegister("6clwF", function(module, exports) {

$parcel$export(module.exports, "JiraSearchClientProvider", () => $fe7e2b06857d7b1f$export$f8102de5af58503c);
$parcel$export(module.exports, "useJiraSearchClientContext", () => $fe7e2b06857d7b1f$export$71e1e199804dfd5e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aAuSn = parcelRequire("aAuSn");

var $csnse = parcelRequire("csnse");

var $dGwqS = parcelRequire("dGwqS");

var $lP9EZ = parcelRequire("lP9EZ");

var $cfEFl = parcelRequire("cfEFl");
var $kfImN = parcelRequire("kfImN");

var $91yhh = parcelRequire("91yhh");
const $fe7e2b06857d7b1f$var$ERROR_MESSAGE = 'Jira search client has not been instantiated. This is most likely because you are missing a JiraSearchClientProvider.';
const $fe7e2b06857d7b1f$var$defaultCollaborationGraphConfig = {
    collaborationGraphUrl: 'gateway/api/collaboration',
    useCollaborationGraphForRecents: false
};
const $fe7e2b06857d7b1f$var$getCollabGraphClientWithConfig = (0, $csnse.default)((config)=>new (0, $cfEFl.CollaborationGraphClient)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $fe7e2b06857d7b1f$export$5b76b773dfc5ee6a = /*#__PURE__*/ (0, $gwFzn.createContext)({});
const $fe7e2b06857d7b1f$var$DEFAULT_SITES = [];
const $fe7e2b06857d7b1f$export$f8102de5af58503c = ({ aggregatorUrl: aggregatorUrl, cloudId: cloudId, isUserAnonymous: isUserAnonymous, collaborationGraphUrl: collaborationGraphUrl, children: children, baseUrl: baseUrl, accountId: accountId, siteUrl: siteUrl = '', recentIssuesSupplier: recentIssuesSupplier, currentUserSupplier: currentUserSupplier, sites: sites = $fe7e2b06857d7b1f$var$DEFAULT_SITES })=>{
    siteUrl = (0, $gwFzn.useMemo)(()=>(0, $kfImN.extractSiteUrl)({
            siteUrl: siteUrl,
            sites: sites
        }), [
        siteUrl,
        sites
    ]);
    const { backendExperiment: backendExperiment } = (0, $91yhh.useExperiments)();
    const searchClient = (0, $gwFzn.useMemo)(()=>new (0, $lP9EZ.JiraSearchClient)({
            siteMasterList: sites,
            url: aggregatorUrl,
            cloudId: cloudId,
            isUserAnonymous: isUserAnonymous,
            recentIssuesSupplier: recentIssuesSupplier,
            siteUrl: siteUrl,
            backendExperiment: backendExperiment
        }), [
        aggregatorUrl,
        cloudId,
        isUserAnonymous,
        recentIssuesSupplier,
        siteUrl,
        sites,
        backendExperiment
    ]);
    const collabGraphClient = $fe7e2b06857d7b1f$var$getCollabGraphClientWithConfig({
        // If no collaborationGraphUrl is passed as a prop, use the fallback (default) URL
        collaborationGraphUrl: collaborationGraphUrl || $fe7e2b06857d7b1f$var$defaultCollaborationGraphConfig.collaborationGraphUrl,
        cloudId: cloudId,
        isMultiSite: sites.length > 1,
        sites: sites
    });
    const currentUserClient = (0, $gwFzn.useMemo)(()=>accountId ? new (0, $dGwqS.JiraCurrentUserClient)({
            accountId: accountId,
            baseUrl: baseUrl,
            currentUserSupplier: currentUserSupplier
        }) : undefined, [
        accountId,
        baseUrl,
        currentUserSupplier
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($fe7e2b06857d7b1f$export$5b76b773dfc5ee6a.Provider, {
        value: {
            searchClient: searchClient,
            collabGraphClient: collabGraphClient,
            currentUserClient: currentUserClient,
            siteUrl: siteUrl,
            cloudId: cloudId,
            sites: sites
        },
        children: children
    });
};
const $fe7e2b06857d7b1f$export$413dca1b70dbb4a7 = (Component)=>{
    return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($fe7e2b06857d7b1f$export$5b76b773dfc5ee6a.Consumer, {
            children: ({ searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, cloudId: cloudId, sites: sites })=>{
                if (!searchClient) throw new Error($fe7e2b06857d7b1f$var$ERROR_MESSAGE);
                const { ...rest } = props;
                return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    ...rest,
                    searchClient: searchClient,
                    collabGraphClient: collabGraphClient,
                    currentUserClient: currentUserClient,
                    cloudId: cloudId,
                    sites: sites
                });
            }
        });
};
function $fe7e2b06857d7b1f$export$71e1e199804dfd5e() {
    const { searchClient: searchClient, collabGraphClient: collabGraphClient, currentUserClient: currentUserClient, siteUrl: siteUrl, sites: sites, cloudId: cloudId } = (0, $gwFzn.useContext)($fe7e2b06857d7b1f$export$5b76b773dfc5ee6a);
    if (!searchClient) throw new Error($fe7e2b06857d7b1f$var$ERROR_MESSAGE);
    return {
        searchClient: searchClient,
        collabGraphClient: collabGraphClient,
        currentUserClient: currentUserClient,
        siteUrl: siteUrl,
        cloudId: cloudId,
        sites: sites
    };
}

});
parcelRegister("dGwqS", function(module, exports) {

$parcel$export(module.exports, "JiraCurrentUserClient", () => $d81dca87d92d32f6$export$bbcfcc9f52275229);

var $gwFzn = parcelRequire("gwFzn");

var $dwp40 = parcelRequire("dwp40");

var $9Nzn7 = parcelRequire("9Nzn7");

var $3NyIw = parcelRequire("3NyIw");

var $6clwF = parcelRequire("6clwF");
const $d81dca87d92d32f6$var$USER_DATA_URL = '/rest/api/3/user';
class $d81dca87d92d32f6$export$bbcfcc9f52275229 {
    async makeRequest(path) {
        const options = {
            path: path,
            queryParams: {
                accountId: this.accountId,
                expand: 'applicationRoles'
            }
        };
        return (0, $9Nzn7.timed)((0, $dwp40.utils).requestService(this.serviceConfig, options));
    }
    constructor({ accountId: accountId, baseUrl: baseUrl, currentUserSupplier: currentUserSupplier }){
        this.serviceConfig = void 0;
        this.currentUserCache = void 0;
        this.accountId = void 0;
        this.getCurrentUser = ()=>this.currentUserCache.get().value;
        this.getUserSupplier = async ()=>{
            const { result: result, durationMs: durationMs } = await this.makeRequest($d81dca87d92d32f6$var$USER_DATA_URL);
            return {
                ...result,
                timings: durationMs
            };
        };
        this.serviceConfig = {
            url: baseUrl
        };
        this.accountId = accountId;
        this.currentUserCache = new (0, $3NyIw.SimpleCache)(currentUserSupplier || this.getUserSupplier);
    }
}
const $d81dca87d92d32f6$export$2393d475b44b8a57 = (user = {})=>{
    const [loadingComplete, setLoadingComplete] = (0, $gwFzn.useState)(false);
    const [currentUser, setCurrentUser] = (0, $gwFzn.useState)(user);
    const { currentUserClient: currentUserClient } = (0, $6clwF.useJiraSearchClientContext)();
    (0, $gwFzn.useEffect)(()=>{
        if (!loadingComplete) {
            let shouldUpdate = true;
            currentUserClient?.getCurrentUser().then((result)=>{
                if (shouldUpdate && !loadingComplete) {
                    setCurrentUser({
                        id: result.accountId,
                        name: result.displayName,
                        avatarUrl: result.avatarUrls['24x24'],
                        email: result.emailAddress,
                        hasSoftwareAccess: result.applicationRoles.items.some((item)=>item.key === 'jira-software')
                    });
                    setLoadingComplete(true);
                }
            }).catch(()=>{}); // swallow any errors
            return ()=>{
                shouldUpdate = false;
            };
        }
    }, [
        currentUserClient,
        loadingComplete
    ]);
    return currentUser;
};

});

parcelRegister("lP9EZ", function(module, exports) {

$parcel$export(module.exports, "JiraSearchClient", () => $4194cf53882a191e$export$824e4d5b28750c3f);
$parcel$export(module.exports, "attributeTypeToContentType", () => $4194cf53882a191e$export$1436a8642ffb43cf);

var $czt8s = parcelRequire("czt8s");

var $12cJV = parcelRequire("12cJV");
var $c3kEC = parcelRequire("c3kEC");

var $8WxPE = parcelRequire("8WxPE");

var $3NyIw = parcelRequire("3NyIw");

var $8hr1g = parcelRequire("8hr1g");

var $fC7SC = parcelRequire("fC7SC");

var $kfImN = parcelRequire("kfImN");
const $4194cf53882a191e$var$RECENT_PLANS_SOFT_LIMIT = 2;
const $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE = 'jira.nav-v3';
class $4194cf53882a191e$export$824e4d5b28750c3f {
    getRecent(cache, context, sites) {
        const { fromCache: fromCache, value: value } = cache.get(context, (0, $kfImN.limitToMaxSiteUsage)(sites));
        return (0, $czt8s.CancellablePromise).from(value.then((results)=>({
                ...results,
                isCached: fromCache
            })));
    }
    getRecentBoardsProjectsFiltersPlansInterleaved(context, sites) {
        const { fromCache: boardsProjectsFiltersFromCache, value: boardsProjectsFiltersValue } = this.recentBoardsProjectsFiltersCache.get(context, sites);
        const { fromCache: plansFromCache, value: plansValue } = this.recentPlansCache.get(context, sites);
        return (0, $czt8s.CancellablePromise).from(Promise.all([
            boardsProjectsFiltersValue,
            plansValue
        ]).then((results)=>({
                ...this.interleaveRecentBoardsProjectsFiltersPlans(results[0], results[1]),
                isCached: plansFromCache && boardsProjectsFiltersFromCache
            })));
    }
    getRecentIssues(context, sites) {
        return this.getRecent(this.recentIssuesCache, context, sites);
    }
    getRecentPlans(context, sites) {
        return this.getRecent(this.recentPlansCache, context, sites);
    }
    getRecentProjects(context, sites) {
        return this.getRecent(this.recentProjectsCache, context, sites);
    }
    getRecentBoardsProjectsFilters(context, sites) {
        return this.getRecent(this.recentBoardsProjectsFiltersCache, context, sites);
    }
    getRecentBoardsProjectsFiltersPlans(context, sites) {
        return this.getRecentBoardsProjectsFiltersPlansInterleaved(context, sites);
    }
    /**
   * Check the user permissions for the given list of products.
   */ async getProductPermissions(products) {
        if (!this.permissionsDataCache) this.permissionsDataCache = await this.aggregatorClient.getProductPermissions(products, $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE);
        return this.permissionsDataCache;
    }
    async getAbTestData() {
        if (this.abTestDataCache) return this.abTestDataCache;
        const abTest = await this.aggregatorClient.getAbTestData((0, $8WxPE.Scope).JiraIssue, $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE);
        this.abTestDataCache = abTest;
        return abTest;
    }
    getRecentPeople(context, sites) {
        return this.getRecent(this.recentPeopleCache, context, sites);
    }
    searchPeople(query, context, sites) {
        return (0, $czt8s.CancellablePromise).from(this.searchForPeopleScope(query, context, false, sites));
    }
    searchForPeopleScope(query, context, isForRecentResults, sites, queryVersion) {
        if (this.isUserAnonymous) return Promise.resolve({
            items: [],
            timings: 0,
            totalSize: 0
        });
        const results = this.searchForScope(query, [], context, [
            (0, $8WxPE.Scope).People
        ], $4194cf53882a191e$export$824e4d5b28750c3f.PEOPLE_RESULT_LIMIT, isForRecentResults, sites, queryVersion)[(0, $8WxPE.Scope).People];
        if (!results) throw new Error(`Failed to retrieve results for scope ${(0, $8WxPE.Scope).People}`);
        return results.promise();
    }
    searchProjects(query, context, sites) {
        const results = this.searchForScope(query, [], context, [
            (0, $8WxPE.Scope).JiraProject
        ], $4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites)[(0, $8WxPE.Scope).JiraProject];
        if (!results) throw new Error(`Failed to retrieve results for scope ${(0, $8WxPE.Scope).JiraProject}`);
        return results;
    }
    constructor(config){
        this.abTestDataCache = null;
        this.permissionsDataCache = null;
        this.aggregatorClient = void 0;
        this.recentIssuesCache = void 0;
        this.recentPeopleCache = void 0;
        this.recentBoardsProjectsFiltersCache = void 0;
        this.recentPlansCache = void 0;
        this.recentProjectsCache = void 0;
        this.isUserAnonymous = void 0;
        this.recentIssuesSupplier = async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $8WxPE.Scope).JiraIssue
            ], $4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, true, sites)[(0, $8WxPE.Scope).JiraIssue];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $8WxPE.Scope).JiraIssue}`);
            return results.promise();
        };
        // For recent results, we only want to show up to 2 recent plans as the last 2 results
        // as we cannot accurately interleave  recent plans with recent boards, projects, filter results.
        // However, it is valid to show more than 2 plans in the case where other entity types have been exhausted.
        this.interleaveRecentBoardsProjectsFiltersPlans = (boardProjectFilterResults, planResults)=>{
            const timings = planResults.timings > boardProjectFilterResults.timings ? planResults.timings : boardProjectFilterResults.timings;
            const { items: items } = boardProjectFilterResults;
            if (planResults.items.length >= $4194cf53882a191e$var$RECENT_PLANS_SOFT_LIMIT) while(items.length > $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - $4194cf53882a191e$var$RECENT_PLANS_SOFT_LIMIT)items.pop();
            else while(items.length > $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT - planResults.items.length)items.pop();
            for(let planCount = 0; items.length < $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT && planResults.items.length > planCount; planCount++)items.push(planResults.items[planCount]);
            return {
                timings: timings,
                items: items,
                totalSize: items.length
            };
        };
        this.search = (query, filters, context, queryVersion, hasAdvancedRoadmapsAccess, sites)=>{
            const issueSearch = this.searchForScope(query, filters, context, [
                (0, $8WxPE.Scope).JiraIssue
            ], $4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT, false, sites, queryVersion);
            const onlyDateFilterEnabled = filters.length === 1 && filters[0]?.type === 'dateFromLastModified';
            const scopes = hasAdvancedRoadmapsAccess ? [
                (0, $8WxPE.Scope).JiraBoardProjectFilterPlan
            ] : [
                (0, $8WxPE.Scope).JiraBoardProjectFilter
            ];
            const limit = hasAdvancedRoadmapsAccess ? $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT : $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_LIMIT;
            const jiraBoardProjectFilterSearch = filters.length === 0 || onlyDateFilterEnabled ? this.searchForScope(query, filters, context, scopes, limit, false, sites, queryVersion) : {};
            return {
                ...issueSearch,
                ...jiraBoardProjectFilterSearch
            };
        };
        this.searchForScope = (query, filters, context, scopes, resultLimit, isForRecentResults, sites = [], queryVersion)=>{
            const modelParams = queryVersion || queryVersion === 0 ? [
                {
                    '@type': 'queryParams',
                    queryVersion: queryVersion
                }
            ] : [];
            const allFilters = [];
            let baseProjectFilters = null;
            let baseAssigneeFilters = null;
            let baseBinaryStatusCategoryFilters = null;
            let lastModifiedFilter = {
                '@type': 'lastModified'
            };
            let lastViewedFilter = {
                '@type': 'lastViewed'
            };
            filters.forEach((filter)=>{
                switch(filter.type){
                    case 'project':
                        if (!baseProjectFilters) {
                            baseProjectFilters = {
                                '@type': 'projects',
                                projectIds: []
                            };
                            allFilters.push(baseProjectFilters);
                        }
                        baseProjectFilters.projectIds.push(filter.id);
                        break;
                    case 'assignee':
                        if (!baseAssigneeFilters) {
                            baseAssigneeFilters = {
                                '@type': 'assignees',
                                accountIds: []
                            };
                            allFilters.push(baseAssigneeFilters);
                        }
                        baseAssigneeFilters.accountIds.push(filter.id);
                        break;
                    case 'binary_status_category':
                        if (!baseBinaryStatusCategoryFilters) {
                            baseBinaryStatusCategoryFilters = {
                                '@type': 'binary_status_categories',
                                binaryStatusCategories: []
                            };
                            allFilters.push(baseBinaryStatusCategoryFilters);
                        }
                        baseBinaryStatusCategoryFilters.binaryStatusCategories.push(filter.id);
                        break;
                    case 'dateFromLastModified':
                        filter.id && (lastModifiedFilter.from = filter.id);
                        break;
                    case 'dateFromLastViewed':
                        filter.id && (lastViewedFilter.from = filter.id);
                        break;
                    case 'dateToLastModified':
                        filter.id && (lastModifiedFilter.to = filter.id);
                        break;
                    default:
                        break;
                }
            });
            if (lastModifiedFilter.from || lastModifiedFilter.to) allFilters.push(lastModifiedFilter);
            if (lastViewedFilter.from) allFilters.push(lastViewedFilter);
            const responses = this.aggregatorClient.search({
                query: query,
                context: context,
                scopes: scopes,
                modelParams: modelParams,
                resultLimit: resultLimit,
                filters: allFilters,
                experience: $4194cf53882a191e$var$NAVIGATION_V3_EXPERIENCE,
                sites: sites.length > 0 ? sites.map((s)=>s.cloudId) : undefined
            });
            return scopes.reduce((results, currentScope)=>({
                    ...results,
                    [currentScope]: (0, $czt8s.CancellablePromise).from(responses.then(({ response: response, requestDurationMs: requestDurationMs })=>{
                        const scopedResponse = response.retrieveScope(currentScope);
                        if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
                        if (scopedResponse.error) throw (0, $c3kEC.responseErrorToError)(scopedResponse.error);
                        if (currentScope === (0, $8WxPE.Scope).JiraIssue) return (0, $fC7SC.transformJiraIssueScope)(scopedResponse, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).JiraPlan) return (0, $fC7SC.transformJiraPlanScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).JiraBoardProjectFilter) return (0, $fC7SC.transformJiraBoardProjectFilterScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).JiraBoardProjectFilterPlan) return (0, $fC7SC.transformJiraBoardProjectFilterScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).JiraProject) return (0, $fC7SC.transformJiraProjectScope)(scopedResponse.results, isForRecentResults, requestDurationMs);
                        else if (currentScope === (0, $8WxPE.Scope).People) return (0, $fC7SC.transformUrsPeople)(scopedResponse.results, isForRecentResults, requestDurationMs, sites.length > 0);
                    }))
                }), {});
        };
        const { recentIssuesSupplier: recentIssuesSupplier = null } = config;
        this.aggregatorClient = new (0, $12cJV.AggregatorClient)(config);
        this.recentPeopleCache = new (0, $3NyIw.SimpleCache)((context, sites)=>this.searchForPeopleScope('', context, true, sites));
        this.recentIssuesCache = recentIssuesSupplier ? new (0, $3NyIw.SimpleCache)((ignored)=>recentIssuesSupplier()) : new (0, $3NyIw.SimpleCache)(this.recentIssuesSupplier);
        this.recentBoardsProjectsFiltersCache = new (0, $3NyIw.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $8WxPE.Scope).JiraBoardProjectFilter
            ], $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, $8WxPE.Scope).JiraBoardProjectFilter];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $8WxPE.Scope).JiraBoardProjectFilter}`);
            return results.promise();
        });
        this.recentPlansCache = new (0, $3NyIw.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $8WxPE.Scope).JiraPlan
            ], $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT, true, sites)[(0, $8WxPE.Scope).JiraPlan];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $8WxPE.Scope).JiraPlan}`);
            return results.promise();
        });
        this.recentProjectsCache = new (0, $3NyIw.SimpleCache)(async (context, sites)=>{
            const results = this.searchForScope('', [], context, [
                (0, $8WxPE.Scope).JiraProject
            ], $4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_RESULT_LIMIT, true, sites)[(0, $8WxPE.Scope).JiraProject];
            if (!results) throw new Error(`Failed to retrieve recent results for scope ${(0, $8WxPE.Scope).JiraProject}`);
            return results.promise();
        });
        this.isUserAnonymous = config.isUserAnonymous;
    }
}
$4194cf53882a191e$export$824e4d5b28750c3f.ITEM_RESULT_LIMIT = 50;
$4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_LIMIT = 6;
$4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_BOARD_FILTER_PLAN_LIMIT = 8;
$4194cf53882a191e$export$824e4d5b28750c3f.PROJECT_RESULT_LIMIT = 10;
$4194cf53882a191e$export$824e4d5b28750c3f.PEOPLE_RESULT_LIMIT = 10;
function $4194cf53882a191e$export$1436a8642ffb43cf(attributeType) {
    switch(attributeType){
        case (0, $8WxPE.AttributeType).issue:
            return (0, $8WxPE.ContentType).JiraIssue;
        case (0, $8WxPE.AttributeType).project:
            return (0, $8WxPE.ContentType).JiraProject;
        case (0, $8WxPE.AttributeType).board:
            return (0, $8WxPE.ContentType).JiraBoard;
        case (0, $8WxPE.AttributeType).filter:
            return (0, $8WxPE.ContentType).JiraFilter;
        case (0, $8WxPE.AttributeType).plan:
            return (0, $8WxPE.ContentType).JiraPlan;
        case (0, $8WxPE.AttributeType).people:
            return (0, $8WxPE.ContentType).JiraPeople;
        default:
            throw new (0, $8hr1g.UnreachableError)(attributeType);
    }
}

});
parcelRegister("8WxPE", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $068ba82a94015a1a$export$775b6bb06e53a214);
$parcel$export(module.exports, "ContentType", () => $068ba82a94015a1a$export$e2e108cbe2e4f865);
$parcel$export(module.exports, "AttributeType", () => $068ba82a94015a1a$export$d31c6c64cddbeeac);
var $068ba82a94015a1a$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $068ba82a94015a1a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $068ba82a94015a1a$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $068ba82a94015a1a$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $068ba82a94015a1a$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});

});

parcelRegister("8hr1g", function(module, exports) {

$parcel$export(module.exports, "UnreachableError", () => $abe2b3690446e017$export$676c8946b241bf4b);
class $abe2b3690446e017$export$676c8946b241bf4b extends Error {
    constructor(v){
        super(`Unreachable code was reachable, value: ${v}`);
    }
}

});

parcelRegister("fC7SC", function(module, exports) {

$parcel$export(module.exports, "transformJiraIssueScope", () => $074c4d4296761b1e$export$ed218c5a500295c6);
$parcel$export(module.exports, "transformJiraPlanScope", () => $074c4d4296761b1e$export$3327c57623badb76);
$parcel$export(module.exports, "transformJiraBoardProjectFilterScope", () => $074c4d4296761b1e$export$313c00d1fd0198a9);
$parcel$export(module.exports, "transformJiraProjectScope", () => $074c4d4296761b1e$export$61106bcfd557994b);
$parcel$export(module.exports, "transformUrsPeople", () => $074c4d4296761b1e$export$ca9c7208f3fa3596);

var $8WxPE = parcelRequire("8WxPE");

var $lP9EZ = parcelRequire("lP9EZ");

var $jV49M = parcelRequire("jV49M");

var $kfImN = parcelRequire("kfImN");
function $074c4d4296761b1e$export$ed218c5a500295c6(response, isCached, timings) {
    const { results: results, size: size } = response;
    return {
        items: results.filter((item)=>item.attributes['@type'] === (0, $8WxPE.AttributeType).issue).map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $8WxPE.ContentType).JiraIssue,
                attributes: {
                    ...item.attributes,
                    isRecentResult: isCached
                },
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: size || results.length
    };
}
function $074c4d4296761b1e$export$3327c57623badb76(results, isCached, timings) {
    return {
        items: results.map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $8WxPE.ContentType).JiraPlan,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $074c4d4296761b1e$export$313c00d1fd0198a9(results, isCached, timings) {
    return {
        items: results.filter((item)=>[
                (0, $8WxPE.AttributeType).board,
                (0, $8WxPE.AttributeType).project,
                (0, $8WxPE.AttributeType).filter,
                (0, $8WxPE.AttributeType).plan
            ].includes(item.attributes['@type'])).map((item)=>{
            const contentType = (0, $lP9EZ.attributeTypeToContentType)(item.attributes['@type']);
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: contentType,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $074c4d4296761b1e$export$61106bcfd557994b(results, isCached, timings) {
    return {
        items: results.map((item)=>{
            return {
                resultId: item.id,
                name: item.name,
                href: item.url,
                contentType: (0, $8WxPE.ContentType).JiraProject,
                attributes: item.attributes,
                isCached: isCached
            };
        }),
        timings: timings,
        totalSize: results.length
    };
}
function $074c4d4296761b1e$export$ca9c7208f3fa3596(results, isCached, timings, isMultiSite) {
    return {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(results, (item)=>item.id).map((item)=>({
                resultId: item.id,
                name: item.name,
                href: (0, $kfImN.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id, 'jira'),
                contentType: (0, $8WxPE.ContentType).JiraPeople,
                attributes: {
                    '@type': (0, $8WxPE.AttributeType).people,
                    avatarUrl: item.avatarUrl,
                    userId: item.id
                },
                isCached: isCached
            })),
        timings: timings,
        totalSize: results.length
    };
}

});




parcelRegister("cuRlJ", function(module, exports) {

$parcel$export(module.exports, "getResultLinkComponent", () => $42ea84ce17f63a94$export$7298e35d46e5a43);

var $gwFzn = parcelRequire("gwFzn");

var $cPER9 = parcelRequire("cPER9");

var $8lYIw = parcelRequire("8lYIw");
const $42ea84ce17f63a94$var$isNewTabClick = (e)=>e && (e.metaKey || e.shiftKey || e.ctrlKey);
const $42ea84ce17f63a94$export$7298e35d46e5a43 = (closeDrawer)=>{
    class ResultLinkComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
        render() {
            const { children: children, href: href, target: target, className: className } = this.props;
            const LinkComponent = this.getLinkComponent(href);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(LinkComponent, {
                href: href,
                onClick: this.handleClick,
                target: target,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className
            }, children);
        }
        constructor(...args){
            super(...args);
            this.handleClick = (event)=>{
                if (closeDrawer && !$42ea84ce17f63a94$var$isNewTabClick(event)) closeDrawer();
            };
            this.getLinkComponent = (href)=>href && href.startsWith('/people/') ? (0, $cPER9.PeopleLink) : (0, $8lYIw.Link);
        }
    }
    return ResultLinkComponent;
};

});

parcelRegister("f4L2T", function(module, exports) {

$parcel$export(module.exports, "CurrentSpaceContext", () => $844c79f4d45e1a83$export$109846573338f1b2);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $dqunX = parcelRequire("dqunX");
const $844c79f4d45e1a83$export$109846573338f1b2 = ({ children: children, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
        query: (0, $dqunX.CurrentSpaceQuery),
        variables: {
            spaceKey: spaceKey
        }
    }, ({ data: data, loading: loading })=>{
        const id = data?.space?.id;
        const spaceName = data?.space?.name;
        const iconUrl = data?.space?.icon?.path;
        const currentSpace = id && spaceName && iconUrl ? {
            id: id,
            spaceName: spaceName,
            spaceKey: spaceKey,
            iconUrl: iconUrl
        } : undefined;
        return children({
            loading: loading,
            currentSpace: currentSpace
        });
    });

});
parcelRegister("dqunX", function(module, exports) {

$parcel$export(module.exports, "CurrentSpaceQuery", () => $f677b35d623dd038$export$6cba1f4a018a0482);

var $d2LG0 = parcelRequire("d2LG0");
const $f677b35d623dd038$export$6cba1f4a018a0482 = (0, $d2LG0.default)`query CurrentSpaceQuery($spaceKey:String){space(key:$spaceKey){id name icon{path(type:ABSOLUTE)}}}`;

});


parcelRegister("escKD", function(module, exports) {

$parcel$export(module.exports, "QuickFindNav3", () => $9d71cfad51bcb6ee$export$d916d15625b46dc9);

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $4jplB = parcelRequire("4jplB");
const $9d71cfad51bcb6ee$export$d916d15625b46dc9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "quick-find-container",
        xcss: $9d71cfad51bcb6ee$var$searchBarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $9d71cfad51bcb6ee$var$searchBarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jplB.QuickFind), null)));
const $9d71cfad51bcb6ee$var$searchBarWrapper = (0, $ecnYn.xcss)({
    position: 'relative',
    width: '200px',
    height: "var(--ds-space-500, 40px)"
});
const $9d71cfad51bcb6ee$var$searchBarContainer = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    bottom: 'space.0',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    zIndex: 'dialog'
});

});
parcelRegister("4jplB", function(module, exports) {

$parcel$export(module.exports, "generateSearchUrl", () => $5235a3f27f080bad$export$8233bb098a93ad26);
$parcel$export(module.exports, "QuickFind", () => $5235a3f27f080bad$export$7d842d92e2721710);

var $gwFzn = parcelRequire("gwFzn");

var $hKLPv = parcelRequire("hKLPv");

var $dEBDF = parcelRequire("dEBDF");

var $bQm3c = parcelRequire("bQm3c");

var $gz8ZY = parcelRequire("gz8ZY");

var $dPJCf = parcelRequire("dPJCf");

var $9wGTI = parcelRequire("9wGTI");

var $ljm2R = parcelRequire("ljm2R");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

var $e4o8D = parcelRequire("e4o8D");

var $4VJDS = parcelRequire("4VJDS");
const $5235a3f27f080bad$var$generateUserUrl = (userId)=>`/wiki/people/${userId}`;
const $5235a3f27f080bad$var$generateTeamUrl = (teamId)=>`/wiki/people/team/${teamId}`;
const $5235a3f27f080bad$var$useTextParameter = (0, $dPJCf.createSingleQueryParamHook)('text');
const $5235a3f27f080bad$export$8233bb098a93ad26 = (urlQueryParams)=>{
    const url = new URL('/wiki/search', window.location.origin);
    const searchParams = new URLSearchParams(window.location.search);
    if (window.location.pathname !== '/wiki/search' && (0, $9wGTI.fg)('rovo_search_qf_to_product_filtered_fps')) searchParams.set('product', 'confluence');
    Object.entries(urlQueryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
    });
    url.search = searchParams.toString();
    return url.href;
};
const $5235a3f27f080bad$export$7d842d92e2721710 = ()=>{
    const [open, setOpen] = (0, $gwFzn.useState)(false);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { cloudId: cloudId, orgId: orgId, activationId: activationId, isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId, displayName: displayName, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const textParameter = $5235a3f27f080bad$var$useTextParameter();
    const queryParams = (0, $gwFzn.useMemo)(()=>({
            text: textParameter
        }), [
        textParameter
    ]);
    const analyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            activationId: activationId,
            navdexPointType: (0, $dEBDF.TOUCH)
        }), [
        activationId
    ]);
    const user = (0, $gwFzn.useMemo)(()=>({
            id: userId,
            name: displayName
        }), [
        userId,
        displayName
    ]);
    const experimentLayers = (0, $4VJDS.default).getStringList('search_platform_layer_functions', []);
    const onNavigate = (0, $gwFzn.useCallback)((url)=>push(url), [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hKLPv.QuickFind), {
        cloudId: cloudId,
        orgId: orgId,
        primaryProduct: "confluence",
        analyticsAttributes: analyticsAttributes,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isNav4Enabled: isNav4Enabled,
        onNavigate: onNavigate,
        queryParams: queryParams,
        open: open,
        setOpen: setOpen,
        user: user,
        generateSearchUrl: $5235a3f27f080bad$export$8233bb098a93ad26,
        generateUserUrl: $5235a3f27f080bad$var$generateUserUrl,
        generateTeamUrl: $5235a3f27f080bad$var$generateTeamUrl,
        experimentLayers: experimentLayers,
        isRovoLLMEnabled: isRovoLLMEnabled,
        isSSR: renderServerPlaceholder
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? [
            (0, $ljm2R.NAVIGATION_SLASH_SHORTCUT),
            (0, $ljm2R.NAVIGATION_SHORTCUT)
        ] : undefined,
        accelerator: (0, $ljm2R.isMac)() ? (0, $ljm2R.UNIVERSAL_NAVIGATION_SHORTCUT_MAC) : (0, $ljm2R.UNIVERSAL_NAVIGATION_SHORTCUT_WIN),
        listener: ()=>setOpen(true),
        isAppNavigationShortcut: true
    }));
};

});
parcelRegister("hKLPv", function(module, exports) {

$parcel$export(module.exports, "QuickFind", () => $c8b08557d75a416b$export$7d842d92e2721710);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dpPtd = parcelRequire("dpPtd");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $hnvzE = parcelRequire("hnvzE");

var $icqFF = parcelRequire("icqFF");

var $4OGlb = parcelRequire("4OGlb");

var $7WbA8 = parcelRequire("7WbA8");

var $2ok43 = parcelRequire("2ok43");

var $86ob4 = parcelRequire("86ob4");

var $1XDdH = parcelRequire("1XDdH");

var $l1k3Q = parcelRequire("l1k3Q");

var $2tzUc = parcelRequire("2tzUc");

var $4VmlX = parcelRequire("4VmlX");

var $is3gE = parcelRequire("is3gE");

var $bHLTK = parcelRequire("bHLTK");

var $h9lDJ = parcelRequire("h9lDJ");

var $42YhP = parcelRequire("42YhP");

var $f8Fnp = parcelRequire("f8Fnp");

var $jQSTy = parcelRequire("jQSTy");
var $j5QtW = parcelRequire("j5QtW");
var $57tKZ = parcelRequire("57tKZ");
const $c8b08557d75a416b$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    width: '100%',
    position: 'relative'
});
const $c8b08557d75a416b$var$QuickFindComponent = ({ open: open, setOpen: setOpen, postQueryDisabled: postQueryDisabled, textfieldComponent: textfieldComponent, isSSR: isSSR })=>{
    const inputBoxRef = (0, $gwFzn.useRef)(null);
    const dialogRef = (0, $gwFzn.useRef)(null);
    const inputRef = (0, $gwFzn.useRef)(null);
    const [localQuery, setLocalQuery] = (0, $gwFzn.useState)((0, $2ok43.getInitialQuery));
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const dialogId = (0, $gwFzn.useId)();
    (0, $57tKZ.useSyncStates)(quickFindOpen, setQuickFindOpen, open, setOpen);
    (0, $jQSTy.useCloseManager)({
        dialogRef: dialogRef,
        inputBoxRef: inputBoxRef
    });
    (0, $j5QtW.usePreQueryDwellTimeAnalytics)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $l1k3Q.QuickFindResults), {}),
            (0, $dh538.fg)('rovo_search_quick_find_prefetch') && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $42YhP.LazyPreload), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $c8b08557d75a416b$var$textFieldBoxStyles,
                ref: inputBoxRef,
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $icqFF.KeyboardHighlightProvider), {
                    listenerNode: inputRef?.current,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f8Fnp.SearchTextField), {
                            dialogId: dialogId,
                            inputRef: inputRef,
                            localQuery: localQuery,
                            setLocalQuery: setLocalQuery,
                            textfieldComponent: textfieldComponent,
                            postQueryDisabled: postQueryDisabled
                        }),
                        !isSSR && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dpPtd.FlagsProvider), {
                            children: quickFindOpen && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $86ob4.WidthObserverProvider), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h9lDJ.SearchDialog), {
                                    dialogId: dialogId,
                                    dialogRef: dialogRef,
                                    inputRef: inputRef,
                                    localQuery: localQuery,
                                    setLocalQuery: setLocalQuery
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $c8b08557d75a416b$export$68bbc91d7879f9e4 = ({ children: children, queryParams: actualQueryParams, ...props })=>{
    /**
	 * Quick Find does not need to set queryParams, hence using an object
	 * in a state variable as the queryParams object. Any interactions with
	 * the url should be done through onNavigate in the AppContext.
	 */ const [queryParams, setQueryParams] = (0, $gwFzn.useState)({
        text: actualQueryParams?.text
    });
    /**
	 * Quick Find only reacts to changes in the text query parameter when the
	 * user is on the search page.
	 */ const previousTextQueryParam = (0, $gwFzn.useRef)(actualQueryParams?.text);
    (0, $gwFzn.useEffect)(()=>{
        if (actualQueryParams?.text === previousTextQueryParam.current) return;
        let onSearchRoute = true; // Default to true in case URL parsing fails
        try {
            const generateSearchUrl = props.generateSearchUrl || (0, $1XDdH.defaultGenerateSearchUrl);
            const searchUrl = new URL(generateSearchUrl({}));
            const searchPath = searchUrl.pathname;
            const currentUrl = new URL(window.location.href);
            const currentPath = currentUrl.pathname;
            onSearchRoute = searchPath === currentPath;
        } catch (e) {
        // ignore error
        }
        if (onSearchRoute) setQueryParams((previousQueryParams)=>({
                ...previousQueryParams,
                text: actualQueryParams?.text
            }));
        previousTextQueryParam.current = actualQueryParams?.text;
    }, [
        actualQueryParams?.text,
        props.generateSearchUrl
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2tzUc.BootstrapStoreProvider), {
        ...props,
        queryParams: queryParams,
        callbacks: {
            updateQueryParameters: setQueryParams
        },
        statsigLayer: (0, $4OGlb.STATSIG_QUICK_FIND_LAYER),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bHLTK.SearchStoreProvider), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $is3gE.QuickFindStoreProvider), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7WbA8.AppContextProvider), {
                    ...props,
                    queryParams: queryParams,
                    children: children
                })
            })
        })
    });
};
const $c8b08557d75a416b$export$7d842d92e2721710 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hnvzE.default), {
        name: "quick-find",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($c8b08557d75a416b$export$68bbc91d7879f9e4, {
            ...props,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($c8b08557d75a416b$var$QuickFindComponent, {
                ...props
            })
        })
    });
};

});
parcelRegister("2ok43", function(module, exports) {

$parcel$export(module.exports, "getInitialQuery", () => $e39928e964cca707$export$ed7270bd966434af);
$parcel$export(module.exports, "useInputSkeleton", () => $e39928e964cca707$export$67de3a75cbe82e14);

var $gwFzn = parcelRequire("gwFzn");

var $fG2rA = parcelRequire("fG2rA");
var $epS7s = parcelRequire("epS7s");
const $e39928e964cca707$export$ed7270bd966434af = ()=>(0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_QUERY_KEY)) || (0, $fG2rA.getInputSkeletonQuery)() || '';
const $e39928e964cca707$export$67de3a75cbe82e14 = ({ localQuery: localQuery, inputRef: inputRef })=>{
    // Focus input if skeleton is focused
    (0, $gwFzn.useEffect)(()=>{
        const skeletonFocused = (0, $fG2rA.getInputSkeletonFocus)();
        if (skeletonFocused) {
            const input = inputRef?.current;
            if (input) {
                input.focus();
                const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $fG2rA.getInputSkeletonSelection)();
                input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $fG2rA.removeInputSkeletonState)();
    }, [
        inputRef
    ]);
    // Push local query to session storage
    (0, $gwFzn.useEffect)(()=>{
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_QUERY_KEY), localQuery);
    }, [
        localQuery
    ]);
};

});

parcelRegister("l1k3Q", function(module, exports) {

$parcel$export(module.exports, "QuickFindResults", () => $0c35e478cf8dbc82$export$da9d0159e5272189);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $czt8s = parcelRequire("czt8s");
var $8LSUr = parcelRequire("8LSUr");

var $1yEFx = parcelRequire("1yEFx");

var $jjjIy = parcelRequire("jjjIy");

var $8WnGI = parcelRequire("8WnGI");

var $9wmQG = parcelRequire("9wmQG");

var $ebR6f = parcelRequire("ebR6f");

var $aE5mL = parcelRequire("aE5mL");

var $JQd0k = parcelRequire("JQd0k");

var $1nJM3 = parcelRequire("1nJM3");

var $4VkIo = parcelRequire("4VkIo");

var $8N0Nm = parcelRequire("8N0Nm");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $inrbX = parcelRequire("inrbX");

var $c74az = parcelRequire("c74az");

var $fqqqA = parcelRequire("fqqqA");

var $3zpmm = parcelRequire("3zpmm");

var $eK6Pl = parcelRequire("eK6Pl");

var $cA4A0 = parcelRequire("cA4A0");

var $6CCNp = parcelRequire("6CCNp");
const $0c35e478cf8dbc82$var$DEBOUNCE_TIMEOUT = 250;
const $0c35e478cf8dbc82$var$EMPTY_RESULTS = {
    result: [],
    duration: 0
};
const $0c35e478cf8dbc82$export$ab15aae48c593ecc = ({ postQueryDisabled: postQueryDisabled, onPreQueryStart: onPreQueryStart, onPreQuerySuccess: onPreQuerySuccess, onPreQueryFailure: onPreQueryFailure, onPostQueryStart: onPostQueryStart, onPostQuerySuccess: onPostQuerySuccess, onPostQueryFailure: onPostQueryFailure, onPostQueryCancel: onPostQueryCancel })=>{
    const [bootstrap] = (0, $j4ply.useBootstrap)();
    const isSearchReady = (0, $djVCD.useIsSearchReady)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { selectedFilters: selectedFilters, entities: entities } = (0, $4VkIo.useSelectedFilters)({
        thirdPartyConfigs: bootstrap.thirdPartyConfigs,
        cloudId: bootstrap.cloudId
    });
    const logException = (0, $1nJM3.useLogException)();
    const [retryCount] = (0, $djVCD.useRetryCount)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const { setJiraIssueFieldsLoading: setJiraIssueFieldsLoading, setRequestedBackendExperiments: setRequestedBackendExperiments } = (0, $djVCD.useSearchActions)();
    const prevQueryRef = (0, $gwFzn.useRef)();
    const prevQuickFindOpenRef = (0, $gwFzn.useRef)(quickFindOpen);
    const warmupRequestWasFired = (0, $gwFzn.useRef)(false);
    const prevSelectedQueryFiltersRef = (0, $gwFzn.useRef)(selectedQueryFilters);
    const prevSelectedFilters = (0, $gwFzn.useRef)();
    const fetchRecentActivitiesPromiseRef = (0, $gwFzn.useRef)();
    const preQueryPromiseRef = (0, $gwFzn.useRef)();
    const postQueryPromiseRef = (0, $gwFzn.useRef)();
    const { setUpdateRecentQueries: setUpdateRecentQueries, setFetchEntitiesRequestId: setFetchEntitiesRequestId, setFetchSpacesRequestId: setFetchSpacesRequestId } = (0, $4VmlX.useQuickFindActions)();
    const [preQueryLoading, setPreQueryLoading] = (0, $gwFzn.useState)(true);
    const [preQueryError, setPreQueryError] = (0, $gwFzn.useState)();
    const [postQueryLoading, setPostQueryLoading] = (0, $gwFzn.useState)(false);
    const [postQueryError, setPostQueryError] = (0, $gwFzn.useState)();
    const [recentQueries, setRecentQueries] = (0, $gwFzn.useState)([]);
    const [filteredRecentQueries, setFilteredRecentQueries] = (0, $gwFzn.useState)([]);
    const [filteredRecentActivities, setFilteredRecentActivities] = (0, $gwFzn.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [searchResults, setSearchResults] = (0, $gwFzn.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    const [peopleAndTeams, setPeopleAndTeams] = (0, $gwFzn.useState)($0c35e478cf8dbc82$var$EMPTY_RESULTS);
    /**
	 * Callback to update recent queries for the current product and user
	 */ const fetchRecentQueries = (0, $gwFzn.useCallback)(()=>{
        if (!bootstrap.primaryProduct || !bootstrap.user?.id) return;
        const recentQueries = (0, $cA4A0.getRecentQueries)(bootstrap.primaryProduct, bootstrap.user.id);
        setRecentQueries(recentQueries);
    }, [
        bootstrap.primaryProduct,
        bootstrap.user?.id,
        setRecentQueries
    ]);
    /**
	 * Store the callback to update recent queries in the store. This is used to refresh recent queries
	 * when they are updated, e.g. when a search request is made or when a recent query is removed.
	 */ (0, $gwFzn.useEffect)(()=>{
        fetchRecentQueries();
        setUpdateRecentQueries(fetchRecentQueries);
    }, [
        fetchRecentQueries,
        setUpdateRecentQueries
    ]);
    /**
	 * Callback to fetch recent activities
	 */ const fetchRecentActivitiesCallback = (0, $gwFzn.useCallback)(async ()=>{
        if (bootstrap.cloudId) return (0, $c74az.fetchRecentActivities)(bootstrap.cloudId, bootstrap.aggAbsoluteUrl);
        else return [];
    }, [
        bootstrap.cloudId,
        bootstrap.aggAbsoluteUrl
    ]);
    /**
	 * Callback to fetch pre-query results and updates the store with the results
	 */ const fetchQuickFindPreQuery = (0, $gwFzn.useCallback)((query, product)=>{
        if (!fetchRecentActivitiesPromiseRef.current) {
            setPreQueryLoading(true);
            onPreQueryStart?.();
            const fetchRecentActivitiesPromise = (0, $8WnGI.measureAsyncFunction)(fetchRecentActivitiesCallback).then((result)=>{
                setPreQueryLoading(false);
                onPreQuerySuccess?.();
                return result;
            }).catch((error)=>{
                logException(error);
                setPreQueryError(error);
                onPreQueryFailure?.();
                return $0c35e478cf8dbc82$var$EMPTY_RESULTS;
            });
            fetchRecentActivitiesPromiseRef.current = fetchRecentActivitiesPromise;
        }
        const hideFilteredPreQueryResults = selectedQueryFilters.length > 0 || query.length && product !== undefined || query.length && (0, $dh538.fg)('quick_find_user_shard_query');
        if (hideFilteredPreQueryResults) {
            setFilteredRecentQueries([]);
            setFilteredRecentActivities($0c35e478cf8dbc82$var$EMPTY_RESULTS);
            return;
        }
        const preQueryPromise = new (0, $czt8s.CancellablePromise)(fetchRecentActivitiesPromiseRef.current);
        preQueryPromise.promise().then((recentActivities)=>{
            const filteredRecentActivities = (0, $jjjIy.filterSearchResults)(recentActivities.result, query);
            const filteredRecentQueries = (0, $jjjIy.filterSearchResults)(recentQueries, query);
            setFilteredRecentQueries(filteredRecentQueries);
            setFilteredRecentActivities({
                result: filteredRecentActivities,
                duration: recentActivities.duration
            });
        }).catch((error)=>{
        // no-op on cancel
        });
    }, [
        fetchRecentActivitiesCallback,
        logException,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess,
        recentQueries,
        selectedQueryFilters.length
    ]);
    /**
	 * Callback to fetch confluence entities
	 */ const fetchConfluenceEntitiesCallback = (0, $gwFzn.useCallback)(async ()=>{
        let thirdPartyFilters;
        if ((0, $dh538.fg)('enable_quickfind_3p_search_results_confluence')) thirdPartyFilters = (0, $eK6Pl.getThirdPartyFiltersForQuickFind)(bootstrap.thirdPartyConfigs);
        return Promise.all([
            (0, $eK6Pl.fetchConfluenceAnd3PEntities)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, thirdPartyFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments, entities),
            (0, $eK6Pl.fetchConfluenceSpaces)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions)
        ]).then((results)=>{
            const [entities, spaces] = results;
            return {
                results: [
                    ...entities.fetchResults,
                    ...spaces.fetchResults
                ],
                fetchEntitiesRequestId: entities.fetchEntitiesRequestId ?? undefined,
                fetchSpacesRequestId: spaces.fetchSpacesRequestId ?? undefined
            };
        });
    }, [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        bootstrap.thirdPartyConfigs,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments,
        entities
    ]);
    /**
	 * Callback to fetch atlas entities
	 */ const fetchAtlasEntitiesCallback = (0, $gwFzn.useCallback)(async ()=>(0, $eK6Pl.fetchAtlasEntities)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId } = results;
            return {
                results: fetchResults,
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchSpacesRequestId: undefined
            };
        }), [
        bootstrap.aggAbsoluteUrl,
        bootstrap.cloudId,
        bootstrap.primaryProduct,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        selectedFilters,
        quickFindQuery,
        searchSessionId,
        setRequestedBackendExperiments
    ]);
    /**
	 * Callback to fetch confluence entities
	 */ const fetchMercuryEntitiesCallback = (0, $gwFzn.useCallback)(async ()=>(0, $eK6Pl.fetchMercuryEntities)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId } = results;
            return {
                results: [
                    ...fetchResults
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchSpacesRequestId: undefined
            };
        }), [
        bootstrap.aggAbsoluteUrl,
        bootstrap.cloudId,
        bootstrap.primaryProduct,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        selectedFilters,
        quickFindQuery,
        searchSessionId,
        setRequestedBackendExperiments
    ]);
    /**
	 *  Callback to fetch jira entities
	 */ const fetchJiraEntitiesCallback = (0, $gwFzn.useCallback)(async ()=>(0, $eK6Pl.fetchJiraEntities)(bootstrap.aggAbsoluteUrl, quickFindQuery, bootstrap.primaryProduct, bootstrap.cloudId || '', searchSessionId, selectedFilters, bootstrap.experimentConfig, bootstrap.productEdition, bootstrap.productDataRegions, setRequestedBackendExperiments).then((results)=>{
            const { fetchResults: fetchResults, fetchEntitiesRequestId: fetchEntitiesRequestId } = results;
            return {
                results: [
                    ...fetchResults
                ],
                fetchEntitiesRequestId: fetchEntitiesRequestId ?? undefined,
                fetchSpacesRequestId: undefined
            };
        }), [
        bootstrap.aggAbsoluteUrl,
        bootstrap.primaryProduct,
        bootstrap.cloudId,
        bootstrap.experimentConfig,
        bootstrap.productEdition,
        bootstrap.productDataRegions,
        quickFindQuery,
        searchSessionId,
        selectedFilters,
        setRequestedBackendExperiments
    ]);
    /**
	 * Callback to fetch people and teams results
	 */ const fetchPeopleAndTeamsCallback = (0, $gwFzn.useCallback)(async ()=>{
        const { orgId: orgId, primaryProduct: primaryProduct, user: user, cloudId: cloudId } = bootstrap;
        if (orgId && primaryProduct && user?.id && cloudId) {
            // When no query filters are selected, get people and teams results
            // using the query
            if (selectedQueryFilters.length === 0) return (0, $3zpmm.fetchPeopleAndTeamsResults)(quickFindQuery, orgId, primaryProduct, user.id, cloudId);
            // When a single query filter is selected and it is a contributor filter,
            // get people and teams results using the contributor name
            if (selectedQueryFilters.length === 1 && selectedQueryFilters[0].filterId === 'contributor') return (0, $3zpmm.fetchPeopleAndTeamsResults)(selectedQueryFilters[0].displayText, orgId, primaryProduct, user.id, cloudId);
        }
        return [];
    }, [
        bootstrap,
        quickFindQuery,
        selectedQueryFilters
    ]);
    /**
	 * Function which fetches the post query results. This consists of a call to get
	 * product search results and a call to get people and teams. Given that Promise.allSettled
	 * is used, the slowest request will determine the time it takes to resolve.
	 */ const fetchQuickFindPostQuery = (0, $gwFzn.useCallback)(()=>{
        const { cloudId: cloudId = '', aggAbsoluteUrl: aggAbsoluteUrl } = bootstrap;
        // TODO: this is too nested - refactor this into switch or if-else statements
        const fetchProductEntities = bootstrap.primaryProduct === 'confluence' ? fetchConfluenceEntitiesCallback : bootstrap.primaryProduct === 'townsquare' ? fetchAtlasEntitiesCallback : bootstrap.primaryProduct === 'mercury' ? fetchMercuryEntitiesCallback : bootstrap.primaryProduct === 'jira' ? fetchJiraEntitiesCallback : ()=>Promise.resolve({
                results: [],
                fetchEntitiesRequestId: undefined,
                fetchSpacesRequestId: undefined
            });
        const fetchPeopleAndTeams = bootstrap.primaryProduct !== 'mercury' && !selectedProduct ? fetchPeopleAndTeamsCallback : ()=>Promise.resolve([]);
        const postQueryPromise = new (0, $czt8s.CancellablePromise)(Promise.allSettled([
            (0, $8WnGI.measureAsyncFunction)(fetchProductEntities),
            (0, $8WnGI.measureAsyncFunction)(fetchPeopleAndTeams)
        ]));
        postQueryPromiseRef.current = postQueryPromise;
        onPostQueryStart?.();
        postQueryPromise.promise().then((results)=>{
            const productEntitiesStatus = results[0].status;
            const peopleAndTeamsStatus = results[1].status;
            // Post-query success is determined by product entities request, errors
            // from people and teams are ignored
            if (productEntitiesStatus === 'fulfilled') {
                const fetchedResults = results[0].value.result.results;
                setSearchResults({
                    result: fetchedResults,
                    duration: results[0].value.duration
                });
                const hasThirdPartyResults = fetchedResults.some((result)=>result.id.startsWith('ari:cloud:graph::document') || result.id.startsWith('ari:cloud:graph::remote-link'));
                setFetchEntitiesRequestId(results[0].value.result.fetchEntitiesRequestId);
                setFetchSpacesRequestId(results[0].value.result.fetchSpacesRequestId);
                const peopleAndTeams = peopleAndTeamsStatus === 'fulfilled' ? {
                    result: results[1].value.result,
                    duration: results[1].value.duration
                } : $0c35e478cf8dbc82$var$EMPTY_RESULTS;
                setPeopleAndTeams(peopleAndTeams);
                const allDurations = results.map((result)=>result.status === 'fulfilled' ? result.value.duration : 0);
                const maxDuration = Math.max(...allDurations);
                onPostQuerySuccess?.(maxDuration, hasThirdPartyResults);
            } else {
                setPostQueryError(new Error('Failed to fetch post query results'));
                onPostQueryFailure?.();
            }
            setPostQueryLoading(false);
            return results;
        }).then((results)=>{
            const issueStatus = results[0].status;
            if (issueStatus === 'fulfilled' && (0, $dh538.fg)('enable_status_jira_issues_quick_find')) {
                let fetchedResults = results[0].value.result.results;
                // Fetch extra fields for issues
                const issuesToFetch = [];
                if (fetchedResults && fetchedResults.length > 0) fetchedResults.forEach((result)=>{
                    if ((0, $8LSUr.isSearchResultJiraIssue)(result.data)) {
                        const issueKey = result.data.issue?.webUrl?.split('/').at(-1) || result.data.url.split('/').at(-1);
                        if (!!issueKey) issuesToFetch.push(issueKey);
                    }
                });
                if (issuesToFetch.length > 0) {
                    setJiraIssueFieldsLoading(true);
                    (0, $8N0Nm.fetchJiraFields)({
                        issueKeys: issuesToFetch,
                        cloudId: cloudId,
                        aggAbsoluteUrl: aggAbsoluteUrl
                    }).then((jiraHydrationResults)=>{
                        const issues = jiraHydrationResults.data?.jira.issuesByKey;
                        if (issues && fetchedResults) {
                            const issuesMap = new Map(issues.map((issue)=>[
                                    issue.id,
                                    issue
                                ]));
                            fetchedResults = fetchedResults.map((result)=>{
                                const issue = issuesMap.get(result.id);
                                if (issue) {
                                    const colorName = issue.statusField.status.statusCategory?.colorName;
                                    if (result.data && result.data.status) result.data.status.colorName = colorName;
                                }
                                return result;
                            });
                        }
                        const updatedResults = issueStatus === 'fulfilled' ? {
                            result: fetchedResults,
                            duration: results[0].value.duration
                        } : $0c35e478cf8dbc82$var$EMPTY_RESULTS;
                        setSearchResults(updatedResults);
                    }).finally(()=>{
                        setJiraIssueFieldsLoading(false);
                    });
                }
            }
        }).catch(()=>{
        // Promise.allSettled will never reject, hence rejections only occur
        // when the promise is cancelled. In this case, we don't need to do anything.
        });
    }, [
        bootstrap,
        fetchAtlasEntitiesCallback,
        fetchConfluenceEntitiesCallback,
        fetchJiraEntitiesCallback,
        fetchMercuryEntitiesCallback,
        fetchPeopleAndTeamsCallback,
        onPostQueryFailure,
        onPostQueryStart,
        onPostQuerySuccess,
        selectedProduct,
        setFetchEntitiesRequestId,
        setFetchSpacesRequestId,
        setJiraIssueFieldsLoading
    ]);
    /**
	 * Debounced fetch function for quick find results. This callback should never mutate
	 * as the only dependency is the timeout value, hence it can be safely used in dependency array.
	 */ const debouncedFetchQuickFindPostQuery = (0, $JQd0k.useDebouncedCallback)(fetchQuickFindPostQuery, $0c35e478cf8dbc82$var$DEBOUNCE_TIMEOUT);
    /**
	 * Warm-up request for user shard permissions cache
	 * when dialog is opened **for the first time**
	 */ (0, $gwFzn.useEffect)(()=>{
        if (quickFindOpen && !warmupRequestWasFired.current && (0, $dh538.fg)('quick_find_user_shard_query')) {
            debouncedFetchQuickFindPostQuery();
            warmupRequestWasFired.current = true;
        }
    }, [
        quickFindOpen,
        debouncedFetchQuickFindPostQuery
    ]);
    /**
	 * Updates results when various Quick Find states change, this includes:
	 * - when search is ready
	 * - when the dialog opens
	 * - when the query changes
	 * - when recent queries or activities change
	 * - when selected entities or filters change
	 */ (0, $gwFzn.useEffect)(()=>{
        if (!isSearchReady) return;
        if (preQueryPromiseRef.current) preQueryPromiseRef.current.cancel();
        fetchQuickFindPreQuery(quickFindQuery, selectedProduct);
        prevQuickFindOpenRef.current = quickFindOpen;
        if (!quickFindOpen || currentQueryFilter) return;
        if (quickFindQuery === prevQueryRef.current && selectedFilters === prevSelectedFilters.current) return;
        prevQueryRef.current = quickFindQuery;
        prevSelectedQueryFiltersRef.current = selectedQueryFilters;
        prevSelectedFilters.current = selectedFilters;
        if (postQueryDisabled) return;
        const hasQuery = quickFindQuery || selectedQueryFilters.length > 0;
        if (!hasQuery) onPostQueryCancel?.();
        setSearchResults({
            result: [],
            duration: 0
        });
        setPeopleAndTeams({
            result: [],
            duration: 0
        });
        setPostQueryLoading(true);
        setPostQueryError(undefined);
        if (hasQuery) {
            // Cancel the inflight request if there is one
            if (postQueryPromiseRef.current) postQueryPromiseRef.current.cancel();
            setPostQueryLoading(true);
            debouncedFetchQuickFindPostQuery();
        }
    }, [
        fetchQuickFindPreQuery,
        debouncedFetchQuickFindPostQuery,
        quickFindQuery,
        retryCount,
        isSearchReady,
        quickFindOpen,
        selectedFilters,
        entities,
        onPostQueryCancel,
        postQueryDisabled,
        currentQueryFilter,
        selectedQueryFilters,
        selectedProduct
    ]);
    return (0, $gwFzn.useMemo)(()=>(0, $6CCNp.getQuickFindContent)({
            // Using refs here to ensure new results state is returned only
            // when the various result variables in the dependency array change
            query: prevQueryRef.current,
            selectedQueryFilters: prevSelectedQueryFiltersRef.current,
            quickFindOpen: prevQuickFindOpenRef.current,
            preQueryError: preQueryError,
            preQueryLoading: preQueryLoading,
            postQueryError: postQueryError,
            postQueryLoading: postQueryLoading,
            filteredRecentQueries: filteredRecentQueries,
            filteredRecentActivities: filteredRecentActivities,
            searchResults: searchResults,
            peopleAndTeams: peopleAndTeams,
            postQueryDisabled: postQueryDisabled
        }), [
        filteredRecentActivities,
        filteredRecentQueries,
        peopleAndTeams,
        postQueryDisabled,
        postQueryError,
        postQueryLoading,
        preQueryError,
        preQueryLoading,
        searchResults
    ]);
};
const $0c35e478cf8dbc82$var$useSearchResultsShownAnalytics = ()=>{
    const previousStateRef = (0, $gwFzn.useRef)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [requestedBackendExperiments] = (0, $djVCD.useRequestedBackendExperiments)();
    (0, $gwFzn.useEffect)(()=>{
        // Store a copy of previous state before updating the ref
        const previousState = previousStateRef.current;
        previousStateRef.current = content ? content.state : undefined;
        // Don't fire analytics event if the dialog is closed
        if (!quickFindOpen || !content) return;
        // Don't fire analytics event if the state hasn't changed
        if (content.state === previousState) return;
        // Ignore states that do not have search results
        if (content.state === (0, $aE5mL.State).PREQUERY_LOADING || content.state === (0, $aE5mL.State).PREQUERY_ERROR || content.state === (0, $aE5mL.State).POSTQUERY_ERROR) return;
        /**
		 * Do not fire analytics event when the dialog is opened and post-query
		 * results are already returned. This is to have parity with the old
		 * quick find component.
		 *
		 * Whilst this may not be correct, this is here to ensure changes in metrics
		 * such as QSR and CTR are intentional.
		 *
		 * TODO: Discuss with DS/DE if this correct behaviour
		 */ if (content.state === (0, $aE5mL.State).POSTQUERY_RESULTS && previousState === undefined) return;
        const resultsTypeMap = {
            PREQUERY_RESULTS: 'preQuerySearchResults',
            PREQUERY_NO_RESULTS: 'preQuerySearchResults',
            POSTQUERY_LOADING: 'cachedResults',
            POSTQUERY_RESULTS: 'postQuerySearchResults',
            POSTQUERY_NO_RESULTS: 'postQuerySearchResults'
        };
        const resultsType = resultsTypeMap[content.state];
        const { sectionCount: sectionCount, resultCount: resultCount } = (0, $9wmQG.getSectionsAndResultsCount)();
        const resultTypeCounts = (0, $9wmQG.getResultTypeCounts)();
        const productsInResults = (0, $9wmQG.getProductsInResults)();
        const noResultsFetched = content.state === (0, $aE5mL.State).PREQUERY_NO_RESULTS || content.state === (0, $aE5mL.State).POSTQUERY_NO_RESULTS || resultCount === 0;
        // Don't fire cachedResults event if there are no results
        if (noResultsFetched && resultsType === 'cachedResults') return;
        const are3pResultsShown = productsInResults.some((0, $1yEFx.is3pProductKey));
        fireAnalyticsEvent((0, $ebR6f.onSearchResultsShown)({
            attributes: {
                ...commonAttributes,
                sectionCount: sectionCount,
                resultCount: resultCount,
                resultTypeCounts: resultTypeCounts,
                productsInResults: productsInResults,
                are3pResultsShown: are3pResultsShown,
                noResultsFetched: noResultsFetched,
                ...(0, $inrbX.getCommonQueryAttributes)(content.query),
                ...requestedBackendExperiments
            },
            nonPrivacySafeAttributes: {
                query: content.query
            },
            resultsType: resultsType
        }));
    }, [
        commonAttributes,
        content,
        fireAnalyticsEvent,
        quickFindOpen,
        requestedBackendExperiments
    ]);
};
const $0c35e478cf8dbc82$export$da9d0159e5272189 = /*#__PURE__*/ (0, $gwFzn.memo)((options)=>{
    const callbacks = (0, $fqqqA.useQuickFindResultsCallbacks)();
    const useQuickFindResultsArgs = (0, $gwFzn.useMemo)(()=>({
            ...options,
            ...callbacks
        }), [
        options,
        callbacks
    ]);
    const content = $0c35e478cf8dbc82$export$ab15aae48c593ecc(useQuickFindResultsArgs);
    const { setContent: setContent } = (0, $4VmlX.useQuickFindActions)();
    (0, $gwFzn.useEffect)(()=>{
        setContent(content);
    }, [
        content,
        setContent
    ]);
    $0c35e478cf8dbc82$var$useSearchResultsShownAnalytics();
    return null;
});

});
parcelRegister("8WnGI", function(module, exports) {

$parcel$export(module.exports, "measureAsyncFunction", () => $cf5ef1e7c875b308$export$45bde04e7d1842b0);

var $kyKWe = parcelRequire("kyKWe");
async function $cf5ef1e7c875b308$export$45bde04e7d1842b0(asyncFunction) {
    const markName = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    performance.mark(`${markName}-start`);
    const result = await asyncFunction();
    performance.mark(`${markName}-end`);
    performance.measure(markName, `${markName}-start`, `${markName}-end`);
    const measure = performance.getEntriesByName(markName)[0];
    const duration = measure.duration;
    // Clear the marks and measure to avoid memory leaks
    performance.clearMarks(`${markName}-start`);
    performance.clearMarks(`${markName}-end`);
    performance.clearMeasures(markName);
    return {
        result: result,
        duration: duration
    };
}

});

parcelRegister("9wmQG", function(module, exports) {

$parcel$export(module.exports, "SearchDialogHeaderAnalyticsWrapper", () => $c5fb920fb7e7d9be$export$8814e97d826fd90d);
$parcel$export(module.exports, "SearchDialogResultAnalyticsWrapper", () => $c5fb920fb7e7d9be$export$e01f22447ddebe43);
$parcel$export(module.exports, "getProductsInResults", () => $c5fb920fb7e7d9be$export$e21758a6ca606f0a);
$parcel$export(module.exports, "getResultTypeCounts", () => $c5fb920fb7e7d9be$export$334c5c15d40bbec1);
$parcel$export(module.exports, "getSectionsAndResultsCount", () => $c5fb920fb7e7d9be$export$e9dac44129e02fa9);
$parcel$export(module.exports, "getNodePosition", () => $c5fb920fb7e7d9be$export$39e67138c277998b);
/**
 * This file provides the necessary wrappers and utility functions to provide
 * analytics data for Quick Find result positions. Quick Find analytics contains
 * data such as the number of results, the number of sections, and the
 * position / section of a selected result.
 *
 * It does this by using the DOM as the source of truth rather than having to
 * maintain section objects and indexes in the code. This allows rendering
 * display components to be simplified and could prove to be more robust, e.g.
 * if a search result doesn't render due to an error and subsequently hits
 * its error boundary, section and results count remain correct.
 *
 * There is however the requirement that all heading and results components
 * are siblings in the DOM tree.
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $c5fb920fb7e7d9be$export$e7b6022782937b95 = 'search-dialog-heading';
const $c5fb920fb7e7d9be$export$926357658a80ff2a = 'search-dialog-result';
const $c5fb920fb7e7d9be$var$resultTypes = [
    'peopleAndTeams',
    'recentQueries',
    'recentActivities',
    'queryFilters',
    'searchResults'
];
const $c5fb920fb7e7d9be$export$8814e97d826fd90d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ children: children, id: id, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: $c5fb920fb7e7d9be$export$e7b6022782937b95,
        "data-section-id": id,
        ref: ref,
        ...rest,
        children: children
    }));
});
const $c5fb920fb7e7d9be$export$e01f22447ddebe43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ children: children, resultType: resultType, product: product, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        // Ignoring this check as class is not being used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $c5fb920fb7e7d9be$export$926357658a80ff2a,
        "data-result-type": resultType,
        "data-product": product,
        ref: ref,
        ...rest,
        children: children
    });
});
const $c5fb920fb7e7d9be$export$e21758a6ca606f0a = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const productSet = new Set();
    for(let i = 0; i < resultNodes.length; i++){
        const product = resultNodes[i].getAttribute('data-product');
        product && productSet.add(product);
    }
    const productsInResults = Array.from(productSet);
    return productsInResults;
};
const $c5fb920fb7e7d9be$export$334c5c15d40bbec1 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    return $c5fb920fb7e7d9be$var$resultTypes.reduce((o, resultType)=>{
        o[resultType] = resultNodes.filter((node)=>node.getAttribute('data-result-type') === resultType).length || 0;
        return o;
    }, {});
};
const $c5fb920fb7e7d9be$var$getAllHeadingsAndResults = ()=>{
    const headingNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$e7b6022782937b95));
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    if (!headingNodes.length || !resultNodes.length) return {
        allNodes: [],
        headingNodes: [],
        resultNodes: []
    };
    const parentNode = headingNodes.length ? headingNodes[0].parentNode : resultNodes.length ? resultNodes[0].parentNode : undefined;
    if (!parentNode) throw new Error('Could not find a parent node for headings and results');
    for (const node of [
        ...headingNodes,
        ...resultNodes
    ]){
        if (node.parentNode !== parentNode) throw new Error('All headings and results do not share a parent');
    }
    const allNodes = Array.from(parentNode.children).filter((e)=>$c5fb920fb7e7d9be$var$isHeading(e) || $c5fb920fb7e7d9be$var$isResult(e));
    return {
        allNodes: allNodes,
        headingNodes: headingNodes,
        resultNodes: resultNodes
    };
};
const $c5fb920fb7e7d9be$var$isHeading = (e)=>{
    return e.classList.contains($c5fb920fb7e7d9be$export$e7b6022782937b95);
};
const $c5fb920fb7e7d9be$var$isResult = (e)=>{
    return e.classList.contains($c5fb920fb7e7d9be$export$926357658a80ff2a);
};
const $c5fb920fb7e7d9be$export$e9dac44129e02fa9 = ()=>{
    try {
        const { allNodes: allNodes, headingNodes: headingNodes, resultNodes: resultNodes } = $c5fb920fb7e7d9be$var$getAllHeadingsAndResults();
        // If the first node is a result, then we count it as a section
        const sectionCount = allNodes.length ? headingNodes.length + ($c5fb920fb7e7d9be$var$isResult(allNodes[0]) ? 1 : 0) : 0;
        return {
            sectionCount: sectionCount,
            resultCount: resultNodes.length
        };
    } catch (e) {
        return {};
    }
};
const $c5fb920fb7e7d9be$export$39e67138c277998b = (targetNode)=>{
    try {
        const { sectionCount: sectionCount, resultCount: resultCount } = $c5fb920fb7e7d9be$export$e9dac44129e02fa9();
        const { allNodes: allNodes } = $c5fb920fb7e7d9be$var$getAllHeadingsAndResults();
        // If the first node is a result, then we count it as a section
        let sectionIndex = allNodes.length ? $c5fb920fb7e7d9be$var$isResult(allNodes[0]) ? 0 : -1 : -1;
        let sectionId = '';
        // Initialise variables to -1 as when we encounter a node,
        // we increment to represent the current index of the node
        let resultIndex = -1;
        let indexWithinSection = -1;
        for (const node of allNodes){
            if ($c5fb920fb7e7d9be$var$isHeading(node)) {
                sectionIndex++;
                sectionId = node.dataset.sectionId || '';
                indexWithinSection = -1;
            }
            if ($c5fb920fb7e7d9be$var$isResult(node)) {
                resultIndex++;
                indexWithinSection++;
            }
            if (node === targetNode) break;
        }
        return {
            sectionId: sectionId,
            sectionCount: sectionCount,
            resultCount: resultCount,
            sectionIndex: sectionIndex,
            globalIndex: resultIndex,
            indexWithinSection: indexWithinSection
        };
    } catch (e) {
        return {};
    }
};

});

parcelRegister("ebR6f", function(module, exports) {

$parcel$export(module.exports, "onSearchResultsShown", () => $e1a1aba41a097938$export$2d1da932f40a427e);
const $e1a1aba41a097938$export$2d1da932f40a427e = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, resultsType: resultsType })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: 'searchResults',
        actionSubjectId: resultsType,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("aE5mL", function(module, exports) {

$parcel$export(module.exports, "State", () => $7c0d6974c60a6f80$export$7254cc27399e90bd);
$parcel$export(module.exports, "isPreQueryState", () => $7c0d6974c60a6f80$export$bbc0e9ab60a7c746);
$parcel$export(module.exports, "isPostQueryState", () => $7c0d6974c60a6f80$export$f33d0292f2f7a82a);
$parcel$export(module.exports, "isPostQueryLoadingOrResults", () => $7c0d6974c60a6f80$export$3d387094581134ab);
const $7c0d6974c60a6f80$export$7254cc27399e90bd = {
    PREQUERY_ERROR: 'PREQUERY_ERROR',
    PREQUERY_LOADING: 'PREQUERY_LOADING',
    PREQUERY_NO_RESULTS: 'PREQUERY_NO_RESULTS',
    PREQUERY_RESULTS: 'PREQUERY_RESULTS',
    POSTQUERY_ERROR: 'POSTQUERY_ERROR',
    POSTQUERY_LOADING: 'POSTQUERY_LOADING',
    POSTQUERY_NO_RESULTS: 'POSTQUERY_NO_RESULTS',
    POSTQUERY_RESULTS: 'POSTQUERY_RESULTS'
};
const $7c0d6974c60a6f80$export$bbc0e9ab60a7c746 = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.PREQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$f33d0292f2f7a82a = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_ERROR || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_NO_RESULTS || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};
const $7c0d6974c60a6f80$export$3d387094581134ab = (state)=>{
    return state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_LOADING || state === $7c0d6974c60a6f80$export$7254cc27399e90bd.POSTQUERY_RESULTS;
};

});

parcelRegister("JQd0k", function(module, exports) {

$parcel$export(module.exports, "useDebouncedCallback", () => $e31678cde9628b17$export$e70e6da722faba05);

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");
const $e31678cde9628b17$export$e70e6da722faba05 = (callback, debounceTime)=>{
    const ref = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    const debouncedCallback = (0, $gwFzn.useMemo)(()=>{
        const func = ()=>{
            ref.current?.();
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(func, debounceTime);
    }, [
        debounceTime
    ]);
    return debouncedCallback;
};

});

parcelRegister("inrbX", function(module, exports) {

$parcel$export(module.exports, "useQuickFindAnalytics", () => $3a401808d4c266ad$export$82052fbad762998f);
$parcel$export(module.exports, "useQuickFindAttributes", () => $3a401808d4c266ad$export$380f10e960af9b57);
$parcel$export(module.exports, "getCommonQueryAttributes", () => $3a401808d4c266ad$export$e44a494bf5ca923a);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $6yNqK = parcelRequire("6yNqK");

var $a0M2t = parcelRequire("a0M2t");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");
const $3a401808d4c266ad$export$82052fbad762998f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $gwFzn.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: 'searchDialog'
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
const $3a401808d4c266ad$export$380f10e960af9b57 = ()=>{
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const fetchEntitiesRequestId = (0, $4VmlX.useFetchEntitiesRequestId)();
    const fetchSpacesRequestId = (0, $4VmlX.useFetchSpacesRequestId)();
    const [queryUpdatedTime] = (0, $djVCD.useQueryUpdatedTime)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [queryVersion] = (0, $djVCD.useQueryVersion)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const filters = (0, $djVCD.useFilterAttributesForTracking)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    const { frontendExperiments: frontendExperiments = {} } = experimentConfig;
    const { filterSelections: filterSelections, filters: filterCategories } = filters;
    const commonAttributes = {
        productEdition: productEdition,
        frontendExperiments: {
            activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
            ...frontendExperiments
        },
        ...$3a401808d4c266ad$export$e44a494bf5ca923a(quickFindQuery),
        queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
        queryVersion: queryVersion,
        searchSessionId: searchSessionId,
        fetchEntitiesTraceId: fetchEntitiesRequestId,
        fetchSpacesTraceId: fetchSpacesRequestId,
        isQuickFind: true,
        mode: applicationMode,
        productSelected: productSelected || (0, $6yNqK.ALL_PRODUCTS_STRING),
        filters: filterCategories,
        filterSelections: filterSelections,
        ...analyticsAttributes
    };
    const nonPrivacySafeAttributes = {
        query: quickFindQuery
    };
    return {
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};
const $3a401808d4c266ad$export$e44a494bf5ca923a = (query)=>{
    return {
        numberOfTerms: (query.match(/\w+/g) || []).length,
        queryHash: (0, $a0M2t.sha256Hash)(query),
        queryHashSHA256: (0, $a0M2t.sha256Hash)(query),
        queryLength: query.length,
        wordCount: (query.match(/\w+/g) || []).length
    };
};

});

parcelRegister("c74az", function(module, exports) {

$parcel$export(module.exports, "fetchRecentActivities", () => $198609fd26633f18$export$ae65634d024c5427);

var $dh538 = parcelRequire("dh538");

var $hWR4v = parcelRequire("hWR4v");
var $ja8yA = parcelRequire("ja8yA");
const $198609fd26633f18$export$48de245659972a87 = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
const $198609fd26633f18$export$742b5ce6018da1f4 = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $198609fd26633f18$export$ae65634d024c5427 = async (cloudId, aggAbsoluteUrl)=>{
    return await (0, $ja8yA.recentActivitiesQuery)({
        variables: {
            filteredProducts: $198609fd26633f18$export$48de245659972a87,
            filteredObjectTypes: (0, $dh538.fg)('smartlinks-qf-recents') ? $198609fd26633f18$export$742b5ce6018da1f4 : $198609fd26633f18$export$742b5ce6018da1f4.filter((type)=>type !== 'remote-link'),
            filteredRootContainerIds: [
                `ari:cloud:platform::site/${cloudId}`,
                `ari:cloud:townsquare::site/${cloudId}`
            ],
            itemsLimit: 200
        },
        aggAbsoluteUrl: aggAbsoluteUrl
    }).then((response)=>{
        const edges = response.data?.activity?.myActivity?.all?.edges || [];
        return edges.map($198609fd26633f18$export$cf1f13813d90479a);
    });
};
const $198609fd26633f18$export$cf1f13813d90479a = (result)=>{
    const product = result.node.object.product;
    let title = '';
    if ((0, $hWR4v.is1PActivity)(result.node.object)) {
        if (product === 'confluence') title = result.node.object.data?.title || '';
        else if (product === 'jira') {
            const key = result.node.object.data?.key;
            const summary = result.node.object.data?.fieldsById?.edges?.[0]?.node?.text;
            title = key && summary ? `${key}: ${summary}` : '';
        } else if (product === 'townsquare') title = result.node.object.data?.name || '';
    } else if ((0, $hWR4v.isGraphActivity)(result.node.object) && ((0, $hWR4v.isDocumentActivity)(result.node.object) || (0, $hWR4v.isRemoteLinkActivity)(result.node.object))) title = result.node.object.data?.displayName || '';
    else title = '';
    return {
        id: result.node.object.id,
        title: title,
        data: result,
        type: 'recent-activity'
    };
};

});

parcelRegister("fqqqA", function(module, exports) {

$parcel$export(module.exports, "useQuickFindResultsCallbacks", () => $a755cc866a3495f8$export$483ef80309da5ade);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $9NDUe = parcelRequire("9NDUe");
var $5aVN7 = parcelRequire("5aVN7");

var $6SihM = parcelRequire("6SihM");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $inrbX = parcelRequire("inrbX");
const $a755cc866a3495f8$export$483ef80309da5ade = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const is3PinQFEnabled = (0, $dh538.fg)('enable_quickfind_3p_search_results_confluence');
    const { incrementQueryVersion: incrementQueryVersion } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const ufoPreQueryLoadExperience = (0, $gwFzn.useRef)(new (0, $5aVN7.UFOExperience)(`${primaryProduct}-pre-query-results-load`, {
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'search-dialog'
        }
    }));
    const ufoPostQueryLoadExperience = (0, $gwFzn.useRef)(new (0, $5aVN7.UFOExperience)(`${primaryProduct}-post-query-results-load`, {
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: 'search-dialog'
        }
    }));
    const onPreQueryStart = (0, $gwFzn.useCallback)(()=>{
        ufoPreQueryLoadExperience.current.start();
    }, []);
    const onPreQuerySuccess = (0, $gwFzn.useCallback)(()=>{
        ufoPreQueryLoadExperience.current.success({
            metadata: {
                isQuickFind: true
            }
        });
    }, []);
    const onPreQueryFailure = (0, $gwFzn.useCallback)(()=>{
        ufoPreQueryLoadExperience.current.failure();
    }, []);
    const onPostQueryStart = (0, $gwFzn.useCallback)(()=>{
        const restartMetric = async ()=>{
            await ufoPostQueryLoadExperience.current.abort();
            await ufoPostQueryLoadExperience.current.start();
        };
        restartMetric();
    }, []);
    const onPostQuerySuccess = (0, $gwFzn.useCallback)((duration, hasThirdPartyResults)=>{
        incrementQueryVersion();
        ufoPostQueryLoadExperience.current.success({
            metadata: {
                isQuickFind: true,
                isHello: isHello,
                use3PResults: is3PinQFEnabled,
                hasThirdPartyResults: hasThirdPartyResults
            }
        });
        fireAnalyticsEvent((0, $6SihM.onSearchRequestCompleted)({
            attributes: {
                ...commonAttributes,
                postQueryRequestDurationMs: duration,
                hasThirdPartyResults: hasThirdPartyResults
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        incrementQueryVersion,
        nonPrivacySafeAttributes,
        isHello,
        is3PinQFEnabled
    ]);
    const onPostQueryFailure = (0, $gwFzn.useCallback)(()=>{
        ufoPostQueryLoadExperience.current.failure();
    }, []);
    const onPostQueryCancel = (0, $gwFzn.useCallback)(()=>{
        ufoPostQueryLoadExperience.current.abort();
    }, []);
    return (0, $gwFzn.useMemo)(()=>({
            onPreQueryStart: onPreQueryStart,
            onPreQuerySuccess: onPreQuerySuccess,
            onPreQueryFailure: onPreQueryFailure,
            onPostQueryStart: onPostQueryStart,
            onPostQuerySuccess: onPostQuerySuccess,
            onPostQueryFailure: onPostQueryFailure,
            onPostQueryCancel: onPostQueryCancel
        }), [
        onPostQueryCancel,
        onPostQueryFailure,
        onPostQueryStart,
        onPostQuerySuccess,
        onPreQueryFailure,
        onPreQueryStart,
        onPreQuerySuccess
    ]);
};

});
parcelRegister("6SihM", function(module, exports) {

$parcel$export(module.exports, "onSearchRequestCompleted", () => $33a13590dc77f914$export$caa45abe6a87e5b5);
const $33a13590dc77f914$export$caa45abe6a87e5b5 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'completed',
        actionSubject: 'searchRequest',
        actionSubjectId: 'postQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});


parcelRegister("3zpmm", function(module, exports) {

$parcel$export(module.exports, "fetchPeopleAndTeamsResults", () => $6e53edd4c7804f3e$export$290039782fc4e47);

var $1L3gY = parcelRequire("1L3gY");
const $6e53edd4c7804f3e$export$290039782fc4e47 = async (query, organizationId, primaryProduct, principalId, siteId)=>{
    // Override townsquare with watermelon as URS does not support townsquare as a primary product
    const productKey = primaryProduct === 'townsquare' ? 'watermelon' : primaryProduct;
    const response = await (0, $1L3gY.default)({
        query: query,
        context: {
            contextType: 'quick_find',
            siteId: siteId,
            productKey: productKey,
            principalId: principalId,
            organizationId: organizationId
        },
        includeUsers: true,
        includeTeams: true,
        includeGroups: false,
        maxNumberOfResults: 2,
        performSearchQueryOnly: false,
        searchQuery: {
            filter: 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)'
        }
    });
    return response.map($6e53edd4c7804f3e$export$cf1f13813d90479a);
};
const $6e53edd4c7804f3e$export$cf1f13813d90479a = (result)=>({
        id: result.id,
        title: result.name || result.displayName || '',
        data: result,
        type: 'people-and-teams'
    });

});

parcelRegister("eK6Pl", function(module, exports) {

$parcel$export(module.exports, "getThirdPartyFiltersForQuickFind", () => $d482bbe0b8132b8c$export$263a3384b7ce18b1);
$parcel$export(module.exports, "fetchConfluenceAnd3PEntities", () => $d482bbe0b8132b8c$export$9605a5c4a68b2654);
$parcel$export(module.exports, "fetchConfluenceSpaces", () => $d482bbe0b8132b8c$export$919c2c6ec09a9e2);
$parcel$export(module.exports, "fetchAtlasEntities", () => $d482bbe0b8132b8c$export$65df7212bf163b08);
$parcel$export(module.exports, "fetchMercuryEntities", () => $d482bbe0b8132b8c$export$60162ce0dfbba9f8);
$parcel$export(module.exports, "fetchJiraEntities", () => $d482bbe0b8132b8c$export$cfa5e5437133749b);

var $dh538 = parcelRequire("dh538");

var $johDC = parcelRequire("johDC");

var $1yEFx = parcelRequire("1yEFx");

var $NwuTK = parcelRequire("NwuTK");

var $dOOW1 = parcelRequire("dOOW1");

var $5XpfZ = parcelRequire("5XpfZ");

var $a5OFf = parcelRequire("a5OFf");

var $lDo65 = parcelRequire("lDo65");
const $d482bbe0b8132b8c$var$experience = 'quick-find';
const $d482bbe0b8132b8c$export$263a3384b7ce18b1 = (thirdPartyConfigs)=>{
    const smartlinkProducts = Object.keys(thirdPartyConfigs).filter((productKey)=>(0, $a5OFf.isProductSmartlink)({
            productKey: productKey,
            thirdPartyConfigs: thirdPartyConfigs
        }));
    const quickFind3PProducts = [
        (0, $1yEFx.ProductKeys3P).GoogleDrive,
        (0, $1yEFx.ProductKeys3P).Sharepoint
    ].concat((0, $dh538.fg)('quickfind-smartlinks') ? [
        ...smartlinkProducts
    ] : []);
    const quickFind3PEntities = quickFind3PProducts.filter((productKey)=>!thirdPartyConfigs[productKey]?.userNeedsOAuth).map((productKey)=>Array.from(thirdPartyConfigs[productKey]?.typeFilterConfig?.keys() ?? [])).flat();
    const quickFindIntegrationARIs = (0, $dOOW1.getIntegrationARIsFromConfig)();
    const titleMatchValue = false;
    return (0, $dOOW1.getThirdPartyFilters)(quickFind3PProducts, titleMatchValue, quickFind3PEntities, thirdPartyConfigs, quickFindIntegrationARIs);
};
const $d482bbe0b8132b8c$export$9605a5c4a68b2654 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, thirdPartyFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments, filteredEntities)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // refer to fetchJiraEntities
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const supportedEntities = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost',
        'ati:cloud:confluence:attachment',
        'ati:cloud:confluence:whiteboard',
        'ati:cloud:confluence:database',
        ...(0, $dh538.fg)('add_confluence_entities_quickfind') ? [
            'ati:cloud:confluence:embed',
            'ati:cloud:confluence:folder'
        ] : [],
        ...thirdPartyFilters ? [
            'ati:cloud:graph:document'
        ] : [],
        ...(0, $dh538.fg)('quickfind-smartlinks') ? [
            'ati:cloud:graph:remote-link'
        ] : []
    ];
    const entities = supportedEntities.filter((supportedEntity)=>filteredEntities.includes(supportedEntity));
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    // TODO: Remove this code override and add it via an experiment
    const useUserShardIndexForConfluenceQuery = (0, $dh538.fg)('quick_find_user_shard_query');
    const finalExperimentId = useUserShardIndexForConfluenceQuery ? 'L1-usershard-shosexp_L2-pipelineOnly__default_QR-cloudberry' : experimentId;
    const finalExperimentLayers = useUserShardIndexForConfluenceQuery ? [
        {
            name: 'search_platform_layer_l1',
            layerId: 'L1-usershard-shosexp',
            shadowId: null
        },
        {
            name: 'search_platform_layer_l2',
            layerId: 'L2-pipelineOnly',
            shadowId: null
        }
    ] : experimentLayers;
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 7,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                issueTypeIDs: []
            }
        },
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: thirdPartyFilters ?? {
            titleMatchOnly: true,
            subtypes: []
        },
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentId: finalExperimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(finalExperimentLayers)
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: response.extensions?.gateway?.request_id
    };
};
const $d482bbe0b8132b8c$export$919c2c6ec09a9e2 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    // refer to fetchJiraEntities
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:confluence:space'
    ];
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 1,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                issueTypeIDs: []
            }
        },
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers)
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchSpacesRequestId: response.extensions?.gateway?.request_id
    };
};
const $d482bbe0b8132b8c$export$65df7212bf163b08 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    // refer to fetchJiraEntities
    const { commonFilters: commonFilters, mercuryFilters: mercuryFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:townsquare:project',
        'ati:cloud:townsquare:goal',
        'ati:cloud:townsquare:tag'
    ];
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: true,
            contentStatuses: [],
            containerStatus: []
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: [],
                assigneeARIs: [],
                issueTypeIDs: []
            }
        },
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: []
        },
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers)
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: response.extensions?.gateway?.request_id
    };
};
const $d482bbe0b8132b8c$export$60162ce0dfbba9f8 = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments)=>{
    // TODO: replace all the hard-coded values of filters with the ones passed on from selectedFilters
    // and remove experiementId and shadowExperimentId as these are no longer used
    // refer to fetchJiraEntities
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:mercury:focus-area',
        'ati:cloud:mercury:focus-area-status-update'
    ];
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: 6,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers)
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: response.extensions?.gateway?.request_id
    };
};
/**
 * The experiment layers are mapped to ensure permitted attributes are sent into search requests.
 */ const $d482bbe0b8132b8c$var$mapExperimentLayers = (experimentLayers)=>experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
            name: name,
            layerId: layerId,
            shadowId: shadowId,
            definitions: definitions
        }));
const $d482bbe0b8132b8c$export$cfa5e5437133749b = async (aggAbsoluteUrl, query, sourceProduct, cloudId, searchSessionId, selectedFilters, experimentConfig, productEdition, productDataRegions, setRequestedBackendExperiments)=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, thirdPartyFilters: thirdPartyFilters, jiraFilters: jiraFilters } = selectedFilters || (0, $dOOW1.getEmptySelectedFilters)();
    const entities = [
        'ati:cloud:jira:board',
        'ati:cloud:jira:dashboard',
        'ati:cloud:jira:filter',
        'ati:cloud:jira:issue',
        'ati:cloud:jira:project'
    ];
    const backendExperiment = (0, $NwuTK.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: entities,
        productEdition: productEdition,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        productDataRegions: productDataRegions,
        experience: $d482bbe0b8132b8c$var$experience,
        tenantId: cloudId
    });
    setRequestedBackendExperiments(backendExperiment);
    const { experimentLayers: experimentLayers } = backendExperiment || {};
    const variables = {
        experience: $d482bbe0b8132b8c$var$experience,
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:jira::site/${cloudId}`,
        tenantId: cloudId,
        limit: 7,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        mercuryFilters: mercuryFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        sort: [],
        searchSessionId: searchSessionId,
        sourceProduct: sourceProduct,
        experimentLayers: $d482bbe0b8132b8c$var$mapExperimentLayers(experimentLayers)
    };
    const response = await (0, $johDC.searchDialogQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        fetchResults: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: response.extensions?.gateway?.request_id
    };
};
const $d482bbe0b8132b8c$export$cf1f13813d90479a = (result)=>({
        id: result.id,
        title: result.title,
        data: result,
        type: 'search-result'
    });
const $d482bbe0b8132b8c$export$80a74e60556dec79 = async ()=>{
    const response = await Promise.resolve((0, $lDo65.userShardMock));
    const nodes = response.data?.search?.results.edges.map((edge)=>edge.node) || [];
    return {
        results: nodes.map($d482bbe0b8132b8c$export$cf1f13813d90479a),
        fetchEntitiesRequestId: undefined,
        fetchSpacesRequestId: undefined
    };
};

});
parcelRegister("lDo65", function(module, exports) {

$parcel$export(module.exports, "userShardMock", () => $823d921a43c527c1$export$6cf111bd7d77355d);
const $823d921a43c527c1$export$6cf111bd7d77355d = {
    data: {
        search: {
            results: {
                edges: [
                    {
                        node: {
                            description: 'Write instead talk prove individual however strategy. So herself difference. Research authority style dark number.',
                            iconUrl: 'https://picsum.photos/691/320',
                            id: '5acc5def-79d4-40ac-8f52-ae46d6831c73',
                            title: 'Southern reach director conference bar.',
                            type: 'page',
                            url: 'http://hicks.com/',
                            __typename: 'SearchConfluencePageBlogAttachment',
                            product: 'confluence',
                            lastModified: '2006-04-04T04:18:40.945099',
                            isVerified: false,
                            space: {
                                id: 'ab59b2b6-589b-4f2e-8d2d-170d16deb5e6',
                                name: 'Cardenas, Bell and Williams',
                                webUiLink: 'categories/app/categories'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '2019-08-13T21:01:17.929899',
                                user: {
                                    accountId: '9b283ff5-4969-4b9d-a34d-bd808ee6f0ee',
                                    name: 'Richard Contreras',
                                    picture: 'https://dummyimage.com/450x361',
                                    email: 'angelahahn@example.org',
                                    extendedProfile: {
                                        jobTitle: 'Video editor'
                                    }
                                }
                            },
                            users_viewed: [
                                'd18c7954-52a1-44d1-80f3-75c2939a3c4f',
                                '6acea4a7-216c-4047-b19c-d01b251b17ec',
                                'e291b395-cd37-4c11-8c53-12bf086a6a4f',
                                '4c4fd265-0762-4144-853c-9891aa592aec',
                                '992bb120-3caf-4680-8f59-4106b3749005'
                            ],
                            users_commented: [
                                '2a41863c-9279-48f1-a808-3e2c2f98f0e1',
                                '074d9b19-d8d0-4c0e-a3ce-70630a56cc43',
                                '7872c24c-a7b4-48ba-9f9e-8bb4467133dd',
                                'b9a4ef38-0704-4289-bdc1-d46820bb5ff1',
                                '91fd1340-d1f0-4b7b-a2c9-44960ce3062e'
                            ],
                            user_edited: [
                                'd7f7b4a6-509b-42f5-a5ff-c647b4d736c9',
                                'ddf897f1-c28a-4a87-9ca6-bc3ca146868b',
                                '2c025aad-a99d-4a57-8a38-f21b026e1e4a',
                                '0b682e46-31f3-4ec6-8ba1-c34a31cb3822',
                                '9850ce5d-8fd0-4485-9dc3-9e1b04b177d6'
                            ],
                            confluenceEntity: {
                                ancestors: [
                                    {
                                        id: 'da24cfeb-7bc9-40bd-bac2-d3444e011a95',
                                        title: 'Building free share must role.',
                                        links: {
                                            webUi: 'wp-content/category/main'
                                        }
                                    },
                                    {
                                        id: '6c89b66c-4c22-4484-bccf-e1dd8593734e',
                                        title: 'Congress institution where better now stop actually.',
                                        links: {
                                            webUi: 'blog'
                                        }
                                    }
                                ],
                                metadata: {
                                    titleEmojiPublished: {
                                        id: null,
                                        value: null
                                    }
                                },
                                commentCountSummary: {
                                    total: 97
                                },
                                likesSummary: {
                                    count: 27
                                }
                            }
                        }
                    },
                    {
                        node: {
                            description: 'Probably upon sing short out do. Behavior increase southern long agree address risk us.',
                            iconUrl: 'https://placekitten.com/986/579',
                            id: '7bc0f818-ad94-4cbd-b88c-ff8b49b06610',
                            title: 'Heart maintain learn despite mouth clearly seem.',
                            type: 'gdoc_document',
                            url: 'http://www.davis-ruiz.com/',
                            __typename: 'SearchResultGoogleDocument',
                            product: 'google',
                            lastModified: '1995-01-15T11:05:46.063993',
                            isVerified: true,
                            space: {
                                id: 'a09eb82a-639e-41e4-8e21-8b921c352762',
                                name: 'Davis-Andrews',
                                webUiLink: 'tag/app'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '1990-06-21T02:48:25.697280',
                                user: {
                                    accountId: '848f760f-d398-41eb-ac62-eb47ec2448be',
                                    name: 'Sarah Foley',
                                    picture: 'https://dummyimage.com/683x208',
                                    email: 'rodney86@example.org',
                                    extendedProfile: {
                                        jobTitle: 'Energy manager'
                                    }
                                }
                            },
                            users_viewed: [
                                'ebda7fa5-dd22-4b2b-91fb-273727b80d4f',
                                '02e50818-734e-4118-8fae-b756f41490af',
                                '90f28367-962c-41fc-866b-9f2ce0e59ff7',
                                'e3008455-4e68-4f03-9588-607a611c5a44',
                                '7391fb8e-d99c-477e-91e2-f673c1aeec0c'
                            ],
                            users_commented: [
                                '833dc991-5548-4b89-8db6-3563bd6ad67c',
                                '42ffad7c-c67b-4f8a-ba38-6623d1c77008',
                                '1fa026ba-84ee-47f7-a7ad-578d816f69b5',
                                '635f46fb-64ca-4932-a7df-942ef9116455',
                                'ee33c5c2-4992-4506-95e1-920de4c6da3d'
                            ],
                            user_edited: [
                                '3a059892-9c26-465f-a5d9-64436247517d',
                                '086f550d-2c78-46ce-b66a-3cbe2cf5dbca',
                                'a51e9325-41d2-4923-8c53-905f88092c78',
                                '32749082-f541-47d2-a349-318375d2d7c9',
                                '5b5651ef-0e1a-496f-8e88-7bcf0960cee6'
                            ],
                            googleDocEntity: []
                        }
                    },
                    {
                        node: {
                            description: 'Effort modern thing college. His result couple vote act city. Material rate deep finish.\nMaybe sport upon. Somebody factor require class fund. Him he cost door organization however effect.',
                            iconUrl: 'https://placekitten.com/936/487',
                            id: 'b312225a-f5f7-4c6a-b41a-5a947dca56bb',
                            title: 'Music bit test opportunity four.',
                            type: 'page',
                            url: 'http://bonilla.net/',
                            __typename: 'SearchConfluencePageBlogAttachment',
                            product: 'confluence',
                            lastModified: '2010-05-26T18:03:36.431642',
                            isVerified: false,
                            space: {
                                id: '44538462-d330-40d6-a9bd-d7d8b25305bd',
                                name: 'Richardson-Perry',
                                webUiLink: 'tag'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '1988-02-04T09:02:52.372568',
                                user: {
                                    accountId: '3cef5fb2-d266-4fa8-b412-b8bf2100f9de',
                                    name: 'Andrew Bradley',
                                    picture: 'https://placekitten.com/930/981',
                                    email: 'rhondagates@example.net',
                                    extendedProfile: {
                                        jobTitle: 'Production manager'
                                    }
                                }
                            },
                            users_viewed: [
                                '37bd8038-2c6e-4831-bd87-489929f39956',
                                '6d0609cc-7431-4ee7-87f1-f562cac0cfed',
                                'bb0c92db-8435-4c7e-a595-0f7240b1b03d',
                                '6cc0acbe-0862-49f6-a97b-4c6d8e3a0cbc',
                                '947ff689-cbf6-4110-97d8-f1bfb6eab5d5'
                            ],
                            users_commented: [
                                'f28f50b7-9681-4c6f-abcf-0aede1e5e510',
                                'e70104cf-5a38-40f8-a91c-6eacbd77a56e',
                                '7d67ba23-0d34-4efe-99c2-afafd58b3e5e',
                                '2c1d666d-a6fe-43bc-9cf8-7d1c41487de5',
                                'bbdbb39b-a98f-4925-a7db-7c631d04d26a'
                            ],
                            user_edited: [
                                '38a2cf95-bfae-4654-9a4d-741d7f8e3400',
                                '9b40e3fb-0a83-47aa-9b6a-f390862302f1',
                                '51fc97fa-3409-44a1-a90b-a3883aecc345',
                                '79b44666-390a-4534-ad8c-c7c01d10fb5a',
                                '53df2510-6207-47bf-8b35-d1ab47245cb0'
                            ],
                            confluenceEntity: {
                                ancestors: [
                                    {
                                        id: '6a41be89-d3cc-4af7-8ec3-96a5386642f5',
                                        title: 'Group example second information statement.',
                                        links: {
                                            webUi: 'blog'
                                        }
                                    },
                                    {
                                        id: '68a3c9af-132c-4262-8f78-ab19841f0164',
                                        title: 'Personal all interest society behavior person.',
                                        links: {
                                            webUi: 'list/blog/app'
                                        }
                                    }
                                ],
                                metadata: {
                                    titleEmojiPublished: {
                                        id: null,
                                        value: null
                                    }
                                },
                                commentCountSummary: {
                                    total: 72
                                },
                                likesSummary: {
                                    count: 1
                                }
                            }
                        }
                    },
                    {
                        node: {
                            description: 'Member growth will if. They experience challenge enough. Brother sound realize fast.\nSong plant anything medical.',
                            iconUrl: 'https://placekitten.com/151/653',
                            id: '5c46b39b-a668-41d0-92df-012eac9e138f',
                            title: 'Hot read painting policy environmental.',
                            type: 'gdoc_document',
                            url: 'https://www.brooks-osborne.com/',
                            __typename: 'SearchResultGoogleDocument',
                            product: 'google',
                            lastModified: '2004-09-19T18:19:21.096056',
                            isVerified: true,
                            space: {
                                id: '863891d4-e0a9-4145-82cd-53545e02bb2d',
                                name: 'Johnson and Sons',
                                webUiLink: 'blog'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '2008-03-03T12:49:25.101438',
                                user: {
                                    accountId: '105d2bd6-29e3-4208-96a9-146286d6630f',
                                    name: 'Jason Garcia',
                                    picture: 'https://dummyimage.com/494x74',
                                    email: 'mike20@example.org',
                                    extendedProfile: {
                                        jobTitle: 'Field trials officer'
                                    }
                                }
                            },
                            users_viewed: [
                                '961f188b-d0fe-4f39-b5fa-a9fab3c5cc4b',
                                '7ac03ca9-c40e-4abc-869f-46431b6205bb',
                                'cfe88c6d-0a50-499e-a64e-de69d13fe94a',
                                '38039b13-6599-406f-9bea-9570fc58ca95',
                                'e1df89c4-bd94-4d67-ab26-aba538212ebb'
                            ],
                            users_commented: [
                                '1e53b7b5-acb4-4ee8-80b1-7a9d12a2ff43',
                                '851f91fd-e9d8-4800-9caa-9b5a1239c65c',
                                '8e0ce91a-330c-427c-ba9a-2f222498d550',
                                'd7090eae-6301-402b-8c9c-a5221bbe6c2a',
                                '7464f611-5d04-41b1-8a6e-394de940bc0d'
                            ],
                            user_edited: [
                                '7a1ddde1-ff48-4a28-82e2-5097a45d6aa3',
                                'c06da3f2-7e4b-4105-b916-7879de52f690',
                                'de43c9f6-6463-4cce-9a04-bd6188878f31',
                                '8f1620f5-3bf6-480f-a62c-97a080301840',
                                'accf2adb-af6c-4e4e-9dd2-d37d0843b192'
                            ],
                            googleDocEntity: []
                        }
                    },
                    {
                        node: {
                            description: 'Example while glass else unit. Pass play wife hundred heavy.\nFeeling see behavior southern already some work they. At bit head administration seek amount.',
                            iconUrl: 'https://dummyimage.com/622x468',
                            id: '46d468f8-348b-4a43-92bb-04d7fbc857b3',
                            title: 'Receive window often box.',
                            type: 'gdoc_document',
                            url: 'http://www.dillon.com/',
                            __typename: 'SearchResultGoogleDocument',
                            product: 'google',
                            lastModified: '2000-05-02T23:30:56.447866',
                            isVerified: false,
                            space: {
                                id: 'c0e21975-ce5e-4edd-a0a0-8786cef6c63c',
                                name: 'Green and Sons',
                                webUiLink: 'tags/category'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '1978-02-16T23:04:15.102121',
                                user: {
                                    accountId: '2f4d4944-7414-4eae-a2c5-0af0d7163de1',
                                    name: 'Anthony Barton',
                                    picture: 'https://placekitten.com/838/568',
                                    email: 'julia92@example.org',
                                    extendedProfile: {
                                        jobTitle: 'Oceanographer'
                                    }
                                }
                            },
                            users_viewed: [
                                '137661fb-56c9-4ced-af69-0be68c7068e8',
                                '198815d1-6e0d-477f-99d5-e3078c03af34',
                                '9aa16d7b-58b9-49e8-a28f-3792c02ecfff',
                                'e718aec4-d6c2-41e5-9b46-6bffe9234474',
                                '174a4d14-df8a-4274-a073-f1680daaa0eb'
                            ],
                            users_commented: [
                                '0064ca05-61c3-46f3-a335-e73f0a6ae728',
                                'c70237db-90e5-40d5-b356-8718f37e669b',
                                'a8076405-3c1d-4f4d-9012-e0bbedf10d8f',
                                '684a7b9e-dfd2-4329-94e0-b25792a4ea7b',
                                'a7e49dee-7d37-41b6-be8b-d05f60c315f8'
                            ],
                            user_edited: [
                                'e5e45afd-c7f9-4665-8969-c8c7da938b2d',
                                'ec996965-4ca7-4037-9e29-ba0f45dd5e0f',
                                '81751370-a21d-4751-9a5b-f9d2a0867b3e',
                                '9c00622a-6f7f-4861-ac97-3358cb4e2850',
                                '73543537-c543-494a-9876-4b3ecf9ff4ca'
                            ],
                            googleDocEntity: []
                        }
                    },
                    {
                        node: {
                            description: 'Mention break southern phone work. Network marriage hold way country church.\nHappy sea hotel serious finally next.\nIt give who.\nInstead thousand lawyer according care.',
                            iconUrl: 'https://placekitten.com/350/291',
                            id: '00579406-d861-4122-83a0-bbb423f95b14',
                            title: 'Stay wind computer control star career range.',
                            type: 'page',
                            url: 'http://carter-flores.info/',
                            __typename: 'SearchConfluencePageBlogAttachment',
                            product: 'confluence',
                            lastModified: '2016-07-17T15:51:11.675432',
                            isVerified: true,
                            space: {
                                id: '6b128d94-ce67-4448-9be2-b52d0da5f269',
                                name: 'Rodriguez-Doyle',
                                webUiLink: 'wp-content'
                            },
                            socialSignal: {
                                signal: 'comment',
                                timestamp: '2015-05-01T06:23:48.066278',
                                user: {
                                    accountId: '57d8845c-21cc-49a8-be97-3ba36068090c',
                                    name: 'Christopher Gonzalez',
                                    picture: 'https://dummyimage.com/2x1012',
                                    email: 'iramos@example.com',
                                    extendedProfile: {
                                        jobTitle: 'Television production assistant'
                                    }
                                }
                            },
                            users_viewed: [
                                '1d35dd66-6ad2-4b2f-96c6-8ba70f14cff5',
                                'f87c3dba-d909-40d4-b685-68a4e9426887',
                                '91182508-a548-457d-8ea4-8c9f2d3cfca0',
                                '654f1539-663c-434f-bbdb-8886d78f4328',
                                '51bdf189-8ab0-4904-aee0-34fb44a91dea'
                            ],
                            users_commented: [
                                '7a0302ce-7ef2-4464-bc09-042049430c40',
                                'bca173b4-9567-4348-9bd5-ce873d2c8a15',
                                '47b0c102-25a6-40d4-b4c7-6c39c1fde4f2',
                                '67853ce0-8a04-4b4b-8271-d6db3aa3728b',
                                '324539eb-7fb9-4f6d-b1da-fecfbaa2b375'
                            ],
                            user_edited: [
                                '6666e520-a652-4209-b2a8-6214d3bd10dd',
                                'c0637267-2896-4833-a3a7-59906fc8b753',
                                'f98e9ad2-f9a0-4c4a-9d49-064b52c9070b',
                                'f3b85911-3dac-4a0d-9cff-f90b84c62ae2',
                                '02304ebb-e870-4e80-8611-44869668f504'
                            ],
                            confluenceEntity: {
                                ancestors: [
                                    {
                                        id: '4a1205f3-5391-4fa1-954c-ed39f5ade15b',
                                        title: 'Dog young benefit improve girl.',
                                        links: {
                                            webUi: 'categories'
                                        }
                                    },
                                    {
                                        id: '5be5cb73-af2e-4c24-9a3d-d16bfe0dc928',
                                        title: 'Lose nor ready same develop if.',
                                        links: {
                                            webUi: 'wp-content'
                                        }
                                    }
                                ],
                                metadata: {
                                    titleEmojiPublished: {
                                        id: null,
                                        value: null
                                    }
                                },
                                commentCountSummary: {
                                    total: 8
                                },
                                likesSummary: {
                                    count: 44
                                }
                            }
                        }
                    }
                ],
                queryInfo: null,
                abTest: {
                    abTestId: 'no_ab_test_id',
                    controlId: 'L1-OS-3recalllimitknn_L2-3pdocprod___QR-cloudberry',
                    experimentId: 'L1-OS-3recalllimitknn_L2-3pdocprod___QR-cloudberry'
                },
                totalCount: 1318761,
                totalCounts: [
                    {
                        product: 'confluence',
                        count: 1318761
                    }
                ],
                pageInfo: {
                    endCursor: '5388cd59-45ed-40c8-991d-b7546e1dd79e'
                }
            }
        }
    },
    extensions: {
        gateway: {
            request_id: '82bca72a-4471-4bed-ae6c-ff9ccb99b727',
            crossRegion: false,
            edgeCrossRegion: false
        }
    }
};

});


parcelRegister("cA4A0", function(module, exports) {

$parcel$export(module.exports, "getRecentQueries", () => $1435b53be5ab4d50$export$d6415f081f333b17);

var $1SV4e = parcelRequire("1SV4e");
const $1435b53be5ab4d50$export$d6415f081f333b17 = (primaryProduct, userId)=>{
    const recentSearches = (0, $1SV4e.getRecentSearches)(userId, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
    return recentSearches.map($1435b53be5ab4d50$export$cf1f13813d90479a);
};
const $1435b53be5ab4d50$export$cf1f13813d90479a = (query)=>({
        id: query,
        title: query,
        data: query,
        type: 'recent-query'
    });

});

parcelRegister("6CCNp", function(module, exports) {

$parcel$export(module.exports, "getQuickFindContent", () => $2bb736a7e62c9305$export$35ead133d529e85e);
const $2bb736a7e62c9305$var$preQueryErrorHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, preQueryError: preQueryError, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    if ((!hasQuery || postQueryDisabled) && preQueryError) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
};
const $2bb736a7e62c9305$var$preQueryLoadingHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, preQueryLoading: preQueryLoading, filteredRecentQueries: filteredRecentQueries, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    if ((!hasQuery || postQueryDisabled) && preQueryLoading) return {
        state: 'PREQUERY_LOADING',
        query: '',
        recentQueries: filteredRecentQueries
    };
};
const $2bb736a7e62c9305$var$preQueryNoResultsHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, filteredRecentActivities: filteredRecentActivities, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    const totalResults = filteredRecentActivities.result.length;
    if ((!hasQuery || postQueryDisabled) && totalResults === 0) return {
        state: 'PREQUERY_NO_RESULTS',
        query: ''
    };
};
const $2bb736a7e62c9305$var$preQueryResultsHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    const totalResults = filteredRecentActivities.result.length;
    if ((!hasQuery || postQueryDisabled) && totalResults > 0) return {
        state: 'PREQUERY_RESULTS',
        query: '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result
    };
};
const $2bb736a7e62c9305$var$postQueryErrorHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, postQueryError: postQueryError, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    if (hasQuery && !postQueryDisabled && postQueryError) return {
        state: 'POSTQUERY_ERROR',
        query: query || ''
    };
};
const $2bb736a7e62c9305$var$postQueryLoadingHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, postQueryLoading: postQueryLoading, filteredRecentActivities: filteredRecentActivities, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    if (hasQuery && !postQueryDisabled && postQueryLoading) return {
        state: 'POSTQUERY_LOADING',
        query: query || '',
        recentActivities: filteredRecentActivities.result
    };
};
const $2bb736a7e62c9305$var$postQueryNoResultsHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    const totalResults = searchResults.result.length + peopleAndTeams.result.length;
    if (hasQuery && !postQueryDisabled && totalResults === 0) return {
        state: 'POSTQUERY_NO_RESULTS',
        query: query || ''
    };
};
const $2bb736a7e62c9305$var$postQueryResultsHandler = ({ query: query, selectedQueryFilters: selectedQueryFilters, filteredRecentQueries: filteredRecentQueries, filteredRecentActivities: filteredRecentActivities, searchResults: searchResults, peopleAndTeams: peopleAndTeams, postQueryDisabled: postQueryDisabled })=>{
    const hasQuery = query || selectedQueryFilters.length > 0;
    const totalResults = searchResults.result.length + peopleAndTeams.result.length;
    if (hasQuery && !postQueryDisabled && totalResults > 0) return {
        state: 'POSTQUERY_RESULTS',
        query: query || '',
        recentQueries: filteredRecentQueries,
        recentActivities: filteredRecentActivities.result,
        searchResults: searchResults.result,
        peopleAndTeams: peopleAndTeams.result
    };
};
const $2bb736a7e62c9305$export$35ead133d529e85e = (args)=>{
    if (!args.quickFindOpen) return;
    const handlers = [
        $2bb736a7e62c9305$var$preQueryErrorHandler,
        $2bb736a7e62c9305$var$preQueryLoadingHandler,
        $2bb736a7e62c9305$var$preQueryNoResultsHandler,
        $2bb736a7e62c9305$var$preQueryResultsHandler,
        $2bb736a7e62c9305$var$postQueryErrorHandler,
        $2bb736a7e62c9305$var$postQueryLoadingHandler,
        $2bb736a7e62c9305$var$postQueryNoResultsHandler,
        $2bb736a7e62c9305$var$postQueryResultsHandler
    ];
    for (const handler of handlers){
        const result = handler(args);
        if (result) return result;
    }
    // This should never happen, but default to error state
    if (!args.query) return {
        state: 'PREQUERY_ERROR',
        query: ''
    };
    else return {
        state: 'POSTQUERY_ERROR',
        query: args.query
    };
};

});


parcelRegister("is3gE", function(module, exports) {

$parcel$export(module.exports, "QuickFindStoreProvider", () => $f58c1f7467c49dec$export$5f60ff1bbe7f1a37);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4VmlX = parcelRequire("4VmlX");
const $f58c1f7467c49dec$export$5f60ff1bbe7f1a37 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4VmlX.QuickFindStoreContainer), {
        children: children
    });
};

});

parcelRegister("h9lDJ", function(module, exports) {

$parcel$export(module.exports, "SearchDialog", () => $71af45ffeeb47c72$export$2aadebb53f6015f6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $hWR4v = parcelRequire("hWR4v");
var $4TTdD = parcelRequire("4TTdD");
var $7ZetK = parcelRequire("7ZetK");

var $9vOy1 = parcelRequire("9vOy1");

var $1yEFx = parcelRequire("1yEFx");

var $3R0ts = parcelRequire("3R0ts");

var $7WbA8 = parcelRequire("7WbA8");

var $5Lref = parcelRequire("5Lref");

var $39Swq = parcelRequire("39Swq");

var $86ob4 = parcelRequire("86ob4");

var $kIdP4 = parcelRequire("kIdP4");

var $a5OFf = parcelRequire("a5OFf");

var $iEwMm = parcelRequire("iEwMm");

var $fr375 = parcelRequire("fr375");

var $5I2eK = parcelRequire("5I2eK");

var $aE5mL = parcelRequire("aE5mL");

var $19BAV = parcelRequire("19BAV");

var $dsrEB = parcelRequire("dsrEB");

var $1nJM3 = parcelRequire("1nJM3");

var $gGFxq = parcelRequire("gGFxq");

var $inrbX = parcelRequire("inrbX");

var $dSjat = parcelRequire("dSjat");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $j4ply = parcelRequire("j4ply");

var $d5Ozh = parcelRequire("d5Ozh");

var $4VmlX = parcelRequire("4VmlX");

var $NvPpA = parcelRequire("NvPpA");

var $2nHbb = parcelRequire("2nHbb");

var $e79Fp = parcelRequire("e79Fp");

var $cuvog = parcelRequire("cuvog");

var $47juE = parcelRequire("47juE");

var $d6thU = parcelRequire("d6thU");

var $cu2Tg = parcelRequire("cu2Tg");

var $a0YSD = parcelRequire("a0YSD");

var $kMtrE = parcelRequire("kMtrE");

var $aBMZB = parcelRequire("aBMZB");

var $iUdW4 = parcelRequire("iUdW4");

var $8SdvD = parcelRequire("8SdvD");

var $fvCil = parcelRequire("fvCil");

var $lTdhv = parcelRequire("lTdhv");

var $2FGXW = parcelRequire("2FGXW");

var $fKnXN = parcelRequire("fKnXN");

var $hPvza = parcelRequire("hPvza");

var $8IQPm = parcelRequire("8IQPm");

var $hDfbs = parcelRequire("hDfbs");

var $fscQt = parcelRequire("fscQt");

var $3qFOk = parcelRequire("3qFOk");

var $5BL1t = parcelRequire("5BL1t");
const $71af45ffeeb47c72$var$searchDialogStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: '4px',
    boxShadow: 'elevation.shadow.overlay',
    marginTop: 'space.100',
    width: '100%'
});
const $71af45ffeeb47c72$var$searchResultsSectionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.100',
    gap: 'space.025',
    maxHeight: 'calc(100vh - 220px)',
    overflowY: 'auto'
});
const $71af45ffeeb47c72$export$2aadebb53f6015f6 = ({ dialogId: dialogId, dialogRef: dialogRef, localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const intl = (0, $dBxQj.default)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { retrySearch: retrySearch } = (0, $djVCD.useSearchActions)();
    const [{ thirdPartyConfigs: thirdPartyConfigs, products: availableProducts }] = (0, $j4ply.useBootstrap)();
    const content = (0, $4VmlX.useContent)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const allItems = $71af45ffeeb47c72$var$useBody(content);
    $71af45ffeeb47c72$var$useResetSessionAnalytics();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    $71af45ffeeb47c72$var$useAnalyticsEvents(fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes);
    const resultOnClick = (0, $dSjat.useQuickFindResultOnClick)();
    const resultOnContextMenu = (0, $dSjat.useQuickFindResultOnContextMenu)();
    const resultOnHighlighted = (0, $dSjat.useQuickFindResultOnHighlighted)();
    const footerOnClick = (0, $dSjat.useQuickFindFooterOnClick)();
    const queryFiltersBody = (0, $fKnXN.useQueryFilterResults)({
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        inputRef: inputRef
    });
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    let hasThirdPartyResults = false;
    const localDialogRef = (0, $gwFzn.useRef)(null);
    (0, $86ob4.useWidthObserverRegistration)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID), localDialogRef);
    if (!content) return null;
    const { state: state } = content;
    const body = [];
    let searchResultItemBody;
    for (const content of allItems){
        if ((0, $5BL1t.isErrorItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $47juE.ErrorScreen), {
            onRetry: retrySearch
        }, content.id));
        if ((0, $5BL1t.isLandingItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $aBMZB.LandingScreen), {}, content.id));
        if ((0, $5BL1t.isNoResultsItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8SdvD.NoResultsScreen), {
            onRetry: retrySearch
        }, content.id));
        if ((0, $5BL1t.isHeadingItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $39Swq.Heading), {
            id: content.id,
            text: content.data,
            includeInAnalytics: content.includeInAnalytics
        }, content.id));
        if ((0, $5BL1t.isSkeletonItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hDfbs.SearchResultSkeleton), {}, content.id));
        if ((0, $5BL1t.isRecentQueryItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8IQPm.RecentQuery), {
            result: content.data,
            state: state
        }, content.id));
        if ((0, $5BL1t.isRecentActivityItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hPvza.RecentActivity), {
            result: content.data,
            state: state,
            onClick: resultOnClick,
            onContextMenu: resultOnContextMenu,
            onHighlighted: resultOnHighlighted
        }, content.id));
        if ((0, $5BL1t.isSearchResultItem)(content)) {
            const productEntity = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lTdhv.ProductEntity), {
                result: content.data,
                state: state,
                onClick: resultOnClick,
                onContextMenu: resultOnContextMenu,
                onHighlighted: resultOnHighlighted
            }, content.id);
            if ((0, $dh538.fg)('enable_quickfind_3p_search_results_confluence')) {
                if (!searchResultItemBody) {
                    searchResultItemBody = [];
                    body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Profiler), {
                        id: "QuickFindSearchDialogResults",
                        onRender: (_, phase, actualDuration)=>{
                            if (phase === 'mount' && localQuery.length) fireAnalyticsEvent((0, $5I2eK.onSearchResultsRendered)({
                                attributes: {
                                    ...commonAttributes,
                                    durationMs: actualDuration,
                                    hasThirdPartyResults: hasThirdPartyResults
                                },
                                nonPrivacySafeAttributes: nonPrivacySafeAttributes
                            }));
                        },
                        children: searchResultItemBody
                    }));
                }
                searchResultItemBody.push(productEntity);
                if ((0, $7ZetK.isSearchResultGraphEntity)(content.data)) hasThirdPartyResults = true;
            } else body.push(productEntity);
        }
        if ((0, $5BL1t.isPeopleAndTeamsItem)(content)) body.push(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $fvCil.PeopleAndTeams), {
            result: content.data,
            state: state,
            onClick: resultOnClick,
            onContextMenu: resultOnContextMenu,
            onHighlighted: resultOnHighlighted
        }, content.id));
    }
    const footer = (()=>{
        // Post-query state with Confluence or Focus
        if ((primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence || primaryProduct === (0, $1yEFx.PrimaryProductKeys).Focus) && (0, $aE5mL.isPostQueryState)(state)) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fscQt.SearchPageLink), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                !(0, $dh538.fg)('quick_find_filters') && (0, $aE5mL.isPostQueryLoadingOrResults)(state) && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3qFOk.SearchPagePrimaryProductLink), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6thU.FeedbackFooter), {})
            ]
        });
        if (primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fscQt.SearchPageLink), {
                    state: state,
                    onClick: footerOnClick
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a0YSD.JiraAdvancedSearchLink), {
                    state: state,
                    onClick: footerOnClick
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kMtrE.JiraSingleSiteSearch), {
                    state: state,
                    onClick: footerOnClick
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6thU.FeedbackFooter), {})
            ]
        });
        // Pre-query footer
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fscQt.SearchPageLink), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                !(0, $dh538.fg)('quick_find_filters') && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Unified,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3qFOk.SearchPagePrimaryProductLink), {
                            state: state,
                            onClick: footerOnClick
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuvog.Divider), {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6thU.FeedbackFooter), {})
            ]
        });
    })();
    const isAIEnabled = isRovoLLMEnabled || isAdminHubAIEnabled;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $71af45ffeeb47c72$var$searchDialogStyles,
        "aria-label": intl.formatMessage((0, $iUdW4.messages).searchDialogAriaLabel),
        testId: 'search-dialog',
        ref: (0, $kIdP4.mergeRefs)(dialogRef, localDialogRef),
        id: dialogId,
        children: queryFiltersBody ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $71af45ffeeb47c72$var$searchResultsSectionStyles,
            children: queryFiltersBody
        }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $71af45ffeeb47c72$var$searchResultsSectionStyles,
                    children: [
                        primaryProduct === (0, $1yEFx.PrimaryProductKeys).Assets && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2nHbb.AssetsUnavailableBanner), {}),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $19BAV.default), {
                            requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                            children: [
                                (0, $aE5mL.isPreQueryState)(state) && ((0, $dh538.fg)('3p_bulk_connect') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1nJM3.ErrorBoundary), {
                                    section: "QuickFindSearchDialogBulkConnectBanner",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5Lref.BulkConnectBanner), {
                                                thirdPartyConfigs: thirdPartyConfigs,
                                                availableProducts: availableProducts,
                                                useNewlyConnectedProducts: (0, $dsrEB.useNewlyConnectedProducts),
                                                useLocalStorage: (0, $d5Ozh.useLocalStorageSearchPagePersistedState),
                                                useIsBulkConnectModalOpenQuickFind: (0, $4VmlX.useIsBulkConnectModalOpen),
                                                isOnSearchDialog: true
                                            }),
                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $NvPpA.BulkConnectModal), {
                                                isOnSearchDialog: true
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1nJM3.ErrorBoundary), {
                                    section: "QuickFindSearchDialogOAuthContainer",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5OFf.OAuthContainer), {
                                        isOnSearchDialog: true,
                                        thirdPartyConfigs: thirdPartyConfigs,
                                        availableProducts: availableProducts,
                                        isHello: isHello,
                                        useOAuthHandlers: (0, $gGFxq.useOAuthHandlers)
                                    })
                                })),
                                $71af45ffeeb47c72$export$50d89b0bfbd161a1(state, isAIEnabled) && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e79Fp.RovoTipBanner), {}),
                                (0, $aE5mL.isPostQueryState)(state) && (0, $dh538.fg)('quick_find_filters') && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cu2Tg.QuickFindFilters), {}),
                                (0, $aE5mL.isPostQueryLoadingOrResults)(state) && !(0, $dh538.fg)('quick_find_filters') && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2FGXW.ProductFilterHeader), {
                                    availableProducts: availableProducts
                                })
                            ]
                        }),
                        body
                    ]
                }),
                footer
            ]
        })
    });
};
const $71af45ffeeb47c72$var$useBody = (content)=>{
    const intl = (0, $dBxQj.default)();
    return (0, $gwFzn.useMemo)(()=>{
        if (!content) return [];
        const { state: state } = content;
        const items = [];
        const recentsHeadingItem = {
            id: 'recent-activities',
            type: 'heading',
            data: intl.formatMessage((0, $iUdW4.messages).recentsHeading)
        };
        const searchResultsHeadingItem = {
            id: 'search-results',
            type: 'heading',
            data: intl.formatMessage((0, $dh538.fg)('quick_find_user_shard_query') ? (0, $iUdW4.messages).forYou : (0, $iUdW4.messages).searchResultsHeading)
        };
        if (state === (0, $aE5mL.State).PREQUERY_ERROR) items.push({
            id: 'error',
            type: 'error'
        });
        if (state === (0, $aE5mL.State).PREQUERY_LOADING) {
            items.push(...content.recentQueries.slice(0, 3));
            items.push(recentsHeadingItem);
            for(let i = 0; i < 7; i++)items.push({
                id: `skeleton-${i}`,
                type: 'skeleton'
            });
        }
        if (state === (0, $aE5mL.State).PREQUERY_NO_RESULTS) items.push({
            id: 'landing',
            type: 'landing'
        });
        if (state === (0, $aE5mL.State).PREQUERY_RESULTS) {
            items.push(...content.recentQueries.slice(0, 3));
            if (content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                const filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 7);
                items.push(...filteredRecentActivities);
            }
        }
        if (state === (0, $aE5mL.State).POSTQUERY_ERROR) items.push({
            id: 'error',
            type: 'error'
        });
        if (state === (0, $aE5mL.State).POSTQUERY_LOADING) {
            if (content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                const filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 5);
                items.push(...filteredRecentActivities);
            }
            items.push({
                ...searchResultsHeadingItem,
                includeInAnalytics: false
            });
            for(let i = 0; i < 5; i++)items.push({
                id: `skeleton-${i}`,
                type: 'skeleton'
            });
        }
        if (state === (0, $aE5mL.State).POSTQUERY_NO_RESULTS) items.push({
            id: 'no-results',
            type: 'no-results'
        });
        if (state === (0, $aE5mL.State).POSTQUERY_RESULTS) {
            const dedupedSearchResults = content.searchResults.filter((searchResult)=>{
                const isDuplicate = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 5).some((recentlyViewedResult)=>{
                    const activityObject = recentlyViewedResult.data.node.object;
                    const id = (0, $hWR4v.isGraphActivity)(activityObject) ? activityObject.data?.id : recentlyViewedResult.id;
                    return id === searchResult.id;
                });
                return searchResult.id && !isDuplicate;
            });
            const filteredSearchResults = dedupedSearchResults.filter((result)=>!(0, $4TTdD.isSearchConfluenceSpace)(result.data));
            const confluenceSpaceResult = dedupedSearchResults.find((result)=>(0, $4TTdD.isSearchConfluenceSpace)(result.data));
            if (content.recentActivities.length > 0) {
                items.push(recentsHeadingItem);
                const filteredRecentActivities = content.recentActivities.filter((activity)=>activity.data.node.object.data !== null).slice(0, 5);
                items.push(...filteredRecentActivities);
            }
            const showSearchResultsSection = Boolean(dedupedSearchResults.length + content.peopleAndTeams.length + content.recentQueries.length);
            if (showSearchResultsSection) {
                items.push(searchResultsHeadingItem);
                items.push(...filteredSearchResults.slice(0, confluenceSpaceResult ? 5 : 6));
                confluenceSpaceResult && items.push(confluenceSpaceResult);
                items.push(...content.peopleAndTeams.slice(0, 2));
                items.push(...content.recentQueries.slice(0, 1));
            }
        }
        return items;
    }, [
        content,
        intl
    ]);
};
const $71af45ffeeb47c72$var$useAnalyticsEvents = (fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes)=>{
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent((0, $fr375.onSearchDialogShown)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        return ()=>{
            fireAnalyticsEvent((0, $iEwMm.onSearchDialogDismissed)({
                attributes: commonAttributes,
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
        };
    // Only want these events to fire when the dialog opens and closes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $71af45ffeeb47c72$var$useResetSessionAnalytics = ()=>{
    const { refreshSearchSessionId: refreshSearchSessionId } = (0, $j4ply.useBootstrapActions)();
    const { resetQueryVersion: resetQueryVersion } = (0, $djVCD.useSearchActions)();
    (0, $gwFzn.useEffect)(()=>{
        refreshSearchSessionId();
        resetQueryVersion();
    }, [
        refreshSearchSessionId,
        resetQueryVersion
    ]);
};
const $71af45ffeeb47c72$export$50d89b0bfbd161a1 = (state, isAIEnabled = false)=>{
    const isCorrectState = (0, $aE5mL.isPreQueryState)(state) || (0, $aE5mL.isPostQueryLoadingOrResults)(state);
    if ((0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25')) return isCorrectState && isAIEnabled;
    return isCorrectState;
};

});
parcelRegister("3R0ts", function(module, exports) {

$parcel$export(module.exports, "SEARCH_DIALOG_WIDTH_OBSERVER_ID", () => $979dcbe39352dbbd$export$194e5f2c2ebfcf47);
const $979dcbe39352dbbd$export$194e5f2c2ebfcf47 = 'quick-find-dialog';

});

parcelRegister("39Swq", function(module, exports) {

$parcel$export(module.exports, "Heading", () => $5cfb43da7e344c6a$export$a8a3e93435678ff9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $9wmQG = parcelRequire("9wmQG");
const $5cfb43da7e344c6a$var$containerStyles = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100'
});
const $5cfb43da7e344c6a$var$headingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    fontWeight: 'font.weight.semibold',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    width: '100%',
    padding: 'space.100',
    userSelect: 'none'
});
const $5cfb43da7e344c6a$export$a8a3e93435678ff9 = ({ id: id, text: text, includeInAnalytics: includeInAnalytics = true })=>{
    const headingWithoutAnalyticsWrapper = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $5cfb43da7e344c6a$var$containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $5cfb43da7e344c6a$var$headingStyles,
            children: text
        })
    });
    return includeInAnalytics ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9wmQG.SearchDialogHeaderAnalyticsWrapper), {
        id: id,
        children: headingWithoutAnalyticsWrapper
    }) : headingWithoutAnalyticsWrapper;
};

});

parcelRegister("iEwMm", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogDismissed", () => $57230a101297e6c3$export$bcff6baaecbbc96);
const $57230a101297e6c3$export$bcff6baaecbbc96 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'dismissed',
        actionSubject: `searchDialog`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("fr375", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogShown", () => $de62c0fb6467b42a$export$39e1d377a6a3de5d);
const $de62c0fb6467b42a$export$39e1d377a6a3de5d = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `searchDialog`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("5I2eK", function(module, exports) {

$parcel$export(module.exports, "onSearchResultsRendered", () => $71aa6db8e0b63681$export$ccb93b1cc213aa40);
const $71aa6db8e0b63681$export$ccb93b1cc213aa40 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'rendered',
        actionSubject: `searchResults`,
        actionSubjectId: `postQuerySearchResults`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("dSjat", function(module, exports) {

$parcel$export(module.exports, "getActionSubjectId", () => $6926da8980239f02$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "useQuickFindResultOnClick", () => $6926da8980239f02$export$8a7aec9b1f72e063);
$parcel$export(module.exports, "useQuickFindResultOnContextMenu", () => $6926da8980239f02$export$bc76edbc675e4404);
$parcel$export(module.exports, "useQuickFindResultOnHighlighted", () => $6926da8980239f02$export$3f21dcaf9a5530d9);
$parcel$export(module.exports, "useQuickFindFooterOnClick", () => $6926da8980239f02$export$eb0ecd911360e8d4);

var $gwFzn = parcelRequire("gwFzn");

var $1SV4e = parcelRequire("1SV4e");

var $2vZke = parcelRequire("2vZke");

var $782qq = parcelRequire("782qq");

var $dQShB = parcelRequire("dQShB");

var $3RYZm = parcelRequire("3RYZm");

var $aE5mL = parcelRequire("aE5mL");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $inrbX = parcelRequire("inrbX");
function $6926da8980239f02$export$b6f8db3ad0711b02(state) {
    switch(state){
        case (0, $aE5mL.State).PREQUERY_RESULTS:
            return 'preQuerySearchResults';
        case (0, $aE5mL.State).PREQUERY_LOADING:
            return 'preQueryLoadingSearchResults';
        case (0, $aE5mL.State).POSTQUERY_LOADING:
            return 'cachedResults';
        case (0, $aE5mL.State).POSTQUERY_RESULTS:
            return 'postQuerySearchResults';
        default:
            return '';
    }
}
const $6926da8980239f02$export$8a7aec9b1f72e063 = ()=>{
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $gwFzn.useCallback)((props)=>{
        const { event: event, data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes, options: options } = props;
        const { addCurrentQueryAsRecentQuery: addCurrentQueryAsRecentQuery = true } = options || {};
        const newTab = event && (event.ctrlKey || event.metaKey || event.shiftKey);
        if (!newTab) setQuickFindOpen(false);
        if (addCurrentQueryAsRecentQuery) {
            const trimmedInuptQuery = quickFindQuery.trim();
            if (trimmedInuptQuery !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)(trimmedInuptQuery, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
        }
        const actionSubjectId = $6926da8980239f02$export$b6f8db3ad0711b02(state);
        fireAnalyticsEvent((0, $3RYZm.onSearchDialogResultSelected)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        quickFindQuery,
        nonPrivacySafeAttributes,
        primaryProduct,
        setQuickFindOpen,
        updateRecentQueries,
        user
    ]);
};
const $6926da8980239f02$export$bc76edbc675e4404 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $gwFzn.useCallback)((props)=>{
        const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes } = props;
        const actionSubjectId = $6926da8980239f02$export$b6f8db3ad0711b02(state);
        fireAnalyticsEvent((0, $782qq.onSearchDialogResultContextMenuOpened)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes
    ]);
};
const $6926da8980239f02$export$3f21dcaf9a5530d9 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $gwFzn.useCallback)((props)=>{
        const { data: data, state: state, additionalAnalyticsAttributes: additionalAnalyticsAttributes } = props;
        const actionSubjectId = $6926da8980239f02$export$b6f8db3ad0711b02(state);
        fireAnalyticsEvent((0, $dQShB.onSearchDialogResultHighlighted)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                ...additionalAnalyticsAttributes,
                ...data
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes
    ]);
};
const $6926da8980239f02$export$eb0ecd911360e8d4 = ()=>{
    const [user] = (0, $j4ply.useUser)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    return (0, $gwFzn.useCallback)((props)=>{
        const { event: event, state: state, options: options, actionSubjectId: actionSubjectId } = props;
        const { addCurrentQueryAsRecentQuery: addCurrentQueryAsRecentQuery = true } = options || {};
        const newTab = event.ctrlKey || event.metaKey || event.shiftKey;
        if (!newTab) setQuickFindOpen(false);
        if (addCurrentQueryAsRecentQuery) {
            const trimmedInputQuery = quickFindQuery.trim();
            if (trimmedInputQuery !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)(trimmedInputQuery, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
        }
        if (!primaryProduct) return;
        fireAnalyticsEvent((0, $2vZke.onAdvancedSearchLinkSelected)({
            actionSubjectId: actionSubjectId,
            attributes: {
                ...commonAttributes,
                trigger: 'click',
                newTab: newTab,
                isLoading: state === (0, $aE5mL.State).PREQUERY_LOADING || state === (0, $aE5mL.State).POSTQUERY_LOADING
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        quickFindQuery,
        nonPrivacySafeAttributes,
        primaryProduct,
        setQuickFindOpen,
        updateRecentQueries,
        user
    ]);
};

});
parcelRegister("2vZke", function(module, exports) {

$parcel$export(module.exports, "onAdvancedSearchLinkSelected", () => $b2e1078ac279219a$export$50f1b1860bee88e0);
const $b2e1078ac279219a$export$50f1b1860bee88e0 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, actionSubjectId: actionSubjectId })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'advancedSearchLink',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("782qq", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogResultContextMenuOpened", () => $bb6e90fe17bdbf50$export$4d9e9e3a052b2865);
const $bb6e90fe17bdbf50$export$4d9e9e3a052b2865 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'contextMenu opened',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("dQShB", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogResultHighlighted", () => $a6985f2e364fb5e8$export$d17f8c02a91cd2a5);
const $a6985f2e364fb5e8$export$d17f8c02a91cd2a5 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'ui',
        action: 'highlighted',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("3RYZm", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogResultSelected", () => $dd727cd9033cfd92$export$1d3be7f4bb8882c3);
const $dd727cd9033cfd92$export$1d3be7f4bb8882c3 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'searchResult',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});


parcelRegister("2nHbb", function(module, exports) {

$parcel$export(module.exports, "AssetsUnavailableBanner", () => $0028c77a13fa2c26$export$d2e895abf2051d81);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $2Nwuj = parcelRequire("2Nwuj");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $aoVih = parcelRequire("aoVih");

var $4VmlX = parcelRequire("4VmlX");

var $kCOhL = parcelRequire("kCOhL");
const $0028c77a13fa2c26$export$d2e895abf2051d81 = ()=>{
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $0028c77a13fa2c26$var$containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aoVih.default), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $kCOhL.messages).assetsUnavailableMessage,
                values: {
                    bold: (chunks)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                            weight: 'bold',
                            children: chunks
                        }),
                    searchLink: (chunks)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
                            href: '/jira/assets?showSearch=true',
                            onClick: ()=>setQuickFindOpen(false),
                            children: chunks
                        })
                }
            })
        })
    });
};
const $0028c77a13fa2c26$var$containerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});

});
parcelRegister("kCOhL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $be39043139f18c46$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $be39043139f18c46$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    assetsUnavailableMessage: {
        id: "search_dialog_assets_unavailable_message",
        defaultMessage: "<bold>Assets</bold> will be available here soon. For now, try <searchLink>Assets search</searchLink>."
    }
});

});


parcelRegister("e79Fp", function(module, exports) {

$parcel$export(module.exports, "RovoTipBanner", () => $238c7f3a77e6e665$export$4d99a070549a9300);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $1qfLF = parcelRequire("1qfLF");

var $3HOqx = parcelRequire("3HOqx");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $4SPhZ = parcelRequire("4SPhZ");

var $5tPRL = parcelRequire("5tPRL");
var $dfZ5P = parcelRequire("dfZ5P");

var $j4ply = parcelRequire("j4ply");

var $8drE0 = parcelRequire("8drE0");
const $238c7f3a77e6e665$var$RovoTipMessageStyle = (0, $ecnYn.xcss)({
    width: '95%',
    marginLeft: 'space.050',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050'
});
const $238c7f3a77e6e665$var$RovoTipContainerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $238c7f3a77e6e665$var$RovoTipStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: `${"var(--ds-space-500, 40px)"}`,
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    borderRadius: `${"var(--ds-space-050, 4px)"}`,
    backgroundColor: 'color.background.accent.purple.subtlest',
    color: 'color.text.accent.purple'
});
const $238c7f3a77e6e665$export$4d99a070549a9300 = ()=>{
    const [showRovoTip, setShowRovoTip] = (0, $gwFzn.useState)(false);
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    (0, $gwFzn.useEffect)(()=>{
        if (!primaryProduct || !user || !user.id) return;
        const rovoTipFromLocalStorage = (0, $4SPhZ.getRovoTip)(primaryProduct, user.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        primaryProduct,
        user
    ]);
    const dismissRovoTip = (0, $gwFzn.useCallback)(()=>{
        if (!primaryProduct || !user || !user.id) return;
        const rovoTipFromLocalStorage = (0, $4SPhZ.setRovoTip)(primaryProduct, user.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        primaryProduct,
        user
    ]);
    if (!showRovoTip) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $238c7f3a77e6e665$var$RovoTipContainerStyle,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            xcss: $238c7f3a77e6e665$var$RovoTipStyle,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                    label: "blank",
                    color: "var(--ds-text-accent-purple, #5E4DB2)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $238c7f3a77e6e665$var$RovoTipMessageStyle,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("b", {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $8drE0.messages).rovoTip
                            })
                        }),
                        ' ',
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $8drE0.messages).rovoBannerMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        icon: (0, $dfZ5P.RemoveIcon),
                        spacing: 'compact',
                        onClick: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            dismissRovoTip();
                        },
                        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $8drE0.messages).dismissBannerLabel
                        }),
                        appearance: 'subtle'
                    })
                })
            ]
        })
    });
};

});
parcelRegister("4SPhZ", function(module, exports) {

$parcel$export(module.exports, "getRovoTip", () => $801ec4174110d9b1$export$b9330795d9444727);
$parcel$export(module.exports, "setRovoTip", () => $801ec4174110d9b1$export$297a6fb093b042a3);
const $801ec4174110d9b1$export$568e0ce3cc5a9972 = 'atlassian.unified-search.quick-find-rovo-tip';
const $801ec4174110d9b1$export$4bac6b574c2c1d97 = 'anonymous-user';
const $801ec4174110d9b1$export$b9330795d9444727 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $801ec4174110d9b1$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = $801ec4174110d9b1$var$getLocalStorageItem($801ec4174110d9b1$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    const rovoTipProducts = rovoTip[userIdOrAnonymous] || {};
    return rovoTipProducts[productId] === undefined ? true : rovoTipProducts[productId];
};
const $801ec4174110d9b1$export$297a6fb093b042a3 = (productId, userId)=>{
    const userIdOrAnonymous = userId || $801ec4174110d9b1$export$4bac6b574c2c1d97;
    const quickFindRovoTipRaw = $801ec4174110d9b1$var$getLocalStorageItem($801ec4174110d9b1$export$568e0ce3cc5a9972);
    const rovoTip = quickFindRovoTipRaw ? JSON.parse(quickFindRovoTipRaw) : {};
    if (!rovoTip[userIdOrAnonymous]) rovoTip[userIdOrAnonymous] = {};
    rovoTip[userIdOrAnonymous][productId] = false;
    $801ec4174110d9b1$var$setLocalStorageItem($801ec4174110d9b1$export$568e0ce3cc5a9972, JSON.stringify(rovoTip));
    return rovoTip[userIdOrAnonymous][productId];
};
const $801ec4174110d9b1$var$setLocalStorageItem = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $801ec4174110d9b1$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};

});

parcelRegister("5tPRL", function(module, exports) {

$parcel$export(module.exports, "ResultLink", () => $d4baf0504b42b38c$export$d0a8235d2583609);
$parcel$export(module.exports, "ResultContentWrapper", () => $d4baf0504b42b38c$export$87a308048e18f5d7);
$parcel$export(module.exports, "EnlargedResultContentWrapper", () => $d4baf0504b42b38c$export$e10965f6350456f8);
$parcel$export(module.exports, "ReturnIconContainer", () => $d4baf0504b42b38c$export$b7244afbfdf4cb9a);
$parcel$export(module.exports, "EnlargedReturnIconContainer", () => $d4baf0504b42b38c$export$cc248e72bc9d7b85);
$parcel$export(module.exports, "IconContainer", () => $d4baf0504b42b38c$export$8f314e512d92575f);
$parcel$export(module.exports, "EnlargedIconContainer", () => $d4baf0504b42b38c$export$ca5c00fa71c2e27e);
$parcel$export(module.exports, "ResultTitleContainer", () => $d4baf0504b42b38c$export$9c613d6c52df949a);
$parcel$export(module.exports, "EnlargedResultTitleContainer", () => $d4baf0504b42b38c$export$e97ece467686c93c);
$parcel$export(module.exports, "ResultLabel", () => $d4baf0504b42b38c$export$a999164f6ebc756c);
$parcel$export(module.exports, "ResultDetail", () => $d4baf0504b42b38c$export$b695f824f00c1cb0);
$parcel$export(module.exports, "CollapsedResultDetail", () => $d4baf0504b42b38c$export$addf7aa0f753bbe8);
$parcel$export(module.exports, "EnlargedCollapsedResultDetail", () => $d4baf0504b42b38c$export$a44951d703db9a17);
$parcel$export(module.exports, "EnlargedResultTitleContainerSkeleton", () => $d4baf0504b42b38c$export$c571ffd341b1e6fe);
$parcel$export(module.exports, "EnlargedResultDetail", () => $d4baf0504b42b38c$export$c8ec38cc79b76eaa);
$parcel$export(module.exports, "EnlargedResultDetailSkeleton", () => $d4baf0504b42b38c$export$a15ed502bc39849a);
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $d4baf0504b42b38c$export$43a2b5c94cb85d9c);
$parcel$export(module.exports, "EnlargedCollapsedResultDetailWrapper", () => $d4baf0504b42b38c$export$2dfb537c5a7f8cc3);
$parcel$export(module.exports, "DetailsSeparator", () => $d4baf0504b42b38c$export$35507434feaa4496);
$parcel$export(module.exports, "CollapsedResultContentWrapper", () => $d4baf0504b42b38c$export$ee32d1086c278cfc);
$parcel$export(module.exports, "EnlargedSkeletonIcon", () => $d4baf0504b42b38c$export$3c77a9b2eee1dfc5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");

var $kPBHE = parcelRequire("kPBHE");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $d4baf0504b42b38c$export$d0a8235d2583609 = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "e8crcwv0"
})({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.primaryTextColour),
    '&:hover': {
        textDecoration: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $2azjJ.primaryTextColour)
    },
    '&:focus': {
        outlineOffset: '-2px'
    },
    '&:visited': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $2azjJ.primaryTextColour),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.SearchDialogResultTitle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: (0, $2azjJ.visitedLinkColor)
        }
    }
});
const $d4baf0504b42b38c$export$87a308048e18f5d7 = (0, $gwrgp.default)("div", {
    target: "e8crcwv1"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2azjJ.grid).multiple(props.isCollapsed ? 5 : 4).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $2azjJ.grid).twice().px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $2azjJ.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $2azjJ.itemHighlightColor)
        }
    }));
const $d4baf0504b42b38c$export$e10965f6350456f8 = (0, $gwrgp.default)("div", {
    target: "e8crcwv2"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-space-075, 6px)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $2azjJ.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $2azjJ.itemHighlightColor)
        }
    }));
const $d4baf0504b42b38c$export$b7244afbfdf4cb9a = (0, $gwrgp.default)("div", {
    target: "e8crcwv3"
})((props)=>({
        borderRadius: '3px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: (0, $2azjJ.grid).half().px,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $2azjJ.grid).multiple(3).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $2azjJ.grid).twice().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: (0, $2azjJ.grid).multiple(1.5).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: props.isCollapsed ? (0, $2azjJ.grid).px : (0, $2azjJ.grid).half().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isKeyboardHighlighted ? 1 : 0
    }));
const $d4baf0504b42b38c$export$cc248e72bc9d7b85 = (0, $gwrgp.default)("div", {
    target: "e8crcwv4"
})({
    name: "1l17wfx",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px);"
});
const $d4baf0504b42b38c$export$d84276b3ae03593f = /*#__PURE__*/ (0, $gwrgp.default)($d4baf0504b42b38c$export$b7244afbfdf4cb9a, {
    target: "e8crcwv5"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).multiple(2.5).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $2azjJ.grid).multiple(2.5).px,
    opacity: 1
});
const $d4baf0504b42b38c$export$8f314e512d92575f = (0, $gwrgp.default)("div", {
    target: "e8crcwv6"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $2azjJ.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flex: `0 0 ${(0, $2azjJ.grid).twice().px}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $2azjJ.grid).twice().px,
    display: 'flex',
    alignItems: 'center'
});
const $d4baf0504b42b38c$export$ca5c00fa71c2e27e = (0, $gwrgp.default)("div", {
    target: "e8crcwv7"
})({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: "var(--ds-space-100, 8px)",
    flex: `0 0 ${"var(--ds-space-300, 24px)"}`,
    display: 'flex',
    alignItems: 'center'
});
const $d4baf0504b42b38c$export$9c613d6c52df949a = (0, $gwrgp.default)("div", {
    target: "e8crcwv8"
})((0, $2azjJ.nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, $2azjJ.grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, $2azjJ.primaryTextColour), ";@media screen and (max-width:", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;}");
const $d4baf0504b42b38c$export$e97ece467686c93c = (0, $gwrgp.default)("div", {
    target: "e8crcwv9"
})((0, $2azjJ.nowrapEllipsis), " line-height:14px;flex:1 0 auto;color:", (0, $2azjJ.primaryTextColour), ";height:16px;@media screen and (max-width:", (0, $2azjJ.dialogPageTakeoverWidth), "px){width:100%;}width:90%;");
const $d4baf0504b42b38c$export$a999164f6ebc756c = (0, $gwrgp.default)("span", {
    target: "e8crcwv10"
})((0, $2azjJ.nowrapEllipsis), {
    color: "var(--ds-text-subtle, #5E6C84)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $2azjJ.grid).px
});
const $d4baf0504b42b38c$export$b695f824f00c1cb0 = (0, $gwrgp.default)("div", {
    target: "e8crcwv11"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $2azjJ.grid).multiple(3).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $2azjJ.grid).multiple(19).px
});
const $d4baf0504b42b38c$export$addf7aa0f753bbe8 = (0, $gwrgp.default)("div", {
    target: "e8crcwv12"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $d4baf0504b42b38c$export$a44951d703db9a17 = (0, $gwrgp.default)("div", {
    target: "e8crcwv13"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});
const $d4baf0504b42b38c$export$c571ffd341b1e6fe = (0, $gwrgp.default)("div", {
    target: "e8crcwv14"
})({
    maxWidth: '100%',
    width: '256px',
    height: '14px',
    marginBottom: "var(--ds-space-025, 2px)",
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
});
const $d4baf0504b42b38c$export$c8ec38cc79b76eaa = (0, $gwrgp.default)("div", {
    target: "e8crcwv15"
})((0, $2azjJ.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    maxWidth: "'initial'",
    minWidth: 'fit-content',
    marginLeft: "var(--ds-space-150, 12px)"
});
const $d4baf0504b42b38c$export$a15ed502bc39849a = (0, $gwrgp.default)("div", {
    target: "e8crcwv16"
})({
    maxWidth: '100%',
    width: '100px',
    height: '12px',
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
});
const $d4baf0504b42b38c$export$43a2b5c94cb85d9c = (0, $gwrgp.default)("div", {
    target: "e8crcwv17"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $2azjJ.grid).multiple(54).px
});
const $d4baf0504b42b38c$export$2dfb537c5a7f8cc3 = (0, $gwrgp.default)("div", {
    target: "e8crcwv18"
})({
    name: "jn0r0q",
    styles: "display:flex;width:90%;"
});
const $d4baf0504b42b38c$export$35507434feaa4496 = (0, $gwrgp.default)("div", {
    target: "e8crcwv19"
})({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2azjJ.grid).px}`
});
const $d4baf0504b42b38c$export$ee32d1086c278cfc = (0, $gwrgp.default)("div", {
    target: "e8crcwv20"
})({
    name: "1a9l0m2",
    styles: "display:block;min-width:0;flex-grow:1;"
});
const $d4baf0504b42b38c$export$2cacbb382e8a2ce4 = (0, $gwrgp.default)("button", {
    target: "e8crcwv21"
})({
    name: "1qpf3mh",
    styles: "background-color:transparent;border:none;cursor:pointer;padding:0;width:100%;text-align:left;"
});
const $d4baf0504b42b38c$export$3c77a9b2eee1dfc5 = (0, $gwrgp.default)("div", {
    target: "e8crcwv22"
})({
    width: '100%',
    height: '100%',
    borderRadius: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-skeleton, ${(0, $6fnsQ.N20A)})`
});

});
parcelRegister("kPBHE", function(module, exports) {

$parcel$export(module.exports, "Link", () => $1e87bb95c8c7b16d$export$a6c7ac8248d6e38a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $1e87bb95c8c7b16d$export$a6c7ac8248d6e38a = ({ linkComponent: linkComponent, ...props })=>{
    // Hack?
    const Component = linkComponent || 'a';
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ...props
    });
};

});


parcelRegister("8drE0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $57957bf3159c123e$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $57957bf3159c123e$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    rovoTip: {
        id: "search_dialog_rovo_tip",
        defaultMessage: "Rovo tip:"
    },
    dismissBannerLabel: {
        id: "search_dialog_dismiss_banner_label",
        defaultMessage: "Dismiss banner"
    },
    rovoBannerMessage: {
        id: "search_dialog_rovo_banner_message",
        defaultMessage: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer"
    }
});

});


parcelRegister("cuvog", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $92cb390251785e80$export$2e0a83ec2e27ecbb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $92cb390251785e80$var$dividerStyles = (0, $ecnYn.xcss)({
    height: '0',
    width: '100%',
    borderTop: '1px solid',
    borderColor: 'color.border'
});
const $92cb390251785e80$export$2e0a83ec2e27ecbb = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $92cb390251785e80$var$dividerStyles
    });
};

});

parcelRegister("47juE", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $5e4b8c366d6ef407$export$42f84e610f279c31);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $2W0qg = parcelRequire("2W0qg");

var $8u7zP = parcelRequire("8u7zP");

var $inrbX = parcelRequire("inrbX");

var $iKNBc = parcelRequire("iKNBc");

const $5e4b8c366d6ef407$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("aKipV")));
const $5e4b8c366d6ef407$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $5e4b8c366d6ef407$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $5e4b8c366d6ef407$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $5e4b8c366d6ef407$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $5e4b8c366d6ef407$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    font: 'font.body',
    color: 'color.link',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $5e4b8c366d6ef407$export$42f84e610f279c31 = ({ onRetry: onRetry })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent((0, $8u7zP.onSearchDialogErrorShown)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    // Same as other analytics events, we only want this to fire when the screen displays
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $5e4b8c366d6ef407$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $5e4b8c366d6ef407$var$imageFallbackStyles
                }),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($5e4b8c366d6ef407$var$Image, {})
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $5e4b8c366d6ef407$var$headingStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $iKNBc.messages).errorSearchHeading
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $5e4b8c366d6ef407$var$bodyStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $iKNBc.messages).errorSearchBody,
                    values: {
                        button: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
                                xcss: $5e4b8c366d6ef407$var$pressableStyles,
                                onClick: onRetry,
                                children: s
                            })
                    }
                })
            })
        ]
    });
};

});
parcelRegister("8u7zP", function(module, exports) {

$parcel$export(module.exports, "onSearchDialogErrorShown", () => $c81ca25909252d74$export$8657eff97a198097);
const $c81ca25909252d74$export$8657eff97a198097 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'ui',
        action: 'shown',
        actionSubject: `searchDialogError`,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("iKNBc", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7e87035b4b825004$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $7e87035b4b825004$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    errorSearchHeading: {
        id: "search_dialog_error_search_heading",
        defaultMessage: "We're having trouble loading your recently viewed content."
    },
    errorSearchBody: {
        id: "search_dialog_error_search_body",
        defaultMessage: "It might just be a hiccup. Please try refreshing the page or <button>try again</button>."
    }
});

});

parcelRegister("aKipV", function(module, exports) {

let $7d2c7c8baa46136b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7d2c7c8baa46136b$var$load("4KiYL").then(()=>parcelRequire('9Wb1k'));

});


parcelRegister("d6thU", function(module, exports) {

$parcel$export(module.exports, "FeedbackFooter", () => $67539e0ab092f04e$export$e7b87342306a8337);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $8UOsA = parcelRequire("8UOsA");

var $7Yuqm = parcelRequire("7Yuqm");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $heoiU = parcelRequire("heoiU");
const $67539e0ab092f04e$var$footerContainerStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.150',
    paddingBlockEnd: 'space.150',
    paddingInlineStart: 'space.200',
    paddingInlineEnd: 'space.200',
    color: 'color.text',
    gap: 'space.150'
});
const $67539e0ab092f04e$export$e7b87342306a8337 = ()=>{
    const [feedbackIsOpen, { setIsFeedbackModalOpen: setIsFeedbackModalOpen }] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const [isHello] = (0, $j4ply.useIsHello)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [selectedProducts] = (0, $djVCD.useSelectedProducts)();
    const [user] = (0, $j4ply.useUser)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: $67539e0ab092f04e$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $heoiU.messages).feedbackFooter
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UOsA.FeedbackButton), {
                onClick: (e)=>{
                    e.preventDefault();
                    setIsFeedbackModalOpen(true);
                }
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7Yuqm.default), {
                cloudId: cloudId || '',
                experimentConfig: experimentConfig,
                isHello: isHello,
                isOpen: feedbackIsOpen,
                primaryProduct: primaryProduct || '',
                product: selectedProducts.length ? selectedProducts.join(', ') : 'no product filter',
                setIsOpen: setIsFeedbackModalOpen,
                source: "quick-find",
                userId: user.id || '',
                userName: user.name || '',
                mode: applicationMode
            })
        ]
    });
};

});
parcelRegister("heoiU", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5514968f55e57b26$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $5514968f55e57b26$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    feedbackFooter: {
        id: "search_dialog_feedback_footer",
        defaultMessage: "Help us improve search"
    }
});

});


parcelRegister("cu2Tg", function(module, exports) {

$parcel$export(module.exports, "QuickFindFilters", () => $b21d47feb05d9034$export$cc5615a202a2ea8c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $isYda = parcelRequire("isYda");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $3R0ts = parcelRequire("3R0ts");

var $86ob4 = parcelRequire("86ob4");

var $djVCD = parcelRequire("djVCD");

var $5xYfl = parcelRequire("5xYfl");

var $9Pz4M = parcelRequire("9Pz4M");

var $9fB7u = parcelRequire("9fB7u");
const $b21d47feb05d9034$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInline: 'space.200',
    paddingBlockStart: 'space.025',
    paddingBlockEnd: 'space.075'
});
const $b21d47feb05d9034$var$filterDropdownIconStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    marginInlineEnd: 'space.100'
});
const $b21d47feb05d9034$export$cc5615a202a2ea8c = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const isDialogAbove275px = dialogWidth > 275;
    const displayCustomizeIcon = isDialogAbove275px || !selectedProduct;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $b21d47feb05d9034$var$containerStyles,
        children: [
            displayCustomizeIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $b21d47feb05d9034$var$filterDropdownIconStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                    label: formatMessage((0, $9fB7u.i18n).filterByIcon)
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5xYfl.InlineAppSelector), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Pz4M.InlineProductFilters), {})
        ]
    });
};

});
parcelRegister("5xYfl", function(module, exports) {

$parcel$export(module.exports, "InlineAppSelector", () => $e1138a05237425a8$export$863a72861bb447a2);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $eWgaW = parcelRequire("eWgaW");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $3gadb = parcelRequire("3gadb");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $eoZmS = parcelRequire("eoZmS");

var $5FKsO = parcelRequire("5FKsO");

var $a5OFf = parcelRequire("a5OFf");

var $5xGHP = parcelRequire("5xGHP");

var $1nJM3 = parcelRequire("1nJM3");

var $gGFxq = parcelRequire("gGFxq");

var $inrbX = parcelRequire("inrbX");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $1FKBY = parcelRequire("1FKBY");

var $9g3OD = parcelRequire("9g3OD");
const $e1138a05237425a8$var$inlineFilterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $e1138a05237425a8$var$inlineFilterSeparator = (0, $ecnYn.xcss)({
    width: '1px',
    height: '29px',
    // As specified in the designs
    alignSelf: 'center',
    borderRight: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $e1138a05237425a8$var$AppButtonFor3PApps = ({ productKey: productKey, redirectToFPSWithProductSelected: redirectToFPSWithProductSelected, trigger: trigger })=>{
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const isSmartlink = (0, $a5OFf.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.useIsUserOAuthed)(productKey);
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    if (userNeedsOAuth) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "QuickFindAppButtonFor3PAppsOAuthWrapper",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eoZmS.OAuthWarningWrapper), {
            product: productKey,
            postAuthAction: ()=>{
                redirectToFPSWithProductSelected();
            },
            trigger: (triggerProps)=>trigger({
                    ...triggerProps,
                    userNeedsAuth: true
                }),
            isOnSearchDialog: true,
            useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
            useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
            isSmartlink: isSmartlink,
            searchQuery: quickFindQuery
        }, productKey)
    });
    return trigger({
        userNeedsAuth: false
    });
};
const $e1138a05237425a8$export$863a72861bb447a2 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { selectProductFilter: selectProductFilter } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { apps1PToDisplay: apps1PToDisplay, apps3PToDisplay: apps3PToDisplay, isDialogAbove400px: isDialogAbove400px, isDialogAbove450px: isDialogAbove450px, primaryProduct: primaryProduct, selectedProduct: selectedProduct } = (0, $9g3OD.useInlineAppSelector)();
    const onAppFilterSelected = (productKey, options)=>{
        const newSelectedProduct = selectedProduct === productKey ? undefined : productKey;
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: productKey,
            action: newSelectedProduct === undefined ? 'unselected' : 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: options.isPostAuthAction,
                isRedirectedToFPS: options.redirectToFPS
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        if (!options.redirectToFPS) {
            selectProductFilter(newSelectedProduct);
            return;
        }
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push');
        setQuickFindOpen(false);
    };
    const apps3pComponent = apps3PToDisplay.map(({ productKey: productKey, productConfig: productConfig })=>{
        const Icon = productConfig.Icon;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: formatMessage((0, $1FKBY.i18n).appTooltipFor3PApps, {
                productName: productConfig.displayName
            }),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($e1138a05237425a8$var$AppButtonFor3PApps, {
                productKey: productKey,
                productConfig: productConfig,
                redirectToFPSWithProductSelected: ()=>onAppFilterSelected(productKey, {
                        redirectToFPS: true,
                        isPostAuthAction: true
                    }),
                trigger: ({ triggerProps: triggerProps, userNeedsAuth: userNeedsAuth })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5FKsO.FilterButton), {
                        ...triggerProps,
                        contentFit: isDialogAbove450px ? 'default' : 'compact',
                        iconAfter: !userNeedsAuth && /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWgaW))), {
                            label: formatMessage((0, $1FKBY.i18n).externalLinkIconLabel),
                            color: "currentColor"
                        }),
                        iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
                            size: "small"
                        }),
                        isSelected: false,
                        onClick: ()=>{
                            if (!userNeedsAuth) onAppFilterSelected(productKey, {
                                redirectToFPS: true,
                                isPostAuthAction: false
                            });
                        },
                        spacing: !userNeedsAuth || isDialogAbove400px ? 'default' : 'compact',
                        children: isDialogAbove400px && productConfig.displayName
                    })
            }, productKey)
        }, productKey);
    });
    const apps1PComponent = apps1PToDisplay.map(({ productKey: productKey, productConfig: productConfig, redirectToFPS: redirectToFPS })=>{
        const AppIcon = productConfig.Icon;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5FKsO.FilterButton), {
            "aria-current": selectedProduct === productKey,
            contentFit: isDialogAbove450px ? 'default' : 'compact',
            iconAfter: redirectToFPS && /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWgaW))), {
                label: formatMessage((0, $1FKBY.i18n).externalLinkIconLabel),
                color: "currentColor"
            }),
            iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)(AppIcon, {
                size: "small"
            }),
            isSelected: selectedProduct === productKey,
            onClick: ()=>onAppFilterSelected(productKey, {
                    redirectToFPS: redirectToFPS,
                    isPostAuthAction: false
                }),
            spacing: isDialogAbove400px ? 'default' : 'compact',
            children: isDialogAbove400px && productConfig.displayName
        }, productKey);
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        testId: "qf-inline-app-selector",
        xcss: $e1138a05237425a8$var$inlineFilterStyles,
        children: [
            primaryProduct === (0, $1yEFx.PrimaryProductKeys).Confluence && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    apps1PComponent,
                    apps3pComponent
                ]
            }),
            primaryProduct !== (0, $1yEFx.PrimaryProductKeys).Confluence && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    apps3pComponent,
                    apps1PComponent
                ]
            }),
            selectedProduct && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $e1138a05237425a8$var$inlineFilterSeparator
            })
        ]
    });
};

});
parcelRegister("5FKsO", function(module, exports) {

$parcel$export(module.exports, "FilterButton", () => $0c4269204833e8a1$export$fb46dd9777cc6db0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");
const $0c4269204833e8a1$var$defaultFilterButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075',
    color: 'color.text.subtle',
    borderRadius: '4px',
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    minHeight: '32px',
    // As specified on Figma
    maxWidth: '164px',
    // As specified on Figma
    backgroundColor: 'color.background.neutral.subtle',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $0c4269204833e8a1$var$compactContentFitStyles = (0, $ecnYn.xcss)({
    maxWidth: '113px' // As specified on Figma
});
const $0c4269204833e8a1$var$minWidthZeroStyles = (0, $ecnYn.xcss)({
    minWidth: '0' // Allow the button to shrink as much as possible
});
const $0c4269204833e8a1$var$filterButtonSelectedStateStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $0c4269204833e8a1$var$compactSpacingStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.050'
});
const $0c4269204833e8a1$var$filterButtonContentStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $0c4269204833e8a1$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(function FilterButton({ children: children, contentFit: contentFit = 'default', iconAfter: iconAfter, iconBefore: iconBefore, isSelected: isSelected, minWidthZero: minWidthZero = false, spacing: spacing = 'default', ...pressableProps }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2W0qg.default), {
        ...pressableProps,
        ref: ref,
        xcss: [
            $0c4269204833e8a1$var$defaultFilterButtonStyles,
            isSelected && $0c4269204833e8a1$var$filterButtonSelectedStateStyles,
            spacing === 'compact' && $0c4269204833e8a1$var$compactSpacingStyles,
            contentFit === 'compact' && $0c4269204833e8a1$var$compactContentFitStyles,
            minWidthZero && $0c4269204833e8a1$var$minWidthZeroStyles
        ],
        children: [
            iconBefore,
            children && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0c4269204833e8a1$var$filterButtonContentStyles,
                children: children
            }),
            iconAfter
        ]
    });
});

});

parcelRegister("5xGHP", function(module, exports) {

$parcel$export(module.exports, "onAppFilterSelect", () => $00b64bc742da3325$export$abf7f7ce81b5b4bb);
const $00b64bc742da3325$export$abf7f7ce81b5b4bb = ({ action: action, actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: action,
        actionSubject: 'appSelector',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("1FKBY", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $1aa60baca70ed4d4$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $1aa60baca70ed4d4$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    externalLinkIconLabel: {
        id: "inline-app-selector.external-link-icon.label",
        defaultMessage: "External Link Icon"
    },
    appTooltipFor3PApps: {
        id: "inline-app-selector.3p-app-tooltip",
        defaultMessage: "Open a full page search for this term filtered by {productName} results"
    }
});

});

parcelRegister("9g3OD", function(module, exports) {

$parcel$export(module.exports, "useInlineAppSelector", () => $9fbf3b40278c59cd$export$6b2b316097ae586c);

var $gwFzn = parcelRequire("gwFzn");

var $l8wXo = parcelRequire("l8wXo");

var $kZ0dZ = parcelRequire("kZ0dZ");

var $9yyKc = parcelRequire("9yyKc");

var $1yEFx = parcelRequire("1yEFx");

var $3R0ts = parcelRequire("3R0ts");

var $86ob4 = parcelRequire("86ob4");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");
// TODO: Render dynamic 1P products, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$supported1PApps = (primaryProduct)=>{
    if (!primaryProduct) return [];
    switch(primaryProduct){
        case (0, $1yEFx.PrimaryProductKeys).Confluence:
            return [
                {
                    productKey: (0, $1yEFx.ProductKeys).Confluence,
                    redirectToFPS: false
                }
            ];
        default:
            return [
                {
                    productKey: (0, $1yEFx.ProductKeys).Confluence,
                    redirectToFPS: true
                },
                {
                    productKey: (0, $1yEFx.ProductKeys).Jira,
                    redirectToFPS: true
                }
            ];
    }
};
// TODO: Render dynamic 1P products, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$supported3PApps = [
    (0, $1yEFx.ProductKeys).GoogleDrive,
    (0, $1yEFx.ProductKeys).Slack
];
// TODO: Render the icons based on configuration, hardcoded for now for Team 25
const $9fbf3b40278c59cd$var$appSelectorIcons = {
    [(0, $1yEFx.ProductKeys).GoogleDrive]: (0, $9yyKc.RovoLogoFromSVG)((0, $l8wXo.GoogleDriveAppSelectorIcon)),
    [(0, $1yEFx.ProductKeys).Slack]: (0, $9yyKc.RovoLogoFromSVG)((0, $kZ0dZ.SlackAppSelectorIcon))
};
const $9fbf3b40278c59cd$export$6b2b316097ae586c = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const dialogWidth = (0, $86ob4.useElementWidth)((0, $3R0ts.SEARCH_DIALOG_WIDTH_OBSERVER_ID));
    const isDialogAbove400px = dialogWidth > 400;
    const isDialogAbove450px = dialogWidth > 450;
    const apps3PToDisplay = (0, $gwFzn.useMemo)(()=>$9fbf3b40278c59cd$var$supported3PApps.filter((supported3PApp)=>availableProducts.includes(supported3PApp)).filter((_)=>!selectedProduct).map((productKey)=>({
                productKey: productKey,
                productConfig: productConfigs[productKey]
            }))// TODO: Remove the following Icon override of the icons when we render the icons based on a configuration
        .map(({ productKey: productKey, productConfig: productConfig })=>({
                productKey: productKey,
                productConfig: {
                    ...productConfig,
                    ...$9fbf3b40278c59cd$var$appSelectorIcons[productKey] ? {
                        Icon: $9fbf3b40278c59cd$var$appSelectorIcons[productKey]
                    } : {}
                }
            })), [
        availableProducts,
        productConfigs,
        selectedProduct
    ]);
    const apps1PToDisplay = (0, $gwFzn.useMemo)(()=>$9fbf3b40278c59cd$var$supported1PApps(primaryProduct).filter((supported1PApp)=>availableProducts.includes(supported1PApp.productKey)).filter((supported1PApp)=>!selectedProduct || supported1PApp.productKey === selectedProduct).map((supportedApp)=>({
                ...supportedApp,
                productConfig: productConfigs[supportedApp.productKey]
            })), [
        availableProducts,
        primaryProduct,
        productConfigs,
        selectedProduct
    ]);
    return {
        apps1PToDisplay: apps1PToDisplay,
        apps3PToDisplay: apps3PToDisplay,
        isDialogAbove400px: isDialogAbove400px,
        isDialogAbove450px: isDialogAbove450px,
        primaryProduct: primaryProduct,
        selectedProduct: selectedProduct
    };
};

});
parcelRegister("l8wXo", function(module, exports) {

$parcel$export(module.exports, "GoogleDriveAppSelectorIcon", () => $8f03b897883d0b88$export$e087ba40596ff085);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $8f03b897883d0b88$export$e087ba40596ff085 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181643)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_271_181643)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white",
                            fillOpacity: "0.01"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                            clipPath: "url(#clip2_271_181643)",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
                                    fill: "#0066DA"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
                                    fill: "#00AC47"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
                                    fill: "#EA4335"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
                                    fill: "#00832D"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
                                    fill: "#2684FC"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
                                    fill: "#FFBA00"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "18.3333",
                            fill: "white",
                            transform: "translate(2 2.83325)"
                        })
                    })
                ]
            })
        ]
    });

});

parcelRegister("kZ0dZ", function(module, exports) {

$parcel$export(module.exports, "SlackAppSelectorIcon", () => $fa17f1a0bfd05113$export$f11b42d1aefdd173);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $fa17f1a0bfd05113$export$f11b42d1aefdd173 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });

});



parcelRegister("9Pz4M", function(module, exports) {

$parcel$export(module.exports, "InlineProductFilters", () => $f4dec8f243f8bf8c$export$b1ad550c251413b4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $eWgaW = parcelRequire("eWgaW");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $7WbA8 = parcelRequire("7WbA8");

var $5FKsO = parcelRequire("5FKsO");

var $hML65 = parcelRequire("hML65");

var $inrbX = parcelRequire("inrbX");

var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $idGm7 = parcelRequire("idGm7");

var $hMKYS = parcelRequire("hMKYS");
const $f4dec8f243f8bf8c$var$inlineProductFilterStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    paddingInlineStart: 'space.100',
    gap: 'space.100',
    width: '100%',
    minWidth: '0' // Prevents the filter buttons from overflowing from its container and allow it to shrink as much as possible
});
const $f4dec8f243f8bf8c$export$b1ad550c251413b4 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    if (!selectedProduct) return null;
    const moreButtonOnClick = ()=>{
        setQuickFindOpen(false);
        fireAnalyticsEvent((0, $hML65.onMoreProductFiltersSelected)({
            actionSubjectId: 'more-product-filters',
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        // TODO: This is a temporary measure until we do QS-6716 post Team 25 where it syncs filters with FPS.
        // For now, executing a search query on FPS search will always clear the filters in QF as FPS filters
        // is the source of truth for filter state.
        clearAllFilters();
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            text: quickFindQuery
        }), 'push');
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $f4dec8f243f8bf8c$var$inlineProductFilterStyles,
        testId: "qf-product-filters",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $idGm7.SpaceFilter), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5FKsO.FilterButton), {
                onClick: moreButtonOnClick,
                iconAfter: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWgaW))), {
                    label: formatMessage((0, $hMKYS.i18n).externalLinkIconLabel),
                    color: "currentColor"
                }),
                children: formatMessage((0, $hMKYS.i18n).moreButtonLabel)
            })
        ]
    });
};

});
parcelRegister("hML65", function(module, exports) {

$parcel$export(module.exports, "onMoreProductFiltersSelected", () => $b7cdee9969fa612b$export$59708e770734a297);
const $b7cdee9969fa612b$export$59708e770734a297 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'moreProductFilters',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("idGm7", function(module, exports) {

$parcel$export(module.exports, "SpaceFilter", () => $5bd43442241df578$export$2414da0e5c5cdf82);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $c4sKh = parcelRequire("c4sKh");

var $eG1e2 = parcelRequire("eG1e2");

var $jQ2up = parcelRequire("jQ2up");

var $5FKsO = parcelRequire("5FKsO");

var $946uu = parcelRequire("946uu");

var $5cssW = parcelRequire("5cssW");

var $a97k3 = parcelRequire("a97k3");

var $hqP8k = parcelRequire("hqP8k");
const $5bd43442241df578$export$2414da0e5c5cdf82 = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $a97k3.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, badgeLabel: badgeLabel, firstSelectedOptionLabel: firstSelectedOptionLabel } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $hqP8k.i18n).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $hqP8k.i18n).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $946uu.FilterPopupSelect), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $hqP8k.i18n).space),
        placeholder: formatMessage((0, $hqP8k.i18n).confluenceFilterSpacePlaceholder),
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: clearOptions,
        target: ({ isOpen: isOpen, ...targetProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5FKsO.FilterButton), {
                ...targetProps,
                isSelected: !!selectedOptions.length,
                iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                    label: formatMessage((0, $hqP8k.i18n).confluenceFilterSpaceIcon)
                }),
                iconAfter: badgeLabel && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
                    appearance: "primary",
                    children: badgeLabel
                }),
                minWidthZero: true,
                children: firstSelectedOptionLabel ? firstSelectedOptionLabel : formatMessage((0, $hqP8k.i18n).space)
            })
    });
};

});
parcelRegister("946uu", function(module, exports) {

$parcel$export(module.exports, "FilterPopupSelect", () => $40387639b8effd2d$export$381eb977a1d9bc81);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $c9mMn = parcelRequire("c9mMn");
var $cuAuQ = parcelRequire("cuAuQ");

var $k5mzm = parcelRequire("k5mzm");

var $ls6iZ = parcelRequire("ls6iZ");
const $40387639b8effd2d$export$381eb977a1d9bc81 = ({ defaultIsOpen: defaultIsOpen = false, isSearchable: isSearchable = false, isLoading: isLoading = false, canClearFilter: canClearFilter = false, checkboxIndicators: checkboxIndicators = false, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, label: label, noOptionsMessage: noOptionsMessage, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, target: target })=>{
    const debounceTimeout = (0, $gwFzn.useRef)(null);
    // TODO: this can be removed if we have debounce in the store when lookup
    const [currentSearchInput, setCurrentSearchInput] = (0, $gwFzn.useState)(searchInput);
    const handleInputChange = (0, $gwFzn.useCallback)((value, action)=>{
        if (action.action !== 'input-change') return;
        setCurrentSearchInput(value);
        if (!onSearchInputChange) return;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(()=>{
            onSearchInputChange(value);
        }, 300);
    }, [
        onSearchInputChange
    ]);
    const handleChange = (0, $gwFzn.useCallback)((value)=>{
        onSelectChange(value);
    }, [
        onSelectChange
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cuAuQ.default), {
        blurInputOnSelect: false,
        canClearFilter: canClearFilter,
        closeMenuOnSelect: !checkboxIndicators,
        components: {
            Control: $k5mzm.Control,
            MenuList: $ls6iZ.MenuList,
            ...checkboxIndicators ? {
                Option: (0, $c9mMn.CheckboxOption)
            } : {}
        },
        defaultIsOpen: defaultIsOpen,
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        defaultOptions: false,
        formatOptionLabel: formatOptionLabel,
        inputValue: currentSearchInput,
        isClearable: false,
        isLoading: isLoading,
        isOptionSelected: (option)=>option.isSelected,
        isSearchable: isSearchable,
        label: label,
        maxMenuHeight: 400,
        maxMenuWidth: "22rem",
        menuPlacement: "bottom",
        minMenuWidth: minMenuWidth,
        noOptionsMessage: currentSearchInput ? undefined : ()=>noOptionsMessage,
        onChange: handleChange,
        onClearOptions: onClearOptions,
        onInputChange: handleInputChange,
        onMenuClose: ()=>{
            setCurrentSearchInput('');
            onDropdownClose?.();
        },
        onMenuOpen: onDropdownOpen,
        options: options,
        placeholder: placeholder,
        popperProps: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        },
        searchThreshold: -1,
        shouldCloseMenuOnTab: false,
        target: target
    });
};

});

parcelRegister("hqP8k", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $98def20fb816381d$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $98def20fb816381d$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    space: {
        id: "search-page.filters.names.space",
        defaultMessage: "Space"
    },
    confluenceFilterSpacePlaceholder: {
        id: "search-page.confluence.filter.space.placeholder",
        defaultMessage: "Find spaces"
    },
    confluenceFilterLabelSelected: {
        id: "search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "search-page.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    },
    confluenceFilterSpaceIcon: {
        id: "search-page.confluence.filter.space.icon",
        defaultMessage: "Space Icon"
    }
});

});


parcelRegister("hMKYS", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $db27a10ae551c873$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $db27a10ae551c873$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    externalLinkIconLabel: {
        id: "inline-product-filters.external-link-icon.label",
        defaultMessage: "External Link Icon"
    },
    moreButtonLabel: {
        id: "inline-product-filters.more-filters.label",
        defaultMessage: "More"
    }
});

});


parcelRegister("9fB7u", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $77e9ec5198e0dc0e$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $77e9ec5198e0dc0e$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    filterByIcon: {
        id: "quick-find-filters.filter-by-icon-label",
        defaultMessage: "Filter by Icon"
    }
});

});


parcelRegister("a0YSD", function(module, exports) {

$parcel$export(module.exports, "JiraAdvancedSearchLink", () => $e02869b185b9e3c4$export$104db48ac99dc257);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $jluld = parcelRequire("jluld");

var $u9agA = parcelRequire("u9agA");

var $ltx9b = parcelRequire("ltx9b");

var $k2YFb = parcelRequire("k2YFb");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $83gV2 = parcelRequire("83gV2");

var $4VmlX = parcelRequire("4VmlX");

var $g8fQj = parcelRequire("g8fQj");
const $e02869b185b9e3c4$var$ACTION_SUBJECT_ID = 'jiraAdvancedIssueSearch';
const $e02869b185b9e3c4$export$104db48ac99dc257 = ({ state: state, onClick: onClick })=>{
    const intl = (0, $dBxQj.default)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: intl.formatMessage((0, $g8fQj.messages).jira_advanced_search),
        color: "currentColor"
    });
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ltx9b.CommandIcon), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const onResultClicked = (0, $gwFzn.useCallback)((event)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: $e02869b185b9e3c4$var$ACTION_SUBJECT_ID
        });
    }, [
        onClick,
        state
    ]);
    const url = generateSearchUrl({
        ...queryParams,
        product: (0, $1yEFx.PrimaryProductKeys).Jira,
        text: quickFindQuery
    }, true);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $83gV2.SearchFooter), {
        icon: icon,
        title: intl.formatMessage((0, $g8fQj.messages).jira_advanced_search),
        rightMetadata: rightMetadata,
        url: url,
        onResultClicked: onResultClicked
    });
};

});
parcelRegister("ltx9b", function(module, exports) {

$parcel$export(module.exports, "CommandIcon", () => $738ebcb5194247d5$export$76bfbab5e3f9a6a3);
// Copied from packages/search/product-search-dialog/src/extensible/quick-find/icons/command-icon.tsx

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $738ebcb5194247d5$export$76bfbab5e3f9a6a3 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});

parcelRegister("k2YFb", function(module, exports) {

$parcel$export(module.exports, "ReturnIcon", () => $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $dbff52abefb1bfa8$export$d6c38c54dfb7c9d5 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});

parcelRegister("83gV2", function(module, exports) {

$parcel$export(module.exports, "SearchFooter", () => $02caee92bec6b3d2$export$64ded8b71dfcba9e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $26eSY = parcelRequire("26eSY");

var $icqFF = parcelRequire("icqFF");

var $7WbA8 = parcelRequire("7WbA8");
const $02caee92bec6b3d2$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.100',
    paddingBlockEnd: 'space.100',
    paddingInlineStart: 'space.200',
    paddingInlineEnd: 'space.200',
    display: 'flex',
    alignItems: 'center'
});
const $02caee92bec6b3d2$var$resultHoveredStlyes = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $02caee92bec6b3d2$var$keyboardHighlightedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $02caee92bec6b3d2$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $02caee92bec6b3d2$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $02caee92bec6b3d2$var$titleStyles = (0, $ecnYn.xcss)({
    overflow: 'clip',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $02caee92bec6b3d2$var$textOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $02caee92bec6b3d2$var$rightSectionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'space.150'
});
const $02caee92bec6b3d2$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    ':focus-visible': {
        outlineStyle: 'solid',
        outlineColor: 'color.border.accent.blue',
        outlineWidth: 'space.025',
        // @ts-ignore
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $02caee92bec6b3d2$export$64ded8b71dfcba9e = ({ icon: icon, title: title, rightMetadata: rightMetadata, url: url, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu })=>{
    const ref = (0, $gwFzn.useRef)();
    const [isHovered, setIsHovered] = (0, $gwFzn.useState)(false);
    const { linkComponent: Link } = (0, $7WbA8.useAppContext)();
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: ()=>{
            ref.current?.click();
        },
        onHighlightedCallback: ()=>{}
    });
    const onClick = (0, $gwFzn.useCallback)((event)=>{
        onResultClicked?.(event);
    }, [
        onResultClicked
    ]);
    const onContextMenu = (0, $gwFzn.useCallback)((event)=>{
        onResultContextMenu?.(event);
    }, [
        onResultContextMenu
    ]);
    return (0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
        backgroundColor: "color.background.neutral.subtle",
        onClick: onClick,
        onContextMenu: onContextMenu,
        testId: "search-dialog-footer",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
            xcss: [
                $02caee92bec6b3d2$var$linkStyles
            ],
            href: url,
            testId: "search-dialog-footer-link",
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $02caee92bec6b3d2$var$resultStyles,
                    isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
                    isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
                ],
                ref: (node)=>{
                    ref.current = node;
                    setRef(node);
                },
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$iconAreaStyles,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$middleAreaStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $02caee92bec6b3d2$var$titleStyles,
                                $02caee92bec6b3d2$var$textOverflowStyles
                            ],
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$rightSectionStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                            above: "xs",
                            children: rightMetadata
                        })
                    })
                ]
            })
        })
    }) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        onClick: onClick,
        onContextMenu: onContextMenu,
        testId: "search-dialog-footer",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
            xcss: [
                $02caee92bec6b3d2$var$linkStyles
            ],
            href: url,
            testId: "search-dialog-footer-link",
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $02caee92bec6b3d2$var$resultStyles,
                    isHovered && $02caee92bec6b3d2$var$resultHoveredStlyes,
                    isKeyboardHighlighted && $02caee92bec6b3d2$var$keyboardHighlightedStyles
                ],
                ref: (node)=>{
                    ref.current = node;
                    setRef(node);
                },
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$iconAreaStyles,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$middleAreaStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $02caee92bec6b3d2$var$titleStyles,
                                $02caee92bec6b3d2$var$textOverflowStyles
                            ],
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $02caee92bec6b3d2$var$rightSectionStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                            above: "xs",
                            children: rightMetadata
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("g8fQj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cb4c307b2668c972$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $cb4c307b2668c972$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    jira_advanced_search: {
        id: "jira_advanced_search",
        defaultMessage: "Jira Advanced Search"
    }
});

});


parcelRegister("kMtrE", function(module, exports) {

$parcel$export(module.exports, "JiraSingleSiteSearch", () => $ad3c6b6b491bd60c$export$72bf2a5ecf09330e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $fEibl = parcelRequire("fEibl");

var $fpGTa = parcelRequire("fpGTa");
var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $6fnsQ = parcelRequire("6fnsQ");

var $4VmlX = parcelRequire("4VmlX");

var $e8RPG = parcelRequire("e8RPG");
const $ad3c6b6b491bd60c$var$styles = (0, $ecnYn.xcss)({
    height: '100%',
    display: 'inline-block'
});
const $ad3c6b6b491bd60c$var$singleSiteContainer = (0, $ecnYn.xcss)({
    padding: 'space.100'
});
const $ad3c6b6b491bd60c$var$iconContainer = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    marginRight: 'space.150'
});
const $ad3c6b6b491bd60c$var$labelContainer = (0, $ecnYn.xcss)({
    marginRight: 'space.100',
    marginLeft: 'space.050',
    color: 'color.text',
    ':hover': {
        color: 'color.text'
    },
    ':focus': {
        color: 'color.text'
    }
});
const $ad3c6b6b491bd60c$var$styleLink = (0, $ecnYn.xcss)({
    WebkitBoxAlign: 'baseline',
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'inline-flex',
    justifyContent: 'center',
    fontWeight: 'font.weight.medium',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    border: `2px solid ${`var(--ds-border, ${(0, $6fnsQ.N900)})`}`,
    borderRadius: '4px',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    marginRight: 'space.100',
    color: 'color.text.subtle',
    textDecoration: 'none',
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    ':hover': {
        color: 'color.text.subtle',
        backgroundColor: 'color.background.neutral.hovered',
        textDecoration: 'none',
        transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
    },
    ':visited': {
        color: 'color.text.subtle'
    },
    ':focus-visible': {
        color: 'color.text.subtle'
    },
    ':focus': {
        color: 'color.text.subtle'
    }
});
var $ad3c6b6b491bd60c$var$JiraFooterLinkActionSubjectId = /*#__PURE__*/ function(JiraFooterLinkActionSubjectId) {
    JiraFooterLinkActionSubjectId["JIRA_BOARDS"] = "jiraBoardsSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_FILTERS"] = "jiraFiltersSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PROJECTS"] = "jiraProjectsSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PLANS"] = "jiraPlansSearchLink";
    JiraFooterLinkActionSubjectId["JIRA_PEOPLE"] = "jiraPeopleSearchLink";
    return JiraFooterLinkActionSubjectId;
}($ad3c6b6b491bd60c$var$JiraFooterLinkActionSubjectId || {});
const $ad3c6b6b491bd60c$export$4c85ccfa2dce935c = (query)=>{
    const allLinks = {
        board: {
            href: `/secure/ManageRapidViews.jspa?contains=${query}`,
            message: (0, $e8RPG.messages).jira_quick_find_boards,
            actionSubjectId: "jiraBoardsSearchLink"
        },
        project: {
            href: `/projects?contains=${query}`,
            message: (0, $e8RPG.messages).jira_quick_find_projects,
            actionSubjectId: "jiraProjectsSearchLink"
        },
        filters: {
            href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
            message: (0, $e8RPG.messages).jira_quick_find_filters,
            actionSubjectId: "jiraFiltersSearchLink"
        },
        plans: {
            href: `/jira/plans`,
            message: (0, $e8RPG.messages).jira_quick_find_plans,
            actionSubjectId: "jiraPlansSearchLink"
        },
        people: {
            href: `/jira/people/search?q=${query}`,
            message: (0, $e8RPG.messages).jira_quick_find_people,
            actionSubjectId: "jiraPeopleSearchLink"
        }
    };
    return allLinks;
};
const $ad3c6b6b491bd60c$export$72bf2a5ecf09330e = ({ state: state, onClick: onClick })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const searchConfiguration = $ad3c6b6b491bd60c$export$4c85ccfa2dce935c(quickFindQuery);
    const onFilterClick = (0, $gwFzn.useCallback)((event, actionSubjectId)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: actionSubjectId
        });
    }, [
        onClick,
        state
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $ad3c6b6b491bd60c$var$singleSiteContainer,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $ad3c6b6b491bd60c$var$iconContainer,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fEibl))), {
                    label: "navigate-single-site-icon"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $ad3c6b6b491bd60c$var$labelContainer,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $e8RPG.messages).jira_quick_find_single_site_label
                })
            }),
            Object.keys(searchConfiguration).map((key)=>{
                const { href: href, message: message, actionSubjectId: actionSubjectId } = searchConfiguration[key];
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    role: "none",
                    xcss: $ad3c6b6b491bd60c$var$styles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpGTa.default), {
                        xcss: $ad3c6b6b491bd60c$var$styleLink,
                        href: href,
                        onClick: (event)=>onFilterClick(event, actionSubjectId),
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...message
                        })
                    })
                }, `single_site_${key}`);
            })
        ]
    });
};

});
parcelRegister("e8RPG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2edb72d725c5d8f9$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $2edb72d725c5d8f9$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    jira_quick_find_single_site_label: {
        id: "jira_single_site_label",
        defaultMessage: "Navigate to"
    },
    jira_quick_find_projects: {
        id: "jira_single_site_projects",
        defaultMessage: "Projects"
    },
    jira_quick_find_boards: {
        id: "jira_single_site_boards",
        defaultMessage: "Boards"
    },
    jira_quick_find_filters: {
        id: "jira_single_site_filters",
        defaultMessage: "Filters"
    },
    jira_quick_find_plans: {
        id: "jira_single_site_plans",
        defaultMessage: "Plans"
    },
    jira_quick_find_people: {
        id: "jira_single_site_people",
        defaultMessage: "People"
    }
});

});


parcelRegister("aBMZB", function(module, exports) {

$parcel$export(module.exports, "LandingScreen", () => $9ebd3fccc7b29e09$export$144e5acf8752ad4a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $9vOy1 = parcelRequire("9vOy1");

var $7WbA8 = parcelRequire("7WbA8");

var $j4ply = parcelRequire("j4ply");

var $kG9Ys = parcelRequire("kG9Ys");

const $9ebd3fccc7b29e09$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("d6iVp")));
const $9ebd3fccc7b29e09$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $9ebd3fccc7b29e09$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $9ebd3fccc7b29e09$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $9ebd3fccc7b29e09$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $9ebd3fccc7b29e09$export$144e5acf8752ad4a = ()=>{
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const bodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo ? (0, $kG9Ys.messages).quickFindNoContentBodyWithRovo : isAdminHubAIEnabled ? (0, $kG9Ys.messages).quickFindNoContentBodyWithAtlassianIntelligence : (0, $kG9Ys.messages).quickFindNoContentBodyDefault;
    const newBodyCopy = applicationMode === (0, $9vOy1.ApplicationModes).Rovo && isRovoLLMEnabled || isAdminHubAIEnabled ? (0, $kG9Ys.messages).quickFindNoContentBodyWithAI : (0, $kG9Ys.messages).quickFindNoContentBody;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $9ebd3fccc7b29e09$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $9ebd3fccc7b29e09$var$imageFallbackStyles
                }),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($9ebd3fccc7b29e09$var$Image, {})
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $9ebd3fccc7b29e09$var$headingStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $dh538.fg)('rovo_search_updated_entitlement_checks_for_team_25') ? newBodyCopy : bodyCopy
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $9ebd3fccc7b29e09$var$bodyStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $kG9Ys.messages).quickFindNoContentHeading
                })
            })
        ]
    });
};

});
parcelRegister("kG9Ys", function(module, exports) {

$parcel$export(module.exports, "messages", () => $678282c0e0260f8c$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $678282c0e0260f8c$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    quickFindNoContentHeading: {
        id: "search_dialog_no_content_heading",
        defaultMessage: "Seek and you shall find"
    },
    quickFindNoContentBodyWithRovo: {
        id: "search_dialog_no_content_body_with_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and integrated products"
    },
    quickFindNoContentBodyWithAtlassianIntelligence: {
        id: "search_dialog_no_content_body_with_atlassian_intelligence",
        defaultMessage: "Search or ask anything across your Atlassian products"
    },
    quickFindNoContentBodyDefault: {
        id: "search_dialog_no_content_body",
        defaultMessage: "Search for anything across your Atlassian products"
    },
    quickFindNoContentBody: {
        id: "search_dialog_no_content_body",
        defaultMessage: "Search for what you're looking for in your Atlassian and integrated products"
    },
    quickFindNoContentBodyWithAI: {
        id: "search_dialog_no_content_body_with_atlassian_intelligence",
        defaultMessage: "Search or ask what you're looking for in your Atlassian and integrated products"
    }
});

});

parcelRegister("d6iVp", function(module, exports) {

let $989a8402a1e78ab9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $989a8402a1e78ab9$var$load("atmg2").then(()=>parcelRequire('iTSW4'));

});


parcelRegister("iUdW4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3f03f084e86b29e6$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $3f03f084e86b29e6$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    searchDialogAriaLabel: {
        id: "search_dialog_aria_label",
        defaultMessage: "Search Dialog"
    },
    recentsHeading: {
        id: "search_dialog_recents_heading",
        defaultMessage: "Recently viewed"
    },
    searchResultsHeading: {
        id: "recents_heading",
        defaultMessage: "Search Results"
    },
    forYou: {
        id: "for_you_heading",
        defaultMessage: "For You"
    }
});

});

parcelRegister("8SdvD", function(module, exports) {

$parcel$export(module.exports, "NoResultsScreen", () => $c5e5408b5df96d67$export$373c6a9b01d625eb);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $7WbA8 = parcelRequire("7WbA8");

var $4VmlX = parcelRequire("4VmlX");

var $eWG0a = parcelRequire("eWG0a");

const $c5e5408b5df96d67$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("34gzq")));
const $c5e5408b5df96d67$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.200',
    color: 'color.text'
});
const $c5e5408b5df96d67$var$imageFallbackStyles = (0, $ecnYn.xcss)({
    width: '124px',
    height: '124px'
});
const $c5e5408b5df96d67$var$headingStyles = (0, $ecnYn.xcss)({
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    marginTop: 'space.100'
});
const $c5e5408b5df96d67$var$bodyStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100',
    font: 'font.body'
});
const $c5e5408b5df96d67$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    font: 'font.body',
    color: 'color.link',
    padding: 'space.0',
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $c5e5408b5df96d67$export$373c6a9b01d625eb = ({ onRetry: onRetry })=>{
    const { linkComponent: Link, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $c5e5408b5df96d67$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $c5e5408b5df96d67$var$imageFallbackStyles
                }),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($c5e5408b5df96d67$var$Image, {})
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $c5e5408b5df96d67$var$headingStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $eWG0a.messages).noResultsHeading,
                    values: {
                        button: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
                                xcss: $c5e5408b5df96d67$var$pressableStyles,
                                onClick: onRetry,
                                children: s
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $c5e5408b5df96d67$var$bodyStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $eWG0a.messages).noResultsBody,
                    values: {
                        link: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
                                xcss: $c5e5408b5df96d67$var$pressableStyles,
                                href: generateSearchUrl({
                                    ...queryParams,
                                    text: quickFindQuery
                                }),
                                children: s
                            })
                    }
                })
            })
        ]
    });
};

});
parcelRegister("eWG0a", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bc6e38173da21e1a$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $bc6e38173da21e1a$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    noResultsHeading: {
        id: "search_dialog_no_results_heading",
        defaultMessage: "We couldn't find any results with that title"
    },
    noResultsBody: {
        id: "search_dialog_error_search_body",
        defaultMessage: "<link>Search all content across your organization</link> or try again with a different term."
    }
});

});

parcelRegister("34gzq", function(module, exports) {

let $23be995ad26ad65d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $23be995ad26ad65d$var$load("g5R8w").then(()=>parcelRequire('6r800'));

});


parcelRegister("fvCil", function(module, exports) {

$parcel$export(module.exports, "PeopleAndTeams", () => $18e1948c3888bb1b$export$c84e51771b9ba67c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $esRft = parcelRequire("esRft");

var $u9agA = parcelRequire("u9agA");

var $c5JjN = parcelRequire("c5JjN");

var $icWhS = parcelRequire("icWhS");
var $aU479 = parcelRequire("aU479");
var $bloXB = parcelRequire("bloXB");

var $k2YFb = parcelRequire("k2YFb");

var $7WbA8 = parcelRequire("7WbA8");

var $eKxuB = parcelRequire("eKxuB");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $hr82m = parcelRequire("hr82m");
const $18e1948c3888bb1b$export$c84e51771b9ba67c = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [orgId] = (0, $j4ply.useOrgId)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const { generateTeamUrl: generateTeamUrl, generateUserUrl: generateUserUrl } = (0, $7WbA8.useAppContext)();
    const id = result.id;
    const userTitle = result.name;
    const teamTitle = result.displayName;
    const title = result.entityType === (0, $c5JjN.EntityType).USER ? userTitle : teamTitle;
    const highlightedTitle = title && quickFindQuery ? (0, $bloXB.highlightMatchedText)(title, quickFindQuery.split(' ')).highlightedTitle : undefined;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
        appearance: result.entityType === (0, $c5JjN.EntityType).USER ? 'circle' : 'square',
        borderColor: "transparent",
        name: title,
        size: 'small',
        src: result.avatarUrl || result.smallAvatarImageUrl
    });
    const userMetadata = [
        'user-metadata',
        result.title
    ];
    const teamMetadata = [
        'team-metadata',
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $hr82m.messages).team
        })
    ];
    const metadata = result.entityType === (0, $c5JjN.EntityType).USER ? [
        userMetadata
    ] : [
        teamMetadata
    ];
    let path;
    // TODO remove this statement once all products have specified their own generateUserUrl and generateTeamUrl props
    if (primaryProduct && orgId && cloudId) path = result.entityType === (0, $c5JjN.EntityType).USER ? (0, $aU479.getUserPath)(result.id, primaryProduct, orgId, cloudId) : (0, $aU479.getTeamPath)(result.id, primaryProduct, orgId, cloudId);
    if (generateUserUrl && result.entityType === (0, $c5JjN.EntityType).USER) path = generateUserUrl(result.id);
    else if (generateTeamUrl && result.entityType !== (0, $c5JjN.EntityType).USER) path = generateTeamUrl(result.id);
    const url = path && new URL(path, window.location.origin).href;
    const analyticsMetadata = (0, $gwFzn.useMemo)(()=>({
            contentId: id,
            contentType: 'user'
        }), [
        id
    ]);
    const onResultClicked = (0, $gwFzn.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onClick,
        state
    ]);
    const onResultContextMenu = (0, $gwFzn.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $gwFzn.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: {
                metadata: analyticsMetadata
            }
        });
    }, [
        analyticsMetadata,
        onHighlighted,
        state
    ]);
    if (!title || !metadata || !url) return null;
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: url,
        searchSessionId: searchSessionId
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        id: id,
        icon: icon,
        resultType: "peopleAndTeams",
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: urlWithAnalyticsQueryParams,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};

});
parcelRegister("eKxuB", function(module, exports) {

$parcel$export(module.exports, "SearchResult", () => $2944de3e13791145$export$a2def421b23768aa);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $26eSY = parcelRequire("26eSY");

var $9lW6K = parcelRequire("9lW6K");

var $icqFF = parcelRequire("icqFF");

var $9wmQG = parcelRequire("9wmQG");

var $7WbA8 = parcelRequire("7WbA8");

var $a7nUd = parcelRequire("a7nUd");
const $2944de3e13791145$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $2944de3e13791145$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'border.radius.200',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
});
const $2944de3e13791145$var$resultHoveredStlyes = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $2944de3e13791145$var$keyboardHighlightedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $2944de3e13791145$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2944de3e13791145$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $2944de3e13791145$var$titleStyles = (0, $ecnYn.xcss)({
    overflow: 'clip',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $2944de3e13791145$var$metadataStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    font: 'font.body.small',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '13px',
    display: 'flex',
    alignItems: 'center',
    minWidth: '0'
});
const $2944de3e13791145$var$textOverflowStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $2944de3e13791145$var$rightSectionStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: 'space.150'
});
const $2944de3e13791145$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text',
    textDecoration: 'none',
    display: 'inline-block',
    width: '100%',
    borderRadius: 'border.radius.200',
    ':hover': {
        textDecoration: 'none',
        color: 'color.text'
    },
    ':visited': {
        textDecoration: 'none',
        color: 'color.text'
    }
});
const $2944de3e13791145$var$headingStyle = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    gap: 'space.075',
    alignItems: 'center',
    maxWidth: '100%'
});
const $2944de3e13791145$export$a2def421b23768aa = ({ icon: icon, title: title, resultType: resultType, product: product, metadata: metadata = [], rightMetadata: rightMetadata, hoveredRightMetadata: hoveredRightMetadata, highlightedRightMetadata: highlightedRightMetadata, url: url, isThirdParty: isThirdParty = false, highlightedTitle: highlightedTitle, includeInAnalytics: includeInAnalytics = true, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onResultHighlighted: onResultHighlighted, titleMetadataParts: titleMetadataParts })=>{
    const wrapperRef = (0, $gwFzn.useRef)(null);
    const ref = (0, $gwFzn.useRef)();
    const [isHovered, setIsHovered] = (0, $gwFzn.useState)(false);
    const { linkComponent: Link } = (0, $7WbA8.useAppContext)();
    const [isKeyboardHighlighted, setRef] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: (e)=>{
            /**
			 * Two different event listeners are used to handle enter key presses
			 * when the input is focused:
			 * - the onKeyDown callback on the Textfield component which uses
			 *   React's synthetic event listeners (onKeyDown)
			 * - the keyboard highlight provider's onKeydownCallback which
			 *   uses native event listeners (window.addEventListener). This one
			 *   will only be called if a search result is highlighted.
			 * Ideally there should be only one event listener however, it isn't
			 * worth the effort to refactor the keyboard highlight provider right now.
			 *
			 * Given that the keyboard highlight provider's callback uses native
			 * event listeners, it will always be called first. This is a problem
			 * because there is no way for the keyboard highlight provider to
			 * communicate that the event has been handled, resulting in a bug
			 * where we try to handle the event twice if a search result was
			 * highlighted. It must be noted that it cannot be guaranteed that
			 * the search results are still highlighted after the native event
			 * listener has executed as it could close the search dialog.
			 *
			 * To fix this, a somewhat hacky solution has been added to delay
			 * the click event in the keyboard highlight provdier by one frame
			 * in search-dialog-result/index. This allows the React synthetic
			 * event to decide if it should handle the event by checking if a
			 * search result is highlighted, otherwise it will do nothing and
			 * let the keyboard highlight provider handle the event.
			 */ requestAnimationFrame(()=>{
                if (e.key === 'Enter') ref.current?.click();
            });
        },
        onHighlightedCallback: ()=>{
            const data = wrapperRef.current ? (0, $9wmQG.getNodePosition)(wrapperRef.current) : {};
            onResultHighlighted?.(data);
        }
    });
    const onClick = (0, $gwFzn.useCallback)((event)=>{
        const data = wrapperRef.current ? (0, $9wmQG.getNodePosition)(wrapperRef.current) : {};
        onResultClicked?.(event, data);
    }, [
        onResultClicked
    ]);
    const onContextMenu = (0, $gwFzn.useCallback)((event)=>{
        const data = wrapperRef.current ? (0, $9wmQG.getNodePosition)(wrapperRef.current) : {};
        onResultContextMenu?.(event, data);
    }, [
        onResultContextMenu
    ]);
    const metadataPartsWithTextOverflow = metadata.map((part, i)=>i === metadata.length - 1 && typeof part === 'string' ? [
            part,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$textOverflowStyles,
                as: "span",
                children: part
            })
        ] : part);
    const content = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        ref: (node)=>{
            ref.current = node;
            setRef(node);
        },
        xcss: [
            $2944de3e13791145$var$resultStyles,
            isHovered && $2944de3e13791145$var$resultHoveredStlyes,
            isKeyboardHighlighted && $2944de3e13791145$var$keyboardHighlightedStyles
        ],
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$iconAreaStyles,
                children: icon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$middleAreaStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                        xcss: $2944de3e13791145$var$headingStyle,
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                xcss: [
                                    $2944de3e13791145$var$titleStyles,
                                    $2944de3e13791145$var$textOverflowStyles
                                ],
                                children: highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title
                            }),
                            titleMetadataParts && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7nUd.SearchMetadata), {
                                    parts: titleMetadataParts
                                })
                            })
                        ]
                    }),
                    metadata.length >= 1 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $2944de3e13791145$var$metadataStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7nUd.SearchMetadata), {
                            parts: metadataPartsWithTextOverflow
                        })
                    })
                ]
            }),
            hoveredRightMetadata && isHovered ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$rightSectionStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                    above: "xs",
                    children: hoveredRightMetadata
                })
            }) : highlightedRightMetadata && isKeyboardHighlighted ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$rightSectionStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                    above: "xs",
                    children: highlightedRightMetadata
                })
            }) : rightMetadata ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $2944de3e13791145$var$rightSectionStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $26eSY.Show), {
                    above: "xs",
                    children: rightMetadata
                })
            }) : null
        ]
    });
    const resultWithoutAnalyticsWrapper = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $2944de3e13791145$var$containerStyles,
        children: (0, $dh538.fg)('custom-interactive-elements-not-keyboard-focusable') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
            backgroundColor: "color.background.neutral.subtle",
            onClick: onClick,
            onContextMenu: onContextMenu,
            children: url ? /*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
                xcss: [
                    $2944de3e13791145$var$linkStyles
                ],
                rel: isThirdParty ? 'noreferrer' : '',
                target: isThirdParty ? '_blank' : undefined,
                href: url,
                children: content
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                children: content
            })
        }) : // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            onClick: onClick,
            onContextMenu: onContextMenu,
            children: url ? /*#__PURE__*/ (0, $7UHDa.jsx)(Link, {
                xcss: $2944de3e13791145$var$linkStyles,
                rel: isThirdParty ? 'noreferrer' : '',
                target: isThirdParty ? '_blank' : undefined,
                href: url,
                children: content
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                children: content
            })
        })
    });
    return includeInAnalytics ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9wmQG.SearchDialogResultAnalyticsWrapper), {
        role: "listitem",
        "data-testid": "search-dialog-result",
        ref: wrapperRef,
        resultType: resultType,
        product: product,
        children: resultWithoutAnalyticsWrapper
    }) : resultWithoutAnalyticsWrapper;
};

});

parcelRegister("hr82m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d0b52bf4302d81ca$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $d0b52bf4302d81ca$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    team: {
        id: "search_dialog_team",
        defaultMessage: "Team"
    }
});

});


parcelRegister("lTdhv", function(module, exports) {

$parcel$export(module.exports, "ProductEntity", () => $0e1f91acee299cdf$export$c9f98fed0b66ba21);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $2BDjU = parcelRequire("2BDjU");

var $6vkAh = parcelRequire("6vkAh");

var $lqEjG = parcelRequire("lqEjG");

var $kMYZ2 = parcelRequire("kMYZ2");

var $7ZetK = parcelRequire("7ZetK");
var $7jIfa = parcelRequire("7jIfa");
var $4TTdD = parcelRequire("4TTdD");
var $8LSUr = parcelRequire("8LSUr");
var $HOiSI = parcelRequire("HOiSI");
var $6h3V2 = parcelRequire("6h3V2");
var $gzcCN = parcelRequire("gzcCN");

var $icWhS = parcelRequire("icWhS");
var $bloXB = parcelRequire("bloXB");

var $k2YFb = parcelRequire("k2YFb");

var $1yEFx = parcelRequire("1yEFx");

var $3E8x9 = parcelRequire("3E8x9");

var $aRSt4 = parcelRequire("aRSt4");

var $9LULT = parcelRequire("9LULT");

var $e9NQR = parcelRequire("e9NQR");

var $eKxuB = parcelRequire("eKxuB");

var $Y34Hw = parcelRequire("Y34Hw");

var $92zSJ = parcelRequire("92zSJ");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $lAvUJ = parcelRequire("lAvUJ");
const $0e1f91acee299cdf$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $0e1f91acee299cdf$var$mapConfluenceSearchResult = (result, query, searchSessionId, isUserShardJiraResult)=>{
    const id = result.id;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: isUserShardJiraResult ? (0, $1yEFx.ProductKeys).Jira : (0, $1yEFx.ProductKeys).Confluence
    });
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const space = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.space?.name ? result.space.name : null;
    const spaceId = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.space?.id;
    const isLiveDoc = (0, $4TTdD.isSearchConfluencePageBlogAttachment)(result) && result.confluenceEntity?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    const metadata = [
        isUserShardJiraResult ? 'Jira' : 'Confluence',
        [
            'type',
            isUserShardJiraResult ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $lAvUJ.messages).issue
            }) : isLiveDoc ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $lAvUJ.messages).liveDoc
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: result.type
            })
        ],
        space
    ];
    const timestamp = result.lastModified || '';
    const eventType = (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = result.lastModified ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const url = (0, $icWhS.getConfluenceUrlWithAnalyticsQueryParams)({
        url: result.url,
        query: query,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `confluence ${result.type}`,
        product: `confluence`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapAtlasSearchResult = (result, query, searchSessionId)=>{
    const id = result.id;
    const productIcon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Atlas
    });
    const icon = productIcon;
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const metadata = [
        'Atlas',
        [
            'type',
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: result.type
            })
        ]
    ];
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `atlas ${result.type}`,
        product: `atlas`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapMercurySearchResult = (result, query, searchSessionId)=>{
    const { id: id } = result;
    let icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Focus
    });
    let resultType, title, highlightedTitle, metadata;
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaPartial)(result)) {
        const { focusArea: focusArea } = result;
        const currentStatus = (focusArea?.health ? focusArea.health.key : focusArea?.status.key) || 'pending';
        const status = (0, $6vkAh.isFocusAreaStatus)(currentStatus) ? currentStatus : 'pending';
        if ((0, $dh538.fg)('mercury_enable_new_focus_area_icons')) icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2BDjU.default), {
            status: status
        });
        else {
            const hierarchyLevel = focusArea?.focusAreaType.hierarchyLevel || 0;
            const level = (0, $kMYZ2.isFocusAreaHierarchyLevel)(hierarchyLevel) ? hierarchyLevel : 0;
            icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqEjG.default), {
                level: level,
                status: status
            });
        }
        title = result.title;
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Focus area';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                    children: resultType
                })
            ],
            result.focusArea ? [
                'focusAreaType',
                result.focusArea?.focusAreaType.name
            ] : null
        ];
    }
    if ((0, $HOiSI.isSearchResultMercuryFocusAreaStatusUpdatePartial)(result)) {
        title = (0, $92zSJ.getSummarizedAdfContent)(result.description, query);
        highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
        resultType = 'Focus area update';
        metadata = [
            'Focus',
            [
                'type',
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                    children: resultType
                })
            ]
        ];
    }
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `mercury ${result.type}`,
        product: `mercury`
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapThirdPartySearchResult = (result, query, searchSessionId, thirdPartyConfigs)=>{
    const id = result.id;
    const thirdPartyId = result.entity?.thirdPartyId;
    let product = '';
    if (result.providerId) product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, result.providerId) || 'graph';
    if ((product === 'graph' || !result.providerId) && thirdPartyId) {
        const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(thirdPartyId);
        const resourceType = resourceOwner.split('.').at(1);
        product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    }
    if (!Object.values((0, $1yEFx.ProductKeys)).includes(product)) return;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const title = result.title;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const typeLabel = (0, $9LULT.getDocumentSubtypeLabel)({
        product: product,
        subtype: result?.subtype
    });
    const parentName = (0, $7ZetK.isDocumentEntity)(result) ? result.entity?.parent?.displayName : null;
    const metadata = [
        [
            'type',
            typeLabel ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...typeLabel
                })
            }) : result?.subtype ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: result?.subtype.charAt(0).toUpperCase() + result?.subtype.substring(1).toLowerCase()
            }) : null
        ],
        parentName ?? null
    ];
    const timestamp = result.lastModifiedDate || '';
    const eventType = (0, $3E8x9.WORKED_EVENT).UPDATED;
    const rightMetadata = result.lastModifiedDate ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${result.subtype}`,
        product: product
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $0e1f91acee299cdf$var$mapJiraSearchResult = (result, query, searchSessionId, isStatusLoading)=>{
    const id = result.id;
    const analyticsMetadata = {
        contentId: id,
        contentType: `jira ${result.type}`,
        product: `jira`
    };
    const title = result.title;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Jira
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const status = (0, $8LSUr.isSearchResultJiraIssue)(result) ? (0, $e9NQR.getStatus)(result.status?.name, result.status?.colorName, isStatusLoading) : null;
    const titleMetadataParts = status && (0, $dh538.fg)('enable_status_jira_issues_quick_find') ? [
        [
            'status',
            status
        ]
    ] : [];
    const metadata = [
        'Jira',
        [
            'type',
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $0e1f91acee299cdf$var$typeLabelContainer,
                children: result.type
            })
        ]
    ];
    const rightMetadata = (0, $8LSUr.isSearchResultJiraIssue)(result) ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: result.lastModifiedDate || '',
        eventType: (0, $3E8x9.WORKED_EVENT).UPDATED,
        isMyActivityData: false
    }) : null;
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const url = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        id: id,
        title: title,
        highlightedTitle: highlightedTitle,
        icon: icon,
        status: status,
        analyticsMetadata: analyticsMetadata,
        metadata: metadata,
        highlightedRightMetadata: highlightedRightMetadata,
        rightMetadata: rightMetadata,
        url: url,
        titleMetadataParts: titleMetadataParts
    };
};
const $0e1f91acee299cdf$var$mapSearchResult = (result, query, searchSessionId, thirdPartyConfigs, isStatusLoading, isUserShardEnabled)=>{
    const isUserShardJiraResult = isUserShardEnabled && result.id.includes('jira');
    if ((0, $4TTdD.isSearchConfluencePartial)(result)) return $0e1f91acee299cdf$var$mapConfluenceSearchResult(result, query, searchSessionId, isUserShardJiraResult);
    else if ((0, $7jIfa.isSearchAtlasPartial)(result)) return $0e1f91acee299cdf$var$mapAtlasSearchResult(result, query, searchSessionId);
    else if ((0, $HOiSI.isSearchMercuryPartial)(result)) return $0e1f91acee299cdf$var$mapMercurySearchResult(result, query, searchSessionId);
    else if ((0, $7ZetK.isSearchResultGraphEntity)(result)) return $0e1f91acee299cdf$var$mapThirdPartySearchResult(result, query, searchSessionId, thirdPartyConfigs);
    else if ((0, $8LSUr.isSearchJiraPartial)(result)) return $0e1f91acee299cdf$var$mapJiraSearchResult(result, query, searchSessionId, isStatusLoading);
    else return null;
};
const $0e1f91acee299cdf$export$c9f98fed0b66ba21 = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const isHydrationLoading = (0, $djVCD.useIsJiraHydrationLoading)();
    const isUserShardEnabled = (0, $dh538.fg)('quick_find_user_shard_query');
    const mappedResult = $0e1f91acee299cdf$var$mapSearchResult(result, quickFindQuery, searchSessionId, thirdPartyConfigs, isHydrationLoading, isUserShardEnabled);
    const additionalAnalyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            metadata: mappedResult?.analyticsMetadata,
            is3pLink: (0, $1yEFx.all3pProductKeys).includes(mappedResult?.analyticsMetadata.product)
        }), [
        mappedResult
    ]);
    const onResultClicked = (0, $gwFzn.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onClick,
        state
    ]);
    const onResultContextMenu = (0, $gwFzn.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $gwFzn.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        ...mappedResult,
        resultType: "searchResults",
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};

});
parcelRegister("lqEjG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c704531fdb19e4bf$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $2BDjU = parcelRequire("2BDjU");

var $e8kWw = parcelRequire("e8kWw");
const $c704531fdb19e4bf$export$9fa64e8c3e32f949 = {
    pending: "var(--ds-icon-accent-gray, #758195)",
    paused: "var(--ds-icon-accent-gray, #758195)",
    on_track: "var(--ds-icon-accent-lime, #6A9A23)",
    at_risk: "var(--ds-icon-warning, #E56910)",
    off_track: "var(--ds-icon-accent-red, #C9372C)",
    completed: "var(--ds-icon-accent-gray, #758195)"
};
const $c704531fdb19e4bf$var$iconContainer = (0, $ecnYn.xcss)({
    flexShrink: 0,
    lineHeight: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
});
function $c704531fdb19e4bf$export$2e2bcd8739ae039({ size: size, level: level, status: status, customColor: customColor, testId: testId, label: label }) {
    // Focus area icons have been migrated to the new @atlassian/focus-area-icon
    if ((0, $dh538.fg)('mercury_enable_new_focus_area_icons')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2BDjU.default), {
        status: status,
        // Since the customColor prop here does not enforce the new IconColor type and to avoid backwards
        // compatility issues, please use @atlassian/focus-area-icon if customColor prop is needed
        // https://hello.atlassian.net/wiki/spaces/DST/pages/3748692796/New+ADS+iconography+Code+migration+guide
        spacing: size === 'medium' || size === 'large' ? 'spacious' : 'compact',
        testId: testId,
        label: label
    });
    const adjustedSize = size === 'xsmall' ? 'xxsmall' : size;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $c704531fdb19e4bf$var$iconContainer,
        as: "span",
        children: (0, $e8kWw.FocusAreaIconMap)[level](customColor ?? (status ? $c704531fdb19e4bf$export$9fa64e8c3e32f949[status] : 'currentColor'), adjustedSize ?? 'medium', testId, label)
    });
}

});
parcelRegister("e8kWw", function(module, exports) {

$parcel$export(module.exports, "FocusAreaIconMap", () => $7d59de8f7f9d41d6$export$885129de440ed9d8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $7d59de8f7f9d41d6$export$85f83f46f1a8949d = {
    xxsmall: '16',
    small: '24',
    medium: '32',
    large: '48'
};
const $7d59de8f7f9d41d6$export$b367b0f8b81333e = 'Focus area icon';
const $7d59de8f7f9d41d6$var$iconViewBox = (size)=>size === 'xxsmall' ? '4 4 16 16' : '0 0 24 24';
const $7d59de8f7f9d41d6$export$885129de440ed9d8 = {
    0: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "11.9167",
                    cy: "7.375",
                    r: "1.625",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "17.4583",
                    cy: "16.875",
                    r: "1.625",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeWidth: "1.5",
                    d: "M11.917 9.065v2.938m0 0h3.541a2 2 0 0 1 2 2v.84m-5.541-2.84H8.375a2 2 0 0 0-2 2v1.053m5.542-3.053v3.053"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "11.9167",
                    cy: "16.875",
                    r: "1.625",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "6.375",
                    cy: "16.875",
                    r: "1.625",
                    strokeWidth: "1.5"
                })
            ]
        }),
    1: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "11.9879",
                    cy: "6.99597",
                    r: "1.99597",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeWidth: "1.5",
                    d: "M12.099 9.214v2.543m0 0H14.2a2 2 0 0 1 2 2v.668M12.1 11.757H9.996a2 2 0 0 0-2 2v.668"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "16.2015",
                    cy: "16.754",
                    r: "1.99597",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "7.99597",
                    cy: "16.754",
                    r: "1.99597",
                    strokeWidth: "1.5"
                })
            ]
        }),
    2: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "6.66667",
                    cy: "17.3333",
                    r: "1.91667",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "1.91667",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "17.3334",
                    cy: "6.66667",
                    r: "1.91667",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeWidth: "1.5",
                    d: "M6.667 15.556v-2.37c0-.655.53-1.186 1.185-1.186h2.37M17.333 8.444v2.37c0 .655-.53 1.186-1.185 1.186h-2.37"
                })
            ]
        }),
    3: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "17.569",
                    cy: "16.6379",
                    r: "1.86207",
                    strokeWidth: "1.5",
                    transform: "rotate(90 17.569 16.638)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "6.86205",
                    cy: "6.86207",
                    r: "1.86207",
                    strokeWidth: "1.5",
                    transform: "rotate(90 6.862 6.862)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeWidth: "1.5",
                    d: "M8.048 6.897h1.074a2.5 2.5 0 0 1 2.5 2.5v4.775a2.5 2.5 0 0 0 2.5 2.5h2.28"
                })
            ]
        }),
    4: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "16.8001",
                    cy: "16.8",
                    r: "2.2",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "7.95",
                    cy: "7.95",
                    r: "2.2",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M7.95 10.446v6.104c0 .138.112.25.25.25h5.877m2.723-2.95V8.2a.25.25 0 0 0-.25-.25H10.9"
                })
            ]
        }),
    5: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "16.7059",
                    cy: "15.7059",
                    r: "2.29412",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "8.29412",
                    cy: "7.29412",
                    r: "2.29412",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M8.322 9.875v5.554c0 .138.111.25.25.25h5.553"
                })
            ]
        }),
    6: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            // Level 6 icon uses a custom xxsmall viewport to fit and center icon
            viewBox: size === 'xxsmall' ? '3 5 16.2 16.2' : '0 0 24 24',
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "12.6111",
                    cy: "7.58333",
                    r: "1.83333",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M10.028 7.583H5a1 1 0 0 0-1 1v7.612M11.75 20.5h5.028a1 1 0 0 0 1-1v-7.611"
                })
            ]
        }),
    7: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "14.4451",
                    cy: "16.3594",
                    r: "2.39062",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M7 6v10.2c0 .139.112.25.25.25h4.258M7.41 9.893h3.688"
                })
            ]
        }),
    8: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "15.5189",
                    cy: "15.3112",
                    r: "1.98113",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M7 6v4.505c0 .138.112.25.25.25h5.803"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fill: color,
                    stroke: "none",
                    d: "M10.777 10.854a.75.75 0 1 0-1.5 0h1.5Zm-1.5 0v3.987h1.5v-3.987h-1.5Zm1 4.987h2.776v-1.5h-2.776v1.5Zm-1-1a1 1 0 0 0 1 1v-1.5a.5.5 0 0 1 .5.5h-1.5Z"
                })
            ]
        }),
    9: (color, size, testId, label = $7d59de8f7f9d41d6$export$b367b0f8b81333e)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            height: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            width: $7d59de8f7f9d41d6$export$85f83f46f1a8949d[size],
            viewBox: $7d59de8f7f9d41d6$var$iconViewBox(size),
            "data-testid": testId,
            "aria-label": label,
            role: "img",
            stroke: color,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("circle", {
                    cx: "11.6249",
                    cy: "11.6249",
                    r: "2.08929",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    strokeLinecap: "round",
                    strokeWidth: "1.5",
                    d: "M5 12.098v5.152a1 1 0 0 0 1 1h5.625M18.25 11.152V6a1 1 0 0 0-1-1h-5.625"
                })
            ]
        })
};

});


parcelRegister("kMYZ2", function(module, exports) {

$parcel$export(module.exports, "isFocusAreaHierarchyLevel", () => $08d78abb43143d38$export$a7630963491fabb6);
function $08d78abb43143d38$export$a7630963491fabb6(level) {
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
    ].indexOf(level) !== -1;
}
function $08d78abb43143d38$export$78192d4e53523287(status) {
    return [
        'pending',
        'paused',
        'on_track',
        'off_track',
        'at_risk',
        'completed'
    ].indexOf(status) !== -1;
}

});

parcelRegister("9LULT", function(module, exports) {

$parcel$export(module.exports, "getDocumentSubtypeLabel", () => $db7c0f516add704a$export$a47c0c6de01249fd);
$parcel$export(module.exports, "getRemoteLinkSubtypeLabel", () => $db7c0f516add704a$export$19dc2415a5fa9123);

var $1yEFx = parcelRequire("1yEFx");

var $75nfs = parcelRequire("75nfs");
const $db7c0f516add704a$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $75nfs.messages).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $75nfs.messages).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $75nfs.messages).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $75nfs.messages).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $75nfs.messages).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $75nfs.messages).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $1yEFx.ProductKeys).Sharepoint || product === (0, $1yEFx.ProductKeys).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $1yEFx.ProductKeys).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    return label;
};
const $db7c0f516add704a$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const labelKey = `${subtype}Label`;
    if (labelKey in (0, $75nfs.messages)) return (0, $75nfs.messages)[labelKey];
    else return (0, $75nfs.messages).otherLabel;
};

});
parcelRegister("75nfs", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b9359f0728408764$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $b9359f0728408764$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    },
    documentLabel: {
        id: "document.label",
        defaultMessage: "Document"
    },
    spreadsheetLabel: {
        id: "spreadsheet.label",
        defaultMessage: "Spreadsheet"
    },
    presentationLabel: {
        id: "presentation.label",
        defaultMessage: "Presentation"
    },
    fileLabel: {
        id: "file.label",
        defaultMessage: "File"
    },
    databaseLabel: {
        id: "database.label",
        defaultMessage: "Database"
    },
    webPageLabel: {
        id: "web-page.label",
        defaultMessage: "Web Page"
    },
    pageLabel: {
        id: "page.label",
        defaultMessage: "Page"
    },
    blogpostLabel: {
        id: "blogpost.label",
        defaultMessage: "Blogpost"
    },
    dashboardLabel: {
        id: "dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoiceLabel: {
        id: "invoice.label",
        defaultMessage: "Invoice"
    },
    designLabel: {
        id: "design.label",
        defaultMessage: "Design"
    },
    dealLabel: {
        id: "deal.label",
        defaultMessage: "Deal"
    },
    videoLabel: {
        id: "video.label",
        defaultMessage: "Video"
    },
    taskLabel: {
        id: "task.label",
        defaultMessage: "Task"
    },
    issueLabel: {
        id: "issue.label",
        defaultMessage: "Issue"
    },
    spaceLabel: {
        id: "space.label",
        defaultMessage: "Space"
    },
    projectLabel: {
        id: "project.label",
        defaultMessage: "Project"
    },
    repositoryLabel: {
        id: "repository.label",
        defaultMessage: "Repository"
    },
    customerOrgLabel: {
        id: "customer-org.label",
        defaultMessage: "Customer Org"
    },
    imageLabel: {
        id: "image.label",
        defaultMessage: "Image"
    },
    archiveLabel: {
        id: "archive.label",
        defaultMessage: "Archive"
    },
    audioLabel: {
        id: "audio.label",
        defaultMessage: "Audio"
    },
    pdfLabel: {
        id: "pdf.label",
        defaultMessage: "PDF"
    },
    codeLabel: {
        id: "code.label",
        defaultMessage: "Code"
    },
    otherLabel: {
        id: "other.label",
        defaultMessage: "Other"
    }
});

});


parcelRegister("lAvUJ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0559f7291a65cc73$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $0559f7291a65cc73$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    statusUpdateTitle: {
        id: "quick-find.mercury.focus-area-status-update.title",
        defaultMessage: "Update for {focusAreaName}"
    },
    issue: {
        id: "issue_type",
        defaultMessage: "Issue"
    }
});

});


parcelRegister("2FGXW", function(module, exports) {

$parcel$export(module.exports, "ProductFilterHeader", () => $af73fd345568e68c$export$21c17ab78196b771);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $isYda = parcelRequire("isYda");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $6fnsQ = parcelRequire("6fnsQ");

var $1yEFx = parcelRequire("1yEFx");

var $d5Ozh = parcelRequire("d5Ozh");

var $adz0l = parcelRequire("adz0l");
const $af73fd345568e68c$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
    justifyContent: 'center'
});
const $af73fd345568e68c$var$productFilterHeaderContainerStyle = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
});
const $af73fd345568e68c$var$productFilterHeaderStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 'space.100',
    overflowX: 'hidden',
    marginLeft: 'space.150'
});
const $af73fd345568e68c$export$21c17ab78196b771 = ({ availableProducts: availableProducts })=>{
    // eslint-disable-next-line @atlassian/search-common/no-use-local-storage
    const [storedState] = (0, $d5Ozh.useLocalStorageSearchPagePersistedState)();
    const hiddenProducts = (0, $gwFzn.useMemo)(()=>{
        if (!storedState || !storedState.filters) return [];
        return Object.keys(storedState.filters).filter((product)=>storedState.filters[product].hidden).map((product)=>product);
    }, [
        storedState
    ]);
    const combinedProducts = (0, $gwFzn.useMemo)(()=>{
        const products1P = [
            (0, $1yEFx.ProductKeys).Confluence,
            (0, $1yEFx.ProductKeys).Jira
        ].filter((product)=>availableProducts.includes(product)).filter((product)=>!hiddenProducts.includes(product));
        const products3P = [
            (0, $1yEFx.ProductKeys).GoogleDrive,
            (0, $1yEFx.ProductKeys).Sharepoint,
            (0, $1yEFx.ProductKeys).Teams,
            (0, $1yEFx.ProductKeys).Slack
        ].filter((product)=>availableProducts.includes(product)).filter((product)=>!hiddenProducts.includes(product)).slice(0, 2);
        return [
            ...products1P,
            ...products3P
        ];
    }, [
        availableProducts,
        hiddenProducts
    ]);
    if (combinedProducts.length === 0) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $af73fd345568e68c$var$productFilterHeaderContainerStyle,
        id: "product-filter-header",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $af73fd345568e68c$var$iconAreaStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                    spacing: "none",
                    label: '',
                    color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $af73fd345568e68c$var$productFilterHeaderStyle,
                children: combinedProducts.map((product)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $adz0l.HeaderProductButtonFinal), {
                        otherProps: {},
                        productKey: product
                    }, product))
            })
        ]
    });
};

});
parcelRegister("adz0l", function(module, exports) {

$parcel$export(module.exports, "HeaderProductButtonFinal", () => $f6ba6e0a08941574$export$3b6e7b728016bc27);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $1SV4e = parcelRequire("1SV4e");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $eoZmS = parcelRequire("eoZmS");

var $aRSt4 = parcelRequire("aRSt4");

var $a5OFf = parcelRequire("a5OFf");

var $9hejW = parcelRequire("9hejW");

var $1nJM3 = parcelRequire("1nJM3");

var $gGFxq = parcelRequire("gGFxq");

var $inrbX = parcelRequire("inrbX");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");
const $f6ba6e0a08941574$var$baseStyles = (0, $ecnYn.xcss)({
    height: 'size.300',
    paddingInline: 'space.150',
    borderRadius: 'border.radius.100',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $f6ba6e0a08941574$var$buttonWrapperStyles = (0, $ecnYn.xcss)({
    maxWidth: '280px' // matches dropdown of 312px (and padding)
});
const $f6ba6e0a08941574$var$textStyles = (0, $ecnYn.xcss)({
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)"
});
const $f6ba6e0a08941574$var$HeaderProductButton = ({ otherProps: otherProps, triggerProps: triggerProps, productKey: productKey, label: label, onClick: onClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $f6ba6e0a08941574$var$buttonWrapperStyles,
        ...triggerProps,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2W0qg.default), {
            onClick: onClick,
            ...otherProps,
            testId: testId,
            xcss: $f6ba6e0a08941574$var$baseStyles,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                alignInline: "start",
                space: "space.100",
                spread: "space-between",
                alignBlock: "center",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                    alignBlock: "center",
                    alignInline: "start",
                    xcss: $f6ba6e0a08941574$var$textStyles,
                    space: "space.100",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductOrNounIcon), {
                            label: "",
                            size: "small",
                            productOrNounKey: productKey
                        }),
                        label && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $f6ba6e0a08941574$var$textStyles,
                            children: label
                        })
                    ]
                })
            })
        })
    });
};
const $f6ba6e0a08941574$export$3b6e7b728016bc27 = ({ otherProps: otherProps, productKey: productKey, onClick: onClick, testId: testId })=>{
    const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.useIsUserOAuthed)(productKey);
    const products = (0, $1yEFx.useProductConfigs)();
    const productLabel = products[productKey].displayName;
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const isSmartlink = (0, $a5OFf.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [{ primaryProduct: primaryProduct, user: user }] = (0, $j4ply.useBootstrap)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onClickNoOauth = (0, $gwFzn.useCallback)(()=>{
        if (!primaryProduct) return;
        // Store search in recent searches
        if (quickFindQuery.trim() !== '' && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)(quickFindQuery.trim(), user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
            updateRecentQueries?.();
        }
        setQuickFindOpen(false);
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push');
        fireAnalyticsEvent((0, $9hejW.onProductFilterSelected)({
            actionSubjectId: productKey,
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        primaryProduct,
        quickFindQuery,
        user,
        setQuickFindOpen,
        onNavigate,
        generateSearchUrl,
        queryParams,
        productKey,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        updateRecentQueries
    ]);
    if (!userNeedsOAuth) return /*#__PURE__*/ (0, $7UHDa.jsx)($f6ba6e0a08941574$var$HeaderProductButton, {
        otherProps: otherProps,
        productKey: productKey,
        label: productLabel,
        onClick: onClickNoOauth,
        testId: testId
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1nJM3.ErrorBoundary), {
        section: "QuickFindHeaderProductButtonOAuthWrapper",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eoZmS.OAuthWarningWrapper), {
            product: productKey,
            trigger: ({ isDisabled: isDisabled, oAuthWarning: oAuthWarning, triggerProps: triggerProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)($f6ba6e0a08941574$var$HeaderProductButton, {
                    otherProps: otherProps,
                    triggerProps: triggerProps,
                    productKey: productKey,
                    label: productLabel,
                    onClick: onClick,
                    testId: testId
                }),
            isOnSearchDialog: true,
            useOAuthHandlers: (0, $gGFxq.useOAuthHandlers),
            useIsUserOAuthed: (0, $gGFxq.useIsUserOAuthed),
            isSmartlink: isSmartlink,
            searchQuery: quickFindQuery
        }, productKey)
    });
};

});
parcelRegister("9hejW", function(module, exports) {

$parcel$export(module.exports, "onProductFilterSelected", () => $e6d04984988c7e76$export$37a6fcdc5420268c);
const $e6d04984988c7e76$export$37a6fcdc5420268c = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'productFilter',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});



parcelRegister("fKnXN", function(module, exports) {

$parcel$export(module.exports, "useQueryFilterResults", () => $8215af3ea39f4647$export$385c746fbc3d50c5);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $5cssW = parcelRequire("5cssW");

var $4VmlX = parcelRequire("4VmlX");

var $ehGUC = parcelRequire("ehGUC");

var $9SKNj = parcelRequire("9SKNj");

var $fHXCw = parcelRequire("fHXCw");

var $h5ei1 = parcelRequire("h5ei1");
const $8215af3ea39f4647$var$titleContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $8215af3ea39f4647$var$iconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $8215af3ea39f4647$var$titleStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $8215af3ea39f4647$var$ContributorQueryFilterOptions = ({ localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const [filterData, { setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $ehGUC.contributorFilter).id
    });
    if (filterData?.isLoading) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fHXCw.FilterOptionSkeletons), {});
    if (!filterData || filterData.options.length === 0) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h5ei1.NoOptions), {});
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: filterData.options.map((option)=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9SKNj.Option), {
                title: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $8215af3ea39f4647$var$titleContainerStyles,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $8215af3ea39f4647$var$iconStyles,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
                                src: option.avatarUrl,
                                size: "small",
                                borderColor: "transparent",
                                appearance: "circle",
                                name: option.label
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $8215af3ea39f4647$var$titleStyles,
                            as: "span",
                            children: option.label
                        })
                    ]
                }),
                option: option,
                setOption: setOption,
                localQuery: localQuery,
                setLocalQuery: setLocalQuery,
                inputRef: inputRef
            }, option.value);
        })
    });
};
const $8215af3ea39f4647$export$385c746fbc3d50c5 = ({ localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    if (!currentQueryFilter) return null;
    if (currentQueryFilter.filterId === 'contributor') return /*#__PURE__*/ (0, $7UHDa.jsx)($8215af3ea39f4647$var$ContributorQueryFilterOptions, {
        localQuery: localQuery,
        setLocalQuery: setLocalQuery,
        inputRef: inputRef
    });
    return null;
};

});
parcelRegister("9SKNj", function(module, exports) {

$parcel$export(module.exports, "Option", () => $9dcebcedad235590$export$36d18380658d5d20);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $4AkKf = parcelRequire("4AkKf");

var $u9agA = parcelRequire("u9agA");

var $k2YFb = parcelRequire("k2YFb");

var $eKxuB = parcelRequire("eKxuB");

var $kI4Ow = parcelRequire("kI4Ow");

var $inrbX = parcelRequire("inrbX");

var $hvVqi = parcelRequire("hvVqi");

var $4VmlX = parcelRequire("4VmlX");

var $68IrG = parcelRequire("68IrG");
const $9dcebcedad235590$export$36d18380658d5d20 = ({ title: title, option: option, setOption: setOption, localQuery: localQuery, setLocalQuery: setLocalQuery, inputRef: inputRef })=>{
    const intl = (0, $dBxQj.default)();
    const currentQueryFilter = (0, $4VmlX.useCurrentQueryFilter)();
    const { addSelectedQueryFilter: addSelectedQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
        label: intl.formatMessage((0, $68IrG.messages).filterIconLabel)
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const onResultClicked = (0, $gwFzn.useCallback)(()=>{
        if (!currentQueryFilter) return;
        // Set the filter
        setOption({
            ...option,
            isSelected: false
        });
        // Update the query shown in the input
        const newLocalQuery = (0, $hvVqi.getInputQueryWithNewSelectedQueryFilter)(localQuery, currentQueryFilter?.keyword, option.label);
        setLocalQuery(newLocalQuery);
        // Update the selected query filters
        addSelectedQueryFilter({
            filterId: currentQueryFilter.filterId,
            keyword: currentQueryFilter.keyword,
            displayText: currentQueryFilter.keyword + option.label,
            option: option
        });
        // Fire analytics event
        fireAnalyticsEvent((0, $kI4Ow.onQueryFilterSelected)({
            actionSubjectId: currentQueryFilter.filterId,
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
        inputRef?.current?.focus();
    }, [
        addSelectedQueryFilter,
        commonAttributes,
        currentQueryFilter,
        fireAnalyticsEvent,
        inputRef,
        localQuery,
        nonPrivacySafeAttributes,
        option,
        setLocalQuery,
        setOption
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        id: option.value,
        icon: icon,
        title: title,
        resultType: 'queryFilters',
        onResultClicked: onResultClicked,
        highlightedRightMetadata: highlightedRightMetadata
    });
};

});
parcelRegister("kI4Ow", function(module, exports) {

$parcel$export(module.exports, "onQueryFilterSelected", () => $e6d2962f130fd57e$export$724848965240e03c);
const $e6d2962f130fd57e$export$724848965240e03c = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'selected',
        actionSubject: 'queryFilter',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("hvVqi", function(module, exports) {

$parcel$export(module.exports, "useFilterKeywordToFilterId", () => $a00b54be6ab004d4$export$c37f199dbeef0d2c);
$parcel$export(module.exports, "useFilterKeywordToFilterActions", () => $a00b54be6ab004d4$export$170a7ded78a9d477);
$parcel$export(module.exports, "findQueryFilterKeyword", () => $a00b54be6ab004d4$export$a47046b35fa42e2d);
$parcel$export(module.exports, "getFilterLookupQuery", () => $a00b54be6ab004d4$export$3141a593bcb9212f);
$parcel$export(module.exports, "getQueryWithoutSelectedQueryFilters", () => $a00b54be6ab004d4$export$f0a1ecf34ab38b2d);
$parcel$export(module.exports, "getInputQueryWithNewSelectedQueryFilter", () => $a00b54be6ab004d4$export$53fd39a93e83286f);

var $gwFzn = parcelRequire("gwFzn");

var $5cssW = parcelRequire("5cssW");

var $aGXLL = parcelRequire("aGXLL");
const $a00b54be6ab004d4$export$c37f199dbeef0d2c = ()=>{
    return (0, $gwFzn.useMemo)(()=>{
        const contributorFilterMapping = Object.fromEntries((0, $aGXLL.CONTRIBUTOR_FILTER_QUERY_KEYWORDS).map((keyword)=>[
                keyword,
                (0, $aGXLL.filter).id
            ]));
        return {
            ...contributorFilterMapping
        };
    }, []);
};
const $a00b54be6ab004d4$export$170a7ded78a9d477 = ()=>{
    const contributorFilterFromStore = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aGXLL.filter).id
    });
    return (0, $gwFzn.useMemo)(()=>{
        const contributorFilterMapping = Object.fromEntries((0, $aGXLL.CONTRIBUTOR_FILTER_QUERY_KEYWORDS).map((keyword)=>[
                keyword,
                contributorFilterFromStore[1]
            ]));
        return {
            ...contributorFilterMapping
        };
    // Only want to make this object once as we only need access to the actions
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const $a00b54be6ab004d4$export$a47046b35fa42e2d = (query, filterKeywords)=>{
    for (const keyword of filterKeywords){
        if (query.includes(keyword)) return keyword;
    }
};
const $a00b54be6ab004d4$export$3141a593bcb9212f = (query, filterKeyword)=>{
    if (!query.includes(filterKeyword)) return;
    const lookupQueryIndexStart = query.lastIndexOf(filterKeyword) + filterKeyword.length;
    const lookupQuery = query.substring(lookupQueryIndexStart);
    return lookupQuery;
};
const $a00b54be6ab004d4$export$f0a1ecf34ab38b2d = (inputQuery, selectedQueryFilters)=>{
    let filteredQuery = inputQuery;
    for (const selectedQueryFilter of selectedQueryFilters)filteredQuery = filteredQuery.replace(selectedQueryFilter.displayText, '');
    return filteredQuery;
};
const $a00b54be6ab004d4$export$53fd39a93e83286f = (inputQuery, keyword, displayText)=>{
    // Find the last occurrence of the keyword
    const keywordIndex = inputQuery.lastIndexOf(keyword);
    return inputQuery.substring(0, keywordIndex) + keyword + displayText;
};

});

parcelRegister("68IrG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $becbf29994847995$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $becbf29994847995$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    filterIconLabel: {
        id: "filter",
        defaultMessage: "Filter icon"
    }
});

});


parcelRegister("fHXCw", function(module, exports) {

$parcel$export(module.exports, "FilterOptionSkeletons", () => $51a381ed95ba126a$export$cc8f1bc150ee9d84);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $51a381ed95ba126a$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $51a381ed95ba126a$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'border.radius.200',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
});
const $51a381ed95ba126a$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $51a381ed95ba126a$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius.100'
});
const $51a381ed95ba126a$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $51a381ed95ba126a$var$titleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius.100',
    height: '16px',
    width: '40%'
});
const $51a381ed95ba126a$export$1983fc89ea4805f2 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $51a381ed95ba126a$var$containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            xcss: [
                $51a381ed95ba126a$var$resultStyles
            ],
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $51a381ed95ba126a$var$iconAreaStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $51a381ed95ba126a$var$iconStyles
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $51a381ed95ba126a$var$middleAreaStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $51a381ed95ba126a$var$titleStyles
                        ]
                    })
                })
            ]
        })
    });
};
const $51a381ed95ba126a$export$cc8f1bc150ee9d84 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($51a381ed95ba126a$export$1983fc89ea4805f2, {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)($51a381ed95ba126a$export$1983fc89ea4805f2, {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)($51a381ed95ba126a$export$1983fc89ea4805f2, {})
        ]
    });
};

});

parcelRegister("h5ei1", function(module, exports) {

$parcel$export(module.exports, "NoOptions", () => $b44fb3788556f802$export$eac7c78123119abb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $bk7QC = parcelRequire("bk7QC");
const $b44fb3788556f802$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 'space.200'
});
const $b44fb3788556f802$export$eac7c78123119abb = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $b44fb3788556f802$var$containerStyles,
        children: intl.formatMessage((0, $bk7QC.messages).noOptions)
    });
};

});
parcelRegister("bk7QC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5fda3f2bb8e62542$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $5fda3f2bb8e62542$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    noOptions: {
        id: "noOptions",
        defaultMessage: "No options"
    }
});

});



parcelRegister("hPvza", function(module, exports) {

$parcel$export(module.exports, "RecentActivity", () => $bfef7c7cb8b104c2$export$8d9137fcb112aeab);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $hWR4v = parcelRequire("hWR4v");
var $6h3V2 = parcelRequire("6h3V2");
var $gzcCN = parcelRequire("gzcCN");

var $icWhS = parcelRequire("icWhS");
var $bloXB = parcelRequire("bloXB");

var $k2YFb = parcelRequire("k2YFb");

var $1yEFx = parcelRequire("1yEFx");

var $3E8x9 = parcelRequire("3E8x9");

var $aRSt4 = parcelRequire("aRSt4");

var $9LULT = parcelRequire("9LULT");

var $e9NQR = parcelRequire("e9NQR");

var $eKxuB = parcelRequire("eKxuB");

var $Y34Hw = parcelRequire("Y34Hw");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $adUP1 = parcelRequire("adUP1");
const $bfef7c7cb8b104c2$var$labelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $bfef7c7cb8b104c2$var$mapConfluenceActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { title: title, space: space, links: links } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Confluence
    });
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const isLiveDoc = activity.object.data?.subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    const type = [
        'confluence-type',
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: isLiveDoc ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $adUP1.messages).liveDoc
            }) : activity.object.type
        })
    ];
    const spaceName = space?.name || '';
    const metadata = [
        type,
        spaceName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const urlBase = links?.base;
    const urlWebUi = links?.webUi;
    const url = urlBase && urlWebUi && `${urlBase}${urlWebUi}`;
    const spaceId = space?.id;
    const analyticsMetadata = {
        contentId: id,
        containerId: spaceId,
        contentType: `confluence ${activity.object.type}`,
        product: `confluence`
    };
    if (!title || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapJiraActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { key: key, fieldsById: fieldsById, webUrl: webUrl } = activity.object.data;
    const statusName = activity.object.data?.statusCategory?.name;
    const statusColor = activity.object.data?.statusCategory?.colorName;
    const status = (0, $e9NQR.getStatus)(statusName, statusColor);
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Jira
    });
    const summary = fieldsById?.edges?.[0]?.node?.text;
    const title = key && summary && `${key}: ${summary}`;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const titleMetadataParts = status && (0, $dh538.fg)('enable_status_jira_issues_quick_find') ? [
        [
            'status',
            status
        ]
    ] : [];
    const type = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $bfef7c7cb8b104c2$var$labelContainer,
        children: activity.object.type
    });
    const metadata = [
        [
            'jira-type',
            type
        ]
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `jira ${activity.object.type}`,
        product: `jira`
    };
    if (!title || !webUrl) return undefined;
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: webUrl,
        analyticsMetadata: analyticsMetadata,
        titleMetadataParts: titleMetadataParts
    };
};
const $bfef7c7cb8b104c2$var$mapTownsquareActivityToSearchResult = (activity, query)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { name: name, key: key, url: url } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: (0, $1yEFx.ProductKeys).Atlas
    });
    const highlightedTitle = name && query ? (0, $bloXB.highlightMatchedText)(name, query.split(' ')).highlightedTitle : undefined;
    const type = [
        'type',
        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: activity.object.type
        })
    ];
    const metadata = [
        type,
        key ?? null
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `townsquare ${activity.object.type}`,
        product: `townsquare`
    };
    if (!name || !url) return undefined;
    return {
        id: id,
        icon: icon,
        title: name,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphDocumentActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { type: type, displayName: displayName, parent: parent, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    let product = '';
    if (providerId) product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, providerId) || 'graph';
    if ((product === 'graph' || !providerId) && id) {
        const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
        const resourceType = resourceOwner.split('.').at(1);
        product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    }
    if (!Object.values((0, $1yEFx.ProductKeys)).includes(product)) return;
    const subtype = type?.category?.toLowerCase();
    const label = (0, $9LULT.getDocumentSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...label
            })
        }) : subtype ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
        }) : null
    ];
    const parentName = parent?.displayName ?? null;
    const metadata = [
        typeLabel,
        parentName
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphRemoteLinkActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if (!activity.object.data) return;
    const { category: category, displayName: displayName, url: url, provider: provider } = activity.object.data;
    const id = activity.object.id;
    const providerId = provider?.providerId;
    let product = '';
    let productDisplayName = '';
    if (providerId) {
        product = (0, $Y34Hw.getProductFromProviderId)(thirdPartyConfigs, providerId) || 'graph';
        productDisplayName = (0, $Y34Hw.getProductDisplayNameFromProviderId)(thirdPartyConfigs, providerId) || '';
    }
    if ((product === 'graph' || !providerId) && id) {
        const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
        const resourceType = resourceOwner.split('.').at(1);
        product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    }
    if (!Object.values((0, $1yEFx.ProductKeys)).includes(product)) return;
    const subtype = category?.toLowerCase();
    const label = (0, $9LULT.getRemoteLinkSubtypeLabel)({
        product: product,
        subtype: subtype
    });
    const title = displayName;
    if (!title || !url) return undefined;
    const highlightedTitle = title && query ? (0, $bloXB.highlightMatchedText)(title, query.split(' ')).highlightedTitle : undefined;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
        size: "small",
        product: product
    });
    const productLabel = [
        'productLabel',
        productDisplayName ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: productDisplayName
        }) : null
    ];
    const typeLabel = [
        'typeLabel',
        label ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $bfef7c7cb8b104c2$var$labelContainer,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...label
            })
        }) : null
    ];
    const metadata = [
        productLabel,
        typeLabel
    ];
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3E8x9.EventTypeMessage), {
        timestamp: timestamp,
        eventType: eventType,
        isMyActivityData: true
    });
    const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        children: [
            rightMetadata,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
        ]
    });
    const analyticsMetadata = {
        contentId: id,
        contentType: `${product} ${subtype}`,
        product: product
    };
    return {
        id: id,
        icon: icon,
        title: title,
        highlightedTitle: highlightedTitle,
        metadata: metadata,
        rightMetadata: rightMetadata,
        highlightedRightMetadata: highlightedRightMetadata,
        url: url,
        analyticsMetadata: analyticsMetadata
    };
};
const $bfef7c7cb8b104c2$var$mapGraphActivityToSearchResult = (activity, query, thirdPartyConfigs)=>{
    if ((0, $hWR4v.isDocumentActivity)(activity.object)) return $bfef7c7cb8b104c2$var$mapGraphDocumentActivityToSearchResult(activity, query, thirdPartyConfigs);
    if ((0, $hWR4v.isRemoteLinkActivity)(activity.object) && (0, $dh538.fg)('smartlinks-qf-recents')) return $bfef7c7cb8b104c2$var$mapGraphRemoteLinkActivityToSearchResult(activity, query, thirdPartyConfigs);
    return undefined;
};
const $bfef7c7cb8b104c2$export$1d02b83d52558ed = (edge, query, searchSessionId, thirdPartyConfigs)=>{
    const activity = edge.node;
    const product = activity.object.product;
    const result = (0, $hWR4v.isGraphActivity)(activity.object) ? $bfef7c7cb8b104c2$var$mapGraphActivityToSearchResult(activity, query, thirdPartyConfigs) : product === 'confluence' ? $bfef7c7cb8b104c2$var$mapConfluenceActivityToSearchResult(activity, query) : product === 'jira' ? $bfef7c7cb8b104c2$var$mapJiraActivityToSearchResult(activity, query) : product === 'townsquare' ? $bfef7c7cb8b104c2$var$mapTownsquareActivityToSearchResult(activity, query) : undefined;
    if (!result) return undefined;
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        ...result,
        url: urlWithAnalyticsQueryParams
    };
};
const $bfef7c7cb8b104c2$export$8d9137fcb112aeab = ({ result: result, state: state, onClick: onClick, onContextMenu: onContextMenu, onHighlighted: onHighlighted })=>{
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [{ thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const mappedResult = $bfef7c7cb8b104c2$export$1d02b83d52558ed(result, quickFindQuery, searchSessionId, thirdPartyConfigs);
    const additionalAnalyticsAttributes = (0, $gwFzn.useMemo)(()=>({
            isCached: true,
            metadata: mappedResult?.analyticsMetadata,
            is3pLink: (0, $1yEFx.all3pProductKeys).includes(mappedResult?.analyticsMetadata.product)
        }), [
        mappedResult
    ]);
    const onResultClicked = (0, $gwFzn.useCallback)((event, data)=>{
        onClick?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onClick,
        state
    ]);
    const onResultContextMenu = (0, $gwFzn.useCallback)((event, data)=>{
        onContextMenu?.({
            event: event,
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onContextMenu,
        state
    ]);
    const onResultHighlighted = (0, $gwFzn.useCallback)((data)=>{
        onHighlighted?.({
            data: data,
            state: state,
            additionalAnalyticsAttributes: additionalAnalyticsAttributes
        });
    }, [
        additionalAnalyticsAttributes,
        onHighlighted,
        state
    ]);
    if (!mappedResult) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        ...mappedResult,
        resultType: "recentActivities",
        product: mappedResult.analyticsMetadata.product,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onResultHighlighted: onResultHighlighted
    });
};

});
parcelRegister("adUP1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3a985a01f765cd1f$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $3a985a01f765cd1f$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    }
});

});


parcelRegister("8IQPm", function(module, exports) {

$parcel$export(module.exports, "RecentQuery", () => $8aeaf6643ef42bf9$export$de317f365b3e4c5c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $kevJM = parcelRequire("kevJM");

var $5H7UU = parcelRequire("5H7UU");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $1SV4e = parcelRequire("1SV4e");

var $k2YFb = parcelRequire("k2YFb");

var $7WbA8 = parcelRequire("7WbA8");

var $eKxuB = parcelRequire("eKxuB");

var $gOMqv = parcelRequire("gOMqv");

var $4PIs2 = parcelRequire("4PIs2");

var $inrbX = parcelRequire("inrbX");

var $dSjat = parcelRequire("dSjat");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $e1gWV = parcelRequire("e1gWV");
const $8aeaf6643ef42bf9$export$de317f365b3e4c5c = ({ result: result, state: state })=>{
    const intl = (0, $dBxQj.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const [user] = (0, $j4ply.useUser)();
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onResultClicked = (0, $gwFzn.useCallback)((event)=>{
        const newTab = event && (event.ctrlKey || event.metaKey || event.shiftKey);
        if (!newTab) {
            if ((0, $dh538.fg)('rovo_search_quick_find_prefetch')) (0, $gOMqv.preloadSearchPageResults)({
                searchQuery: result
            });
            setQuickFindOpen(false);
        }
        // Move this recent query to the top of the list
        if (result && user && user.id && primaryProduct) {
            (0, $1SV4e.addRecentSearch)(result, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
            updateRecentQueries?.();
        }
        fireAnalyticsEvent((0, $4PIs2.onRecentQuerySelected)({
            actionSubjectId: (0, $dSjat.getActionSubjectId)(state),
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        primaryProduct,
        result,
        setQuickFindOpen,
        state,
        updateRecentQueries,
        user
    ]);
    const mapRecentQueryToSearchResult = (0, $gwFzn.useCallback)((query)=>{
        const id = query;
        const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: intl.formatMessage((0, $e1gWV.messages).recentSearch),
            color: "currentColor"
        });
        const title = query;
        const onClick = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            if (user.id && primaryProduct) {
                (0, $1SV4e.removeRecentSearch)(query, user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
        };
        const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            children: intl.formatMessage((0, $e1gWV.messages).recentSearch)
        });
        const hoveredRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    children: intl.formatMessage((0, $e1gWV.messages).recentSearch)
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5H7UU))),
                    spacing: 'compact',
                    onClick: onClick,
                    label: intl.formatMessage((0, $e1gWV.messages).recentSearch)
                })
            ]
        });
        const highlightedRightMetadata = /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    children: intl.formatMessage((0, $e1gWV.messages).recentSearch)
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
            ]
        });
        const url = generateSearchUrl({
            ...queryParams,
            text: query,
            search_id: searchSessionId
        });
        return {
            id: id,
            icon: icon,
            title: title,
            url: url,
            rightMetadata: rightMetadata,
            hoveredRightMetadata: hoveredRightMetadata,
            highlightedRightMetadata: highlightedRightMetadata
        };
    }, [
        intl,
        generateSearchUrl,
        queryParams,
        searchSessionId,
        user.id,
        primaryProduct,
        updateRecentQueries
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKxuB.SearchResult), {
        resultType: "recentQueries",
        ...mapRecentQueryToSearchResult(result),
        onResultClicked: onResultClicked
    });
};

});
parcelRegister("4PIs2", function(module, exports) {

$parcel$export(module.exports, "onRecentQuerySelected", () => $7ce255b0a50b97ee$export$18593f729c2ce860);
const $7ce255b0a50b97ee$export$18593f729c2ce860 = ({ actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'selected',
        actionSubject: 'recentQuery',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("e1gWV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $59ce0bd6e733cc83$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $59ce0bd6e733cc83$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    recentSearch: {
        id: "search_dialog_recent_search",
        defaultMessage: "Recent search"
    },
    removeRecentSearch: {
        id: "search_dialog_remove_recent_search_label",
        defaultMessage: "Remove recent search"
    }
});

});


parcelRegister("hDfbs", function(module, exports) {

$parcel$export(module.exports, "SearchResultSkeleton", () => $191ce2f0a4d53c1e$export$dd3282b157ef6f7a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $191ce2f0a4d53c1e$var$containerStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.100',
    marginInlineEnd: 'space.100'
});
const $191ce2f0a4d53c1e$var$resultStyles = (0, $ecnYn.xcss)({
    paddingBlockStart: 'space.075',
    paddingBlockEnd: 'space.075',
    paddingInlineStart: 'space.100',
    paddingInlineEnd: 'space.100',
    borderRadius: 'border.radius.200',
    display: 'flex',
    alignItems: 'center',
    pointerEvents: 'none'
});
const $191ce2f0a4d53c1e$var$iconAreaStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $191ce2f0a4d53c1e$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200',
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius.100'
});
const $191ce2f0a4d53c1e$var$middleAreaStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
    flex: 1,
    marginLeft: 'space.150'
});
const $191ce2f0a4d53c1e$var$titleStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.skeleton',
    borderRadius: 'border.radius.100',
    height: '16px',
    width: '40%'
});
const $191ce2f0a4d53c1e$var$metadataStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'color.skeleton',
    width: '20%',
    borderRadius: 'border.radius.100',
    height: '13px'
});
const $191ce2f0a4d53c1e$export$dd3282b157ef6f7a = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $191ce2f0a4d53c1e$var$containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            xcss: [
                $191ce2f0a4d53c1e$var$resultStyles
            ],
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $191ce2f0a4d53c1e$var$iconAreaStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: $191ce2f0a4d53c1e$var$iconStyles
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $191ce2f0a4d53c1e$var$middleAreaStyles,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $191ce2f0a4d53c1e$var$titleStyles
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: [
                                $191ce2f0a4d53c1e$var$metadataStyles
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("fscQt", function(module, exports) {

$parcel$export(module.exports, "SearchPageLink", () => $130bb7db5dbd93df$export$bf6cf7fe2100de5c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $jluld = parcelRequire("jluld");

var $dh538 = parcelRequire("dh538");

var $u9agA = parcelRequire("u9agA");

var $k2YFb = parcelRequire("k2YFb");

var $7WbA8 = parcelRequire("7WbA8");

var $83gV2 = parcelRequire("83gV2");

var $gOMqv = parcelRequire("gOMqv");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $c6Son = parcelRequire("c6Son");
const $130bb7db5dbd93df$export$bf6cf7fe2100de5c = ({ state: state, onClick: onClick })=>{
    const intl = (0, $dBxQj.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const onResultClicked = (0, $gwFzn.useCallback)((event)=>{
        onClick({
            state: state,
            event: event,
            actionSubjectId: `${primaryProduct?.toLowerCase() || ''}AdvancedSearchLink`
        });
        if ((0, $dh538.fg)('rovo_search_quick_find_prefetch')) (0, $gOMqv.preloadSearchPageResults)({
            searchQuery: quickFindQuery,
            contributors: queryParams.contributors
        });
        if ((0, $dh538.fg)('quick_find_filters')) // TODO: This is a temporary measure until we do QS-6716 post Team 25 where it syncs filters with FPS.
        // For now, executing a search query on FPS search will always clear the filters in QF as FPS filters
        // is the source of truth for filter state.
        clearAllFilters();
    }, [
        onClick,
        state,
        primaryProduct,
        quickFindQuery,
        clearAllFilters,
        queryParams
    ]);
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
        label: intl.formatMessage((0, $c6Son.messages).searchAcrossProducts),
        color: "currentColor"
    });
    const title = intl.formatMessage((0, $c6Son.messages).searchAcrossProducts);
    const rightMetadata = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
    });
    const url = generateSearchUrl({
        ...queryParams,
        text: quickFindQuery
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $83gV2.SearchFooter), {
        icon: icon,
        title: title,
        rightMetadata: rightMetadata,
        url: url,
        onResultClicked: onResultClicked
    });
};

});
parcelRegister("c6Son", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fbb70dd8ca3729b4$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $fbb70dd8ca3729b4$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    searchAcrossProducts: {
        id: "search_dialog_search_across_products",
        defaultMessage: "Search across products"
    }
});

});


parcelRegister("3qFOk", function(module, exports) {

$parcel$export(module.exports, "SearchPagePrimaryProductLink", () => $3cfecd681a6a1322$export$2b7ed2e07f16b196);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $4AkKf = parcelRequire("4AkKf");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $9vOy1 = parcelRequire("9vOy1");

var $ltx9b = parcelRequire("ltx9b");

var $e4RDM = parcelRequire("e4RDM");

var $k2YFb = parcelRequire("k2YFb");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $aRSt4 = parcelRequire("aRSt4");

var $83gV2 = parcelRequire("83gV2");

var $gOMqv = parcelRequire("gOMqv");

var $19BAV = parcelRequire("19BAV");

var $j4ply = parcelRequire("j4ply");

var $4VmlX = parcelRequire("4VmlX");

var $3SISy = parcelRequire("3SISy");
const $3cfecd681a6a1322$var$titleStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $3cfecd681a6a1322$var$confluenceIconContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    paddingInline: 'space.050',
    alignItems: 'end'
});
const $3cfecd681a6a1322$export$2b7ed2e07f16b196 = ({ state: state, onClick: onClick })=>{
    const intl = (0, $dBxQj.default)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const onResultClicked = (0, $gwFzn.useCallback)((event)=>{
        onClick({
            event: event,
            state: state,
            actionSubjectId: `${primaryProduct?.toLowerCase() || ''}AdvancedSearchLink`
        });
        if ((0, $dh538.fg)('rovo_search_quick_find_prefetch')) (0, $gOMqv.preloadSearchPageResults)({
            searchQuery: quickFindQuery,
            contributors: queryParams.contributors
        });
    }, [
        onClick,
        state,
        primaryProduct,
        quickFindQuery,
        queryParams
    ]);
    const title = (0, $gwFzn.useMemo)(()=>{
        if (primaryProduct === 'confluence') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $3cfecd681a6a1322$var$titleStyles,
            children: intl.formatMessage((0, $3SISy.messages).filterByConfluence, {
                confluenceIcon: (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $3cfecd681a6a1322$var$confluenceIconContainerStyles,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
                        product: (0, $1yEFx.ProductKeys).Confluence,
                        size: "small"
                    })
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aRSt4.ProductIcon), {
                    product: (0, $1yEFx.ProductKeys).Confluence,
                    size: "small"
                })
            })
        });
        else if (primaryProduct === 'mercury') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
            xcss: $3cfecd681a6a1322$var$titleStyles,
            children: intl.formatMessage((0, $3SISy.messages).filterByMercury)
        });
        else return null;
    }, [
        primaryProduct,
        intl
    ]);
    const rightMetadata = (0, $gwFzn.useMemo)(()=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $19BAV.default), {
                    requiredMode: (0, $9vOy1.ApplicationModes).Rovo,
                    children: window.navigator.userAgent.includes('Mac') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ltx9b.CommandIcon), {}) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e4RDM.ControlIcon), {})
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k2YFb.ReturnIcon), {})
            ]
        }), []);
    if (title === null) return null;
    const url = generateSearchUrl({
        ...queryParams,
        product: primaryProduct,
        text: quickFindQuery
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $83gV2.SearchFooter), {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
            label: "" // Icon is only for display purposes and this footer button purpose is in the title
            ,
            color: "currentColor"
        }),
        title: title,
        rightMetadata: rightMetadata,
        url: url,
        onResultClicked: onResultClicked
    });
};

});
parcelRegister("e4RDM", function(module, exports) {

$parcel$export(module.exports, "ControlIcon", () => $cf009b9a2e935b27$export$1de95e9d7dda5112);
// Copied from packages/search/product-search-dialog/src/extensible/quick-find/icons/control-icon.tsx

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $cf009b9a2e935b27$var$IconContainer = (0, $gwrgp.default)("span", {
    target: "e1uibf2e0"
})({
    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`,
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-border-radius-400, 4px)",
    border: "'1px solid transparent'",
    color: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${"var(--ds-space-075, 6px)"}`
});
const $cf009b9a2e935b27$export$1de95e9d7dda5112 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($cf009b9a2e935b27$var$IconContainer, {
        children: "Ctrl"
    });

});

parcelRegister("3SISy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1617c7a5c0a1c8ce$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $1617c7a5c0a1c8ce$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    filterByConfluence: {
        id: "search_dialog_filter_by_confluence",
        defaultMessage: "Filter by {confluenceIcon} Confluence spaces, contributors and more"
    },
    filterByMercury: {
        id: "search_dialog_filter_by_mercury",
        defaultMessage: "Filter by focus areas"
    }
});

});


parcelRegister("5BL1t", function(module, exports) {

$parcel$export(module.exports, "isErrorItem", () => $aed36fde90c7e426$export$6500cdbd153f3497);
$parcel$export(module.exports, "isLandingItem", () => $aed36fde90c7e426$export$6dc914a1cb2e7113);
$parcel$export(module.exports, "isNoResultsItem", () => $aed36fde90c7e426$export$993e95eb6704a94c);
$parcel$export(module.exports, "isHeadingItem", () => $aed36fde90c7e426$export$9050e45a166250f);
$parcel$export(module.exports, "isSkeletonItem", () => $aed36fde90c7e426$export$d680994c1f15882e);
$parcel$export(module.exports, "isRecentQueryItem", () => $aed36fde90c7e426$export$871ba967042323cb);
$parcel$export(module.exports, "isRecentActivityItem", () => $aed36fde90c7e426$export$329ac1434313f6b2);
$parcel$export(module.exports, "isSearchResultItem", () => $aed36fde90c7e426$export$746233dd1618793c);
$parcel$export(module.exports, "isPeopleAndTeamsItem", () => $aed36fde90c7e426$export$bc8d42212d76a15c);
const $aed36fde90c7e426$export$6500cdbd153f3497 = (item)=>{
    return item.type === 'error';
};
const $aed36fde90c7e426$export$6dc914a1cb2e7113 = (item)=>{
    return item.type === 'landing';
};
const $aed36fde90c7e426$export$993e95eb6704a94c = (item)=>{
    return item.type === 'no-results';
};
const $aed36fde90c7e426$export$9050e45a166250f = (item)=>{
    return item.type === 'heading';
};
const $aed36fde90c7e426$export$d680994c1f15882e = (item)=>{
    return item.type === 'skeleton';
};
const $aed36fde90c7e426$export$871ba967042323cb = (item)=>{
    return item.type === 'recent-query';
};
const $aed36fde90c7e426$export$329ac1434313f6b2 = (item)=>{
    return item.type === 'recent-activity';
};
const $aed36fde90c7e426$export$746233dd1618793c = (item)=>{
    return item.type === 'search-result';
};
const $aed36fde90c7e426$export$bc8d42212d76a15c = (item)=>{
    return item.type === 'people-and-teams';
};

});


parcelRegister("42YhP", function(module, exports) {

$parcel$export(module.exports, "LazyPreload", () => $c1277af91e0a07d7$export$7913deaaeb43b6ad);

var $gwFzn = parcelRequire("gwFzn");

const $c1277af91e0a07d7$export$7913deaaeb43b6ad = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("eadj7")));

});
parcelRegister("eadj7", function(module, exports) {

let $a4fc52689a9f2984$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a4fc52689a9f2984$var$load("jukzQ"),
    $a4fc52689a9f2984$var$load("01FrO")
]).then(()=>parcelRequire('9LjTt'));

});


parcelRegister("f8Fnp", function(module, exports) {

$parcel$export(module.exports, "SearchTextField", () => $33671f0d02952dbc$export$fb8d8fbc0c4c1705);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $1SV4e = parcelRequire("1SV4e");

var $icqFF = parcelRequire("icqFF");

var $9vOy1 = parcelRequire("9vOy1");

var $1yEFx = parcelRequire("1yEFx");

var $7WbA8 = parcelRequire("7WbA8");

var $hr2Qv = parcelRequire("hr2Qv");

var $2ok43 = parcelRequire("2ok43");

var $gOMqv = parcelRequire("gOMqv");

var $2vZke = parcelRequire("2vZke");

var $aE5mL = parcelRequire("aE5mL");

var $inrbX = parcelRequire("inrbX");

var $hvVqi = parcelRequire("hvVqi");

var $j4ply = parcelRequire("j4ply");
var $djVCD = parcelRequire("djVCD");

var $4VmlX = parcelRequire("4VmlX");

var $kW291 = parcelRequire("kW291");

var $b8c3g = parcelRequire("b8c3g");
const $33671f0d02952dbc$export$fb8d8fbc0c4c1705 = ({ dialogId: dialogId, inputRef: inputRef, localQuery: localQuery, setLocalQuery: setLocalQuery, textfieldComponent: textfieldComponent, postQueryDisabled: postQueryDisabled })=>{
    const previousTextQueryParam = (0, $gwFzn.useRef)();
    const [mounted, setMounted] = (0, $gwFzn.useState)(false);
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams, isNav4Enabled: isNav4Enabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $7WbA8.useAppContext)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [{ primaryProduct: primaryProduct, user: user }] = (0, $j4ply.useBootstrap)();
    const content = (0, $4VmlX.useContent)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const keyboardHighlight = (0, $icqFF.useKeyboardHighlightProvider)();
    const getSelectedIndex = keyboardHighlight?.getSelectedIndex;
    const updateRecentQueries = (0, $4VmlX.useUpdateRecentQueries)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { setQuickFindOpen: setQuickFindOpen, resetSelectedQueryFilters: resetSelectedQueryFilters } = (0, $4VmlX.useQuickFindActions)();
    const { setQueryUpdatedTime: setQueryUpdatedTime, clearAllFilters: clearAllFilters, setInputQuery: setInputQuery } = (0, $djVCD.useSearchActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const debouncedOnTextEnteredAnalyticsCallback = (0, $b8c3g.useDebouncedOnTextEnteredAnalyticsCallback)();
    (0, $2ok43.useInputSkeleton)({
        localQuery: localQuery,
        inputRef: inputRef
    });
    /**
	 * Handles the case when the input is hydrated after SSR. This effect
	 * retains the value, focus and cursor position of the input if the user
	 * started typing before hydration.
	 *
	 * If this component was not SSR'd, then the result of this effect
	 * is that the initial value is rendered only after the second render.
	 */ (0, $gwFzn.useEffect)(()=>{
        if (inputRef?.current) {
            if (inputRef.current.value) setLocalQuery(inputRef.current.value);
            const isFocused = document.activeElement === inputRef.current;
            const selectionStart = isFocused ? inputRef.current.selectionStart : null;
            const selectionEnd = isFocused ? inputRef.current.selectionEnd : null;
            if (isFocused) requestAnimationFrame(()=>{
                inputRef?.current?.focus();
                if (selectionStart !== null && selectionEnd !== null) inputRef?.current?.setSelectionRange(selectionStart, selectionEnd);
            });
        }
        setMounted(true);
    }, [
        inputRef,
        setLocalQuery
    ]);
    (0, $kW291.useQueryFilters)(localQuery, postQueryDisabled);
    // Only when the text query param changes, update the local query. If the
    // local query without selected query filters is the same as text query param,
    // do nothing.
    (0, $gwFzn.useEffect)(()=>{
        if (queryParams.text === previousTextQueryParam.current) return;
        previousTextQueryParam.current = queryParams.text;
        const localQueryWithoutSelectedQueryFilters = (0, $hvVqi.getQueryWithoutSelectedQueryFilters)(localQuery, selectedQueryFilters);
        const newLocalQuery = typeof queryParams.text === 'string' ? queryParams.text : '';
        if (localQueryWithoutSelectedQueryFilters !== newLocalQuery) {
            setInputQuery(newLocalQuery);
            setLocalQuery(newLocalQuery);
            clearAllFilters();
            resetSelectedQueryFilters();
        }
    }, [
        clearAllFilters,
        queryParams.text,
        resetSelectedQueryFilters,
        selectedQueryFilters,
        setLocalQuery,
        localQuery,
        setInputQuery
    ]);
    // Update query time when query changes
    (0, $gwFzn.useEffect)(()=>{
        setQueryUpdatedTime();
    }, [
        setQueryUpdatedTime,
        localQuery
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (quickFindOpen) inputRef?.current?.focus();
        else inputRef?.current?.blur();
    }, [
        inputRef,
        quickFindOpen
    ]);
    const onKeyDown = (0, $gwFzn.useCallback)((event)=>{
        /**
			 * Ignore enter key press if a search result is highlighted as we let
			 * the keyboard highlight provider handle the event in this case.
			 */ const resultHighlighted = getSelectedIndex && getSelectedIndex() !== undefined;
        if (event.key === 'Enter' && !resultHighlighted) {
            if (!primaryProduct) return;
            /**
				 * Stop the event from propagating to prevent UFO
				 * VC90 metric from being cancelled on route change.
				 */ event.stopPropagation();
            // Prefetch FPS results
            if ((0, $dh538.fg)('rovo_search_quick_find_prefetch')) (0, $gOMqv.preloadSearchPageResults)({
                searchQuery: quickFindQuery,
                contributors: queryParams.contributors
            });
            // Store search in recent searches
            if (quickFindQuery.trim() !== '' && user && user.id && primaryProduct) {
                (0, $1SV4e.addRecentSearch)(quickFindQuery.trim(), user.id, primaryProduct, (0, $1SV4e.RECENT_SEARCH_KEY));
                updateRecentQueries?.();
            }
            event.currentTarget.blur();
            setQuickFindOpen(false);
            fireAnalyticsEvent((0, $2vZke.onAdvancedSearchLinkSelected)({
                actionSubjectId: `${primaryProduct.toLowerCase()}AdvancedSearchLink`,
                attributes: {
                    ...commonAttributes,
                    trigger: 'return',
                    newTab: false,
                    isLoading: content?.state === (0, $aE5mL.State).PREQUERY_LOADING || content?.state === (0, $aE5mL.State).POSTQUERY_LOADING
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }));
            const searchForPrimaryProduct = !selectedProduct && (applicationMode === (0, $9vOy1.ApplicationModes).Rovo && (event.metaKey || event.ctrlKey) || applicationMode !== (0, $9vOy1.ApplicationModes).Rovo && !(event.metaKey || event.ctrlKey));
            if ((0, $dh538.fg)('quick_find_filters')) // TODO: This is a temporary measure until we do QS-6716 post Team 25 where it syncs filters with FPS.
            // For now, executing a search query on FPS search will always clear the filters in QF as FPS filters
            // is the source of truth for filter state.
            clearAllFilters();
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            onNavigateCallback(generateSearchUrl({
                ...queryParams,
                product: searchForPrimaryProduct ? primaryProduct : undefined,
                text: quickFindQuery
            }, !!(primaryProduct === (0, $1yEFx.PrimaryProductKeys).Jira && (event.metaKey || event.ctrlKey))), 'push');
        }
        if (event.key === 'Escape') {
            event.currentTarget.blur();
            setQuickFindOpen(false);
        }
    }, [
        getSelectedIndex,
        primaryProduct,
        quickFindQuery,
        user,
        setQuickFindOpen,
        fireAnalyticsEvent,
        commonAttributes,
        content?.state,
        nonPrivacySafeAttributes,
        selectedProduct,
        applicationMode,
        clearAllFilters,
        onNavigate,
        generateSearchUrl,
        queryParams,
        updateRecentQueries
    ]);
    const onChange = (0, $gwFzn.useCallback)((event)=>{
        const newQuery = event.currentTarget.value;
        setLocalQuery(newQuery);
        debouncedOnTextEnteredAnalyticsCallback();
    }, [
        debouncedOnTextEnteredAnalyticsCallback,
        setLocalQuery
    ]);
    const Textfield = textfieldComponent || (0, $hr2Qv.Textfield);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Textfield, {
        value: mounted ? localQuery : undefined,
        dialogId: dialogId,
        inputRef: inputRef,
        appMode: applicationMode,
        quickFindOpen: quickFindOpen,
        isNav4Enabled: isNav4Enabled,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        onFocus: ()=>setQuickFindOpen(true),
        onKeyDown: onKeyDown,
        onChange: onChange,
        onClear: ()=>{
            setLocalQuery('');
            inputRef?.current?.focus();
        }
    });
};

});
parcelRegister("kW291", function(module, exports) {

$parcel$export(module.exports, "useQueryFilters", () => $908389ef2c25a547$export$d3538183feb90c1a);

var $gwFzn = parcelRequire("gwFzn");

var $fVdiF = parcelRequire("fVdiF");

var $hvVqi = parcelRequire("hvVqi");

var $4VmlX = parcelRequire("4VmlX");
const $908389ef2c25a547$export$d3538183feb90c1a = (localQuery, postQueryDisabled)=>{
    const filterKeywordToFilterId = (0, $hvVqi.useFilterKeywordToFilterId)();
    const filterKeywordToFilterActions = (0, $hvVqi.useFilterKeywordToFilterActions)();
    const selectedQueryFilters = (0, $4VmlX.useSelectedQueryFilters)();
    const { setQuickFindQuery: setQuickFindQuery, deleteSelectedQueryFilter: deleteSelectedQueryFilter, setCurrentQueryFilter: setCurrentQueryFilter } = (0, $4VmlX.useQuickFindActions)();
    const [debouncedSetLookupInput, cancelDebouncedSetLookupInput] = (0, $fVdiF.default)((lookupInput, setLookupInput)=>{
        setLookupInput(lookupInput);
    }, 300);
    (0, $gwFzn.useEffect)(()=>{
        const queryWithoutSelectedQueryFilters = (0, $hvVqi.getQueryWithoutSelectedQueryFilters)(localQuery, selectedQueryFilters);
        const trimmedQuery = queryWithoutSelectedQueryFilters.trim();
        setQuickFindQuery(trimmedQuery);
    }, [
        localQuery,
        selectedQueryFilters,
        setQuickFindQuery
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (postQueryDisabled) return;
        // Deselect select query filters if their display text is no longer in the query
        for (const selectedQueryFilter of selectedQueryFilters)if (!localQuery.includes(selectedQueryFilter.displayText)) {
            const filterActions = filterKeywordToFilterActions[selectedQueryFilter.keyword];
            if (filterActions && selectedQueryFilter.option) {
                filterActions.setOption({
                    ...selectedQueryFilter.option,
                    isSelected: true
                });
                deleteSelectedQueryFilter(selectedQueryFilter);
            }
        }
        // To determine if a user is accessing a query filter, we use the query without
        // selected query filters to allow for multiple query filters to be used at once
        const queryWithoutSelectedQueryFilters = (0, $hvVqi.getQueryWithoutSelectedQueryFilters)(localQuery, selectedQueryFilters);
        // Determine if the user is using a query filter
        const filterKeywords = Object.keys(filterKeywordToFilterId);
        const keyword = (0, $hvVqi.findQueryFilterKeyword)(queryWithoutSelectedQueryFilters, filterKeywords);
        // Reset current query filter if keyword is not found
        if (!keyword) {
            cancelDebouncedSetLookupInput();
            setCurrentQueryFilter(undefined);
            return;
        }
        // Get the filter id and actioins for the filter corresponding to the keyword
        const filterId = filterKeywordToFilterId[keyword];
        const filterActions = filterKeywordToFilterActions[keyword];
        const filterLookupQuery = (0, $hvVqi.getFilterLookupQuery)(queryWithoutSelectedQueryFilters, keyword);
        // Load the options for the filter
        if (filterId && filterActions && filterLookupQuery !== undefined) {
            setCurrentQueryFilter({
                filterId: filterId,
                keyword: keyword
            });
            cancelDebouncedSetLookupInput();
            if (filterLookupQuery === '') {
                filterActions.loadInitialOptions();
                filterActions.setLookupInput('');
            } else debouncedSetLookupInput(filterLookupQuery, filterActions.setLookupInput);
        }
    }, [
        selectedQueryFilters,
        filterKeywordToFilterId,
        filterKeywordToFilterActions,
        deleteSelectedQueryFilter,
        setCurrentQueryFilter,
        localQuery,
        cancelDebouncedSetLookupInput,
        debouncedSetLookupInput,
        postQueryDisabled
    ]);
};

});

parcelRegister("b8c3g", function(module, exports) {

$parcel$export(module.exports, "useDebouncedOnTextEnteredAnalyticsCallback", () => $9fa79de2eb008d7c$export$fe11394d33dcb3dd);

var $gwFzn = parcelRequire("gwFzn");

var $ioxS0 = parcelRequire("ioxS0");

var $JQd0k = parcelRequire("JQd0k");

var $inrbX = parcelRequire("inrbX");

var $4VmlX = parcelRequire("4VmlX");
const $9fa79de2eb008d7c$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME = 300;
const $9fa79de2eb008d7c$export$fe11394d33dcb3dd = ()=>{
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const fireOnTextEnteredAnalyticsCallback = (0, $gwFzn.useCallback)(()=>{
        if (!quickFindOpen) return;
        fireAnalyticsEvent((0, $ioxS0.onTextEntered)({
            attributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        nonPrivacySafeAttributes,
        quickFindOpen
    ]);
    return (0, $JQd0k.useDebouncedCallback)(fireOnTextEnteredAnalyticsCallback, $9fa79de2eb008d7c$var$ON_TEXT_ENTERED_ANALYTICS_DEBOUNCE_TIME);
};

});
parcelRegister("ioxS0", function(module, exports) {

$parcel$export(module.exports, "onTextEntered", () => $4af3204510a58241$export$db28d8e16fb16e80);
const $4af3204510a58241$export$db28d8e16fb16e80 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: 'entered',
        actionSubject: 'text',
        actionSubjectId: 'searchDialogTextField',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});



parcelRegister("jQSTy", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", () => $00b97e1dc9e8581d$export$92dae2778ae88f9d);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $dh538 = parcelRequire("dh538");

var $4VmlX = parcelRequire("4VmlX");
const $00b97e1dc9e8581d$export$92dae2778ae88f9d = ({ dialogRef: dialogRef, inputBoxRef: inputBoxRef })=>{
    const mouseDownInside = (0, $gwFzn.useRef)(false);
    const [isFeedbackModalOpen] = (0, $4VmlX.useIsFeedbackModalOpen)();
    const [isBulkConnectModalOpen] = (0, $4VmlX.useIsBulkConnectModalOpen)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    (0, $gwFzn.useEffect)(()=>{
        const onMouseDown = (event)=>{
            mouseDownInside.current = false;
            const { target: target } = event;
            const targetNode = target;
            const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
            const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
            if (isClickOnPopup || isClickOnTrigger) mouseDownInside.current = true;
        };
        const onClick = (event)=>{
            const { target: target } = event;
            const targetNode = target;
            if (isFeedbackModalOpen) return;
            if (isBulkConnectModalOpen && (0, $dh538.fg)('3p_bulk_connect')) return;
            const isClickOnPopup = dialogRef.current && dialogRef.current.contains(targetNode);
            const isClickOnTrigger = inputBoxRef.current && inputBoxRef.current.contains(targetNode);
            if (!isClickOnPopup && !isClickOnTrigger && !mouseDownInside.current) setQuickFindOpen(false);
        };
        const onKeyDown = (event)=>{
            const { key: key } = event;
            if (key === 'Escape' || key === 'Esc') setQuickFindOpen(false);
        };
        const onBlur = (e)=>{
            const activeElement = document.activeElement;
            const activeElementIsIFrame = activeElement instanceof HTMLIFrameElement;
            // Close Quick Find if the new active element is an iframe, we need
            // to do this check since click events are not fired on iframes
            if (activeElementIsIFrame) setQuickFindOpen(false);
        };
        const unbind = (0, $d8F95.bindAll)(window, [
            {
                type: 'mousedown',
                listener: onMouseDown,
                options: {
                    capture: false
                }
            },
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: true
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'blur',
                listener: onBlur
            }
        ]);
        return ()=>{
            unbind();
        };
    }, [
        setQuickFindOpen,
        isFeedbackModalOpen,
        isBulkConnectModalOpen,
        dialogRef,
        inputBoxRef
    ]);
};

});

parcelRegister("j5QtW", function(module, exports) {

$parcel$export(module.exports, "usePreQueryDwellTimeAnalytics", () => $37f7a1f5b4662dd4$export$20260e4d2b6c9d50);

var $gwFzn = parcelRequire("gwFzn");

var $7WbA8 = parcelRequire("7WbA8");

var $2ok43 = parcelRequire("2ok43");

var $bfgmu = parcelRequire("bfgmu");

var $g9TqG = parcelRequire("g9TqG");

var $inrbX = parcelRequire("inrbX");

var $4VmlX = parcelRequire("4VmlX");
const $37f7a1f5b4662dd4$export$20260e4d2b6c9d50 = ()=>{
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindOpen = (0, $4VmlX.useQuickFindOpen)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const hadInitialQuery = (0, $gwFzn.useRef)(Boolean((0, $2ok43.getInitialQuery)() || queryParams.text));
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const { start: startTimer, stop: stopTimer, cancel: cancelTimer } = (0, $g9TqG.useTimer)({
        onTimerEnd: (ms)=>fireAnalyticsEvent((0, $bfgmu.onPreQueryDwelled)({
                attributes: {
                    ...commonAttributes,
                    duration: ms
                },
                nonPrivacySafeAttributes: nonPrivacySafeAttributes
            }))
    });
    // Analytics to track the first transition from pre-query to post-query
    (0, $gwFzn.useEffect)(()=>{
        // Do nothing if the page loaded with a query
        if (hadInitialQuery.current) return;
        // Start the timer when the dialog is opened
        if (quickFindOpen) startTimer();
        // Cancel the timer when the dialog is closed
        if (!quickFindOpen) cancelTimer(); // no-ops if the timer hasn't started or has already finished
        // Stop the timer when the user starts typing
        if (quickFindQuery) stopTimer();
    }, [
        cancelTimer,
        quickFindOpen,
        quickFindQuery,
        startTimer,
        stopTimer
    ]);
};

});
parcelRegister("bfgmu", function(module, exports) {

$parcel$export(module.exports, "onPreQueryDwelled", () => $b7759cf22d019191$export$24139682747f5c4);
const $b7759cf22d019191$export$24139682747f5c4 = ({ attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        source: 'searchDialog',
        eventType: 'track',
        action: 'dwelled',
        actionSubject: 'searchResults',
        actionSubjectId: 'preQuerySearchResults',
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });

});

parcelRegister("g9TqG", function(module, exports) {

$parcel$export(module.exports, "useTimer", () => $aca2bc20d4823d2b$export$632123ff591ac565);

var $gwFzn = parcelRequire("gwFzn");
function $aca2bc20d4823d2b$export$632123ff591ac565({ onTimerEnd: onTimerEnd }) {
    const [timer, setTimer] = (0, $gwFzn.useState)({
        status: 'idle'
    });
    const start = (0, $gwFzn.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'idle') return state;
            return {
                ...state,
                startTime: new Date(),
                status: 'running'
            };
        });
    }, []);
    const stop = (0, $gwFzn.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'running') return state;
            const end = new Date().getTime() - (timer.startTime?.getTime() ?? 0);
            onTimerEnd?.(end);
            return {
                ...state,
                endTime: new Date(),
                milliseconds: end,
                status: 'finished'
            };
        });
    }, [
        onTimerEnd,
        timer.startTime
    ]);
    const cancel = (0, $gwFzn.useCallback)(()=>{
        setTimer((state)=>{
            if (state.status !== 'running') return state;
            return {
                ...state,
                status: 'cancelled'
            };
        });
    }, []);
    return {
        start: start,
        stop: stop,
        cancel: cancel,
        status: timer.status,
        milliseconds: timer.milliseconds
    };
}

});


parcelRegister("57tKZ", function(module, exports) {

$parcel$export(module.exports, "useSyncStates", () => $64ab60c9a8f30827$export$29d6913fc893cfe8);

var $gwFzn = parcelRequire("gwFzn");
function $64ab60c9a8f30827$export$29d6913fc893cfe8(stateA, setStateA, stateB, setStateB) {
    const prevA = (0, $gwFzn.useRef)();
    const prevB = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        // Do nothing if any of the arguments are undefined
        if (stateA === undefined || setStateA === undefined || stateB === undefined || setStateB === undefined) return;
        // On mount, use stateA as the source of truth
        if (prevA.current === undefined && prevB.current === undefined) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            return;
        }
        // If updates to both states are updated to the same value in the
        // same render cycle, ensure previous values are updated
        if (stateA === stateB) {
            prevA.current = stateA;
            prevB.current = stateB;
            return;
        }
        // If stateA has changed, update stateB to match
        if (prevA.current !== stateA) {
            prevA.current = stateA;
            prevB.current = stateA;
            setStateB(stateA);
            // Exit here as only one state should be updated, otherwise an infinite
            // loop will occur. This means that stateA takes precedence if both
            // states are changed in the same render cycle.
            return;
        }
        // If stateB has changed, update stateA to match
        if (prevB.current !== stateB) {
            prevA.current = stateB;
            prevB.current = stateB;
            setStateA(stateB);
        }
    }, [
        setStateA,
        setStateB,
        stateA,
        stateB
    ]);
}

});




parcelRegister("7Fvok", function(module, exports) {

$parcel$export(module.exports, "ExtensibleCrossProductSearchDialog", () => $8a27c616de5aba0e$export$c89d6fd97d04eec5);

var $gwFzn = parcelRequire("gwFzn");

var $jtVoy = parcelRequire("jtVoy");
var $5wbh9 = parcelRequire("5wbh9");
var $fx9tH = parcelRequire("fx9tH");
var $gHaio = parcelRequire("gHaio");
var $4jHJP = parcelRequire("4jHJP");
var $4d43O = parcelRequire("4d43O");
var $k19N9 = parcelRequire("k19N9");
var $2evZZ = parcelRequire("2evZZ");
var $29ccb = parcelRequire("29ccb");
var $2WIYs = parcelRequire("2WIYs");
var $80L9g = parcelRequire("80L9g");

var $gz8ZY = parcelRequire("gz8ZY");

var $9oxdN = parcelRequire("9oxdN");

var $jlIaF = parcelRequire("jlIaF");

var $bQm3c = parcelRequire("bQm3c");

var $kDja4 = parcelRequire("kDja4");

var $gXsSh = parcelRequire("gXsSh");

var $yuLaV = parcelRequire("yuLaV");

var $4pEo5 = parcelRequire("4pEo5");

var $5bPOK = parcelRequire("5bPOK");

var $2VPmd = parcelRequire("2VPmd");

var $bB6dC = parcelRequire("bB6dC");

var $1mK5P = parcelRequire("1mK5P");

var $2qgZ5 = parcelRequire("2qgZ5");

var $4XEM3 = parcelRequire("4XEM3");

var $5jHnK = parcelRequire("5jHnK");
const $8a27c616de5aba0e$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER = 'watermelon';
const $8a27c616de5aba0e$var$COMPASS_PRODUCT_IDENTIFIER = 'compass';
const $8a27c616de5aba0e$var$AI_SEARCH_PREQUERY_BANNER_MESSAGE_ID = 'confluence.frontend.search.sain.prequery.banner.message';
const $8a27c616de5aba0e$export$c89d6fd97d04eec5 = (0, $gXsSh.withRoutesContext)((props)=>{
    const { cloudId: cloudId, aggregatorUrl: aggregatorUrl, formatDate: formatDate, isExpanded: isExpanded, forwardRef: forwardRef, linkComponent: linkComponent, onNavigate: onNavigate, onNavigateSecondary: onNavigateSecondary, setIsExpanded: setIsExpanded, theme: theme, user: user, features: { jiraFeatures: jiraFeatures, interactiveSkeleton: interactiveSkeleton }, clearStickySearchRef: clearStickySearchRef, shouldFillContainer: shouldFillContainer, getQueryParams: getQueryParams } = props;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { edition: edition, userId: userId, orgId: orgId, locale: locale } = (0, $bQm3c.useSessionData)();
    const [showPrequeryBanner, setShowPrequeryBanner] = (0, $gwFzn.useState)(false);
    const [prequeryBannerEligible, prequeryBannerDismissed, prequeryBannerError] = (0, $9oxdN.useFeatureDiscovery)($8a27c616de5aba0e$var$AI_SEARCH_PREQUERY_BANNER_MESSAGE_ID);
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isQuickSearchForWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isQuickSearchForDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const autocorrectEnabled = locale.split('-')[0] === 'en';
    const [quickFindEnabled] = (0, $5bPOK.useQuickFindEnabled)();
    const objectTypes = [
        (0, $bB6dC.ActivitiesObjectType).PAGE,
        (0, $bB6dC.ActivitiesObjectType).BLOGPOST,
        (0, $bB6dC.ActivitiesObjectType).EMBED,
        ...isQuickSearchForWhiteboardsEnabled ? [
            (0, $bB6dC.ActivitiesObjectType).WHITEBOARD
        ] : [],
        ...isQuickSearchForDatabasesEnabled ? [
            (0, $bB6dC.ActivitiesObjectType).DATABASE
        ] : []
    ];
    const { experimentLayers: experimentLayers, ...confluenceSuppliers } = (0, $2qgZ5.useConfluenceItemSuppliers)({
        cloudId: cloudId,
        userId: userId,
        principalId: userId || undefined,
        formatDate: formatDate,
        autocorrectEnabled: autocorrectEnabled,
        isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled,
        isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled,
        objectTypes: objectTypes
    });
    const dismissPrequeryBanner = ()=>{
        setShowPrequeryBanner(false);
        prequeryBannerDismissed();
    };
    const { aiSearchConfig: aiSearchConfig } = (0, $1mK5P.useAISearchSupplier)({
        prequeryBannerEnabled: showPrequeryBanner,
        dismissPrequeryBanner: dismissPrequeryBanner
    });
    (0, $gwFzn.useEffect)(()=>{
        if (prequeryBannerEligible && !prequeryBannerError) setShowPrequeryBanner(true);
    }, [
        prequeryBannerEligible,
        prequeryBannerError
    ]);
    const onNavigateMultiProduct = (id, href)=>{
        const navigationCallback = id === 'confluence' ? onNavigate : onNavigateSecondary;
        navigationCallback(href);
    };
    const { contentScope: contentScope, extensibleScopes: extensibleScopes } = (0, $4XEM3.useConfluenceScopes)({
        isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled,
        isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled
    });
    const queryParams = getQueryParams();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $80L9g.UserInputContextProvider), {
        stickySearchEnabled: true,
        isExpanded: isExpanded,
        resetStickySearchRef: clearStickySearchRef
    }, quickFindEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4pEo5.ConfluenceQuickFind), {
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        theme: theme,
        user: user,
        forwardRef: forwardRef,
        onNavigateGeneric: onNavigateMultiProduct,
        cloudId: cloudId,
        orgId: orgId,
        aggregatorUrl: aggregatorUrl,
        formatDate: formatDate,
        linkComponent: linkComponent,
        shouldFillContainer: shouldFillContainer,
        isRovoEnabled: quickFindEnabled,
        isGriffinNavEnabled: isNav4Enabled,
        queryParams: queryParams
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4d43O.FilterContextProvider), {
        isEnabled: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fx9tH.FilterContextProvider), {
        isEnabled: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5jHnK.ExperimentLayersAnalyticsListener), {
        experimentLayers: experimentLayers
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k19N9.MultiProductDialog), {
        aiSearchConfig: aiSearchConfig,
        aggregatorUrl: aggregatorUrl,
        abTestCloudId: cloudId,
        orgId: orgId,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        theme: theme,
        user: user,
        forwardRef: forwardRef,
        onNavigateGeneric: onNavigateMultiProduct,
        dialogFeatures: {
            interactiveSkeleton: interactiveSkeleton,
            isGriffinNavEnabled: isNav4Enabled
        },
        edition: edition?.toString(),
        shouldFillContainer: shouldFillContainer,
        queryParams: queryParams
    }, ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            role: "tabpanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gHaio.ExtensibleConfluenceTab), {
            order: 0,
            linkComponent: linkComponent,
            formatDate: formatDate,
            onRetry: onRetry,
            permissionSupplier: ()=>Promise.resolve(extensibleScopes),
            ...confluenceSuppliers,
            isPrefetchingEnabled: true,
            recentClientConfig: {
                url: (0, $jlIaF.CONTEXT_PATH),
                cloudId: cloudId,
                isUserAnonymous: !userId,
                isCollaborationGraphEnabled: false,
                collaborationGraphUrl: '/gateway/api/collaboration'
            },
            autocorrectEnabled: autocorrectEnabled,
            additionalContentTypesEnabled: true,
            aiSearchConfig: aiSearchConfig,
            rendererOverride: {
                ConfluenceResultRenderer: $2VPmd.ConfluenceResultRenderer,
                contentScope: contentScope
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jHJP.ExtensibleJiraTab), {
            order: 1,
            formatDate: formatDate,
            onRetry: onRetry,
            features: jiraFeatures
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jtVoy.BitbucketTab), {
            order: 2,
            onRetry: onRetry,
            features: {
                enableSingleScopesCall: true
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2evZZ.OpsgenieTab), {
            order: 3,
            onRetry: onRetry,
            cloudId: cloudId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $29ccb.TownsquareTab), {
            order: 4,
            onRetry: onRetry,
            userTeamConfig: {
                context: {
                    contextType: 'filter',
                    organizationId: orgId,
                    principalId: 'Context',
                    productKey: $8a27c616de5aba0e$var$TOWNSQUARE_SMARTS_PRODUCT_IDENTIFIER,
                    siteId: cloudId
                }
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2WIYs.TrelloTab), {
            order: 5,
            onRetry: onRetry
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5wbh9.CompassTab), {
            sourceContext: "confluence",
            isUserAnonymous: !userId,
            order: 6,
            onRetry: onRetry,
            userTeamConfig: {
                context: {
                    contextType: 'CompassFilter',
                    organizationId: orgId,
                    principalId: 'Context',
                    productKey: $8a27c616de5aba0e$var$COMPASS_PRODUCT_IDENTIFIER,
                    siteId: cloudId
                }
            }
        })))))));
});

});
parcelRegister("jtVoy", function(module, exports) {

$parcel$export(module.exports, "BitbucketTab", () => $3cc71055164da496$export$a83467d99f696187);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $crAJ1 = parcelRequire("crAJ1");

var $5CiaV = parcelRequire("5CiaV");

var $bqoDl = parcelRequire("bqoDl");

var $bF0iL = parcelRequire("bF0iL");

var $4V3UW = parcelRequire("4V3UW");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $85AiF = parcelRequire("85AiF");

var $it4Xp = parcelRequire("it4Xp");

var $cPiQS = parcelRequire("cPiQS");

var $eztGN = parcelRequire("eztGN");

var $3Z7LN = parcelRequire("3Z7LN");

var $iEwUU = parcelRequire("iEwUU");

var $kmpep = parcelRequire("kmpep");
const $3cc71055164da496$var$mapAggregatorResponseToSearchItem = (repo)=>{
    return {
        title: repo.name,
        id: repo.uuid,
        meta: repo.workspace.name,
        url: repo.links.html.href,
        iconUrl: repo.links.avatar.href,
        containerId: repo.workspace.uuid
    };
};
const $3cc71055164da496$export$9d75ef492044e493 = ({ intl: intl, viewAllLinkGenerator: overriddenViewAllLinkGenerator, codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator, codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen, permissionSupplier: overriddenPermissionsSupplier, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, currentContext: currentContext, features: features, ...rest })=>{
    const { viewAllLinkGenerator: viewAllLinkGenerator, codeSearchUrlGenerator: codeSearchUrlGenerator, codeSearchContextualUrlGenerator: codeSearchContextualUrlGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, $gwFzn.useMemo)(()=>{
        return (0, $cPiQS.bitbucketURLGenerators)({
            viewAllLinkGenerator: overriddenViewAllLinkGenerator,
            codeSearchUrlGenerator: overriddenCodeSearchUrlGenerator,
            codeSearchContextualUrlGenerator: overriddenCodeSearchContextualUrlGenerator,
            urlGeneratorForNoResultsScreen: overriddenUrlGeneratorForNoResultsScreen
        });
    }, [
        overriddenCodeSearchUrlGenerator,
        overriddenCodeSearchContextualUrlGenerator,
        overriddenUrlGeneratorForNoResultsScreen,
        overriddenViewAllLinkGenerator
    ]);
    const sections = [
        {
            id: (0, $it4Xp.BitbucketScope).BitbucketRepostitory,
            title: intl.formatMessage((0, $bqoDl.messages).bitbucket_repository_heading),
            scope: (0, $it4Xp.BitbucketScope).BitbucketRepostitory,
            showResultCount: true,
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultMapper: ({ results: results })=>results.map((value)=>$3cc71055164da496$var$mapAggregatorResponseToSearchItem(value))
        }
    ];
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)((0, $it4Xp.BITBUCKET_PRODUCT_ID), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const permissionSupplier = (0, $85AiF.useBitbucketPermissionSupplier)(overriddenPermissionsSupplier);
    const formattedSearchForCodeLabel = (context)=>{
        const { repository: repository, workspace: workspace } = context || {};
        let source = 'Bitbucket';
        if (repository) source = repository.name;
        else if (workspace) source = workspace.name;
        return intl.formatMessage((0, $bqoDl.messages).bitbucket_advanced_search, {
            source: source
        });
    };
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return viewAllLinkGenerator(query);
    }, [
        viewAllLinkGenerator,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        expandedStateInputPlaceholder: intl.formatMessage((0, $bqoDl.messages).bitbucket_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        id: (0, $it4Xp.BITBUCKET_PRODUCT_ID),
        permissionSupplier: permissionSupplier,
        preQuerySectionTitleGenerator: (section)=>section.id === (0, $it4Xp.BitbucketScope).BitbucketRepostitory ? intl.formatMessage((0, $bqoDl.messages).bitbucket_recent_repositories) : '',
        sections: sections,
        title: intl.formatMessage((0, $bF0iL.messages).bitbucket_tab_label),
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        ...rest,
        ...itemSuppliers,
        children: ({ linkComponent: linkComponent, query: query })=>{
            const codeSearchUrl = currentContext ? codeSearchContextualUrlGenerator(query, currentContext) : codeSearchUrlGenerator(query);
            const contextualSearchMessage = formattedSearchForCodeLabel(currentContext);
            return {
                Header: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4V3UW.AdvancedSearch), {
                        advancedSearchMessage: contextualSearchMessage,
                        advancedSearchUrl: codeSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $3cc71055164da496$export$a83467d99f696187 = (0, $js7oX.default)($3cc71055164da496$export$9d75ef492044e493);

});
parcelRegister("crAJ1", function(module, exports) {

$parcel$export(module.exports, "SearchFooter", () => $307b1644cf276a47$export$64ded8b71dfcba9e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $307b1644cf276a47$export$64ded8b71dfcba9e = (0, $gwrgp.default)("div", {
    target: "e1jzvw2y0"
})({
    width: '100%',
    height: `${"var(--ds-space-600, 48px)"}`,
    borderTop: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`
});

});

parcelRegister("5CiaV", function(module, exports) {

$parcel$export(module.exports, "useDefaultSuppliers", () => $029554683ea761ec$export$967ff0f6c3886589);

var $gJKpQ = parcelRequire("gJKpQ");

var $4ldrV = parcelRequire("4ldrV");

var $kmpep = parcelRequire("kmpep");

var $88j1D = parcelRequire("88j1D");

var $fJRVo = parcelRequire("fJRVo");
const $029554683ea761ec$var$MAX_DEFAULT_SITES = 3;
const $029554683ea761ec$export$dc64f87f5460b276 = (aggregatorClient, sections, context, experience, sourceProduct)=>async ({ query: query, filters: allFilters, workspaces: workspaces, sectionIds: allPermissionedScopes })=>{
        const defaultSites = workspaces?.slice(0, $029554683ea761ec$var$MAX_DEFAULT_SITES).map((workspace)=>workspace.id);
        // Extract sites from filters
        const siteFilter = allFilters.find((filter)=>filter['@type'] === (0, $88j1D.SITE_FILTER_TYPE_NAME));
        // @ts-ignore - typescript is not smart enough to know `siteFilter` will only ever be the sites filter
        const sites = siteFilter?.values || defaultSites || [];
        // Remove sites from the filters array
        const filters = allFilters.filter((filter)=>filter['@type'] !== (0, $88j1D.SITE_FILTER_TYPE_NAME)).map((f)=>f);
        const permittedSections = sections.filter((section)=>allPermissionedScopes.indexOf(section.id) >= 0).filter((section)=>section.isEnabled ? section.isEnabled(query, filters) : true);
        const scopes = permittedSections.map((section)=>section.scope);
        if (!aggregatorClient) return {
            sections: []
        };
        const { response: response } = await aggregatorClient.search({
            query: query,
            scopes: scopes,
            modelParams: [],
            experience: experience,
            context: context,
            filters: filters,
            sites: sites,
            sourceProduct: sourceProduct
        });
        const sectionsWithResults = permittedSections.map(({ scope: scope, id: id, title: title, resultMapper: resultMapper, ...rest })=>{
            const results = response.retrieveScope(scope);
            if (results === null) throw new Error(`Scope ${scope} was not found in the response, despite being requested`);
            return {
                ...rest,
                id: id,
                title: title,
                size: results.size,
                searchResults: resultMapper(results) || [],
                resultMapper: resultMapper
            };
        });
        const scopesWithSize = response.rawData.scopes.filter(({ size: size })=>size);
        const reponseHasSize = scopesWithSize.length > 0;
        const totalSizeAsReportedByAPI = reponseHasSize ? response.rawData.scopes.reduce((count, scope)=>count + (scope.size || 0), 0) : undefined;
        return {
            size: totalSizeAsReportedByAPI,
            sections: sectionsWithResults
        };
    };
const $029554683ea761ec$export$967ff0f6c3886589 = (id, sections, overrides)=>{
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const sessionId = (0, $4ldrV.useSearchSessionId)();
    const productContext = (0, $fJRVo.useProductContext)();
    const { getPrimaryProduct: getPrimaryProduct } = productContext;
    const primaryProduct = getPrimaryProduct();
    const primaryProductId = primaryProduct?.id;
    const search = $029554683ea761ec$export$dc64f87f5460b276(aggregatorClient, sections, {
        sessionId: sessionId,
        referrerId: ''
    }, (0, $gJKpQ.PLACEHOLDER_EXPERIENCE), primaryProductId);
    return {
        preQueryItemSupplier: overrides?.preQueryItemSupplier ?? ((args)=>search({
                ...args,
                query: '',
                filters: []
            })),
        postQueryItemSupplier: overrides?.postQueryItemSupplier ?? search
    };
};

});
parcelRegister("gJKpQ", function(module, exports) {

$parcel$export(module.exports, "PLACEHOLDER_EXPERIENCE", () => $79cbd4001c087560$export$2bde439437c11152);

var $kmpep = parcelRequire("kmpep");
const $79cbd4001c087560$export$2bde439437c11152 = 'product-search-dialog';

});
parcelRegister("kmpep", function(module, exports) {

$parcel$export(module.exports, "AggregatorClientContextProvider", () => $1c8fa64373cfd191$export$db02e603a9db00);
$parcel$export(module.exports, "useAggregatorClient", () => $1c8fa64373cfd191$export$b8a9ed32354e757e);
$parcel$export(module.exports, "useTypedAggregatorClient", () => $1c8fa64373cfd191$export$51bbe78d05c20324);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $12cJV = parcelRequire("12cJV");

var $91yhh = parcelRequire("91yhh");
const $1c8fa64373cfd191$var$AggregatorClientContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext(undefined);
const $1c8fa64373cfd191$export$db02e603a9db00 = ({ abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, children: children })=>{
    const { backendExperiment: backendExperiment } = (0, $91yhh.useExperiments)();
    const aggregatorClient = (0, $gwFzn.useMemo)(()=>new (0, $12cJV.AggregatorClient)({
            url: aggregatorUrl,
            cloudId: abTestCloudId,
            siteMasterList: [],
            backendExperiment: backendExperiment
        }), [
        abTestCloudId,
        aggregatorUrl,
        backendExperiment
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($1c8fa64373cfd191$var$AggregatorClientContext.Provider, {
        value: aggregatorClient,
        children: children
    });
};
const $1c8fa64373cfd191$export$b8a9ed32354e757e = ()=>{
    const aggregatorClient = (0, $gwFzn.useContext)($1c8fa64373cfd191$var$AggregatorClientContext);
    return aggregatorClient;
};
const $1c8fa64373cfd191$export$51bbe78d05c20324 = ()=>{
    // Casting done here to ensure that the result types match the scopes requested
    const untypedClient = (0, $gwFzn.useContext)($1c8fa64373cfd191$var$AggregatorClientContext);
    return untypedClient;
};

});


parcelRegister("4ldrV", function(module, exports) {

$parcel$export(module.exports, "SearchSessionProvider", () => $833e609371746364$export$facabd4fde35268);
$parcel$export(module.exports, "useSearchSessionId", () => $833e609371746364$export$e1e7a4797df1a656);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kyKWe = parcelRequire("kyKWe");

var $hpDfc = parcelRequire("hpDfc");
const $833e609371746364$var$SearchSessionContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    searchSessionId: undefined
});
class $833e609371746364$var$SearchSessionProviderError extends Error {
    constructor(){
        super('Could not find any SearchSessionProvider, make sure there is a SearchSessionProvider further up the tree');
    }
}
function $833e609371746364$export$432081be24450536(Component) {
    const WrapperComponent = (props)=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)($833e609371746364$var$SearchSessionContext.Consumer, {
            children: ({ searchSessionId: searchSessionId })=>{
                if (!searchSessionId) throw new $833e609371746364$var$SearchSessionProviderError();
                return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    ...props,
                    searchSessionId: searchSessionId
                });
            }
        });
    };
    return WrapperComponent;
}
class $833e609371746364$export$facabd4fde35268 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    static getDerivedStateFromProps(props, state) {
        // Reset the searchSessionId only when the dialog is expanded
        return {
            sessionKey: props.sessionKey,
            searchSessionId: props.sessionKey !== state.sessionKey && props.sessionKey !== 'ssid_provider_false' ? (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))() : state.searchSessionId
        };
    }
    render() {
        const { children: children } = this.props;
        const { searchSessionId: searchSessionId } = this.state;
        return /*#__PURE__*/ (0, $7UHDa.jsx)($833e609371746364$var$SearchSessionContext.Provider, {
            value: {
                searchSessionId: searchSessionId
            },
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
                analyticContext: {
                    searchSessionId: searchSessionId
                },
                nonPrivacySafeAnalyticContext: {},
                children: children
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            sessionKey: this.props.sessionKey,
            searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
        };
    }
}
function $833e609371746364$export$e1e7a4797df1a656() {
    const { searchSessionId: searchSessionId } = (0, $gwFzn.useContext)($833e609371746364$var$SearchSessionContext);
    if (searchSessionId) return searchSessionId;
    throw new $833e609371746364$var$SearchSessionProviderError();
}

});
parcelRegister("hpDfc", function(module, exports) {

$parcel$export(module.exports, "SearchDialogAnalyticsContext", () => $16dbb5df832b7062$export$b6f131c43d0365a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5dFS9 = parcelRequire("5dFS9");

var $kDuN4 = parcelRequire("kDuN4");
const $16dbb5df832b7062$export$b6f131c43d0365a = ({ analyticContext: analyticContext, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext = {}, filterAnalyticsContext: filterAnalyticsContext = {}, nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeAnalyticContextGenerator, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
        channel: (0, $5dFS9.DEFAULT_GAS_CHANNEL),
        onEvent: (event)=>{
            const additionalAttributes = typeof analyticContext === 'function' ? analyticContext() : analyticContext;
            const nonPrivacySafeAttributes = nonPrivacySafeAnalyticContextGenerator !== undefined ? nonPrivacySafeAnalyticContextGenerator() : nonPrivacySafeAnalyticContext;
            event.update((payload)=>{
                const filters = {
                    ...payload.attributes?.filters,
                    ...filterAnalyticsContext
                };
                // Operational event not support nonPrivacySafeAttributes
                const nonPrivacySafeAttributesPayload = payload.eventType === 'operational' ? {} : {
                    nonPrivacySafeAttributes: {
                        ...payload?.nonPrivacySafeAttributes,
                        ...nonPrivacySafeAttributes
                    }
                };
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        ...additionalAttributes,
                        filters: Object.keys(filters).length > 0 ? filters : undefined
                    },
                    ...nonPrivacySafeAttributesPayload
                };
            });
        },
        children: children
    });
};

});


parcelRegister("88j1D", function(module, exports) {

$parcel$export(module.exports, "SITE_FILTER_TYPE_NAME", () => $aa1fd6477603f439$export$f76bd7c689371575);
$parcel$export(module.exports, "DEFAULT_OPTION", () => $aa1fd6477603f439$export$d3212964e526b51c);
$parcel$export(module.exports, "FilterUIVariant", () => $aa1fd6477603f439$export$ab762b8071023de0);
$parcel$export(module.exports, "LastModifiedValues", () => $aa1fd6477603f439$export$2a1fb5b806348bf0);
const $aa1fd6477603f439$export$f76bd7c689371575 = 'sites';
const $aa1fd6477603f439$export$d3212964e526b51c = 'default';
var $aa1fd6477603f439$export$ab762b8071023de0 = /*#__PURE__*/ function(FilterUIVariant) {
    FilterUIVariant["CHECKBOX"] = "CHECKBOX";
    FilterUIVariant["STATIC_SELECT"] = "STATIC_SELECT";
    FilterUIVariant["MULTI_SELECT"] = "MULTI_SELECT";
    return FilterUIVariant;
}({});
var $aa1fd6477603f439$export$2a1fb5b806348bf0 = /*#__PURE__*/ function(LastModifiedValues) {
    LastModifiedValues["DEFAULT"] = "default";
    LastModifiedValues["TODAY"] = "today";
    LastModifiedValues["YESTERDAY"] = "yesterday";
    LastModifiedValues["PAST_SEVEN_DAYS"] = "past7Days";
    LastModifiedValues["PAST_THIRTY_DAYS"] = "past30Days";
    LastModifiedValues["PAST_YEAR"] = "pastYear";
    return LastModifiedValues;
}({});

});


parcelRegister("bqoDl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c3475590821d5a81$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $c3475590821d5a81$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Bitbucket
   */ bitbucket_repository_heading: {
        id: "product_search_dialog.bitbucket.repository_heading",
        defaultMessage: "Repositories"
    },
    bitbucket_advanced_search: {
        id: "product_search_dialog.bitbucket.bitbucket_advanced_search",
        defaultMessage: "Search for code in {source}"
    },
    bitbucket_repositories_section_title: {
        id: "product_search_dialog.bitbucket.bitbucket_repositories_section_title",
        defaultMessage: "Repositories"
    },
    bitbucket_recent_repositories: {
        id: "product_search_dialog.bitbucket.bitbucket_recent_repositories",
        defaultMessage: "Recently updated repositories"
    },
    bitbucket_expanded_input_placeholder: {
        id: "product_search_dialog.bitbucket.expanded.input-placeholder",
        defaultMessage: "Search Bitbucket"
    }
});

});

parcelRegister("4V3UW", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearch", () => $2ba4e0bc1633544b$export$2709da4acd7d0aec);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $epvHH = parcelRequire("epvHH");
var $icqFF = parcelRequire("icqFF");

var $jEno1 = parcelRequire("jEno1");

var $3S0fp = parcelRequire("3S0fp");
var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $eKv3Q = parcelRequire("eKv3Q");
var $l3UB9 = parcelRequire("l3UB9");

var $fJRVo = parcelRequire("fJRVo");

var $2ZIpG = parcelRequire("2ZIpG");

var $b9sDF = parcelRequire("b9sDF");
const $2ba4e0bc1633544b$var$onKeyDown = (e, target, actionSubjectId, fireAnalyticsEvent)=>{
    if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $5dFS9.Trigger).RETURN,
            actionSubjectId: actionSubjectId,
            isLoading: false,
            newTab: false
        }));
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $2ba4e0bc1633544b$export$2709da4acd7d0aec = ({ advancedSearchMessage: advancedSearchMessage, advancedSearchUrl: advancedSearchUrl, linkComponent: linkComponent })=>{
    const { isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const productName = getActiveProduct()?.title;
    const actionSubjectId = `${productName}AdvancedSearchLink`;
    const onAdvancedSearchClicked = (0, $gwFzn.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e)
        }));
    }, [
        fireAnalyticsEvent,
        actionSubjectId,
        isLoading
    ]);
    const [isKeyboardHighlighted, ref] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: (0, $gwFzn.useCallback)((e, target)=>$2ba4e0bc1633544b$var$onKeyDown(e, target, actionSubjectId, fireAnalyticsEvent), [
            actionSubjectId,
            fireAnalyticsEvent
        ])
    });
    if (!advancedSearchUrl || !advancedSearchMessage) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $b9sDF.AdvancedSearchLinkWrapper), {
        ref: ref,
        onClick: onAdvancedSearchClicked,
        role: "none",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $l3UB9.AdvancedSearchLink), {
            href: advancedSearchUrl,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eKv3Q.CenteredAdvancedSearchGroup), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jEno1))), {
                            color: "currentColor",
                            LEGACY_size: "small",
                            label: advancedSearchMessage
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKv3Q.AdvancedSearchContent), {
                            children: advancedSearchMessage
                        })
                    ]
                }),
                isKeyboardHighlighted && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epvHH.ReturnIcon), {
                    inverted: isKeyboardHighlighted
                })
            ]
        })
    });
};

});
parcelRegister("epvHH", function(module, exports) {

$parcel$export(module.exports, "ReturnIcon", () => $abe9af1675ab5b46$export$d6c38c54dfb7c9d5);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $abe9af1675ab5b46$export$d6c38c54dfb7c9d5 = ({ inverted: inverted = false })=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    width: "24",
                    height: "16",
                    fill: inverted ? `var(--ds-background-neutral-bold, ${0, $6fnsQ.N80})` : `var(--ds-background-neutral, ${0, $6fnsQ.N30})`,
                    rx: "3"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fill: inverted ? `var(--ds-icon-inverse, ${0, $6fnsQ.N30})` : `var(--ds-icon-subtle, ${0, $6fnsQ.N80})`,
                    fillRule: "nonzero",
                    d: "M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
                })
            ]
        })
    });

});

parcelRegister("eKv3Q", function(module, exports) {

$parcel$export(module.exports, "CenteredAdvancedSearchGroup", () => $73c221919444c9a0$export$5d708f1c4bba7ac3);
$parcel$export(module.exports, "StyledAdvancedSearch", () => $73c221919444c9a0$export$ffb3e5c7f83e1d2f);
$parcel$export(module.exports, "AdvancedSearchContent", () => $73c221919444c9a0$export$aa7c31826bbddc7b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $2hEyf = parcelRequire("2hEyf");

var $kPBHE = parcelRequire("kPBHE");

var $gwrgp = parcelRequire("gwrgp");
const $73c221919444c9a0$export$5d708f1c4bba7ac3 = (0, $gwrgp.default)("div", {
    target: "e1fpfwrr0"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $73c221919444c9a0$var$outlineWidth = 2;
const $73c221919444c9a0$export$ffb3e5c7f83e1d2f = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "e1fpfwrr1"
})((props)=>({
        alignItems: 'center',
        color: `var(--ds-text, ${0, $6fnsQ.N900})`,
        cursor: 'pointer',
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        padding: `${"var(--ds-space-075, 6px)"} ${16 - $73c221919444c9a0$var$outlineWidth}px`,
        border: `${$73c221919444c9a0$var$outlineWidth}px solid transparent`,
        '&:hover': {
            color: `var(--ds-text, ${0, $6fnsQ.N900})`,
            backgroundColor: `var(--ds-background-neutral, ${0, $6fnsQ.N20})`,
            textDecoration: 'none'
        },
        '&:visited': {
            color: `var(--ds-text, ${0, $6fnsQ.N900})`
        },
        '&:focus': {
            outline: 'none',
            border: `${$73c221919444c9a0$var$outlineWidth}px solid ${`var(--ds-border-focused, ${0, $6fnsQ.B100})`}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? `var(--ds-background-neutral, ${0, $6fnsQ.N20})` : `var(--ds-background-neutral-subtle, ${0, $6fnsQ.N0})`
    }));
const $73c221919444c9a0$export$aa7c31826bbddc7b = (0, $gwrgp.default)("span", {
    target: "e1fpfwrr2"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $2hEyf.fontFallback).body.medium})`,
    paddingLeft: "var(--ds-space-200, 16px)",
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("l3UB9", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchLink", () => $2b4af01aea146af3$export$3f63855034354a21);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eKv3Q = parcelRequire("eKv3Q");
const $2b4af01aea146af3$export$3f63855034354a21 = ({ href: href, linkComponent: linkComponent, ...rest })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKv3Q.StyledAdvancedSearch), {
        linkComponent: linkComponent,
        "data-test-id": "search-dialog-advanced-search-link",
        href: href,
        ...rest
    });

});

parcelRegister("2ZIpG", function(module, exports) {

$parcel$export(module.exports, "QueryContextProvider", () => $2904842909f92043$export$96e4d538f00fbce1);
$parcel$export(module.exports, "useQuery", () => $2904842909f92043$export$dd0a697e1782aedd);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $80L9g = parcelRequire("80L9g");

var $hpDfc = parcelRequire("hpDfc");
var $PfqP9 = parcelRequire("PfqP9");

var $gF7Az = parcelRequire("gF7Az");
const $2904842909f92043$var$QueryContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    query: '',
    queryVersion: 0,
    isLoading: false,
    setQuery: (ignore)=>{},
    setQueryOnly: (ignore)=>{},
    setAdditionalAnalyticsContext: (ignore)=>({})
});
const $2904842909f92043$export$96e4d538f00fbce1 = ({ children: children })=>{
    const [stateQuery, setStateQuery] = (0, $gwFzn.useState)('');
    const { stickySearchEnabled: stickySearchEnabled, query: sessionQuery, showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog, storeQuery: storeQuery } = (0, $80L9g.useSessionUserInput)();
    const query = stickySearchEnabled ? sessionQuery : stateQuery;
    const setQuery = (0, $gwFzn.useCallback)((value)=>{
        if (showSearchAIDialog) toggleShowSearchAIDialog(false);
        stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
    }, [
        showSearchAIDialog,
        toggleShowSearchAIDialog,
        stickySearchEnabled,
        storeQuery
    ]);
    const setQueryOnly = (0, $gwFzn.useCallback)((value)=>{
        stickySearchEnabled ? storeQuery(value) : setStateQuery(value);
    }, [
        stickySearchEnabled,
        storeQuery
    ]);
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { isLoading: isLoading, setAdditionalAnalyticsContext: setAdditionalAnalyticsContext, addAnalyticContext: addAnalyticContext, nonPrivacySafeContext: nonPrivacySafeContext, queryVersion: queryVersion } = (0, $PfqP9.useAnalyticsContext)(query);
    (0, $gwFzn.useEffect)(()=>{
        if (!isExpanded) {
            if (!stickySearchEnabled) setQuery('');
            setAdditionalAnalyticsContext({
                type: 'reset'
            });
        }
    }, [
        isExpanded,
        setAdditionalAnalyticsContext,
        stickySearchEnabled,
        setQuery
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($2904842909f92043$var$QueryContext.Provider, {
        value: {
            query: query,
            queryVersion: queryVersion,
            setQuery: setQuery,
            setQueryOnly: setQueryOnly,
            setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
            isLoading: isLoading
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: addAnalyticContext,
            nonPrivacySafeAnalyticContextGenerator: nonPrivacySafeContext,
            children: children
        })
    });
};
const $2904842909f92043$export$dd0a697e1782aedd = ()=>{
    return (0, $gwFzn.useContext)($2904842909f92043$var$QueryContext);
};

});
parcelRegister("80L9g", function(module, exports) {

$parcel$export(module.exports, "UserInputContextProvider", () => $14178128195429da$export$dab413a8570d1ac4);
$parcel$export(module.exports, "useSessionUserInput", () => $14178128195429da$export$296c1552a8cb35a5);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $epS7s = parcelRequire("epS7s");

var $5dFS9 = parcelRequire("5dFS9");
var $hpDfc = parcelRequire("hpDfc");
var $6dP89 = parcelRequire("6dP89");
const $14178128195429da$var$noop = ()=>{};
const $14178128195429da$var$SESSION_RESET_TIMEOUT_MS = 300000;
const $14178128195429da$var$anyConfluenceFiltersChecked = (filters)=>{
    const confluencefilters = filters.confluence;
    if (confluencefilters) {
        const hasSpaceFilterChecked = confluencefilters.space?.length ? confluencefilters.space?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        const hasPeopleFilterChecked = confluencefilters.people?.length ? confluencefilters.people?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        const hasSiteFilterChecked = confluencefilters.site?.length ? confluencefilters.site?.some((filter)=>{
            return filter.isChecked;
        }) : false;
        return hasSpaceFilterChecked || hasPeopleFilterChecked || hasSiteFilterChecked;
    }
    return false;
};
const $14178128195429da$export$c87c231bb0fb0228 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    stickySearchEnabled: false,
    query: '',
    showSearchAIDialog: false,
    storeQuery: $14178128195429da$var$noop,
    toggleShowSearchAIDialog: $14178128195429da$var$noop,
    readFilters: $14178128195429da$var$noop,
    storeFilters: $14178128195429da$var$noop,
    resetSearchSession: $14178128195429da$var$noop,
    resetConfluenceFiltersRef: undefined,
    resetExtensibleFiltersRef: undefined
});
const $14178128195429da$export$dab413a8570d1ac4 = ({ stickySearchEnabled: stickySearchEnabled = false, sessionResetIdleTime: sessionResetIdleTime = $14178128195429da$var$SESSION_RESET_TIMEOUT_MS, isExpanded: isExpanded = false, resetStickySearchRef: resetStickySearchRef, children: children })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const [query, setQuery] = (0, $gwFzn.useState)((0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_QUERY_KEY)) || '');
    const [isStickyUpdated, setIsStickyUpdated] = (0, $gwFzn.useState)(false);
    const [stickyQueryUpdated, setStickyQueryUpdated] = (0, $gwFzn.useState)(false);
    const queryFirstUpdatedRef = (0, $gwFzn.useRef)(undefined);
    const lastExpandRef = (0, $gwFzn.useRef)(false);
    const lastQueryRef = (0, $gwFzn.useRef)('');
    const timeoutRef = (0, $gwFzn.useRef)();
    const resetConfluenceFiltersRef = (0, $gwFzn.useRef)();
    const resetExtensibleFiltersRef = (0, $gwFzn.useRef)();
    const sessionShowSearchAIDialogStr = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_SHOW_AI_DIALOG_KEY));
    const sessionShowSearchAIDialog = sessionShowSearchAIDialogStr ? JSON.parse(sessionShowSearchAIDialogStr) : false;
    const [showSearchAIDialog, setShowSearchAIDialog] = (0, $gwFzn.useState)(sessionShowSearchAIDialog);
    const resetSearchSession = (0, $gwFzn.useCallback)(()=>{
        (0, $epS7s.deleteSessionItem)((0, $epS7s.SEARCH_QUERY_KEY));
        (0, $epS7s.deleteSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
        (0, $epS7s.deleteSessionItem)((0, $epS7s.SEARCH_SHOW_AI_DIALOG_KEY));
        resetConfluenceFiltersRef.current?.();
        resetExtensibleFiltersRef.current?.();
        setQuery('');
        setShowSearchAIDialog(false);
        queryFirstUpdatedRef.current = undefined;
        lastQueryRef.current = '';
    }, [
        resetConfluenceFiltersRef,
        resetExtensibleFiltersRef
    ]);
    const readFilters = (0, $gwFzn.useCallback)((productId)=>{
        const searchFilterString = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
        const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
        if (productId in filters) return filters[productId];
        return {};
    }, []);
    const updateSessionResetTimeout = (0, $gwFzn.useCallback)(()=>{
        if (timeoutRef?.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            if (timeoutRef?.current) clearTimeout(timeoutRef.current);
            const searchFilterString = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
            const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
            if (query === '' && !$14178128195429da$var$anyConfluenceFiltersChecked(filters)) return; // Skip the reset and analytics event if no filters or query entered
            resetSearchSession();
            fireAnalyticsEvent((0, $5dFS9.onStickySearchCleared)({
                timeout: sessionResetIdleTime
            }));
        }, sessionResetIdleTime);
    }, [
        query,
        sessionResetIdleTime,
        resetSearchSession,
        fireAnalyticsEvent
    ]);
    const storeQuery = (0, $gwFzn.useCallback)((query)=>{
        setQuery(query);
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_QUERY_KEY), query);
        updateSessionResetTimeout();
        if (queryFirstUpdatedRef.current === undefined) queryFirstUpdatedRef.current = Date.now();
        if (lastQueryRef.current) setStickyQueryUpdated(query !== lastQueryRef.current);
    }, [
        updateSessionResetTimeout
    ]);
    const toggleShowSearchAIDialog = (0, $gwFzn.useCallback)((showSearchAIDialog)=>{
        setShowSearchAIDialog(showSearchAIDialog);
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_SHOW_AI_DIALOG_KEY), showSearchAIDialog.toString());
    }, []);
    const storeFilters = (0, $gwFzn.useCallback)((productId, value)=>{
        const searchFilterString = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY));
        const filters = searchFilterString ? JSON.parse(searchFilterString) : {};
        filters[productId] = value;
        (0, $epS7s.setSessionItem)((0, $epS7s.SEARCH_FILTERS_KEY), JSON.stringify(filters));
        if (lastExpandRef.current) updateSessionResetTimeout;
    }, [
        lastExpandRef,
        updateSessionResetTimeout
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (resetStickySearchRef) resetStickySearchRef.current = resetSearchSession;
    });
    (0, $gwFzn.useEffect)(()=>{
        if (!lastExpandRef.current && isExpanded) updateSessionResetTimeout();
        if (lastExpandRef.current && !isExpanded) updateSessionResetTimeout();
    }, [
        lastExpandRef,
        isExpanded,
        updateSessionResetTimeout
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!lastExpandRef.current && isExpanded) {
            setIsStickyUpdated(query !== '');
            lastQueryRef.current = query;
            setStickyQueryUpdated(false);
        }
        lastExpandRef.current = isExpanded;
    }, [
        isExpanded,
        lastExpandRef,
        lastQueryRef,
        query
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($14178128195429da$export$c87c231bb0fb0228.Provider, {
        value: {
            stickySearchEnabled: stickySearchEnabled,
            query: query,
            showSearchAIDialog: showSearchAIDialog,
            storeQuery: stickySearchEnabled ? storeQuery : $14178128195429da$var$noop,
            toggleShowSearchAIDialog: toggleShowSearchAIDialog,
            readFilters: stickySearchEnabled ? readFilters : $14178128195429da$var$noop,
            storeFilters: stickySearchEnabled ? storeFilters : $14178128195429da$var$noop,
            resetSearchSession: stickySearchEnabled ? resetSearchSession : $14178128195429da$var$noop,
            resetConfluenceFiltersRef: stickySearchEnabled ? resetConfluenceFiltersRef : undefined,
            resetExtensibleFiltersRef: stickySearchEnabled ? resetExtensibleFiltersRef : undefined
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: stickySearchEnabled ? {
                isSticky: true,
                isStickyUpdated: isStickyUpdated,
                stickyQueryUpdated: stickyQueryUpdated,
                queryUpdatedAgo: queryFirstUpdatedRef.current ? Date.now() - queryFirstUpdatedRef.current : undefined
            } : {
                isSticky: false
            },
            children: children
        })
    });
};
const $14178128195429da$export$296c1552a8cb35a5 = ()=>{
    return (0, $gwFzn.useContext)($14178128195429da$export$c87c231bb0fb0228);
};

});

parcelRegister("PfqP9", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $bdba8c9822bcf66e$export$d1f587f82ad51c4);

var $gwFzn = parcelRequire("gwFzn");

var $3S0fp = parcelRequire("3S0fp");
const $bdba8c9822bcf66e$var$defaultAnalyticsContextState = {
    queryVersion: 0,
    isLoading: false
};
const $bdba8c9822bcf66e$var$analyticsContextReducer = (state, action)=>{
    switch(action.type){
        case 'queryVersion':
            return {
                ...state,
                queryVersion: action.value
            };
        case 'isLoading':
            return {
                ...state,
                isLoading: action.value
            };
        case 'reset':
            return $bdba8c9822bcf66e$var$defaultAnalyticsContextState;
        default:
            throw new Error();
    }
};
const $bdba8c9822bcf66e$export$d1f587f82ad51c4 = (query)=>{
    const [{ queryVersion: queryVersion, isLoading: isLoading }, setAdditionalAnalyticsContext] = (0, $gwFzn.useReducer)($bdba8c9822bcf66e$var$analyticsContextReducer, $bdba8c9822bcf66e$var$defaultAnalyticsContextState);
    const addAnalyticContext = (0, $gwFzn.useCallback)(()=>{
        return {
            wordCount: (0, $3S0fp.getWordCount)(query),
            queryLength: query.length,
            queryHash: (0, $3S0fp.sha256Hash)(query),
            queryHashSHA256: (0, $3S0fp.sha256Hash)(query),
            queryVersion: queryVersion
        };
    }, [
        query,
        queryVersion
    ]);
    const nonPrivacySafeContext = (0, $gwFzn.useCallback)(()=>{
        return {
            query: query
        };
    }, [
        query
    ]);
    return {
        isLoading: isLoading,
        setAdditionalAnalyticsContext: setAdditionalAnalyticsContext,
        addAnalyticContext: addAnalyticContext,
        nonPrivacySafeContext: nonPrivacySafeContext,
        queryVersion: queryVersion
    };
};

});


parcelRegister("b9sDF", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchLinkWrapper", () => $7f9d1377acc537c5$export$8e79650dab255425);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// AdvancedSearchLinkWrapper component is used for keyboard highlighting
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $7f9d1377acc537c5$export$8e79650dab255425 = (0, $gwrgp.default)("span", {
    target: "ecy8ma0"
})({
    name: "hboir5",
    styles: "display:flex;width:100%;"
});

});


parcelRegister("a5cba", function(module, exports) {

$parcel$export(module.exports, "SearchDialogProduct", () => $37edf39650c77c6a$export$bea8d7c130bb15c8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5UXzK = parcelRequire("5UXzK");

var $dByQx = parcelRequire("dByQx");

var $gF7Az = parcelRequire("gF7Az");

var $7a9pa = parcelRequire("7a9pa");

var $1e3Dw = parcelRequire("1e3Dw");
const $37edf39650c77c6a$export$bea8d7c130bb15c8 = ({ generateAdvancedSearchUrl: genUrl, ...rest })=>{
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const generateAdvancedSearchUrl = (0, $1e3Dw.useGenerateAdvancedSearchUrl)(genUrl);
    const props = {
        ...rest,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dByQx.default), {
        ...props,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5UXzK.AsyncProduct), {
            ...props,
            fallback: !isExpanded ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}) : undefined,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7a9pa.AsyncProvider), {
                ...props
            })
        })
    });
};

});
parcelRegister("5UXzK", function(module, exports) {

$parcel$export(module.exports, "AsyncProduct", () => $b2233dbfbf7baa26$export$ea887de8bd536d84);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7prbm = parcelRequire("7prbm");

var $2jYn8 = parcelRequire("2jYn8");

var $fJRVo = parcelRequire("fJRVo");

var $cpIJW = parcelRequire("cpIJW");

var $bBxPo = parcelRequire("bBxPo");
class $b2233dbfbf7baa26$export$6bc62c4e30aa3c0a extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentWillUnmount() {
        const { removeProduct: removeProduct, id: id } = this.props;
        removeProduct(id);
    }
    render() {
        const { fallback: FallbackComponent, id: id, children: children } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Suspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bBxPo.ActiveProduct), {
                id: id,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7prbm.TimeLazyLoad), {
                    product: id,
                    children: FallbackComponent ? /*#__PURE__*/ (0, $7UHDa.jsx)(FallbackComponent, {}) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2jYn8.LoadingSpinner), {})
                })
            }),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cpIJW.InitialisationExperienceSuccess), {
                    ...this.props
                }),
                children
            ]
        });
    }
}
const $b2233dbfbf7baa26$export$ea887de8bd536d84 = (0, $fJRVo.withProductContext)($b2233dbfbf7baa26$export$6bc62c4e30aa3c0a);

});
parcelRegister("7prbm", function(module, exports) {

$parcel$export(module.exports, "TimeLazyLoad", () => $cd5e177fbad53fb4$export$5a31ea5680c95894);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");
const $cd5e177fbad53fb4$export$5a31ea5680c95894 = ({ children: children, product: product })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    (0, $gwFzn.useEffect)(()=>{
        const start = Date.now();
        return ()=>{
            fireAnalyticsEvent((0, $5dFS9.onPaneLoadComplete)(product, Date.now() - start));
        };
    }, [
        fireAnalyticsEvent,
        product
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});

parcelRegister("2jYn8", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $2eff2ad85863b392$export$b08b517936747730);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $jYL82 = parcelRequire("jYL82");

var $9hlns = parcelRequire("9hlns");
const $2eff2ad85863b392$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $jYL82.SpinnerContainer), {
        "data-testid": "search-dialog-loading-spinner",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jYL82.HorizontalCenteredContainer), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {})
        })
    });

});
parcelRegister("jYL82", function(module, exports) {

$parcel$export(module.exports, "HorizontalCenteredContainer", () => $63fd68c4ea134445$export$574c01fef92380ae);
$parcel$export(module.exports, "SpinnerContainer", () => $63fd68c4ea134445$export$a5e06607a5ac6158);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dTk3A = parcelRequire("dTk3A");

var $gwrgp = parcelRequire("gwrgp");
const $63fd68c4ea134445$export$574c01fef92380ae = (0, $gwrgp.default)("div", {
    target: "eh93uzp0"
})({
    name: "13o6z6d",
    styles: "margin:0 auto;"
});
const $63fd68c4ea134445$export$a5e06607a5ac6158 = (0, $gwrgp.default)("div", {
    target: "eh93uzp1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $dTk3A.gridSize)() * 12}px`,
    width: '100%',
    display: 'flex',
    alignItems: 'center'
});

});


parcelRegister("cpIJW", function(module, exports) {

$parcel$export(module.exports, "InitialisationExperienceSuccess", () => $fe5a5ea44cc052c2$export$12ba87fc0c8ef4e3);

var $gwFzn = parcelRequire("gwFzn");

var $gRazf = parcelRequire("gRazf");

var $fJRVo = parcelRequire("fJRVo");

var $jAnRi = parcelRequire("jAnRi");
const $fe5a5ea44cc052c2$export$7f8c86254a9e879c = ({ id: id, abTest: abTest, getPrimaryProduct: getPrimaryProduct })=>{
    const [successCalled, setSuccessCalled] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (successCalled) return;
        const primaryProduct = getPrimaryProduct();
        if (abTest && primaryProduct && primaryProduct.id === id) {
            (0, $jAnRi.initialisationExperience).success();
            setSuccessCalled(true);
        }
    }, [
        abTest,
        getPrimaryProduct,
        id,
        successCalled
    ]);
    return null;
};
const $fe5a5ea44cc052c2$export$12ba87fc0c8ef4e3 = (0, $gRazf.withABTestContext)((0, $fJRVo.withProductContext)($fe5a5ea44cc052c2$export$7f8c86254a9e879c));

});
parcelRegister("gRazf", function(module, exports) {

$parcel$export(module.exports, "ABTestContextProvider", () => $64a4585da9ac3d3b$export$e7d53dc13567ec0e);
$parcel$export(module.exports, "useABTest", () => $64a4585da9ac3d3b$export$14279a3fbdb52451);
$parcel$export(module.exports, "withABTestContext", () => $64a4585da9ac3d3b$export$5124bc23083a567d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");
var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $gJKpQ = parcelRequire("gJKpQ");
var $kmpep = parcelRequire("kmpep");

var $fJRVo = parcelRequire("fJRVo");

var $91yhh = parcelRequire("91yhh");

var $dByQx = parcelRequire("dByQx");

var $dh538 = parcelRequire("dh538");
const $64a4585da9ac3d3b$export$22966a5ebf51ce99 = {
    abTestId: 'default',
    controlId: 'default',
    experimentId: 'default'
};
const $64a4585da9ac3d3b$var$ABTestContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    abTest: null
});
const $64a4585da9ac3d3b$var$ABTestContextProviderStateless = ({ isMultiProduct: isMultiProduct, searchClient: searchClient, scope: scope, children: children, primaryProductId: primaryProductId, experience: experience })=>{
    const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, $91yhh.useExperiments)();
    const [abTest, setAbTest] = (0, $gwFzn.useState)(()=>{
        const defaultAbTest = (0, $dh538.fg)('qs-7058-remove-experiment-call-search-dialog') ? $64a4585da9ac3d3b$export$22966a5ebf51ce99 : null;
        return backendExperiment || defaultAbTest;
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    (0, $gwFzn.useEffect)(()=>{
        const now = Date.now();
        if ((0, $dh538.fg)('qs-7058-remove-experiment-call-search-dialog') || !searchClient || !scope || abTest) return;
        if (scope === (0, $dByQx.PERFORMANCE_IMPROVEMENT_DUMMY_SECTION)) {
            setAbTest($64a4585da9ac3d3b$export$22966a5ebf51ce99);
            return;
        }
        searchClient// TODO: Remove PLACEHOLDER_EXPERIENCE
        .getAbTestData(scope, experience ?? (0, $gJKpQ.PLACEHOLDER_EXPERIENCE), primaryProductId).then((abTestResponse)=>{
            const duration = Date.now() - now;
            const abTestWithDefault = abTestResponse || $64a4585da9ac3d3b$export$22966a5ebf51ce99;
            setAbTest(abTestWithDefault);
            fireAnalyticsEvent((0, $5dFS9.onExperimentLoaded)(abTestWithDefault, duration, !!isMultiProduct));
        }).catch((e)=>{
            setAbTest($64a4585da9ac3d3b$export$22966a5ebf51ce99);
        });
    }, [
        searchClient,
        fireAnalyticsEvent,
        isMultiProduct,
        scope,
        abTest,
        primaryProductId,
        experience,
        backendExperiment
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($64a4585da9ac3d3b$var$ABTestContext.Provider, {
        value: {
            abTest: abTest
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: {
                abTest: abTest || undefined,
                frontendExperiments: {
                    activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
                    ...frontendExperiments
                }
            },
            nonPrivacySafeAnalyticContext: {},
            children: children
        })
    });
};
const $64a4585da9ac3d3b$export$e7d53dc13567ec0e = (props)=>{
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const searchClient = (0, $kmpep.useAggregatorClient)();
    const primaryProduct = getPrimaryProduct();
    const { sectionIds: sectionIds } = primaryProduct || {};
    const scope = (0, $gwFzn.useMemo)(()=>sectionIds && sectionIds.length > 0 ? sectionIds[0] : undefined, [
        sectionIds
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($64a4585da9ac3d3b$var$ABTestContextProviderStateless, {
        ...props,
        scope: scope,
        searchClient: searchClient,
        primaryProductId: primaryProduct?.id
    });
};
const $64a4585da9ac3d3b$export$14279a3fbdb52451 = ()=>{
    const { abTest: abTest } = (0, $gwFzn.useContext)($64a4585da9ac3d3b$var$ABTestContext);
    return abTest;
};
const $64a4585da9ac3d3b$export$5124bc23083a567d = (WrappedComponent)=>{
    return (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)(WrappedComponent, {
            ...props,
            ...(0, $gwFzn.useContext)($64a4585da9ac3d3b$var$ABTestContext)
        });
};

});
parcelRegister("dByQx", function(module, exports) {

$parcel$export(module.exports, "PERFORMANCE_IMPROVEMENT_DUMMY_SECTION", () => $0ab33f74cad490ac$export$d56c05d9b1186628);
$parcel$export(module.exports, "default", () => $0ab33f74cad490ac$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gJKpQ = parcelRequire("gJKpQ");
var $kmpep = parcelRequire("kmpep");

var $fJRVo = parcelRequire("fJRVo");

var $e0qNw = parcelRequire("e0qNw");
const $0ab33f74cad490ac$export$8e8702b7c6f58328 = ({ children: children, permissionSupplier: permissionSupplier, id: id, title: title, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter })=>{
    const invokePostQuerySearchRef = (0, $gwFzn.useRef)(()=>{});
    const [allowedSections, setAllowedSections] = (0, $gwFzn.useState)([]);
    const searchClient = (0, $kmpep.useAggregatorClient)();
    (0, $gwFzn.useEffect)(()=>{
        if (allowedSections.length === 0) {
            // For Jira we need to improve performance by not rendering all the search dialog tabs before the
            // dialog is expanded. However, in order to ensure that the search component is interactive there needs
            // to be at least one allowed section. This test is a workaround to ensure that when there is only this
            // single dummy section that it is included without a permission check. This hook will be called again
            // when the search dialog is expanded and the real sections are provided.
            if (sections.length === 1 && sections[0].id === $0ab33f74cad490ac$export$d56c05d9b1186628) {
                setAllowedSections([
                    $0ab33f74cad490ac$export$d56c05d9b1186628
                ]);
                return;
            } else {
                const promise = permissionSupplier ? permissionSupplier() : searchClient ? searchClient.batchedGetExtensibleProductPermission(id, {
                    productIds: [
                        id
                    ],
                    experience: (0, $gJKpQ.PLACEHOLDER_EXPERIENCE)
                }) : Promise.resolve([]);
                promise.then((response)=>{
                    setAllowedSections(response);
                });
            }
        }
    /**
		 * We want to replicate componentDidMount behaviour to avoid invoking the API multiple times and we don't care if any other deps changed.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return allowedSections.length > 0 ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e0qNw.default), {
            allowedSections: allowedSections,
            sections: sections,
            id: id,
            title: title,
            order: order,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            expandedStateInputPlaceholder: expandedStateInputPlaceholder,
            workspaces: workspaces,
            autocorrectEnabled: autocorrectEnabled,
            showViewAllFiltersLink: showViewAllFiltersLink,
            tabRenderer: tabRenderer,
            aiSearchConfig: aiSearchConfig,
            showSearchOnEnter: showSearchOnEnter,
            invokePostQuerySearchRef: invokePostQuerySearchRef,
            children: children
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $0ab33f74cad490ac$export$d56c05d9b1186628 = '__PERFORMANCE_IMPROVEMENT_DUMMY_SECTION__';
var $0ab33f74cad490ac$export$2e2bcd8739ae039 = (0, $fJRVo.withProductContext)($0ab33f74cad490ac$export$8e8702b7c6f58328);

});
parcelRegister("e0qNw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e48ac6f5e264642a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fJRVo = parcelRequire("fJRVo");
const $e48ac6f5e264642a$export$90be722c085777fe = ({ addProduct: addProduct, showProduct: showProduct, updateProduct: updateProduct, id: id, title: title, children: children, allowedSections: allowedSections, sections: sections, order: order, generateAdvancedSearchUrl: generateAdvancedSearchUrl, expandedStateInputPlaceholder: expandedStateInputPlaceholder, workspaces: workspaces, autocorrectEnabled: autocorrectEnabled, showViewAllFiltersLink: showViewAllFiltersLink, tabRenderer: tabRenderer, aiSearchConfig: aiSearchConfig, showSearchOnEnter: showSearchOnEnter, invokePostQuerySearchRef: invokePostQuerySearchRef })=>{
    const [originalId] = (0, $gwFzn.useState)(id);
    const [registeredProduct, setRegisteredProduct] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (allowedSections.length > 0) {
            const allowedSectionString = allowedSections.join(' ');
            const allowedRegisteredSections = sections.map((sec)=>sec.id).filter((sectionId)=>{
                const sectionIds = sectionId.replace(id, '').replace('.', '').split(',');
                let allowed = true;
                sectionIds.forEach((section)=>{
                    if (allowedSectionString.indexOf(section) === -1) allowed = false;
                });
                return allowed;
            });
            if (allowedRegisteredSections.length > 0) {
                addProduct({
                    id: id,
                    title: title,
                    sectionIds: sections.map((sec)=>sec.id),
                    order: order,
                    generateAdvancedSearchUrl: generateAdvancedSearchUrl,
                    expandedStateInputPlaceholder: expandedStateInputPlaceholder,
                    workspaces: workspaces,
                    autocorrectEnabled: autocorrectEnabled,
                    showViewAllFiltersLink: showViewAllFiltersLink,
                    tabRenderer: tabRenderer,
                    aiSearchConfig: aiSearchConfig,
                    showSearchOnEnter: showSearchOnEnter,
                    invokePostQuerySearchRef: invokePostQuerySearchRef
                });
                setRegisteredProduct(true);
            }
        }
    /**
		 * Updating of state is a side effect. We want it to happen in component did mount stage. Hence replicating this behaviour.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (!registeredProduct) return;
        if (id !== originalId) {
            // eslint-disable-next-line no-console
            console.error("product-search-dialog: Cannot update a different product's properties. Did you change accidentally change a product's id?");
            return;
        }
        updateProduct({
            id: id,
            generateAdvancedSearchUrl: generateAdvancedSearchUrl,
            tabRenderer: tabRenderer
        });
    }, [
        registeredProduct,
        id,
        originalId,
        updateProduct,
        generateAdvancedSearchUrl,
        tabRenderer
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};
var $e48ac6f5e264642a$export$2e2bcd8739ae039 = (0, $fJRVo.withProductContext)($e48ac6f5e264642a$export$90be722c085777fe);

});



parcelRegister("jAnRi", function(module, exports) {

$parcel$export(module.exports, "COMPONENT", () => $e4619431597b06fa$export$af1e30ebbae9df3b);
$parcel$export(module.exports, "initialisationExperience", () => $e4619431597b06fa$export$e5b98327036a989d);

var $9NDUe = parcelRequire("9NDUe");
var $5aVN7 = parcelRequire("5aVN7");
const $e4619431597b06fa$export$af1e30ebbae9df3b = 'search-dialog';
const $e4619431597b06fa$export$e5b98327036a989d = new (0, $5aVN7.UFOExperience)('intialisation', {
    type: (0, $9NDUe.ExperienceTypes).Load,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $e4619431597b06fa$export$af1e30ebbae9df3b
    }
});

});


parcelRegister("bBxPo", function(module, exports) {

$parcel$export(module.exports, "ActiveProduct", () => $d457cad9438f33e2$export$13224c53a1606253);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $fJRVo = parcelRequire("fJRVo");
const $d457cad9438f33e2$export$13224c53a1606253 = ({ children: children, id: id })=>{
    const { getProduct: getProduct } = (0, $fJRVo.useProductContext)();
    const product = getProduct(id);
    if (!product?.isDisplayed) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});


parcelRegister("7a9pa", function(module, exports) {

$parcel$export(module.exports, "AsyncProvider", () => $298df496b78eadc8$export$2f9c5c9733d48598);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $298df496b78eadc8$var$AsyncResultProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("gKUJ3")).then(({ ResultProvider: ResultProvider })=>({
            default: ResultProvider
        })));
const $298df496b78eadc8$export$2f9c5c9733d48598 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($298df496b78eadc8$var$AsyncResultProvider, {
        ...props,
        children: props.children
    });

});
parcelRegister("gKUJ3", function(module, exports) {

let $c32cf1c2d1f97278$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c32cf1c2d1f97278$var$load("8F6ik").then(()=>parcelRequire('f8JZq'));

});


parcelRegister("1e3Dw", function(module, exports) {

$parcel$export(module.exports, "useGenerateAdvancedSearchUrl", () => $d3fd384d52c00b18$export$25a2b20022e2a01a);

var $gwFzn = parcelRequire("gwFzn");

var $amrMu = parcelRequire("amrMu");

var $4wMwH = parcelRequire("4wMwH");
const $d3fd384d52c00b18$export$25a2b20022e2a01a = (genUrl)=>{
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    return (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        const advancedSearchUrl = genUrl?.(query, baseUrl, usage) || '';
        if (isGriffinNavEnabled) {
            const urlParts = advancedSearchUrl.split('?');
            // Omit text and originalQuery from the query params
            // originalQuery is used to support AutoCorrection in FPS and we don't want it
            // to persist between search queries
            const { text: text, originalQuery: originalQuery, ...rest } = queryParams || {};
            return `${urlParts[0]}?${new URLSearchParams({
                ...rest,
                ...query !== '' && {
                    text: query
                }
            }).toString()}`;
        }
        return advancedSearchUrl;
    }, [
        genUrl,
        isGriffinNavEnabled,
        queryParams
    ]);
};

});
parcelRegister("amrMu", function(module, exports) {

$parcel$export(module.exports, "FeaturesProvider", () => $1fd3b472f26a38c1$export$502d46f2366b5b43);
$parcel$export(module.exports, "useFeaturesContext", () => $1fd3b472f26a38c1$export$38c566c0640fb69a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4wMwH = parcelRequire("4wMwH");
const $1fd3b472f26a38c1$export$98552201007e6417 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({});
const $1fd3b472f26a38c1$export$502d46f2366b5b43 = ({ dialogFeatures: dialogFeatures = {}, children: children })=>{
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    // Do not proceed with griffin navigation if query param props are not available
    const isGriffinNavEnabled = (0, $gwFzn.useMemo)(()=>dialogFeatures.isGriffinNavEnabled === true && queryParams !== undefined, [
        dialogFeatures.isGriffinNavEnabled,
        queryParams
    ]);
    return(/**
		 * Defaults and platfrom feature flag values can be overriden if explicit props are injected. This serves two purposes:
		 *
		 * 1. Storybook knobs can be provisioned for features that are powered by platfrom feature flags
		 *
		 * 2. Consumer products like Confluence, Jira can run statsig based experiments, where the Statsig evaluation happens in the product's code
		 * but the effect happens inside the code shipped by search platform.
		 */ /*#__PURE__*/ (0, $7UHDa.jsx)($1fd3b472f26a38c1$export$98552201007e6417.Provider, {
        value: {
            ...dialogFeatures,
            isGriffinNavEnabled: isGriffinNavEnabled
        },
        children: children
    }));
};
const $1fd3b472f26a38c1$export$38c566c0640fb69a = ()=>{
    return (0, $gwFzn.useContext)($1fd3b472f26a38c1$export$98552201007e6417);
};

});
parcelRegister("4wMwH", function(module, exports) {

$parcel$export(module.exports, "QueryParamsProvider", () => $de5accedd145fe95$export$90a656ad86ba2e2);
$parcel$export(module.exports, "useQueryParams", () => $de5accedd145fe95$export$b37ee0d76c6d2fbc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $de5accedd145fe95$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    queryParams: undefined
});
const $de5accedd145fe95$export$90a656ad86ba2e2 = ({ queryParams: queryParams, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($de5accedd145fe95$var$Context.Provider, {
        value: {
            queryParams: queryParams
        },
        children: children
    });
};
const $de5accedd145fe95$export$b37ee0d76c6d2fbc = ()=>{
    return (0, $gwFzn.useContext)($de5accedd145fe95$var$Context);
};

});




parcelRegister("85AiF", function(module, exports) {

$parcel$export(module.exports, "useBitbucketPermissionSupplier", () => $5cca7b29b77d44d1$export$e0a27ecb613d1aab);

var $gwFzn = parcelRequire("gwFzn");

var $gJKpQ = parcelRequire("gJKpQ");
var $kmpep = parcelRequire("kmpep");

var $it4Xp = parcelRequire("it4Xp");
const $5cca7b29b77d44d1$export$e0a27ecb613d1aab = (overridenPermissionsSupplier)=>{
    const client = (0, $kmpep.useTypedAggregatorClient)();
    return (0, $gwFzn.useMemo)(()=>{
        if (overridenPermissionsSupplier) return overridenPermissionsSupplier;
        return ()=>client?.getProductScopes((0, $it4Xp.BITBUCKET_PRODUCT_ID), (0, $gJKpQ.PLACEHOLDER_EXPERIENCE)) || [];
    }, [
        client,
        overridenPermissionsSupplier
    ]);
};

});
parcelRegister("it4Xp", function(module, exports) {

$parcel$export(module.exports, "BitbucketScope", () => $7fdea999808324e3$export$30e31f52a81be3c8);
$parcel$export(module.exports, "BITBUCKET_PRODUCT_ID", () => $7fdea999808324e3$export$49fc3e2141fc5779);
var $7fdea999808324e3$export$30e31f52a81be3c8 = /*#__PURE__*/ function(BitbucketScope) {
    BitbucketScope["BitbucketRepostitory"] = "bitbucket.repository";
    return BitbucketScope;
}({});
const $7fdea999808324e3$export$49fc3e2141fc5779 = 'bitbucket';

});


parcelRegister("cPiQS", function(module, exports) {

$parcel$export(module.exports, "bitbucketURLGenerators", () => $5e4d9137215cb451$export$8f020ef2e5947a78);
const $5e4d9137215cb451$var$getBitbucketBaseURL = ()=>{
    const hostname = window.location.hostname;
    if (hostname.includes('jira-dev.com') || hostname.startsWith('localhost')) return 'https://staging.bb-inf.net';
    return 'https://bitbucket.org';
};
const $5e4d9137215cb451$export$8f020ef2e5947a78 = (overrides)=>{
    const viewAllLinkGenerator = (query)=>`${$5e4d9137215cb451$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}`;
    const urlGeneratorForNoResultsScreen = (query)=>query ? `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/dashboard/repositories?search=${encodeURIComponent(query)}` : `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/dashboard/repositories`;
    const codeSearchUrlGenerator = (query)=>query ? `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/search?q=${encodeURIComponent(query)}` : `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/search`;
    const codeSearchContextualUrlGenerator = (query, context)=>{
        const { repository: repository, workspace: workspace } = context;
        let fullModifier = query || repository ? '?q=' : '';
        // Populate query params
        if (repository) {
            const repoSlug = encodeURIComponent(`repo:${repository.slug} `);
            fullModifier = `${fullModifier}${repoSlug}`;
        }
        if (query) fullModifier = `${fullModifier}${encodeURIComponent(query)}`;
        const workspaceUUID = repository?.workspace?.uuid || workspace?.uuid;
        if (workspaceUUID) fullModifier = fullModifier ? `${fullModifier}&account=${encodeURIComponent(workspaceUUID)}` : `?account=${encodeURIComponent(workspaceUUID)}`;
        return `${$5e4d9137215cb451$var$getBitbucketBaseURL()}/search${fullModifier}`;
    };
    return {
        viewAllLinkGenerator: overrides?.viewAllLinkGenerator || viewAllLinkGenerator,
        urlGeneratorForNoResultsScreen: overrides?.urlGeneratorForNoResultsScreen || urlGeneratorForNoResultsScreen,
        codeSearchUrlGenerator: overrides?.codeSearchUrlGenerator || codeSearchUrlGenerator,
        codeSearchContextualUrlGenerator: overrides?.codeSearchContextualUrlGenerator || codeSearchContextualUrlGenerator
    };
};

});

parcelRegister("eztGN", function(module, exports) {

$parcel$export(module.exports, "useShowAtlassianHomeSearchLink", () => $70c648daba3c4f25$export$14841bea82c8a2c4);

var $dh538 = parcelRequire("dh538");

var $cGCOz = parcelRequire("cGCOz");

var $iEwUU = parcelRequire("iEwUU");
const $70c648daba3c4f25$export$14841bea82c8a2c4 = (primaryProduct)=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $cGCOz.useRovoContext)();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    return $70c648daba3c4f25$export$52dc59b9f236d940(isRovoEnabled, orgId, primaryProduct);
};
const $70c648daba3c4f25$export$52dc59b9f236d940 = (isRovoEnabled, orgId, primaryProduct)=>!!(isRovoEnabled && orgId && primaryProduct === 'jira' && (0, $dh538.fg)('jira_rovo_in_quick_search'));

});
parcelRegister("cGCOz", function(module, exports) {

$parcel$export(module.exports, "RovoContextProvider", () => $a17b947b16252498$export$ee92d5ccc84fac27);
$parcel$export(module.exports, "useRovoContext", () => $a17b947b16252498$export$4deb785ed026cc56);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $a17b947b16252498$var$RovoContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    isRovoEnabled: false,
    setIsRovoEnabled: (isRovoEnabled)=>{}
});
const $a17b947b16252498$export$ee92d5ccc84fac27 = ({ isEnabled: isEnabled, children: children })=>{
    const [isRovoEnabled, setIsRovoEnabled] = (0, $gwFzn.useState)(isEnabled || false);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($a17b947b16252498$var$RovoContext.Provider, {
        value: {
            isRovoEnabled: isRovoEnabled,
            setIsRovoEnabled: setIsRovoEnabled
        },
        children: children
    });
};
function $a17b947b16252498$export$4deb785ed026cc56() {
    return (0, $gwFzn.useContext)($a17b947b16252498$var$RovoContext);
}

});

parcelRegister("iEwUU", function(module, exports) {

$parcel$export(module.exports, "UserProvider", () => $977849d86adacef2$export$88f24fd8fcfab6ca);
$parcel$export(module.exports, "useUserContext", () => $977849d86adacef2$export$87c54b525b914dab);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $977849d86adacef2$var$UserContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    user: {},
    setUser: (user)=>{}
});
const $977849d86adacef2$export$88f24fd8fcfab6ca = ({ user: initialUser, orgId: orgId, children: children })=>{
    const [user, setUser] = (0, $gwFzn.useState)(initialUser || {});
    return /*#__PURE__*/ (0, $7UHDa.jsx)($977849d86adacef2$var$UserContext.Provider, {
        value: {
            user: user,
            orgId: orgId,
            setUser: setUser
        },
        children: children
    });
};
function $977849d86adacef2$export$87c54b525b914dab() {
    return (0, $gwFzn.useContext)($977849d86adacef2$var$UserContext);
}

});


parcelRegister("3Z7LN", function(module, exports) {

$parcel$export(module.exports, "getAtlassianHomeSearchUrl", () => $254bef028b438f80$export$306c16563e2015b8);
$parcel$export(module.exports, "AtlassianHomeSearchLink", () => $254bef028b438f80$export$829d02f6cd9ab0ce);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $g1L9J = parcelRequire("g1L9J");

var $guzTv = parcelRequire("guzTv");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $2ZIpG = parcelRequire("2ZIpG");

var $4mZlP = parcelRequire("4mZlP");

var $e1ib8 = parcelRequire("e1ib8");

var $fjD79 = parcelRequire("fjD79");

var $9BAfc = parcelRequire("9BAfc");

var $4I873 = parcelRequire("4I873");

var $3S0fp = parcelRequire("3S0fp");
var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $fJRVo = parcelRequire("fJRVo");

var $l3UB9 = parcelRequire("l3UB9");
const $254bef028b438f80$var$ModifierIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {
        showModifierKey: true
    });
const $254bef028b438f80$var$ReturnIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {});
const $254bef028b438f80$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex'
});
const $254bef028b438f80$var$productIconStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '78px'
});
const $254bef028b438f80$var$moreButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    paddingInline: 'space.075',
    marginRight: 'space.050',
    height: '20px',
    display: 'flex',
    alignItems: 'center'
});
const $254bef028b438f80$var$absoluteStyles = (0, $ecnYn.xcss)({
    position: 'absolute'
});
const $254bef028b438f80$var$borderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '22px',
    width: '22px',
    borderRadius: '6px'
});
const $254bef028b438f80$var$jiraIconOverlapStyles = (0, $ecnYn.xcss)({
    zIndex: 'dialog',
    transform: 'translate(15px, 0)'
});
const $254bef028b438f80$var$confluenceIconOverlapStyles = (0, $ecnYn.xcss)({
    zIndex: 'navigation',
    transform: 'translate(30px, 0)'
});
const $254bef028b438f80$var$googleDriveIconOverlapStyles = (0, $ecnYn.xcss)({
    zIndex: 'card',
    transform: 'translate(45px, 0)'
});
const $254bef028b438f80$var$slackIconOverlapStyles = (0, $ecnYn.xcss)({
    transform: 'translate(60px, 0)'
});
const $254bef028b438f80$var$IconComponent = ({ showModifierIcon: showModifierIcon })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $254bef028b438f80$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: $254bef028b438f80$var$productIconStyles,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$jiraIconOverlapStyles,
                            $254bef028b438f80$var$borderStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g1L9J.JiraIcon), {
                            size: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$confluenceIconOverlapStyles,
                            $254bef028b438f80$var$borderStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $guzTv.ConfluenceIcon), {
                            size: "20"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$googleDriveIconOverlapStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9BAfc.GoogleDriveIcon), {})
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $254bef028b438f80$var$absoluteStyles,
                            $254bef028b438f80$var$slackIconOverlapStyles
                        ],
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4I873.SlackIcon), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: $254bef028b438f80$var$moreButtonStyles,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                    size: "small",
                    align: "center",
                    color: "color.text.subtle",
                    children: formatMessage((0, $e1ib8.messages).more)
                })
            }),
            showModifierIcon ? /*#__PURE__*/ (0, $7UHDa.jsx)($254bef028b438f80$var$ModifierIcon, {}) : /*#__PURE__*/ (0, $7UHDa.jsx)($254bef028b438f80$var$ReturnIcon, {})
        ]
    });
};
const $254bef028b438f80$export$306c16563e2015b8 = (orgId, cloudId, query, primaryProduct)=>{
    const url = new URL(`${(0, $fjD79.getDefaultAtlasBaseURL)(true)}/o/${orgId}/search`);
    url.searchParams.set('cloudId', cloudId);
    if (primaryProduct) url.searchParams.set('referrer', primaryProduct);
    if (query) url.searchParams.set('text', query);
    return url.toString();
};
const $254bef028b438f80$export$829d02f6cd9ab0ce = ({ orgId: orgId, cloudId: cloudId, showModifierIcon: showModifierIcon, actionSubjectId: actionSubjectId })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { query: query, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const activeProduct = getActiveProduct();
    const href = $254bef028b438f80$export$306c16563e2015b8(orgId, cloudId, query, primaryProduct?.id);
    const productName = activeProduct?.title;
    const defaultActionSubjectId = `${productName}AdvancedSearchLink`;
    const onAdvancedSearchClicked = (0, $gwFzn.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: actionSubjectId || defaultActionSubjectId,
            isLoading: isLoading,
            newTab: true,
            isRovoCrossProductSearchLink: true
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        actionSubjectId,
        defaultActionSubjectId
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooterLink), {
        href: href,
        onClick: onAdvancedSearchClicked,
        linkComponent: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $l3UB9.AdvancedSearchLink), {
                ...props,
                isKeyboardHighlighted: !!props.isKeyboardHighlighted,
                href: href,
                target: "_blank"
            }),
        contentLabel: formatMessage((0, $e1ib8.messages).extensible_advanced_search_cross_product_footer),
        returnKeyIconComponent: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($254bef028b438f80$var$IconComponent, {
                showModifierIcon: showModifierIcon
            })
    });
};

});
parcelRegister("4mZlP", function(module, exports) {

$parcel$export(module.exports, "ReturnIconWithModifier", () => $53e1ecb0ab1cac21$export$74f31472c4e66c81);
$parcel$export(module.exports, "AdvancedSearchFooterLink", () => $53e1ecb0ab1cac21$export$3bd10e9d8677419f);
$parcel$export(module.exports, "AdvancedSearchFooter", () => $53e1ecb0ab1cac21$export$ad56be906d54f7e2);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $epvHH = parcelRequire("epvHH");
var $icqFF = parcelRequire("icqFF");

var $jEno1 = parcelRequire("jEno1");

var $7LKLe = parcelRequire("7LKLe");

var $eKv3Q = parcelRequire("eKv3Q");
var $l3UB9 = parcelRequire("l3UB9");
var $ingNj = parcelRequire("ingNj");

var $2ZIpG = parcelRequire("2ZIpG");

var $2OcMi = parcelRequire("2OcMi");

var $3S0fp = parcelRequire("3S0fp");
var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $dBxQj = parcelRequire("dBxQj");

var $e1ib8 = parcelRequire("e1ib8");

var $fJRVo = parcelRequire("fJRVo");

var $ju7KJ = parcelRequire("ju7KJ");

var $80L9g = parcelRequire("80L9g");

var $gF7Az = parcelRequire("gF7Az");

var $4ldrV = parcelRequire("4ldrV");

var $f0f3d = parcelRequire("f0f3d");

var $6kOEz = parcelRequire("6kOEz");

var $hFUff = parcelRequire("hFUff");

var $5uL5H = parcelRequire("5uL5H");
const $53e1ecb0ab1cac21$var$onKeyDown = (e, target)=>{
    if (e.key === 'Enter') {
        e.preventDefault();
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $53e1ecb0ab1cac21$var$onKeyDownWithShift = (e, target)=>{
    if (e.key === 'Enter' && e.shiftKey) {
        e.preventDefault();
        // The ref here is the wrapper span however we simulate a click on the `ResultLinkComponent` that it wraps.
        target.firstElementChild?.click?.();
    }
};
const $53e1ecb0ab1cac21$export$74f31472c4e66c81 = ({ showModifierKey: showModifierKey })=>{
    const ModifierKeyIcon = window.navigator.userAgent.includes('Mac') ? (0, $6kOEz.CommandIcon) : (0, $hFUff.ControlIcon);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ju7KJ.SearchFooterLabelWrapper), {
        children: [
            showModifierKey && /*#__PURE__*/ (0, $7UHDa.jsx)(ModifierKeyIcon, {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5uL5H.SquareReturnIcon), {})
        ]
    });
};
const $53e1ecb0ab1cac21$export$ec11565276b0198d = ({ isKeyboardHighlighted: isKeyboardHighlighted, showSearchOnEnter: showSearchOnEnter, filterByProductFooter: filterByProductFooter, squareReturnIcon: squareReturnIcon })=>{
    if (showSearchOnEnter) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $ju7KJ.SearchFooterLabelWrapper), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ju7KJ.SearchFooterLabel), {
                children: "Shift"
            }),
            "+",
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epvHH.ReturnIcon), {
                inverted: isKeyboardHighlighted
            })
        ]
    });
    if (squareReturnIcon) return /*#__PURE__*/ (0, $7UHDa.jsx)($53e1ecb0ab1cac21$export$74f31472c4e66c81, {
        showModifierKey: filterByProductFooter
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epvHH.ReturnIcon), {
        inverted: isKeyboardHighlighted
    });
};
const $53e1ecb0ab1cac21$export$3bd10e9d8677419f = ({ href: href, searchIconLabel: searchIconLabel = '', contentLabel: contentLabel, onClick: onClick, filterByProductFooter: filterByProductFooter, showSearchOnEnter: showSearchOnEnter, squareReturnIcon: squareReturnIcon, linkComponent: linkComponent, returnKeyIconComponent: ReturnKeyIconComponent = $53e1ecb0ab1cac21$export$ec11565276b0198d })=>{
    const [isKeyboardHighlighted, ref] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: showSearchOnEnter ? $53e1ecb0ab1cac21$var$onKeyDownWithShift : $53e1ecb0ab1cac21$var$onKeyDown
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ref: ref,
        onClick: onClick,
        role: "none",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'flex',
            height: '100%',
            width: '100%'
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $l3UB9.AdvancedSearchLink), {
            href: href,
            isKeyboardHighlighted: isKeyboardHighlighted,
            linkComponent: linkComponent,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ju7KJ.ContentWrapper), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eKv3Q.CenteredAdvancedSearchGroup), {
                        children: [
                            filterByProductFooter ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7LKLe))), {
                                color: "currentColor",
                                LEGACY_size: "small",
                                label: searchIconLabel
                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jEno1))), {
                                color: "currentColor",
                                LEGACY_size: "small",
                                label: searchIconLabel
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eKv3Q.AdvancedSearchContent), {
                                children: contentLabel
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)(ReturnKeyIconComponent, {
                    isKeyboardHighlighted: isKeyboardHighlighted,
                    showSearchOnEnter: showSearchOnEnter,
                    filterByProductFooter: filterByProductFooter,
                    squareReturnIcon: squareReturnIcon
                })
            ]
        })
    }));
};
const $53e1ecb0ab1cac21$export$de2cb7be8250c972 = ({ query: query, isLoading: isLoading, activeProduct: activeProduct, closeDialog: closeDialog, searchFooterLabel: searchFooterLabel, searchFooterLabelWithIcon: searchFooterLabelWithIcon, linkComponent: linkComponent, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', squareReturnIcon: squareReturnIcon = false, filterByProductFooter: filterByProductFooter = false, returnKeyIconComponent: returnKeyIconComponent })=>{
    const intl = (0, $dBxQj.default)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const productName = activeProduct?.title;
    const productId = activeProduct?.id;
    const urlGenerator = activeProduct?.generateAdvancedSearchUrl || urlGeneratorForNoResultsScreen;
    const baseSearchUrl = filterByProductFooter ? `${urlGenerator(query)}&product=confluence` : urlGenerator(query);
    const advancedSearchUrl = query && productId === (0, $f0f3d.ProductKeys).Confluence ? (0, $2OcMi.addQuery)(baseSearchUrl, 'search_id', searchSessionId) : baseSearchUrl;
    const workspaces = activeProduct?.workspaces;
    const showSearchOnEnter = !!activeProduct?.showSearchOnEnter;
    const actionSubjectId = `${productName}AdvancedSearchLink`;
    const { resetSearchSession: resetSearchSession } = (0, $80L9g.useSessionUserInput)();
    const searchLabel = searchFooterLabel || intl.formatMessage((0, $e1ib8.messages).extensible_advanced_search_footer);
    const advancedSearchContentLabel = searchFooterLabelWithIcon || searchLabel;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onAdvancedSearchClicked = (0, $gwFzn.useCallback)((e)=>{
        if (!(0, $3S0fp.isNewTab)(e)) resetSearchSession();
        if (filterByProductFooter) closeDialog();
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e)
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        actionSubjectId,
        resetSearchSession,
        closeDialog,
        filterByProductFooter
    ]);
    if (workspaces && workspaces?.length > 1) {
        const workspacesWithAdvancedSearchLinks = workspaces.map((workspace)=>({
                product: productName || '',
                content: workspace.name,
                key: workspace.name,
                advancedSearchUrl: activeProduct?.generateAdvancedSearchUrl?.(query, workspace.baseUrl) || ''
            }));
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ingNj.default), {
            workspaces: workspacesWithAdvancedSearchLinks,
            linkComponent: linkComponent,
            isLoading: isLoading,
            onClick: (_, e)=>{
                (0, $5dFS9.onAdvancedSearchSelected)({
                    actionSubjectId: actionSubjectId,
                    trigger: (0, $3S0fp.getTrigger)(e),
                    isLoading: isLoading,
                    newTab: (0, $3S0fp.isNewTab)(e)
                });
            }
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)($53e1ecb0ab1cac21$export$3bd10e9d8677419f, {
        href: advancedSearchUrl,
        searchIconLabel: searchLabel,
        contentLabel: advancedSearchContentLabel,
        onClick: onAdvancedSearchClicked,
        filterByProductFooter: filterByProductFooter,
        showSearchOnEnter: showSearchOnEnter,
        squareReturnIcon: squareReturnIcon,
        linkComponent: linkComponent,
        returnKeyIconComponent: returnKeyIconComponent
    });
};
const $53e1ecb0ab1cac21$export$ad56be906d54f7e2 = ({ ...rest })=>{
    const { query: query, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { setIsExpanded: setIsExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($53e1ecb0ab1cac21$export$de2cb7be8250c972, {
        ...rest,
        query: query,
        isLoading: isLoading,
        activeProduct: activeProduct,
        closeDialog: closeDialog
    });
};

});
parcelRegister("7LKLe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289d4f542a1ed26db6d28b87ad2efcf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a8131e3ff7fd976$var$_react = $5a8131e3ff7fd976$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5a8131e3ff7fd976$var$_filter = $5a8131e3ff7fd976$var$_interopRequireDefault((parcelRequire("4AkKf")));

var $5a8131e3ff7fd976$var$_filter2 = $5a8131e3ff7fd976$var$_interopRequireDefault((parcelRequire("jIcpb")));
function $5a8131e3ff7fd976$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FilterIcon.
 * This component is FilterIcon, with `UNSAFE_fallbackIcon` set to "FilterIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a8131e3ff7fd976$var$FilterIcon = (props)=>/*#__PURE__*/ $5a8131e3ff7fd976$var$_react.default.createElement($5a8131e3ff7fd976$var$_filter.default, Object.assign({
        LEGACY_fallbackIcon: $5a8131e3ff7fd976$var$_filter2.default
    }, props));
$5a8131e3ff7fd976$var$FilterIcon.Name = 'FilterIconMigration';
var $5a8131e3ff7fd976$var$_default = module.exports.default = $5a8131e3ff7fd976$var$FilterIcon;

});

parcelRegister("ingNj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e55472238d050e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $jiwai = parcelRequire("jiwai");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $3S0fp = parcelRequire("3S0fp");
var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $bF0iL = parcelRequire("bF0iL");
const $a1e55472238d050e$var$MAX_PRIMARY_WORKSPACES = 5;
const $a1e55472238d050e$var$getActionSubjectIdForProduct = (product)=>{
    return `${product.toLowerCase()}AdvancedSearchLink`;
};
const $a1e55472238d050e$export$c1abbe883cc8875 = ({ workspaces: workspaces, linkComponent: linkComponent, onClick: onClick, isLoading: isLoading, intl: intl })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const links = workspaces.map((workspace)=>({
            content: workspace.content,
            key: workspace.key,
            href: workspace.advancedSearchUrl
        }));
    const label = intl.formatMessage((0, $bF0iL.messages).multi_site_advanced_search_label);
    const dropdownLabel = intl.formatMessage((0, $bF0iL.messages).multi_site_advanced_search_more_dropdown, {
        count: links.length - $a1e55472238d050e$var$MAX_PRIMARY_WORKSPACES
    });
    const onAdvancedSearchClicked = (0, $gwFzn.useCallback)(({ key: key }, e)=>{
        const workspace = workspaces.filter((w)=>w.key === key)[0];
        if (!workspace) return;
        fireAnalyticsEvent((0, $5dFS9.onMultiSiteAdvancedSearchSelected)({
            trigger: (0, $3S0fp.getTrigger)(e),
            actionSubjectId: $a1e55472238d050e$var$getActionSubjectIdForProduct(workspace.product),
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e),
            destinationId: key,
            index: workspaces.map((w)=>w.key).indexOf(key)
        }));
    }, [
        fireAnalyticsEvent,
        isLoading,
        workspaces
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jiwai.SearchFooterLinks), {
        linkComponent: linkComponent,
        onClick: (link, e)=>{
            onAdvancedSearchClicked(link, e);
            onClick && onClick(link.href, e);
        },
        label: label,
        dropdownTriggerLabel: dropdownLabel,
        links: links,
        maxPrimaryLinks: $a1e55472238d050e$var$MAX_PRIMARY_WORKSPACES
    });
};
var $a1e55472238d050e$export$2e2bcd8739ae039 = (0, $js7oX.default)($a1e55472238d050e$export$c1abbe883cc8875);

});
parcelRegister("jiwai", function(module, exports) {

$parcel$export(module.exports, "SearchFooterLinks", () => $aa4a78fb49270be5$export$697ca8c8f8bb38fc);

var $7UHDa = parcelRequire("7UHDa");

var $eEA8O = parcelRequire("eEA8O");

var $3gadb = parcelRequire("3gadb");

var $gwFzn = parcelRequire("gwFzn");

var $7ujO6 = parcelRequire("7ujO6");

var $DXuE9 = parcelRequire("DXuE9");

const $aa4a78fb49270be5$var$DropDownLinks = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("8NNqI")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $aa4a78fb49270be5$var$DEFAULT_MAX_PRIMARY_LINKS = 5;
const $aa4a78fb49270be5$export$697ca8c8f8bb38fc = ({ label: label, links: links, dropdownTriggerLabel: dropdownTriggerLabel, onClick: onClick, linkComponent: linkComponent, maxPrimaryLinks: maxPrimaryLinks })=>{
    const primaryLinks = links.slice(0, maxPrimaryLinks || $aa4a78fb49270be5$var$DEFAULT_MAX_PRIMARY_LINKS);
    const dropdownLinks = links.slice(maxPrimaryLinks || $aa4a78fb49270be5$var$DEFAULT_MAX_PRIMARY_LINKS, links.length);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $DXuE9.SearchFooterLinksContainer), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DXuE9.LabelContainer), {
                children: label
            }),
            primaryLinks.map((link)=>{
                const { key: key, href: href, content: content } = link;
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DXuE9.PrimaryButtonWrapper), {
                    onClick: (e)=>onClick && onClick(link, e),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DXuE9.PrimaryButtonStyledLink), {
                        href: href,
                        linkComponent: linkComponent,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                            content: content,
                            tag: (0, $7ujO6.ForwardedRefToolTipTag),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                                spacing: "compact",
                                tabIndex: -1,
                                children: content
                            })
                        })
                    })
                }, key);
            }),
            dropdownLinks && dropdownLinks.length > 0 ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($aa4a78fb49270be5$var$DropDownLinks, {
                    dropdownLinks: dropdownLinks,
                    dropdownTriggerLabel: dropdownTriggerLabel,
                    onClick: onClick,
                    linkComponent: linkComponent
                })
            }) : null
        ]
    });
};

});
parcelRegister("7ujO6", function(module, exports) {

$parcel$export(module.exports, "ForwardedRefToolTipTag", () => $e1ffbeb6e0936f83$export$349601f91196bc9c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $DXuE9 = parcelRequire("DXuE9");
const $e1ffbeb6e0936f83$export$349601f91196bc9c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $DXuE9.TruncatedTextDiv), {
        ...props,
        ref: ref
    }));

});
parcelRegister("DXuE9", function(module, exports) {

$parcel$export(module.exports, "SearchFooterLinksContainer", () => $9319a5a14fadb0c4$export$636ae9b701e134a6);
$parcel$export(module.exports, "LabelContainer", () => $9319a5a14fadb0c4$export$f5ae33f1b01a6402);
$parcel$export(module.exports, "TruncatedTextDiv", () => $9319a5a14fadb0c4$export$f060a0d7354d6f0f);
$parcel$export(module.exports, "PrimaryButtonWrapper", () => $9319a5a14fadb0c4$export$70f18730b5e534f8);
$parcel$export(module.exports, "PrimaryButtonStyledLink", () => $9319a5a14fadb0c4$export$c0a945c47b321ccb);
$parcel$export(module.exports, "DropownMenuLink", () => $9319a5a14fadb0c4$export$62368ee747a81340);

var $6fnsQ = parcelRequire("6fnsQ");

var $dTk3A = parcelRequire("dTk3A");

var $kPBHE = parcelRequire("kPBHE");

var $2azjJ = parcelRequire("2azjJ");

var $gwrgp = parcelRequire("gwrgp");
const $9319a5a14fadb0c4$export$636ae9b701e134a6 = (0, $gwrgp.default)("div", {
    target: "e17810te0"
})({
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'start',
    flexDirection: 'row',
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-200, 16px)"}`,
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $2azjJ.dialogWidth),
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});
const $9319a5a14fadb0c4$export$f5ae33f1b01a6402 = (0, $gwrgp.default)("div", {
    target: "e17810te1"
})({
    name: "1eq7d53",
    styles: "margin-right:var(--ds-space-050, 4px);flex-shrink:0;"
});
const $9319a5a14fadb0c4$export$f060a0d7354d6f0f = (0, $gwrgp.default)("div", {
    target: "e17810te2"
})({
    name: "1h2ruwl",
    styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
});
const $9319a5a14fadb0c4$export$70f18730b5e534f8 = (0, $gwrgp.default)("div", {
    target: "e17810te3"
})({
    name: "1qj33pc",
    styles: "flex:1 1 0;overflow:hidden;max-width:max-content;margin-right:var(--ds-space-025, 2px);"
});
const $9319a5a14fadb0c4$export$c0a945c47b321ccb = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "e17810te4"
})({
    display: 'flex',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $dTk3A.borderRadius)()}px`,
    transitionDuration: '0.2s',
    transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    '&:focus': {
        outline: 'none',
        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $6fnsQ.B100)})`} inset`
    },
    '&:hover': {
        textDecoration: 'none'
    }
});
const $9319a5a14fadb0c4$export$62368ee747a81340 = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "e17810te5"
})({
    display: 'block',
    position: 'relative',
    '&:focus': {
        outline: `2px solid ${`var(--ds-border-focused, ${(0, $6fnsQ.B100)})`}`,
        outlineOffset: '-2px'
    },
    '&:hover': {
        textDecoration: 'none'
    }
});

});


parcelRegister("8NNqI", function(module, exports) {

let $66893e103bfe4ddc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $66893e103bfe4ddc$var$load("6sXO4").then(()=>parcelRequire('gg9qV'));

});



parcelRegister("2OcMi", function(module, exports) {

$parcel$export(module.exports, "addQuery", () => $1f2b7f00ecdc409c$export$46ffbef61eff3d00);
$parcel$export(module.exports, "addQueryParams", () => $1f2b7f00ecdc409c$export$cbc5b385481fb319);
const $1f2b7f00ecdc409c$export$46ffbef61eff3d00 = (url, key, unencodedValue)=>{
    return $1f2b7f00ecdc409c$export$cbc5b385481fb319(url, {
        [key]: unencodedValue
    });
};
const $1f2b7f00ecdc409c$export$cbc5b385481fb319 = (url, params)=>{
    if (!url) return url;
    const sanitisedUrl = url.endsWith('?') || url.endsWith('&') ? url.slice(0, url.length - 1) : url;
    const paramsString = Object.entries(params).reduce((rest, [key, unencodedValue])=>{
        if (!key) return rest;
        const nextPart = `${encodeURIComponent(key)}=${encodeURIComponent(unencodedValue)}`;
        if (rest) return `${rest}&${nextPart}`;
        return nextPart;
    }, '');
    if (!paramsString) return url;
    // If it has a query string already
    if (sanitisedUrl.includes('?')) return `${sanitisedUrl}&${paramsString}`;
    return `${sanitisedUrl}?${paramsString}`;
};

});

parcelRegister("e1ib8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f92b14cfe6710408$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $f92b14cfe6710408$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Extensible
   */ extensible_advanced_search_footer: {
        id: "extensible_search_dialog.advanced_search",
        defaultMessage: "Advanced search"
    },
    extensible_advanced_search_cross_product_footer: {
        id: "extensible_search_dialog.advanced_search_all_apps",
        defaultMessage: "Search all apps"
    },
    extensible_connect_to: {
        id: "extensible_search_dialog.connect_to",
        defaultMessage: "Connect to"
    },
    extensible_connect: {
        id: "extensible_search_dialog.connect",
        defaultMessage: "Connect"
    },
    more: {
        id: "extensible_search_dialog.more",
        defaultMessage: "+ more"
    }
});

});

parcelRegister("ju7KJ", function(module, exports) {

$parcel$export(module.exports, "ContentWrapper", () => $27d3f42c4140793d$export$6ce170286acaa8d3);
$parcel$export(module.exports, "SearchFooterLabelWrapper", () => $27d3f42c4140793d$export$85cc5ece3620f7ef);
$parcel$export(module.exports, "SearchFooterLabel", () => $27d3f42c4140793d$export$db59656b68ced4b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $27d3f42c4140793d$export$6ce170286acaa8d3 = (0, $gwrgp.default)("div", {
    target: "er9v89y0"
})({
    name: "ab8yd1",
    styles: "display:flex;height:100%;"
});
const $27d3f42c4140793d$export$85cc5ece3620f7ef = (0, $gwrgp.default)("div", {
    target: "er9v89y1"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    gap: "var(--ds-space-025, 2px)",
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N90)})`
});
const $27d3f42c4140793d$export$db59656b68ced4b = (0, $gwrgp.default)("div", {
    target: "er9v89y2"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`,
    padding: `0px ${"var(--ds-space-025, 2px)"}`,
    borderRadius: '4px'
});

});

parcelRegister("f0f3d", function(module, exports) {

$parcel$export(module.exports, "ProductKeys", () => $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c);
$parcel$export(module.exports, "QuickFindConfluence", () => $5393c5baf4aba6f7$export$1763eeb490def9b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $iBckn = parcelRequire("iBckn");

var $k1wrx = parcelRequire("k1wrx");

var $dh538 = parcelRequire("dh538");

var $a5cba = parcelRequire("a5cba");

var $bF0iL = parcelRequire("bF0iL");

var $dDSTM = parcelRequire("dDSTM");

var $8ioQN = parcelRequire("8ioQN");

var $1WJaw = parcelRequire("1WJaw");

var $cnoUz = parcelRequire("cnoUz");

var $20N1w = parcelRequire("20N1w");

var $1OS8u = parcelRequire("1OS8u");

var $axxOe = parcelRequire("axxOe");

var $clOud = parcelRequire("clOud");

var $1x1dO = parcelRequire("1x1dO");

var $ktwn8 = parcelRequire("ktwn8");

var $iEwUU = parcelRequire("iEwUU");

var $5yZy1 = parcelRequire("5yZy1");

var $91yhh = parcelRequire("91yhh");

var $bK7ak = parcelRequire("bK7ak");

var $amrMu = parcelRequire("amrMu");
const $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c = {
    Confluence: 'confluence',
    Atlas: 'townsquare'
};
const $5393c5baf4aba6f7$export$a55448378aa900a7 = ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20N1w.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k1wrx.EnlargedSearchResultContent), {
            ...searchResult,
            isKeyboardHighlighted: isKeyboardHighlighted,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(searchResult.icon) ? searchResult.icon : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {})
        })
    });
};
const $5393c5baf4aba6f7$export$1763eeb490def9b = ({ onRetry: onRetry, linkComponent: linkComponent, confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, onPreQueryErrorCallback: onPreQueryErrorCallback, cloudId: cloudId, orgId: orgId, primaryProduct: primaryProduct })=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const features = (0, $amrMu.useFeaturesContext)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const appendAnalyticsQueryParams = (0, $bK7ak.useQueryParams)();
    const isEnhancedSearchAnalyticsEnabled = (0, $dh538.fg)('cc_page_experiences_enhanced_search_analytics_conf');
    const appendQueryParams = isEnhancedSearchAnalyticsEnabled && primaryProduct === 'confluence' ? appendAnalyticsQueryParams : undefined;
    const preQueryItemSupplier = (0, $iBckn.useQuickFindItemSupplier)({
        confCloudClient: confCloudClient,
        aggAbsoluteUrl: aggAbsoluteUrl,
        markErrorAsHandled: onPreQueryErrorCallback,
        itemRenderer: $5393c5baf4aba6f7$export$a55448378aa900a7,
        recentContentResultMapper: (0, $1OS8u.quickFindRecentItemResultMapper),
        recentSpaceResultMapper: (0, $axxOe.quickFindRecentSpaceResultMapper),
        userId: user.id,
        cloudId: cloudId
    });
    // This currently isn't being used for results fetching or rendering. It is
    // only being used to create an array of sections which are then used for
    // product registration. After product registration, these scopes are then
    // used to call the experiment endpoint, for this reason they need to be
    // valid scopes for each product.
    const defaultSections = (0, $gwFzn.useMemo)(()=>{
        switch(primaryProduct){
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Confluence:
                return [
                    {
                        id: 'confluence.page',
                        title: ''
                    }
                ];
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Atlas:
                return [
                    {
                        id: 'townsquare.goal',
                        title: ''
                    }
                ];
            default:
                return [];
        }
    }, [
        primaryProduct
    ]);
    const { backendExperiment: backendExperiment } = (0, $91yhh.useExperiments)();
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const quickFindPeopleAndTeamsResultMapper = (0, $clOud.getQuickFindPeopleAndTeamsResultMapper)(primaryProduct, orgId || '', cloudId);
    const quickFindPostQueryItemSupplier = (0, $iBckn.useQuickFindPostQueryItemSupplier)({
        cloudId: cloudId,
        resultRenderer: $5393c5baf4aba6f7$export$a55448378aa900a7,
        confluenceResultMapper: (0, $ktwn8.quickFindConfluenceContentMapper),
        atlasResultMapper: (0, $5yZy1.quickFindAtlasContentMapper),
        spaceResultMapper: (0, $1x1dO.quickFindConfluenceSpaceMapper),
        peopleAndTeamsResultMapper: quickFindPeopleAndTeamsResultMapper,
        sectionTitle: formatMessage((0, $dDSTM.messages).quick_find_results_section),
        userId: user.id,
        orgId: orgId,
        aggAbsoluteUrl: aggAbsoluteUrl,
        primaryProduct: primaryProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId
            }))
    });
    const noResultsPostQueryItemSupplier = (0, $gwFzn.useCallback)(()=>Promise.resolve((0, $8ioQN.EMPTY_SEARCH_ITEMS)), []);
    const postQueryItemSupplier = features?.quickFind?.postQueryDisabled ? noResultsPostQueryItemSupplier : quickFindPostQueryItemSupplier;
    // TODO: baseUrl is a holdover from QS and not needed in QF
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        let url = '';
        const params = new URLSearchParams();
        const trimmedQuery = query.trim();
        if (trimmedQuery) params.append('text', trimmedQuery);
        if (primaryProduct === $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Confluence) {
            url = '/wiki/search/';
            if (usage === 'onInputEnterModified') params.append('product', 'confluence');
        } else if (orgId && primaryProduct === $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Atlas) {
            url = `/o/${orgId}/search/`;
            params.append('cloudId', cloudId);
        }
        // URLSearchParams's toString will do encode special characters, however spaces
        // are encoded as +. We need to replace them with %20 to match existing behaviour.
        url += `?${params.toString()}`;
        url = url.replace(/\+/g, '%20');
        return url;
    }, [
        cloudId,
        orgId,
        primaryProduct
    ]);
    const title = (0, $gwFzn.useMemo)(()=>{
        switch(primaryProduct){
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Confluence:
                return formatMessage((0, $bF0iL.messages).confluence_tab_label);
            case $5393c5baf4aba6f7$export$ef2c0ffddaaaf76c.Atlas:
                return formatMessage((0, $bF0iL.messages).atlas_tab_label);
            default:
                return '';
        }
    }, [
        formatMessage,
        primaryProduct
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        permissionSupplier: ()=>Promise.resolve(defaultSections.map((s)=>s.id)),
        sections: defaultSections,
        id: primaryProduct,
        title: title,
        order: 0,
        expandedStateInputPlaceholder: formatMessage((0, $dDSTM.messages).quick_find_search_input_placeholder),
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier,
        onRetry: onRetry,
        ResultRenderer: (0, $1WJaw.QuickFindResultRenderer),
        SearchItemsTransformer: (0, $cnoUz.QuickFindConfluenceTransformer),
        isPrefetchingEnabled: true,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        searchFooterLabel: 'Search your organization',
        linkComponent: linkComponent,
        appendQueryParams: appendQueryParams
    });
};

});
parcelRegister("iBckn", function(module, exports) {

$parcel$export(module.exports, "RECENT_ITEMS_SECTION_ID", () => $39c726418f03e72e$export$9747eb11a16f4445);
$parcel$export(module.exports, "RECENT_SPACES_SECTION_ID", () => $39c726418f03e72e$export$3813b30107e5b323);
$parcel$export(module.exports, "useQuickFindItemSupplier", () => $39c726418f03e72e$export$ec546060f7cdc293);
$parcel$export(module.exports, "CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID", () => $39c726418f03e72e$export$7b0766a033869f00);
$parcel$export(module.exports, "useQuickFindPostQueryItemSupplier", () => $39c726418f03e72e$export$f872504428bf2e7e);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $c3vDd = parcelRequire("c3vDd");

var $ja8yA = parcelRequire("ja8yA");

var $9Lfxk = parcelRequire("9Lfxk");

var $jjQiR = parcelRequire("jjQiR");

var $gruCU = parcelRequire("gruCU");
const $39c726418f03e72e$var$INCLUDED_PRODUCTS = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
// To filter out Confluence comment results - although query does
// not include comment type it is still returning comment results
const $39c726418f03e72e$var$INCLUDED_OBJECT_TYPES = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED = 200;
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED = 10;
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED = 7;
const $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED = 3;
const $39c726418f03e72e$var$POST_QUERY_MAX_CONTENTS = 7;
const $39c726418f03e72e$var$POST_QUERY_MAX_SPACES = 1;
const $39c726418f03e72e$export$9747eb11a16f4445 = 'recent-items';
const $39c726418f03e72e$export$3813b30107e5b323 = 'recent-spaces';
const $39c726418f03e72e$export$ec546060f7cdc293 = ({ confCloudClient: confCloudClient, aggAbsoluteUrl: aggAbsoluteUrl, markErrorAsHandled: markErrorAsHandled, itemRenderer: itemRenderer, recentContentResultMapper: recentContentResultMapper, recentSpaceResultMapper: recentSpaceResultMapper, userId: userId, cloudId: cloudId })=>{
    return (0, $gwFzn.useCallback)(async ()=>{
        const getSections = ({ recentContents: recentContents, recentSpaces: recentSpaces })=>({
                sections: [
                    {
                        id: $39c726418f03e72e$export$9747eb11a16f4445,
                        title: '',
                        searchResults: recentContents,
                        resultLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_DISPLAYED,
                        resultRenderer: itemRenderer
                    },
                    {
                        id: $39c726418f03e72e$export$3813b30107e5b323,
                        title: '',
                        searchResults: recentSpaces,
                        resultLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_DISPLAYED,
                        resultRenderer: itemRenderer
                    }
                ]
            });
        if (!userId) return getSections({
            recentContents: [],
            recentSpaces: []
        });
        const recentActivitiesPromise = (0, $ja8yA.recentActivitiesQuery)({
            variables: {
                filteredProducts: $39c726418f03e72e$var$INCLUDED_PRODUCTS,
                filteredObjectTypes: (0, $dh538.fg)('smartlinks-qf-recents') ? $39c726418f03e72e$var$INCLUDED_OBJECT_TYPES : $39c726418f03e72e$var$INCLUDED_OBJECT_TYPES.filter((type)=>type !== 'remote-link'),
                filteredRootContainerIds: [
                    `ari:cloud:platform::site/${cloudId}`,
                    // covers Confluence, Jira
                    `ari:cloud:townsquare::site/${cloudId}` // for some reason Atlas has a different root container id
                ],
                itemsLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_CONTENTS_FETCHED
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        });
        const recentSpacesPromise = confCloudClient ? confCloudClient.query({
            query: (0, $c3vDd.QuickFindSpacesQuery),
            variables: {
                spaceLimit: $39c726418f03e72e$var$PRE_QUERY_MAX_RECENT_SPACES_FETCHED
            }
        }) : Promise.resolve(undefined);
        const { recentContents: recentContents, recentSpaces: recentSpaces } = await Promise.all([
            recentActivitiesPromise,
            recentSpacesPromise
        ]).then(([recentItemsResponse, recentSpacesResponse])=>{
            const recentContents = recentItemsResponse?.data?.activity?.myActivity?.all.edges.filter((edge)=>edge?.node?.object?.data).map(recentContentResultMapper) || [];
            const recentSpacesResults = (0, $gruCU.parsePartialApolloResults)(recentSpacesResponse?.data?.myVisitedSpaces, recentSpacesResponse?.errors);
            const recentSpaces = recentSpacesResults?.nodes?.spaces?.map(recentSpaceResultMapper) || [];
            return {
                recentContents: recentContents,
                recentSpaces: recentSpaces
            };
        }).catch((err)=>{
            markErrorAsHandled && markErrorAsHandled(err);
            throw err;
        });
        return getSections({
            recentContents: recentContents,
            recentSpaces: recentSpaces
        });
    }, [
        confCloudClient,
        userId,
        markErrorAsHandled,
        itemRenderer,
        recentContentResultMapper,
        recentSpaceResultMapper,
        aggAbsoluteUrl,
        cloudId
    ]);
};
const $39c726418f03e72e$var$CONFLUENCE_CONTENT_ENTITIES = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database'
];
const $39c726418f03e72e$var$ATLAS_ENTITIES = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
const $39c726418f03e72e$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID = 'townsquare.project,goal,tag';
const $39c726418f03e72e$export$7b0766a033869f00 = 'confluence.page,blogpost,attachment';
const $39c726418f03e72e$export$47653725e5b469bb = 'space';
const $39c726418f03e72e$export$f80b16ba1f3b0d5c = 'people-and-teams';
const $39c726418f03e72e$var$ProductKeys = {
    Confluence: 'confluence',
    Atlas: 'townsquare'
};
const $39c726418f03e72e$export$f872504428bf2e7e = ({ aggAbsoluteUrl: aggAbsoluteUrl, cloudId: cloudId, resultRenderer: resultRenderer, confluenceResultMapper: confluenceResultMapper, atlasResultMapper: atlasResultMapper, spaceResultMapper: spaceResultMapper, peopleAndTeamsResultMapper: peopleAndTeamsResultMapper, sectionTitle: sectionTitle, userId: userId, orgId: orgId, primaryProduct: primaryProduct, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers })=>{
    const intl = (0, $dBxQj.default)();
    return (0, $gwFzn.useCallback)(async (args)=>{
        const { query: query, analyticsInfo: analyticsInfo } = args;
        const getPeopleAndTeamsResults = async (query, userId, cloudId)=>{
            if (!userId || !cloudId) return [];
            const peopleResults = await (0, $jjQiR.getUserAndTeamSearchResults)({
                query: query,
                cloudId: cloudId,
                principalId: userId || '',
                orgId: orgId || '',
                intl: intl
            }).catch((e)=>{
                console.error(e);
                return [];
            });
            return peopleResults.map(peopleAndTeamsResultMapper);
        };
        const getConfluenceResults = async (query, cloudId)=>{
            const contentQueryResults = await (0, $9Lfxk.quickFindSearchQuery)({
                variables: {
                    query: query,
                    cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                    resultsLimit: $39c726418f03e72e$var$POST_QUERY_MAX_CONTENTS,
                    spaceLimit: $39c726418f03e72e$var$POST_QUERY_MAX_SPACES,
                    includeAncestors: true,
                    // to show breadcrumbs
                    contentEntities: $39c726418f03e72e$var$CONFLUENCE_CONTENT_ENTITIES,
                    confluenceFilters: {
                        titleMatchOnly: true
                    },
                    searchSessionId: analyticsInfo?.searchSessionId,
                    queryVersion: analyticsInfo?.queryVersion,
                    includeSpaces: true,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            });
            const contentResponse = contentQueryResults.data?.search.results?.edges || [];
            const contentResults = contentResponse.map(confluenceResultMapper);
            const spaceResponse = contentQueryResults.data?.search.spaces?.edges || [];
            const spaceResults = spaceResponse.map(spaceResultMapper);
            return {
                contentResults: contentResults,
                spaceResults: spaceResults
            };
        };
        const getAtlasResults = async (query, analyticsInfo)=>{
            const contentQueryResults = await (0, $9Lfxk.quickFindSearchQuery)({
                variables: {
                    query: query,
                    cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
                    contentEntities: $39c726418f03e72e$var$ATLAS_ENTITIES,
                    confluenceFilters: {
                        titleMatchOnly: true
                    },
                    // this filter is applied on Atlas results as well
                    resultsLimit: $39c726418f03e72e$var$POST_QUERY_MAX_CONTENTS,
                    spaceLimit: $39c726418f03e72e$var$POST_QUERY_MAX_SPACES,
                    includeAncestors: false,
                    searchSessionId: analyticsInfo?.searchSessionId,
                    queryVersion: analyticsInfo?.queryVersion,
                    includeSpaces: false,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            });
            const contentResponse = contentQueryResults.data?.search.results?.edges || [];
            const contentResults = contentResponse.map(atlasResultMapper);
            return {
                contentResults: contentResults,
                spaceResults: []
            };
        };
        const getResults = (product)=>{
            switch(product){
                case $39c726418f03e72e$var$ProductKeys.Confluence:
                    return getConfluenceResults(query, cloudId);
                case $39c726418f03e72e$var$ProductKeys.Atlas:
                    return getAtlasResults(query, analyticsInfo);
                default:
                    return getConfluenceResults(query, cloudId);
            }
        };
        const { contentResults: contentResults, spaceResults: spaceResults } = await getResults(primaryProduct);
        const peopleAndTeamsResults = await getPeopleAndTeamsResults(query, userId, cloudId);
        const getContentSectionId = (product)=>{
            switch(product){
                case $39c726418f03e72e$var$ProductKeys.Confluence:
                    return $39c726418f03e72e$export$7b0766a033869f00;
                case $39c726418f03e72e$var$ProductKeys.Atlas:
                    return $39c726418f03e72e$var$ATLAS_PROJECT_GOAL_TAG_SECTION_ID;
                default:
                    return $39c726418f03e72e$export$7b0766a033869f00;
            }
        };
        return {
            sections: [
                {
                    id: getContentSectionId(primaryProduct),
                    title: sectionTitle,
                    searchResults: contentResults,
                    resultRenderer: resultRenderer
                },
                {
                    id: $39c726418f03e72e$export$47653725e5b469bb,
                    searchResults: spaceResults,
                    title: !contentResults.length ? sectionTitle : '',
                    resultRenderer: resultRenderer
                },
                {
                    id: $39c726418f03e72e$export$f80b16ba1f3b0d5c,
                    searchResults: peopleAndTeamsResults,
                    title: !contentResults.length && !spaceResults.length ? sectionTitle : '',
                    resultRenderer: resultRenderer
                }
            ]
        };
    }, [
        cloudId,
        resultRenderer,
        confluenceResultMapper,
        atlasResultMapper,
        spaceResultMapper,
        peopleAndTeamsResultMapper,
        sectionTitle,
        intl,
        orgId,
        userId,
        aggAbsoluteUrl,
        primaryProduct,
        experimentId,
        shadowExperimentId,
        experimentLayers
    ]);
};

});
parcelRegister("c3vDd", function(module, exports) {

$parcel$export(module.exports, "QuickFindSpacesQuery", () => $7c8d7e5d36cb13e1$export$9af2898b36d6a2cf);

var $d2LG0 = parcelRequire("d2LG0");
const $7c8d7e5d36cb13e1$var$QuickFindSpacesFragment = (0, $d2LG0.default)`fragment QuickFindSpacesFragment on Space{id key name icon{path}links{webui}}`;
const $7c8d7e5d36cb13e1$export$9af2898b36d6a2cf = (0, $d2LG0.default)`query QuickFindSpacesQuery($spaceLimit:Int!){myVisitedSpaces(limit:$spaceLimit){nodes{spaces{...QuickFindSpacesFragment}}}}${$7c8d7e5d36cb13e1$var$QuickFindSpacesFragment}`;

});

parcelRegister("9Lfxk", function(module, exports) {

$parcel$export(module.exports, "quickFindSearchQuery", () => $8c45e3f8287acbdd$export$ac350a1cbaa2773a);

var $4qT1X = parcelRequire("4qT1X");

var $3xvML = parcelRequire("3xvML");
const $8c45e3f8287acbdd$export$ac350a1cbaa2773a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $3xvML.quickFindSearchGraphQuery),
        operationName: $3xvML.operationName
    });
};

});
parcelRegister("3xvML", function(module, exports) {

$parcel$export(module.exports, "operationName", () => $c3125637c00709c9$export$5db520940cf00715);
$parcel$export(module.exports, "quickFindSearchGraphQuery", () => $c3125637c00709c9$export$5dd443f88002bca3);
const $c3125637c00709c9$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    __typename
    key
  }
}
`;
const $c3125637c00709c9$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    __typename
    key
  }
}
`;
const $c3125637c00709c9$var$SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
  __typename
  lastModified
  iconCssClass
  space {
    __typename
    id
    name
  }
  confluenceEntity @include(if: $includeAncestors) {
    ... on ConfluencePage {
      __typename
      ancestors {
        __typename
        id
        title
      }
    }
  }
}`;
const $c3125637c00709c9$export$5db520940cf00715 = 'QuickFindSearchQuery';
const $c3125637c00709c9$export$5dd443f88002bca3 = `
  query ${$c3125637c00709c9$export$5db520940cf00715}(
    $query: String!
    $cloudIdARI: String!
    $resultsLimit: Int!
    $spaceLimit: Int!
    $contentEntities: [String!]!
    $confluenceFilters: SearchConfluenceFilter
    $queryVersion: Int
    $searchSessionId: String
    $includeSpaces: Boolean!
    $includeAncestors: Boolean!
    $experimentId: String
    $shadowExperimentId: String
    $experimentLayers: [SearchExperimentLayer]
  ) {
    search {
      results: search(
        experience: "quick-find"
        query: $query
        first: $resultsLimit
        filters: {
          entities: $contentEntities
          locations: [$cloudIdARI]
          confluenceFilters: $confluenceFilters
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
        experimentContext: {
          experimentId: $experimentId
          shadowExperimentId: $shadowExperimentId
          experimentLayers: $experimentLayers
        }
      ) {
        __typename
        edges {
          __typename
          node {
            id
            title
            url
            type
            iconUrl
            __typename
            ${$c3125637c00709c9$var$SearchConfluencePageBlogAttachment}
            ${$c3125637c00709c9$var$SearchResultAtlasProject}
            ${$c3125637c00709c9$var$SearchResultAtlasGoal}
          }
        }
        abTest {
          __typename
          abTestId
          controlId
          experimentId
        }
        totalCount
      }
      spaces: search(
        experience: "searchDialog"
        query: $query
        first: $spaceLimit
        filters: {
          entities: ["ati:cloud:confluence:space"]
          locations: [$cloudIdARI]
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
      ) @include(if: $includeSpaces) {
        __typename
        edges {
          __typename
          node {
            ... on SearchConfluenceSpace {
              __typename
              id
              key
              title
              type
              url
              iconPath
            }
          }
        }
      }
    }
  }
`;

});


parcelRegister("jjQiR", function(module, exports) {

$parcel$export(module.exports, "getUserAndTeamSearchResults", () => $dca90199d0dcae68$export$69624d2b3a5a261b);

var $5kTPO = parcelRequire("5kTPO");
const $dca90199d0dcae68$var$MAX_RESULTS_USERS = 2;
const $dca90199d0dcae68$export$6e670d76ab78fcb3 = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $dca90199d0dcae68$export$69624d2b3a5a261b = ({ query: query, cloudId: cloudId, orgId: orgId, principalId: principalId = 'Context', intl: intl })=>(0, $5kTPO.default)({
        searchQueryFilter: $dca90199d0dcae68$export$6e670d76ab78fcb3,
        includeUsers: true,
        includeGroups: false,
        includeTeams: true,
        context: {
            contextType: 'confluence_search-dialog',
            principalId: principalId,
            productKey: 'confluence',
            siteId: cloudId,
            organizationId: orgId
        },
        maxNumberOfResults: $dca90199d0dcae68$var$MAX_RESULTS_USERS,
        query: query
    }, intl);

});

parcelRegister("gruCU", function(module, exports) {

$parcel$export(module.exports, "parsePartialApolloResults", () => $5eb9952c6e8f9411$export$e877f985e0128c5e);

var $3pqlr = parcelRequire("3pqlr");
function $5eb9952c6e8f9411$export$e877f985e0128c5e(data, graphQLErrors) {
    // Return data if there are no errors
    if (!graphQLErrors?.length) return data;
    // Return data if there are errors, but there is also partial data
    if (graphQLErrors?.length && data) {
        console.warn('Returning partial data despite GraphQL errors: ', graphQLErrors);
        return data;
    }
    // Throw an exception only if there are errors and NO data
    throw new (0, $3pqlr.GraphQLNoResultsWithErrorResponseError)(graphQLErrors);
}

});
parcelRegister("3pqlr", function(module, exports) {

$parcel$export(module.exports, "GraphQLNoResultsWithErrorResponseError", () => $1c744931ef76935f$export$beb638af7aef4c03);
class $1c744931ef76935f$export$beb638af7aef4c03 extends Error {
    constructor(graphQLErrors){
        super();
        this.graphQLErrors = void 0;
        this.name = 'GraphQLNoResultsWithErrorResponseError';
        this.graphQLErrors = graphQLErrors;
        this.message = 'GraphQL returned errors and no results';
    }
}

});



parcelRegister("k1wrx", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchResultContent", () => $136b05df76cfe49d$export$171a2a7e5a778acc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dfZ5P = parcelRequire("dfZ5P");
var $jqsW9 = parcelRequire("jqsW9");

var $68Mwd = parcelRequire("68Mwd");

var $4jR19 = parcelRequire("4jR19");

var $9lW6K = parcelRequire("9lW6K");

var $1qfLF = parcelRequire("1qfLF");

var $5tPRL = parcelRequire("5tPRL");
const $136b05df76cfe49d$export$171a2a7e5a778acc = ({ icon: icon, label: label, title: title, highlightedTitle: highlightedTitle, meta: meta, additionalMeta: additionalMeta, displayAdditionalMetaWhenHighlightedOnly: displayAdditionalMetaWhenHighlightedOnly, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, returnIcon: returnIcon = 'onHighlight', isRecentSearch: isRecentSearch, onRemove: onRemove })=>{
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    const [isHover, setIsHover] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const isActive = isKeyboardHighlighted || isHover;
    const showReturnIcon = (0, $gwFzn.useMemo)(()=>(returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch, [
        isKeyboardHighlighted,
        returnIcon,
        isRecentSearch
    ]);
    const showRemoveIcon = (0, $gwFzn.useMemo)(()=>isRecentSearch && isActive, [
        isRecentSearch,
        isActive
    ]);
    const showAdditionalMeta = (0, $gwFzn.useMemo)(()=>additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive), [
        displayAdditionalMetaWhenHighlightedOnly,
        isActive,
        additionalMeta
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.EnlargedResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedIconContainer), {
                children: icon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.EnlargedResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            typeof title === 'string' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                                    title: title,
                                    className: "SearchDialogResultTitle",
                                    children: highlightedTitle ? (0, $9lW6K.enrichResultTitle)(highlightedTitle) : title
                                })
                            }) : title,
                            typeof label === 'string' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultLabel), {
                                title: label,
                                children: label
                            }) : label
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedCollapsedResultDetailWrapper), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedCollapsedResultDetail), {
                            children: meta
                        })
                    })
                ]
            }),
            showAdditionalMeta && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedResultDetail), {
                children: additionalMeta
            }),
            showReturnIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jqsW9.SquareReturnIcon), {})
            }),
            showRemoveIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    icon: (0, $dfZ5P.RemoveIcon),
                    spacing: 'compact',
                    onClick: onRemove,
                    label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $68Mwd.messages).remove_button_label
                    }),
                    appearance: 'subtle'
                })
            })
        ]
    });
};

});
parcelRegister("jqsW9", function(module, exports) {

$parcel$export(module.exports, "SquareReturnIcon", () => $247b5da4c2bbf48f$export$4501fc029b186da8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $247b5da4c2bbf48f$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});

parcelRegister("68Mwd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $23def8654352e503$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $23def8654352e503$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    remove_button_label: {
        id: "search_dialog.results.remove_button_label",
        defaultMessage: "Remove this."
    }
});

});


parcelRegister("dDSTM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $383eef3932fe8448$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $383eef3932fe8448$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Quick Find
   */ quick_find_search_input_placeholder: {
        id: "product_search_dialog.quick_find_search_input_rovo_placeholder",
        defaultMessage: "Search or ask Rovo"
    },
    quick_find_recent_search_text_dialog: {
        id: "product_search_dialog.quick_find_recent_search_text_dialog",
        defaultMessage: "From your recent searches"
    },
    quick_find_show_organization_results: {
        id: "product_search_dialog.quick_find_show_organization_results",
        defaultMessage: "Search your organization"
    },
    quick_find_show_filtered_results: {
        id: "product_search_dialog.quick_find_show_filtered_confluence_results",
        defaultMessage: "Filter by Confluence spaces, contributors and more"
    },
    quick_find_show_filtered_results_with_icon: {
        id: "product_search_dialog.quick_find_show_filtered_confluence_results_with_icon",
        defaultMessage: "Filter by {confluenceIcon} Confluence spaces, contributors and more"
    },
    quick_find_ask_atlassian_intelligence: {
        id: "product_search_dialog.quick_find_ask_atlassian_intelligence",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    quick_find_recently_viewed: {
        id: "product_search_dialog.quick_find_recently_viewed",
        defaultMessage: "Recently Viewed"
    },
    quick_find_recent_draft_label: {
        id: "product_search_dialog.quick_find_recent_draft_label",
        defaultMessage: "DRAFT"
    },
    quick_find_recent_spaces_additional_meta: {
        id: "product_search_dialog.quick_find_recent_spaces_additional_meta",
        defaultMessage: "You recently visited"
    },
    quick_find_footer_text: {
        id: "product_search_dialog.quick_find_footer_help_text",
        defaultMessage: "Help us improve search"
    },
    quick_find_footer_full_page_search_link: {
        id: "product_search_dialog.quick_find_footer_full_page_search_products_link",
        defaultMessage: "Search across products"
    },
    quick_find_no_content_header: {
        id: "product_search_dialog.quick_find_no_content_header",
        defaultMessage: "Seek and you shall find"
    },
    quick_find_no_content_body: {
        id: "product_search_dialog.quick_find_no_content_body_rovo",
        defaultMessage: "Search or ask Rovo what you're looking for in your Atlassian and integrated products"
    },
    quick_find_post_query_no_results_header: {
        id: "product_search_dialog.quick_find_post_query_no_results_header",
        defaultMessage: "We couldn't find any results with that title"
    },
    quick_find_post_query_no_results_body: {
        id: "product_search_dialog.quick_find_post_query_no_results_body",
        defaultMessage: "<SearchContentLink>Search all content across your organization</SearchContentLink> or try again with a different term."
    },
    quick_find_search_results: {
        id: "product_search_dialog.quick_find_search_results",
        defaultMessage: "Search Results"
    },
    quick_find_confluence_space: {
        id: "product_search_dialog.quick_find_confluence_space",
        defaultMessage: "Confluence Space"
    },
    quick_find_results_section: {
        id: "product_search_dialog.quick_find_results_section",
        defaultMessage: "Search Results"
    },
    quick_find_results_team: {
        id: "product_search_dialog.quick_find_result_item_team",
        defaultMessage: "Team"
    },
    quick_find_recent_search: {
        id: "product_search_dialog.quick_find_recent_search",
        defaultMessage: "Recent search"
    },
    remove_button_label: {
        id: "product_search_dialog.results.remove_button_label",
        defaultMessage: "Remove this."
    },
    quick_find_rovo_tip: {
        id: "product_search_dialog.quick_find_rovo_tip",
        defaultMessage: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer."
    }
});

});

parcelRegister("8ioQN", function(module, exports) {

$parcel$export(module.exports, "EMPTY_SEARCH_ITEMS", () => $e45c02ccc2a6876d$export$205c1cd8d8ed1926);
const $e45c02ccc2a6876d$export$205c1cd8d8ed1926 = {
    size: 0,
    sections: []
};

});

parcelRegister("1WJaw", function(module, exports) {

$parcel$export(module.exports, "QuickFindResultRenderer", () => $1eb9e7406142d7a1$export$6e27f80792772bd6);

var $7UHDa = parcelRequire("7UHDa");

var $exgPf = parcelRequire("exgPf");
var $bO2XA = parcelRequire("bO2XA");
var $2LczZ = parcelRequire("2LczZ");

var $gwFzn = parcelRequire("gwFzn");

var $jFPud = parcelRequire("jFPud");

var $kPY5t = parcelRequire("kPY5t");

var $kUZlH = parcelRequire("kUZlH");

var $kf2EW = parcelRequire("kf2EW");
var $iN7gh = parcelRequire("iN7gh");
var $2hOQY = parcelRequire("2hOQY");

var $kTE07 = parcelRequire("kTE07");

var $4jR19 = parcelRequire("4jR19");

var $dDSTM = parcelRequire("dDSTM");

var $4Lm6U = parcelRequire("4Lm6U");

var $2hOQY = parcelRequire("2hOQY");

var $fJRVo = parcelRequire("fJRVo");

var $hyKIh = parcelRequire("hyKIh");

var $cGCOz = parcelRequire("cGCOz");

var $f0f3d = parcelRequire("f0f3d");

var $7OZuO = parcelRequire("7OZuO");

var $4ldrV = parcelRequire("4ldrV");

var $2OcMi = parcelRequire("2OcMi");
const $1eb9e7406142d7a1$export$6e27f80792772bd6 = ({ productState: productState, preQueryItems: preQueryItems, postQueryItems: postQueryItems, linkComponent: linkComponent, appendQueryParams: appendQueryParams, onRetryPreQuery: onRetryPreQuery, onRetryPostQuery: onRetryPostQuery })=>{
    const isMobileView = (0, $kPY5t.useIsMobileView)();
    const { isRovoEnabled: isRovoEnabled } = (0, $cGCOz.useRovoContext)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const productId = activeProduct?.id;
    const renderResults = (0, $gwFzn.useCallback)(()=>{
        switch(productState){
            case (0, $jFPud.ProductStates).PreQuerySuccess:
            case (0, $jFPud.ProductStates).PreQueryLoading:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: preQueryItems,
                    linkComponent: linkComponent,
                    screen: "preQuerySearchResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
            case (0, $jFPud.ProductStates).PreQueryNoResult:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kTE07.PreQueryEmptyScreen), {});
            case (0, $jFPud.ProductStates).PreQueryError:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Lm6U.SearchErrorScreen), {
                    onRetry: onRetryPreQuery
                });
            case (0, $jFPud.ProductStates).PostQueryTyping:
            case (0, $jFPud.ProductStates).PostQueryLoading:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: postQueryItems,
                    linkComponent: linkComponent,
                    screen: "cachedResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams,
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bO2XA.EnlargedSearchResultSection), {
                        title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $dDSTM.messages).quick_find_search_results
                        }),
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {}),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exgPf.EnlargedSearchResultContentSkeleton), {})
                        ]
                    })
                });
            case (0, $jFPud.ProductStates).PostQueryError:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Lm6U.SearchErrorScreen), {
                    onRetry: onRetryPostQuery
                });
            case (0, $jFPud.ProductStates).PostQueryNoResult:
                const urlGeneratorForNoResultsScreen = (query)=>{
                    const generateUrl = activeProduct?.generateAdvancedSearchUrl || (()=>'');
                    const advancedSearchUrl = generateUrl(query);
                    return (0, $2OcMi.addQuery)(advancedSearchUrl, 'search_id', searchSessionId);
                };
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7OZuO.default), {
                    urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
                    fromQuickFindPostQueryNoResults: true
                });
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUZlH.GenericSearchResult), {
                    searchItems: postQueryItems,
                    linkComponent: linkComponent,
                    screen: "postQuerySearchResults",
                    productState: productState,
                    isCollapsed: isMobileView,
                    appendQueryParams: appendQueryParams
                });
        }
    }, [
        productState,
        preQueryItems,
        linkComponent,
        isMobileView,
        appendQueryParams,
        postQueryItems,
        onRetryPreQuery,
        onRetryPostQuery,
        activeProduct?.generateAdvancedSearchUrl,
        searchSessionId
    ]);
    const showSearchFooter = productState === (0, $jFPud.ProductStates).PreQuerySuccess || productState === (0, $jFPud.ProductStates).PreQueryLoading || productState === (0, $jFPud.ProductStates).PreQueryNoResult || productId === (0, $f0f3d.ProductKeys).Confluence && (productState === (0, $jFPud.ProductStates).PostQuerySuccess || productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryNoResult);
    const showFilterFooter = productId === (0, $f0f3d.ProductKeys).Confluence && (productState === (0, $jFPud.ProductStates).PostQuerySuccess || productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryNoResult);
    const showFeedbackFooter = productState === (0, $jFPud.ProductStates).PreQuerySuccess || productState === (0, $jFPud.ProductStates).PostQuerySuccess || productState === (0, $jFPud.ProductStates).PostQueryLoading || productState === (0, $jFPud.ProductStates).PostQueryNoResult;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            isRovoEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hyKIh.QuickFindRovoTip), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LczZ.SearchDialogContent), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LczZ.ResultContainerOuter), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2LczZ.ResultContainer), {
                        "aria-live": "polite",
                        children: renderResults()
                    })
                })
            }),
            showSearchFooter && productId === (0, $f0f3d.ProductKeys).Confluence ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2hOQY.SearchFooterPersistRecentSearch), {
                linkComponent: linkComponent
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2hOQY.SearchFooter), {
                linkComponent: linkComponent
            }),
            showFilterFooter && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iN7gh.FilterFooter), {}),
            showFeedbackFooter && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kf2EW.FeedbackFooter), {})
        ]
    });
};

});
parcelRegister("exgPf", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchResultContentSkeleton", () => $f5c3065a125d2f4b$export$958cb3907bb9ede);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5tPRL = parcelRequire("5tPRL");
const $f5c3065a125d2f4b$export$958cb3907bb9ede = ({})=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.EnlargedResultContentWrapper), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedIconContainer), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedSkeletonIcon), {})
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedResultTitleContainerSkeleton), {}),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedResultDetailSkeleton), {})
                ]
            })
        ]
    });
};

});

parcelRegister("bO2XA", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchResultSection", () => $c6b6394c69100db5$export$3cb2a92d364e01db);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $c4sKh = parcelRequire("c4sKh");

var $hiGBZ = parcelRequire("hiGBZ");
const $c6b6394c69100db5$export$3cb2a92d364e01db = ({ title: title, totalResults: totalResults, children: children })=>{
    const hasTitle = Boolean(title);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hiGBZ.EnlargedSearchResultSectionContainer), {
        "data-vc": "search-result-section-enlarged",
        children: [
            hasTitle && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hiGBZ.EnlargedSearchResultSectionHeading), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hiGBZ.EnlargedSearchResultsSectionTitle), {
                    children: [
                        title,
                        totalResults ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hiGBZ.SearchResultSectionTitleBadgeContainer), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
                                testId: "search-result-count-badge",
                                children: totalResults
                            })
                        }) : null
                    ]
                })
            }),
            children
        ]
    });
};

});
parcelRegister("hiGBZ", function(module, exports) {

$parcel$export(module.exports, "SearchResultSectionContainer", () => $4c44caf80474dcb2$export$ee908270616a8c0);
$parcel$export(module.exports, "EnlargedSearchResultSectionContainer", () => $4c44caf80474dcb2$export$503dfba90bfcca30);
$parcel$export(module.exports, "SearchResultSectionHeading", () => $4c44caf80474dcb2$export$12a98bde80b93e83);
$parcel$export(module.exports, "EnlargedSearchResultSectionHeading", () => $4c44caf80474dcb2$export$7ff5e58611d4f213);
$parcel$export(module.exports, "SearchResultsSectionTitle", () => $4c44caf80474dcb2$export$ce295363b4299a23);
$parcel$export(module.exports, "EnlargedSearchResultsSectionTitle", () => $4c44caf80474dcb2$export$ba58138b255a651c);
$parcel$export(module.exports, "SearchResultSectionTitleBadgeContainer", () => $4c44caf80474dcb2$export$47dafe5a3fc802fe);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $2azjJ = parcelRequire("2azjJ");

var $gwrgp = parcelRequire("gwrgp");
const $4c44caf80474dcb2$export$ee908270616a8c0 = (0, $gwrgp.default)("div", {
    target: "e1vq42j40"
})({
    padding: `${"var(--ds-space-100, 8px)"} 0`
});
const $4c44caf80474dcb2$export$503dfba90bfcca30 = (0, $gwrgp.default)("div", {
    target: "e1vq42j41"
})({
    name: "13xfj3y",
    styles: "padding:0;display:flex;flex-direction:column;gap:var(--ds-space-025, 2px);"
});
const $4c44caf80474dcb2$export$12a98bde80b93e83 = (0, $gwrgp.default)("div", {
    target: "e1vq42j42"
})({
    marginBottom: "var(--ds-space-075, 6px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: (0, $2azjJ.grid).multiple(4).px
});
const $4c44caf80474dcb2$export$7ff5e58611d4f213 = (0, $gwrgp.default)("div", {
    target: "e1vq42j43"
})({
    name: "1pkue4f",
    styles: "height:28px;display:flex;"
});
const $4c44caf80474dcb2$export$ce295363b4299a23 = (0, $gwrgp.default)("h2", {
    target: "e1vq42j44"
})({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $2azjJ.grid).twice().px,
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2azjJ.grid).twice().px}`
});
const $4c44caf80474dcb2$export$ba58138b255a651c = (0, $gwrgp.default)("span", {
    target: "e1vq42j45"
})({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`,
    boxSizing: 'border-box',
    padding: `0 ${"var(--ds-space-100, 8px)"}`
});
const $4c44caf80474dcb2$export$47dafe5a3fc802fe = (0, $gwrgp.default)("div", {
    target: "e1vq42j46"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $2azjJ.grid).px,
    fontWeight: "var(--ds-font-weight-regular, 400)"
});

});


parcelRegister("jFPud", function(module, exports) {

$parcel$export(module.exports, "APIStates", () => $dfe01d0022147fd7$export$c701d1d8ac310aa0);
$parcel$export(module.exports, "ProductStates", () => $dfe01d0022147fd7$export$212790b4ffec121f);
var $dfe01d0022147fd7$export$c701d1d8ac310aa0 = /*#__PURE__*/ function(APIStates) {
    APIStates["Typing"] = "typing";
    APIStates["Loading"] = "loading";
    APIStates["Error"] = "error";
    APIStates["NoResult"] = "noresult";
    APIStates["Success"] = "success";
    return APIStates;
}({});
var $dfe01d0022147fd7$export$212790b4ffec121f = /*#__PURE__*/ function(ProductStates) {
    ProductStates["PreQueryLoading"] = "PreQueryLoading";
    ProductStates["PostQueryLoading"] = "PostQueryLoading";
    ProductStates["PreQuerySuccess"] = "PreQuerySuccess";
    ProductStates["PostQuerySuccess"] = "PostQuerySuccess";
    ProductStates["PreQueryError"] = "PreQueryError";
    ProductStates["PostQueryError"] = "PostQueryError";
    ProductStates["PreQueryNoResult"] = "PreQueryNoResult";
    ProductStates["PostQueryNoResult"] = "PostQueryNoResult";
    ProductStates["PostQueryTyping"] = "PostQueryTyping";
    ProductStates["Invalid"] = "Invalid";
    return ProductStates;
}({});

});

parcelRegister("kPY5t", function(module, exports) {

$parcel$export(module.exports, "useIsMobileView", () => $67b453f3f4811515$export$853d1166284edec0);

var $2azjJ = parcelRequire("2azjJ");
const $67b453f3f4811515$export$853d1166284edec0 = ()=>window.innerWidth <= (0, $2azjJ.dialogPageTakeoverWidth);

});

parcelRegister("kUZlH", function(module, exports) {

$parcel$export(module.exports, "GenericSearchResult", () => $3e96c9432766ab22$export$855c9ab7e6e3e97f);

var $7UHDa = parcelRequire("7UHDa");

var $bO2XA = parcelRequire("bO2XA");
var $lpcw3 = parcelRequire("lpcw3");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $hpDfc = parcelRequire("hpDfc");

var $2jE99 = parcelRequire("2jE99");

var $i0h8F = parcelRequire("i0h8F");

var $ipASa = parcelRequire("ipASa");

var $20N1w = parcelRequire("20N1w");

var $amrMu = parcelRequire("amrMu");

var $38QdT = parcelRequire("38QdT");
const $3e96c9432766ab22$export$f6fdc80358dfd95 = 10;
const $3e96c9432766ab22$export$fd06a2c70d34842e = (searchResultSections, sectionIndex)=>searchResultSections.slice(0, sectionIndex).reduce((accumulator, currentElem)=>accumulator + Math.min(currentElem.searchResults.length, currentElem.resultLimit || $3e96c9432766ab22$export$f6fdc80358dfd95), 0);
const $3e96c9432766ab22$var$getTotalResultCount = (forceHideResultCount, section)=>{
    // resultCount is only shown when a size is specified. We changed this
    // from using searchResults.length as we want to indicate the number of
    // possible search results rather than just the ones shown.
    const resultCount = !forceHideResultCount && section.showResultCount && section.size && section.searchResults.length ? Math.max(section.size, section.searchResults.length) : undefined;
    // totalResults considers the count returned from a section's resultMapper
    // to ensure rendered results align with the displayed count, in case results shown
    // are limited by the resultMapper
    const totalResults = Boolean(resultCount && section.searchResults.length < (section.resultLimit || $3e96c9432766ab22$export$f6fdc80358dfd95) && resultCount >= section.searchResults.length) ? section.searchResults.length : resultCount;
    return totalResults;
};
const $3e96c9432766ab22$var$GenericSearchResultWithIntl = ({ children: children, forceHideResultCount: forceHideResultCount = false, generateSectionTitle: generateSectionTitle = ({ title: title })=>title, intl: intl, isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, renderSectionViewAll: renderSectionViewAll, searchItems: searchItems, screen: screen, nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext, appendQueryParams: appendQueryParams })=>{
    const { quickFind: quickFind } = (0, $amrMu.useFeaturesContext)();
    if (!searchItems || !(0, $2jE99.hasSearchResults)(searchItems)) {
        // This is mainly used to handle the loading state (e.g. a spinner or a skeleton)
        if (children) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $38QdT.SearchResultWrapper), {
            children: children
        });
        return null;
    }
    const ResultSection = quickFind?.enabled ? (0, $bO2XA.EnlargedSearchResultSection) : (0, $lpcw3.SearchResultSection);
    const QuickFindPersistRecentSearch = quickFind?.enabled ? (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment : (0, $20N1w.PersistRecentSearch);
    const ItemSection = (props)=>{
        const { section: section, sectionIndex: sectionIndex } = props;
        const itemLimit = typeof section.resultLimit === 'number' ? section.resultLimit : $3e96c9432766ab22$export$f6fdc80358dfd95;
        const searchResults = section.searchResults?.slice(0, itemLimit) || [];
        const totalResults = $3e96c9432766ab22$var$getTotalResultCount(forceHideResultCount, section);
        const totalNumberOfItemsInPreviousSections = $3e96c9432766ab22$export$fd06a2c70d34842e(searchItems.sections, sectionIndex);
        if (searchResults.length === 0) return null;
        return /*#__PURE__*/ (0, $7UHDa.jsxs)(ResultSection, {
            totalResults: totalResults,
            title: section.titleRenderer ? section.titleRenderer({
                isCollapsed: isCollapsed,
                productState: productState
            }) : generateSectionTitle(section, intl),
            children: [
                searchResults.map((result, index)=>{
                    const analyticContext = {
                        sectionIndex: sectionIndex,
                        sectionId: section.id,
                        containerId: result.containerId || null,
                        indexWithinSection: index,
                        globalIndex: totalNumberOfItemsInPreviousSections + index,
                        isCached: result.isRecentResult || false,
                        metadata: {
                            contentId: result.id,
                            containerId: result.containerId || null,
                            contentType: result.type || null
                        }
                    };
                    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
                        analyticContext: analyticContext,
                        nonPrivacySafeAnalyticContext: nonPrivacySafeAnalyticContext || {},
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)(QuickFindPersistRecentSearch, {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i0h8F.SearchResultItem), {
                                isCollapsed: isCollapsed,
                                linkComponent: linkComponent,
                                productState: productState,
                                resultRenderer: section.resultRenderer,
                                resultWrapper: section.resultWrapper,
                                screen: screen,
                                searchResult: result,
                                appendQueryParams: appendQueryParams,
                                useAnalyticsOverride: section.useAnalyticsOverride
                            })
                        })
                    }, result.id);
                }),
                renderSectionViewAll && section.viewAllLinkGenerator && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ipASa.ViewAllLink), {
                    linkComponent: linkComponent,
                    section: section,
                    totalResults: totalResults
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $38QdT.SearchResultWrapper), {
        children: [
            searchItems.sections.map((section, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)(ItemSection, {
                    section: section,
                    sectionIndex: index
                }, section.id)),
            children
        ]
    });
};
const $3e96c9432766ab22$export$855c9ab7e6e3e97f = (0, $js7oX.default)($3e96c9432766ab22$var$GenericSearchResultWithIntl);

});
parcelRegister("lpcw3", function(module, exports) {

$parcel$export(module.exports, "SearchResultSection", () => $806221755b41bdf0$export$51a5a703da15f0f7);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $c4sKh = parcelRequire("c4sKh");

var $hiGBZ = parcelRequire("hiGBZ");
const $806221755b41bdf0$export$51a5a703da15f0f7 = ({ title: title, totalResults: totalResults, children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hiGBZ.SearchResultSectionContainer), {
        "data-vc": "search-result-section",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hiGBZ.SearchResultSectionHeading), {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hiGBZ.SearchResultsSectionTitle), {
                    children: [
                        title,
                        totalResults ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hiGBZ.SearchResultSectionTitleBadgeContainer), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
                                testId: "search-result-count-badge",
                                children: totalResults
                            })
                        }) : null
                    ]
                })
            }),
            children
        ]
    });
};

});

parcelRegister("2jE99", function(module, exports) {

$parcel$export(module.exports, "hasSearchResults", () => $278487f7dee8bb82$export$bcf020eea629e7ed);
const $278487f7dee8bb82$export$bcf020eea629e7ed = (searchItems)=>{
    const sectionsWithSearchResults = searchItems.sections.filter(({ searchResults: searchResults })=>searchResults.length > 0);
    return sectionsWithSearchResults.length > 0;
};

});

parcelRegister("i0h8F", function(module, exports) {

$parcel$export(module.exports, "SearchResultItem", () => $37c05cfbff7bc1a9$export$56e008c8bd1ccf7c);

var $7UHDa = parcelRequire("7UHDa");

var $WEXnq = parcelRequire("WEXnq");
var $16tQa = parcelRequire("16tQa");

var $gwFzn = parcelRequire("gwFzn");

var $4ldrV = parcelRequire("4ldrV");

var $2OcMi = parcelRequire("2OcMi");

var $ejGzS = parcelRequire("ejGzS");

var $O4eEI = parcelRequire("O4eEI");
const $37c05cfbff7bc1a9$var$DefaultSearchResultItemWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};
/**
 * Intended to be used for search results that are not links
 */ const $37c05cfbff7bc1a9$var$SearchResultItemKeyboardHiglightWrapper = ({ searchResultId: searchResultId, children: children })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $16tQa.useKeyboardHighlighting)({
        searchResultId: searchResultId
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: ref,
        children: children(isKeyboardHighlighted)
    });
};
const $37c05cfbff7bc1a9$export$56e008c8bd1ccf7c = ({ isCollapsed: isCollapsed, linkComponent: linkComponent, productState: productState, resultRenderer: resultRenderer, resultWrapper: resultWrapper, screen: screen, searchResult: searchResult, appendQueryParams: appendQueryParams, useAnalyticsOverride: useAnalyticsOverride = ()=>({}) })=>{
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { onHighlightCallback: defaultOnHighlightCallback, onSelectCallback: defaultOnSelectCallback, onContextMenuCallback: defaultOnContextMenuCallback } = (0, $O4eEI.useSearchResultAnalyticsCallbacks)({
        screen: screen,
        actionSubject: 'searchResult'
    });
    const { onHighlightCallback: overriddenOnHighlightCallback, onSelectCallback: overriddenOnSelectCallback, onContextMenuCallback: overriddenOnContextMenuCallback } = useAnalyticsOverride({
        screen: screen
    });
    const url = appendQueryParams === undefined ? (0, $2OcMi.addQuery)(searchResult.url, 'search_id', searchSessionId) : appendQueryParams(searchResult.url, searchSessionId, searchResult.type, searchResult.id);
    const SearchResultItemWrapper = resultWrapper || $37c05cfbff7bc1a9$var$DefaultSearchResultItemWrapper;
    const searchResultContentRenderer = (0, $gwFzn.useCallback)((isKeyboardHighlighted)=>resultRenderer ? resultRenderer({
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted,
            productState: productState,
            screen: screen,
            searchResult: searchResult
        }) : (0, $ejGzS.defaultResultRenderer)({
            isCollapsed: isCollapsed,
            isKeyboardHighlighted: isKeyboardHighlighted,
            screen: screen,
            searchResult: searchResult
        }), [
        isCollapsed,
        productState,
        resultRenderer,
        screen,
        searchResult
    ]);
    const id = `link-${searchResult.id}`;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(SearchResultItemWrapper, {
        url: url,
        titleId: id,
        children: url ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $WEXnq.SearchResultLink), {
            href: url,
            linkComponent: searchResult.linkComponent ?? linkComponent,
            searchResultId: searchResult.id,
            onContextMenu: overriddenOnContextMenuCallback || defaultOnContextMenuCallback,
            onHighlighted: overriddenOnHighlightCallback || defaultOnHighlightCallback,
            onSelect: overriddenOnSelectCallback || defaultOnSelectCallback,
            "data-testid": id,
            id: id,
            children: (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)($37c05cfbff7bc1a9$var$SearchResultItemKeyboardHiglightWrapper, {
            searchResultId: searchResult.id,
            children: (isKeyboardHighlighted)=>searchResultContentRenderer(isKeyboardHighlighted)
        })
    });
};

});
parcelRegister("WEXnq", function(module, exports) {

$parcel$export(module.exports, "SearchResultLink", () => $6dc18a1d5e5462b9$export$76cc11d043a1381);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5tPRL = parcelRequire("5tPRL");

var $16tQa = parcelRequire("16tQa");
const $6dc18a1d5e5462b9$export$76cc11d043a1381 = ({ children: children, href: href, linkComponent: linkComponent, searchResultId: searchResultId, onSelect: onSelect, onHighlighted: onHighlighted, onContextMenu: onContextMenu, ...rest })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $16tQa.useKeyboardHighlighting)({
        searchResultId: searchResultId,
        onHighlighted: onHighlighted
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: ref,
        onClick: onSelect,
        onContextMenu: onContextMenu,
        role: "none",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultLink), {
            linkComponent: linkComponent,
            href: href,
            ...rest,
            children: children(isKeyboardHighlighted)
        })
    }));
};

});
parcelRegister("16tQa", function(module, exports) {

$parcel$export(module.exports, "useKeyboardHighlighting", () => $c5296a0f968b5575$export$9803d460130e453);

var $gwFzn = parcelRequire("gwFzn");

var $icqFF = parcelRequire("icqFF");
/**
 * Callback which simulates a click on the target element when the enter key
 * is pressed whilst the target element is active.
 *
 * @param e Event from key down
 * @param target Active element when key was pressed
 */ const $c5296a0f968b5575$var$onKeyDown = (e, target)=>{
    // Only navigate if Enter was pressed without any modifiers
    if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        // Find the deepest child element in the DOM
        let clickTarget = target;
        while(clickTarget.firstElementChild instanceof HTMLElement && clickTarget.firstElementChild?.click)clickTarget = clickTarget.firstElementChild;
        clickTarget.click();
    }
};
const $c5296a0f968b5575$export$9803d460130e453 = ({ searchResultId: searchResultId, onHighlighted: onHighlighted })=>{
    const [isKeyboardHighlighted, ref] = (0, $icqFF.useKeyboardNavigation)({
        onKeydownCallback: $c5296a0f968b5575$var$onKeyDown,
        navigationTrackingId: searchResultId ?? null
    });
    // Ref for whether or not this search result was last highlighted
    const previousHighlight = (0, $gwFzn.useRef)(false);
    // Call the onHighlighted callback when this search result is highlighted
    (0, $gwFzn.useEffect)(()=>{
        if (!previousHighlight.current && isKeyboardHighlighted) onHighlighted?.();
        previousHighlight.current = isKeyboardHighlighted;
    }, [
        isKeyboardHighlighted,
        previousHighlight,
        onHighlighted
    ]);
    return {
        isKeyboardHighlighted: isKeyboardHighlighted,
        ref: ref
    };
};

});


parcelRegister("ejGzS", function(module, exports) {

$parcel$export(module.exports, "defaultResultRenderer", () => $c2d03b527301e03f$export$fa734eedc505eef7);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dcJ7R = parcelRequire("dcJ7R");

var $cO3Oi = parcelRequire("cO3Oi");

var $gnG2x = parcelRequire("gnG2x");

var $9Qum6 = parcelRequire("9Qum6");
const $c2d03b527301e03f$export$fa734eedc505eef7 = ({ isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, screen: screen, searchResult: searchResult })=>{
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(searchResult.icon) ? searchResult.icon : typeof searchResult.icon === 'string' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Qum6.ResultAvatar), {
        borderColor: "transparent",
        src: searchResult.icon,
        appearance: "square",
        size: "xsmall",
        testId: "result-avatar"
    }) : searchResult.iconRenderer ? searchResult.iconRenderer({
        screen: screen
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Qum6.ResultAvatar), {
        borderColor: "transparent",
        src: searchResult.iconUrl,
        appearance: "square",
        size: "xsmall",
        testId: "result-avatar"
    });
    const title = searchResult.isVerified ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        space: "space.025",
        alignBlock: "center",
        children: [
            searchResult.title,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cO3Oi.VerifiedTeamIcon), {})
        ]
    }) : searchResult.title;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gnG2x.SearchResultContent), {
        isKeyboardHighlighted: isKeyboardHighlighted,
        title: title,
        meta: searchResult.meta,
        additionalMeta: searchResult.additionalMeta,
        isCollapsed: isCollapsed,
        icon: icon
    }, `item_${searchResult.id}`);
};

});
parcelRegister("gnG2x", function(module, exports) {

$parcel$export(module.exports, "SearchResultContent", () => $9f2dcb84dea7d967$export$b5fd7d6305bfbd3e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $epvHH = parcelRequire("epvHH");

var $5tPRL = parcelRequire("5tPRL");
const $9f2dcb84dea7d967$export$595b9d59c3d65270 = '@@@hl@@@';
const $9f2dcb84dea7d967$export$eea8f6b95460c3c3 = '@@@endhl@@@';
const $9f2dcb84dea7d967$var$getResultLabel = (label)=>{
    if (typeof label === 'string') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultLabel), {
        title: typeof label === 'string' ? label : undefined,
        children: label
    });
    return label;
};
const $9f2dcb84dea7d967$var$getResultTitle = (title)=>{
    if (typeof title === 'string') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            title: title,
            className: "SearchDialogResultTitle",
            children: title
        })
    });
    return title;
};
const $9f2dcb84dea7d967$export$b5fd7d6305bfbd3e = ({ icon: icon, label: label, title: title, meta: meta, additionalMeta: additionalMeta, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    const getResultContent = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: isCollapsed ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                "data-testid": "collapsed-result-view",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.ResultTitleContainer), {
                        isCollapsed: true,
                        children: [
                            $9f2dcb84dea7d967$var$getResultLabel(label),
                            $9f2dcb84dea7d967$var$getResultTitle(title)
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultDetailWrapper), {
                        children: [
                            meta && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.CollapsedResultDetail), {
                                title: typeof meta === 'string' ? meta : undefined,
                                children: meta
                            }),
                            additionalMeta && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.DetailsSeparator), {
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.CollapsedResultDetail), {
                                        children: additionalMeta
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.ResultTitleContainer), {
                        children: [
                            $9f2dcb84dea7d967$var$getResultLabel(label),
                            $9f2dcb84dea7d967$var$getResultTitle(title)
                        ]
                    }),
                    meta && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultDetail), {
                        title: typeof meta === 'string' ? meta : undefined,
                        children: meta
                    }),
                    additionalMeta ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultDetail), {
                        title: typeof additionalMeta === 'string' ? additionalMeta : undefined,
                        children: additionalMeta
                    }) : null
                ]
            })
        });
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(null);
    (0, $gwFzn.useEffect)(()=>{
        if (isKeyboardHighlighted && contentRef.current?.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.ResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.IconContainer), {
                children: icon
            }),
            getResultContent(),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ReturnIconContainer), {
                isCollapsed: isCollapsed,
                isKeyboardHighlighted: isKeyboardHighlighted,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $epvHH.ReturnIcon), {
                    inverted: true
                })
            })
        ]
    });
};

});

parcelRegister("9Qum6", function(module, exports) {

$parcel$export(module.exports, "ResultAvatar", () => $97dd1a753677152a$export$d2397285980ae833);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $esRft = parcelRequire("esRft");

var $gwrgp = parcelRequire("gwrgp");
const $97dd1a753677152a$var$NegativeMargin = (0, $gwrgp.default)("div", {
    target: "ez36xyc0"
})({
    name: "43a5nv",
    styles: "margin:var(--ds-space-negative-025, -2px);display:flex;"
});
const $97dd1a753677152a$export$d2397285980ae833 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($97dd1a753677152a$var$NegativeMargin, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
            ...props
        })
    });

});


parcelRegister("O4eEI", function(module, exports) {

$parcel$export(module.exports, "useSearchResultAnalyticsCallbacks", () => $2ea9acd69c9f229c$export$4381245974d3b25a);

var $gwFzn = parcelRequire("gwFzn");

var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");
const $2ea9acd69c9f229c$export$4381245974d3b25a = ({ onHighlighted: onHighlighted, onSelect: onSelect, screen: screen, actionSubject: actionSubject })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onHighlightCallback = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $5dFS9.onSearchResultHighlighted)({
            screen: screen,
            actionSubject: actionSubject
        }));
        onHighlighted?.();
    }, [
        actionSubject,
        fireAnalyticsEvent,
        onHighlighted,
        screen
    ]);
    const onSelectCallback = (0, $gwFzn.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onSearchResultSelected)({
            screen: screen,
            actionSubject: actionSubject
        }));
        onSelect?.(e);
    }, [
        actionSubject,
        fireAnalyticsEvent,
        onSelect,
        screen
    ]);
    const onContextMenuCallback = (0, $gwFzn.useCallback)((e)=>{
        fireAnalyticsEvent((0, $5dFS9.onSearchResultContext)({
            screen: screen,
            actionSubject: actionSubject
        }));
    }, [
        actionSubject,
        fireAnalyticsEvent,
        screen
    ]);
    return {
        onHighlightCallback: onHighlightCallback,
        onSelectCallback: onSelectCallback,
        onContextMenuCallback: onContextMenuCallback
    };
};

});


parcelRegister("ipASa", function(module, exports) {

$parcel$export(module.exports, "ViewAllLink", () => $ae4aed250b0b0b86$export$f8fe8ba0816633ed);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $hgHjQ = parcelRequire("hgHjQ");

var $bF0iL = parcelRequire("bF0iL");

var $2ZIpG = parcelRequire("2ZIpG");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");
const $ae4aed250b0b0b86$export$f8fe8ba0816633ed = ({ linkComponent: linkComponent, section: section, totalResults: totalResults = 0 })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { viewAllLinkGenerator: viewAllLinkGenerator, viewAllLinkRenderer: viewAllLinkRenderer } = section;
    if (!viewAllLinkGenerator) return null;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        onClick: ()=>{
            fireAnalyticsEvent((0, $5dFS9.onSearchResultViewAllLinkClicked)(section.id));
        },
        role: "none",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hgHjQ.SearchResultSectionLink), {
            linkComponent: linkComponent,
            href: viewAllLinkGenerator(query),
            testId: "search-result-section-link",
            children: viewAllLinkRenderer ? viewAllLinkRenderer({
                section: section,
                totalResults: totalResults
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $bF0iL.messages).common_show_all_results_link
            })
        })
    }));
};

});
parcelRegister("hgHjQ", function(module, exports) {

$parcel$export(module.exports, "SearchResultSectionLink", () => $a5b1325517543fd8$export$f39804bac419a7f4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5A4WA = parcelRequire("5A4WA");
const $a5b1325517543fd8$export$f39804bac419a7f4 = ({ children: children, linkComponent: linkComponent, ...rest })=>/* component must either be `undefined` or an component. A null or false will throw an error */ /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5A4WA.SectionLink), {
        appearance: "link",
        ...rest,
        component: linkComponent || undefined,
        children: children
    });

});
parcelRegister("5A4WA", function(module, exports) {

$parcel$export(module.exports, "SectionLink", () => $9155aa83cf58fa2b$export$3545bd757920e2b3);

var $eEA8O = parcelRequire("eEA8O");

var $2azjJ = parcelRequire("2azjJ");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $9155aa83cf58fa2b$export$3545bd757920e2b3 = /*#__PURE__*/ (0, $gwrgp.default)((0, $eEA8O.default), {
    target: "e1052ovn0"
})("margin-left:", (0, $2azjJ.grid).half().px, ";color:", `var(--ds-link, ${(0, $6fnsQ.B400)})`, ";cursor:pointer !important;&:hover{text-decoration:underline !important;}");

});



parcelRegister("20N1w", function(module, exports) {

$parcel$export(module.exports, "usePersistRecentSearches", () => $6c6cdd0bab182993$export$3adda20dc7f5408f);
$parcel$export(module.exports, "PersistRecentSearch", () => $6c6cdd0bab182993$export$c8074e5d4e733c21);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iEwUU = parcelRequire("iEwUU");

var $1SV4e = parcelRequire("1SV4e");

var $fJRVo = parcelRequire("fJRVo");

var $2ZIpG = parcelRequire("2ZIpG");
const $6c6cdd0bab182993$export$3adda20dc7f5408f = (overrideQuery)=>{
    const previousQuery = (0, $gwFzn.useRef)(null);
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const persistRecentSearch = (0, $gwFzn.useCallback)(()=>{
        if (user?.id && product?.id) {
            if (overrideQuery && overrideQuery.trim() !== '') (0, $1SV4e.addRecentSearch)(overrideQuery, user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
            else if (previousQuery.current !== query && query.trim() !== '') {
                (0, $1SV4e.addRecentSearch)(query, user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
                previousQuery.current = query;
            }
        }
    }, [
        product?.id,
        query,
        user.id,
        overrideQuery
    ]);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        persistRecentSearch();
    }, [
        persistRecentSearch
    ]);
    const onEnter = (0, $gwFzn.useCallback)((event)=>{
        if (event.key === 'Enter') persistRecentSearch();
    }, [
        persistRecentSearch
    ]);
    return [
        onClick,
        onEnter
    ];
};
const $6c6cdd0bab182993$export$c8074e5d4e733c21 = ({ children: children, overrideQuery: overrideQuery })=>{
    const [onClick, onEnter] = $6c6cdd0bab182993$export$3adda20dc7f5408f(overrideQuery);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        onClick: onClick,
        onKeyDown: onEnter,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: '100%'
        },
        "data-testid": "persist-recent-search",
        children: children
    }));
};

});

parcelRegister("38QdT", function(module, exports) {

$parcel$export(module.exports, "SearchResultWrapper", () => $da656065b0b219a8$export$7ef688c5abd67ccc);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6hiXa = parcelRequire("6hiXa");

var $amrMu = parcelRequire("amrMu");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $da656065b0b219a8$var$QuickFindSearchResultWrapper = (0, $6hiXa.default).div`
	display: flex;
	flex-direction: column;
	gap: ${"var(--ds-space-025, 2px)"};
	padding: ${"var(--ds-space-100, 8px)"};
`;
const $da656065b0b219a8$export$7ef688c5abd67ccc = ({ children: children })=>{
    const { quickFind: quickFind } = (0, $amrMu.useFeaturesContext)();
    return quickFind?.enabled ? /*#__PURE__*/ (0, $7UHDa.jsx)($da656065b0b219a8$var$QuickFindSearchResultWrapper, {
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});


parcelRegister("kf2EW", function(module, exports) {

$parcel$export(module.exports, "FeedbackFooter", () => $9f20ae4c2debb5df$export$e7b87342306a8337);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dDSTM = parcelRequire("dDSTM");

var $kiEGX = parcelRequire("kiEGX");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $8UOsA = parcelRequire("8UOsA");
const $9f20ae4c2debb5df$var$footerContainerStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    borderTop: '1px solid',
    borderColor: 'color.border',
    display: 'flex',
    alignItems: 'center',
    color: 'color.text',
    gap: 'space.150'
});
const $9f20ae4c2debb5df$export$e7b87342306a8337 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $9f20ae4c2debb5df$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $dDSTM.messages).quick_find_footer_text
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kiEGX.default), {
                TriggerComponent: ({ onClick: onClick })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $8UOsA.FeedbackButton), {
                        onClick: onClick
                    })
            })
        ]
    });
};

});
parcelRegister("kiEGX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1b8b9c22c9ab1c26$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6uGcC = parcelRequire("6uGcC");

var $iLCTn = parcelRequire("iLCTn");

var $dBxQj = parcelRequire("dBxQj");

var $iEwUU = parcelRequire("iEwUU");

var $h2sba = parcelRequire("h2sba");

var $2GmtI = parcelRequire("2GmtI");

var $kmpep = parcelRequire("kmpep");

var $fJRVo = parcelRequire("fJRVo");

var $amrMu = parcelRequire("amrMu");

var $91yhh = parcelRequire("91yhh");

const $1b8b9c22c9ab1c26$var$AkFeedbackCollector = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("i8OiN")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $1b8b9c22c9ab1c26$var$AkFeedbackFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("i8OiN")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $1b8b9c22c9ab1c26$var$HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $1b8b9c22c9ab1c26$var$ENTRYPOINT_ID = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
const $1b8b9c22c9ab1c26$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
/**
 * Feedback collector for extensible tabs in Quick Search i.e. confluence tab in QS and QF
 */ const $1b8b9c22c9ab1c26$var$FeedbackCollector = ({ TriggerComponent: TriggerComponent = (0, $h2sba.FeedbackButton) })=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { name: name, id: id } = user;
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $gwFzn.useState)(false);
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const { backendExperiment: backendExperiment, frontendExperiments: frontendExperiments = {} } = (0, $91yhh.useExperiments)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct()?.title;
    const primaryProduct = getPrimaryProduct()?.title;
    const isHello = $1b8b9c22c9ab1c26$var$HELLO_TENANT_ID === cloudId;
    const isQuickFind = (0, $amrMu.useFeaturesContext)().quickFind?.enabled;
    const experience = isQuickFind ? 'quick-find' : 'quick-search';
    const feedbackContext = JSON.stringify({
        experimentLayers: backendExperiment?.experimentLayers,
        frontendExperiments: frontendExperiments,
        frontendVersion: (0, $2GmtI.BUILD_VERSION),
        product: activeProduct,
        primaryProduct: primaryProduct,
        cloudId: cloudId,
        userId: id,
        source: 'product-search-dialog',
        isHello: isHello,
        experience: experience,
        release: (0, $iLCTn.getProductReleaseVersion)(primaryProduct)
    });
    const { locale: locale } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)(TriggerComponent, {
                onClick: (e)=>{
                    e.preventDefault();
                    setIsOpen(true);
                }
            }),
            isOpen ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($1b8b9c22c9ab1c26$var$AkFeedbackCollector, {
                    locale: locale,
                    onClose: ()=>setIsOpen(false),
                    onSubmit: ()=>setDisplayFlag(true),
                    atlassianAccountId: id,
                    name: name,
                    entrypointId: $1b8b9c22c9ab1c26$var$ENTRYPOINT_ID,
                    additionalFields: [
                        {
                            id: $1b8b9c22c9ab1c26$var$FEEDBACK_CONTEXT_CF,
                            value: feedbackContext
                        }
                    ]
                })
            }) : null,
            displayFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
                onDismissed: ()=>setDisplayFlag(false),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)($1b8b9c22c9ab1c26$var$AkFeedbackFlag, {
                        locale: locale
                    })
                })
            })
        ]
    });
};
var $1b8b9c22c9ab1c26$export$2e2bcd8739ae039 = $1b8b9c22c9ab1c26$var$FeedbackCollector;

});
parcelRegister("h2sba", function(module, exports) {

$parcel$export(module.exports, "FeedbackButton", () => $9740cc300cdd6cc9$export$116fedbe5e2e2bd8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $bF0iL = parcelRequire("bF0iL");

var $ccHMk = parcelRequire("ccHMk");
const $9740cc300cdd6cc9$var$buttonStyles = (0, $3jLHL.css)({
    margin: '0 auto',
    width: 'fit-content'
});
const $9740cc300cdd6cc9$export$116fedbe5e2e2bd8 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $9740cc300cdd6cc9$var$buttonStyles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $ccHMk.default), {
        onClick: onClick,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $4jR19.default), (0, $bF0iL.messages).common_give_feedback)));
};

});

parcelRegister("2GmtI", function(module, exports) {

$parcel$export(module.exports, "BUILD_VERSION", () => $4178462f01553fa5$export$2db401a6b81eceee);
const $4178462f01553fa5$var$packageName = "platform-pkg";
const $4178462f01553fa5$var$packageVersion = "0.0.0-use.local";
const $4178462f01553fa5$export$2db401a6b81eceee = `${$4178462f01553fa5$var$packageName}@${$4178462f01553fa5$var$packageVersion}`;

});

parcelRegister("i8OiN", function(module, exports) {

let $d34ffe4e69389cef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d34ffe4e69389cef$var$load("c6MKV"),
    $d34ffe4e69389cef$var$load("aZinD"),
    $d34ffe4e69389cef$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});



parcelRegister("iN7gh", function(module, exports) {

$parcel$export(module.exports, "FilterFooter", () => $abeef2063379c8b4$export$b4bfb1c3ed0cdeca);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $7skR0 = parcelRequire("7skR0");

var $4mZlP = parcelRequire("4mZlP");

var $dDSTM = parcelRequire("dDSTM");

var $8fCWV = parcelRequire("8fCWV");

var $20N1w = parcelRequire("20N1w");
const $abeef2063379c8b4$export$b4bfb1c3ed0cdeca = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const confluenceIcon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7skR0.ConfluenceIcon), {
        appearance: "brand",
        size: "small"
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20N1w.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8fCWV.QuickFindAdvancedSearchLink), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                squareReturnIcon: true,
                searchFooterLabel: formatMessage((0, $dDSTM.messages).quick_find_show_filtered_results),
                searchFooterLabelWithIcon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $dDSTM.messages).quick_find_show_filtered_results_with_icon,
                    values: {
                        confluenceIcon: confluenceIcon
                    }
                }),
                filterByProductFooter: true
            })
        })
    });
};

});
parcelRegister("8fCWV", function(module, exports) {

$parcel$export(module.exports, "QuickFindAdvancedSearchLink", () => $d9eaece468643009$export$a10ba81e8e8d140);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $d9eaece468643009$export$a10ba81e8e8d140 = (0, $gwrgp.default)("div", {
    target: "e58cvu60"
})({
    borderTop: `1px solid ${`var(--ds-border, ${(0, $6fnsQ.N40A)})`}`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span > a': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    }
});

});


parcelRegister("2hOQY", function(module, exports) {

$parcel$export(module.exports, "SearchFooter", () => $7b3b7f54929a6bc9$export$64ded8b71dfcba9e);
$parcel$export(module.exports, "SearchFooterPersistRecentSearch", () => $7b3b7f54929a6bc9$export$8784f9fd2cdbbd0a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $4mZlP = parcelRequire("4mZlP");

var $dDSTM = parcelRequire("dDSTM");

var $8fCWV = parcelRequire("8fCWV");

var $20N1w = parcelRequire("20N1w");
const $7b3b7f54929a6bc9$export$64ded8b71dfcba9e = ({ linkComponent: linkComponent })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8fCWV.QuickFindAdvancedSearchLink), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
            linkComponent: linkComponent,
            squareReturnIcon: true,
            searchFooterLabel: formatMessage((0, $dDSTM.messages).quick_find_footer_full_page_search_link)
        })
    });
};
const $7b3b7f54929a6bc9$export$8784f9fd2cdbbd0a = ({ linkComponent: linkComponent })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20N1w.PersistRecentSearch), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($7b3b7f54929a6bc9$export$64ded8b71dfcba9e, {
            linkComponent: linkComponent
        })
    });
};

});

parcelRegister("kTE07", function(module, exports) {

$parcel$export(module.exports, "PreQueryEmptyScreen", () => $25501d5677c22b5e$export$f16a7ed214a332fa);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");

var $dDSTM = parcelRequire("dDSTM");

var $4jR19 = parcelRequire("4jR19");

const $25501d5677c22b5e$export$f76aab36aa9d8077 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("61iEs")));
const $25501d5677c22b5e$export$f16a7ed214a332fa = ({})=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
        Image: $25501d5677c22b5e$export$f76aab36aa9d8077,
        title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_no_content_header
        }),
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_no_content_body
        })
    });
};

});
parcelRegister("a7YLG", function(module, exports) {

$parcel$export(module.exports, "EmptyState", () => $63d3900d9fbf3b90$export$fddf379e22a74b00);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1HjZs = parcelRequire("1HjZs");
const $63d3900d9fbf3b90$export$fddf379e22a74b00 = ({ title: title, content: content, Image: Image })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1HjZs.Wrapper), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)(Image, {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1HjZs.Title), {
                    children: title
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1HjZs.Content), {
                    children: content
                })
            ]
        })
    });

});
parcelRegister("1HjZs", function(module, exports) {

$parcel$export(module.exports, "Title", () => $3c24ade336ec6966$export$f99233281efd08a0);
$parcel$export(module.exports, "Content", () => $3c24ade336ec6966$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Wrapper", () => $3c24ade336ec6966$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $7UHDa = parcelRequire("7UHDa");

var $2azjJ = parcelRequire("2azjJ");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
parcelRequire("gwFzn");

var $gwrgp = parcelRequire("gwrgp");
const $3c24ade336ec6966$var$TitleContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginTop: 'space.100'
});
const $3c24ade336ec6966$export$f99233281efd08a0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $3c24ade336ec6966$var$TitleContainerStyles,
        children: children
    });
};
const $3c24ade336ec6966$export$7c6e2c02157bb7d2 = (0, $gwrgp.default)("div", {
    target: "e1ttkipm0"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: (0, $2azjJ.grid).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $2azjJ.primaryTextColour)
});
const $3c24ade336ec6966$export$e6dfd72ab29f8598 = (0, $gwrgp.default)("div", {
    target: "e1ttkipm1"
})({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $2azjJ.grid).twice().px
});

});


parcelRegister("61iEs", function(module, exports) {

let $46214de772d3b2f1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $46214de772d3b2f1$var$load("4Sse2").then(()=>parcelRequire('c473Z'));

});


parcelRegister("4Lm6U", function(module, exports) {

$parcel$export(module.exports, "SearchErrorScreen", () => $60673a10504c6d4a$export$66fb8d8f30619036);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $j9DEc = parcelRequire("j9DEc");
const $60673a10504c6d4a$export$66fb8d8f30619036 = ({ onRetry: onRetry = ()=>null })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j9DEc.default), {
        onRetry: onRetry
    });
};

});
parcelRegister("j9DEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95f96bde66e8ac9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");
var $kPBHE = parcelRequire("kPBHE");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $bF0iL = parcelRequire("bF0iL");

var $cic0f = parcelRequire("cic0f");

const $d95f96bde66e8ac9$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("aFh8s")));
class $d95f96bde66e8ac9$export$930da00ff8e1539f extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
            title: intl.formatMessage((0, $bF0iL.messages).common_error_state_failed_search_heading),
            Image: $d95f96bde66e8ac9$var$Image,
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.getContent = ()=>{
            const { onRetry: onRetry } = this.props;
            const linkComponent = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $cic0f.Button), {
                    ...props,
                    role: "button",
                    tabIndex: 0,
                    onClick: ()=>onRetry(),
                    onKeyDown: (event)=>event.key === 'Enter' ? onRetry() : undefined
                });
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $bF0iL.messages).common_error_state_failed_search_body,
                values: {
                    emptyLink: (s)=>// eslint-disable-next-line jsx-a11y/anchor-is-valid
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPBHE.Link), {
                            linkComponent: linkComponent,
                            href: '',
                            children: s
                        })
                }
            });
        };
    }
}
var $d95f96bde66e8ac9$export$2e2bcd8739ae039 = (0, $js7oX.default)($d95f96bde66e8ac9$export$930da00ff8e1539f);

});
parcelRegister("cic0f", function(module, exports) {

$parcel$export(module.exports, "Button", () => $369c822a7a7f1b34$export$353f5b6fc5456de1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $369c822a7a7f1b34$export$353f5b6fc5456de1 = (0, $gwrgp.default)("span", {
    target: "e1hs8rk0"
})({
    color: `var(--ds-link, ${(0, $6fnsQ.B400)})`,
    cursor: 'pointer'
});

});

parcelRegister("aFh8s", function(module, exports) {

let $7c3b0677d27d41ae$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7c3b0677d27d41ae$var$load("eQXoP").then(()=>parcelRequire('6Vk9P'));

});



parcelRegister("hyKIh", function(module, exports) {

$parcel$export(module.exports, "QuickFindRovoTip", () => $d0c603ac0340e923$export$719e67cc0251dc18);

var $7UHDa = parcelRequire("7UHDa");

var $3HOqx = parcelRequire("3HOqx");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $5tPRL = parcelRequire("5tPRL");
var $dfZ5P = parcelRequire("dfZ5P");

var $1qfLF = parcelRequire("1qfLF");

var $dDSTM = parcelRequire("dDSTM");

var $hAh3S = parcelRequire("hAh3S");

var $aDRXf = parcelRequire("aDRXf");
const $d0c603ac0340e923$var$RovoTipMessageStyle = (0, $ecnYn.xcss)({
    width: '95%',
    marginLeft: 'space.050',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.050'
});
const $d0c603ac0340e923$var$RovoTipContainerStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $d0c603ac0340e923$var$RovoTipStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    minHeight: `${"var(--ds-space-500, 40px)"}`,
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    borderRadius: `${"var(--ds-space-050, 4px)"}`,
    backgroundColor: 'color.background.accent.purple.subtlest',
    color: 'color.text.accent.purple'
});
const $d0c603ac0340e923$export$719e67cc0251dc18 = ()=>{
    const { showRovoTip: showRovoTip, dismissRovoTip: dismissRovoTip } = (0, $hAh3S.useQuickFindRovoTip)();
    const { focusInput: focusInput } = (0, $aDRXf.useInputContext)();
    if (!showRovoTip) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $d0c603ac0340e923$var$RovoTipContainerStyle,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            xcss: $d0c603ac0340e923$var$RovoTipStyle,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                    label: "blank",
                    color: "var(--ds-text-accent-purple, #5E4DB2)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                    xcss: $d0c603ac0340e923$var$RovoTipMessageStyle,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("b", {
                            children: "Rovo tip:"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $dDSTM.messages).quick_find_rovo_tip
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.EnlargedReturnIconContainer), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        icon: (0, $dfZ5P.RemoveIcon),
                        spacing: 'compact',
                        onClick: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            dismissRovoTip();
                            focusInput && focusInput();
                        },
                        label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $dDSTM.messages).remove_button_label
                        }),
                        appearance: 'subtle'
                    })
                })
            ]
        })
    });
};

});
parcelRegister("hAh3S", function(module, exports) {

$parcel$export(module.exports, "useQuickFindRovoTip", () => $de41115665781d7f$export$ccc3a6663aee8d48);

var $gwFzn = parcelRequire("gwFzn");

var $4SPhZ = parcelRequire("4SPhZ");

var $iEwUU = parcelRequire("iEwUU");

var $fJRVo = parcelRequire("fJRVo");
const $de41115665781d7f$export$ccc3a6663aee8d48 = ()=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const [showRovoTip, setShowRovoTip] = (0, $gwFzn.useState)(true);
    (0, $gwFzn.useEffect)(()=>{
        if (!product) return;
        const rovoTipFromLocalStorage = (0, $4SPhZ.getRovoTip)(product.id, user?.id);
        setShowRovoTip(rovoTipFromLocalStorage);
    }, [
        user.id,
        product
    ]);
    const dismissRovoTip = (0, $gwFzn.useCallback)(()=>{
        if (product?.id) {
            const rovoTipFromLocalStorage = (0, $4SPhZ.setRovoTip)(product.id, user?.id);
            setShowRovoTip(rovoTipFromLocalStorage);
        }
    }, [
        user.id,
        product
    ]);
    return {
        showRovoTip: showRovoTip,
        dismissRovoTip: dismissRovoTip
    };
};

});

parcelRegister("aDRXf", function(module, exports) {

$parcel$export(module.exports, "InputContext", () => $0bc222710141dc7b$export$37fb8590cf2c088c);
$parcel$export(module.exports, "useInputContext", () => $0bc222710141dc7b$export$25c2004aac4f3cc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $0bc222710141dc7b$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    focusInput: undefined
});
const $0bc222710141dc7b$export$37fb8590cf2c088c = ({ children: children, forwardRef: forwardRef })=>{
    const focusInput = (0, $gwFzn.useCallback)(()=>{
        if (typeof forwardRef === 'object') forwardRef?.current?.focus();
    }, [
        forwardRef
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0bc222710141dc7b$var$Context.Provider, {
        value: {
            focusInput: focusInput
        },
        children: children
    });
};
const $0bc222710141dc7b$export$25c2004aac4f3cc = ()=>{
    return (0, $gwFzn.useContext)($0bc222710141dc7b$var$Context);
};

});


parcelRegister("7OZuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8910aa043bf2e2af$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $lnXRc = parcelRequire("lnXRc");

var $5dFS9 = parcelRequire("5dFS9");

var $ecdEs = parcelRequire("ecdEs");
var $1BaDj = parcelRequire("1BaDj");

var $2ZIpG = parcelRequire("2ZIpG");

var $5TmpD = parcelRequire("5TmpD");

var $21MH9 = parcelRequire("21MH9");

var $eEbYb = parcelRequire("eEbYb");
const $8910aa043bf2e2af$var$NoResultsWithHooks = ({ urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen = ()=>'', advancedSearchSelected: advancedSearchSelected, fromQuickFindPostQueryNoResults: fromQuickFindPostQueryNoResults })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $5TmpD.useAutocorrectionEnabled)();
    const advancedSearchUrl = urlGeneratorForNoResultsScreen(query); // TODO: needs filters here
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
        children: [
            autocorrectionEnabled && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $21MH9.AutocorrectAsyncWrapper), {
                container: (0, $eEbYb.NoResultsAutocorrectWrapper)
            }),
            fromQuickFindPostQueryNoResults ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1BaDj.default), {
                advancedSearchUrl: advancedSearchUrl,
                advancedSearchSelected: advancedSearchSelected
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ecdEs.default), {
                advancedSearchUrl: advancedSearchUrl,
                advancedSearchSelected: advancedSearchSelected
            })
        ]
    });
};
var $8910aa043bf2e2af$export$2e2bcd8739ae039 = (0, $lnXRc.withAnalytics)({
    advancedSearchSelected: (0, $5dFS9.onAdvancedSearchSelected)
})($8910aa043bf2e2af$var$NoResultsWithHooks);

});
parcelRegister("lnXRc", function(module, exports) {

$parcel$export(module.exports, "withAnalytics", () => $64f03dc1bbdc8c07$export$af9baadf0e4f6e13);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1DWH0 = parcelRequire("1DWH0");

var $5dFS9 = parcelRequire("5dFS9");
function $64f03dc1bbdc8c07$export$af9baadf0e4f6e13(analytics) {
    return (Component)=>{
        class WrappedComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
            render() {
                const { createAnalyticsEvent: createAnalyticsEvent, ...rest } = this.props;
                // There is NOT typesafety for the next line as typescript cannot infer types correctly with spread operators.
                // This is just going to have to go without type safety for the next line.
                return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                    ...rest,
                    ...this.wrappedAnalyticsCallback
                });
            }
            constructor(..._args){
                super(..._args);
                this.wrappedAnalyticsCallback = Object.keys(analytics).reduce((acc, key)=>({
                        ...acc,
                        // We forward all args to the corresponding callback regardless of type
                        [key]: (...args)=>{
                            this.props.createAnalyticsEvent && this.props.createAnalyticsEvent(analytics[key](...args)).fire((0, $5dFS9.DEFAULT_GAS_CHANNEL));
                        }
                    }), {});
            }
        }
        return (0, $1DWH0.default)()(WrappedComponent);
    };
}

});

parcelRegister("ecdEs", function(module, exports) {

$parcel$export(module.exports, "Image", () => $5dc707e28a4ee781$export$3e431a229df88919);
$parcel$export(module.exports, "default", () => $5dc707e28a4ee781$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");
var $kPBHE = parcelRequire("kPBHE");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $3S0fp = parcelRequire("3S0fp");

var $5dFS9 = parcelRequire("5dFS9");

var $bF0iL = parcelRequire("bF0iL");

var $eEA8O = parcelRequire("eEA8O");

var $194zG = parcelRequire("194zG");

const $5dc707e28a4ee781$export$3e431a229df88919 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("8Jyqa")));
class $5dc707e28a4ee781$export$ef6006467f04ee41 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
            title: intl.formatMessage((0, $bF0iL.messages).common_empty_state_heading),
            Image: $5dc707e28a4ee781$export$3e431a229df88919,
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.onAdvancedSearchClicked = (e)=>{
            const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
            advancedSearchSelected({
                trigger: (0, $3S0fp.getTrigger)(e),
                actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).NO_RESULTS,
                isLoading: false,
                newTab: (0, $3S0fp.isNewTab)(e)
            });
            onClick && onClick(advancedSearchUrl, e);
        };
        this.getContent = ()=>{
            const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
            if (!hasFilters) return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                role: "none",
                onClick: this.onAdvancedSearchClicked,
                children: isMultiSite || !advancedSearchUrl ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $bF0iL.messages).common_empty_state_body_no_advanced_search
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $bF0iL.messages).common_empty_state_body,
                    values: {
                        a: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPBHE.Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl,
                                children: s
                            })
                    }
                })
            }));
            else return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        tagName: "div",
                        ...(0, $bF0iL.messages).filters_applied
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $194zG.ClearFiltersButtonWrapper), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            onClick: clearFilters,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $bF0iL.messages).clear_filters
                            })
                        })
                    })
                ]
            });
        };
    }
}
var $5dc707e28a4ee781$export$2e2bcd8739ae039 = (0, $js7oX.default)($5dc707e28a4ee781$export$ef6006467f04ee41);

});
parcelRegister("194zG", function(module, exports) {

$parcel$export(module.exports, "ClearFiltersButtonWrapper", () => $118ff74bd36c6a4e$export$8c06dfd742f74a6f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $118ff74bd36c6a4e$export$8c06dfd742f74a6f = (0, $gwrgp.default)("div", {
    target: "eg9i8g80"
})({
    name: "1bqq45c",
    styles: "padding-top:var(--ds-space-400, 32px);"
});

});

parcelRegister("8Jyqa", function(module, exports) {

let $65bd3a06c384a101$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $65bd3a06c384a101$var$load("9RypW").then(()=>parcelRequire('hd6X6'));

});


parcelRegister("1BaDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e1084fdfd1fe42d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");
var $kPBHE = parcelRequire("kPBHE");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $3S0fp = parcelRequire("3S0fp");

var $5dFS9 = parcelRequire("5dFS9");

var $bF0iL = parcelRequire("bF0iL");

var $dDSTM = parcelRequire("dDSTM");

var $eEA8O = parcelRequire("eEA8O");

var $194zG = parcelRequire("194zG");

var $ecdEs = parcelRequire("ecdEs");
class $1e1084fdfd1fe42d$export$be28e1c115e337c7 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
            title: intl.formatMessage((0, $dDSTM.messages).quick_find_post_query_no_results_header),
            Image: (0, $ecdEs.Image),
            content: this.getContent()
        });
    }
    constructor(...args){
        super(...args);
        this.onAdvancedSearchClicked = (e)=>{
            const { advancedSearchSelected: advancedSearchSelected, onClick: onClick, advancedSearchUrl: advancedSearchUrl } = this.props;
            advancedSearchSelected({
                trigger: (0, $3S0fp.getTrigger)(e),
                actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).NO_RESULTS,
                isLoading: false,
                newTab: (0, $3S0fp.isNewTab)(e)
            });
            onClick && onClick(advancedSearchUrl, e);
        };
        this.getContent = ()=>{
            const { linkComponent: linkComponent, advancedSearchUrl: advancedSearchUrl, hasFilters: hasFilters, clearFilters: clearFilters, isMultiSite: isMultiSite } = this.props;
            if (!hasFilters) return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                role: "none",
                onClick: this.onAdvancedSearchClicked,
                children: isMultiSite || !advancedSearchUrl ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $bF0iL.messages).common_empty_state_body_no_advanced_search
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $dDSTM.messages).quick_find_post_query_no_results_body,
                    values: {
                        SearchContentLink: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kPBHE.Link), {
                                linkComponent: linkComponent,
                                href: advancedSearchUrl,
                                children: s
                            })
                    }
                })
            }));
            else return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        tagName: "div",
                        ...(0, $bF0iL.messages).filters_applied
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $194zG.ClearFiltersButtonWrapper), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            onClick: clearFilters,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...(0, $bF0iL.messages).clear_filters
                            })
                        })
                    })
                ]
            });
        };
    }
}
var $1e1084fdfd1fe42d$export$2e2bcd8739ae039 = (0, $js7oX.default)($1e1084fdfd1fe42d$export$be28e1c115e337c7);

});

parcelRegister("21MH9", function(module, exports) {

$parcel$export(module.exports, "AutocorrectAsyncWrapper", () => $8a39f80e5c1cc577$export$5e9f08d9cf554737);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

const $8a39f80e5c1cc577$var$LoadedAutocorrection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("fVDj1")).then(({ LoadedAutocorrection: LoadedAutocorrection })=>({
            default: LoadedAutocorrection
        })));
const $8a39f80e5c1cc577$export$5e9f08d9cf554737 = ({ container: container, fallback: fallback })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($8a39f80e5c1cc577$var$LoadedAutocorrection, {
            container: container,
            fallback: fallback
        })
    });
};

});
parcelRegister("fVDj1", function(module, exports) {

let $b98aab3798d87c59$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b98aab3798d87c59$var$load("6kNSo").then(()=>parcelRequire('kOUyO'));

});




parcelRegister("cnoUz", function(module, exports) {

$parcel$export(module.exports, "QuickFindConfluenceTransformer", () => $704a874b96428859$export$d1cc89207db04ec4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $bySHO = parcelRequire("bySHO");

var $lqMdf = parcelRequire("lqMdf");

var $7mejp = parcelRequire("7mejp");

var $791Lz = parcelRequire("791Lz");

var $2IGSl = parcelRequire("2IGSl");

var $a57V3 = parcelRequire("a57V3");
const $704a874b96428859$export$d1cc89207db04ec4 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bySHO.PreQueryFilterTransformer), {
        ...rest,
        children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $lqMdf.PreQueryRecentlyViewedTransformer), {
                ...args,
                children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7mejp.RecentSearchesTransformer), {
                        ...args,
                        children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $791Lz.QueryFilterTransformer), {
                                ...args,
                                children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2IGSl.PostQueryRecentlyViewedTransformer), {
                                        ...args,
                                        children: (args)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $a57V3.DeduplicateRecentlyViewedAndResultsTransformer), {
                                                ...args,
                                                children: (args)=>children(args)
                                            })
                                    })
                            })
                    })
            })
    });
};

});
parcelRegister("bySHO", function(module, exports) {

$parcel$export(module.exports, "PreQueryFilterTransformer", () => $e72227bd0175ccc2$export$eb528a71db3ec636);

var $iBckn = parcelRequire("iBckn");

var $2ZIpG = parcelRequire("2ZIpG");
const $e72227bd0175ccc2$export$eb528a71db3ec636 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const filteredPreQuerySections = query ? preQueryItems.sections : preQueryItems.sections.filter((section)=>section.id !== (0, $iBckn.RECENT_SPACES_SECTION_ID));
    const filteredPreQueryItems = {
        sections: filteredPreQuerySections,
        size: filteredPreQuerySections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0)
    };
    return children({
        preQueryItems: filteredPreQueryItems,
        postQueryItems: postQueryItems,
        productState: productState
    });
};

});

parcelRegister("lqMdf", function(module, exports) {

$parcel$export(module.exports, "PreQueryRecentlyViewedTransformer", () => $8c058a58127c6526$export$4cf1eef5109c47c9);

var $js7oX = parcelRequire("js7oX");

var $dDSTM = parcelRequire("dDSTM");

var $3q90y = parcelRequire("3q90y");
const $8c058a58127c6526$export$8d431b8c84c2735b = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const newPreQueryItemsSections = preQueryItems.sections.map((section, i)=>{
        if (section.id === (0, $3q90y.RECENT_SEARCHES_SECTION_ID) || section.searchResults.length === 0) return section;
        else {
            const newSection = {
                ...section,
                title: intl.formatMessage((0, $dDSTM.messages).quick_find_recently_viewed)
            };
            return newSection;
        }
    });
    preQueryItems.sections = newPreQueryItemsSections;
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItems,
        productState: productState
    });
};
const $8c058a58127c6526$export$4cf1eef5109c47c9 = (0, $js7oX.default)($8c058a58127c6526$export$8d431b8c84c2735b);

});
parcelRegister("3q90y", function(module, exports) {

$parcel$export(module.exports, "RECENT_SEARCHES_SECTION_ID", () => $b9ad121c89489744$export$6c90641783086ccb);
$parcel$export(module.exports, "useRecentSearchesSection", () => $b9ad121c89489744$export$e5468815b4eb37d);

var $7UHDa = parcelRequire("7UHDa");

var $k1wrx = parcelRequire("k1wrx");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dDSTM = parcelRequire("dDSTM");

var $fJRVo = parcelRequire("fJRVo");

var $2ZIpG = parcelRequire("2ZIpG");

var $9Janh = parcelRequire("9Janh");

var $eYinl = parcelRequire("eYinl");

var $O4eEI = parcelRequire("O4eEI");

var $20N1w = parcelRequire("20N1w");

var $aDRXf = parcelRequire("aDRXf");
const $b9ad121c89489744$export$6c90641783086ccb = 'recent-searches';
const $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY = 3;
const $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY = 1;
const $b9ad121c89489744$export$e5468815b4eb37d = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const { focusInput: focusInput } = (0, $aDRXf.useInputContext)();
    const { recentSearchItems: recentSearchItems, removeRecentSearch: removeRecentSearch } = (0, $9Janh.useRecentSearches)({
        Icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eYinl.QuickFindIcon), {})
    });
    const recentSearches = recentSearchItems.map((result)=>({
            id: result.id,
            title: result.title,
            icon: result.icon,
            url: getActiveProduct()?.generateAdvancedSearchUrl?.(result.title) || '',
            meta: '',
            additionalMeta: query !== '' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $dDSTM.messages).quick_find_recent_search_text_dialog
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $dDSTM.messages).quick_find_recent_search
            })
        }));
    const recentSearchesSection = (0, $gwFzn.useMemo)(()=>{
        return {
            id: $b9ad121c89489744$export$6c90641783086ccb,
            title: '',
            searchResults: recentSearches,
            resultRenderer: ({ searchResult: searchResult, isKeyboardHighlighted: isKeyboardHighlighted, isCollapsed: isCollapsed })=>{
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20N1w.PersistRecentSearch), {
                    overrideQuery: searchResult.title,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k1wrx.EnlargedSearchResultContent), {
                        ...searchResult,
                        icon: searchResult.icon,
                        isKeyboardHighlighted: isKeyboardHighlighted,
                        isCollapsed: isCollapsed,
                        isRecentSearch: true,
                        onRemove: (event)=>{
                            event.preventDefault();
                            event.stopPropagation();
                            removeRecentSearch(searchResult.title);
                            focusInput && focusInput();
                        },
                        displayAdditionalMetaWhenHighlightedOnly: query === ''
                    })
                });
            },
            resultLimit: query ? $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_POST_QUERY : $b9ad121c89489744$var$MAX_RECENT_SEARCHES_SHOWN_IN_PRE_QUERY,
            useAnalyticsOverride: ({ screen: screen })=>(0, $O4eEI.useSearchResultAnalyticsCallbacks)({
                    screen: screen,
                    actionSubject: 'recentSearch'
                })
        };
    }, [
        query,
        recentSearches,
        removeRecentSearch,
        focusInput
    ]);
    return recentSearchesSection;
};

});
parcelRegister("9Janh", function(module, exports) {

$parcel$export(module.exports, "useRecentSearches", () => $82a68bc4ee5a3cdf$export$d349a1b1b7874c14);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iEwUU = parcelRequire("iEwUU");

var $1SV4e = parcelRequire("1SV4e");

var $fJRVo = parcelRequire("fJRVo");

var $dJB5H = parcelRequire("dJB5H");

var $3S0fp = parcelRequire("3S0fp");
const $82a68bc4ee5a3cdf$export$e0495117e49f394c = 50; // It can be different from the number of records in local storage
const $82a68bc4ee5a3cdf$export$d349a1b1b7874c14 = ({ Icon: Icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dJB5H.DefaultIcon), {}), limit: limit = $82a68bc4ee5a3cdf$export$e0495117e49f394c })=>{
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const [recentSearchItems, setRecentSearchItems] = (0, $gwFzn.useState)([]);
    const memoizedIcon = (0, $gwFzn.useMemo)(()=>Icon, [
        Icon
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!product || !user.id) return;
        const recentSearches = (0, $1SV4e.getRecentSearches)(user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
        const searchResults = recentSearches.map((value)=>({
                id: (0, $3S0fp.sha256Hash)(value),
                title: value,
                icon: memoizedIcon
            }));
        if (recentSearchItems.length === 0 && searchResults.length > 0) setRecentSearchItems(searchResults);
    }, [
        product,
        user.id,
        memoizedIcon,
        recentSearchItems.length
    ]);
    const removeRecentSearch = (0, $gwFzn.useCallback)((query)=>{
        if (user?.id && product?.id) {
            const recentSearches = (0, $1SV4e.removeRecentSearch)(query, user.id, product.id, (0, $1SV4e.RECENT_SEARCH_KEY));
            if (recentSearches) {
                const searchResults = recentSearches.map((value)=>({
                        id: (0, $3S0fp.sha256Hash)(value),
                        title: value,
                        icon: memoizedIcon
                    }));
                setRecentSearchItems(searchResults);
            }
        }
    }, [
        product,
        user.id,
        memoizedIcon
    ]);
    return {
        recentSearchItems: recentSearchItems.slice(0, limit),
        removeRecentSearch: removeRecentSearch
    };
};

});
parcelRegister("dJB5H", function(module, exports) {

$parcel$export(module.exports, "DefaultIcon", () => $54104dff0de2abd7$export$d206ce4c12e8ddf6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $aEOt2 = parcelRequire("aEOt2");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $54104dff0de2abd7$var$IconContainer = (0, $gwrgp.default)("span", {
    target: "eao5nkl0"
})({
    name: "1qkppl",
    styles: "margin-left:var(--ds-space-negative-025, -2px);margin-top:var(--ds-space-025, 2px);"
});
const $54104dff0de2abd7$export$d206ce4c12e8ddf6 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($54104dff0de2abd7$var$IconContainer, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aEOt2))), {
            color: `var(--ds-icon-accent-gray, ${(0, $6fnsQ.N600)})`,
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "recent-search"
        })
    });

});


parcelRegister("eYinl", function(module, exports) {

$parcel$export(module.exports, "QuickFindIcon", () => $4e314a008b56330d$export$f5db5b3314f27023);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $aEOt2 = parcelRequire("aEOt2");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $4e314a008b56330d$var$IconContainer = (0, $gwrgp.default)("span", {
    target: "e10r90tl0"
})({
    background: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`,
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-border-radius-400, 4px)",
    border: "'1px solid transparent'"
});
const $4e314a008b56330d$export$f5db5b3314f27023 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($4e314a008b56330d$var$IconContainer, {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aEOt2))), {
            color: `var(--ds-icon-accent-gray, ${(0, $6fnsQ.N600)})`,
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "recent-search"
        })
    });

});



parcelRegister("7mejp", function(module, exports) {

$parcel$export(module.exports, "RecentSearchesTransformer", () => $217415c35164e8dc$export$2142bc2fa441a5b0);

var $3q90y = parcelRequire("3q90y");
const $217415c35164e8dc$export$2142bc2fa441a5b0 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const recentSearchesSection = (0, $3q90y.useRecentSearchesSection)();
    const preQueryItemsWithRecentSearches = {
        sections: [
            recentSearchesSection,
            ...preQueryItems.sections
        ],
        size: preQueryItems.size
    };
    return children({
        preQueryItems: preQueryItemsWithRecentSearches,
        postQueryItems: postQueryItems,
        productState: productState
    });
};

});

parcelRegister("791Lz", function(module, exports) {

$parcel$export(module.exports, "QueryFilterTransformer", () => $a2f4de094cafd3d0$export$308bb2328bfeb2be);

var $2ZIpG = parcelRequire("2ZIpG");

var $74Udv = parcelRequire("74Udv");
const $a2f4de094cafd3d0$var$RECENTLY_VIEWED_ITEMS_SHOWN = 10;
const $a2f4de094cafd3d0$export$308bb2328bfeb2be = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const filteredPreQueryItems = (0, $74Udv.filterAllSectionItems)({
        sections: preQueryItems.sections,
        size: preQueryItems.size
    }, query, $a2f4de094cafd3d0$var$RECENTLY_VIEWED_ITEMS_SHOWN);
    const highlightedPostQueryItems = (0, $74Udv.highlightPostQueryResultTitles)(postQueryItems, query);
    return children({
        preQueryItems: filteredPreQueryItems,
        postQueryItems: highlightedPostQueryItems,
        productState: productState
    });
};

});
parcelRegister("74Udv", function(module, exports) {

$parcel$export(module.exports, "filterFirstSectionItems", () => $fa84d6e3ef79d059$export$c942155d15f72814);
$parcel$export(module.exports, "filterAllSectionItems", () => $fa84d6e3ef79d059$export$f48d35d3732436aa);
$parcel$export(module.exports, "highlightPostQueryResultTitles", () => $fa84d6e3ef79d059$export$630e09546900f38e);
$parcel$export(module.exports, "mergeFirstSectionSearchItems", () => $fa84d6e3ef79d059$export$c28e3f530240553c);

var $bloXB = parcelRequire("bloXB");

var $3q90y = parcelRequire("3q90y");

var $jV49M = parcelRequire("jV49M");
const $fa84d6e3ef79d059$export$c942155d15f72814 = (searchItems, query, numberOfResultItems = 3)=>{
    if (!searchItems.sections[0]) return searchItems;
    const filteredSearchResults = searchItems.sections[0].searchResults.filter((item)=>{
        return item.title.toLowerCase().includes(query.toLowerCase());
    }).slice(0, numberOfResultItems);
    return {
        size: filteredSearchResults.length,
        sections: [
            {
                ...searchItems.sections[0],
                searchResults: filteredSearchResults
            }
        ]
    };
};
const $fa84d6e3ef79d059$export$f48d35d3732436aa = (searchItems, query, numberOfResultItems = 3)=>{
    if (query === '') return searchItems;
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredSearchSections = searchItems.sections.map((section)=>{
        return {
            ...section,
            searchResults: section.searchResults.map((item)=>{
                // 1st pass
                const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
                    if (!acc) return acc;
                    return item.title.toLowerCase().includes(word.toLowerCase());
                }, true);
                if (doAllWordsMatch) {
                    // 2nd and 3rd Pass
                    const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $bloXB.highlightMatchedText)(item.title, wordsInQuery);
                    itemScoreMap[item.id] = score;
                    return {
                        ...item,
                        highlightedTitle: section.id !== (0, $3q90y.RECENT_SEARCHES_SECTION_ID) ? highlightedTitle : negatedHighlightedTitle
                    };
                }
                return null;
            }).filter((item)=>item).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.id] - itemScoreMap[item.id] : 0).slice(0, numberOfResultItems)
        };
    });
    const size = filteredSearchSections.map((section)=>section.searchResults.length).reduce((acc, b)=>acc + b, 0);
    return {
        size: size,
        sections: filteredSearchSections
    };
};
const $fa84d6e3ef79d059$export$630e09546900f38e = (postQueryItems, query)=>{
    const wordsInQuery = query.split(' ');
    const highlightedSearchSections = postQueryItems.sections.map((section)=>{
        return {
            ...section,
            searchResults: section.searchResults.map((item)=>{
                const { highlightedTitle: highlightedTitle } = (0, $bloXB.highlightMatchedText)(item.title, wordsInQuery);
                return {
                    ...item,
                    highlightedTitle: highlightedTitle
                };
            })
        };
    });
    return {
        size: postQueryItems.size,
        sections: highlightedSearchSections
    };
};
const $fa84d6e3ef79d059$export$c28e3f530240553c = (intermediateSearchItems, postQuerySearchItems)=>{
    if (!intermediateSearchItems.sections[0] || intermediateSearchItems.sections[0]?.searchResults.length === 0) return postQuerySearchItems;
    if (!postQuerySearchItems.sections[0] || postQuerySearchItems.sections[0]?.searchResults.length === 0) return intermediateSearchItems;
    const fullMergedResultsList = [
        ...intermediateSearchItems.sections[0].searchResults.map((result)=>({
                ...result,
                isRecentResult: true
            })),
        ...postQuerySearchItems.sections[0].searchResults
    ];
    const deduplicatedList = (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(fullMergedResultsList, (item)=>item.id);
    const sections = [
        {
            ...postQuerySearchItems.sections[0],
            searchResults: deduplicatedList
        }
    ];
    return {
        size: sections.reduce((accumulator, currentElem)=>accumulator + currentElem.searchResults.length, 0),
        sections: sections
    };
};

});


parcelRegister("2IGSl", function(module, exports) {

$parcel$export(module.exports, "PostQueryRecentlyViewedTransformer", () => $9788089c1dc93380$export$1607c6754b1f6fc5);

var $js7oX = parcelRequire("js7oX");

var $jFPud = parcelRequire("jFPud");

var $dDSTM = parcelRequire("dDSTM");

var $3q90y = parcelRequire("3q90y");
const $9788089c1dc93380$var$RECENTLY_VIEWED_ITEMS_SHOWN = 5;
/**
 * This transformer assumes that preQueryItems contains recently viewed search
 * results and adds them to the postQueryItems.
 */ const $9788089c1dc93380$var$PostQueryRecentlyViewedTransformerWithIntl = ({ intl: intl, preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    // Create an array of recently viewed sections. These sections exclude recent
    // searches and have a combined result limit of 10.
    let recentlyViewedCount = 0;
    const recentlyViewedSections = preQueryItems.sections.filter((section)=>section.id !== (0, $3q90y.RECENT_SEARCHES_SECTION_ID)).filter((section)=>section.searchResults.length > 0).map((section, i)=>{
        const newSection = {
            ...section,
            resultLimit: Math.min(section.searchResults.length, $9788089c1dc93380$var$RECENTLY_VIEWED_ITEMS_SHOWN - recentlyViewedCount),
            title: i === 0 ? intl.formatMessage((0, $dDSTM.messages).quick_find_recently_viewed) : ''
        };
        recentlyViewedCount = Math.min(recentlyViewedCount + section.searchResults.length, $9788089c1dc93380$var$RECENTLY_VIEWED_ITEMS_SHOWN);
        return newSection;
    });
    // Add recent searches to the end of postQueryItems after post query returns
    const recentSearchesSection = preQueryItems.sections.find((section)=>section.id === (0, $3q90y.RECENT_SEARCHES_SECTION_ID));
    const postQueryItemsSectionsWithRecentSearches = recentSearchesSection && productState === (0, $jFPud.ProductStates).PostQuerySuccess ? [
        ...postQueryItems.sections,
        recentSearchesSection
    ] : [
        ...postQueryItems.sections
    ];
    // Create the new postQueryItems object
    const postQueryItemsWithRecentlyViewed = {
        size: [
            ...recentlyViewedSections,
            ...postQueryItems.sections
        ].map((section)=>section.searchResults.length).reduce((a, b)=>a + b, 0),
        sections: [
            ...recentlyViewedSections,
            ...postQueryItemsSectionsWithRecentSearches
        ]
    };
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postQueryItemsWithRecentlyViewed,
        productState: productState
    });
};
const $9788089c1dc93380$export$1607c6754b1f6fc5 = (0, $js7oX.default)($9788089c1dc93380$var$PostQueryRecentlyViewedTransformerWithIntl);

});

parcelRegister("a57V3", function(module, exports) {

$parcel$export(module.exports, "DeduplicateRecentlyViewedAndResultsTransformer", () => $3a919f723ec8ca9b$export$91b234728c3a1640);

var $iBckn = parcelRequire("iBckn");
const $3a919f723ec8ca9b$var$MAX_RENDERED_SEARCH_RESULTS = 5;
const $3a919f723ec8ca9b$export$91b234728c3a1640 = ({ preQueryItems: preQueryItems, postQueryItems: postQueryItems, productState: productState, children: children })=>{
    const searchResults = postQueryItems.sections.find((section)=>section.id === (0, $iBckn.CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID))?.searchResults || [];
    const recentlyViewedResults = postQueryItems.sections.find((section)=>section.id === (0, $iBckn.RECENT_ITEMS_SECTION_ID))?.searchResults || [];
    const dedupedSearchResults = searchResults.filter((searchResult)=>{
        // Check for duplicates using ARIs
        const isDuplicate = recentlyViewedResults.some((recentlyViewedResult)=>recentlyViewedResult.ari === searchResult.ari);
        return searchResult.ari && !isDuplicate;
    });
    const postDeduplication = {
        ...postQueryItems,
        sections: postQueryItems.sections.map((section)=>{
            if (section.id === (0, $iBckn.CONFLUENCE_PAGE_BLOGPOST_ATTACHMENT_SECTION_ID)) return {
                ...section,
                searchResults: dedupedSearchResults.slice(0, $3a919f723ec8ca9b$var$MAX_RENDERED_SEARCH_RESULTS)
            };
            return section;
        })
    };
    return children({
        preQueryItems: preQueryItems,
        postQueryItems: postDeduplication,
        productState: productState
    });
};

});


parcelRegister("1OS8u", function(module, exports) {

$parcel$export(module.exports, "quickFindRecentItemResultMapper", () => $47e0642ad89da657$export$1aadfab314f9e7ce);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $hWR4v = parcelRequire("hWR4v");

var $aIk0I = parcelRequire("aIk0I");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $DuEDb = parcelRequire("DuEDb");

var $dDSTM = parcelRequire("dDSTM");

var $8PrAH = parcelRequire("8PrAH");

var $kOyOy = parcelRequire("kOyOy");

var $j7mwp = parcelRequire("j7mwp");
const $47e0642ad89da657$var$CONTEXT_PATH = '/wiki';
const $47e0642ad89da657$var$labelStyles = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.050'
});
const $47e0642ad89da657$export$1aadfab314f9e7ce = (edge)=>{
    const item = edge.node;
    const data = item.object.data;
    const productType = item.object.product;
    switch(productType){
        case (0, $hWR4v.ActivityProduct).JIRA:
            return {
                id: item.object.id,
                title: `${data?.key}: ${(data?.fieldsById?.edges || [
                    {}
                ])[0].node?.text}` || '',
                url: data?.webUrl || '',
                icon: (0, $8PrAH.ContentIconRenderer)({
                    type: 'jira',
                    title: data?.title
                }),
                meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j7mwp.QuickFindResultMeta), {
                    meta: [
                        'Jira',
                        (0, $j7mwp.capitalizeFirstLetter)(item.object.type)
                    ]
                }),
                additionalMeta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DuEDb.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`
            };
        case (0, $hWR4v.ActivityProduct).CONFLUENCE:
            // Do NOT show drafts for live-edit pages since they're not drafts from a user perspective
            const isDraft = (data?.pageStatus === 'DRAFT' || data?.blogStatus === 'DRAFT') && data?.subtype !== 'LIVE';
            return {
                ari: item.object.id,
                id: item.object.id,
                title: data?.title || '',
                url: `${data?.links?.base || $47e0642ad89da657$var$CONTEXT_PATH}${data?.links?.webUi}`,
                icon: (0, $8PrAH.ContentIconRenderer)({
                    type: item.object.type,
                    title: data?.title,
                    isDraft: isDraft
                }),
                label: isDraft ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    xcss: $47e0642ad89da657$var$labelStyles,
                    as: "span",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $dDSTM.messages).quick_find_recent_draft_label
                        })
                    })
                }) : '',
                meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kOyOy.ConfluenceResultMeta), {
                    resultContentType: item.object.type,
                    resultAncestors: data?.ancestors,
                    resultSpace: data?.space
                }),
                additionalMeta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DuEDb.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`,
                containerId: data?.space?.id || undefined
            };
        case (0, $hWR4v.ActivityProduct).ATLAS:
            return {
                id: item.object.id,
                title: `${data?.name}` || '',
                url: data?.url || '',
                icon: (0, $8PrAH.ContentIconRenderer)({
                    type: 'atlas',
                    imageSrc: data?.iconData || '',
                    title: data?.title
                }),
                meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j7mwp.QuickFindResultMeta), {
                    meta: [
                        (0, $j7mwp.capitalizeFirstLetter)(item.object.type),
                        data?.key
                    ]
                }),
                additionalMeta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DuEDb.EventTypeMessage), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                isRecentResult: true,
                type: `${item.object.product} ${item.object.type}`
            };
        default:
            return {
                id: '',
                title: '',
                url: '',
                icon: '',
                meta: ''
            };
    }
};

});
parcelRegister("DuEDb", function(module, exports) {

$parcel$export(module.exports, "WORKED_EVENT", () => $4c50cd29395d06d1$export$eb4e9f525aef1cc3);
$parcel$export(module.exports, "EventTypeMessage", () => $4c50cd29395d06d1$export$9e4fb3fb50a3c754);
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $hrzSy = parcelRequire("hrzSy");

var $lDMQ2 = parcelRequire("lDMQ2");

var $eaVC4 = parcelRequire("eaVC4");

var $4oRNp = parcelRequire("4oRNp");

var $5mJ0F = parcelRequire("5mJ0F");
var $Lyrmh = parcelRequire("Lyrmh");
var $4c50cd29395d06d1$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    return VIEWED_EVENT;
}({});
var $4c50cd29395d06d1$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
function $4c50cd29395d06d1$export$e873c799b137eec4(date) {
    return (0, $lDMQ2.default)(new Date(date), $4c50cd29395d06d1$var$startOfOneWeekAgo());
}
function $4c50cd29395d06d1$var$startOfOneWeekAgo() {
    return (0, $eaVC4.default)((0, $4oRNp.default)(new Date(), 1));
}
const $4c50cd29395d06d1$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData = true })=>{
    const isAbsolute = $4c50cd29395d06d1$export$e873c799b137eec4(timestamp);
    const message = (0, $Lyrmh.useEventTypeMessage)(eventType, {
        isMyActivityData: isMyActivityData,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $5mJ0F.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2nPZH.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...message,
        values: values
    });
};

});

parcelRegister("8PrAH", function(module, exports) {

$parcel$export(module.exports, "ContentIconRenderer", () => $3b53752b63a8cd2e$export$bf56fa242f0fc37d);
$parcel$export(module.exports, "GenericIconRenderer", () => $3b53752b63a8cd2e$export$e5d849fb708254a9);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $esRft = parcelRequire("esRft");

var $2qVkt = parcelRequire("2qVkt");

var $9RVmI = parcelRequire("9RVmI");

var $ZDq1z = parcelRequire("ZDq1z");

var $5tmwS = parcelRequire("5tmwS");

var $1yB28 = parcelRequire("1yB28");

var $6B0jU = parcelRequire("6B0jU");

var $8jHAi = parcelRequire("8jHAi");

var $jfyuR = parcelRequire("jfyuR");

var $dQMPp = parcelRequire("dQMPp");
const $3b53752b63a8cd2e$var$negativeMarginStyles = (0, $ecnYn.xcss)({
    margin: 'space.negative.025',
    display: 'flex'
});
const $3b53752b63a8cd2e$var$iconTypes = {
    ATLAS: 'atlas',
    ATTACHMENT: 'attachment',
    BLOGPOST: 'blogpost',
    COMMENT: 'comment',
    CONTENT: 'content',
    CONFLUENCEBLOGPOST: 'confluence-blogpost',
    CONFLUENCEPAGE: 'confluence-page',
    DATABASE: 'database',
    FOLDER: 'folder',
    JIRA: 'jira',
    PAGE: 'page',
    WHITEBOARD: 'whiteboard'
};
const $3b53752b63a8cd2e$var$iconStyles = {
    BLUE: 'blue',
    GRAY: 'gray',
    PURPLE: 'purple',
    SHAPE: 'square',
    SIZE: '24',
    TEAL: 'teal',
    YELLOW: 'yellow'
};
const $3b53752b63a8cd2e$export$bf56fa242f0fc37d = ({ type: type, imageSrc: imageSrc, title: title, isDraft: isDraft = false })=>{
    // CONFLUENCE
    if (type === $3b53752b63a8cd2e$var$iconTypes.PAGE || type === $3b53752b63a8cd2e$var$iconTypes.CONFLUENCEPAGE || type === $3b53752b63a8cd2e$var$iconTypes.CONTENT) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: type,
        appearance: isDraft ? $3b53752b63a8cd2e$var$iconStyles.GRAY : $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.BLOGPOST || type === $3b53752b63a8cd2e$var$iconTypes.CONFLUENCEBLOGPOST) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.DATABASE) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.PURPLE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.FOLDER) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.WHITEBOARD) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.TEAL,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.COMMENT) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.YELLOW,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.ATTACHMENT) // TODO: Clarify if the attachment icon should be changed
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jfyuR.AttachmentIcon), {
        title: title || '',
        size: "medium",
        label: type
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.ATLAS) return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        width: "24px",
        height: "24px",
        src: imageSrc || '',
        "aria-label": type,
        alt: type
    });
    else if (type === $3b53752b63a8cd2e$var$iconTypes.JIRA) // TODO: Clarify the decision made for jira icons
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        label: type,
        appearance: $3b53752b63a8cd2e$var$iconStyles.BLUE,
        shape: $3b53752b63a8cd2e$var$iconStyles.SHAPE,
        size: $3b53752b63a8cd2e$var$iconStyles.SIZE
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {});
};
const $3b53752b63a8cd2e$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $3b53752b63a8cd2e$var$negativeMarginStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        })
    });

});
parcelRegister("jfyuR", function(module, exports) {

$parcel$export(module.exports, "AttachmentIcon", () => $6488faa431f4e155$export$edc04f92718bbea4);

var $gwFzn = parcelRequire("gwFzn");

var $dlbUV = parcelRequire("dlbUV");

var $fX9Sa = parcelRequire("fX9Sa");

var $d4cCP = parcelRequire("d4cCP");

var $gguok = parcelRequire("gguok");

var $d8Kpd = parcelRequire("d8Kpd");

var $gH8Rx = parcelRequire("gH8Rx");

var $8DZd1 = parcelRequire("8DZd1");

var $djgQ6 = parcelRequire("djgQ6");

var $d5BUD = parcelRequire("d5BUD");

var $b4DX7 = parcelRequire("b4DX7");

var $41GKb = parcelRequire("41GKb");

var $20uDq = parcelRequire("20uDq");

var $11LZV = parcelRequire("11LZV");

var $lzyQK = parcelRequire("lzyQK");

var $hY1Uy = parcelRequire("hY1Uy");

var $dfQbH = parcelRequire("dfQbH");

var $1iV2p = parcelRequire("1iV2p");

var $7t8Pn = parcelRequire("7t8Pn");

var $ayTrS = parcelRequire("ayTrS");

var $hXc8o = parcelRequire("hXc8o");

var $90Icb = parcelRequire("90Icb");

var $lkBga = parcelRequire("lkBga");
const $6488faa431f4e155$var$AttachmentFileExtensionMatchers = [
    {
        regexp: /\.(pdf)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
        ]
    },
    {
        regexp: /\.(gif)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d5BUD))),
            (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
        ]
    },
    {
        regexp: /\.(jpeg|jpg|png)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
        ]
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
        ]
    },
    {
        regexp: /\.(zip|tar|gz|bz2|rar)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
            (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
        ]
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
        ]
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
            (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
        ]
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
            (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
        ]
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
            (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
        ]
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        icon: [
            (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
            (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
        ]
    }
];
const $6488faa431f4e155$var$getIconArray = (title)=>{
    const extension = $6488faa431f4e155$var$AttachmentFileExtensionMatchers.find((extensionMatcher)=>{
        const matches = extensionMatcher.regexp.exec(title);
        return matches && matches.length > 0;
    });
    if (extension) return extension.icon;
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1))),
        (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)))
    ];
};
const $6488faa431f4e155$export$ebe2a8421106a1ee = {
    small: 0,
    medium: 1
};
const $6488faa431f4e155$export$edc04f92718bbea4 = ({ title: title, label: label, size: size })=>{
    const iconArray = $6488faa431f4e155$var$getIconArray(title);
    const sizeIndex = $6488faa431f4e155$export$ebe2a8421106a1ee[size];
    const icon = iconArray[sizeIndex];
    return /*#__PURE__*/ (0, $gwFzn.createElement)(icon, {
        label: label,
        testId: icon.name
    });
};

});


parcelRegister("kOyOy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceResultMeta", () => $a454b160acdd3a63$export$9138e703d4b4585b);
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/ConfluenceResultMeta.tsx

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");

var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");

var $j7mwp = parcelRequire("j7mwp");

var $gwrgp = parcelRequire("gwrgp");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a454b160acdd3a63$var$ConfluenceResultMetaWrapper = (0, $gwrgp.default)("span", {
    target: "e10xva5d0"
})({
    name: "u4p24i",
    styles: "display:flex;flex-direction:row;align-items:center;"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a454b160acdd3a63$var$ConfluenceTypeWrapper = (0, $gwrgp.default)("span", {
    target: "e10xva5d1"
})({
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`
});
const $a454b160acdd3a63$var$BreadCrumbs = ({ breadCrumbs: breadCrumbs = [] })=>{
    if (breadCrumbs.length === 0) return null;
    // only allow 2 breadcrumbs
    // take the first and the last (if different)
    let twoBreadcrumbs = [];
    if (breadCrumbs.length > 2) twoBreadcrumbs = [
        breadCrumbs[0],
        breadCrumbs[breadCrumbs.length - 1]
    ];
    else twoBreadcrumbs = breadCrumbs;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
        separator: "/",
        space: "space.100",
        children: twoBreadcrumbs.map(({ id: id, title: title }, i)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                color: "color.text.subtle",
                size: "small",
                children: title
            }, id))
    });
};
const $a454b160acdd3a63$export$9138e703d4b4585b = ({ resultContentType: resultContentType, resultAncestors: resultAncestors, resultSpace: resultSpace })=>{
    const breadcrumbs = $a454b160acdd3a63$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($a454b160acdd3a63$var$ConfluenceResultMetaWrapper, {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($a454b160acdd3a63$var$ConfluenceTypeWrapper, {
                children: "Confluence"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j7mwp.SpacerWrapper), {
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)($a454b160acdd3a63$var$ConfluenceTypeWrapper, {
                children: `${(0, $j7mwp.capitalizeFirstLetter)(resultContentType)}`
            }),
            breadcrumbs?.length && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j7mwp.SpacerWrapper), {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)($a454b160acdd3a63$var$BreadCrumbs, {
                        breadCrumbs: breadcrumbs
                    })
                ]
            })
        ]
    });
};
const $a454b160acdd3a63$export$ed9f69ac7e699c53 = (ancestors, space)=>{
    let breadcrumbs = [];
    if (space) {
        const spaceBreadcrumb = {
            id: space?.id,
            title: space?.name
        };
        if (!ancestors || ancestors.length === 0) breadcrumbs = [
            spaceBreadcrumb
        ];
        else if (ancestors.length >= 1) // The first ancestor is a root node that shouldn't be rendered
        breadcrumbs = [
            spaceBreadcrumb,
            ...ancestors.slice(1)
        ];
    }
    // Filter out invalid breadcrumbs
    return breadcrumbs.filter((breadCrumb)=>breadCrumb.id && breadCrumb.title);
};

});
parcelRegister("j7mwp", function(module, exports) {

$parcel$export(module.exports, "SpacerWrapper", () => $68686fedcc1e2524$export$b05a2e78ddf8915e);
$parcel$export(module.exports, "capitalizeFirstLetter", () => $68686fedcc1e2524$export$d07f57595c356899);
$parcel$export(module.exports, "QuickFindResultMeta", () => $68686fedcc1e2524$export$73e5ecb29f7bf6e9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $68686fedcc1e2524$var$ResultMetaWrapper = (0, $gwrgp.default)("span", {
    target: "eflzzry0"
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`
});
const $68686fedcc1e2524$export$b05a2e78ddf8915e = (0, $gwrgp.default)("span", {
    target: "eflzzry1"
})({
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N300)})`,
    margin: `0px ${"var(--ds-space-100, 8px)"}`
});
function $68686fedcc1e2524$export$d07f57595c356899(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
}
const $68686fedcc1e2524$export$73e5ecb29f7bf6e9 = ({ meta: meta })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($68686fedcc1e2524$var$ResultMetaWrapper, {
        children: meta.filter((metaItem)=>metaItem !== null && metaItem !== undefined).map((metaItem, index)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                children: [
                    metaItem,
                    index !== meta.length - 1 && /*#__PURE__*/ (0, $7UHDa.jsx)($68686fedcc1e2524$export$b05a2e78ddf8915e, {
                        children: "\u2022"
                    })
                ]
            }))
    });
};

});



parcelRegister("axxOe", function(module, exports) {

$parcel$export(module.exports, "quickFindRecentSpaceResultMapper", () => $c38d98a6d1a1036a$export$d04e5b6d01e34c3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $esRft = parcelRequire("esRft");

var $dDSTM = parcelRequire("dDSTM");
const $c38d98a6d1a1036a$var$negativeMarginStyles = (0, $ecnYn.xcss)({
    margin: 'space.negative.025'
});
const $c38d98a6d1a1036a$var$CONTEXT_PATH = '/wiki';
const $c38d98a6d1a1036a$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $bUlM5.default), {
        xcss: $c38d98a6d1a1036a$var$negativeMarginStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
            size: size,
            borderColor: "transparent",
            src: iconUrl,
            appearance: appearance,
            testId: "result-avatar"
        })
    });
const $c38d98a6d1a1036a$export$d04e5b6d01e34c3 = (item)=>({
        id: item?.id || '',
        title: item?.name || '',
        meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_confluence_space
        }),
        additionalMeta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_recent_spaces_additional_meta
        }),
        url: `${$c38d98a6d1a1036a$var$CONTEXT_PATH}${item?.links?.webui || ''}`,
        containerId: item?.id || undefined,
        icon: $c38d98a6d1a1036a$export$e5d849fb708254a9({
            iconUrl: `${$c38d98a6d1a1036a$var$CONTEXT_PATH}${item?.icon?.path || ''}`,
            size: 'small'
        }),
        isRecentResult: true,
        type: 'confluence space'
    });

});

parcelRegister("clOud", function(module, exports) {

$parcel$export(module.exports, "getQuickFindPeopleAndTeamsResultMapper", () => $9ebe45aba70c0c63$export$dbdea3e42644cff8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $8PrAH = parcelRequire("8PrAH");

var $dDSTM = parcelRequire("dDSTM");

var $aU479 = parcelRequire("aU479");
const $9ebe45aba70c0c63$export$dbdea3e42644cff8 = (primaryProduct, orgId, cloudId)=>{
    return (result)=>{
        if (result.type === 'team') return {
            title: result.name,
            id: result.id,
            type: result.type,
            meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $dDSTM.messages).quick_find_results_team
            }),
            url: `${window.location.origin}${(0, $aU479.getTeamPath)(result.id, primaryProduct, orgId, cloudId)}`,
            icon: (0, $8PrAH.GenericIconRenderer)({
                iconUrl: result.avatarUrl
            })
        };
        else return {
            title: result.name,
            id: result.id,
            type: result.type,
            meta: result.title || '',
            url: `${window.location.origin}${(0, $aU479.getUserPath)(result.id, primaryProduct, orgId, cloudId)}`,
            icon: (0, $8PrAH.GenericIconRenderer)({
                iconUrl: result.avatarUrl,
                appearance: 'circle'
            })
        };
    };
};

});

parcelRegister("1x1dO", function(module, exports) {

$parcel$export(module.exports, "quickFindConfluenceSpaceMapper", () => $8bf0db52976a1541$export$831f92f4f63a8807);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dDSTM = parcelRequire("dDSTM");

var $lNtmT = parcelRequire("lNtmT");

var $8PrAH = parcelRequire("8PrAH");
const $8bf0db52976a1541$export$831f92f4f63a8807 = ({ node: item })=>{
    return {
        id: (0, $lNtmT.transformAriToId)(item?.id || '', item?.type || ''),
        title: item?.title || '',
        meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dDSTM.messages).quick_find_confluence_space
        }),
        url: item?.url || '',
        type: 'confluence space',
        containerId: item?.id,
        icon: (0, $8PrAH.GenericIconRenderer)({
            iconUrl: `/wiki${item?.iconPath || ''}`,
            size: 'small'
        })
    };
};

});
parcelRegister("lNtmT", function(module, exports) {

$parcel$export(module.exports, "transformAriToId", () => $35f4e8be421d896f$export$6d8886e8d5cdbeec);
const $35f4e8be421d896f$export$6d8886e8d5cdbeec = (id, type)=>{
    switch(type){
        case 'page':
            return id.split(':page/')[1];
        case 'blogpost':
            return id.split(':blogpost/')[1];
        case 'attachment':
            return id.split(':attachment/')[1];
        case 'space':
            return id.split(':space/')[1];
        case 'whiteboard':
            return id.split(':whiteboard/')[1];
        case 'embed':
            // embed ari url contains activation id so we split it differently here
            const embedAri = id.split('/');
            return embedAri[embedAri.length - 1];
        case 'database':
            // Databases ari url contains activation id so we split it differently here
            const databaseAri = id.split('/');
            return databaseAri[databaseAri.length - 1];
        default:
            return id;
    }
};

});


parcelRegister("ktwn8", function(module, exports) {

$parcel$export(module.exports, "quickFindConfluenceContentMapper", () => $df95e20809de4e37$export$6a180a233e580286);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $8PrAH = parcelRequire("8PrAH");

var $lNtmT = parcelRequire("lNtmT");

var $kOyOy = parcelRequire("kOyOy");

var $DuEDb = parcelRequire("DuEDb");
const $df95e20809de4e37$export$6a180a233e580286 = ({ node: item })=>{
    return {
        ari: item?.id,
        id: (0, $lNtmT.transformAriToId)(item?.id || '', item?.type || ''),
        title: item?.title || '',
        url: item?.url || '',
        meta: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kOyOy.ConfluenceResultMeta), {
            resultContentType: item?.type || '',
            resultAncestors: item?.confluenceEntity?.ancestors,
            resultSpace: item?.space
        }),
        additionalMeta: item?.lastModified ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $DuEDb.EventTypeMessage), {
            timestamp: item.lastModified,
            eventType: (0, $DuEDb.WORKED_EVENT).UPDATED,
            isMyActivityData: false
        }) : '',
        containerId: (0, $lNtmT.transformAriToId)(item?.space?.id || 'UNAVAILABLE', 'space'),
        type: `confluence ${item?.type}` || '',
        icon: (0, $8PrAH.ContentIconRenderer)({
            type: item?.type || '',
            title: item?.title
        })
    };
};

});

parcelRegister("5yZy1", function(module, exports) {

$parcel$export(module.exports, "quickFindAtlasContentMapper", () => $d6ae9f5288c13a0d$export$92506b66b43d2a63);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7jIfa = parcelRequire("7jIfa");

var $lNtmT = parcelRequire("lNtmT");

var $gj7hi = parcelRequire("gj7hi");

var $j7mwp = parcelRequire("j7mwp");
const $d6ae9f5288c13a0d$var$getIcon = (result)=>{
    return result?.iconUrl ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
        height: 24,
        width: 24,
        title: result.type,
        src: result.iconUrl
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $d6ae9f5288c13a0d$var$getKey = (item)=>{
    if ((0, $7jIfa.isSearchResultAtlasProjectPartial)(item)) return item.project?.key;
    else if ((0, $7jIfa.isSearchResultAtlasGoalPartial)(item)) return item.goal?.key;
    else return null;
};
const $d6ae9f5288c13a0d$var$getTitle = (item)=>{
    if (!item) return '';
    let entityKey = $d6ae9f5288c13a0d$var$getKey(item);
    if (entityKey) return `${entityKey}: ${item.title || ''}`;
    return item.title || '';
};
const $d6ae9f5288c13a0d$export$92506b66b43d2a63 = ({ node: item })=>{
    return {
        id: (0, $lNtmT.transformAriToId)(item?.id || '', item?.type || ''),
        title: $d6ae9f5288c13a0d$var$getTitle(item),
        url: item?.url || '',
        meta: (0, $j7mwp.capitalizeFirstLetter)(item?.type || ''),
        additionalMeta: '',
        containerId: '',
        type: `atlas ${item?.type}` || '',
        icon: $d6ae9f5288c13a0d$var$getIcon(item)
    };
};

});

parcelRegister("bK7ak", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $493c216466d2aa05$export$b37ee0d76c6d2fbc);

var $UNGcJ = parcelRequire("UNGcJ");

var $2OcMi = parcelRequire("2OcMi");

var $2ZIpG = parcelRequire("2ZIpG");
const $493c216466d2aa05$export$b37ee0d76c6d2fbc = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    return (url, searchSessionId, type, resultId, additionalAnalytics)=>{
        // legacy QF/QS have different types/have confluence prefixed or not
        return (0, $UNGcJ.transformAnalyticsToQueryParam)({
            query: query,
            url: url,
            searchSessionId: searchSessionId,
            additionalAnalytics: additionalAnalytics,
            resultId: resultId,
            type: type,
            addQueryParams: $2OcMi.addQueryParams,
            addQuery: $2OcMi.addQuery
        });
    };
};

});
parcelRegister("UNGcJ", function(module, exports) {

$parcel$export(module.exports, "transformAnalyticsToQueryParam", () => $bced069a163eb3f4$export$f9c120c22694d7aa);

var $aU479 = parcelRequire("aU479");

var $7H6GR = parcelRequire("7H6GR");
const $bced069a163eb3f4$export$f9c120c22694d7aa = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics, resultId: resultId, addQueryParams: addQueryParams, addQuery: addQuery, type: type })=>{
    const isConfluenceContent = typeof resultId === 'string' && resultId.includes('confluence') || typeof type === 'string' && [
        'confluence page',
        'confluence blogpost',
        'confluence space',
        'confluence attachment',
        'confluence whiteboard'
    ].some((contentType)=>contentType.includes(type));
    const hasAdditionalAnalytics = typeof additionalAnalytics === 'object' && Object.keys(additionalAnalytics).length > 0;
    if (!isConfluenceContent || !(query || hasAdditionalAnalytics)) return addQuery(url, 'search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${(0, $7H6GR.valueSeparator)}${(0, $aU479.hashData)(query)}`);
    if (hasAdditionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${(0, $7H6GR.valueSeparator)}${value}`);
    });
    if (events.length === 0) return addQuery(url, 'search_id', searchSessionId);
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join((0, $7H6GR.attributeSeparator)));
    return addQueryParams(url, {
        search_id: searchSessionId,
        additional_analytics: analyticsFormattedForUrlParsing
    });
};

});



parcelRegister("6kOEz", function(module, exports) {

$parcel$export(module.exports, "CommandIcon", () => $7193e24f5ddd050a$export$76bfbab5e3f9a6a3);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $7193e24f5ddd050a$export$76bfbab5e3f9a6a3 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.89453 8.89551H6.88965C5.80957 8.89551 4.93457 8.04785 4.93457 6.96094C4.93457 5.87402 5.80957 4.99902 6.88965 4.99902C7.96973 4.99902 8.84473 5.87402 8.84473 6.96094V7.95898H11.1553V6.96094C11.1553 5.87402 12.0303 4.99902 13.1104 4.99902C14.1904 4.99902 15.0654 5.87402 15.0654 6.96094C15.0654 8.04785 14.1904 8.89551 13.1104 8.89551H12.1123V11.2402H13.1104C14.1904 11.2402 15.0654 12.0879 15.0654 13.1748C15.0654 14.2617 14.1904 15.1367 13.1104 15.1367C12.0303 15.1367 11.1553 14.2617 11.1553 13.1748V12.1768H8.84473V13.1748C8.84473 14.2617 7.96973 15.1367 6.88965 15.1367C5.80957 15.1367 4.93457 14.2617 4.93457 13.1748C4.93457 12.0879 5.80957 11.2402 6.88965 11.2402H7.89453V8.89551ZM6.88965 7.97266H7.89453V6.96094C7.89453 6.40723 7.43652 5.95605 6.88965 5.95605C6.34277 5.95605 5.88477 6.40723 5.88477 6.96094C5.88477 7.51465 6.34277 7.97266 6.88965 7.97266ZM13.1104 7.97266C13.6572 7.97266 14.1152 7.51465 14.1152 6.96094C14.1152 6.40723 13.6572 5.95605 13.1104 5.95605C12.5635 5.95605 12.1123 6.40723 12.1123 6.96094V7.97266H13.1104ZM8.84473 11.2539H11.1553V8.88184H8.84473V11.2539ZM6.88965 12.1562C6.34277 12.1562 5.88477 12.6143 5.88477 13.168C5.88477 13.7217 6.34277 14.1729 6.88965 14.1729C7.43652 14.1729 7.89453 13.7217 7.89453 13.168V12.1562H6.88965ZM13.1104 12.1562H12.1123V13.168C12.1123 13.7217 12.5635 14.1729 13.1104 14.1729C13.6572 14.1729 14.1152 13.7217 14.1152 13.168C14.1152 12.6143 13.6572 12.1562 13.1104 12.1562Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});

parcelRegister("hFUff", function(module, exports) {

$parcel$export(module.exports, "ControlIcon", () => $d8b813963b40dde9$export$1de95e9d7dda5112);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $d8b813963b40dde9$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    height: '20px',
    borderRadius: 'border.radius.050',
    border: '1px solid transparent',
    color: 'color.text.subtle',
    font: 'font.body.small',
    display: 'flex',
    alignItems: 'center',
    paddingInline: 'space.050',
    paddingBlock: '0'
});
const $d8b813963b40dde9$export$1de95e9d7dda5112 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $d8b813963b40dde9$var$iconStyles,
        children: "Ctrl"
    });

});

parcelRegister("5uL5H", function(module, exports) {

$parcel$export(module.exports, "SquareReturnIcon", () => $d6b1539a23a3e88d$export$4501fc029b186da8);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $d6b1539a23a3e88d$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });

});


parcelRegister("fjD79", function(module, exports) {

$parcel$export(module.exports, "getDefaultAtlasBaseURL", () => $1f7067aa44298f63$export$b182d98f245a5298);
$parcel$export(module.exports, "createProfileLink", () => $1f7067aa44298f63$export$5b4f9e589794eb96);
$parcel$export(module.exports, "createTeamProfileLink", () => $1f7067aa44298f63$export$a1c75f05b6ef3ec6);
$parcel$export(module.exports, "default", () => $1f7067aa44298f63$export$2e2bcd8739ae039);
const $1f7067aa44298f63$export$b182d98f245a5298 = (isGlobalExperienceWorkspace)=>{
    const hostname = window.location.hostname;
    const subdomain = isGlobalExperienceWorkspace ? 'home' : 'team';
    if (hostname.includes('jira-dev.com') || hostname.includes('.stg.atlassian.') || hostname.startsWith('localhost')) return `https://${subdomain}.stg.atlassian.com`;
    return `https://${subdomain}.atlassian.com`;
};
const $1f7067aa44298f63$export$4c191d74745f6ab1 = (entityId, path, isGlobalExperienceWorkspace, orgId)=>{
    const baseUrl = $1f7067aa44298f63$export$b182d98f245a5298(isGlobalExperienceWorkspace);
    if (isGlobalExperienceWorkspace && orgId) return `${baseUrl}/o/${orgId}/${path}/${entityId}`;
    return `${baseUrl}/${path}/${entityId}`;
};
const $1f7067aa44298f63$export$5b4f9e589794eb96 = (accountId, isGlobalExperienceWorkspace, orgId)=>$1f7067aa44298f63$export$4c191d74745f6ab1(accountId, 'people', isGlobalExperienceWorkspace, orgId);
const $1f7067aa44298f63$export$a1c75f05b6ef3ec6 = (teamId, isGlobalExperienceWorkspace, orgId)=>$1f7067aa44298f63$export$4c191d74745f6ab1(teamId, 'people/team', isGlobalExperienceWorkspace, orgId);
const $1f7067aa44298f63$var$getAtlasViewAllRedirectUrl = (entity, searchText, workspaces, isGlobalExperienceWorkspace, orgId)=>{
    let url;
    if (workspaces && workspaces.length === 1 && /team\.(stg\.)?atlassian\.com/.test(workspaces[0].baseUrl)) url = new URL(workspaces[0].baseUrl);
    else url = new URL($1f7067aa44298f63$export$b182d98f245a5298(isGlobalExperienceWorkspace));
    const pathPrefix = isGlobalExperienceWorkspace && orgId ? `o/${orgId}/` : '';
    url.pathname = `${pathPrefix}action/search/${entity}`;
    url.searchParams.append('searchText', searchText);
    return url.href;
};
var $1f7067aa44298f63$export$2e2bcd8739ae039 = $1f7067aa44298f63$var$getAtlasViewAllRedirectUrl;

});

parcelRegister("9BAfc", function(module, exports) {

$parcel$export(module.exports, "GoogleDriveIcon", () => $5b5eba0a2aeb65d3$export$e16bd899bb4eebf9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $5b5eba0a2aeb65d3$var$iconStyles = (0, $ecnYn.xcss)({
    width: '22px',
    height: '22px'
});
const $5b5eba0a2aeb65d3$export$e16bd899bb4eebf9 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $5b5eba0a2aeb65d3$var$iconStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    x: "0.618757",
                    y: "0.618757",
                    width: "20.7625",
                    height: "20.7625",
                    rx: "4.38124",
                    stroke: "#0B1228",
                    strokeOpacity: "0.14",
                    strokeWidth: "0.762486"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip0_931_182)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M4.20962 16.0782L4.91523 17.2907C5.06186 17.546 5.27262 17.7466 5.52005 17.8925L8.04009 13.5529H3C3 13.8355 3.07331 14.1181 3.21993 14.3734L4.20962 16.0782Z",
                            fill: "#0066DA"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M11 8.44751L8.47995 4.10791C8.23253 4.25378 8.02176 4.45435 7.87514 4.70962L3.21993 12.7324C3.07601 12.9822 3.00019 13.265 3 13.5529H8.04009L11 8.44751Z",
                            fill: "#00AC47"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M16.4799 17.8925C16.7273 17.7466 16.9381 17.546 17.0847 17.2907L17.3779 16.7893L18.78 14.3734C18.9266 14.1181 18.9999 13.8355 18.9999 13.5529H13.9595L15.032 15.6497L16.4799 17.8925Z",
                            fill: "#EA4335"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M11 8.4475L13.5201 4.1079C13.2726 3.96203 12.9886 3.8891 12.6953 3.8891H9.30472C9.01148 3.8891 8.7274 3.97115 8.47998 4.1079L11 8.4475Z",
                            fill: "#00832D"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M13.9594 13.5529H8.03958L5.51953 17.8925C5.76695 18.0383 6.05103 18.1113 6.34427 18.1113H15.6547C15.9479 18.1113 16.232 18.0292 16.4794 17.8925L13.9594 13.5529Z",
                            fill: "#2684FC"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M16.4525 8.72101L14.1249 4.70962C13.9782 4.45435 13.7675 4.25378 13.52 4.10791L11 8.44751L13.9599 13.5529H18.9908C18.9908 13.2703 18.9175 12.9877 18.7709 12.7324L16.4525 8.72101Z",
                            fill: "#FFBA00"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_931_182",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "16",
                            height: "14.2222",
                            fill: "white",
                            transform: "translate(3 3.88904)"
                        })
                    })
                })
            ]
        })
    });

});

parcelRegister("4I873", function(module, exports) {

$parcel$export(module.exports, "SlackIcon", () => $a12b4f39323b4c5d$export$b33fb54b08bb6422);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $a12b4f39323b4c5d$var$iconStyles = (0, $ecnYn.xcss)({
    width: '22px',
    height: '22px'
});
const $a12b4f39323b4c5d$export$b33fb54b08bb6422 = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $a12b4f39323b4c5d$var$iconStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    x: "1",
                    y: "1",
                    width: "20",
                    height: "20",
                    rx: "4",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                    x: "0.5",
                    y: "0.5",
                    width: "21",
                    height: "21",
                    rx: "4.5",
                    stroke: "#0B1228",
                    strokeOpacity: "0.14"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip0_931_190)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M6.99813 12.8186C6.99813 13.6234 6.34773 14.2738 5.54301 14.2738C4.73828 14.2738 4.08789 13.6234 4.08789 12.8186C4.08789 12.0139 4.73828 11.3635 5.54301 11.3635H6.99813V12.8186ZM7.72569 12.8186C7.72569 12.0139 8.37608 11.3635 9.1808 11.3635C9.98553 11.3635 10.6359 12.0139 10.6359 12.8186V16.4564C10.6359 17.2612 9.98553 17.9116 9.1808 17.9116C8.37608 17.9116 7.72569 17.2612 7.72569 16.4564V12.8186Z",
                            fill: "#E01E5A"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M9.18109 6.97615C8.37636 6.97615 7.72597 6.32576 7.72597 5.52104C7.72597 4.71631 8.37636 4.06592 9.18109 4.06592C9.98581 4.06592 10.6362 4.71631 10.6362 5.52104V6.97615H9.18109ZM9.18109 7.71474C9.98581 7.71474 10.6362 8.36513 10.6362 9.16986C10.6362 9.97458 9.98581 10.625 9.18109 10.625H5.53227C4.72754 10.625 4.07715 9.97458 4.07715 9.16986C4.07715 8.36513 4.72754 7.71474 5.53227 7.71474H9.18109Z",
                            fill: "#36C5F0"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M15.0123 9.16986C15.0123 8.36513 15.6627 7.71474 16.4674 7.71474C17.2721 7.71474 17.9225 8.36513 17.9225 9.16986C17.9225 9.97458 17.2721 10.625 16.4674 10.625H15.0123V9.16986ZM14.2847 9.16986C14.2847 9.97458 13.6344 10.625 12.8296 10.625C12.0249 10.625 11.3745 9.97458 11.3745 9.16986V5.52104C11.3745 4.71631 12.0249 4.06592 12.8296 4.06592C13.6344 4.06592 14.2847 4.71631 14.2847 5.52104V9.16986Z",
                            fill: "#2EB67D"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M12.8296 15.0013C13.6344 15.0013 14.2847 15.6517 14.2847 16.4564C14.2847 17.2612 13.6344 17.9116 12.8296 17.9116C12.0249 17.9116 11.3745 17.2612 11.3745 16.4564V15.0013H12.8296ZM12.8296 14.2738C12.0249 14.2738 11.3745 13.6234 11.3745 12.8186C11.3745 12.0139 12.0249 11.3635 12.8296 11.3635H16.4784C17.2832 11.3635 17.9336 12.0139 17.9336 12.8186C17.9336 13.6234 17.2832 14.2738 16.4784 14.2738H12.8296Z",
                            fill: "#ECB22E"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_931_190",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "14",
                            height: "14",
                            fill: "white",
                            transform: "translate(4 3.99988)"
                        })
                    })
                })
            ]
        })
    });

});



parcelRegister("5wbh9", function(module, exports) {

$parcel$export(module.exports, "CompassTab", () => $c70e830949a8116b$export$47b1e713578cc03f);

var $7UHDa = parcelRequire("7UHDa");

var $dh538 = parcelRequire("dh538");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $crAJ1 = parcelRequire("crAJ1");

var $4V3UW = parcelRequire("4V3UW");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $jFPud = parcelRequire("jFPud");

var $2Mbeb = parcelRequire("2Mbeb");

var $cTEvB = parcelRequire("cTEvB");

var $elGZM = parcelRequire("elGZM");

var $cLKdA = parcelRequire("cLKdA");

var $6ihFa = parcelRequire("6ihFa");

var $48qR7 = parcelRequire("48qR7");

var $iEwUU = parcelRequire("iEwUU");

var $eztGN = parcelRequire("eztGN");

var $3Z7LN = parcelRequire("3Z7LN");

var $kmpep = parcelRequire("kmpep");

const $c70e830949a8116b$var$UpsellModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("2Ecsl")).then((mod)=>({
            default: mod.UpsellModal
        })));
/**
 * Callback function to be used by PSD's permission supplier.
 * @returns all Compass scope required for Compass tab to function properly.
 */ const $c70e830949a8116b$var$upsellPermissionSupplier = ()=>{
    const response = Object.values((0, $cLKdA.CompassScope));
    return Promise.resolve(response);
};
const $c70e830949a8116b$var$CompassTabWithIntl = ({ baseUrl: baseUrl, crossFlowEnabled: crossFlowEnabled, intl: intl, isCompassActivated: isCompassActivated = false, isUserAnonymous: isUserAnonymous = false, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, sourceContext: sourceContext, upsellCtaButtonProps: upsellCtaButtonProps, userTeamConfig: userTeamConfig, ...rest })=>{
    const { advancedSearchLinkGenerator: advancedSearchLinkGenerator } = (0, $gwFzn.useMemo)(()=>{
        return (0, $48qR7.compassURLGenerators)(baseUrl);
    }, [
        baseUrl
    ]);
    const sections = (0, $cTEvB.getSections)(intl);
    const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, $elGZM.useCompassSuppliers)({
        userTeamConfig: userTeamConfig,
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    }, sections);
    const getAdvancedSearchButtonLabel = (0, $gwFzn.useCallback)((productState)=>{
        switch(productState){
            case (0, $jFPud.ProductStates).PreQueryLoading:
            case (0, $jFPud.ProductStates).PreQuerySuccess:
            case (0, $jFPud.ProductStates).PreQueryError:
            case (0, $jFPud.ProductStates).PreQueryNoResult:
                return intl.formatMessage((0, $2Mbeb.messages).compass_view_all_components);
            default:
                return intl.formatMessage((0, $2Mbeb.messages).compass_view_all_results);
        }
    }, [
        intl
    ]);
    const upsellTabRenderer = (0, $gwFzn.useCallback)(({ title: title })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6ihFa.UpsellTab), {
            title: title
        });
    }, []);
    const shouldUpsell = !isUserAnonymous && crossFlowEnabled && !isCompassActivated;
    const permissionSupplier = shouldUpsell ? $c70e830949a8116b$var$upsellPermissionSupplier : rest.permissionSupplier;
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return advancedSearchLinkGenerator(query);
    }, [
        advancedSearchLinkGenerator,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $elGZM.COMPASS_PRODUCT_ID),
        sections: sections,
        title: intl.formatMessage((0, $2Mbeb.messages).compass_tab_label),
        expandedStateInputPlaceholder: intl.formatMessage((0, $2Mbeb.messages).compass_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        tabRenderer: !(0, $dh538.fg)('jira_remove_new_lozenge_from_compass_search_tab') && shouldUpsell ? upsellTabRenderer : undefined,
        permissionSupplier: permissionSupplier,
        ...rest,
        children: ({ linkComponent: linkComponent, productState: productState, query: query })=>{
            if (shouldUpsell) return {
                Body: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($c70e830949a8116b$var$UpsellModal, {
                        sourceContext: sourceContext ?? 'product search dialog',
                        ctaButtonProps: upsellCtaButtonProps
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {})
            };
            const advancedSearchUrl = advancedSearchLinkGenerator(query);
            const message = getAdvancedSearchButtonLabel(productState);
            return {
                Header: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4V3UW.AdvancedSearch), {
                        advancedSearchMessage: message,
                        advancedSearchUrl: advancedSearchUrl,
                        linkComponent: linkComponent
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $c70e830949a8116b$export$47b1e713578cc03f = (0, $js7oX.default)($c70e830949a8116b$var$CompassTabWithIntl);

});
parcelRegister("2Mbeb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c4131fa39bec30c7$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $c4131fa39bec30c7$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Compass
   */ compass_tab_label: {
        id: "product_search_dialog.compass.tab_label",
        defaultMessage: "Compass"
    },
    compass_components_section_heading: {
        id: "product_search_dialog.compass.components_section_heading",
        defaultMessage: "Components"
    },
    compass_people_section_heading: {
        id: "product_search_dialog.compass.people_section_heading",
        defaultMessage: "People"
    },
    compass_teams_section_heading: {
        id: "product_search_dialog.compass.teams_section_heading",
        defaultMessage: "Teams"
    },
    compass_endpoints_section_heading: {
        id: "product_search_dialog.compass.endpoints_section_heading",
        defaultMessage: "Endpoints"
    },
    compass_expanded_input_placeholder: {
        id: "product_search_dialog.compass.expanded.input-placeholder",
        defaultMessage: "Search Compass"
    },
    compass_view_all_components: {
        id: "product_search_dialog.compass.view_all_components_label",
        defaultMessage: "View all components"
    },
    compass_view_all_results: {
        id: "product_search_dialog.compass.view_all_results_label",
        defaultMessage: "View all results"
    },
    compass_component_type_service: {
        id: "product_search_dialog.compass.component_type.service",
        defaultMessage: "Service"
    },
    compass_component_type_library: {
        id: "product_search_dialog.compass.component_type.library",
        defaultMessage: "Library"
    },
    compass_component_type_application: {
        id: "product_search_dialog.compass.component_type.application",
        defaultMessage: "Application"
    },
    compass_component_type_capability: {
        id: "product_search_dialog.compass.component_type.capability",
        defaultMessage: "Capability"
    },
    compass_component_type_cloud_resource: {
        id: "product_search_dialog.compass.component_type.cloud_resource",
        defaultMessage: "Cloud resource"
    },
    compass_component_type_data_pipeline: {
        id: "product_search_dialog.compass.component_type.data_pipeline",
        defaultMessage: "Data pipeline"
    },
    compass_component_type_machine_learning_model: {
        id: "product_search_dialog.compass.component_type.machine_learning_model",
        defaultMessage: "Machine learning model"
    },
    compass_component_type_ui_element: {
        id: "product_search_dialog.compass.component_type.ui_element",
        defaultMessage: "UI element"
    },
    compass_component_type_website: {
        id: "product_search_dialog.compass.component_type.website",
        defaultMessage: "Website"
    },
    compass_component_type_other: {
        id: "product_search_dialog.compass.component_type.other",
        defaultMessage: "Other"
    },
    compass_recently_viewed_components: {
        id: "product_search_dialog.compass.recently_viewed_components",
        defaultMessage: "Recently viewed components"
    },
    compass_recently_viewed_teams: {
        id: "product_search_dialog.compass.recently_viewed_teams",
        defaultMessage: "Recently viewed teams"
    },
    compass_recently_viewed_endpoints: {
        id: "product_search_dialog.compass.recently_viewed_endpoints",
        defaultMessage: "Recently viewed endpoints"
    }
});

});

parcelRegister("cTEvB", function(module, exports) {

$parcel$export(module.exports, "getSections", () => $cf8641474df1decd$export$ddbcae0b0bd6b092);

var $2Mbeb = parcelRequire("2Mbeb");

var $ar4gF = parcelRequire("ar4gF");

var $cLKdA = parcelRequire("cLKdA");
const $cf8641474df1decd$var$mapComponentAggregatorResponseToSearchItem = (response)=>({
        title: response.title,
        id: response.id,
        meta: response.ownerId,
        url: response.url,
        icon: response.type,
        containerId: '' // no container
    });
const $cf8641474df1decd$var$mapApiEndpointAggregatorResponseToSearchItem = (response)=>({
        title: response.title,
        id: response.id,
        url: response.url,
        icon: response.url.split('/').pop()?.split('.')[0] || '',
        meta: ''
    });
const $cf8641474df1decd$export$ddbcae0b0bd6b092 = (intl)=>{
    const sections = [
        {
            id: (0, $cLKdA.CompassScope).Component,
            title: intl.formatMessage((0, $2Mbeb.messages).compass_components_section_heading),
            scope: (0, $cLKdA.CompassScope).Component,
            showResultCount: true,
            resultRenderer: (0, $ar4gF.componentResultRenderer),
            resultMapper: ({ results: results })=>results.map((value)=>$cf8641474df1decd$var$mapComponentAggregatorResponseToSearchItem(value))
        },
        {
            id: (0, $cLKdA.CompassScope).ApiEndpoint,
            title: intl.formatMessage((0, $2Mbeb.messages).compass_endpoints_section_heading),
            scope: (0, $cLKdA.CompassScope).ApiEndpoint,
            showResultCount: true,
            resultRenderer: (0, $ar4gF.endpointResultRenderer),
            resultLimit: 5,
            resultMapper: ({ results: results })=>results.map((value)=>$cf8641474df1decd$var$mapApiEndpointAggregatorResponseToSearchItem(value))
        }
    ];
    return sections;
};

});
parcelRegister("ar4gF", function(module, exports) {

$parcel$export(module.exports, "componentResultRenderer", () => $fe2b6b1b287be335$export$f2eed8836fc2639e);
$parcel$export(module.exports, "peopleAndTeamsResultRenderer", () => $fe2b6b1b287be335$export$3269347603d2224e);
$parcel$export(module.exports, "endpointResultRenderer", () => $fe2b6b1b287be335$export$2db93eff9b2b2c36);
/* result-renderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $ho4zm = parcelRequire("ho4zm");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");

var $3gadb = parcelRequire("3gadb");

var $gnG2x = parcelRequire("gnG2x");

var $9Qum6 = parcelRequire("9Qum6");

var $ejGzS = parcelRequire("ejGzS");

var $jFPud = parcelRequire("jFPud");

var $787Pb = parcelRequire("787Pb");
const $fe2b6b1b287be335$export$f2eed8836fc2639e = (args)=>{
    const { productState: productState, searchResult: searchResult } = args;
    const iconSize = productState === (0, $jFPud.ProductStates).PreQuerySuccess ? 'small' : 'medium';
    const iconType = searchResult.icon?.toString() ?? '';
    return (0, $ejGzS.defaultResultRenderer)({
        ...args,
        searchResult: {
            ...searchResult,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $787Pb.ResultIcon), {
                type: iconType,
                size: iconSize
            })
        }
    });
};
const $fe2b6b1b287be335$export$3269347603d2224e = (args)=>{
    const { productState: productState, searchResult: searchResult } = args;
    const iconSize = productState === (0, $jFPud.ProductStates).PreQuerySuccess ? 'xsmall' : 'small';
    return (0, $ejGzS.defaultResultRenderer)({
        ...args,
        searchResult: {
            ...searchResult,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Qum6.ResultAvatar), {
                borderColor: "transparent",
                src: searchResult.iconUrl,
                appearance: "square",
                size: iconSize,
                testId: "result-avatar"
            })
        }
    });
};
const $fe2b6b1b287be335$var$MethodDetails = {
    POST: {
        abbreviation: 'POST',
        color: 'purpleLight'
    },
    GET: {
        abbreviation: 'GET',
        color: 'greenLight'
    },
    PUT: {
        abbreviation: 'PUT',
        color: 'blueLight'
    },
    DELETE: {
        abbreviation: 'DEL',
        color: 'redLight'
    },
    PATCH: {
        abbreviation: 'PATCH',
        color: 'greyLight'
    },
    OPTIONS: {
        abbreviation: 'OPT',
        color: 'greyLight'
    },
    HEAD: {
        abbreviation: 'HEAD',
        color: 'greyLight'
    },
    TRACE: {
        abbreviation: 'TRACE',
        color: 'greyLight'
    },
    CONNECT: {
        abbreviation: 'CONN',
        color: 'greyLight'
    }
};
const $fe2b6b1b287be335$var$styles = {
    methodTag: "_18u0r5cr"
};
const $fe2b6b1b287be335$export$2db93eff9b2b2c36 = (args)=>{
    const { searchResult: searchResult } = args;
    const method = (typeof searchResult.icon === 'string' ? searchResult.icon : '').toUpperCase();
    const methodDetails = $fe2b6b1b287be335$var$MethodDetails[method];
    const methodTag = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $fe2b6b1b287be335$var$styles.methodTag,
        children: methodDetails ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: methodDetails.abbreviation,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ho4zm.default), {
                text: methodDetails.abbreviation,
                color: methodDetails.color
            })
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: 'OTHER',
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ho4zm.default), {
                text: 'OTHER',
                color: "greyLight"
            })
        })
    });
    const title = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        paddingInlineStart: "space.300",
        children: searchResult.title
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gnG2x.SearchResultContent), {
        isKeyboardHighlighted: args.isKeyboardHighlighted,
        title: title,
        icon: methodTag,
        isCollapsed: args.isCollapsed,
        meta: searchResult.meta
    }, `item_${searchResult.id}`);
};

});
parcelRegister("787Pb", function(module, exports) {

$parcel$export(module.exports, "ResultIcon", () => $191b99a422a86faf$export$e8ec4da10aa3e6a6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $id7ja = parcelRequire("id7ja");

var $3gadb = parcelRequire("3gadb");

var $cLKdA = parcelRequire("cLKdA");

var $jm8C7 = parcelRequire("jm8C7");
const $191b99a422a86faf$export$e8ec4da10aa3e6a6 = ({ type: type, size: size = 'medium' })=>{
    const intl = (0, $dBxQj.default)();
    const componentType = (0, $cLKdA.COMPONENT_TYPES)[type] ?? (0, $cLKdA.COMPONENT_TYPES).OTHER;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: intl.formatMessage(componentType.message),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jm8C7.IconBackground), {
            color: componentType.color,
            size: size,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
                label: type,
                glyph: componentType.icon,
                size: size
            })
        })
    });
};

});
parcelRegister("cLKdA", function(module, exports) {

$parcel$export(module.exports, "CompassScope", () => $ea55797a819afe35$export$7dfd429914c57d74);
$parcel$export(module.exports, "COMPONENT_TYPES", () => $ea55797a819afe35$export$6349b6efda58d149);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");

var $2Mbeb = parcelRequire("2Mbeb");
var $ea55797a819afe35$export$7dfd429914c57d74 = /*#__PURE__*/ function(CompassScope) {
    CompassScope["Component"] = "compass.component";
    CompassScope["People"] = "compass.people";
    CompassScope["Teams"] = "compass.teams";
    CompassScope["ApiEndpoint"] = "compass.api-endpoint";
    return CompassScope;
}({});
const $ea55797a819afe35$export$6349b6efda58d149 = {
    SERVICE: {
        color: `var(--ds-icon, ${$6fnsQ.P300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.714 5a1.286 1.286 0 1 0 0 2.571 1.286 1.286 0 0 0 0-2.571Zm-3.143.327A3.287 3.287 0 0 1 21 6.286a3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.042h-1.72L9.738 12l2.828 4.714h1.72a1 1 0 0 1 .285.041 3.287 3.287 0 0 1 6.429.96 3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.041H12a1 1 0 0 1-.857-.485L8.005 13H4a1 1 0 0 1 0-2h4.005l3.137-5.229A1 1 0 0 1 12 5.286h2.286a1 1 0 0 1 .285.04Zm3.143 11.101a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_service
    },
    LIBRARY: {
        color: `var(--ds-icon, ${$6fnsQ.Y500})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.21667 5C5.80834 5 4.66667 6.14167 4.66667 7.55V11H4.05C3.4701 11 3 11.4701 3 12.05C3 12.6299 3.4701 13.1 4.05 13.1H4.66667V16.55C4.66667 17.9583 5.80834 19.1 7.21667 19.1H9.05C9.6299 19.1 10.1 18.6299 10.1 18.05C10.1 17.4701 9.6299 17 9.05 17H7.21667C6.96814 17 6.76667 16.7985 6.76667 16.55V12.05V7.55C6.76667 7.30147 6.96814 7.1 7.21667 7.1H9.05C9.6299 7.1 10.1 6.6299 10.1 6.05C10.1 5.4701 9.6299 5 9.05 5H7.21667ZM16.8833 19.1C18.2917 19.1 19.4333 17.9583 19.4333 16.55V13.1H20.05C20.6299 13.1 21.1 12.6299 21.1 12.05C21.1 11.4701 20.6299 11 20.05 11H19.4333V7.55C19.4333 6.14167 18.2917 5 16.8833 5L15.05 5C14.4701 5 14 5.4701 14 6.05C14 6.6299 14.4701 7.1 15.05 7.1L16.8833 7.1C17.1319 7.1 17.3333 7.30147 17.3333 7.55V12.05L17.3333 16.55C17.3333 16.7985 17.1319 17 16.8833 17H15.05C14.4701 17 14 17.4701 14 18.05C14 18.6299 14.4701 19.1 15.05 19.1H16.8833Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_library
    },
    APPLICATION: {
        color: `var(--ds-icon, ${$6fnsQ.G300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.57 3.105a1 1 0 0 1 .894.001l3.985 2A1 1 0 0 1 17 6v4.375l3.449 1.731A1 1 0 0 1 21 13v5a1 1 0 0 1-.553.895l-4.004 2a1 1 0 0 1-.894 0l-3.55-1.777-3.556 1.777a1 1 0 0 1-.894 0l-3.997-2A1 1 0 0 1 3 18v-5a1 1 0 0 1 .554-.895L7 10.389V6a1 1 0 0 1 .554-.895l4.016-2Zm-3.563 9.017L5 13.619v3.763l2.997 1.5 3.003-1.5V13.62l-2.993-1.498ZM13 13.619v3.763l2.996 1.5 3.004-1.5v-3.765l-2.986-1.499L13 13.619Zm2-3.237V6.617l-2.986-1.499L9 6.619v3.756l3 1.506 3-1.5Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_application
    },
    CAPABILITY: {
        color: `var(--ds-icon, ${$6fnsQ.N600})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.5145 6.15717C10.5145 6.97758 11.1796 7.64266 12 7.64266C12.8204 7.64266 13.4855 6.97758 13.4855 6.15717C13.4855 5.33676 12.8204 4.67168 12 4.67168C11.1796 4.67168 10.5145 5.33676 10.5145 6.15717ZM11.15 9.22799C10.8953 9.15765 10.6534 9.05647 10.4286 8.92873L8.93348 10.426C9.19656 10.8894 9.34679 11.4253 9.34679 11.9963C9.34679 13.7556 7.9206 15.1818 6.1613 15.1818C4.40201 15.1818 2.97581 13.7556 2.97581 11.9963C2.97581 10.237 4.40201 8.81083 6.1613 8.81083C6.73217 8.81083 7.26796 8.96099 7.73134 9.22398L9.22707 7.72612C8.96447 7.263 8.81454 6.72759 8.81454 6.15717C8.81454 4.39787 10.2407 2.97168 12 2.97168C13.7593 2.97168 15.1855 4.39787 15.1855 6.15717C15.1855 6.72831 15.0352 7.26434 14.772 7.72787L16.2683 9.22419C16.7318 8.96107 17.2677 8.81083 17.8387 8.81083C19.598 8.81083 21.0242 10.237 21.0242 11.9963C21.0242 13.7556 19.598 15.1818 17.8387 15.1818C16.0794 15.1818 14.6532 13.7556 14.6532 11.9963C14.6532 11.4255 14.8034 10.8897 15.0663 10.4264L13.5697 8.92972C13.3453 9.057 13.104 9.15784 12.85 9.228V14.7646C14.1966 15.1366 15.1855 16.3705 15.1855 17.8355C15.1855 19.5948 13.7593 21.021 12 21.021C10.2407 21.021 8.81454 19.5948 8.81454 17.8355C8.81454 16.3705 9.80338 15.1366 11.15 14.7646V9.22799ZM4.67581 11.9963C4.67581 12.8167 5.34089 13.4818 6.1613 13.4818C6.98172 13.4818 7.64679 12.8167 7.64679 11.9963C7.64679 11.1759 6.98172 10.5108 6.1613 10.5108C5.34089 10.5108 4.67581 11.1759 4.67581 11.9963ZM12 19.321C11.1796 19.321 10.5145 18.6559 10.5145 17.8355C10.5145 17.0151 11.1796 16.35 12 16.35C12.8204 16.35 13.4855 17.0151 13.4855 17.8355C13.4855 18.6559 12.8204 19.321 12 19.321ZM16.3532 11.9963C16.3532 12.8167 17.0183 13.4818 17.8387 13.4818C18.6591 13.4818 19.3242 12.8167 19.3242 11.9963C19.3242 11.1759 18.6591 10.5108 17.8387 10.5108C17.0183 10.5108 16.3532 11.1759 16.3532 11.9963Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_capability
    },
    CLOUD_RESOURCE: {
        color: `var(--ds-icon, ${$6fnsQ.P300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M6.07585 10.4798C4.70269 10.7573 3.66883 11.9708 3.66883 13.4258C3.66883 15.0857 4.83719 16.4314 6.49712 16.4314M16.6409 16.4314C18.9648 16.4314 20.5 14.5475 20.5 12.2236C20.5 9.89967 18.6161 8.01578 16.2922 8.01578C15.8909 8.01578 15.5027 8.07196 15.1351 8.17688M15.1399 8.18267C14.3348 6.65375 12.7302 5.61133 10.8822 5.61133C8.22631 5.61133 6.07329 7.76435 6.07329 10.4202V10.4803",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M14.1963 16.4036C14.1963 17.8203 13.0479 18.9688 11.6312 18.9688C10.2146 18.9688 9.06612 17.8203 9.06612 16.4036C9.06612 14.987 10.2146 13.8385 11.6312 13.8385C13.0479 13.8385 14.1963 14.987 14.1963 16.4036Z",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_cloud_resource
    },
    DATA_PIPELINE: {
        color: `var(--ds-icon, ${$6fnsQ.R300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M5.42614 8.00584C6.57734 8.45806 7.87717 7.89141 8.32938 6.7402C8.78159 5.589 8.21495 4.28917 7.06374 3.83696C5.91254 3.38475 4.61271 3.95139 4.1605 5.1026C3.70828 6.2538 4.27493 7.55363 5.42614 8.00584Z",
                        stroke: "#fff",
                        strokeWidth: "1.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M16.9334 20.1997C18.0846 20.6519 19.3844 20.0853 19.8366 18.9341C20.2888 17.7828 19.7222 16.483 18.571 16.0308C17.4198 15.5786 16.12 16.1452 15.6677 17.2964C15.2155 18.4477 15.7822 19.7475 16.9334 20.1997Z",
                        stroke: "#fff",
                        strokeWidth: "1.7",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M6.24493 8.56055V11.0306C6.24493 11.5829 6.69264 12.0306 7.24493 12.0306H16.0659C16.6182 12.0306 17.0659 12.4784 17.0659 13.0306V15.2116",
                        stroke: "#fff",
                        strokeWidth: "1.8",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_data_pipeline
    },
    MACHINE_LEARNING_MODEL: {
        color: `var(--ds-icon, ${$6fnsQ.R300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M11.8555 3.01807L15.7255 5.31503L19.6497 7.51807L19.5955 12.0181L19.6497 16.5181L15.7255 18.7211L11.8555 21.0181L7.98547 18.7211L4.06124 16.5181L4.11547 12.0181L4.06124 7.51807L7.98547 5.31503L11.8555 3.01807Z",
                        stroke: "#fff",
                        strokeWidth: "1.5",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M4.61222 7.89078L18.8696 16.1906",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M4.85273 16.2901L19.0688 7.95921",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "none",
                        d: "M11.7317 20.2989L11.7317 3.24756",
                        stroke: "#fff",
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fill: "#FF5630",
                        d: "M10.7933 14.6374C12.1126 15.1556 13.6021 14.5062 14.1203 13.187C14.6385 11.8678 13.9892 10.3782 12.67 9.86003C11.3507 9.34181 9.86119 9.99116 9.34297 11.3104C8.82476 12.6296 9.47411 14.1192 10.7933 14.6374Z",
                        stroke: "#fff",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_machine_learning_model
    },
    UI_ELEMENT: {
        color: `var(--ds-icon, ${$6fnsQ.Y500})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                        id: "path-1-inside-1_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2.83353",
                            y: "13.6489",
                            width: "6.97358",
                            height: "7.36887",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        fill: "none",
                        x: "2.83353",
                        y: "13.6489",
                        width: "6.97358",
                        height: "7.36887",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-1-inside-1_1403_23012)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                        id: "path-2-inside-2_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2.83353",
                            y: "3.01807",
                            width: "18.5455",
                            height: "8.59702",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        fill: "none",
                        x: "2.83353",
                        y: "3.01807",
                        width: "18.5455",
                        height: "8.59702",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-2-inside-2_1403_23012)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                        id: "path-3-inside-3_1403_23012",
                        fill: "white",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "11.5089",
                            y: "13.6489",
                            width: "9.87006",
                            height: "7.36887",
                            rx: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        fill: "none",
                        x: "11.5089",
                        y: "13.6489",
                        width: "9.87006",
                        height: "7.36887",
                        rx: "1",
                        stroke: "#fff",
                        strokeWidth: "3.2",
                        mask: "url(#path-3-inside-3_1403_23012)"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_ui_element
    },
    WEBSITE: {
        color: `var(--ds-icon, ${$6fnsQ.G300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fill: "fff",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12.3319 20.9136C13.5069 20.9136 14.6704 20.6821 15.756 20.2325C16.8416 19.7828 17.828 19.1237 18.6589 18.2928C19.4898 17.462 20.1489 16.4756 20.5985 15.39C21.0482 14.3044 21.2796 13.1409 21.2796 11.9658C21.2796 10.7908 21.0482 9.62725 20.5985 8.54166C20.1489 7.45607 19.4898 6.46968 18.6589 5.6388C17.828 4.80793 16.8416 4.14884 15.756 3.69917C14.6704 3.24951 13.5069 3.01807 12.3319 3.01807C9.95879 3.01807 7.68289 3.96077 6.00486 5.6388C4.32683 7.31683 3.38412 9.59273 3.38412 11.9658C3.38412 14.3389 4.32683 16.6148 6.00486 18.2928C7.68289 19.9709 9.95879 20.9136 12.3319 20.9136V20.9136ZM11.4371 19.0614C9.70752 18.8456 8.11636 18.0054 6.96289 16.6987C5.80941 15.3919 5.17312 13.7088 5.17368 11.9658C5.17368 11.4111 5.24526 10.8831 5.36158 10.3642L9.64755 14.6501V15.5449C9.64755 16.5292 10.4529 17.3345 11.4371 17.3345V19.0614V19.0614ZM17.6111 16.7887C17.4975 16.427 17.2713 16.1113 16.9654 15.8875C16.6595 15.6637 16.29 15.5436 15.911 15.5449H15.0162V12.8606C15.0162 12.3685 14.6136 11.9658 14.1214 11.9658H8.75278V10.1763H10.5423C11.0345 10.1763 11.4371 9.77362 11.4371 9.28149V7.49194H13.2267C14.2109 7.49194 15.0162 6.68665 15.0162 5.70239V5.33553C17.6379 6.40032 19.4901 8.96832 19.4901 11.9658C19.4901 13.827 18.7743 15.5181 17.6111 16.7887V16.7887Z"
                })
            }),
        message: (0, $2Mbeb.messages).compass_component_type_website
    },
    OTHER: {
        color: `var(--ds-icon, ${$6fnsQ.B300})`,
        icon: (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991ZM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991V10.01Z"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335Zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67Zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668Zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67Z"
                    })
                ]
            }),
        message: (0, $2Mbeb.messages).compass_component_type_other
    }
};

});

parcelRegister("jm8C7", function(module, exports) {

$parcel$export(module.exports, "IconBackground", () => $27cceccddbf9c80b$export$e320804e9cbf60f);

var $SZOxu = parcelRequire("SZOxu");

var $6hiXa = parcelRequire("6hiXa");
const $27cceccddbf9c80b$export$e320804e9cbf60f = (0, $6hiXa.default).div`
	display: flex;
	align-items: center;
	justify-content: center;

	width: ${(props)=>(0, $SZOxu.sizes)[props.size]};
	height: ${(props)=>(0, $SZOxu.sizes)[props.size]};

	background-color: ${(props)=>props.color};
	border-radius: 3px;

	& > svg,
	& > span[role='img'],
	& > span[role='presentation'] {
		width: 83.333333%;
	}
`;

});




parcelRegister("elGZM", function(module, exports) {

$parcel$export(module.exports, "COMPASS_PRODUCT_ID", () => $e334ffb1d4729b69$export$29789a1990c8eafe);
$parcel$export(module.exports, "useCompassSuppliers", () => $e334ffb1d4729b69$export$9b569c25a7f27268);

var $dBxQj = parcelRequire("dBxQj");

var $5CiaV = parcelRequire("5CiaV");

var $3coNb = parcelRequire("3coNb");

var $2Mbeb = parcelRequire("2Mbeb");

var $4RUaK = parcelRequire("4RUaK");

var $cLKdA = parcelRequire("cLKdA");

var $48qR7 = parcelRequire("48qR7");

var $ar4gF = parcelRequire("ar4gF");
const $e334ffb1d4729b69$export$29789a1990c8eafe = 'compass';
const $e334ffb1d4729b69$var$NO_OWNER_TEAM = 'ari:cloud:teams::team/unidentified';
const $e334ffb1d4729b69$export$9b569c25a7f27268 = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier }, sections)=>{
    const intl = (0, $dBxQj.default)();
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)($e334ffb1d4729b69$export$29789a1990c8eafe, sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const peopleAndTeamSupplier = (0, $3coNb.usePeopleAndTeamsQuery)({
        people: {
            id: (0, $cLKdA.CompassScope).People,
            title: intl.formatMessage((0, $2Mbeb.messages).compass_people_section_heading)
        },
        teams: {
            id: (0, $cLKdA.CompassScope).Teams,
            title: intl.formatMessage((0, $2Mbeb.messages).compass_teams_section_heading)
        }
    }, 3);
    const requestTeamMeta = async (teamId)=>{
        if (!userTeamConfig?.context.siteId || !teamId || teamId === $e334ffb1d4729b69$var$NO_OWNER_TEAM) return '';
        try {
            const team = await (0, $4RUaK.getTeamData)({
                url: userTeamConfig?.baseUrl || '',
                teamAri: teamId,
                siteId: userTeamConfig?.context.siteId
            });
            return team.displayName;
        } catch (e) {
            // Ignore
            return '';
        }
    };
    const userTeamConfigOverride = {
        context: userTeamConfig.context,
        baseUrl: userTeamConfig.baseUrl,
        resolveTeamUrl: userTeamConfig.resolveTeamUrl ?? (0, $48qR7.compassURLGenerators)().teamUrlGenerator,
        resolveUserUrl: userTeamConfig.resolveUserUrl ?? (0, $48qR7.compassURLGenerators)().userUrlGenerator
    };
    const hydrateOwnerMeta = async (items)=>{
        const promises = [];
        const compSection = items.sections.find((s)=>s.id === (0, $cLKdA.CompassScope).Component);
        if (compSection) compSection.searchResults.map(async (res)=>{
            promises.push(requestTeamMeta(res.meta).then((teamName)=>res.meta = teamName));
        });
        return Promise.all(promises).then(()=>items);
    };
    const preQueryItemSupplierWithTeamName = async (args)=>{
        const existingSections = await hydrateOwnerMeta(await itemSuppliers.preQueryItemSupplier(args));
        const teamSection = (await peopleAndTeamSupplier('', userTeamConfigOverride)).sections.find((section)=>section.id === (0, $cLKdA.CompassScope).Teams);
        return window.location.pathname.startsWith('/compass') ? existingSections : {
            size: existingSections.size,
            sections: [
                ...existingSections.sections,
                ...teamSection ? [
                    {
                        ...teamSection,
                        resultRenderer: (0, $ar4gF.peopleAndTeamsResultRenderer)
                    }
                ] : []
            ]
        };
    };
    const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await hydrateOwnerMeta(await itemSuppliers.postQueryItemSupplier(args));
        const people = userTeamConfigOverride ? await peopleAndTeamSupplier(args.query, {
            ...userTeamConfigOverride,
            context: {
                ...userTeamConfigOverride.context,
                siteId: userTeamConfigOverride.context.siteId
            }
        }) : null;
        return {
            size: existingSections.size,
            sections: [
                ...existingSections.sections,
                ...people?.sections.map((section)=>({
                        ...section,
                        resultRenderer: (0, $ar4gF.peopleAndTeamsResultRenderer)
                    })) ?? []
            ]
        };
    };
    const preQuerySectionTitleGenerator = (section)=>{
        switch(section.id){
            case (0, $cLKdA.CompassScope).Component:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $2Mbeb.messages).compass_recently_viewed_components) : intl.formatMessage((0, $2Mbeb.messages).compass_components_section_heading);
            case (0, $cLKdA.CompassScope).Teams:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $2Mbeb.messages).compass_recently_viewed_teams) : intl.formatMessage((0, $2Mbeb.messages).compass_teams_section_heading);
            case (0, $cLKdA.CompassScope).ApiEndpoint:
                return window.location.pathname.startsWith('/compass') ? intl.formatMessage((0, $2Mbeb.messages).compass_recently_viewed_endpoints) : intl.formatMessage((0, $2Mbeb.messages).compass_endpoints_section_heading);
            default:
                return '';
        }
    };
    return {
        preQueryItemSupplier: preQueryItemSupplierWithTeamName,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    };
};

});
parcelRegister("3coNb", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamsQuery", () => $6972a0988821eda6$export$f16e39d5b6af63da);

var $dBxQj = parcelRequire("dBxQj");
const $6972a0988821eda6$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const $6972a0988821eda6$var$resolveRecommendationRequest = ({ baseUrl: baseUrl, context: context, includeUsers: includeUsers, includeTeams: includeTeams, query: query, maxNumberOfResults: maxNumberOfResults })=>({
        baseUrl: baseUrl,
        context: context,
        maxNumberOfResults: maxNumberOfResults,
        query: query ?? '',
        searchQueryFilter: $6972a0988821eda6$var$ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER,
        includeUsers: includeUsers ?? false,
        includeGroups: false,
        includeTeams: includeTeams ?? false
    });

const $6972a0988821eda6$var$asyncGetUserRecommendations = async (request, intl)=>{
    try {
        const { getUserRecommendations: getUserRecommendations } = await (parcelRequire("0oBOJ"));
        return getUserRecommendations(request, intl);
    } catch (e) {
    // Ignore
    }
};
const $6972a0988821eda6$export$f16e39d5b6af63da = (peopleAndTeamSections, maxItemsPerSection)=>{
    const intl = (0, $dBxQj.default)();
    return async (query, { baseUrl: baseUrl, context: context, resolveTeamUrl: resolveTeamUrl, resolveUserUrl: resolveUserUrl })=>{
        const teamsRequest = $6972a0988821eda6$var$resolveRecommendationRequest({
            includeTeams: true,
            baseUrl: baseUrl,
            context: context,
            query: query,
            maxNumberOfResults: 20
        });
        // Separate requests enables better empty query results for each section
        const usersRequest = $6972a0988821eda6$var$resolveRecommendationRequest({
            includeUsers: true,
            baseUrl: baseUrl,
            context: context,
            query: query,
            maxNumberOfResults: 20
        });
        try {
            const [teams, users] = await Promise.all([
                $6972a0988821eda6$var$asyncGetUserRecommendations(teamsRequest, intl),
                $6972a0988821eda6$var$asyncGetUserRecommendations(usersRequest, intl)
            ]);
            const teamResults = teams?.map((team)=>{
                return {
                    title: team.name,
                    id: team.id,
                    meta: '',
                    url: resolveTeamUrl ? resolveTeamUrl(team.id) : `/people/team/${team.id}`,
                    iconUrl: team.avatarUrl,
                    isVerified: team.verified
                };
            }) ?? [];
            const userResults = users?.map((user)=>{
                return {
                    title: user.name,
                    id: user.id,
                    meta: user.title || '',
                    url: resolveUserUrl ? resolveUserUrl(user.id) : `/people/${user.id}`,
                    iconUrl: user.avatarUrl
                };
            }) ?? [];
            return {
                sections: [
                    {
                        ...peopleAndTeamSections.people,
                        searchResults: maxItemsPerSection ? userResults.slice(0, maxItemsPerSection) : userResults
                    },
                    {
                        ...peopleAndTeamSections.teams,
                        searchResults: maxItemsPerSection ? teamResults.slice(0, maxItemsPerSection) : teamResults
                    }
                ]
            };
        } catch (error) {
            return {
                sections: [
                    {
                        ...peopleAndTeamSections.people,
                        searchResults: []
                    },
                    {
                        ...peopleAndTeamSections.teams,
                        searchResults: []
                    }
                ]
            };
        }
    };
};

});
parcelRegister("0oBOJ", function(module, exports) {

let $001317073d3e50ca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $001317073d3e50ca$var$load("kQvbt"),
    $001317073d3e50ca$var$load("jQFGH"),
    $001317073d3e50ca$var$load("fQ1rW"),
    $001317073d3e50ca$var$load("4tUsp"),
    $001317073d3e50ca$var$load("9FBaW"),
    $001317073d3e50ca$var$load("jjAxo")
]).then(()=>parcelRequire('7HssB'));

});


parcelRegister("4RUaK", function(module, exports) {

$parcel$export(module.exports, "getTeamData", () => $39c8c0bb71b97b60$export$c11a6707e0ba3a30);

var $dwp40 = parcelRequire("dwp40");
const $39c8c0bb71b97b60$export$a637ff7dbe7c1532 = ({ teamId: teamId, siteId: siteId })=>{
    if (teamId === undefined || siteId === undefined) throw new Error('Missing some required parameters teamId and siteId');
    return `/gateway/api/v4/teams/${encodeURIComponent(teamId)}?siteId=${encodeURIComponent(siteId)}`;
};
const $39c8c0bb71b97b60$export$c11a6707e0ba3a30 = ({ url: url, teamAri: teamAri, siteId: siteId })=>{
    const parts = teamAri.split('/');
    const teamId = parts[parts.length - 1];
    const options = {
        path: $39c8c0bb71b97b60$export$a637ff7dbe7c1532({
            teamId: teamId,
            siteId: siteId
        }),
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
};

});

parcelRegister("48qR7", function(module, exports) {

$parcel$export(module.exports, "compassURLGenerators", () => $e86c1942bf63794c$export$9dd4fd2059f2de3b);
const $e86c1942bf63794c$var$getBaseURL = ()=>window.location.origin;
const $e86c1942bf63794c$export$9dd4fd2059f2de3b = (searchUrlOverride)=>{
    const advancedSearchLinkGenerator = (query)=>`${searchUrlOverride || $e86c1942bf63794c$var$getBaseURL()}/compass/components?query=${encodeURIComponent(query)}`;
    const teamUrlGenerator = (teamId)=>`${$e86c1942bf63794c$var$getBaseURL()}/compass/people/team/${teamId}`;
    const userUrlGenerator = (userId)=>`${$e86c1942bf63794c$var$getBaseURL()}/people/${userId}`;
    return {
        advancedSearchLinkGenerator: advancedSearchLinkGenerator,
        teamUrlGenerator: teamUrlGenerator,
        userUrlGenerator: userUrlGenerator
    };
};

});


parcelRegister("6ihFa", function(module, exports) {

$parcel$export(module.exports, "UpsellTab", () => $c854eda08d12b987$export$2570220d7265a66b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $6dP89 = parcelRequire("6dP89");

var $1Xu3J = parcelRequire("1Xu3J");

var $bUlM5 = parcelRequire("bUlM5");

const $c854eda08d12b987$var$Lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>Promise.resolve((parcelRequire("aIk0I"))).then((module)=>{
        return {
            default: module.default
        };
    }));
const $c854eda08d12b987$var$UpsellTabWithIntl = ({ intl: intl, title: title })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'exposed',
            actionSubject: 'compassSearchCrossFlowExperiment',
            source: 'searchDialog'
        });
    }, [
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
        alignItems: "center",
        columnGap: "space.100",
        testId: "compass-upsell-modal-header",
        children: [
            title,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($c854eda08d12b987$var$Lozenge, {
                    appearance: "new",
                    children: intl.formatMessage((0, $1Xu3J.messages).compass_upsell_tab_lozenge)
                })
            })
        ]
    });
};
const $c854eda08d12b987$export$2570220d7265a66b = (0, $js7oX.default)($c854eda08d12b987$var$UpsellTabWithIntl);

});
parcelRegister("1Xu3J", function(module, exports) {

$parcel$export(module.exports, "messages", () => $16378eb04d0f9038$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $16378eb04d0f9038$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Compass upsell tab
   */ compass_upsell_tab_lozenge: {
        id: "product_search_dialog.compass.upsell_tab_title_lozenge",
        defaultMessage: "New"
    },
    compass_upsell_heading: {
        id: "product_search_dialog.compass.upsell_modal_heading",
        defaultMessage: "Control your software sprawl, so developers can control their time"
    },
    compass_upsell_heading_bitbucket: {
        id: "product_search_dialog.compass.upsell_modal_heading.bitbucket",
        defaultMessage: "Bring more context to your code"
    },
    compass_upsell_description: {
        id: "product_search_dialog.compass.upsell_modal_description",
        defaultMessage: "Catalog your software architecture in one place \u2013 so the teams working on it can reduce context switching, find what they need faster, and be more productive. How\u2019s that for a developer experience?"
    },
    compass_upsell_description_bitbucket: {
        id: "product_search_dialog.compass.upsell_modal_description.bitbucket",
        defaultMessage: "See owners, dependencies, and help resources for your repositories by linking them to a central software catalog."
    },
    compass_upsell_learn_more_link: {
        id: "product_search_dialog.compass.upsell_modal_learn_more_link",
        defaultMessage: "Learn more"
    },
    compass_upsell_learn_more_aria_label: {
        id: "product_search_dialog.compass.upsell_modal_learn_more_aria_label",
        defaultMessage: "Learn more about Compass"
    },
    compass_upsell_cta_button: {
        id: "product_search_dialog.compass.upsell_modal_cta_text",
        defaultMessage: "Get Compass free"
    }
});

});


parcelRegister("2Ecsl", function(module, exports) {

let $1ed8fabc6070140d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1ed8fabc6070140d$var$load("5kEKD").then(()=>parcelRequire('eFfFJ'));

});


parcelRegister("fx9tH", function(module, exports) {

$parcel$export(module.exports, "FilterContextProvider", () => $d37a1f8828c7be3a$export$eb71bf38f5ae0f9c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");

var $jnLgC = parcelRequire("jnLgC");

var $80L9g = parcelRequire("80L9g");
const $d37a1f8828c7be3a$export$5767e6ba1d152dc0 = ()=>{
    const lastModifiedDate = new Date();
    lastModifiedDate.setDate(lastModifiedDate.getDate() - 90);
    return lastModifiedDate.toISOString().split('T')[0];
};
const $d37a1f8828c7be3a$var$useFilters = (defaultFilters = [], storeFilters = (value)=>{})=>{
    const { filters: filters, dispatch: dispatch } = (0, $jnLgC.useFilter)(defaultFilters);
    (0, $gwFzn.useLayoutEffect)(()=>{
        storeFilters(filters);
    });
    const addFilters = (0, $gwFzn.useCallback)((newFilters)=>{
        dispatch((0, $jnLgC.addFilters)(newFilters));
        storeFilters(filters.concat(newFilters));
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const updateFilter = (0, $gwFzn.useCallback)((id, isChecked)=>{
        dispatch((0, $jnLgC.updateFilterState)(id, isChecked, true));
        const index = filters.findIndex((filter)=>filter.id === id);
        const newFilters = [
            ...filters
        ];
        newFilters[index] = {
            ...newFilters[index],
            isChecked: isChecked,
            isVisible: true
        };
        storeFilters(filters.concat(newFilters));
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const clearFilter = (0, $gwFzn.useCallback)(()=>{
        filters.forEach((f)=>{
            dispatch((0, $jnLgC.updateFilterState)(f.id, false));
        });
        const newFilters = filters.map((f)=>{
            const newF = {
                ...f
            };
            newF.isChecked = false;
            return newF;
        });
        storeFilters(newFilters);
    }, [
        dispatch,
        filters,
        storeFilters
    ]);
    const resetFilter = (0, $gwFzn.useCallback)(()=>{
        dispatch((0, $jnLgC.replaceAllFilters)(defaultFilters));
    }, [
        defaultFilters,
        dispatch
    ]);
    return {
        availableFilters: filters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch
    };
};
const $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE = {
    availableFilters: [],
    addFilters: ()=>{},
    updateFilter: ()=>{},
    clearFilter: ()=>{},
    reset: ()=>{},
    dispatch: ()=>{}
};
const $d37a1f8828c7be3a$var$FilterContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    spaceFilters: $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE,
    peopleFilters: $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE,
    siteFilters: $d37a1f8828c7be3a$var$DEFAULT_FILTER_STATE,
    resetFilters: ()=>{},
    prequeryFiltersRef: {
        current: ''
    }
});
function $d37a1f8828c7be3a$export$5e1edcb3c154ab79(availableFilters) {
    const appliedFilters = availableFilters.map((availableFilter, index)=>({
            ...availableFilter,
            index: index
        })).filter((filterWithIndex)=>filterWithIndex.isChecked);
    return {
        applied: appliedFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource,
                index: appliedFilter.index
            })),
        recommendedIds: availableFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource
            }))
    };
}
const $d37a1f8828c7be3a$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultSpaceFilters: defaultSpaceFilters, defaultPeopleFilters: defaultPeopleFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
    const previousEnabledState = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(isEnabled);
    const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters, resetConfluenceFiltersRef: resetConfluenceFiltersRef } = (0, $80L9g.useSessionUserInput)();
    const [filters, setFilters] = (0, $gwFzn.useState)(readFilters('confluence'));
    const initialSpaceFilters = stickySearchEnabled ? filters?.space || defaultSpaceFilters : defaultSpaceFilters;
    const initialPeopleFilters = stickySearchEnabled ? filters?.people || defaultPeopleFilters : defaultPeopleFilters;
    const initialSiteFilters = stickySearchEnabled ? filters?.site || defaultSiteFilters : defaultSiteFilters;
    const getUpdateFilters = (0, $gwFzn.useCallback)((type)=>(options)=>{
            const filters = readFilters('confluence');
            switch(type){
                case 'SPACE':
                    filters.space = options;
                    break;
                case 'PEOPLE':
                    filters.people = options;
                    break;
                case 'SITE':
                    filters.site = options;
                    break;
            }
            storeFilters('confluence', filters);
        }, [
        readFilters,
        storeFilters
    ]);
    const spaceFilterStore = $d37a1f8828c7be3a$var$useFilters(initialSpaceFilters, stickySearchEnabled ? getUpdateFilters('SPACE') : undefined);
    const peopleFilterStore = $d37a1f8828c7be3a$var$useFilters(initialPeopleFilters, stickySearchEnabled ? getUpdateFilters('PEOPLE') : undefined);
    const siteFilterStore = $d37a1f8828c7be3a$var$useFilters(initialSiteFilters, stickySearchEnabled ? getUpdateFilters('SITE') : undefined);
    const prequeryFiltersRef = (0, $gwFzn.useRef)('');
    const filtersAnalyticsContext = spaceFilterStore.availableFilters.length === 0 && peopleFilterStore.availableFilters.length === 0 ? {} : {
        container: $d37a1f8828c7be3a$export$5e1edcb3c154ab79(spaceFilterStore.availableFilters),
        contributor: $d37a1f8828c7be3a$export$5e1edcb3c154ab79(peopleFilterStore.availableFilters)
    };
    const resetFilters = (0, $gwFzn.useCallback)(()=>{
        spaceFilterStore.dispatch((0, $jnLgC.replaceAllFilters)(defaultSpaceFilters || []));
        peopleFilterStore.dispatch((0, $jnLgC.replaceAllFilters)(defaultPeopleFilters || []));
        siteFilterStore.dispatch((0, $jnLgC.replaceAllFilters)(defaultSiteFilters || []));
    }, [
        defaultPeopleFilters,
        defaultSiteFilters,
        defaultSpaceFilters,
        peopleFilterStore,
        siteFilterStore,
        spaceFilterStore
    ]);
    const clearFilters = (0, $gwFzn.useCallback)(()=>{
        spaceFilterStore.clearFilter();
        peopleFilterStore.clearFilter();
        siteFilterStore.clearFilter();
        if (stickySearchEnabled) setFilters(readFilters('confluence'));
    }, [
        spaceFilterStore,
        peopleFilterStore,
        siteFilterStore,
        stickySearchEnabled,
        readFilters
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (resetConfluenceFiltersRef) resetConfluenceFiltersRef.current = clearFilters;
    }, [
        clearFilters,
        resetConfluenceFiltersRef
    ]);
    // We reset the state when the component becomes disabled
    if (previousEnabledState.current && !isEnabled && !stickySearchEnabled) resetFilters();
    previousEnabledState.current = isEnabled;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($d37a1f8828c7be3a$var$FilterContext.Provider, {
        value: {
            spaceFilters: spaceFilterStore,
            peopleFilters: peopleFilterStore,
            siteFilters: siteFilterStore,
            resetFilters: resetFilters,
            prequeryFiltersRef: prequeryFiltersRef
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext,
            children: children
        })
    });
};
const $d37a1f8828c7be3a$export$396ef541d9951d45 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($d37a1f8828c7be3a$var$FilterContext);
};

});
parcelRegister("jnLgC", function(module, exports) {

$parcel$export(module.exports, "addFilters", () => $5fb8761f8962dfc8$export$60c1905c6f855529);
$parcel$export(module.exports, "replaceAllFilters", () => $5fb8761f8962dfc8$export$4dce09b3092bd5e8);
$parcel$export(module.exports, "updateFilterState", () => $5fb8761f8962dfc8$export$e4269d58720a0c2c);
$parcel$export(module.exports, "useFilter", () => $5fb8761f8962dfc8$export$3274cf84b703fff);

var $gwFzn = parcelRequire("gwFzn");
const $5fb8761f8962dfc8$export$60c1905c6f855529 = (filters, sortFunction)=>({
        type: 'ADD_FILTERS',
        newFilters: filters,
        sortFunction: sortFunction
    });
const $5fb8761f8962dfc8$export$3be5fe9f09d6965 = (id)=>({
        type: 'REMOVE_FILTER',
        id: id
    });
const $5fb8761f8962dfc8$export$4dce09b3092bd5e8 = (newFilters)=>({
        type: 'REPLACE_ALL_FILTERS',
        newFilters: newFilters
    });
const $5fb8761f8962dfc8$export$e4269d58720a0c2c = (filterId, isChecked, isVisible)=>({
        type: 'UPDATE_FILTER_STATE',
        filterId: filterId,
        isChecked: isChecked,
        isVisible: isVisible
    });
const $5fb8761f8962dfc8$export$234bf2a76076d85a = (newFilters)=>({
        type: 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED',
        newFilters: newFilters
    });
function $5fb8761f8962dfc8$var$reducer(state, action) {
    switch(action.type){
        case 'ADD_FILTERS':
            {
                if (action.newFilters.length === 0) return state;
                let newState = [
                    ...state
                ];
                action.newFilters.forEach((f)=>{
                    const index = state.findIndex((filter)=>filter.id === f.id);
                    if (index === -1) newState.push(f);
                    else {
                        newState[index] = f;
                        return newState;
                    }
                });
                action.sortFunction && newState.sort(action.sortFunction);
                return newState;
            }
        case 'UPDATE_FILTER_STATE':
            {
                const index = state.findIndex((filter)=>filter.id === action.filterId);
                if (index === -1) return state;
                const newState = [
                    ...state
                ];
                newState[index] = {
                    ...newState[index],
                    isChecked: action.isChecked,
                    isVisible: action.isVisible === undefined || action.isVisible === null ? newState[index].isVisible : action.isVisible
                };
                return newState;
            }
        case 'REMOVE_FILTER':
            return [
                ...state.filter((filter)=>filter.id !== action.id)
            ];
        case 'REPLACE_ALL_FILTERS':
            return [
                ...action.newFilters
            ];
        case 'REPLACE_ALL_FILTERS_AND_MAINTAIN_CHECKED':
            {
                const newState = action.newFilters.map((newFilter)=>{
                    const existingFilter = state.find((f)=>f.id === newFilter.id);
                    if (existingFilter && newFilter.isVisible) newFilter.isChecked = existingFilter.isChecked;
                    return newFilter;
                });
                return newState;
            }
        default:
            // exhaustive check
            const _ = action;
            throw new Error(_);
    }
}
const $5fb8761f8962dfc8$export$3274cf84b703fff = (initialValues)=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useReducer($5fb8761f8962dfc8$var$reducer, initialValues ? initialValues : []);
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>({
            filters: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return value;
};

});


parcelRegister("gHaio", function(module, exports) {

$parcel$export(module.exports, "ExtensibleConfluenceTab", () => $1f7f0d09c2b7d826$export$9afff4557e36fda3);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $bF0iL = parcelRequire("bF0iL");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $5CiaV = parcelRequire("5CiaV");

var $jqR6C = parcelRequire("jqR6C");

var $isK0H = parcelRequire("isK0H");

var $g1L2n = parcelRequire("g1L2n");

var $kzbg7 = parcelRequire("kzbg7");
var $cgH2x = parcelRequire("cgH2x");

var $169DF = parcelRequire("169DF");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $jFPud = parcelRequire("jFPud");

var $lF5IG = parcelRequire("lF5IG");

var $9tC50 = parcelRequire("9tC50");

var $3Oj4P = parcelRequire("3Oj4P");

var $hUj82 = parcelRequire("hUj82");

var $bq0QQ = parcelRequire("bq0QQ");

var $lLhXY = parcelRequire("lLhXY");

var $fXZrW = parcelRequire("fXZrW");

var $gF7Az = parcelRequire("gF7Az");

var $2ZIpG = parcelRequire("2ZIpG");

var $80L9g = parcelRequire("80L9g");

var $bK7ak = parcelRequire("bK7ak");

var $1YBC8 = parcelRequire("1YBC8");
var $3Z7LN = parcelRequire("3Z7LN");

var $iEwUU = parcelRequire("iEwUU");

var $kmpep = parcelRequire("kmpep");

var $eztGN = parcelRequire("eztGN");

const $1f7f0d09c2b7d826$var$InteractiveSearchAIOnboardingBanner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("ex79W")).then(({ InteractiveSearchAIOnboardingBanner: InteractiveSearchAIOnboardingBanner })=>({
            default: InteractiveSearchAIOnboardingBanner
        })));
const $1f7f0d09c2b7d826$export$9afff4557e36fda3 = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, aiSearchConfig: aiSearchConfig, formatDate: formatDate, children: children, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled = false, rendererOverride: rendererOverride, aiAdminNotificationHeader: aiAdminNotificationHeader, confluenceReactivationExperiment: confluenceReactivationExperiment, confluenceAvailabilityExperiment: confluenceAvailabilityExperiment, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const { setQuery: setQuery } = (0, $2ZIpG.useQuery)();
    const { toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const { confluenceSites: confluenceSites } = (0, $lF5IG.useSearchConfigContext)();
    const { defineFilters: defineFilters } = (0, $cgH2x.useGenericFilters)();
    const { isUserAnonymous: isUserAnonymous } = recentClientConfig;
    const { searchClient: searchClient } = (0, $g1L2n.useRecentsClient)(recentClientConfig);
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const appendAnalyticsQueryParams = (0, $bK7ak.useQueryParams)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const [hasFiredVisitedEvent, setHasFiredVisitedEvent] = (0, $gwFzn.useState)(false);
    const isEnhancedSearchAnalyticsEnabled = (0, $dh538.fg)('cc_page_experiences_enhanced_search_analytics_conf');
    const appendQueryParams = isEnhancedSearchAnalyticsEnabled ? appendAnalyticsQueryParams : undefined;
    const siteFilterDefinition = (0, $cgH2x.useSiteFilterDefinition)(rest.workspaces || [], (0, $jqR6C.CONFLUENCE_PRODUCT_ID));
    const { confluenceTabDateFilter: confluenceTabDateFilter, appliedDateFilter: appliedDateFilter } = (0, $fXZrW.useConfluenceDateFilter)();
    const spaceFilterStore = (0, $kzbg7.useFilterStore)([], (0, $jqR6C.CONFLUENCE_PRODUCT_ID), (0, $jqR6C.ConfluenceFilters).Space);
    const peopleFilterStore = (0, $kzbg7.useFilterStore)([], (0, $jqR6C.CONFLUENCE_PRODUCT_ID), (0, $jqR6C.ConfluenceFilters).People);
    const { preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier } = (0, $lLhXY.useConfluenceSuppliers)({
        recentClientConfig: recentClientConfig,
        searchClientConfig: searchClientConfig,
        autocorrectEnabled: autocorrectEnabled,
        spaceFilterStore: spaceFilterStore,
        peopleFilterStore: peopleFilterStore,
        isExpanded: isExpanded,
        isUserAnonymous: isUserAnonymous,
        formatDate: formatDate,
        rendererOverride: rendererOverride,
        additionalContentTypesEnabled: additionalContentTypesEnabled
    });
    const sections = (0, $bq0QQ.useConfluenceSections)({
        formatDate: formatDate,
        autocorrectEnabled: autocorrectEnabled,
        additionalContentTypesEnabled: additionalContentTypesEnabled,
        rendererOverride: rendererOverride
    });
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)((0, $jqR6C.CONFLUENCE_PRODUCT_ID), sections, {
        preQueryItemSupplier: rest.preQueryItemSupplier || preQueryItemSupplier,
        postQueryItemSupplier: rest.postQueryItemSupplier || postQueryItemSupplier
    });
    const confluenceAdvancedSearchUrlFactory = (0, $isK0H.useConfluenceAdvancedSearchUrlFactory)(recentClientConfig.url, {
        spaceFilters: spaceFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.spaceKey || ''),
        peopleFilters: peopleFilterStore.availableFilters.filter((f)=>f.isChecked).map((f)=>f.id),
        dateFilter: !!appliedDateFilter ? [
            appliedDateFilter
        ] : []
    });
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return confluenceAdvancedSearchUrlFactory(query, baseUrl);
    }, [
        confluenceAdvancedSearchUrlFactory,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    const recentSectionTitleGenerator = (0, $gwFzn.useCallback)((section)=>{
        return section.title;
    }, []);
    const loadSpaceFilters = (0, $gwFzn.useCallback)((query)=>{
        return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                (0, $jqR6C.ConfluenceScope).Space
            ],
            modelParams: [],
            resultLimit: (0, $jqR6C.SPACE_FILTER_LIMIT),
            experience: (0, $jqR6C.NAVIGATION_V3_EXPERIENCE),
            sites: []
        }).then(({ response: response })=>{
            const results = response.retrieveScope((0, $jqR6C.ConfluenceScope).Space)?.results;
            return results?.map((result)=>({
                    value: {
                        id: result.id,
                        spaceKey: result.space?.key || '',
                        avatarUrl: `${result.baseUrl}${result.space.icon.path}`,
                        label: result.title,
                        filterSource: (0, $169DF.FilterOptionSource).SEARCH,
                        isChecked: false,
                        isVisible: true
                    },
                    label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUj82.FilterOptionItem), {
                        label: result.title,
                        iconProps: {
                            src: `${result.baseUrl}${result.space.icon.path}`,
                            appearance: 'square'
                        }
                    })
                })) || [];
        });
    }, [
        searchClient,
        isUserAnonymous
    ]);
    const loadPeopleFilters = (0, $gwFzn.useCallback)((query)=>{
        return isUserAnonymous || !searchClient ? Promise.resolve([]) : searchClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                (0, $jqR6C.ConfluenceScope).People
            ],
            modelParams: [],
            resultLimit: (0, $jqR6C.PEOPLE_FILTER_LIMIT),
            experience: (0, $jqR6C.NAVIGATION_V3_EXPERIENCE),
            sites: []
        }).then(({ response: response })=>{
            const results = response.retrieveScope((0, $jqR6C.ConfluenceScope).People)?.results;
            return results?.map((result)=>({
                    value: {
                        id: result.id,
                        avatarUrl: result.avatarUrl,
                        label: result.name,
                        filterSource: (0, $169DF.FilterOptionSource).SEARCH,
                        isChecked: false,
                        isVisible: true
                    },
                    label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUj82.FilterOptionItem), {
                        label: result.name,
                        iconProps: {
                            src: result.avatarUrl
                        }
                    })
                })) || [];
        });
    }, [
        searchClient,
        isUserAnonymous
    ]);
    const confluenceTabGenericFilters = (0, $gwFzn.useMemo)(()=>{
        return [
            {
                ['@type']: (0, $jqR6C.ConfluenceFilters).Space,
                fieldName: 'spaceKeys',
                store: spaceFilterStore,
                loadFilterOptions: loadSpaceFilters,
                sectionLabel: formatMessage((0, $bF0iL.messages).space_filters_title),
                findMoreLabel: formatMessage((0, $bF0iL.messages).space_filters_find_more)
            },
            {
                ['@type']: (0, $jqR6C.ConfluenceFilters).People,
                fieldName: 'accountIds',
                store: peopleFilterStore,
                loadFilterOptions: loadPeopleFilters,
                sectionLabel: formatMessage((0, $bF0iL.messages).contributor_filters_title),
                findMoreLabel: formatMessage((0, $bF0iL.messages).contributor_filters_find_more),
                filterConfig: {
                    filterOptionIconShape: 'circle'
                }
            }
        ];
    }, [
        formatMessage,
        loadPeopleFilters,
        loadSpaceFilters,
        peopleFilterStore,
        spaceFilterStore
    ]);
    const filtersToDefine = (0, $gwFzn.useMemo)(()=>{
        return [
            ...confluenceTabDateFilter,
            ...siteFilterDefinition,
            ...confluenceTabGenericFilters
        ];
    }, [
        confluenceTabGenericFilters,
        confluenceTabDateFilter,
        siteFilterDefinition
    ]);
    const onPrequeryBannerRender = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $5dFS9.onPrequeryBannerShown)());
    }, [
        fireAnalyticsEvent
    ]);
    const onPromptSuggestionClick = (0, $gwFzn.useCallback)((prompt, promptId)=>{
        fireAnalyticsEvent((0, $5dFS9.onSuggestedPromptClick)(promptId));
        setQuery(prompt);
        toggleShowSearchAIDialog(true);
    }, [
        fireAnalyticsEvent,
        setQuery,
        toggleShowSearchAIDialog
    ]);
    const dismissOnboardingBanner = (0, $gwFzn.useCallback)(()=>{
        if (aiSearchConfig?.dismissPrequeryBanner) {
            fireAnalyticsEvent((0, $5dFS9.onPrequeryBannerDismiss)());
            aiSearchConfig.dismissPrequeryBanner();
        }
    }, [
        aiSearchConfig,
        fireAnalyticsEvent
    ]);
    const initializeFilters = (0, $gwFzn.useCallback)(()=>{
        defineFilters((0, $jqR6C.CONFLUENCE_PRODUCT_ID), filtersToDefine);
    }, [
        defineFilters,
        filtersToDefine
    ]);
    initializeFilters();
    const { isEligibleInactiveUser: isEligibleInactiveUser, isEligibleNewUser: isEligibleNewUser, nudgeShown: isNudgeShown, setAllowConfluenceAccessCache: setAllowConfluenceAccessCache } = confluenceReactivationExperiment ?? {
        isEligibleUser: false,
        isEligibleNewUser: false,
        nudgeShown: false
    };
    const confluenceReactivationExperimentTabRenderer = (0, $gwFzn.useCallback)(({ title: title })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Oj4P.ConfluenceReactivationExperimentTab), {
            title: title,
            isEligibleInactiveUser: isEligibleInactiveUser,
            isEligibleNewUser: isEligibleNewUser,
            isNudgeShown: isNudgeShown
        }), [
        isEligibleInactiveUser,
        isEligibleNewUser,
        isNudgeShown
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!isNudgeShown && getActiveProduct()?.id === (0, $jqR6C.CONFLUENCE_PRODUCT_ID) && !hasFiredVisitedEvent) {
            // https://data-portal.internal.atlassian.com/analytics/registry/76739
            fireAnalyticsEvent({
                action: 'opened',
                actionSubject: 'panel',
                actionSubjectId: 'crossProductSearchPanel',
                source: 'searchDialog',
                eventType: 'ui',
                attributes: {
                    activeProduct: (0, $jqR6C.CONFLUENCE_PRODUCT_ID),
                    reactivationNudgeShown: true
                }
            });
            setHasFiredVisitedEvent(true);
        }
    }, [
        fireAnalyticsEvent,
        getActiveProduct,
        hasFiredVisitedEvent,
        setHasFiredVisitedEvent,
        isNudgeShown
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $jqR6C.CONFLUENCE_PRODUCT_ID),
        expandedStateInputPlaceholder: !!aiSearchConfig ? formatMessage((0, $bF0iL.messages).confluence_search_input_expanded_placeholder_ai) : formatMessage((0, $bF0iL.messages).confluence_search_input_expanded_placeholder),
        title: formatMessage((0, $bF0iL.messages).confluence_tab_label),
        tabRenderer: confluenceReactivationExperimentTabRenderer,
        autocorrectEnabled: autocorrectEnabled,
        sections: sections,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        preQuerySectionTitleGenerator: recentSectionTitleGenerator,
        showViewAllFiltersLink: true,
        ...rest,
        ...itemSuppliers,
        aiSearchConfig: aiSearchConfig,
        permissionSupplier: confluenceSites.length > 0 ? (0, $9tC50.defaultPermissionsSupplier) : rest.permissionSupplier,
        appendQueryParams: appendQueryParams,
        children: ({ productState: productState, ...props })=>{
            const Footer = showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1YBC8.ExtensibleConfluenceTabFooter), {
                orgId: orgId,
                cloudId: cloudId,
                ...props
            });
            if (productState === (0, $jFPud.ProductStates).PreQuerySuccess) {
                setAllowConfluenceAccessCache?.();
                if (!!aiAdminNotificationHeader) return {
                    Header: aiAdminNotificationHeader,
                    Footer: Footer
                };
                if (!!aiSearchConfig && aiSearchConfig.prequeryBannerEnabled) return {
                    Header: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($1f7f0d09c2b7d826$var$InteractiveSearchAIOnboardingBanner, {
                            onPromptSuggestionClick: onPromptSuggestionClick,
                            onXButtonClick: dismissOnboardingBanner,
                            onBannerShown: onPrequeryBannerRender
                        }),
                    Footer: Footer
                };
            }
            return {
                Footer: Footer
            };
        }
    });
};

});
parcelRegister("jqR6C", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_PRODUCT_ID", () => $36c76e3adf761bae$export$661dd16d63ed8290);
$parcel$export(module.exports, "NAVIGATION_V3_EXPERIENCE", () => $36c76e3adf761bae$export$4a204ebf24901f2e);
$parcel$export(module.exports, "SPACE_FILTER_LIMIT", () => $36c76e3adf761bae$export$10d5a4cb19960c6c);
$parcel$export(module.exports, "PEOPLE_FILTER_LIMIT", () => $36c76e3adf761bae$export$b41e7ecd9ba9baff);
$parcel$export(module.exports, "ConfluenceFilters", () => $36c76e3adf761bae$export$cf834bb06694a4e);
$parcel$export(module.exports, "ConfluenceScope", () => $36c76e3adf761bae$export$bb0f876d33576f3f);
const $36c76e3adf761bae$export$661dd16d63ed8290 = 'confluence';
const $36c76e3adf761bae$export$4a204ebf24901f2e = 'confluence.nav-v3';
const $36c76e3adf761bae$export$d4cf0635e2303166 = 250;
const $36c76e3adf761bae$export$10d5a4cb19960c6c = 10;
const $36c76e3adf761bae$export$b41e7ecd9ba9baff = 10;
var $36c76e3adf761bae$export$cf834bb06694a4e = /*#__PURE__*/ function(ConfluenceFilters) {
    ConfluenceFilters["Space"] = "spaces";
    ConfluenceFilters["People"] = "contributors";
    ConfluenceFilters["Date"] = "lastModified";
    return ConfluenceFilters;
}({});
var $36c76e3adf761bae$export$bb0f876d33576f3f = /*#__PURE__*/ function(ConfluenceScope) {
    ConfluenceScope["Item"] = "confluence.page,blogpost,attachment";
    ConfluenceScope["Space"] = "confluence.space";
    ConfluenceScope["People"] = "urs.user-confluence";
    ConfluenceScope["Content"] = "confluence.page,blogpost,attachment,whiteboard";
    return ConfluenceScope;
}({});

});

parcelRegister("isK0H", function(module, exports) {

$parcel$export(module.exports, "useConfluenceAdvancedSearchUrlFactory", () => $533b56e765b3323a$export$e189237de9f436c5);
$parcel$export(module.exports, "defaultFormatDate", () => $533b56e765b3323a$export$579a505f09fc5afa);

var $gwFzn = parcelRequire("gwFzn");
const $533b56e765b3323a$var$CONFLUENCE_ADVANCED_SEARCH_URL = '/wiki/search';
const $533b56e765b3323a$var$removeDuplicateWikiInUrl = (siteUrl)=>{
    return siteUrl.replace(/\/wiki(\/)?$/, '');
};
function $533b56e765b3323a$export$e189237de9f436c5(siteUrl, filters) {
    const trimmedSiteUrl = $533b56e765b3323a$var$removeDuplicateWikiInUrl(siteUrl);
    const spaceFilterString = filters.spaceFilters.length > 0 ? `&spaces=${encodeURIComponent(filters.spaceFilters.join(','))}` : '';
    const peopleFilterString = filters.peopleFilters.length > 0 ? `&contributors=${encodeURIComponent(filters.peopleFilters.join(','))}` : '';
    const dateFilterString = filters.dateFilter.length > 0 ? `&lastModified=${filters.dateFilter[0]}` : '';
    return (0, $gwFzn.useCallback)((query, siteUrl)=>{
        const url = siteUrl ? $533b56e765b3323a$var$removeDuplicateWikiInUrl(siteUrl) : trimmedSiteUrl;
        const trimmedQuery = query.trim();
        if (!trimmedQuery) return `${url}${$533b56e765b3323a$var$CONFLUENCE_ADVANCED_SEARCH_URL}`;
        return `${url}${$533b56e765b3323a$var$CONFLUENCE_ADVANCED_SEARCH_URL}?text=${encodeURIComponent(trimmedQuery)}${spaceFilterString}${peopleFilterString}${dateFilterString}`;
    }, [
        trimmedSiteUrl,
        spaceFilterString,
        peopleFilterString,
        dateFilterString
    ]);
}
const $533b56e765b3323a$export$579a505f09fc5afa = (lastModified)=>{
    const date = new Date(lastModified);
    return date.toLocaleString();
};

});

parcelRegister("g1L2n", function(module, exports) {

$parcel$export(module.exports, "useRecentsClient", () => $19ff8c138fce7df4$export$2ac7f7e39d1eda48);

var $gwFzn = parcelRequire("gwFzn");

var $jV49M = parcelRequire("jV49M");

var $csnse = parcelRequire("csnse");

var $aAuSn = parcelRequire("aAuSn");

var $dwp40 = parcelRequire("dwp40");

var $jqR6C = parcelRequire("jqR6C");

var $jXnBe = parcelRequire("jXnBe");

var $cfEFl = parcelRequire("cfEFl");
var $c3kEC = parcelRequire("c3kEC");
var $9Nzn7 = parcelRequire("9Nzn7");

var $1TPG8 = parcelRequire("1TPG8");

var $kmpep = parcelRequire("kmpep");

var $kfImN = parcelRequire("kfImN");

var $3NyIw = parcelRequire("3NyIw");
const $19ff8c138fce7df4$var$NAVIGATION_V3_EXPERIENCE = 'confluence.nav-v3';
const $19ff8c138fce7df4$var$RECENT_PAGES_PATH = 'rest/recentlyviewed/1.0/recent';
const $19ff8c138fce7df4$var$RECENT_SPACE_PATH = 'rest/recentlyviewed/1.0/recent/spaces';
const $19ff8c138fce7df4$var$DEFAULT_COLLAB_GRAPH_URL = 'gateway/api/collaboration';
const $19ff8c138fce7df4$var$ACTIVITY_CLIENT_RETRY_MS = 250;
const $19ff8c138fce7df4$var$RECENT_PAGES_LIMIT = 200;
const $19ff8c138fce7df4$var$RECENT_SPACE_LIMIT = 10;
const $19ff8c138fce7df4$var$RECENT_PEOPLE_LIMIT = 10;
function $19ff8c138fce7df4$var$recentWorkItemToResult(recentItem) {
    const { object: object, containers: containers } = recentItem;
    return {
        resultId: object.id,
        containerName: containers[0].name,
        containerId: '',
        resultType: (0, $jXnBe.ConfluenceObjectResult),
        isRecentResult: true,
        name: object.name || '',
        // Failsafe. All items should have a name.
        href: object.url,
        contentType: `confluence-${object.type}`,
        lastModified: undefined,
        // not available
        analyticsType: (0, $jXnBe.RecentConfluence)
    };
}
function $19ff8c138fce7df4$var$recentPageToResult(recentPage, baseUrl) {
    return {
        resultId: String(recentPage.id),
        name: recentPage.title || '',
        // This is a failsafe, there should be a filter to drop pages with no titles
        href: `${baseUrl}${recentPage.url}`,
        containerName: recentPage.space,
        analyticsType: (0, $jXnBe.RecentConfluence),
        resultType: (0, $jXnBe.ConfluenceObjectResult),
        contentType: `confluence-${recentPage.contentType}`,
        iconClass: recentPage.iconClass,
        containerId: recentPage.spaceId.toString(),
        isRecentResult: true,
        lastModified: undefined,
        // not available for recent results
        spaceId: recentPage.spaceId?.toString()
    };
}
function $19ff8c138fce7df4$var$mapCollabGraphContainer(response) {
    const items = response.collaborationGraphEntities.map((item)=>({
            id: item.containerDetails?.id,
            key: item.containerDetails?.key,
            icon: item.containerDetails?.iconUrl,
            name: item.containerDetails?.name,
            url: item.containerDetails?.url
        })).filter((space)=>space.id !== undefined).map((space)=>$19ff8c138fce7df4$var$recentSpaceToResult(space, space.url));
    return {
        items: items,
        timings: response.timings
    };
}
function $19ff8c138fce7df4$var$recentSpaceToResult(recentSpace, href) {
    return {
        resultId: recentSpace.id,
        name: recentSpace.name,
        key: recentSpace.key,
        href: href,
        avatarUrl: recentSpace.icon,
        analyticsType: (0, $jXnBe.RecentConfluence),
        resultType: (0, $jXnBe.GenericContainerResult),
        contentType: (0, $jXnBe.ConfluenceSpace),
        id: recentSpace.id
    };
}
function $19ff8c138fce7df4$var$mapUrsPeople(response, timings, isMultiSite) {
    if (!response) throw new Error(`Expected a response but did not get any for scope: ${(0, $jXnBe.Scope).UserConfluence}`);
    if (response.error) throw (0, $c3kEC.responseErrorToError)(response.error);
    const items = response.results.map((item)=>({
            resultType: (0, $jXnBe.PersonResult),
            resultId: `people-${item.id}`,
            userId: item.id,
            name: item.name,
            href: (0, $kfImN.generatePeopleProfileUrl)(isMultiSite, item.absoluteUrl, item.id),
            avatarUrl: item.avatarUrl,
            contentType: (0, $jXnBe.Person),
            analyticsType: (0, $jXnBe.ResultPerson),
            mentionName: item.nickname || '',
            presenceMessage: ''
        }));
    return {
        items: (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(items, (item)=>item.resultId),
        timings: timings
    };
}

class $19ff8c138fce7df4$var$RecentsCache {
    constructor(props){
        this.recentCacheProps = void 0;
        this.recentItemCache = void 0;
        this.recentSpaceCache = void 0;
        this.recentPeopleCache = void 0;
        this.recentItemSupplier = async ()=>{
            if (!!this.recentCacheProps.recentWorkAPIUrl) try {
                const { createActivityClient: createActivityClient } = await (parcelRequire("lVwKT"));
                const activityClient = createActivityClient('v3', 'confluence', undefined, this.recentCacheProps.recentWorkAPIUrl);
                const { viewed: viewed } = await activityClient.fetchActivities([
                    $19ff8c138fce7df4$var$ACTIVITY_CLIENT_RETRY_MS
                ], {
                    products: [
                        'confluence'
                    ]
                }, [
                    'viewed'
                ]);
                const items = viewed.filter((item)=>item.object.product === 'confluence').map((item)=>$19ff8c138fce7df4$var$recentWorkItemToResult(item));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: 0
                };
            } catch (e) {
                return {
                    items: [],
                    totalSize: 0,
                    timings: -1
                };
            }
            else try {
                const { result: result, durationMs: durationMs } = await (0, $9Nzn7.timed)((0, $dwp40.utils).requestService({
                    url: this.recentCacheProps.url
                }, {
                    path: $19ff8c138fce7df4$var$RECENT_PAGES_PATH,
                    queryParams: {
                        limit: $19ff8c138fce7df4$var$RECENT_PAGES_LIMIT
                    }
                }));
                const items = result.filter((page)=>!!page.title).map((recentPage)=>$19ff8c138fce7df4$var$recentPageToResult(recentPage, this.recentCacheProps.url));
                return {
                    items: items,
                    totalSize: items.length,
                    timings: durationMs
                };
            } catch (e) {
                return {
                    items: [],
                    totalSize: 0,
                    timings: -1
                };
            }
        };
        this.recentSpaceSupplier = async ()=>{
            if (this.recentCacheProps.isUserAnonymous) return Promise.resolve({
                items: [],
                timings: 0
            });
            if (this.recentCacheProps.isCollaborationGraphEnabled) return this.recentCacheProps.getCollabGraphContainers();
            else try {
                const { result: result, durationMs: durationMs } = await (0, $9Nzn7.timed)((0, $dwp40.utils).requestService({
                    url: this.recentCacheProps.url
                }, {
                    path: $19ff8c138fce7df4$var$RECENT_SPACE_PATH,
                    queryParams: {
                        limit: $19ff8c138fce7df4$var$RECENT_SPACE_LIMIT
                    }
                }));
                return {
                    items: result.map((recentSpace)=>$19ff8c138fce7df4$var$recentSpaceToResult(recentSpace, `${this.recentCacheProps.url}/spaces/${recentSpace.key}`)),
                    timings: durationMs
                };
            } catch (e) {
                return {
                    items: [],
                    timings: -1
                };
            }
        };
        this.recentPeopleSupplier = async ()=>{
            if (this.recentCacheProps.isUserAnonymous || !this.recentCacheProps.aggregatorClient) return Promise.resolve({
                items: [],
                timings: 0
            });
            return this.recentCacheProps.aggregatorClient.search({
                query: '',
                context: {
                    sessionId: '',
                    referrerId: null
                },
                scopes: [
                    (0, $jqR6C.ConfluenceScope).People
                ],
                modelParams: [],
                resultLimit: $19ff8c138fce7df4$var$RECENT_PEOPLE_LIMIT,
                experience: $19ff8c138fce7df4$var$NAVIGATION_V3_EXPERIENCE,
                sites: this.recentCacheProps.sites?.map((s)=>s.cloudId)
            }).then(({ response: response, requestDurationMs: requestDurationMs })=>$19ff8c138fce7df4$var$mapUrsPeople(response.retrieveScope((0, $jqR6C.ConfluenceScope).People), requestDurationMs, (this.recentCacheProps.sites || []).length > 0)).catch((e)=>({
                    items: [],
                    timings: -1
                }));
        };
        this.recentCacheProps = props;
        this.recentItemCache = new (0, $3NyIw.SimpleCache)(this.recentItemSupplier);
        this.recentSpaceCache = new (0, $3NyIw.SimpleCache)(this.recentSpaceSupplier);
        this.recentPeopleCache = new (0, $3NyIw.SimpleCache)(this.recentPeopleSupplier);
    }
}
const $19ff8c138fce7df4$var$getRecentsCache = (0, $csnse.default)((recentsCacheProps)=>new $19ff8c138fce7df4$var$RecentsCache(recentsCacheProps), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $19ff8c138fce7df4$var$getCollabGraphClientWithConfig = (0, $csnse.default)((config)=>new (0, $cfEFl.CollaborationGraphClient)(config), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $19ff8c138fce7df4$export$2ac7f7e39d1eda48 = (props)=>{
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const collabGraphClient = $19ff8c138fce7df4$var$getCollabGraphClientWithConfig({
        collaborationGraphUrl: props.collaborationGraphUrl || $19ff8c138fce7df4$var$DEFAULT_COLLAB_GRAPH_URL,
        cloudId: props.cloudId,
        isMultiSite: (props.sites || []).length > 1,
        sites: props.sites || [],
        collabGraphSessionId: props.collabGraphSessionId
    });
    const { isUserAnonymous: isUserAnonymous } = props;
    const getCollabGraphContainers = (0, $gwFzn.useCallback)(async ()=>{
        return isUserAnonymous ? Promise.resolve({
            items: [],
            timings: 0
        }) : collabGraphClient.getContainers([
            (0, $1TPG8.SpaceContainerType)
        ]).then((response)=>$19ff8c138fce7df4$var$mapCollabGraphContainer(response)).catch((e)=>({
                items: [],
                timings: -1
            }));
    }, [
        collabGraphClient,
        isUserAnonymous
    ]);
    const recentsCache = $19ff8c138fce7df4$var$getRecentsCache({
        ...props,
        aggregatorClient: aggregatorClient,
        getCollabGraphContainers: getCollabGraphContainers
    });
    const getRecentItems = (0, $gwFzn.useCallback)(()=>{
        return recentsCache.recentItemCache.get().value;
    }, [
        recentsCache
    ]);
    const getRecentSpaces = (0, $gwFzn.useCallback)(()=>{
        return recentsCache.recentSpaceCache.get().value;
    }, [
        recentsCache
    ]);
    const getRecentPeople = (0, $gwFzn.useCallback)(()=>{
        return recentsCache.recentPeopleCache.get().value;
    }, [
        recentsCache
    ]);
    return {
        getRecentItems: getRecentItems,
        getRecentSpaces: getRecentSpaces,
        getRecentPeople: getRecentPeople,
        getCollabGraphContainers: getCollabGraphContainers,
        searchClient: aggregatorClient,
        collabGraphClient: collabGraphClient
    };
};

});

parcelRegister("kzbg7", function(module, exports) {

$parcel$export(module.exports, "useFilterStore", () => $8488ca61c8c92e6d$export$875b296eac126ec2);

var $gwFzn = parcelRequire("gwFzn");

var $169DF = parcelRequire("169DF");

var $jnLgC = parcelRequire("jnLgC");

var $80L9g = parcelRequire("80L9g");
const $8488ca61c8c92e6d$export$875b296eac126ec2 = (defaultFilters = [], productId, filterType)=>{
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(undefined);
    const { stickySearchEnabled: stickySearchEnabled, readFilters: readFilters, storeFilters: storeFilters } = (0, $80L9g.useSessionUserInput)();
    const storedFilters = readFilters(productId) ? readFilters(productId)[filterType] : [];
    const defaultFiltersRef = (0, $gwFzn.useRef)(stickySearchEnabled && storedFilters && storedFilters.length > 0 ? storedFilters : defaultFilters);
    const { filters: filters, dispatch: dispatch } = (0, $jnLgC.useFilter)(defaultFiltersRef.current);
    const addFilters = (0, $gwFzn.useCallback)((newFilters)=>dispatch((0, $jnLgC.addFilters)(newFilters, (a, b)=>{
            if (a.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER) return -1;
            if (a.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER) return 1;
            return 0;
        })), [
        dispatch
    ]);
    const loadDefaultFilters = (load)=>{
        setIsLoading(true);
        load.then((result)=>setDefaultFilters(result)).finally(()=>setIsLoading(false));
    };
    const updateFilter = (0, $gwFzn.useCallback)((id, isChecked, isVisible = true)=>dispatch((0, $jnLgC.updateFilterState)(id, isChecked, isVisible)), [
        dispatch
    ]);
    const updateSingleValueFilter = (0, $gwFzn.useCallback)((id)=>{
        filters.forEach((f)=>dispatch((0, $jnLgC.updateFilterState)(f.id, f.id === id)));
    }, [
        filters,
        dispatch
    ]);
    const clearFilter = (0, $gwFzn.useCallback)(()=>{
        filters.forEach((f)=>dispatch((0, $jnLgC.updateFilterState)(f.id, false)));
    }, [
        filters,
        dispatch
    ]);
    const resetFilter = (0, $gwFzn.useCallback)(()=>{
        dispatch((0, $jnLgC.replaceAllFilters)(defaultFilters.length ? defaultFilters : defaultFiltersRef.current));
    }, [
        defaultFilters,
        dispatch
    ]);
    const setDefaultFilters = (0, $gwFzn.useCallback)((filters)=>{
        defaultFiltersRef.current = filters;
        resetFilter();
    }, [
        defaultFiltersRef,
        resetFilter
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (stickySearchEnabled) {
            const stickyFilter = readFilters(productId);
            stickyFilter[filterType] = filters;
            storeFilters(productId, stickyFilter);
        }
    }, [
        stickySearchEnabled,
        readFilters,
        storeFilters,
        productId,
        filterType,
        filters
    ]);
    return {
        availableFilters: filters,
        isLoading: isLoading && defaultFilters.length === 0,
        loadDefaultFilters: loadDefaultFilters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        updateSingleValueFilter: updateSingleValueFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch,
        setDefaultFilters: setDefaultFilters
    };
};

});
parcelRegister("169DF", function(module, exports) {

$parcel$export(module.exports, "FilterOptionSource", () => $d4be48b9fe9cdb51$export$a386c4ddeb43c20a);
var $d4be48b9fe9cdb51$export$a386c4ddeb43c20a = /*#__PURE__*/ function(FilterOptionSource) {
    /**
	 * This means the result came from collab graph
	 */ FilterOptionSource["COLLABORATION_GRAPH"] = "COLLABORATION_GRAPH";
    /**
	 * This means the result came from smart user picker
	 */ FilterOptionSource["SMART_USER_PICKER"] = "SMART_USER_PICKER";
    /**
	 * This means the result came from a recents (bootstrap) query
	 */ FilterOptionSource["RECENT"] = "RECENT";
    /**
	 * This means the result came from an explicit search
	 */ FilterOptionSource["SEARCH"] = "SEARCH";
    /**
	 * This means the result is derived from the current user
	 */ FilterOptionSource["CURRENT_USER"] = "CURRENT_USER";
    /**
	 * This means the result came from an external source passed into the component
	 */ FilterOptionSource["EXTERNAL"] = "EXTERNAL";
    /**
	 * This means the result is static without any user-generation
	 */ FilterOptionSource["STATIC"] = "STATIC";
    return FilterOptionSource;
}({});

});


parcelRegister("cgH2x", function(module, exports) {

$parcel$export(module.exports, "FilterContextHOC", () => $e93e47a7b7b4ad5d$export$ceb34aeb37186333);
$parcel$export(module.exports, "useGenericFilters", () => $e93e47a7b7b4ad5d$export$bc4556a4dba20090);
$parcel$export(module.exports, "useSiteFilterDefinition", () => $e93e47a7b7b4ad5d$export$aa277293bef5fdbf);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $gF7Az = parcelRequire("gF7Az");

var $80L9g = parcelRequire("80L9g");

var $169DF = parcelRequire("169DF");

var $kzbg7 = parcelRequire("kzbg7");

var $88j1D = parcelRequire("88j1D");

var $bF0iL = parcelRequire("bF0iL");
const $e93e47a7b7b4ad5d$export$95f4aabc01d7575d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    filterDefinitions: {},
    defineFilters: ()=>{}
});
const $e93e47a7b7b4ad5d$export$ceb34aeb37186333 = ({ children: children })=>{
    const filterDefinitions = (0, $gwFzn.useRef)({}).current;
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { stickySearchEnabled: stickySearchEnabled, resetExtensibleFiltersRef: resetExtensibleFiltersRef } = (0, $80L9g.useSessionUserInput)();
    const previousExpandState = (0, $gwFzn.useRef)(isExpanded);
    const defineFilters = (productId, filters)=>{
        filterDefinitions[productId] = filters;
    };
    const resetFilters = ()=>{
        Object.keys(filterDefinitions).forEach((productId)=>{
            filterDefinitions[productId].forEach((filter)=>{
                filter.store.reset();
            });
        });
    };
    (0, $gwFzn.useEffect)(()=>{
        if (previousExpandState.current && !isExpanded && !stickySearchEnabled) Object.keys(filterDefinitions).forEach((productId)=>{
            filterDefinitions[productId].forEach((filter)=>{
                filter.store.reset();
            });
        });
        previousExpandState.current = isExpanded;
    }, [
        isExpanded,
        stickySearchEnabled
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $gwFzn.useEffect)(()=>{
        if (resetExtensibleFiltersRef) resetExtensibleFiltersRef.current = resetFilters;
    }); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $7UHDa.jsx)($e93e47a7b7b4ad5d$export$95f4aabc01d7575d.Provider, {
        value: {
            filterDefinitions: filterDefinitions,
            defineFilters: defineFilters
        },
        children: children
    });
};
const $e93e47a7b7b4ad5d$export$bc4556a4dba20090 = ()=>(0, $gwFzn.useContext)($e93e47a7b7b4ad5d$export$95f4aabc01d7575d);
const $e93e47a7b7b4ad5d$export$aa277293bef5fdbf = (workspaces, productId)=>{
    const isMultiWorkspace = workspaces && workspaces.length > 1;
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const siteFilterStore = (0, $kzbg7.useFilterStore)(workspaces?.map((workspace, index)=>({
            label: workspace.name,
            id: workspace.id,
            isChecked: false,
            isVisible: index < 3,
            filterSource: (0, $169DF.FilterOptionSource).EXTERNAL,
            avatarUrl: ''
        })), productId, (0, $88j1D.SITE_FILTER_TYPE_NAME));
    if (isMultiWorkspace) return [
        {
            '@type': (0, $88j1D.SITE_FILTER_TYPE_NAME),
            fieldName: 'values',
            store: siteFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $bF0iL.messages).site_filters_title),
            findMoreLabel: formatMessage((0, $bF0iL.messages).site_filters_find_more)
        }
    ];
    else return [];
};

});

parcelRegister("lF5IG", function(module, exports) {

$parcel$export(module.exports, "useSearchConfigContext", () => $6004f871869f2e35$export$dca16f1ca9af3934);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $USdFJ = parcelRequire("USdFJ");
/**
 * Every product configuration might not choose to have the search config provider.
 * Hence this is explicitly initialised to null.
 */ const $6004f871869f2e35$var$SearchConfigContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext({
    jiraSites: [],
    confluenceSites: [],
    atlasWorkspaces: []
});
const $6004f871869f2e35$export$9ce36a8a6ea7b893 = (props)=>{
    const { children: children, skeleton: SkeletonComponent = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}) } = props;
    const accessibleProducts = (0, $USdFJ.useSearchConfigClient)(props);
    return accessibleProducts == null ? /*#__PURE__*/ (0, $7UHDa.jsx)(SkeletonComponent, {}) : /*#__PURE__*/ (0, $7UHDa.jsx)($6004f871869f2e35$var$SearchConfigContext.Provider, {
        value: accessibleProducts,
        children: children
    });
};
function $6004f871869f2e35$export$dca16f1ca9af3934() {
    return (0, $gwFzn.useContext)($6004f871869f2e35$var$SearchConfigContext);
}

});

parcelRegister("9tC50", function(module, exports) {

$parcel$export(module.exports, "defaultPermissionsSupplier", () => $a2ad679ee4094498$export$79b79eb7219cb5fd);

var $jqR6C = parcelRequire("jqR6C");
const $a2ad679ee4094498$export$79b79eb7219cb5fd = ()=>{
    const response = Object.values((0, $jqR6C.ConfluenceScope));
    return Promise.resolve(response);
};

});

parcelRegister("3Oj4P", function(module, exports) {

$parcel$export(module.exports, "ConfluenceReactivationExperimentTab", () => $089108003db7c5d6$export$33a7dd41d4b97411);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $aIk0I = parcelRequire("aIk0I");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $b9hjy = parcelRequire("b9hjy");

var $bUlM5 = parcelRequire("bUlM5");
const $089108003db7c5d6$var$Tab = ({ intl: intl, title: title, isEligibleInactiveUser: isEligibleInactiveUser, isEligibleNewUser: isEligibleNewUser, isNudgeShown: isNudgeShown })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const displayNudge = !isNudgeShown && (isEligibleInactiveUser || isEligibleNewUser);
    (0, $gwFzn.useEffect)(()=>{
        displayNudge && fireAnalyticsEvent((0, $5dFS9.onConfluenceReactionNudgeShown)(!!isEligibleNewUser));
    }, [
        displayNudge,
        fireAnalyticsEvent,
        isEligibleNewUser
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
        alignItems: "center",
        columnGap: "space.100",
        children: [
            title,
            displayNudge && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                appearance: "new",
                children: intl.formatMessage(isEligibleNewUser ? (0, $b9hjy.messages).never_active_user : (0, $b9hjy.messages).inactive_user)
            })
        ]
    });
};
const $089108003db7c5d6$export$33a7dd41d4b97411 = (0, $js7oX.default)($089108003db7c5d6$var$Tab);

});
parcelRegister("b9hjy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ac4a34ed4901a4de$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $ac4a34ed4901a4de$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Confluence reactivation experiment tab nudge
   */ never_active_user: {
        id: "product_search_dialog.confluence.confluence_reactivation_experiment.never_active_user",
        defaultMessage: "Free access"
    },
    inactive_user: {
        id: "product_search_dialog.confluence.confluence_reactivation_experiment.inactive_user",
        defaultMessage: "More results"
    }
});

});


parcelRegister("hUj82", function(module, exports) {

$parcel$export(module.exports, "FilterOptionItem", () => $bf37330ffae29f1b$export$150fbd78f757731d);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eN2vi = parcelRequire("eN2vi");

var $esRft = parcelRequire("esRft");
const $bf37330ffae29f1b$export$150fbd78f757731d = ({ label: label, iconProps: iconProps })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eN2vi.FilterShowMoreItem), {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
            name: label,
            size: 'small',
            ...iconProps
        }),
        label: label
    });
};

});
parcelRegister("eN2vi", function(module, exports) {

$parcel$export(module.exports, "FilterShowMoreItem", () => $2226f60f4cec6118$export$c09bfbbe14287de2);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lggDm = parcelRequire("lggDm");
const $2226f60f4cec6118$export$c09bfbbe14287de2 = ({ label: label, icon: icon, ...rest })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $lggDm.LabelWrapper), {
        ...rest,
        children: [
            icon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lggDm.IconWrapper), {
                children: icon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lggDm.FilterColLabelText), {
                children: label
            })
        ]
    });
};

});
parcelRegister("lggDm", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $b7a96cd3a77f60a3$export$be58b4326e23250f);
$parcel$export(module.exports, "LabelWrapper", () => $b7a96cd3a77f60a3$export$147422f7450ccfac);
$parcel$export(module.exports, "FilterColLabelText", () => $b7a96cd3a77f60a3$export$39d33abf45c3996);
$parcel$export(module.exports, "FilterRowLabelText", () => $b7a96cd3a77f60a3$export$dd6e1c6307d95848);
$parcel$export(module.exports, "CheckboxWrapper", () => $b7a96cd3a77f60a3$export$eef12940a6696c78);
$parcel$export(module.exports, "PillButton", () => $b7a96cd3a77f60a3$export$c5e39530e713771e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $b7a96cd3a77f60a3$export$397f5285b920487e = (0, $2azjJ.grid).multiple(22);
const $b7a96cd3a77f60a3$export$f51daa55764f8a9 = $b7a96cd3a77f60a3$export$397f5285b920487e.half();
const $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE = 2;
// The +4px is to ensure consistency with the Atlaskit avatar which has a 2px padding around the 24px icon
const $b7a96cd3a77f60a3$var$ICON_WIDTH = (0, $2azjJ.grid).multiple(3).unitless + $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
const $b7a96cd3a77f60a3$var$ICON_HEIGHT = (0, $2azjJ.grid).multiple(3).unitless + $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE * 2;
const $b7a96cd3a77f60a3$export$be58b4326e23250f = (0, $gwrgp.default)("span", {
    target: "e6939t10"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${$b7a96cd3a77f60a3$var$ICON_HEIGHT}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$b7a96cd3a77f60a3$var$ICON_WIDTH}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $2azjJ.grid).unitless - $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px 0 ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $2azjJ.grid).half().unitless - $b7a96cd3a77f60a3$var$IRREMOVABLE_AVATAR_PADDING_SIZE}px`
});
const $b7a96cd3a77f60a3$export$147422f7450ccfac = (0, $gwrgp.default)("span", {
    target: "e6939t11"
})({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // Offset the label's 4px padding-left
    marginLeft: "var(--ds-space-negative-050, -4px)",
    // The -2px is to offset the 28px container (see IconWrapper)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $2azjJ.grid).unitless - 2} 0`
});
const $b7a96cd3a77f60a3$export$39d33abf45c3996 = (0, $gwrgp.default)("span", {
    target: "e6939t12"
})((0, $2azjJ.nowrapEllipsis), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $b7a96cd3a77f60a3$export$397f5285b920487e.px,
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});
const $b7a96cd3a77f60a3$export$dd6e1c6307d95848 = (0, $gwrgp.default)("span", {
    target: "e6939t13"
})((0, $2azjJ.nowrapEllipsis), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $2azjJ.grid).half().px,
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $b7a96cd3a77f60a3$export$f51daa55764f8a9.px
});
const $b7a96cd3a77f60a3$export$eef12940a6696c78 = (0, $gwrgp.default)("span", {
    target: "e6939t14"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `${(0, $2azjJ.grid).unitless - 2}px 0`,
    display: 'flex',
    flexGrow: 1
});
const $b7a96cd3a77f60a3$export$c5e39530e713771e = (0, $gwrgp.default)("button", {
    target: "e6939t15"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $2azjJ.grid).multiple(3).unitless + 2}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.selected ? `var(--ds-text-brand, ${0, $6fnsQ.B400})` : `var(--ds-text-subtlest, ${0, $6fnsQ.N500})`,
        outline: 'none',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${(0, $2azjJ.grid).half().px} ${(0, $2azjJ.grid).px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? `var(--ds-background-selected, ${0, $6fnsQ.B50})` : `var(--ds-background-accent-gray-subtlest, ${0, $6fnsQ.N20})`,
        border: 'none',
        borderRadius: '14px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: `${(0, $2azjJ.grid).multiple(2).unitless + 2}px`,
        cursor: 'pointer',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${0, $6fnsQ.B100})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        }
    }));

});



parcelRegister("bq0QQ", function(module, exports) {

$parcel$export(module.exports, "useConfluenceSections", () => $38dc479b8383985f$export$468e9a0e16eb3222);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $jqR6C = parcelRequire("jqR6C");

var $bF0iL = parcelRequire("bF0iL");

var $isK0H = parcelRequire("isK0H");

var $1LtdH = parcelRequire("1LtdH");

var $88j1D = parcelRequire("88j1D");

var $hucqD = parcelRequire("hucqD");
const $38dc479b8383985f$var$ITEM_LIMIT_SIZE = 10;
const $38dc479b8383985f$var$SPACE_LIMIT_SIZE = 3;
const $38dc479b8383985f$var$PEOPLE_LIMIT_SIZE = 3;
const $38dc479b8383985f$export$468e9a0e16eb3222 = ({ formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, additionalContentTypesEnabled: additionalContentTypesEnabled, rendererOverride: rendererOverride })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const confluenceItemResultMapper = (0, $gwFzn.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.content.id,
                title: result.title,
                type: result.content.type,
                meta: result.container.title,
                additionalMeta: result.lastModified ? formatDate ? formatDate(result.lastModified) : (0, $isK0H.defaultFormatDate)(result.lastModified) : '',
                url: `${result.baseUrl}${result.url}`,
                containerId: result.content?.space?.id || result.container?.id || 'UNAVAILABLE',
                iconRenderer: (0, $1LtdH.ConfluenceItemIconRenderer)(result, true)
            })).slice(0, $38dc479b8383985f$var$ITEM_LIMIT_SIZE), [
        formatDate
    ]);
    const confluenceSpaceResultMapper = (0, $gwFzn.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.id,
                title: result.title,
                meta: '',
                url: `${result.baseUrl || ''}${result.container.displayUrl}`,
                containerId: result.id,
                icon: (0, $1LtdH.GenericConfluenceIconRenderer)(`${result.baseUrl}${result.space.icon.path}`, true)
            })).slice(0, $38dc479b8383985f$var$SPACE_LIMIT_SIZE), []);
    const confluencePeopleResultMapper = (0, $gwFzn.useCallback)(({ results: results })=>results.map((result)=>({
                id: result.id,
                title: result.name,
                meta: '',
                url: result.absoluteUrl?.replace('/people', '/wiki/people') || '',
                containerId: '',
                icon: (0, $1LtdH.GenericConfluenceIconRenderer)(result.avatarUrl, true)
            })).slice(0, $38dc479b8383985f$var$PEOPLE_LIMIT_SIZE), []);
    const enableSpaceAndPeopleScope = (query, filters)=>{
        return !filters.find((filter)=>filter['@type'] === 'spaces' && filter['spaceKeys'].length > 0 || filter['@type'] === 'contributors' && filter['accountIds'].length > 0 || filter['@type'] === 'lastModified' && filter.from && filter.from !== (0, $88j1D.DEFAULT_OPTION));
    };
    const scopeId = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, $jqR6C.ConfluenceScope).Item;
    return (0, $gwFzn.useMemo)(()=>[
            {
                id: scopeId,
                title: formatMessage((0, $bF0iL.messages).confluence_content_section_heading),
                titleRenderer: (0, $hucqD.sectionTitleRenderer)(!!autocorrectEnabled),
                resultRenderer: additionalContentTypesEnabled && !!rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, $hucqD.ConfluenceItemResultRenderer),
                scope: scopeId,
                resultMapper: confluenceItemResultMapper,
                showResultCount: true,
                resultLimit: $38dc479b8383985f$var$ITEM_LIMIT_SIZE
            },
            {
                id: (0, $jqR6C.ConfluenceScope).Space,
                title: formatMessage((0, $bF0iL.messages).confluence_spaces_section_heading),
                scope: (0, $jqR6C.ConfluenceScope).Space,
                resultMapper: confluenceSpaceResultMapper,
                isEnabled: enableSpaceAndPeopleScope
            },
            {
                id: (0, $jqR6C.ConfluenceScope).People,
                title: formatMessage((0, $bF0iL.messages).confluence_people_section_heading),
                scope: (0, $jqR6C.ConfluenceScope).People,
                resultMapper: confluencePeopleResultMapper,
                isEnabled: enableSpaceAndPeopleScope
            }
        ], [
        formatMessage,
        autocorrectEnabled,
        confluenceItemResultMapper,
        confluenceSpaceResultMapper,
        confluencePeopleResultMapper,
        scopeId,
        additionalContentTypesEnabled,
        rendererOverride
    ]);
};

});
parcelRegister("1LtdH", function(module, exports) {

$parcel$export(module.exports, "getAvatarForConfluenceObjectResult", () => $7ce590926ed55824$export$310004de4fa0ccba);
$parcel$export(module.exports, "ConfluenceItemIconRenderer", () => $7ce590926ed55824$export$9e3ce228520dfa00);
$parcel$export(module.exports, "GenericConfluenceIconRenderer", () => $7ce590926ed55824$export$8fde8d521a2cd996);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dlbUV = parcelRequire("dlbUV");

var $d4cCP = parcelRequire("d4cCP");

var $d8Kpd = parcelRequire("d8Kpd");

var $8DZd1 = parcelRequire("8DZd1");

var $41GKb = parcelRequire("41GKb");

var $11LZV = parcelRequire("11LZV");

var $hY1Uy = parcelRequire("hY1Uy");

var $1iV2p = parcelRequire("1iV2p");

var $ayTrS = parcelRequire("ayTrS");

var $90Icb = parcelRequire("90Icb");

var $hxQwS = parcelRequire("hxQwS");

var $13WX1 = parcelRequire("13WX1");

var $fX9Sa = parcelRequire("fX9Sa");

var $gguok = parcelRequire("gguok");

var $gH8Rx = parcelRequire("gH8Rx");

var $djgQ6 = parcelRequire("djgQ6");

var $20uDq = parcelRequire("20uDq");

var $lzyQK = parcelRequire("lzyQK");

var $dfQbH = parcelRequire("dfQbH");

var $7t8Pn = parcelRequire("7t8Pn");

var $hXc8o = parcelRequire("hXc8o");

var $lkBga = parcelRequire("lkBga");

var $bueVT = parcelRequire("bueVT");

var $5yCDo = parcelRequire("5yCDo");

var $9Qum6 = parcelRequire("9Qum6");
/**
 * The following code was derived from an implementation in confluence-frontend,
 * although it differs substantially.
 *
 * The original can be found at ./packages/confluence-rest-api/src/helpers/icons.js
 */ const $7ce590926ed55824$var$ATTACHMENT_ICON_CLASS_PREFIXES = [
    // Quick Nav prefix
    'content-type-attachment-',
    // CQL prefix
    'icon-file-'
];
const $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR = (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1)));
const $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR_LARGE = (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6)));
const $7ce590926ed55824$var$ATTACHMENT_FILE_EXTENSION_MATCHERS = [
    {
        regexp: /\.(gif|jpeg|jpg|png)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($41GKb))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($20uDq)))
    },
    {
        regexp: /\.(pdf)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($11LZV))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
    },
    {
        regexp: /\.(docx|dotx|doc|dot)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($90Icb))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    },
    {
        regexp: /\.(xml|html|js|css|java|jar|war|ear)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($1iV2p))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    },
    {
        regexp: /\.(xlt|xls|xlsm|xlsx|xlst)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($d8Kpd))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    },
    {
        regexp: /\.(wma|wmv|ram|mp3)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($d4cCP))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($gguok)))
    },
    {
        regexp: /\.(pptx|ppsx|potx|pot|ppt|pptm)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($hY1Uy))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    },
    {
        regexp: /\.(mov|mpeg|mpg|mp4|avi)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($ayTrS))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($hXc8o)))
    },
    {
        regexp: /\.(zip)$/i,
        avatar: (0, (/*@__PURE__*/$parcel$interopDefault($dlbUV))),
        avatarLarge: (0, (/*@__PURE__*/$parcel$interopDefault($fX9Sa)))
    }
];
const $7ce590926ed55824$var$getIconType = (iconClass, fileName, isLarge)=>{
    // Check the iconClass to make sure we're looking at an attachment
    const prefixMatches = $7ce590926ed55824$var$ATTACHMENT_ICON_CLASS_PREFIXES.find((prefix)=>{
        return iconClass.startsWith(prefix);
    });
    // if it's an attachment, look at the file extension to work out which type
    if (prefixMatches) {
        const matchingType = $7ce590926ed55824$var$ATTACHMENT_FILE_EXTENSION_MATCHERS.find((extensionMatcher)=>{
            const matches = extensionMatcher.regexp.exec(fileName);
            return !!matches && matches.length > 0;
        });
        if (matchingType) return isLarge ? matchingType.avatarLarge : matchingType.avatar;
    }
    return isLarge ? $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR_LARGE : $7ce590926ed55824$var$DEFAULT_ATTACHMENT_AVATAR;
};
const $7ce590926ed55824$export$310004de4fa0ccba = ({ type: type, title: title, iconCssClass: iconCssClass, isCollapsed: isCollapsed })=>{
    if (type === 'page' || type === 'confluence-page') {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- no icon available (https://product-fabric.atlassian.net/browse/DSP-20735)
        const Icon = isCollapsed ? (0, $5yCDo.default) : (0, $13WX1.default);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
            label: type
        });
    } else if (type === 'blogpost' || type === 'confluence-blogpost') {
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- no icon available (https://product-fabric.atlassian.net/browse/DSP-20735)
        const Icon = isCollapsed ? (0, $bueVT.default) : (0, $hxQwS.default);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
            label: type
        });
    } else if (type === 'attachment') {
        const IconComponent = $7ce590926ed55824$var$getIconType(iconCssClass || '', title, isCollapsed);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(IconComponent, {
            label: type
        });
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $7ce590926ed55824$export$9e3ce228520dfa00 = (result, largerIcons)=>()=>{
        if (result.content) return $7ce590926ed55824$export$310004de4fa0ccba({
            type: result.content.type,
            title: result.content.type,
            iconCssClass: result.iconCssClass,
            isCollapsed: largerIcons
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
    };
const $7ce590926ed55824$export$8fde8d521a2cd996 = (iconUrl, largerIcons)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $9Qum6.ResultAvatar), {
        borderColor: "transparent",
        src: iconUrl,
        appearance: "square",
        size: largerIcons ? 'small' : 'xsmall',
        testId: "result-avatar"
    });

});

parcelRegister("hucqD", function(module, exports) {

$parcel$export(module.exports, "sectionTitleRenderer", () => $7bcfa13d0f838ade$export$aee00814c9e3bae7);
$parcel$export(module.exports, "ConfluenceItemResultRenderer", () => $7bcfa13d0f838ade$export$1bdb91707b6d5bed);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");

var $jFPud = parcelRequire("jFPud");

var $eEbYb = parcelRequire("eEbYb");

var $21MH9 = parcelRequire("21MH9");

var $ejGzS = parcelRequire("ejGzS");

var $1LtdH = parcelRequire("1LtdH");
const $7bcfa13d0f838ade$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
        const { productState: productState } = args;
        const recentTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $bF0iL.messages).common_recently_viewed_section_heading
        });
        const contentTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $bF0iL.messages).confluence_content_section_heading
        });
        switch(productState){
            case (0, $jFPud.ProductStates).PreQuerySuccess:
                return recentTitle;
            case (0, $jFPud.ProductStates).PostQueryLoading:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEbYb.LoadingSkeleton), {
                    "data-testid": 'autocorrection-loading-skeleton'
                });
                return contentTitle;
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $21MH9.AutocorrectAsyncWrapper), {
                    fallback: contentTitle
                });
                return contentTitle;
            default:
                return contentTitle;
        }
    };
const $7bcfa13d0f838ade$export$1bdb91707b6d5bed = ({ searchResult: searchResult, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { productState: productState } = rest;
    if (productState === 'PreQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: ''
        }
    });
    if (productState === 'PostQueryLoading' || productState === 'PostQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: !!searchResult.isRecentResult ? formatMessage((0, $bF0iL.messages).common_recently_viewed_section_heading) : searchResult.additionalMeta,
            icon: !!searchResult.isRecentResult ? (0, $1LtdH.getAvatarForConfluenceObjectResult)({
                // the recent content type is stored in additionalMeta but not displayed
                type: searchResult.additionalMeta || '',
                title: searchResult.title,
                isCollapsed: rest.isCollapsed
            }) : searchResult.icon
        }
    });
    return (0, $ejGzS.defaultResultRenderer)({
        searchResult: searchResult,
        ...rest
    });
};

});


parcelRegister("lLhXY", function(module, exports) {

$parcel$export(module.exports, "useConfluenceSuppliers", () => $4d73e9aedf98202d$export$c9757f311cedcc1d);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $jqR6C = parcelRequire("jqR6C");

var $169DF = parcelRequire("169DF");

var $hucqD = parcelRequire("hucqD");

var $bF0iL = parcelRequire("bF0iL");

var $g1L2n = parcelRequire("g1L2n");

var $2ZIpG = parcelRequire("2ZIpG");

var $fJRVo = parcelRequire("fJRVo");

var $isK0H = parcelRequire("isK0H");

var $1LtdH = parcelRequire("1LtdH");

var $jU1PW = parcelRequire("jU1PW");
const $4d73e9aedf98202d$var$RECENT_ITEMS_SIZE_LIMIT = 10;
const $4d73e9aedf98202d$var$RECENT_SPACES_SIZE_LIMIT = 3;
const $4d73e9aedf98202d$var$ITEM_LIMIT_SIZE = 10;
const $4d73e9aedf98202d$var$SPACE_LIMIT_SIZE = 3;
const $4d73e9aedf98202d$var$PEOPLE_LIMIT_SIZE = 3;

const $4d73e9aedf98202d$export$c9757f311cedcc1d = ({ recentClientConfig: recentClientConfig, searchClientConfig: searchClientConfig, spaceFilterStore: spaceFilterStore, peopleFilterStore: peopleFilterStore, isExpanded: isExpanded, isUserAnonymous: isUserAnonymous, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, rendererOverride: rendererOverride, additionalContentTypesEnabled: additionalContentTypesEnabled })=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const warmUpCache = isExpanded && query !== '' && getActiveProduct()?.id === (0, $jqR6C.CONFLUENCE_PRODUCT_ID);
    const [hasFetchedSpaces, setHasFetchedSpaces] = (0, $gwFzn.useState)(spaceFilterStore?.availableFilters?.length > 0 || false);
    const intl = (0, $dBxQj.default)();
    const hasFetchedUsersRef = (0, $gwFzn.useRef)(peopleFilterStore?.availableFilters?.length > 0 || false);
    const { isCollaborationGraphEnabled: isCollaborationGraphEnabled } = recentClientConfig;
    const { getRecentItems: getRecentItems, getRecentSpaces: getRecentSpaces, getRecentPeople: getRecentPeople, getCollabGraphContainers: getCollabGraphContainers } = (0, $g1L2n.useRecentsClient)(recentClientConfig);
    // Set the default space filters to come from the collab graph if they are not enabled for recents
    (0, $gwFzn.useEffect)(()=>{
        if (warmUpCache && !isCollaborationGraphEnabled && !hasFetchedSpaces) getCollabGraphContainers().then((spaces)=>{
            if (spaces.items.length > 0) spaceFilterStore.setDefaultFilters(spaces.items.map((item, index)=>({
                    id: item.id,
                    spaceKey: item.key,
                    avatarUrl: item.avatarUrl,
                    label: item.name,
                    filterSource: (0, $169DF.FilterOptionSource).RECENT,
                    isChecked: false,
                    isVisible: index < 3
                })));
            setHasFetchedSpaces(true);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isCollaborationGraphEnabled,
        getCollabGraphContainers,
        isExpanded,
        warmUpCache
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (warmUpCache && !hasFetchedUsersRef.current) {
            getRecentPeople().then((recentPeople)=>{
                peopleFilterStore.setDefaultFilters(recentPeople.items.map((item, index)=>({
                        id: item.userId,
                        avatarUrl: item.avatarUrl,
                        label: item.name,
                        filterSource: (0, $169DF.FilterOptionSource).RECENT,
                        isChecked: false,
                        isVisible: index < 3
                    })));
            });
            hasFetchedUsersRef.current = true;
        }
    }, [
        warmUpCache,
        peopleFilterStore,
        getRecentPeople
    ]);
    const contentResultRenderer = additionalContentTypesEnabled && rendererOverride?.ConfluenceResultRenderer ? rendererOverride.ConfluenceResultRenderer : (0, $hucqD.ConfluenceItemResultRenderer);
    const scope = additionalContentTypesEnabled && rendererOverride?.contentScope ? rendererOverride.contentScope : (0, $jqR6C.ConfluenceScope).Item;
    const preQueryItemSupplier = (0, $gwFzn.useMemo)(()=>()=>Promise.all([
                getRecentItems(),
                getRecentSpaces()
            ]).then((results)=>{
                const recentItems = results[0].items;
                const recentSpaces = results[1].items;
                if (!hasFetchedSpaces && isCollaborationGraphEnabled) {
                    spaceFilterStore.setDefaultFilters(recentSpaces.map((item, index)=>({
                            id: item.id,
                            spaceKey: item.key,
                            avatarUrl: item.avatarUrl,
                            label: item.name,
                            filterSource: (0, $169DF.FilterOptionSource).RECENT,
                            isChecked: false,
                            isVisible: index < 3
                        })));
                    setHasFetchedSpaces(true);
                }
                return {
                    size: results.reduce((sum, { items: items })=>{
                        return sum + items.length;
                    }, 0),
                    sections: [
                        {
                            id: 'recent-confluence-items',
                            titleRenderer: (0, $hucqD.sectionTitleRenderer)(!!autocorrectEnabled),
                            title: intl.formatMessage((0, $bF0iL.messages).common_recently_viewed_section_heading),
                            resultRenderer: contentResultRenderer,
                            scope: scope,
                            searchResults: recentItems.map((result)=>({
                                    id: result.resultId,
                                    title: result.name,
                                    meta: result.containerName,
                                    additionalMeta: result.contentType,
                                    url: result.href,
                                    containerId: result.spaceId,
                                    icon: (0, $1LtdH.getAvatarForConfluenceObjectResult)({
                                        type: result.contentType,
                                        title: result.name,
                                        isCollapsed: false
                                    }),
                                    isRecentResult: true
                                })),
                            resultLimit: $4d73e9aedf98202d$var$RECENT_ITEMS_SIZE_LIMIT
                        },
                        {
                            id: 'recent-confluence-spaces',
                            title: intl.formatMessage((0, $bF0iL.messages).common_recently_spaces_section_heading),
                            searchResults: recentSpaces.map((result)=>({
                                    id: result.resultId,
                                    title: result.name,
                                    meta: '',
                                    url: result.href,
                                    containerId: '',
                                    iconUrl: result.avatarUrl,
                                    isRecentResult: true
                                })),
                            resultLimit: $4d73e9aedf98202d$var$RECENT_SPACES_SIZE_LIMIT
                        }
                    ]
                };
            }), [
        getRecentItems,
        getRecentSpaces,
        hasFetchedSpaces,
        isCollaborationGraphEnabled,
        autocorrectEnabled,
        intl,
        spaceFilterStore,
        contentResultRenderer,
        scope
    ]);
    const postQueryItemSupplier = (0, $gwFzn.useMemo)(()=>!searchClientConfig?.graphQLEnabled ? undefined : async (args)=>{
            const { hasCheckedFilters: hasCheckedFilters, getUserSearchResults: getUserSearchResults } = await (parcelRequire("jtFzj"));
            const pageBlogAttachmentGraphQLResultMapper = ({ node: item })=>{
                return {
                    id: (0, $jU1PW.transformAriToId)(item?.id || '', item?.type || ''),
                    title: item?.title || '',
                    url: item?.url || '',
                    meta: item?.space?.name || '',
                    additionalMeta: item?.lastModified ? formatDate ? formatDate(item?.lastModified) : (0, $isK0H.defaultFormatDate)(item?.lastModified) : '',
                    containerId: (0, $jU1PW.transformAriToId)(item?.space?.id || 'UNAVAILABLE', 'space'),
                    type: item?.type || '',
                    icon: (0, $1LtdH.getAvatarForConfluenceObjectResult)({
                        type: item?.type || '',
                        title: item?.title || '',
                        iconCssClass: item?.iconCssClass || '',
                        isCollapsed: true
                    })
                };
            };
            const spaceGraphQLResultMapper = ({ node: item })=>{
                return {
                    id: (0, $jU1PW.transformAriToId)(item?.id || '', item?.type || ''),
                    title: item?.title || '',
                    meta: '',
                    url: item?.url || '',
                    type: item?.type || '',
                    containerId: (0, $jU1PW.transformAriToId)(item?.id || '', item?.type || ''),
                    icon: (0, $1LtdH.GenericConfluenceIconRenderer)(`/wiki${item?.iconPath || ''}`, true)
                };
            };
            const peopleResultMapper = (user)=>({
                    title: user.name,
                    id: user.id,
                    meta: '',
                    url: `${window.location.origin}/wiki/people/${user.id}`,
                    icon: (0, $1LtdH.GenericConfluenceIconRenderer)(`${user.avatarUrl}`, true)
                });
            const fetchOnlyPageBlogAttachments = hasCheckedFilters(args.filters);
            const graphQLResultsPromise = searchClientConfig?.graphQLPromise?.(args);
            const peopleResultsPromise = fetchOnlyPageBlogAttachments || isUserAnonymous ? Promise.resolve([]) : getUserSearchResults({
                query: args.query,
                cloudId: searchClientConfig?.cloudId || '',
                principalId: searchClientConfig?.userId,
                intl: intl
            }).catch((e)=>[]);
            return Promise.all([
                graphQLResultsPromise,
                peopleResultsPromise
            ]).then((results)=>{
                const pageBlogAttachmentResults = results[0]?.search.pageBlogAttachments.edges.map(pageBlogAttachmentGraphQLResultMapper) || [];
                const pageBlogAttachmentsCount = results[0]?.search.pageBlogAttachments.totalCount;
                const spaceResults = results[0]?.search.spaces?.edges.map(spaceGraphQLResultMapper) || [];
                const peopleResults = results[1].map(peopleResultMapper) || [];
                return {
                    sections: [
                        {
                            id: scope,
                            title: intl.formatMessage((0, $bF0iL.messages).confluence_content_section_heading),
                            searchResults: pageBlogAttachmentResults,
                            titleRenderer: (0, $hucqD.sectionTitleRenderer)(!!autocorrectEnabled),
                            resultRenderer: contentResultRenderer,
                            showResultCount: true,
                            size: pageBlogAttachmentsCount || undefined,
                            resultLimit: $4d73e9aedf98202d$var$ITEM_LIMIT_SIZE
                        },
                        {
                            id: (0, $jqR6C.ConfluenceScope).Space,
                            title: intl.formatMessage((0, $bF0iL.messages).confluence_spaces_section_heading),
                            searchResults: spaceResults,
                            resultLimit: $4d73e9aedf98202d$var$SPACE_LIMIT_SIZE
                        },
                        {
                            id: (0, $jqR6C.ConfluenceScope).People,
                            title: intl.formatMessage((0, $bF0iL.messages).confluence_people_section_heading),
                            searchResults: peopleResults,
                            resultLimit: $4d73e9aedf98202d$var$PEOPLE_LIMIT_SIZE
                        }
                    ],
                    size: pageBlogAttachmentResults.length + spaceResults.length + peopleResults.length
                };
            });
        }, [
        autocorrectEnabled,
        formatDate,
        intl,
        searchClientConfig,
        contentResultRenderer,
        isUserAnonymous,
        scope
    ]);
    return {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    };
};

});
parcelRegister("jU1PW", function(module, exports) {

$parcel$export(module.exports, "transformAriToId", () => $522eb9748c713499$export$6d8886e8d5cdbeec);
const $522eb9748c713499$export$6d8886e8d5cdbeec = (id, type)=>{
    switch(type){
        case 'page':
            return id.split(':page/')[1];
        case 'blogpost':
            return id.split(':blogpost/')[1];
        case 'attachment':
            return id.split(':attachment/')[1];
        case 'space':
            return id.split(':space/')[1];
        case 'whiteboard':
            return id.split(':whiteboard/')[1];
        case 'embed':
            // embed ari url contains activation id so we split it differently here
            const embedAri = id.split('/');
            return embedAri[embedAri.length - 1];
        case 'database':
            // Databases ari url contains activation id so we split it differently here
            const databaseAri = id.split('/');
            return databaseAri[databaseAri.length - 1];
        default:
            return id;
    }
};

});

parcelRegister("jtFzj", function(module, exports) {

let $e2e0f86aafc69f62$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e2e0f86aafc69f62$var$load("5QGog").then(()=>parcelRequire('eBmVD'));

});


parcelRegister("fXZrW", function(module, exports) {

$parcel$export(module.exports, "useConfluenceDateFilter", () => $d82bcb6e5a831fde$export$a31429ad2d37d59f);

var $gwFzn = parcelRequire("gwFzn");

var $jqR6C = parcelRequire("jqR6C");

var $169DF = parcelRequire("169DF");

var $88j1D = parcelRequire("88j1D");
var $kzbg7 = parcelRequire("kzbg7");

var $82MWW = parcelRequire("82MWW");

var $dBxQj = parcelRequire("dBxQj");
const $d82bcb6e5a831fde$var$getUTCDateRange = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    const startOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const endOfDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999);
    const from = new Date(startOfDay.getTime() - fromOffset * 86400000);
    const to = new Date(endOfDay.getTime() - toOffset * 86400000);
    return {
        from: from.toISOString().split('Z')[0],
        to: to.toISOString().split('Z')[0]
    };
};
const $d82bcb6e5a831fde$export$a31429ad2d37d59f = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const dateFilterOptionsAndValues = (0, $gwFzn.useMemo)(()=>{
        return {
            [(0, $88j1D.LastModifiedValues).DEFAULT]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).DEFAULT,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_any_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: true,
                    isVisible: true
                },
                dateRange: {
                    from: '',
                    to: ''
                }
            },
            [(0, $88j1D.LastModifiedValues).TODAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).TODAY,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_today_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(0, 0)
            },
            [(0, $88j1D.LastModifiedValues).YESTERDAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).YESTERDAY,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_yesterday_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(1, 1)
            },
            [(0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_week_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(7, 0)
            },
            [(0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_month_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(30, 0)
            },
            [(0, $88j1D.LastModifiedValues).PAST_YEAR]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_YEAR,
                    label: formatMessage((0, $82MWW.messages).confluence_date_filter_year_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $d82bcb6e5a831fde$var$getUTCDateRange(365, 0)
            }
        };
    }, [
        formatMessage
    ]);
    const dateFilterOptions = (0, $gwFzn.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
        dateFilterOptionsAndValues
    ]);
    const dateFilterStore = (0, $kzbg7.useFilterStore)(dateFilterOptions, (0, $jqR6C.CONFLUENCE_PRODUCT_ID), (0, $jqR6C.ConfluenceFilters).Date);
    const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, $88j1D.DEFAULT_OPTION))?.id;
    const getLastModifiedValue = (0, $gwFzn.useCallback)(()=>{
        return appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? {
            '@type': (0, $jqR6C.ConfluenceFilters).Date,
            from: dateFilterOptionsAndValues[appliedDateFilter].dateRange.from,
            to: dateFilterOptionsAndValues[appliedDateFilter].dateRange.to
        } : null;
    }, [
        appliedDateFilter,
        dateFilterOptionsAndValues
    ]);
    const confluenceTabDateFilter = (0, $gwFzn.useMemo)(()=>{
        return [
            {
                ['@type']: (0, $jqR6C.ConfluenceFilters).Date,
                uiVariant: (0, $88j1D.FilterUIVariant).STATIC_SELECT,
                fieldName: 'from',
                store: dateFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, $82MWW.messages).confluence_date_filter_title),
                findMoreLabel: '',
                mapSelectionToAppliedValue: ()=>getLastModifiedValue()
            }
        ];
    }, [
        dateFilterStore,
        formatMessage,
        getLastModifiedValue
    ]);
    return {
        appliedDateFilter: appliedDateFilter,
        confluenceTabDateFilter: confluenceTabDateFilter
    };
};

});
parcelRegister("82MWW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f80ef50bfa9d23a2$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $f80ef50bfa9d23a2$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    confluence_typing_state_header_text: {
        id: "product_search_dialog.confluence.typing_state_header_text",
        defaultMessage: "Search for content in Confluence"
    },
    confluence_date_filter_title: {
        id: "product_search_dialog.confluence.date_filter_title",
        defaultMessage: "Last updated"
    },
    confluence_date_filter_today_label: {
        id: "product_search_dialog.confluence.date_filter_today",
        defaultMessage: "Today"
    },
    confluence_date_filter_yesterday_label: {
        id: "product_search_dialog.confluence.date_filter_yesterday",
        defaultMessage: "Yesterday"
    },
    confluence_date_filter_week_label: {
        id: "product_search_dialog.confluence.date_filters_week",
        defaultMessage: "Past 7 days"
    },
    confluence_date_filter_month_label: {
        id: "product_search_dialog.confluence.date_filters_month",
        defaultMessage: "Past 30 days"
    },
    confluence_date_filter_year_label: {
        id: "product_search_dialog.confluence.date_filters_year",
        defaultMessage: "Past year"
    },
    confluence_date_filter_any_label: {
        id: "product_search_dialog.confluence.date_filters_any",
        defaultMessage: "Any time"
    }
});

});


parcelRegister("1YBC8", function(module, exports) {

$parcel$export(module.exports, "ExtensibleConfluenceTabFooter", () => $50734d056dfcdf62$export$d7ad215466e34991);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $crAJ1 = parcelRequire("crAJ1");

var $4mZlP = parcelRequire("4mZlP");

var $3Z7LN = parcelRequire("3Z7LN");

var $4mZlP = parcelRequire("4mZlP");
const $50734d056dfcdf62$var$ReturnIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {});
const $50734d056dfcdf62$export$d7ad215466e34991 = ({ orgId: orgId, cloudId: cloudId, ...props })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                    ...props,
                    returnKeyIconComponent: $50734d056dfcdf62$var$ReturnIcon
                })
            }),
            orgId && cloudId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                    orgId: orgId,
                    cloudId: cloudId,
                    showModifierIcon: true
                })
            })
        ]
    });
};

});

parcelRegister("ex79W", function(module, exports) {

let $a949b370429bc306$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a949b370429bc306$var$load("8XFC9").then(()=>parcelRequire('gnNGp'));

});


parcelRegister("4jHJP", function(module, exports) {

$parcel$export(module.exports, "ExtensibleJiraTab", () => $704bede17293a569$export$8db2a2835d8b9d10);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $crAJ1 = parcelRequire("crAJ1");

var $bF0iL = parcelRequire("bF0iL");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $5CiaV = parcelRequire("5CiaV");

var $4azzq = parcelRequire("4azzq");

var $cgH2x = parcelRequire("cgH2x");

var $3invz = parcelRequire("3invz");

var $hlU74 = parcelRequire("hlU74");

var $btY8w = parcelRequire("btY8w");

var $1Yciq = parcelRequire("1Yciq");

var $5dFS9 = parcelRequire("5dFS9");

var $lF5IG = parcelRequire("lF5IG");

var $eztGN = parcelRequire("eztGN");

var $iEwUU = parcelRequire("iEwUU");

var $dKB22 = parcelRequire("dKB22");

var $gF7Az = parcelRequire("gF7Az");

var $2ZIpG = parcelRequire("2ZIpG");

var $kbm4u = parcelRequire("kbm4u");

var $iE5Vg = parcelRequire("iE5Vg");

var $jFPud = parcelRequire("jFPud");

var $2jYn8 = parcelRequire("2jYn8");

var $gRazf = parcelRequire("gRazf");

var $3cM77 = parcelRequire("3cM77");

var $5906J = parcelRequire("5906J");

var $3Z7LN = parcelRequire("3Z7LN");

var $4mZlP = parcelRequire("4mZlP");

var $kmpep = parcelRequire("kmpep");
let $704bede17293a569$var$hasLoadedFilters = false;
let $704bede17293a569$var$currentProjectRef;
let $704bede17293a569$var$currentUserRef;
const $704bede17293a569$export$5eff96142961f4a2 = (value)=>$704bede17293a569$var$hasLoadedFilters = value;
const $704bede17293a569$var$JiraNoPreQueryResults = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3cM77.default), {
        message: (0, $bF0iL.messages).jira_empty_state_prequery_heading
    });
const $704bede17293a569$export$8db2a2835d8b9d10 = ({ features: features, children: children, config: config, formatDate: formatDate, autocorrectEnabled: autocorrectEnabled, currentProject: currentProject, currentUser: currentUser, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { jiraSites: jiraSites } = (0, $lF5IG.useSearchConfigContext)();
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const { query: query } = (0, $2ZIpG.useQuery)();
    const hasAdvancedRoadmapsAccess = !!features?.hasAdvancedRoadmapsAccess;
    const hasSoftwareAccess = !!features?.hasSoftwareAccess;
    const isPreviewOnJiraSearchResultsEnabled = !!features?.isPreviewOnJiraSearchResultsEnabled;
    const isReportedByMeFilterEnabled = !!features?.isReportedByMeFilterEnabled;
    const isConsistentIssueDetailsEnabled = !!features?.isConsistentIssueDetailsEnabled;
    const isDateFromFilterEnabled = !!features?.enableDateFromFilter;
    const shouldShowIssueLabelsFilter = !!features?.enableIssueLabelsFilter;
    const isPreQueryFiltersEnabled = true;
    const isSearchWithTextFieldInAllIssuesLinkEnabled = !!features?.isSearchWithTextFieldInAllIssuesLinkEnabled;
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const { defineFilters: defineFilters } = (0, $cgH2x.useGenericFilters)();
    const { filtersDefinition: filtersDefinition, loadFilters: loadFilters, filterValueGetters: filterValueGetters } = (0, $3invz.useFilters)(rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled);
    const { jiraTabDateFilterDefinition: jiraTabDateFilterDefinition, appliedDateFilterValue: appliedDateFilterValue } = (0, $5906J.useJiraDateFilter)({
        isDateFromFilterEnabled: isDateFromFilterEnabled
    });
    const abTest = (0, $gRazf.useABTest)();
    const isFasterSearchDisabled = abTest !== null && abTest !== undefined && (abTest.experimentId === 'durian-without-faster-search' || abTest.experimentId === 'default-without-faster-search');
    if ((!$704bede17293a569$var$hasLoadedFilters || $704bede17293a569$var$currentProjectRef?.id !== currentProject?.id || $704bede17293a569$var$currentUserRef?.id !== currentUser?.id || $704bede17293a569$var$currentUserRef?.avatarUrl !== currentUser?.avatarUrl) && isExpanded && getActiveProduct()?.id === (0, $4azzq.JIRA_PRODUCT_ID) && (isPreQueryFiltersEnabled || query !== '')) {
        loadFilters();
        $704bede17293a569$var$currentProjectRef = currentProject;
        $704bede17293a569$var$currentUserRef = currentUser;
        $704bede17293a569$export$5eff96142961f4a2(true);
    }
    defineFilters((0, $4azzq.JIRA_PRODUCT_ID), [
        ...isDateFromFilterEnabled ? jiraTabDateFilterDefinition : [],
        ...filtersDefinition
    ]);
    const { getFiltersAdvancedSearchUrl: getFiltersAdvancedSearchUrl } = (0, $btY8w.useURLFactory)(filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return getFiltersAdvancedSearchUrl(query, baseUrl);
    }, [
        getFiltersAdvancedSearchUrl,
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    const { recentSectionTitleGenerator: recentSectionTitleGenerator, sections: sections } = (0, $hlU74.useSections)(hasAdvancedRoadmapsAccess, hasSoftwareAccess, getFiltersAdvancedSearchUrl, isPreviewOnJiraSearchResultsEnabled, (0, $dBxQj.default)(), formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled);
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)((0, $4azzq.JIRA_PRODUCT_ID), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $4azzq.JIRA_PRODUCT_ID),
        expandedStateInputPlaceholder: formatMessage((0, $bF0iL.messages).jira_search_placeholder),
        title: formatMessage((0, $bF0iL.messages).jira_tab_label),
        autocorrectEnabled: autocorrectEnabled,
        sections: sections,
        preQuerySectionTitleGenerator: recentSectionTitleGenerator,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        ...rest,
        ...itemSuppliers,
        permissionSupplier: jiraSites.length > 0 ? (0, $dKB22.defaultPermissionsSupplier) : rest.permissionSupplier,
        appendQueryParams: (0, $kbm4u.appendQueryParams),
        isPreQueryFiltersEnabled: isPreQueryFiltersEnabled,
        debounceTime: 300,
        children: ({ linkComponent: linkComponent, productState: productState })=>{
            return {
                Body: ()=>{
                    if (productState === (0, $jFPud.ProductStates).PostQueryLoading && isFasterSearchDisabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2jYn8.LoadingSpinner), {});
                    else if (productState === (0, $jFPud.ProductStates).PreQueryNoResult) return /*#__PURE__*/ (0, $7UHDa.jsx)($704bede17293a569$var$JiraNoPreQueryResults, {});
                },
                SectionFooter: jiraSites.length > 1 ? undefined // don't show the footer for multi sites
                 : ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iE5Vg.default), {
                        advancedSearchSelected: (0, $5dFS9.onAdvancedSearchSelected),
                        linkComponent: linkComponent,
                        productState: productState,
                        features: features
                    }),
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1Yciq.JiraAdvancedSearch), {
                                returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {}) : undefined,
                                linkComponent: linkComponent,
                                productState: productState,
                                features: features
                            }),
                            showAtlassianHomeSearchLink && orgId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                    orgId: orgId,
                                    cloudId: cloudId,
                                    showModifierIcon: true
                                })
                            })
                        ]
                    })
            };
        }
    });
};

});
parcelRegister("4azzq", function(module, exports) {

$parcel$export(module.exports, "JIRA_PRODUCT_ID", () => $c54738dc6b9484af$export$bf5ad8f7e6312fe2);
$parcel$export(module.exports, "NAVIGATION_V3_EXPERIENCE", () => $c54738dc6b9484af$export$4a204ebf24901f2e);
$parcel$export(module.exports, "FILTER_LIST_LIMIT", () => $c54738dc6b9484af$export$a0931d840e4e9fd9);
$parcel$export(module.exports, "ISSUE_LIST_LIMIT", () => $c54738dc6b9484af$export$f6357d218d3fefa3);
$parcel$export(module.exports, "OTHERS_LIST_LIMIT_NO_ADVANCED_ROADMAPS_ACCESS", () => $c54738dc6b9484af$export$862d39c85199c14c);
$parcel$export(module.exports, "OTHERS_LIST_LIMIT_ADVANCED_ROADMAPS_ACCESS", () => $c54738dc6b9484af$export$223565448ddb4a15);
$parcel$export(module.exports, "DEFAULT_COLLAB_GRAPH_URL", () => $c54738dc6b9484af$export$e5ea847149c37067);
$parcel$export(module.exports, "DEFAULT_ISSUE_LABELS_SERVICE_URL", () => $c54738dc6b9484af$export$43bbc37c110456ee);
$parcel$export(module.exports, "ISSUE_NAVIGATOR_URL", () => $c54738dc6b9484af$export$da00a8e161805bdf);
$parcel$export(module.exports, "JiraScope", () => $c54738dc6b9484af$export$45df25c6bac04c78);
$parcel$export(module.exports, "JiraFilters", () => $c54738dc6b9484af$export$dfd4d34c680dbd6e);
const $c54738dc6b9484af$export$bf5ad8f7e6312fe2 = 'jira';
const $c54738dc6b9484af$export$4a204ebf24901f2e = 'jira.nav-v3';
const $c54738dc6b9484af$export$a0931d840e4e9fd9 = 10;
const $c54738dc6b9484af$export$f6357d218d3fefa3 = 10;
const $c54738dc6b9484af$export$862d39c85199c14c = 6;
const $c54738dc6b9484af$export$223565448ddb4a15 = 8;
const $c54738dc6b9484af$export$e5ea847149c37067 = 'gateway/api/collaboration';
const $c54738dc6b9484af$export$43bbc37c110456ee = '/rest/api/1.0/labels/suggest';
const $c54738dc6b9484af$export$da00a8e161805bdf = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
var $c54738dc6b9484af$export$45df25c6bac04c78 = /*#__PURE__*/ function(JiraScope) {
    JiraScope["Issue"] = "jira.issue";
    JiraScope["ProjectFilter"] = "jira.project,filter";
    JiraScope["BoardProjectFilter"] = "jira.board,project,filter";
    JiraScope["BoardProjectFilterPlans"] = "jira.board,project,filter,plan";
    JiraScope["Project"] = "jira.project";
    JiraScope["Assignee"] = "urs.user-jira";
    return JiraScope;
}({});
var $c54738dc6b9484af$export$dfd4d34c680dbd6e = /*#__PURE__*/ function(JiraFilters) {
    JiraFilters["Projects"] = "projects";
    JiraFilters["Assignees"] = "assignees";
    JiraFilters["Status"] = "binary_status_categories";
    JiraFilters["Date"] = "lastModified";
    JiraFilters["ReportedBy"] = "reportedBy";
    JiraFilters["IssueLabels"] = "issueLabels";
    return JiraFilters;
}({});

});

parcelRegister("3invz", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $892be119e555b7f8$export$973ca22476b0e05f);

var $7UHDa = parcelRequire("7UHDa");

var $dBxQj = parcelRequire("dBxQj");

var $gwFzn = parcelRequire("gwFzn");

var $aZ2wG = parcelRequire("aZ2wG");

var $bF0iL = parcelRequire("bF0iL");

var $4azzq = parcelRequire("4azzq");

var $88j1D = parcelRequire("88j1D");
var $kzbg7 = parcelRequire("kzbg7");
var $cgH2x = parcelRequire("cgH2x");

var $71A0K = parcelRequire("71A0K");

var $hUj82 = parcelRequire("hUj82");

var $169DF = parcelRequire("169DF");

var $ly8Ih = parcelRequire("ly8Ih");
const $892be119e555b7f8$export$fe780e7155e72c07 = (projects, project)=>{
    if (!project) return projects;
    const newOption = {
        ...project,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).EXTERNAL
    };
    const existingItem = projects.find((s)=>s.id === project.id);
    if (!existingItem?.isVisible) {
        const lastVisibleItemIdx = projects.findIndex((s)=>!s.isVisible) - 1;
        if (lastVisibleItemIdx > 0) projects[lastVisibleItemIdx].isVisible = false;
    }
    return [
        newOption
    ].concat(projects.filter((s)=>s.id !== project.id));
};
const $892be119e555b7f8$export$e54fe71d6476ce8f = (assignees, currentUser)=>{
    if (!currentUser) return assignees;
    const newOption = {
        id: currentUser.id,
        label: currentUser.name,
        avatarUrl: currentUser.avatarUrl,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).CURRENT_USER
    };
    const existingItem = assignees.find((assignee)=>assignee.id === currentUser.id);
    if (!existingItem?.isVisible) {
        const lastVisibleItemIdx = assignees.findIndex((assignee)=>!assignee.isVisible) - 1;
        if (lastVisibleItemIdx > 0) assignees[lastVisibleItemIdx].isVisible = false;
    }
    return [
        newOption
    ].concat(assignees.filter((assignee)=>assignee.id !== currentUser.id));
};
const $892be119e555b7f8$export$973ca22476b0e05f = (rest, shouldShowIssueLabelsFilter, config, currentProject, currentUser, isReportedByMeFilterEnabled)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { getFilterItemsByJiraScope: getFilterItemsByJiraScope, getProjectOptions: getProjectOptions, fetchIssueLabelOptions: fetchIssueLabelOptions, statusFilterOptions: statusFilterOptions } = (0, $71A0K.useFiltersClient)(config);
    const siteFilterDefinition = (0, $cgH2x.useSiteFilterDefinition)(rest.workspaces || [], (0, $4azzq.JIRA_PRODUCT_ID));
    const projectsFilterStore = (0, $kzbg7.useFilterStore)([], (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).Projects);
    const assigneesFilterStore = (0, $kzbg7.useFilterStore)([], (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).Assignees);
    const reportedByFilterStore = (0, $kzbg7.useFilterStore)([], (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).ReportedBy);
    const statusFilterStore = (0, $kzbg7.useFilterStore)(statusFilterOptions, (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).Status);
    const issueLabelsFilterStore = (0, $kzbg7.useFilterStore)([], (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).IssueLabels);
    const loadFilters = (0, $gwFzn.useCallback)(()=>{
        projectsFilterStore.loadDefaultFilters(getProjectOptions().then((results)=>$892be119e555b7f8$export$fe780e7155e72c07(results, currentProject)));
        assigneesFilterStore.loadDefaultFilters(getFilterItemsByJiraScope((0, $4azzq.JiraScope).Assignee, '').then((results)=>$892be119e555b7f8$export$e54fe71d6476ce8f(results, currentUser)));
        if (shouldShowIssueLabelsFilter) issueLabelsFilterStore.loadDefaultFilters(fetchIssueLabelOptions(''));
        const defaultReportByOption = currentUser && currentUser.id ? {
            id: currentUser.id,
            label: formatMessage((0, $aZ2wG.messages).reported_by_me_filter_option),
            avatarUrl: '',
            isChecked: false,
            isVisible: true,
            filterSource: (0, $169DF.FilterOptionSource).CURRENT_USER
        } : undefined;
        if (defaultReportByOption && isReportedByMeFilterEnabled) reportedByFilterStore.setDefaultFilters([
            defaultReportByOption
        ]);
    }, [
        projectsFilterStore,
        getProjectOptions,
        assigneesFilterStore,
        getFilterItemsByJiraScope,
        shouldShowIssueLabelsFilter,
        currentUser,
        formatMessage,
        isReportedByMeFilterEnabled,
        currentProject,
        issueLabelsFilterStore,
        fetchIssueLabelOptions,
        reportedByFilterStore
    ]);
    const searchProject = (0, $gwFzn.useCallback)(async (query)=>{
        const result = await getFilterItemsByJiraScope((0, $4azzq.JiraScope).Project, query);
        return result?.map((item)=>({
                value: item,
                label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUj82.FilterOptionItem), {
                    label: item.label,
                    iconProps: {
                        src: item.avatarUrl,
                        appearance: 'square'
                    }
                })
            })) || [];
    }, [
        getFilterItemsByJiraScope
    ]);
    const searchAssignee = (0, $gwFzn.useCallback)(async (query)=>{
        const result = await getFilterItemsByJiraScope((0, $4azzq.JiraScope).Assignee, query);
        return result?.map((item)=>({
                value: item,
                label: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hUj82.FilterOptionItem), {
                    label: item.label,
                    iconProps: {
                        src: item.avatarUrl
                    }
                })
            })) || [];
    }, [
        getFilterItemsByJiraScope
    ]);
    const searchIssueLabels = (0, $gwFzn.useCallback)(async (query)=>{
        if (shouldShowIssueLabelsFilter) {
            const result = await fetchIssueLabelOptions(query);
            return result?.map((item)=>({
                    value: item,
                    label: item.label
                })) || [];
        }
        return [];
    }, [
        fetchIssueLabelOptions,
        shouldShowIssueLabelsFilter
    ]);
    const defaultValueGetter = (0, $gwFzn.useCallback)((availableFilters, valueKey = 'id')=>availableFilters.filter((f)=>f.isChecked && f[valueKey]).map((f)=>f[valueKey]), []);
    const appliedReportedByFilter = reportedByFilterStore?.availableFilters?.find((f)=>f.isChecked)?.id;
    const getReportedByMe = (0, $gwFzn.useCallback)(()=>{
        return appliedReportedByFilter ? {
            '@type': (0, $4azzq.JiraFilters).ReportedBy,
            accountIds: [
                appliedReportedByFilter
            ]
        } : null;
    }, [
        appliedReportedByFilter
    ]);
    const reportedByDefinition = isReportedByMeFilterEnabled ? [
        {
            ['@type']: (0, $4azzq.JiraFilters).ReportedBy,
            fieldName: 'accountIds',
            store: reportedByFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $aZ2wG.messages).report_by_filters_title),
            findMoreLabel: '',
            mapSelectionToAppliedValue: getReportedByMe,
            filterConfig: {
                hideIcon: true,
                usePreloadedOptions: true,
                labelComponent: (0, $ly8Ih.FilterColLabText)
            }
        }
    ] : [];
    const appliedIssueLabelsFilters = (0, $gwFzn.useMemo)(()=>defaultValueGetter(issueLabelsFilterStore.availableFilters, 'label'), [
        defaultValueGetter,
        issueLabelsFilterStore.availableFilters
    ]);
    const getAppliedIssueLabels = (0, $gwFzn.useCallback)(()=>{
        if (appliedIssueLabelsFilters.length > 0) return {
            '@type': (0, $4azzq.JiraFilters).IssueLabels,
            issueLabels: appliedIssueLabelsFilters
        };
        return null;
    }, [
        appliedIssueLabelsFilters
    ]);
    const issueLabelsFilterDefinition = shouldShowIssueLabelsFilter ? [
        {
            ['@type']: (0, $4azzq.JiraFilters).IssueLabels,
            uiVariant: (0, $88j1D.FilterUIVariant).MULTI_SELECT,
            fieldName: 'issueLabels',
            store: issueLabelsFilterStore,
            loadFilterOptions: searchIssueLabels,
            sectionLabel: formatMessage((0, $aZ2wG.messages).issue_labels_filters_title),
            findMoreLabel: '',
            placeholderText: formatMessage((0, $aZ2wG.messages).issue_labels_filters_placeholder),
            mapSelectionToAppliedValue: getAppliedIssueLabels,
            filterConfig: {
                mainGroupLabel: formatMessage((0, $aZ2wG.messages).issue_labels_filters_options_group_label)
            }
        }
    ] : [];
    const filtersDefinition = [
        ...siteFilterDefinition,
        {
            ['@type']: (0, $4azzq.JiraFilters).Projects,
            fieldName: 'projectIds',
            store: projectsFilterStore,
            loadFilterOptions: searchProject,
            sectionLabel: formatMessage((0, $bF0iL.messages).project_filters_title),
            findMoreLabel: formatMessage((0, $bF0iL.messages).project_filters_find_more),
            filterConfig: {
                filterOptionIconShape: 'square'
            }
        },
        {
            ['@type']: (0, $4azzq.JiraFilters).Assignees,
            fieldName: 'accountIds',
            store: assigneesFilterStore,
            loadFilterOptions: searchAssignee,
            sectionLabel: formatMessage((0, $bF0iL.messages).assignee_filters_title),
            findMoreLabel: formatMessage((0, $bF0iL.messages).assignee_filters_find_more),
            filterConfig: {
                filterOptionIconShape: 'circle'
            }
        },
        ...reportedByDefinition,
        {
            ['@type']: (0, $4azzq.JiraFilters).Status,
            fieldName: 'binaryStatusCategories',
            store: statusFilterStore,
            loadFilterOptions: async ()=>[],
            sectionLabel: formatMessage((0, $bF0iL.messages).binary_status_category_filters_title),
            findMoreLabel: '',
            filterConfig: {
                filterGroupedBy: 'row',
                hideIcon: true,
                usePreloadedOptions: true
            }
        },
        ...issueLabelsFilterDefinition
    ];
    const filterValueGetters = (0, $gwFzn.useMemo)(()=>({
            projects: ()=>defaultValueGetter(projectsFilterStore.availableFilters),
            assignees: ()=>defaultValueGetter(assigneesFilterStore.availableFilters),
            statuses: ()=>defaultValueGetter(statusFilterStore.availableFilters),
            reportedBy: ()=>defaultValueGetter(reportedByFilterStore.availableFilters),
            issueLabels: ()=>shouldShowIssueLabelsFilter ? appliedIssueLabelsFilters : []
        }), [
        defaultValueGetter,
        projectsFilterStore.availableFilters,
        assigneesFilterStore.availableFilters,
        statusFilterStore.availableFilters,
        reportedByFilterStore.availableFilters,
        appliedIssueLabelsFilters,
        shouldShowIssueLabelsFilter
    ]);
    return {
        filterValueGetters: filterValueGetters,
        filtersDefinition: filtersDefinition,
        loadFilters: loadFilters
    };
};

});
parcelRegister("aZ2wG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $eabab0b86d11e1a1$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $eabab0b86d11e1a1$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    // NOT USED
    jira_boards_icon_accessibility_text: {
        id: "product_search_dialog.jira.boards_icon_accessibility_text",
        defaultMessage: "Board icon"
    },
    date_filter_today_label: {
        id: "product_search_dialog.jira.date_filter_today",
        defaultMessage: "Today"
    },
    date_filter_yesterday_label: {
        id: "product_search_dialog.jira.date_filter_yesterday",
        defaultMessage: "Yesterday"
    },
    date_filter_past_7_days_label: {
        id: "product_search_dialog.jira.date_filter_past_7_days",
        defaultMessage: "Past 7 days"
    },
    date_filter_past_30_days_label: {
        id: "product_search_dialog.jira.date_filter_past_30_days",
        defaultMessage: "Past 30 days"
    },
    date_filter_past_year_label: {
        id: "product_search_dialog.jira.date_filter_past_year",
        defaultMessage: "Past year"
    },
    report_by_filters_title: {
        id: "product_search_dialog.jira.report_by_filters",
        defaultMessage: "Filter by reporter"
    },
    reported_by_me_filter_option: {
        id: "product_search_dialog.jira.reported_by_me_filter",
        defaultMessage: "Reported by me"
    },
    issue_labels_filters_title: {
        id: "product_search_dialog.jira.issue_labels_filters",
        defaultMessage: "Filter by label"
    },
    issue_labels_filters_placeholder: {
        id: "product_search_dialog.jira.issue_labels_filters_placeholder",
        defaultMessage: "Select label"
    },
    issue_labels_filters_options_group_label: {
        id: "product_search_dialog.jira.issue_labels_filters_options_group_label",
        defaultMessage: "All labels"
    }
});

});

parcelRegister("71A0K", function(module, exports) {

$parcel$export(module.exports, "useFiltersClient", () => $941b6ab9222e6d09$export$86c53720f7942492);

var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");

var $4azzq = parcelRequire("4azzq");

var $169DF = parcelRequire("169DF");

var $cfEFl = parcelRequire("cfEFl");
var $c3kEC = parcelRequire("c3kEC");

var $kmpep = parcelRequire("kmpep");

var $aAuSn = parcelRequire("aAuSn");

var $csnse = parcelRequire("csnse");

var $lF5IG = parcelRequire("lF5IG");

var $cfEFl = parcelRequire("cfEFl");

var $jV49M = parcelRequire("jV49M");

var $dwp40 = parcelRequire("dwp40");

var $3S0fp = parcelRequire("3S0fp");
var $6dP89 = parcelRequire("6dP89");

var $7TH2w = parcelRequire("7TH2w");
// Jira uses this for performance monitoring/debugging
const $941b6ab9222e6d09$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
const $941b6ab9222e6d09$var$getCollabGraphClientWithConfig = (0, $csnse.default)((config)=>new (0, $cfEFl.CollaborationGraphClient)({
        collaborationGraphUrl: config.collaborationGraphUrl,
        cloudId: config.cloudId,
        isMultiSite: config.isMultiSite,
        sites: config.sites
    }), (0, (/*@__PURE__*/$parcel$interopDefault($aAuSn))));
const $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS = 3;
const $941b6ab9222e6d09$export$86c53720f7942492 = (config)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { jiraSites: jiraSites } = (0, $lF5IG.useSearchConfigContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const statusFilterOptions = [
        {
            id: 'open',
            filterSource: (0, $169DF.FilterOptionSource).STATIC,
            isChecked: false,
            isVisible: true,
            label: formatMessage((0, $bF0iL.messages).binary_status_category_filter_option_open)
        },
        {
            id: 'done',
            filterSource: (0, $169DF.FilterOptionSource).STATIC,
            isChecked: false,
            isVisible: true,
            label: formatMessage((0, $bF0iL.messages).binary_status_category_filter_option_done)
        }
    ];
    const jiraScopeFilterItemMapper = (item, isVisible, isRecent)=>({
            id: item.id,
            avatarUrl: item.avatarUrl || item.attributes?.avatar?.url,
            label: item.name,
            filterSource: isRecent ? (0, $169DF.FilterOptionSource).RECENT : (0, $169DF.FilterOptionSource).SEARCH,
            isChecked: false,
            isVisible: isVisible
        });
    const filterSupplier = async (currentScope, query, defaultItem)=>{
        if (!aggregatorClient) return [];
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: '',
                referrerId: null
            },
            scopes: [
                currentScope
            ],
            modelParams: [],
            resultLimit: (0, $4azzq.FILTER_LIST_LIMIT),
            experience: (0, $4azzq.NAVIGATION_V3_EXPERIENCE)
        }).then(({ response: response })=>{
            if (!response) throw (0, $c3kEC.responseErrorToError)(`Expected a response but did not get any for scope: ${currentScope}`);
            const scopedResponse = response.retrieveScope(currentScope);
            if (!scopedResponse) throw new Error(`Expected a response but did not get any for scope: ${currentScope}`);
            if (scopedResponse.error) throw (0, $c3kEC.responseErrorToError)(scopedResponse.error);
            const maxVisible = defaultItem !== undefined ? $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS - 1 : $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS;
            const options = scopedResponse.results.map((result, i)=>jiraScopeFilterItemMapper(result, i < maxVisible, query === ''));
            return defaultItem !== undefined ? [
                defaultItem,
                ...options
            ] : options;
        });
    };
    const fetchCollabGraphProjectOptions = async ()=>{
        const collabGraphClient = $941b6ab9222e6d09$var$getCollabGraphClientWithConfig({
            collaborationGraphUrl: config?.collaborationGraphUrl || (0, $4azzq.DEFAULT_COLLAB_GRAPH_URL),
            cloudId: config?.cloudId || '',
            isMultiSite: jiraSites?.length > 1,
            sites: jiraSites
        });
        return await collabGraphClient.getContainers([
            'jiraProject'
        ], jiraSites).then(({ collaborationGraphEntities: collaborationGraphEntities })=>{
            return collaborationGraphEntities.map((entity, i)=>({
                    label: entity.containerDetails.name,
                    id: entity.containerDetails.id,
                    avatarUrl: entity.containerDetails.iconUrl,
                    filterSource: (0, $169DF.FilterOptionSource).COLLABORATION_GRAPH,
                    isChecked: false,
                    isVisible: i < $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS
                }));
        });
    };
    const interleaveCGAndRecentResults = async (uniqueFn, collabGraphOptions)=>{
        if (collabGraphOptions?.length === (0, $cfEFl.MAX_CG_RESULTS)) return collabGraphOptions;
        else try {
            const recentOptions = await filterSupplier((0, $4azzq.JiraScope).Project, '');
            return collabGraphOptions?.length ? (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))([
                ...collabGraphOptions,
                ...recentOptions
            ], uniqueFn).map((item, i)=>({
                    ...item,
                    isVisible: i < $941b6ab9222e6d09$var$MAX_VISIBLE_ITEMS
                })) : recentOptions;
        } catch (e) {
            return collabGraphOptions?.length ? collabGraphOptions : [];
        }
    };
    const getProjectOptions = async ()=>{
        let collaborationGraphOptions;
        if (!!config?.cloudId) collaborationGraphOptions = await fetchCollabGraphProjectOptions();
        const interleavedResults = await interleaveCGAndRecentResults((project)=>project.id, collaborationGraphOptions);
        return interleavedResults;
    };
    const issueLabelFilterItemMapper = (issueLabel, isExternal)=>{
        return {
            id: (0, $3S0fp.sha256Hash)(`${config?.cloudId || ''}_${issueLabel.label}`),
            filterSource: isExternal ? (0, $169DF.FilterOptionSource).EXTERNAL : (0, $169DF.FilterOptionSource).SEARCH,
            isChecked: false,
            isVisible: isExternal,
            label: issueLabel.label
        };
    };
    const fireOperationalEvent = (payload)=>{
        fireAnalyticsEvent({
            eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
            source: 'searchDialog',
            ...payload
        });
    };
    const fetchIssueLabelOptions = async (query)=>{
        const params = new URLSearchParams([
            [
                'query',
                query
            ]
        ]);
        const path = `${(0, $4azzq.DEFAULT_ISSUE_LABELS_SERVICE_URL)}?${params.toString()}`;
        const options = {
            requestInit: {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    [$941b6ab9222e6d09$var$CAPABILITY_HEADER_NAME]: 'PRODUCT_SEARCH_DIALOG'
                }
            }
        };
        try {
            return await (0, $dwp40.utils).requestService({
                url: path
            }, options).then((response)=>response?.suggestions?.map((issueLabel)=>issueLabelFilterItemMapper(issueLabel, query === '')));
        } catch (error) {
            fireOperationalEvent({
                action: 'failed',
                actionSubject: 'fetchIssueLabels',
                attributes: {
                    error: (0, $c3kEC.responseErrorToError)(error).message
                }
            });
            return [];
        }
    };
    return {
        mapJiraScopeFilterItem: jiraScopeFilterItemMapper,
        mapIssueLabelFilterItem: issueLabelFilterItemMapper,
        statusFilterOptions: statusFilterOptions,
        fetchIssueLabelOptions: fetchIssueLabelOptions,
        fetchCollabGraphProjectOptions: fetchCollabGraphProjectOptions,
        getProjectOptions: getProjectOptions,
        getFilterItemsByJiraScope: filterSupplier
    };
};

});

parcelRegister("ly8Ih", function(module, exports) {

$parcel$export(module.exports, "FilterColLabText", () => $d5b9dbc2d7e6b5ed$export$53582861b2eaced6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dTk3A = parcelRequire("dTk3A");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $d5b9dbc2d7e6b5ed$export$53582861b2eaced6 = (0, $gwrgp.default)("span", {
    target: "ekcv2vh0"
})({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $dTk3A.gridSize)() * 22}px`,
    paddingLeft: "var(--ds-space-050, 4px)",
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
});

});


parcelRegister("hlU74", function(module, exports) {

$parcel$export(module.exports, "useSections", () => $8845a8b56f4b6117$export$5e1b8123b0df487f);

var $7UHDa = parcelRequire("7UHDa");

var $dh538 = parcelRequire("dh538");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");

var $4azzq = parcelRequire("4azzq");

var $kbm4u = parcelRequire("kbm4u");

var $8WxPE = parcelRequire("8WxPE");

var $ejGzS = parcelRequire("ejGzS");

var $9PsEY = parcelRequire("9PsEY");

var $ekojD = parcelRequire("ekojD");

var $4JMD6 = parcelRequire("4JMD6");

var $gCJWJ = parcelRequire("gCJWJ");

var $hcMBV = parcelRequire("hcMBV");

const $8845a8b56f4b6117$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("2OJsk")).then((mod)=>({
            default: mod.HoverCard
        })));
const $8845a8b56f4b6117$var$HoverCardResultWrapper = ({ children: children, url: url = '', titleId: titleId = '' })=>{
    const hidePreviewAction = (0, $gwFzn.useMemo)(()=>{
        return {
            hide: false,
            exclude: [
                (0, $hcMBV.CardAction).PreviewAction
            ]
        };
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9PsEY.HoverCardWrapper), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gCJWJ.default), {
            fallback: children,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Suspense, {
                fallback: children,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)($8845a8b56f4b6117$var$HoverCard, {
                    url: url,
                    actionOptions: hidePreviewAction,
                    role: "dialog",
                    titleId: titleId,
                    children: children
                })
            })
        })
    });
};
const $8845a8b56f4b6117$var$viewAllLinkRendererIssues = ({ section: section, totalResults: totalResults })=>{
    const isTotalItemsGreaterThanTheLimit = (totalResults || section.searchResults?.length) > (section.resultLimit || 0);
    return isTotalItemsGreaterThanTheLimit ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $bF0iL.messages).common_show_all_results_link
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $8845a8b56f4b6117$export$5e1b8123b0df487f = (hasAdvancedRoadmapsAccess, hasSoftwareAccess, viewAllLinkGenerator, isPreviewOnJiraSearchResultsEnabled, intl, formatDate, isConsistentIssueDetailsEnabled, autocorrectEnabled)=>{
    const appendQueryParams = (0, $kbm4u.useQueryParams)();
    const mapJiraItems = (response)=>response.results.map((item)=>{
            const base = {
                id: item.id,
                title: item.name,
                url: appendQueryParams(item.url || '', item),
                meta: '',
                iconUrl: item.attributes?.avatar?.url || '',
                type: item.attributes['@type']
            };
            if (item.attributes && item.attributes['@type'] === (0, $8WxPE.AttributeType).issue) return {
                ...base,
                title: `${item.attributes?.key}  ${item.name}`,
                meta: item.attributes?.container?.title || '',
                containerId: item.attributes?.containerId,
                additionalMeta: (0, $ekojD.getTimeDetailForJiraIssueResult)(intl, formatDate, item.attributes?.updated)
            };
            if (item.attributes && item.attributes['@type'] === (0, $8WxPE.AttributeType).board) return {
                ...base,
                meta: item.attributes?.container?.title || '',
                containerId: item.attributes?.containerId
            };
            return base;
        });
    const getSectionDetailsByAccess = ()=>{
        if (hasAdvancedRoadmapsAccess) return {
            scope: (0, $4azzq.JiraScope).BoardProjectFilterPlans,
            recentHeading: (0, $bF0iL.messages).jira_recent_boards_projects_filters_plans_section_heading,
            searchHeading: (0, $bF0iL.messages).jira_boards_projects_filters_plans_section_heading
        };
        if (hasSoftwareAccess) return {
            scope: (0, $4azzq.JiraScope).BoardProjectFilter,
            recentHeading: (0, $bF0iL.messages).jira_recent_boards_projects_filters_section_heading,
            searchHeading: (0, $bF0iL.messages).jira_boards_projects_filters_section_heading
        };
        return {
            scope: (0, $4azzq.JiraScope).ProjectFilter,
            recentHeading: (0, $bF0iL.messages).jira_recent_projects_filters_section_heading,
            searchHeading: (0, $bF0iL.messages).jira_projects_filters_section_heading
        };
    };
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const secondSectionDetails = getSectionDetailsByAccess();
    const enableNoIssueSection = (query, filters)=>!filters.find((filter)=>filter['accountIds']?.length > 0 || filter['projectIds']?.length > 0 || filter['binaryStatusCategories']?.length > 0 || filter['issueLabels']?.length > 0);
    const resultRenderer = ()=>{
        return (args)=>(0, $ejGzS.defaultResultRenderer)(isConsistentIssueDetailsEnabled ? {
                ...args,
                isCollapsed: true
            } : args);
    };
    const sections = [
        {
            id: (0, $4azzq.JiraScope).Issue,
            title: formatMessage((0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_issues_section_headingIssueTermRefresh : (0, $bF0iL.messages).jira_issues_section_heading),
            titleRenderer: (0, $4JMD6.sectionTitleRenderer)(!!autocorrectEnabled),
            scope: (0, $4azzq.JiraScope).Issue,
            resultMapper: mapJiraItems,
            showResultCount: true,
            resultLimit: (0, $4azzq.ISSUE_LIST_LIMIT),
            viewAllLinkRenderer: $8845a8b56f4b6117$var$viewAllLinkRendererIssues,
            resultRenderer: resultRenderer(),
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultWrapper: isPreviewOnJiraSearchResultsEnabled ? $8845a8b56f4b6117$var$HoverCardResultWrapper : undefined
        },
        {
            id: secondSectionDetails.scope,
            title: formatMessage(secondSectionDetails.searchHeading),
            scope: secondSectionDetails.scope,
            resultMapper: mapJiraItems,
            isEnabled: enableNoIssueSection,
            resultLimit: hasAdvancedRoadmapsAccess ? (0, $4azzq.OTHERS_LIST_LIMIT_ADVANCED_ROADMAPS_ACCESS) : (0, $4azzq.OTHERS_LIST_LIMIT_NO_ADVANCED_ROADMAPS_ACCESS)
        }
    ];
    const recentSectionTitleGenerator = (section)=>section.id === (0, $4azzq.JiraScope).Issue ? formatMessage((0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_recently_viewed_issues_section_headingIssueTermRefresh : (0, $bF0iL.messages).jira_recently_viewed_issues_section_heading) : formatMessage(secondSectionDetails.recentHeading);
    return {
        recentSectionTitleGenerator: recentSectionTitleGenerator,
        sections: sections,
        mapJiraItems: mapJiraItems,
        getSectionDetailsByAccess: getSectionDetailsByAccess
    };
};

});
parcelRegister("kbm4u", function(module, exports) {

$parcel$export(module.exports, "useQueryParams", () => $01f8562883944ff4$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "appendQueryParams", () => $01f8562883944ff4$export$a0b32aef6b0d7373);

var $idlpk = parcelRequire("idlpk");

var $8WxPE = parcelRequire("8WxPE");

var $2OcMi = parcelRequire("2OcMi");
const $01f8562883944ff4$export$fd0142e43ea55591 = (href, searchResult)=>{
    const hrefWithReferrals = (0, $idlpk.attachJiraReferralIds)(href, {
        searchObjectId: searchResult.id,
        searchContainerId: searchResult.attributes.containerId,
        searchContentType: (0, $8WxPE.AttributeType).issue
    });
    return hrefWithReferrals;
};
const $01f8562883944ff4$export$8aceb1d6e8b68a94 = (href, searchResult)=>{
    const containerAttribute = searchResult.attributes['@type'] === (0, $8WxPE.AttributeType).board ? {
        searchContainerId: searchResult.attributes.containerId
    } : {};
    const contentTypeAttribute = {
        searchContentType: searchResult.attributes['@type']
    };
    const hrefWithReferrals = (0, $idlpk.attachJiraReferralIds)(href, {
        ...contentTypeAttribute,
        ...containerAttribute,
        searchObjectId: searchResult.id
    });
    return hrefWithReferrals;
};
const $01f8562883944ff4$export$b37ee0d76c6d2fbc = ()=>{
    return (href, searchResult)=>{
        if (searchResult.attributes['@type'] === (0, $8WxPE.AttributeType).issue) return $01f8562883944ff4$export$fd0142e43ea55591(href, searchResult);
        return $01f8562883944ff4$export$8aceb1d6e8b68a94(href, searchResult);
    };
};
const $01f8562883944ff4$export$a0b32aef6b0d7373 = (url, searchSessionId)=>{
    return (0, $2OcMi.addQueryParams)(url, {
        searchSessionId: searchSessionId
    });
};

});
parcelRegister("idlpk", function(module, exports) {

$parcel$export(module.exports, "attachJiraReferralIds", () => $71fe4fb99370a73e$export$6ad518df41ca9b2f);

var $2OcMi = parcelRequire("2OcMi");
const $71fe4fb99370a73e$export$6ad518df41ca9b2f = (href, ids)=>{
    return (0, $2OcMi.addQueryParams)(href, ids);
};

});


parcelRegister("9PsEY", function(module, exports) {

$parcel$export(module.exports, "HoverCardWrapper", () => $a3507ff98cccb432$export$54477ee883ec6167);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $a3507ff98cccb432$export$54477ee883ec6167 = (0, $gwrgp.default)("div", {
    target: "esh65ev0"
})({
    name: "7wh13m",
    styles: "display:block;width:100%;"
});

});

parcelRegister("ekojD", function(module, exports) {

$parcel$export(module.exports, "getTimeDetailForJiraIssueResult", () => $2dadc7da0d3cdd55$export$1d30bb3376c56ddb);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $bF0iL = parcelRequire("bF0iL");

var $RTf6z = parcelRequire("RTf6z");
const $2dadc7da0d3cdd55$export$1d30bb3376c56ddb = (intl, formatDate, updated)=>{
    if (!updated) {
        const message = intl.formatMessage((0, $bF0iL.messages).common_recently_viewed_section_heading);
        return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            title: message,
            children: message
        });
    }
    if (formatDate) return formatDate(updated);
    else return (0, $RTf6z.dateFormatter)(updated);
};

});
parcelRegister("RTf6z", function(module, exports) {

$parcel$export(module.exports, "dateFormatter", () => $e5e658f2850ebd6c$export$406508d2ca449bd);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $hrzSy = parcelRequire("hrzSy");

var $bF0iL = parcelRequire("bF0iL");
const $e5e658f2850ebd6c$var$SECONDS_IN_MIN = 60;
const $e5e658f2850ebd6c$var$SECONDS_IN_HR = $e5e658f2850ebd6c$var$SECONDS_IN_MIN * 60;
const $e5e658f2850ebd6c$var$SECONDS_IN_DAY = $e5e658f2850ebd6c$var$SECONDS_IN_HR * 24;
const $e5e658f2850ebd6c$export$be5e766167e613a9 = {
    commented: (0, $bF0iL.commentedEventTypeMessages),
    created: (0, $bF0iL.createdEventTypeMessages),
    edited: (0, $bF0iL.editedEventTypeMessages),
    published: (0, $bF0iL.publishedEventTypeMessages),
    updated: (0, $bF0iL.updatedEventTypeMessages),
    viewed: (0, $bF0iL.viewedEventTypeMessages)
};
const $e5e658f2850ebd6c$var$WithUpdatedLabel = (formattedDate)=>{
    const i18nMessage = (0, $bF0iL.messages).common_updated_date_formatter;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...i18nMessage,
        values: {
            date: formattedDate
        }
    });
};
const $e5e658f2850ebd6c$var$recentEventLabel = (eventType)=>{
    const i18nMessage = eventType ? $e5e658f2850ebd6c$export$be5e766167e613a9[eventType] || (0, $bF0iL.defaultEventTypeMessages) : (0, $bF0iL.defaultEventTypeMessages);
    return (formattedDate)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...i18nMessage.relative,
            values: {
                date: formattedDate
            }
        });
};
const $e5e658f2850ebd6c$var$absoluteRecentEventLabel = (eventType)=>{
    const i18nMessage = eventType ? $e5e658f2850ebd6c$export$be5e766167e613a9[eventType] || (0, $bF0iL.defaultEventTypeMessages) : (0, $bF0iL.defaultEventTypeMessages);
    return (formattedDate)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...i18nMessage.absolute,
            values: {
                date: formattedDate
            }
        });
};
function $e5e658f2850ebd6c$export$406508d2ca449bd(lastModified, isRecentActivity, eventType) {
    const secondsSinceUpdate = Math.floor((Date.now() - new Date(lastModified).getTime()) / 1000);
    const totalDays = Math.floor(secondsSinceUpdate / $e5e658f2850ebd6c$var$SECONDS_IN_DAY);
    const totalHours = Math.floor(secondsSinceUpdate / $e5e658f2850ebd6c$var$SECONDS_IN_HR);
    const totalMinutes = Math.floor(secondsSinceUpdate / $e5e658f2850ebd6c$var$SECONDS_IN_MIN);
    if (secondsSinceUpdate > 1 && secondsSinceUpdate < 60) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
        value: -secondsSinceUpdate,
        style: "narrow",
        unit: "second",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    if (totalMinutes >= 1 && totalMinutes < 60) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
        value: -totalMinutes,
        style: "narrow",
        unit: "minute",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    if (totalHours >= 1 && totalHours < 24) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
        value: -totalHours,
        style: "narrow",
        unit: "hour",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    if (totalDays >= 1 && totalDays < 8) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hrzSy.default), {
        value: -totalDays,
        style: "narrow",
        unit: "day",
        children: isRecentActivity ? $e5e658f2850ebd6c$var$recentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2nPZH.FormattedDate), {
        year: "numeric",
        month: "short",
        day: "2-digit",
        value: lastModified,
        children: isRecentActivity ? $e5e658f2850ebd6c$var$absoluteRecentEventLabel(eventType) : $e5e658f2850ebd6c$var$WithUpdatedLabel
    });
}

});


parcelRegister("4JMD6", function(module, exports) {

$parcel$export(module.exports, "sectionTitleRenderer", () => $6d4c433494a08e6d$export$aee00814c9e3bae7);

var $7UHDa = parcelRequire("7UHDa");

var $dh538 = parcelRequire("dh538");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $bF0iL = parcelRequire("bF0iL");

var $jFPud = parcelRequire("jFPud");

var $eEbYb = parcelRequire("eEbYb");

var $21MH9 = parcelRequire("21MH9");
const $6d4c433494a08e6d$export$aee00814c9e3bae7 = (autocorrectEnabled)=>(args)=>{
        const { productState: productState } = args;
        const recentTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $bF0iL.messages).common_recently_viewed_section_heading
        });
        const issuesTitleMessage = (0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_issues_section_headingIssueTermRefresh : (0, $bF0iL.messages).jira_issues_section_heading;
        const issuesTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...issuesTitleMessage
        });
        switch(productState){
            case (0, $jFPud.ProductStates).PreQuerySuccess:
                return recentTitle;
            case (0, $jFPud.ProductStates).PostQueryLoading:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEbYb.LoadingSkeleton), {
                    "data-testid": 'autocorrection-loading-skeleton'
                });
                return issuesTitle;
            case (0, $jFPud.ProductStates).PostQuerySuccess:
                if (autocorrectEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $21MH9.AutocorrectAsyncWrapper), {
                    fallback: issuesTitle
                });
                return issuesTitle;
            default:
                return issuesTitle;
        }
    };

});

parcelRegister("gCJWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b77b2477746b3ccd$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
class $b77b2477746b3ccd$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onError && this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
var $b77b2477746b3ccd$export$2e2bcd8739ae039 = $b77b2477746b3ccd$var$ErrorBoundary;

});

parcelRegister("2OJsk", function(module, exports) {

let $20d382e23ad2dec7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $20d382e23ad2dec7$var$load("15APZ"),
    $20d382e23ad2dec7$var$load("2w2Fa"),
    $20d382e23ad2dec7$var$load("9QvHa"),
    $20d382e23ad2dec7$var$load("3ooAX"),
    $20d382e23ad2dec7$var$load("4lfDj"),
    $20d382e23ad2dec7$var$load("dTsOE"),
    $20d382e23ad2dec7$var$load("9Rd6U"),
    $20d382e23ad2dec7$var$load("aZinD"),
    $20d382e23ad2dec7$var$load("2S1L6"),
    $20d382e23ad2dec7$var$load("EfTik")
]).then(()=>parcelRequire('1JhVb'));

});


parcelRegister("btY8w", function(module, exports) {

$parcel$export(module.exports, "useURLFactory", () => $418b29c7f9ac3680$export$f63780fc2b3633e);

var $gwFzn = parcelRequire("gwFzn");

var $4azzq = parcelRequire("4azzq");
/**
 * Builds a JQL query for text search input using summary and description
 */ const $418b29c7f9ac3680$var$buildTextSearchInputJql = (query)=>{
    if (!query) return '';
    const encodedQuery = encodeURIComponent(query);
    return `textfields ~ "${encodedQuery}*"`;
};
const $418b29c7f9ac3680$var$buildJQLAdvancedIssueUrl = (jql)=>`/issues/?jql=${jql}`;
const $418b29c7f9ac3680$var$buildJiraSearchUrl = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $418b29c7f9ac3680$var$buildSmartQueryAdvancedSearchUrl = (query)=>`/secure/QuickSearch.jspa?searchString=${encodeURIComponent(query)}`;
const $418b29c7f9ac3680$var$escapeAndQuoteLabels = (label)=>{
    // Escape backslashes and double quotes
    const escapedLabel = label.replace(/([\\"])/g, '\\$1');
    // Wrap the escaped label in double quotes
    return `"${escapedLabel}"`;
};
const $418b29c7f9ac3680$var$buildJqlQuery = (query, projectIds, accountIds, reporterIds, binaryStatusCategoryValues, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled)=>{
    let textJQL;
    if (isSearchWithTextFieldInAllIssuesLinkEnabled) textJQL = query ? `text ~ "${encodeURIComponent(query)}*"` : '';
    else textJQL = query ? $418b29c7f9ac3680$var$buildTextSearchInputJql(query) : '';
    const projectJQL = projectIds.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : '';
    const assigneeJQL = accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : '';
    const issueLabelsJQL = issueLabels.length > 0 ? `labels IN (${encodeURIComponent(issueLabels.map((label)=>$418b29c7f9ac3680$var$escapeAndQuoteLabels(label)).join(','))})` : '';
    const reporterJQL = reporterIds.length > 0 ? `reporter IN (${encodeURIComponent(reporterIds.join(','))})` : '';
    const updateDateJQL = appliedDateFilterValue !== null ? `updated >= "${appliedDateFilterValue.from}" AND updated <= "${appliedDateFilterValue.to}"` : '';
    const binaryStatusCategoryJQL = binaryStatusCategoryValues?.length === 1 ? `statusCategory IN (${encodeURIComponent($418b29c7f9ac3680$var$getStatusesByStatusCategory(binaryStatusCategoryValues))})` : '';
    return [
        textJQL,
        projectJQL,
        assigneeJQL,
        reporterJQL,
        binaryStatusCategoryJQL,
        issueLabelsJQL,
        updateDateJQL
    ].filter(Boolean).join(' AND ');
};
const $418b29c7f9ac3680$var$getStatusesByStatusCategory = (values)=>{
    if (!!values.find((v)=>v === 'open')) return '"undefined", "In Progress", "To Do"';
    if (!!values.find((v)=>v === 'done')) return '"Done"';
    return '';
};
const $418b29c7f9ac3680$export$f63780fc2b3633e = (filterValueGetters, appliedDateFilterValue, isPreQueryFiltersEnabled, isSearchWithTextFieldInAllIssuesLinkEnabled = false)=>{
    const buildJiraAdvancedSearchPath = (0, $gwFzn.useCallback)((query)=>{
        const trimmedQuery = query.trim();
        const projectIds = filterValueGetters.projects();
        const accountIds = filterValueGetters.assignees();
        const reporterIds = filterValueGetters.reportedBy();
        const binaryStatusCategories = filterValueGetters.statuses();
        const issueLabels = filterValueGetters.issueLabels();
        // If there is a filter applied, and either a query is provided or isPreQueryFiltersEnabled is true, then we build the JQL
        if ((projectIds.length !== 0 || accountIds.length !== 0 || reporterIds.length !== 0 || binaryStatusCategories.length === 1 || issueLabels.length !== 0 || appliedDateFilterValue !== null) && (trimmedQuery || isPreQueryFiltersEnabled)) return $418b29c7f9ac3680$var$buildJQLAdvancedIssueUrl($418b29c7f9ac3680$var$buildJqlQuery(trimmedQuery, projectIds, accountIds, reporterIds, binaryStatusCategories, issueLabels, appliedDateFilterValue, isSearchWithTextFieldInAllIssuesLinkEnabled));
        // Otherwise we determine next action based on whether a query is provided or not
        if (!trimmedQuery) // If query is empty, we utilise a spa transition with ISSUE_NAVIGATOR_URL
        return query === '' ? (0, $4azzq.ISSUE_NAVIGATOR_URL) : $418b29c7f9ac3680$var$buildSmartQueryAdvancedSearchUrl(query);
        return $418b29c7f9ac3680$var$buildJiraSearchUrl(trimmedQuery);
    }, [
        filterValueGetters,
        appliedDateFilterValue,
        isPreQueryFiltersEnabled,
        isSearchWithTextFieldInAllIssuesLinkEnabled
    ]);
    const useFiltersAdvancedSearchUrlFactory = (0, $gwFzn.useCallback)((query, siteUrl)=>`${siteUrl ?? ''}${buildJiraAdvancedSearchPath(query)}`, [
        buildJiraAdvancedSearchPath
    ]);
    return {
        getFiltersAdvancedSearchUrl: useFiltersAdvancedSearchUrlFactory
    };
};

});

parcelRegister("1Yciq", function(module, exports) {

$parcel$export(module.exports, "JiraAdvancedSearch", () => $2ede78aae473f56f$export$f8ed21c35936f5aa);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $lnXRc = parcelRequire("lnXRc");

var $5dFS9 = parcelRequire("5dFS9");

var $bF0iL = parcelRequire("bF0iL");

var $dBxQj = parcelRequire("dBxQj");

var $bKrl4 = parcelRequire("bKrl4");
const $2ede78aae473f56f$export$f5d288a16f3b101c = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bKrl4.GetDefaultFooter), {
            returnKeyIconComponent: props.returnKeyIconComponent,
            linkComponent: props.linkComponent,
            productState: props.productState,
            searchFooterLabel: formatMessage((0, $dh538.fg)('jira-issue-terminology-refresh-m3') ? (0, $bF0iL.messages).jira_view_all_issues_newIssueTermRefresh : (0, $bF0iL.messages).jira_view_all_issues_new)
        })
    });
};
const $2ede78aae473f56f$export$f8ed21c35936f5aa = (0, $lnXRc.withAnalytics)({
    advancedSearchSelected: (0, $5dFS9.onAdvancedSearchSelected)
})($2ede78aae473f56f$export$f5d288a16f3b101c);
var $2ede78aae473f56f$export$2e2bcd8739ae039 = $2ede78aae473f56f$export$f8ed21c35936f5aa;

});
parcelRegister("bKrl4", function(module, exports) {

$parcel$export(module.exports, "GetDefaultFooter", () => $a98761a6028dbe88$export$e3c8b9bd86c3cfd6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4mZlP = parcelRequire("4mZlP");

var $crAJ1 = parcelRequire("crAJ1");
const $a98761a6028dbe88$export$e3c8b9bd86c3cfd6 = ({ productState: productState, ...rest })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
            ...rest
        })
    });
};

});


parcelRegister("dKB22", function(module, exports) {

$parcel$export(module.exports, "defaultPermissionsSupplier", () => $4b29f03d0096a2d7$export$79b79eb7219cb5fd);

var $8WxPE = parcelRequire("8WxPE");
const $4b29f03d0096a2d7$export$79b79eb7219cb5fd = ()=>{
    const response = Object.values((0, $8WxPE.Scope));
    return Promise.resolve(response);
};

});

parcelRegister("iE5Vg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca3b19d515fa565d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $3S0fp = parcelRequire("3S0fp");

var $5dFS9 = parcelRequire("5dFS9");

var $bF0iL = parcelRequire("bF0iL");

var $2ZIpG = parcelRequire("2ZIpG");

var $ebWzW = parcelRequire("ebWzW");
const $ca3b19d515fa565d$export$4c85ccfa2dce935c = (query, features)=>{
    let allLinks = {
        board: {
            href: `/secure/ManageRapidViews.jspa?contains=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_boards,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_BOARDS
        },
        project: {
            href: `/projects?contains=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_projects,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_PROJECTS
        },
        filters: {
            href: `/secure/ManageFilters.jspa?Search=Search&filterView=search&name=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_filters,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_FILTERS
        },
        plans: {
            href: `/jira/plans`,
            message: (0, $bF0iL.messages).jira_advanced_search_plans,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_PLANS
        },
        people: {
            href: `/jira/people/search?q=${query}`,
            message: (0, $bF0iL.messages).jira_advanced_search_people,
            actionSubjectId: (0, $5dFS9.AdvancedSearchLinkSubjectId).JIRA_PEOPLE
        }
    };
    // Remove access to plans if the user does not have Advanced Roadmaps access
    if (!features?.hasAdvancedRoadmapsAccess) delete allLinks.plans;
    // Remove access to boards if the user does not have software access
    if (!features?.hasAdvancedRoadmapsAccess && !features?.hasSoftwareAccess) delete allLinks.board;
    return allLinks;
};
const $ca3b19d515fa565d$export$b16edfe49ade2612 = ({ advancedSearchSelected: advancedSearchSelected, features: features, linkComponent: linkComponent })=>{
    const { query: query, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const onClickAndFireEvent = (e, actionSubjectId)=>{
        e.preventDefault();
        advancedSearchSelected({
            actionSubjectId: actionSubjectId,
            trigger: (0, $3S0fp.getTrigger)(e),
            isLoading: isLoading,
            newTab: (0, $3S0fp.isNewTab)(e)
        });
    };
    const searchConfiguration = $ca3b19d515fa565d$export$4c85ccfa2dce935c(query, features);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ebWzW.AdvancedSearchContainer), {
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
            as: "ul",
            xcss: $ca3b19d515fa565d$var$advancedSearchListStyles,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ebWzW.LabelContainer), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $bF0iL.messages).jira_advanced_search_label
                    })
                }),
                Object.keys(searchConfiguration).map((key)=>{
                    const { href: href, message: message, actionSubjectId: actionSubjectId } = searchConfiguration[key];
                    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                        as: "li",
                        xcss: $ca3b19d515fa565d$var$advancedSearchListItemStyles,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            onClick: (e)=>onClickAndFireEvent(e, actionSubjectId),
                            role: "none",
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ebWzW.StyledLink), {
                                linkComponent: linkComponent,
                                href: href,
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                    ...message
                                })
                            }, `search_link_${key}`)
                        })
                    });
                })
            ]
        })
    });
};
const $ca3b19d515fa565d$var$advancedSearchListStyles = (0, $ecnYn.xcss)({
    padding: '0',
    margin: '0',
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'row'
});
const $ca3b19d515fa565d$var$advancedSearchListItemStyles = (0, $ecnYn.xcss)({
    margin: '0',
    padding: '0'
});
var $ca3b19d515fa565d$export$2e2bcd8739ae039 = (0, $js7oX.default)($ca3b19d515fa565d$export$b16edfe49ade2612);

});
parcelRegister("ebWzW", function(module, exports) {

$parcel$export(module.exports, "AdvancedSearchContainer", () => $34cfde37e0470e3c$export$cb4aeb4aba07ad10);
$parcel$export(module.exports, "LabelContainer", () => $34cfde37e0470e3c$export$f5ae33f1b01a6402);
$parcel$export(module.exports, "StyledLink", () => $34cfde37e0470e3c$export$9048d548939551ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $kPBHE = parcelRequire("kPBHE");

var $gwrgp = parcelRequire("gwrgp");
const $34cfde37e0470e3c$export$cb4aeb4aba07ad10 = (0, $gwrgp.default)("div", {
    target: "eq9f4ne0"
})({
    name: "1jz6vo9",
    styles: "padding:var(--ds-space-200, 16px);"
});
const $34cfde37e0470e3c$export$f5ae33f1b01a6402 = (0, $gwrgp.default)("span", {
    target: "eq9f4ne1"
})({
    marginRight: "var(--ds-space-100, 8px)",
    color: `var(--ds-text, ${(0, $6fnsQ.N900)})`,
    '&:hover, &:focus': {
        color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':visited': {
        color: `var(--ds-text, ${(0, $6fnsQ.N900)})`
    }
});
const $34cfde37e0470e3c$export$9048d548939551ee = /*#__PURE__*/ (0, $gwrgp.default)((0, $kPBHE.Link), {
    target: "eq9f4ne2"
})({
    WebkitBoxAlign: 'baseline',
    alignItems: 'baseline',
    boxSizing: 'border-box',
    display: 'inline-flex',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    textAlign: 'center',
    whiteSpace: 'nowrap',
    borderRadius: '3px',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-150, 8px)"}`,
    marginRight: "var(--ds-space-050, 4px)",
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
    transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`,
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $6fnsQ.N30)})`,
        textDecoration: 'none',
        transition: 'background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
    },
    '&:visited, &:focus-visible, &:focus': {
        color: `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`
    }
});

});


parcelRegister("3cM77", function(module, exports) {

$parcel$export(module.exports, "default", () => $542edd51ae7cea6d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $a7YLG = parcelRequire("a7YLG");

var $js7oX = parcelRequire("js7oX");

var $bF0iL = parcelRequire("bF0iL");

const $542edd51ae7cea6d$var$Image = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("gOGN4")));
const $542edd51ae7cea6d$var$NoPreQueryResults = ({ intl: intl, message: message })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $a7YLG.EmptyState), {
        title: intl.formatMessage(message || (0, $bF0iL.messages).common_empty_state_prequery_heading),
        Image: $542edd51ae7cea6d$var$Image
    });
var $542edd51ae7cea6d$export$2e2bcd8739ae039 = (0, $js7oX.default)($542edd51ae7cea6d$var$NoPreQueryResults);

});
parcelRegister("gOGN4", function(module, exports) {

let $c3e28228a18a4253$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3e28228a18a4253$var$load("3BloW").then(()=>parcelRequire('4SDWJ'));

});


parcelRegister("5906J", function(module, exports) {

$parcel$export(module.exports, "useJiraDateFilter", () => $ad28263e005306c5$export$ab45d91883e25704);

var $gwFzn = parcelRequire("gwFzn");

var $4azzq = parcelRequire("4azzq");

var $169DF = parcelRequire("169DF");

var $88j1D = parcelRequire("88j1D");
var $kzbg7 = parcelRequire("kzbg7");

var $aZ2wG = parcelRequire("aZ2wG");

var $bF0iL = parcelRequire("bF0iL");

var $dBxQj = parcelRequire("dBxQj");
// The toOffset default is -1 because the 'to' date is not inclusive,
//  so we set it to the tomorrow's date to include results from today
const $ad28263e005306c5$var$getDateRange = (fromOffset, toOffset = -1)=>{
    const from = new Date();
    const to = new Date();
    from.setDate(from.getDate() - fromOffset);
    to.setDate(to.getDate() - toOffset);
    return {
        from: from.toISOString().split('T')[0],
        to: to.toISOString().split('T')[0]
    };
};
const $ad28263e005306c5$export$ab45d91883e25704 = ({ isDateFromFilterEnabled: isDateFromFilterEnabled })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const dateFilterOptionsAndValues = (0, $gwFzn.useMemo)(()=>{
        return !isDateFromFilterEnabled ? null : {
            [(0, $88j1D.LastModifiedValues).DEFAULT]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).DEFAULT,
                    label: formatMessage((0, $bF0iL.messages).date_filter_any_time_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: true,
                    isVisible: true
                },
                dateRange: {
                    from: '',
                    to: ''
                }
            },
            [(0, $88j1D.LastModifiedValues).TODAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).TODAY,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_today_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(0)
            },
            [(0, $88j1D.LastModifiedValues).YESTERDAY]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).YESTERDAY,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_yesterday_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(1, 0)
            },
            [(0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_SEVEN_DAYS,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_past_7_days_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(7)
            },
            [(0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_THIRTY_DAYS,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_past_30_days_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(30)
            },
            [(0, $88j1D.LastModifiedValues).PAST_YEAR]: {
                filter: {
                    id: (0, $88j1D.LastModifiedValues).PAST_YEAR,
                    label: formatMessage((0, $aZ2wG.messages).date_filter_past_year_label),
                    filterSource: (0, $169DF.FilterOptionSource).STATIC,
                    avatarUrl: '',
                    isChecked: false,
                    isVisible: true
                },
                dateRange: $ad28263e005306c5$var$getDateRange(365)
            }
        };
    }, [
        isDateFromFilterEnabled,
        formatMessage
    ]);
    const dateFilterOptions = (0, $gwFzn.useMemo)(()=>dateFilterOptionsAndValues ? Object.values(dateFilterOptionsAndValues).map((value)=>value.filter) : [], [
        dateFilterOptionsAndValues
    ]);
    const dateFilterStore = (0, $kzbg7.useFilterStore)(dateFilterOptions, (0, $4azzq.JIRA_PRODUCT_ID), (0, $4azzq.JiraFilters).Date);
    const appliedDateFilter = dateFilterStore?.availableFilters?.find((f)=>f.isChecked && f.id !== (0, $88j1D.DEFAULT_OPTION))?.id;
    const appliedDateFilterValue = appliedDateFilter && dateFilterOptionsAndValues && dateFilterOptionsAndValues[appliedDateFilter] ? dateFilterOptionsAndValues[appliedDateFilter].dateRange : null;
    const getLastModifiedValue = (0, $gwFzn.useCallback)(()=>{
        return appliedDateFilterValue ? {
            '@type': (0, $4azzq.JiraFilters).Date,
            from: appliedDateFilterValue.from,
            to: appliedDateFilterValue.to
        } : null;
    }, [
        appliedDateFilterValue
    ]);
    const jiraTabDateFilterDefinition = (0, $gwFzn.useMemo)(()=>{
        return isDateFromFilterEnabled ? [
            {
                ['@type']: (0, $4azzq.JiraFilters).Date,
                uiVariant: (0, $88j1D.FilterUIVariant).STATIC_SELECT,
                fieldName: 'from',
                store: dateFilterStore,
                loadFilterOptions: async ()=>[],
                sectionLabel: formatMessage((0, $bF0iL.messages).date_filter_filters_title),
                findMoreLabel: '',
                mapSelectionToAppliedValue: ()=>getLastModifiedValue()
            }
        ] : [];
    }, [
        isDateFromFilterEnabled,
        dateFilterStore,
        formatMessage,
        getLastModifiedValue
    ]);
    return {
        appliedDateFilterValue: appliedDateFilterValue,
        jiraTabDateFilterDefinition: jiraTabDateFilterDefinition,
        dateFilterOptionsAndValues: dateFilterOptionsAndValues
    };
};

});


parcelRegister("4d43O", function(module, exports) {

$parcel$export(module.exports, "FilterContextProvider", () => $67a90fc752dffcfd$export$eb71bf38f5ae0f9c);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");

var $jnLgC = parcelRequire("jnLgC");

var $169DF = parcelRequire("169DF");

var $bF0iL = parcelRequire("bF0iL");

var $hYymy = parcelRequire("hYymy");
var $67a90fc752dffcfd$var$_BinaryStatusCategory;
const $67a90fc752dffcfd$var$BROCCOLI_30_EXPERIMENT = {
    experimentId: 'broccoli-30-frontend',
    days: 30
};
const $67a90fc752dffcfd$var$BROCCOLI_60_EXPERIMENT = {
    experimentId: 'broccoli-60-frontend',
    days: 60
};
const $67a90fc752dffcfd$var$BROCCOLI_90_EXPERIMENT = {
    experimentId: 'broccoli-90-frontend',
    days: 90
};
const $67a90fc752dffcfd$export$40e7ffc2d13a061c = [
    $67a90fc752dffcfd$var$BROCCOLI_30_EXPERIMENT,
    $67a90fc752dffcfd$var$BROCCOLI_60_EXPERIMENT,
    $67a90fc752dffcfd$var$BROCCOLI_90_EXPERIMENT
];
class $67a90fc752dffcfd$export$bea22cefe0b3447c {
    constructor(id, jqlValue){
        this.id = void 0;
        this.jqlValue = void 0;
        this.id = id;
        this.jqlValue = jqlValue;
    }
}
$67a90fc752dffcfd$var$_BinaryStatusCategory = $67a90fc752dffcfd$export$bea22cefe0b3447c;
$67a90fc752dffcfd$export$bea22cefe0b3447c.OPEN = new $67a90fc752dffcfd$var$_BinaryStatusCategory('open', '"undefined", "In Progress", "To Do"');
$67a90fc752dffcfd$export$bea22cefe0b3447c.DONE = new $67a90fc752dffcfd$var$_BinaryStatusCategory('done', '"Done"');
const $67a90fc752dffcfd$export$b5d1c2ef6aead4e6 = [
    {
        title: (0, $bF0iL.messages).binary_status_category_filter_option_open,
        id: $67a90fc752dffcfd$export$bea22cefe0b3447c.OPEN.id,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).STATIC
    },
    {
        title: (0, $bF0iL.messages).binary_status_category_filter_option_done,
        id: $67a90fc752dffcfd$export$bea22cefe0b3447c.DONE.id,
        isChecked: false,
        isVisible: true,
        filterSource: (0, $169DF.FilterOptionSource).STATIC
    }
];
const $67a90fc752dffcfd$export$973ca22476b0e05f = (defaultFilters = [])=>{
    const { filters: filters, dispatch: dispatch } = (0, $jnLgC.useFilter)(defaultFilters);
    const addFilters = (0, $gwFzn.useCallback)((newFilters)=>dispatch((0, $jnLgC.addFilters)(newFilters, (a, b)=>{
            if (a.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER) return -1;
            if (a.filterSource !== (0, $169DF.FilterOptionSource).CURRENT_USER && b.filterSource === (0, $169DF.FilterOptionSource).CURRENT_USER) return 1;
            return 0;
        })), [
        dispatch
    ]);
    const updateFilter = (0, $gwFzn.useCallback)((id, isChecked)=>dispatch((0, $jnLgC.updateFilterState)(id, isChecked, true)), [
        dispatch
    ]);
    const clearFilter = (0, $gwFzn.useCallback)(()=>{
        filters.forEach((f)=>dispatch((0, $jnLgC.updateFilterState)(f.id, false)));
    }, [
        filters,
        dispatch
    ]);
    const resetFilter = (0, $gwFzn.useCallback)(()=>{
        dispatch((0, $jnLgC.replaceAllFilters)(defaultFilters));
    }, [
        defaultFilters,
        dispatch
    ]);
    return {
        availableFilters: filters,
        addFilters: addFilters,
        updateFilter: updateFilter,
        clearFilter: clearFilter,
        reset: resetFilter,
        dispatch: dispatch
    };
};
const $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE = {
    availableFilters: [],
    addFilters: ()=>{},
    updateFilter: ()=>{},
    clearFilter: ()=>{},
    reset: ()=>{},
    dispatch: ()=>{}
};
const $67a90fc752dffcfd$var$FilterContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    projectFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    assigneeFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    siteFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    binaryStatusCategoryFilters: $67a90fc752dffcfd$var$DEFAULT_FILTER_STATE,
    dateFilterFrom: {
        value: '',
        setValue: (_value)=>null
    },
    dateFilterTo: {
        value: '',
        setValue: (_value)=>null
    }
});
function $67a90fc752dffcfd$export$5e1edcb3c154ab79(availableFilters) {
    const appliedFilters = availableFilters.map((availableFilter, index)=>({
            ...availableFilter,
            index: index
        })).filter((filterWithIndex)=>filterWithIndex.isChecked);
    return {
        applied: appliedFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource,
                index: appliedFilter.index
            })),
        recommendedIds: availableFilters.map((appliedFilter)=>({
                id: appliedFilter.id,
                source: appliedFilter.filterSource
            }))
    };
}
const $67a90fc752dffcfd$var$transformDateFiltersForAnalytics = (dateFilterFrom)=>{
    const availiableFilters = $67a90fc752dffcfd$export$40e7ffc2d13a061c.map((experiment)=>experiment.days).map((days)=>[
            days,
            (0, $hYymy.getDateXDaysBack)(days)
        ]);
    const appliedFilter = availiableFilters.filter(([_, date])=>date === dateFilterFrom).map(([days, _])=>({
            id: days
        }));
    return {
        applied: appliedFilter.map(({ id: id })=>({
                id: id,
                source: (0, $169DF.FilterOptionSource).STATIC
            })),
        recommendedIds: availiableFilters.map(([days, _])=>({
                id: days,
                source: (0, $169DF.FilterOptionSource).STATIC
            }))
    };
};
const $67a90fc752dffcfd$export$eb71bf38f5ae0f9c = ({ isEnabled: isEnabled = true, defaultProjectFilters: defaultProjectFilters, defaultAssigneeFilters: defaultAssigneeFilters, defaultSiteFilters: defaultSiteFilters, children: children })=>{
    const previousEnabledState = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(isEnabled);
    const [dateFilterFrom, setDateFilterFrom] = (0, $gwFzn.useState)('');
    const [dateFilterTo, setDateFilterTo] = (0, $gwFzn.useState)('');
    const projectFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f(defaultProjectFilters);
    const assigneeFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f(defaultAssigneeFilters);
    const siteFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f(defaultSiteFilters);
    const binaryStatusCategoryFilterStore = $67a90fc752dffcfd$export$973ca22476b0e05f($67a90fc752dffcfd$export$b5d1c2ef6aead4e6);
    const filtersAnalyticsContext = projectFilterStore.availableFilters.length === 0 && assigneeFilterStore.availableFilters.length === 0 ? {} : {
        projects: $67a90fc752dffcfd$export$5e1edcb3c154ab79(projectFilterStore.availableFilters),
        assignees: $67a90fc752dffcfd$export$5e1edcb3c154ab79(assigneeFilterStore.availableFilters),
        binaryStatusCategories: $67a90fc752dffcfd$export$5e1edcb3c154ab79(binaryStatusCategoryFilterStore.availableFilters),
        dateFrom: $67a90fc752dffcfd$var$transformDateFiltersForAnalytics(dateFilterFrom)
    };
    // We reset the state when the component becomes disabled
    if (previousEnabledState.current && !isEnabled) {
        projectFilterStore.reset();
        assigneeFilterStore.reset();
        siteFilterStore.reset();
        binaryStatusCategoryFilterStore.clearFilter();
        setDateFilterFrom('');
        setDateFilterTo('');
    }
    previousEnabledState.current = isEnabled;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($67a90fc752dffcfd$var$FilterContext.Provider, {
        value: {
            projectFilters: projectFilterStore,
            assigneeFilters: assigneeFilterStore,
            siteFilters: siteFilterStore,
            binaryStatusCategoryFilters: binaryStatusCategoryFilterStore,
            dateFilterFrom: {
                value: dateFilterFrom,
                setValue: setDateFilterFrom
            },
            dateFilterTo: {
                value: dateFilterTo,
                setValue: setDateFilterTo
            }
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
            analyticContext: {},
            nonPrivacySafeAnalyticContext: {},
            filterAnalyticsContext: filtersAnalyticsContext,
            children: children
        })
    });
};
const $67a90fc752dffcfd$export$396ef541d9951d45 = ()=>{
    const filterContext = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useContext($67a90fc752dffcfd$var$FilterContext);
    return filterContext;
};

});
parcelRegister("hYymy", function(module, exports) {

$parcel$export(module.exports, "getDateXDaysBack", () => $dae70913057c5350$export$e4a4d5c1140c233a);
const $dae70913057c5350$export$edfa1467d84b6872 = (item, query)=>{
    const lowerQuery = query.toLowerCase().trim();
    return item.name.toLowerCase().includes(lowerQuery) || item.attributes.key.toLowerCase().includes(lowerQuery);
};
const $dae70913057c5350$export$e4a4d5c1140c233a = (daysBefore)=>{
    const date = new Date();
    date.setDate(date.getDate() - daysBefore);
    return date.toISOString().split('T')[0];
};

});


parcelRegister("k19N9", function(module, exports) {

$parcel$export(module.exports, "MultiProductDialog", () => $5e2053bb9142cd57$export$c952be4395be8d29);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7bbzF = parcelRequire("7bbzF");
var $5ZpeZ = parcelRequire("5ZpeZ");
var $7qNFx = parcelRequire("7qNFx");
var $80L9g = parcelRequire("80L9g");

var $kmpep = parcelRequire("kmpep");

var $2ErY6 = parcelRequire("2ErY6");

var $jAnRi = parcelRequire("jAnRi");

var $2ZIpG = parcelRequire("2ZIpG");

var $iEwUU = parcelRequire("iEwUU");

var $48BnN = parcelRequire("48BnN");

var $4ldrV = parcelRequire("4ldrV");

var $gF7Az = parcelRequire("gF7Az");

var $24xEE = parcelRequire("24xEE");

var $gMIQ9 = parcelRequire("gMIQ9");

var $aQmDW = parcelRequire("aQmDW");

var $64EAe = parcelRequire("64EAe");
const $5e2053bb9142cd57$var$ConditionalWrapper = ({ wrapper: wrapper, children: children })=>wrapper?.({
        children: children
    }) ?? children;

const $5e2053bb9142cd57$var$SearchAIDialogComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("9tyGI")).then(({ SearchAIDialog: SearchAIDialog })=>({
            default: SearchAIDialog
        })));
const $5e2053bb9142cd57$var$SearchAIAnswerDialog = ({ aiSearchConfig: aiSearchConfig, onClose: onClose, edition: edition, closeParentDialog: closeParentDialog })=>{
    const { query: query, setQueryOnly: setQueryOnly } = (0, $2ZIpG.useQuery)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId || '';
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { user: user } = (0, $iEwUU.useUserContext)();
    const { resetSearchSession: resetSearchSession } = (0, $80L9g.useSessionUserInput)();
    const { allowChangeExpand: allowChangeExpand } = (0, $gF7Az.useDialogExpansionContext)();
    const filters = (0, $48BnN.useAppliedFilters)('confluence');
    const onNavigate = (0, $gwFzn.useCallback)(()=>{
        resetSearchSession();
        allowChangeExpand(true);
    }, [
        resetSearchSession,
        allowChangeExpand
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {}),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($5e2053bb9142cd57$var$SearchAIDialogComponent, {
            query: query,
            setQuery: setQueryOnly,
            cloudId: cloudId,
            getAIAnswer: aiSearchConfig.aiSearchQueryFunction,
            edition: edition,
            followUpsEnabled: aiSearchConfig.followUpsEnabled,
            onNavigate: onNavigate,
            onClose: onClose,
            searchSessionId: searchSessionId,
            userDetails: user,
            source: "searchDialog",
            parsedFilters: filters,
            closeParentDialog: closeParentDialog,
            sourceProduct: "confluence",
            userGeneratedAI: true
        })
    });
};
const $5e2053bb9142cd57$export$c952be4395be8d29 = ({ children: children, theme: theme, isExpanded: isExpanded, setIsExpanded: setIsExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, dialogFeatures: dialogFeatures, user: user, orgId: orgId, forwardRef: forwardRef, onNavigateGeneric: onNavigateGeneric, keepExpandedInTab: keepExpandedInTab, pageLoadMetrics: pageLoadMetrics, DialogWrapper: DialogWrapper, OnboardingRenderer: OnboardingRenderer, experience: experience, aiSearchConfig: aiSearchConfig, edition: edition, primaryProduct: primaryProduct, shouldFillContainer: shouldFillContainer, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
    (0, $24xEE.useUFOComponentExperience)((0, $jAnRi.initialisationExperience));
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5ZpeZ.MetaContextProvider), {
        theme: theme,
        experience: experience,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        abTestCloudId: abTestCloudId,
        aggregatorUrl: aggregatorUrl,
        clientProviderFeatures: dialogFeatures,
        user: user,
        orgId: orgId,
        dialogFeatures: dialogFeatures,
        primaryProduct: primaryProduct,
        forwardRef: forwardRef,
        isRovoEnabled: isRovoEnabled,
        queryParams: queryParams,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7bbzF.KeyboardWrapper), {
            shouldFillContainer: shouldFillContainer,
            forwardRef: forwardRef,
            keepExpandedInTab: keepExpandedInTab,
            children: ({ ref: ref, onRetry: onRetry })=>{
                return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ErY6.ActiveProductSearchInput), {
                            shouldFillContainer: shouldFillContainer,
                            forwardRef: ref,
                            onNavigateGeneric: onNavigateGeneric,
                            features: dialogFeatures,
                            pageLoadMetrics: pageLoadMetrics
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)($5e2053bb9142cd57$var$ConditionalWrapper, {
                            wrapper: DialogWrapper,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gMIQ9.ActiveProductProvider), {
                                    children: ({ activeProduct: activeProduct, showSearchAIDialog: showSearchAIDialog, onCloseAIDialog: onCloseAIDialog, defaultAIConfig: defaultAIConfig })=>{
                                        const finalAIConfig = dialogFeatures?.isGriffinNavEnabled ? aiSearchConfig || defaultAIConfig : aiSearchConfig;
                                        return showSearchAIDialog && finalAIConfig && isExpanded ? /*#__PURE__*/ (0, $7UHDa.jsx)($5e2053bb9142cd57$var$SearchAIAnswerDialog, {
                                            aiSearchConfig: finalAIConfig,
                                            onClose: onCloseAIDialog,
                                            edition: edition,
                                            closeParentDialog: ()=>setIsExpanded(false)
                                        }) : /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $64EAe.ProductSearchDialogWrapper), {
                                            shouldFillContainer: shouldFillContainer,
                                            children: [
                                                OnboardingRenderer && isExpanded && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aQmDW.DisableXPSAB), {
                                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)(OnboardingRenderer, {
                                                        activeProductId: activeProduct?.id
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7qNFx.ProductTabs), {}),
                                                children({
                                                    ref: ref,
                                                    onRetry: onRetry
                                                })
                                            ]
                                        });
                                    }
                                })
                            })
                        })
                    ]
                });
            }
        })
    });
};

});
parcelRegister("7bbzF", function(module, exports) {

$parcel$export(module.exports, "KeyboardWrapper", () => $59d6c08dd81e927a$export$8ee2389f89cfdd2f);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $uJITI = parcelRequire("uJITI");
var $icqFF = parcelRequire("icqFF");
var $59aAc = parcelRequire("59aAc");

var $gF7Az = parcelRequire("gF7Az");

var $3MlpZ = parcelRequire("3MlpZ");

var $amrMu = parcelRequire("amrMu");
class $59d6c08dd81e927a$export$bb50437fb01e8bb5 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { isExpanded: isExpanded, isQuickFind: isQuickFind, shouldFillContainer: shouldFillContainer, children: children } = this.props;
        const SearchAnchorComponent = isQuickFind ? (0, $uJITI.EnlargedSearchAnchor) : (0, $59aAc.SearchAnchor);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(SearchAnchorComponent, {
            onBlur: this.onBlurHandler,
            onFocus: this.onFocusHandler,
            onKeyDown: this.handleKeyDown,
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $icqFF.KeyboardHighlightProvider), {
                listenerNode: this.state.ref,
                children: children ? children(this.setRef) : null
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            ref: null
        };
        /**
     * Hold a timeout id for the onBlur and onFocus handlers
     */ this.timeout = undefined;
        this.handleKeyDown = (event)=>{
            if (event.key === 'Escape' && !event.defaultPrevented && this.props.isExpanded) {
                event.preventDefault();
                this.close();
            }
        };
        this.onBlurHandler = ()=>{
            this.timeout = window.setTimeout(()=>{
                this.close();
            });
        };
        this.onFocusHandler = ()=>{
            window.clearTimeout(this.timeout);
        };
        this.setRef = (ref)=>{
            if (this.state.ref !== ref) this.setState({
                ref: ref
            });
        };
        this.close = ()=>{
            const { ref: ref } = this.state;
            ref && ref.blur();
            this.props.onClose();
        };
    }
}
const $59d6c08dd81e927a$export$8ee2389f89cfdd2f = ({ children: children, keepExpandedInTab: keepExpandedInTab = false, forwardRef: forwardRef, shouldFillContainer: shouldFillContainer, ...rest })=>{
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded, allowChangeExpand: allowChangeExpand } = (0, $gF7Az.useDialogExpansionContext)();
    const inputRef = (0, $gwFzn.useRef)(null);
    const mergedForwardref = (0, $3MlpZ.mergeRefCallback)(inputRef, forwardRef);
    const isQuickFind = (0, $amrMu.useFeaturesContext)().quickFind?.enabled;
    const onClose = (0, $gwFzn.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    const onTabChange = (0, $gwFzn.useCallback)(()=>{
        if (document.hidden) allowChangeExpand(false);
        else {
            if (isExpanded) inputRef?.current?.focus?.();
            allowChangeExpand(true);
        }
    }, [
        allowChangeExpand,
        isExpanded
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (keepExpandedInTab) {
            document.addEventListener('visibilitychange', onTabChange);
            return ()=>{
                document.removeEventListener('visibilitychange', onTabChange);
            };
        }
    }, [
        onTabChange,
        keepExpandedInTab
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($59d6c08dd81e927a$export$bb50437fb01e8bb5, {
        ...rest,
        shouldFillContainer: shouldFillContainer,
        onClose: onClose,
        isExpanded: isExpanded,
        isQuickFind: isQuickFind,
        children: (setRef)=>{
            const ref = (0, $3MlpZ.mergeRefCallback)(setRef, mergedForwardref);
            const onRetry = ()=>{
                inputRef?.current?.focus?.();
            };
            return children({
                ref: ref,
                onRetry: onRetry
            });
        }
    });
};

});
parcelRegister("uJITI", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchAnchor", () => $811464270192717d$export$774d556eae0f6945);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $kHWmv = parcelRequire("kHWmv");
const $811464270192717d$export$774d556eae0f6945 = ({ children: children, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, isExpanded: isExpanded, shouldFillContainer: shouldFillContainer })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kHWmv.EnlargedSearchAnchorWrapper), {
        isExpanded: isExpanded,
        shouldFillContainer: shouldFillContainer,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kHWmv.AbsoluteContainer), {
            isExpanded: isExpanded,
            shouldFillContainer: shouldFillContainer,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kHWmv.SearchDialogAnchor), {
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                isExpanded: isExpanded,
                shouldFillContainer: shouldFillContainer,
                children: children
            })
        })
    });

});

parcelRegister("3MlpZ", function(module, exports) {

$parcel$export(module.exports, "mergeRefCallback", () => $0ffb284ad494cbe0$export$bf39ce724f6cc9e5);
/**
 * Helper util class to merge a forward and callback ref.
 * The implementation to do this is not clean and so it's isolated here until React has a better solution.
 */ const $0ffb284ad494cbe0$var$callRef = (callbackOrForwardRef, ref)=>{
    if (!callbackOrForwardRef) return;
    if (typeof callbackOrForwardRef === 'function') callbackOrForwardRef(ref);
    else if (typeof callbackOrForwardRef === 'object' && Object.prototype.hasOwnProperty.call(callbackOrForwardRef, 'current')) // `#current` is technically read only, but we will force an assignment here.
    /* eslint-disable-next-line no-param-reassign */ callbackOrForwardRef.current = ref;
    else // This should never happen
    throw new Error('unsupported ref format, currently only callback and forward refs are supported');
};
const $0ffb284ad494cbe0$export$bf39ce724f6cc9e5 = (...refs)=>{
    return (ref)=>{
        refs.forEach((r)=>$0ffb284ad494cbe0$var$callRef(r, ref));
    };
};

});


parcelRegister("5ZpeZ", function(module, exports) {

$parcel$export(module.exports, "MetaContextProvider", () => $a995c577a9050532$export$3d88e5d350ac07d9);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $eSS4z = parcelRequire("eSS4z");

var $gF7Az = parcelRequire("gF7Az");

var $2ZIpG = parcelRequire("2ZIpG");

var $fJRVo = parcelRequire("fJRVo");

var $7HRSM = parcelRequire("7HRSM");

var $aeF8q = parcelRequire("aeF8q");

var $4ldrV = parcelRequire("4ldrV");

var $kmpep = parcelRequire("kmpep");

var $gRazf = parcelRequire("gRazf");

var $6dbhj = parcelRequire("6dbhj");

var $2GvH8 = parcelRequire("2GvH8");

var $iEwUU = parcelRequire("iEwUU");

var $fj1bk = parcelRequire("fj1bk");

var $cgH2x = parcelRequire("cgH2x");

var $hKdD9 = parcelRequire("hKdD9");

var $5YmSS = parcelRequire("5YmSS");

var $amrMu = parcelRequire("amrMu");

var $lesEq = parcelRequire("lesEq");

var $aDRXf = parcelRequire("aDRXf");

var $cGCOz = parcelRequire("cGCOz");

var $4wMwH = parcelRequire("4wMwH");
const $a995c577a9050532$export$3d88e5d350ac07d9 = ({ children: children, theme: theme, setIsExpanded: setIsExpanded, isExpanded: isExpanded, abTestCloudId: abTestCloudId, aggregatorUrl: aggregatorUrl, experience: experience, clientProviderFeatures: clientProviderFeatures, user: user, orgId: orgId, dialogFeatures: dialogFeatures, primaryProduct: primaryProduct, forwardRef: forwardRef, isRovoEnabled: isRovoEnabled, queryParams: queryParams })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4wMwH.QueryParamsProvider), {
        queryParams: queryParams,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $amrMu.FeaturesProvider), {
            dialogFeatures: dialogFeatures,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iEwUU.UserProvider), {
                user: user,
                orgId: orgId,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGCOz.RovoContextProvider), {
                    isEnabled: isRovoEnabled,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7HRSM.default), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lesEq.QuickFindAnalyticContext), {
                            isQuickFind: dialogFeatures?.quickFind?.enabled,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aeF8q.BuildVersionAnalyticContext), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eSS4z.ThemeProvider), {
                                    partialSearchCSS: theme,
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gF7Az.DialogExpansionContextProvider), {
                                        isExpanded: isExpanded,
                                        setIsExpanded: setIsExpanded,
                                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fJRVo.ProductRouter), {
                                            primaryProduct: primaryProduct,
                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kmpep.AggregatorClientContextProvider), {
                                                abTestCloudId: abTestCloudId,
                                                aggregatorUrl: aggregatorUrl,
                                                features: clientProviderFeatures,
                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gRazf.ABTestContextProvider), {
                                                    experience: experience,
                                                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $4ldrV.SearchSessionProvider), {
                                                        sessionKey: `ssid_provider_${isExpanded}`,
                                                        children: [
                                                            isExpanded ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6dbhj.default), {}) : null,
                                                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ZIpG.QueryContextProvider), {
                                                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cgH2x.FilterContextHOC), {
                                                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hKdD9.AutocorrectionProvider), {
                                                                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aDRXf.InputContext), {
                                                                            forwardRef: forwardRef,
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fj1bk.AsyncLoadOnQuery), {}),
                                                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5YmSS.DialogShownHandler), {
                                                                                    isExpanded: isExpanded
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2GvH8.DialogDismissedHandler), {
                                                                                    isExpanded: isExpanded
                                                                                }),
                                                                                children
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("7HRSM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c5b4abe555f149c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");
var $hlhtG = parcelRequire("hlhtG");

var $l3N71 = parcelRequire("l3N71");

var $1E3Hv = parcelRequire("1E3Hv");
class $9c5b4abe555f149c$var$MessagesIntlProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
            messages: this.state.messages,
            locale: this.props.intl.locale,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.fetchLocale = ()=>{
            (0, $l3N71.getMessagesForLocale)(this.props.intl.locale).then((messages)=>this.setState({
                    messages: messages
                }));
        };
        this.state = {
            messages: (0, $l3N71.ENGLISH_LOCALES).indexOf(props.intl.locale) !== -1 ? (0, $1E3Hv.default) : undefined
        };
        this.fetchLocale();
    }
}
const $9c5b4abe555f149c$var$MessagesIntlProviderWithIntl = (0, $js7oX.default)($9c5b4abe555f149c$var$MessagesIntlProvider);
var $9c5b4abe555f149c$export$2e2bcd8739ae039 = $9c5b4abe555f149c$var$MessagesIntlProviderWithIntl;

});
parcelRegister("l3N71", function(module, exports) {

$parcel$export(module.exports, "ENGLISH_LOCALES", () => $670fab1500b9ac87$export$507533edf8f43d4e);
$parcel$export(module.exports, "getMessagesForLocale", () => $670fab1500b9ac87$export$d0a3169680473b6c);

var $1E3Hv = parcelRequire("1E3Hv");
const $670fab1500b9ac87$export$507533edf8f43d4e = [
    'en',
    'en-US',
    'en-GB'
];






























async function $670fab1500b9ac87$var$getMessages(locale) {
    let messages;
    switch(locale){
        case 'cs':
            messages = (parcelRequire("9cl5R"));
            break;
        case 'da':
            messages = (parcelRequire("ezuZG"));
            break;
        case 'de':
            messages = (parcelRequire("53dkg"));
            break;
        case 'en':
            messages = Promise.resolve((parcelRequire("1E3Hv")));
            break;
        case 'en_GB':
            messages = (parcelRequire("j0DHs"));
            break;
        case 'en_ZZ':
            messages = (parcelRequire("am1ps"));
            break;
        case 'es':
            messages = (parcelRequire("fSLXp"));
            break;
        case 'et':
            messages = (parcelRequire("2Im8o"));
            break;
        case 'fi':
            messages = (parcelRequire("dNOQq"));
            break;
        case 'fr':
            messages = (parcelRequire("jHFlV"));
            break;
        case 'hu':
            messages = (parcelRequire("7DNZO"));
            break;
        case 'is':
            messages = (parcelRequire("4amYN"));
            break;
        case 'it':
            messages = (parcelRequire("hk27j"));
            break;
        case 'ja':
            messages = (parcelRequire("2DX3T"));
            break;
        case 'ko':
            messages = (parcelRequire("1yEm5"));
            break;
        case 'nb':
            messages = (parcelRequire("k3kA8"));
            break;
        case 'nl':
            messages = (parcelRequire("aAlhN"));
            break;
        case 'pl':
            messages = (parcelRequire("eP1WB"));
            break;
        case 'pt_BR':
            messages = (parcelRequire("fnCm2"));
            break;
        case 'pt_PT':
            messages = (parcelRequire("6Z2SI"));
            break;
        case 'ro':
            messages = (parcelRequire("3835v"));
            break;
        case 'ru':
            messages = (parcelRequire("jNGUi"));
            break;
        case 'sk':
            messages = (parcelRequire("47tQi"));
            break;
        case 'sv':
            messages = (parcelRequire("yjDNj"));
            break;
        case 'th':
            messages = (parcelRequire("gATwK"));
            break;
        case 'tr':
            messages = (parcelRequire("5hsBE"));
            break;
        case 'uk':
            messages = (parcelRequire("4YlTZ"));
            break;
        case 'vi':
            messages = (parcelRequire("1FSLe"));
            break;
        case 'zh':
            messages = (parcelRequire("1eX7w"));
            break;
        case 'zh_TW':
            messages = (parcelRequire("anvPL"));
            break;
        default:
            throw new Error('Unknown locale: ' + locale);
    }
    return (await messages).default;
}
const $670fab1500b9ac87$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        return await $670fab1500b9ac87$var$getMessages(locale);
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        return await $670fab1500b9ac87$var$getMessages(parentLocale);
    } catch (e) {
    // ignore
    }
    return 0, $1E3Hv.default;
};

});
parcelRegister("1E3Hv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6c104c09525816b7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $6c104c09525816b7$export$2e2bcd8739ae039 = {
    'cross_product_search_dialog.atlas.tab_label': 'Atlas',
    'cross_product_search_dialog.bitbucket.tab_label': 'Bitbucket',
    'cross_product_search_dialog.confluence.tab_label': 'Confluence',
    'cross_product_search_dialog.google_drive.tab_label': 'Drive',
    'cross_product_search_dialog.google_drive.unauthenticated_prompt': 'You can work on all of your Google sheets, docs, slides and more, without ever leaving Atlassian. Only you have this access.',
    'cross_product_search_dialog.jira.tab_label': 'Jira',
    'cross_product_search_dialog.opsgenie.tab_label': 'Opsgenie',
    'cross_product_search_dialog.recently_viewed_title': 'Recently Viewed {sectionTitle}',
    'cross_product_search_dialog.townsquare_globex_tab_label': 'Home',
    'cross_product_search_dialog.townsquare_recent_goals': 'Recent Goals',
    'cross_product_search_dialog.townsquare_recent_help_links': 'Recent Help Links',
    'cross_product_search_dialog.townsquare_recent_learnings_risks_decisions': 'Recent Learnings, Risks and Decisions',
    'cross_product_search_dialog.townsquare_recent_projects': 'Recent Projects',
    'cross_product_search_dialog.townsquare_tab_label': 'Atlas',
    'cross_product_search_dialog.trello.tab_label': 'Trello',
    'cross_product_search_dialog.view_all_results_link': 'View all {sectionTitle}',
    'document-search-result.google-docs-label': 'Docs',
    'document-search-result.google-sheets-label': 'Sheets',
    'document-search-result.google-slides-label': 'Slides',
    'document-search-result.ms-excel-label': 'Excel',
    'document-search-result.ms-powerpoint-label': 'PowerPoint',
    'document-search-result.ms-word-label': 'Word',
    'extensible_search_dialog.advanced_search': 'Advanced search',
    'extensible_search_dialog.advanced_search_all_apps': 'Search all apps',
    'extensible_search_dialog.connect': 'Connect',
    'extensible_search_dialog.connect_to': 'Connect to',
    'extensible_search_dialog.more': '+ more',
    'global_search.jira.advanced_search_boards': 'Boards',
    'global_search.jira.advanced_search_filters': 'Filters',
    'global_search.jira.advanced_search_issues': 'Issues',
    'global_search.jira.advanced_search_issues-issue-term-refresh': 'Work items',
    'global_search.jira.advanced_search_label': 'Go to all:',
    'global_search.jira.advanced_search_people': 'People',
    'global_search.jira.advanced_search_plans': 'Plans',
    'global_search.jira.advanced_search_projects': 'Projects',
    'global_search.jira.search_placeholder': 'Search Jira',
    'global_search.jira.search_placeholder_experiment_jsw_enabled': 'Search for issues, boards, projects, and filters',
    'global_search.jira.search_placeholder_experiment_jsw_enabled-issue-term-refresh': 'Search for work items, boards, projects, and filters',
    'product_s earch_dialog.confluence.assignee_filters_find_more': 'Find an assignee',
    'product_search_dialog.atlas.search_input_expanded_placeholder': 'Search Atlas',
    'product_search_dialog.autocorrection.label': 'Did you mean',
    'product_search_dialog.bitbucket.bitbucket_advanced_search': 'Search for code in {source}',
    'product_search_dialog.bitbucket.bitbucket_recent_repositories': 'Recently updated repositories',
    'product_search_dialog.bitbucket.bitbucket_repositories_section_title': 'Repositories',
    'product_search_dialog.bitbucket.expanded.input-placeholder': 'Search Bitbucket',
    'product_search_dialog.bitbucket.repository_heading': 'Repositories',
    'product_search_dialog.common.site_filters': 'Filter by site',
    'product_search_dialog.compass.component_type.application': 'Application',
    'product_search_dialog.compass.component_type.capability': 'Capability',
    'product_search_dialog.compass.component_type.cloud_resource': 'Cloud resource',
    'product_search_dialog.compass.component_type.data_pipeline': 'Data pipeline',
    'product_search_dialog.compass.component_type.library': 'Library',
    'product_search_dialog.compass.component_type.machine_learning_model': 'Machine learning model',
    'product_search_dialog.compass.component_type.other': 'Other',
    'product_search_dialog.compass.component_type.service': 'Service',
    'product_search_dialog.compass.component_type.ui_element': 'UI element',
    'product_search_dialog.compass.component_type.website': 'Website',
    'product_search_dialog.compass.components_section_heading': 'Components',
    'product_search_dialog.compass.endpoints_section_heading': 'Endpoints',
    'product_search_dialog.compass.expanded.input-placeholder': 'Search Compass',
    'product_search_dialog.compass.people_section_heading': 'People',
    'product_search_dialog.compass.recently_viewed_components': 'Recently viewed components',
    'product_search_dialog.compass.recently_viewed_endpoints': 'Recently viewed endpoints',
    'product_search_dialog.compass.recently_viewed_teams': 'Recently viewed teams',
    'product_search_dialog.compass.tab_label': 'Compass',
    'product_search_dialog.compass.teams_section_heading': 'Teams',
    'product_search_dialog.compass.upsell_modal_cta_text': 'Get Compass free',
    'product_search_dialog.compass.upsell_modal_description': "Catalog your software architecture in one place \u2013 so the teams working on it can reduce context switching, find what they need faster, and be more productive. How\u2019s that for a developer experience?",
    'product_search_dialog.compass.upsell_modal_description.bitbucket': 'See owners, dependencies, and help resources for your repositories by linking them to a central software catalog.',
    'product_search_dialog.compass.upsell_modal_heading': 'Control your software sprawl, so developers can control their time',
    'product_search_dialog.compass.upsell_modal_heading.bitbucket': 'Bring more context to your code',
    'product_search_dialog.compass.upsell_modal_learn_more_aria_label': 'Learn more about Compass',
    'product_search_dialog.compass.upsell_modal_learn_more_link': 'Learn more',
    'product_search_dialog.compass.upsell_tab_title_lozenge': 'New',
    'product_search_dialog.compass.view_all_components_label': 'View all components',
    'product_search_dialog.compass.view_all_results_label': 'View all results',
    'product_search_dialog.confluence.advanced_search_with_product_prefix': 'Confluence advanced search',
    'product_search_dialog.confluence.clear_filters': 'Clear filters',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.description': 'Your team is collaborating in Confluence. Organize team knowledge, capture ideas, and share requirements for your Jira projects with pages, whiteboards, and databases.',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.header': 'Your team is now using Confluence',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.join_button': 'Join your team',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.learn_more_button': 'Learn more',
    'product_search_dialog.confluence.confluence_availability_in_jira_search.tab.more_results': 'More results',
    'product_search_dialog.confluence.confluence_reactivation_experiment.inactive_user': 'More results',
    'product_search_dialog.confluence.confluence_reactivation_experiment.never_active_user': 'Free access',
    'product_search_dialog.confluence.content_section_heading': 'Content',
    'product_search_dialog.confluence.contributor_filters': 'Filter by contributor',
    'product_search_dialog.confluence.contributor_filters_find_more': 'Find a contributor',
    'product_search_dialog.confluence.date_filter_title': 'Last updated',
    'product_search_dialog.confluence.date_filter_today': 'Today',
    'product_search_dialog.confluence.date_filter_yesterday': 'Yesterday',
    'product_search_dialog.confluence.date_filters_any': 'Any time',
    'product_search_dialog.confluence.date_filters_month': 'Past 30 days',
    'product_search_dialog.confluence.date_filters_week': 'Past 7 days',
    'product_search_dialog.confluence.date_filters_year': 'Past year',
    'product_search_dialog.confluence.empty_state_body_no_advanced_search': 'Try different keywords, fewer of them, or ones that are more general.',
    'product_search_dialog.confluence.empty_state_body_prequery_filters': "We can\u2019t find anything created or updated in the last 90 days with your selected filters.",
    'product_search_dialog.confluence.empty_state_body_title': "We couldn't find any matches for your search.",
    'product_search_dialog.confluence.filters_applied': 'Looks like you have some filters applied',
    'product_search_dialog.confluence.pages_blogs_attachments_section_heading': 'Pages, blogs and attachments',
    'product_search_dialog.confluence.people_section_heading': 'People',
    'product_search_dialog.confluence.search_input_expanded_placeholder': 'Search Confluence',
    'product_search_dialog.confluence.search_input_expanded_placeholder_ai': 'Search or ask questions within your Confluence',
    'product_search_dialog.confluence.space_filters': 'Filter by space',
    'product_search_dialog.confluence.space_filters_find_more': 'Find a space',
    'product_search_dialog.confluence.spaces_section_heading': 'Spaces',
    'product_search_dialog.confluence.typing_state_header_text': 'Search for content in Confluence',
    'product_search_dialog.cross_product.empty.no_results_body': '<a>Search all content across your organization</a> or try a different term.',
    'product_search_dialog.cross_product.expanded.input-placeholder': 'Search All',
    'product_search_dialog.cross_product.recents.section_heading': 'Recently viewed',
    'product_search_dialog.cross_product.results.section_heading': 'Search results',
    'product_search_dialog.cross_product.tab_label': 'All',
    'product_search_dialog.empty.no_results_body': 'Try again with a different term, or refine your results with <a>Advanced Search</a>',
    'product_search_dialog.empty.no_results_body_with_no_advanced_search': 'Try again with a different term.',
    'product_search_dialog.empty.no_results_heading': "We couldn't find anything matching your search.",
    'product_search_dialog.empty_prequery.error_heading': 'Something went wrong with showing initial results',
    'product_search_dialog.empty_prequery.no_results_heading': 'Search for what you need',
    'product_search_dialog.error.failed_loading_search_body': 'It might just be a hiccup. Please try refreshing the page or <emptyLink>try again.</emptyLink>',
    'product_search_dialog.error.failed_loading_search_heading': "We're having trouble loading your recently viewed content.",
    'product_search_dialog.give_feedback': 'Give feedback',
    'product_search_dialog.google_drive.files_heading': 'Files',
    'product_search_dialog.inline_onboarding_action': 'Ok',
    'product_search_dialog.inline_onboarding_body': 'Use the Jira and Confluence tabs to search and see recent items in either location.',
    'product_search_dialog.inline_onboarding_title': 'Search across Jira and Confluence',
    'product_search_dialog.jira.assignee_filters': 'Filter by assignee',
    'product_search_dialog.jira.boards_icon_accessibility_text': 'Board icon',
    'product_search_dialog.jira.boards_projects_filters_plans_section_heading': 'Boards, Projects, Filters and Plans',
    'product_search_dialog.jira.boards_projects_filters_section_heading': 'Boards, Projects and Filters',
    'product_search_dialog.jira.date_filter_30': '30d',
    'product_search_dialog.jira.date_filter_60': '60d',
    'product_search_dialog.jira.date_filter_90': '90d',
    'product_search_dialog.jira.date_filter_any': 'Any time',
    'product_search_dialog.jira.date_filter_past_30_days': 'Past 30 days',
    'product_search_dialog.jira.date_filter_past_7_days': 'Past 7 days',
    'product_search_dialog.jira.date_filter_past_year': 'Past year',
    'product_search_dialog.jira.date_filter_today': 'Today',
    'product_search_dialog.jira.date_filter_yesterday': 'Yesterday',
    'product_search_dialog.jira.date_filters': 'Last updated',
    'product_search_dialog.jira.empty_prequery.no_results_heading': 'Start searching to find your work',
    'product_search_dialog.jira.issue_filter_done': 'Done',
    'product_search_dialog.jira.issue_filter_open': 'Open',
    'product_search_dialog.jira.issue_filters': 'Filter by status',
    'product_search_dialog.jira.issue_labels_filters': 'Filter by label',
    'product_search_dialog.jira.issue_labels_filters_options_group_label': 'All labels',
    'product_search_dialog.jira.issue_labels_filters_placeholder': 'Select label',
    'product_search_dialog.jira.issues_section_heading': 'Issues',
    'product_search_dialog.jira.issues_section_heading-issue-term-refresh': 'Work items',
    'product_search_dialog.jira.jira_view_all_issues_new': 'View all issues',
    'product_search_dialog.jira.jira_view_all_issues_new-issue-term-refresh': 'View all work items',
    'product_search_dialog.jira.project_filters': 'Filter by project',
    'product_search_dialog.jira.project_filters_find_more': 'Find a project',
    'product_search_dialog.jira.projects_filters_section_heading': 'Projects and Filters',
    'product_search_dialog.jira.recent_boards_projects_filters_plans_section_heading': 'Recent Boards, Projects, Filters and Plans',
    'product_search_dialog.jira.recent_boards_projects_filters_section_heading': 'Recent Boards, Projects and Filters',
    'product_search_dialog.jira.recent_projects_filters_section_heading': 'Recent Projects and Filters',
    'product_search_dialog.jira.recently_viewed_issues_section_heading': 'Recently viewed issues',
    'product_search_dialog.jira.recently_viewed_issues_section_heading-issue-term-refresh': 'Recently viewed work items',
    'product_search_dialog.jira.report_by_filters': 'Filter by reporter',
    'product_search_dialog.jira.reported_by_me_filter': 'Reported by me',
    'product_search_dialog.jira.site_filters_find_more': 'Find a site',
    'product_search_dialog.loading_filters': 'Loading',
    'product_search_dialog.more_filters': 'View all filters',
    'product_search_dialog.multi_site_advanced_search_label': 'Search on:',
    'product_search_dialog.multi_site_advanced_search_more_dropdown': '{count} more',
    'product_search_dialog.no_options_filters': 'No options',
    'product_search_dialog.opsgenie.advanced_search': 'Advanced alert search',
    'product_search_dialog.opsgenie.alert_heading': 'Alerts',
    'product_search_dialog.opsgenie.expanded.input-placeholder': 'Search Opsgenie',
    'product_search_dialog.opsgenie.opsgenie_recent_alerts': 'Recent Alerts',
    'product_search_dialog.quick_find_ask_atlassian_intelligence': 'Ask Atlassian Intelligence',
    'product_search_dialog.quick_find_confluence_space': 'Confluence Space',
    'product_search_dialog.quick_find_footer_full_page_search_products_link': 'Search across products',
    'product_search_dialog.quick_find_footer_help_text': 'Help us improve search',
    'product_search_dialog.quick_find_no_content_body_rovo': "Search or ask Rovo what you're looking for in your Atlassian and integrated products",
    'product_search_dialog.quick_find_no_content_header': 'Seek and you shall find',
    'product_search_dialog.quick_find_post_query_no_results_body': '<SearchContentLink>Search all content across your organization</SearchContentLink> or try again with a different term.',
    'product_search_dialog.quick_find_post_query_no_results_header': "We couldn't find any results with that title",
    'product_search_dialog.quick_find_recent_draft_label': 'DRAFT',
    'product_search_dialog.quick_find_recent_search': 'Recent search',
    'product_search_dialog.quick_find_recent_search_text_dialog': 'From your recent searches',
    'product_search_dialog.quick_find_recent_spaces_additional_meta': 'You recently visited',
    'product_search_dialog.quick_find_recently_viewed': 'Recently Viewed',
    'product_search_dialog.quick_find_result_item_team': 'Team',
    'product_search_dialog.quick_find_results_section': 'Search Results',
    'product_search_dialog.quick_find_rovo_tip': "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer.",
    'product_search_dialog.quick_find_search_input_rovo_placeholder': 'Search or ask Rovo',
    'product_search_dialog.quick_find_search_results': 'Search Results',
    'product_search_dialog.quick_find_show_filtered_confluence_results': 'Filter by Confluence spaces, contributors and more',
    'product_search_dialog.quick_find_show_filtered_confluence_results_with_icon': 'Filter by {confluenceIcon} Confluence spaces, contributors and more',
    'product_search_dialog.quick_find_show_organization_results': 'Search your organization',
    'product_search_dialog.recent_spaces_section_heading': 'Recent spaces',
    'product_search_dialog.recently_viewed_heading': 'Advanced search',
    'product_search_dialog.recently_viewed_section_heading': 'Recently viewed',
    'product_search_dialog.recently_worked_with_section_heading': 'Recently worked with',
    'product_search_dialog.results.remove_button_label': 'Remove this.',
    'product_search_dialog.search_input_collapsed_placeholder': 'Search',
    'product_search_dialog.search_input_enlarged_aria_label': 'Press enter to navigate to advanced search',
    'product_search_dialog.search_people_link': 'Search people',
    'product_search_dialog.show_all_results_link': 'View all results',
    'product_search_dialog.show_more_results_link': 'Show more',
    'product_search_dialog.townsquare.search_input_expanded_placeholder': 'Search Home',
    'product_search_dialog.townsquare_goals_heading': 'Goals',
    'product_search_dialog.townsquare_goals_view_all': 'Search all goals',
    'product_search_dialog.townsquare_help_links_heading': 'Help Links',
    'product_search_dialog.townsquare_learnings_risks_decisions_heading': 'Learnings, Risks and Decisions',
    'product_search_dialog.townsquare_people_heading': 'People',
    'product_search_dialog.townsquare_people_view_all': 'Search all people',
    'product_search_dialog.townsquare_projects_heading': 'Projects',
    'product_search_dialog.townsquare_projects_view_all': 'Search all projects',
    'product_search_dialog.townsquare_recent_people': 'Recent People',
    'product_search_dialog.townsquare_recent_topics': 'Recent Topics',
    'product_search_dialog.townsquare_teams_heading': 'Teams',
    'product_search_dialog.townsquare_teams_view_all': 'Search all teams',
    'product_search_dialog.townsquare_topics_heading': 'Topics',
    'product_search_dialog.townsquare_topics_view_all': 'Search all topics',
    'product_search_dialog.trello.archived': 'Archived',
    'product_search_dialog.trello.archived.card-hover': 'This card is archived',
    'product_search_dialog.trello.board': 'Board',
    'product_search_dialog.trello.boards_heading': 'Boards',
    'product_search_dialog.trello.cards_heading': 'Cards',
    'product_search_dialog.trello.closed': 'Closed',
    'product_search_dialog.trello.closed.board-hover': 'This board is closed',
    'product_search_dialog.trello.expanded.input-placeholder': 'Search Trello',
    'product_search_dialog.trello.feedback_link': 'Help us improve your search results!',
    'product_search_dialog.trello.list': 'List',
    'product_search_dialog.trello.private_workspace': 'Private Workspace',
    'product_search_dialog.trello.recent_boards_heading': 'Recent boards',
    'product_search_dialog.trello.workspace': 'Workspace',
    'product_search_dialog.updated_date_formatter': 'Updated {date}',
    'recentWork.eventTypeMessage.absolute.commented': 'You commented on {date}',
    'recentWork.eventTypeMessage.absolute.created': 'You created on {date}',
    'recentWork.eventTypeMessage.absolute.edited': 'You edited on {date}',
    'recentWork.eventTypeMessage.absolute.published': 'You published on {date}',
    'recentWork.eventTypeMessage.absolute.updated': 'You updated on {date}',
    'recentWork.eventTypeMessage.absolute.viewed': 'You viewed on {date}',
    'recentWork.eventTypeMessage.absolute.workedOn': 'You worked on {date}',
    'recentWork.eventTypeMessage.relative.commented': 'You commented {date}',
    'recentWork.eventTypeMessage.relative.created': 'You created {date}',
    'recentWork.eventTypeMessage.relative.edited': 'You edited {date}',
    'recentWork.eventTypeMessage.relative.published': 'You published {date}',
    'recentWork.eventTypeMessage.relative.updated': 'You updated {date}',
    'recentWork.eventTypeMessage.relative.viewed': 'You viewed {date}',
    'search_dialog.filters.group.show-more': 'Show more',
    'search_dialog.search_input_clear_label': 'Clear search session',
    'search_dialog.search_input_exit_label': 'Exit Search'
};

});

parcelRegister("9cl5R", function(module, exports) {

let $6b2598c4b46cc26a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6b2598c4b46cc26a$var$load("dXz7U").then(()=>parcelRequire('efF3A'));

});

parcelRegister("ezuZG", function(module, exports) {

let $a9bc604a5d4e8583$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a9bc604a5d4e8583$var$load("gGEZv").then(()=>parcelRequire('1Mvyi'));

});

parcelRegister("53dkg", function(module, exports) {

let $3ad791cb7a90fef8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3ad791cb7a90fef8$var$load("d3blt").then(()=>parcelRequire('5Abiq'));

});

parcelRegister("j0DHs", function(module, exports) {

let $dd6ccffc839738d8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $dd6ccffc839738d8$var$load("59Z93").then(()=>parcelRequire('fY7GX'));

});

parcelRegister("am1ps", function(module, exports) {

let $789d0d615f8512f9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $789d0d615f8512f9$var$load("kotjW").then(()=>parcelRequire('1JK4e'));

});

parcelRegister("fSLXp", function(module, exports) {

let $b9011977c747f9ca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b9011977c747f9ca$var$load("kK6se").then(()=>parcelRequire('dr5EV'));

});

parcelRegister("2Im8o", function(module, exports) {

let $1fa0dc3d0db26d11$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1fa0dc3d0db26d11$var$load("5xf60").then(()=>parcelRequire('928dD'));

});

parcelRegister("dNOQq", function(module, exports) {

let $a0c74aa943be20d4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a0c74aa943be20d4$var$load("9VEIz").then(()=>parcelRequire('8u8jr'));

});

parcelRegister("jHFlV", function(module, exports) {

let $e5821c4013c1b4ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e5821c4013c1b4ec$var$load("cjdHS").then(()=>parcelRequire('iV9jc'));

});

parcelRegister("7DNZO", function(module, exports) {

let $5902f51a4cf9d451$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5902f51a4cf9d451$var$load("Whd6n").then(()=>parcelRequire('6zDwd'));

});

parcelRegister("4amYN", function(module, exports) {

let $3089ebd9dd90541e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3089ebd9dd90541e$var$load("jkUKZ").then(()=>parcelRequire('4V7KZ'));

});

parcelRegister("hk27j", function(module, exports) {

let $c9c5f24e6c5abc00$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c9c5f24e6c5abc00$var$load("9LPlo").then(()=>parcelRequire('eIyMR'));

});

parcelRegister("2DX3T", function(module, exports) {

let $1ecd09b830e26009$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1ecd09b830e26009$var$load("bCZbu").then(()=>parcelRequire('2cNOn'));

});

parcelRegister("1yEm5", function(module, exports) {

let $12284524ab36661d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $12284524ab36661d$var$load("jUfGx").then(()=>parcelRequire('i1XCh'));

});

parcelRegister("k3kA8", function(module, exports) {

let $e9940d98429cf9cc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e9940d98429cf9cc$var$load("8yxgV").then(()=>parcelRequire('k4Hxm'));

});

parcelRegister("aAlhN", function(module, exports) {

let $7b4dc71d89fc231a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7b4dc71d89fc231a$var$load("dBE2i").then(()=>parcelRequire('6e98G'));

});

parcelRegister("eP1WB", function(module, exports) {

let $aca75631ab96b9d5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $aca75631ab96b9d5$var$load("6FNZU").then(()=>parcelRequire('cRwJj'));

});

parcelRegister("fnCm2", function(module, exports) {

let $b326c162b83c2334$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b326c162b83c2334$var$load("ilWcC").then(()=>parcelRequire('3bomr'));

});

parcelRegister("6Z2SI", function(module, exports) {

let $515aacc555a96f8e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $515aacc555a96f8e$var$load("edU6Z").then(()=>parcelRequire('lD7ty'));

});

parcelRegister("3835v", function(module, exports) {

let $247483a27c8d799f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $247483a27c8d799f$var$load("atNxX").then(()=>parcelRequire('jE6uv'));

});

parcelRegister("jNGUi", function(module, exports) {

let $e6a3e061e7171fda$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e6a3e061e7171fda$var$load("gpgvY").then(()=>parcelRequire('aOGjz'));

});

parcelRegister("47tQi", function(module, exports) {

let $2ffef6f65ffb50b7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2ffef6f65ffb50b7$var$load("3IA7L").then(()=>parcelRequire('3vd6f'));

});

parcelRegister("yjDNj", function(module, exports) {

let $0672695a73243a14$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0672695a73243a14$var$load("hpq4P").then(()=>parcelRequire('hy5e4'));

});

parcelRegister("gATwK", function(module, exports) {

let $c14b14af85e511ce$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c14b14af85e511ce$var$load("8WMbP").then(()=>parcelRequire('47py6'));

});

parcelRegister("5hsBE", function(module, exports) {

let $3d84bae1dbf799e6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3d84bae1dbf799e6$var$load("kffHA").then(()=>parcelRequire('fZXUj'));

});

parcelRegister("4YlTZ", function(module, exports) {

let $39edc14fafc359e5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $39edc14fafc359e5$var$load("2zh8u").then(()=>parcelRequire('4BVSW'));

});

parcelRegister("1FSLe", function(module, exports) {

let $13841922cb7e7278$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $13841922cb7e7278$var$load("9YoTA").then(()=>parcelRequire('eI8pB'));

});

parcelRegister("1eX7w", function(module, exports) {

let $0e74f55502569d12$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0e74f55502569d12$var$load("a9qyt").then(()=>parcelRequire('6xDrT'));

});

parcelRegister("anvPL", function(module, exports) {

let $78e4bee6dd082d13$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $78e4bee6dd082d13$var$load("04egH").then(()=>parcelRequire('fBdRZ'));

});



parcelRegister("aeF8q", function(module, exports) {

$parcel$export(module.exports, "BuildVersionAnalyticContext", () => $79b726b1281ccb40$export$7095b8205ce661b6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");

var $2GmtI = parcelRequire("2GmtI");
const $79b726b1281ccb40$export$7095b8205ce661b6 = ({ children: children })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
        analyticContext: {
            frontend: (0, $2GmtI.BUILD_VERSION)
        },
        nonPrivacySafeAnalyticContext: {},
        children: children
    });

});

parcelRegister("6dbhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $95fbe0eb5eb00d19$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $6dP89 = parcelRequire("6dP89");

var $4ldrV = parcelRequire("4ldrV");
var $95fbe0eb5eb00d19$export$2e2bcd8739ae039 = ()=>{
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    (0, $gwFzn.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'operational',
            action: 'exposed',
            actionSubject: 'quickSearchExperiment',
            source: 'searchDialog'
        });
    // We keep the searchSessionId here because we want a new experiment exposure event every new session
    }, [
        fireAnalyticsEvent,
        searchSessionId
    ]);
    return null;
};

});

parcelRegister("2GvH8", function(module, exports) {

$parcel$export(module.exports, "DialogDismissedHandler", () => $2910c33607471958$export$50483e15753411d8);

var $gwFzn = parcelRequire("gwFzn");

var $lnXRc = parcelRequire("lnXRc");

var $5dFS9 = parcelRequire("5dFS9");
class $2910c33607471958$export$b768cbf5d904a94a extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidUpdate(prevProps) {
        const { onDialogClosed: onDialogClosed, isExpanded: isExpanded } = this.props;
        if (prevProps.isExpanded && !isExpanded) onDialogClosed();
    }
    render() {
        return null;
    }
}
const $2910c33607471958$export$50483e15753411d8 = (0, $lnXRc.withAnalytics)({
    onDialogClosed: (0, $5dFS9.onDismissed)
})($2910c33607471958$export$b768cbf5d904a94a);

});

parcelRegister("fj1bk", function(module, exports) {

$parcel$export(module.exports, "AsyncLoadOnQuery", () => $c422feafa0c6ebb6$export$c658105a3bdf0409);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gF7Az = parcelRequire("gF7Az");

var $2ZIpG = parcelRequire("2ZIpG");


const $c422feafa0c6ebb6$export$c658105a3bdf0409 = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const [isFetched, setIsFetched] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (query && isFetched === false && isExpanded) {
            (parcelRequire("0oBOJ"));
            (parcelRequire("fqWdp"));
            setIsFetched(true);
        }
    }, [
        query,
        isFetched,
        setIsFetched,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};

});
parcelRegister("fqWdp", function(module, exports) {

let $b3c671107460e8ca$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b3c671107460e8ca$var$load("lUh9w").then(()=>parcelRequire('5F6io'));

});


parcelRegister("hKdD9", function(module, exports) {

$parcel$export(module.exports, "AutocorrectionProvider", () => $e996a7cbe3e17aef$export$8ba6d08e2bcc861f);
$parcel$export(module.exports, "useAutocorrection", () => $e996a7cbe3e17aef$export$2f6912f63e498900);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $2ZIpG = parcelRequire("2ZIpG");

var $5TmpD = parcelRequire("5TmpD");

var $kmpep = parcelRequire("kmpep");
const $e996a7cbe3e17aef$var$NO_CORRECTION = [];
const $e996a7cbe3e17aef$var$AutocorrectionContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    correction: undefined,
    setCorrection: ()=>{}
});
const $e996a7cbe3e17aef$export$8ba6d08e2bcc861f = ({ children: children })=>{
    const { autocorrectionEnabled: autocorrectionEnabled } = (0, $5TmpD.useAutocorrectionEnabled)();
    const [correction, setCorrection] = (0, $gwFzn.useState)($e996a7cbe3e17aef$var$NO_CORRECTION);
    const { query: query } = (0, $2ZIpG.useQuery)();
    const { locale: locale } = (0, $dBxQj.default)();
    const lang = (0, $5TmpD.sanitizeLanguage)(locale);
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const { url: aggregatorUrl, cloudId: cloudId } = aggregatorClient?.getAggregatorConfig() || {};
    (0, $gwFzn.useEffect)(()=>{
        setCorrection($e996a7cbe3e17aef$var$NO_CORRECTION);
        if (autocorrectionEnabled && (0, $5TmpD.shouldFetchAutocorrection)(query) && aggregatorUrl && cloudId) (0, $5TmpD.fetchAutocorrection)({
            query: query,
            aggregatorUrl: aggregatorUrl,
            lang: lang,
            cloudId: cloudId
        }).then((result)=>{
            if (!!result.termCorrections) setCorrection(result.termCorrections);
        }).catch((_error_)=>{});
    }, [
        autocorrectionEnabled,
        query,
        aggregatorUrl,
        cloudId,
        lang
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($e996a7cbe3e17aef$var$AutocorrectionContext.Provider, {
        value: {
            correction: correction,
            setCorrection: setCorrection
        },
        children: children
    });
};
const $e996a7cbe3e17aef$export$2f6912f63e498900 = ()=>{
    return (0, $gwFzn.useContext)($e996a7cbe3e17aef$var$AutocorrectionContext);
};

});

parcelRegister("5YmSS", function(module, exports) {

$parcel$export(module.exports, "DialogShownHandler", () => $5fa054eff2cb0a5a$export$914029055eb3fe8e);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fJRVo = parcelRequire("fJRVo");

var $5dFS9 = parcelRequire("5dFS9");

var $lnXRc = parcelRequire("lnXRc");

var $eztGN = parcelRequire("eztGN");
const $5fa054eff2cb0a5a$export$18e8dcaf0a5a46b2 = ({ isExpanded: isExpanded, onDialogShown: onDialogShown })=>{
    const { products: products, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const isRovoCrossProductSearchLinkShown = (0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id);
    (0, $gwFzn.useEffect)(()=>{
        const emitAnalyticsEvent = ()=>{
            const visibleProducts = products.map((product)=>product.title);
            const visibleTabsCount = visibleProducts.length > 1 ? products.length : 0;
            onDialogShown({
                visibleProducts: visibleProducts,
                visibleTabsCount: visibleTabsCount,
                isRovoCrossProductSearchLinkShown: isRovoCrossProductSearchLinkShown
            });
        };
        isExpanded && emitAnalyticsEvent();
    }, [
        isExpanded
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {});
};
const $5fa054eff2cb0a5a$export$914029055eb3fe8e = (0, $lnXRc.withAnalytics)({
    onDialogShown: (0, $5dFS9.onShown)
})($5fa054eff2cb0a5a$export$18e8dcaf0a5a46b2);

});

parcelRegister("lesEq", function(module, exports) {

$parcel$export(module.exports, "QuickFindAnalyticContext", () => $f9a704b413e9ca44$export$bf21b659e40e8eb4);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $hpDfc = parcelRequire("hpDfc");
const $f9a704b413e9ca44$export$bf21b659e40e8eb4 = ({ children: children, isQuickFind: isQuickFind = false })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hpDfc.SearchDialogAnalyticsContext), {
        analyticContext: {
            isQuickFind: isQuickFind
        },
        nonPrivacySafeAnalyticContext: {},
        children: children
    });

});


parcelRegister("7qNFx", function(module, exports) {

$parcel$export(module.exports, "ProductTabs", () => $f90153b55c207314$export$f698db24bc555eee);

var $7UHDa = parcelRequire("7UHDa");

var $4A7Gn = parcelRequire("4A7Gn");
var $gCbPZ = parcelRequire("gCbPZ");
var $0DTaW = parcelRequire("0DTaW");
parcelRequire("gwFzn");

var $5dFS9 = parcelRequire("5dFS9");
var $6dP89 = parcelRequire("6dP89");

var $gRazf = parcelRequire("gRazf");

var $aQmDW = parcelRequire("aQmDW");

var $gF7Az = parcelRequire("gF7Az");

var $fJRVo = parcelRequire("fJRVo");

var $5EVbL = parcelRequire("5EVbL");
const $f90153b55c207314$var$CustomTab = ({ index: index, title: title, tabRenderer: tabRenderer })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gCbPZ.default), {
        testId: `search-dialog-product-tab-${index}`,
        children: tabRenderer ? tabRenderer({
            title: title
        }) : title
    }, index);
};
const $f90153b55c207314$export$bd4c4b880e23a953 = (props)=>{
    const { products: products, showProduct: showProduct, getActiveProduct: getActiveProduct, isExpanded: isExpanded, abTest: abTest } = props;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const onTabClicked = (index)=>{
        const id = products[index].id;
        showProduct(products[index].id);
        fireAnalyticsEvent((0, $5dFS9.onTabSelected)({
            tabName: id
        }));
    };
    const activeProductId = getActiveProduct()?.id;
    const activeProductIndex = products.findIndex((product)=>product.id === activeProductId);
    const primaryProduct = products.find((product)=>product.order === 0);
    if (activeProductIndex === -1 && isExpanded && primaryProduct && abTest) {
        showProduct(primaryProduct.id);
        return null;
    }
    if (!isExpanded || products.length === 1 || !abTest || !primaryProduct) return null;
    // Tabs has unwanted flex-basis: 100% set, div wrapper gets around this
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aQmDW.DisableXPSAB), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5EVbL.TabControlsWrapper), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4A7Gn.default), {
                selected: activeProductIndex,
                onChange: onTabClicked,
                id: "tab-controls",
                shouldUnmountTabPanelOnChange: true,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $0DTaW.default), {
                    children: products.map((product, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)($f90153b55c207314$var$CustomTab, {
                            index: index,
                            title: product.title,
                            tabRenderer: product.tabRenderer
                        }, product.id))
                })
            })
        })
    });
};
const $f90153b55c207314$export$f698db24bc555eee = (0, $gRazf.withABTestContext)((0, $fJRVo.withProductContext)((0, $gF7Az.withDialogExpansionContext)($f90153b55c207314$export$bd4c4b880e23a953)));

});
parcelRegister("aQmDW", function(module, exports) {

$parcel$export(module.exports, "DisableXPSAB", () => $fdf090eb866a7114$export$67fbd6b459867ac2);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gRazf = parcelRequire("gRazf");
const $fdf090eb866a7114$export$67fbd6b459867ac2 = ({ children: children })=>{
    const abTest = (0, $gRazf.useABTest)();
    if (abTest?.experimentId === 'xps-hidden') // This experiment is a permanent FE experiment inside aggregator.
    return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
};

});

parcelRegister("5EVbL", function(module, exports) {

$parcel$export(module.exports, "TabControlsWrapper", () => $d8c356d6f37fe7d8$export$f26b9facc67e59ba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwrgp = parcelRequire("gwrgp");
const $d8c356d6f37fe7d8$export$f26b9facc67e59ba = (0, $gwrgp.default)("div", {
    target: "et5m3c0"
})({
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-200, 16px)"}`
});

});


parcelRegister("2ErY6", function(module, exports) {

$parcel$export(module.exports, "ActiveProductSearchInput", () => $088dcb4257ca9f76$export$88d712058aeecea7);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eSS4z = parcelRequire("eSS4z");

var $dh538 = parcelRequire("dh538");

var $1pSma = parcelRequire("1pSma");

var $fJRVo = parcelRequire("fJRVo");

var $3MlpZ = parcelRequire("3MlpZ");

var $2ZIpG = parcelRequire("2ZIpG");

var $gF7Az = parcelRequire("gF7Az");

var $gRazf = parcelRequire("gRazf");

var $9lA6g = parcelRequire("9lA6g");
var $boBbB = parcelRequire("boBbB");

var $a6FpF = parcelRequire("a6FpF");

var $80L9g = parcelRequire("80L9g");

var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");
const $088dcb4257ca9f76$export$83ddef5d719c74b1 = ({ forwardRef: forwardRef, isExpanded: isExpanded, setIsExpanded: setIsExpanded, activeProductId: activeProductId, query: query, setQuery: setQuery, onNavigateGeneric: onNavigateGeneric, isLoading: isLoading, pageLoadMetrics: pageLoadMetrics, shouldFillContainer: shouldFillContainer })=>{
    const inputRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if (pageLoadMetrics) {
            const { metric: metric, customDataGetter: customDataGetter } = pageLoadMetrics;
            metric.stop({
                customData: customDataGetter()
            });
        }
    }, [
        pageLoadMetrics
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isExpanded) inputRef?.current?.focus();
    }, [
        isExpanded,
        inputRef,
        activeProductId
    ]);
    const ref = (0, $3MlpZ.mergeRefCallback)(forwardRef, inputRef);
    const openPressTracing = (0, $1pSma.default)('product-search-input-open');
    const onOpen = (0, $gwFzn.useCallback)(()=>{
        setIsExpanded(true);
        if ((0, $dh538.fg)('cc_search_input_open_press_tracing')) openPressTracing();
    }, [
        setIsExpanded,
        openPressTracing
    ]);
    const onBack = (0, $gwFzn.useCallback)(()=>{
        setIsExpanded(false);
    }, [
        setIsExpanded
    ]);
    const inputComponentProps = {
        activeProductId: activeProductId,
        query: query,
        setQuery: setQuery,
        forwardRef: ref,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        onOpen: onOpen,
        onNavigateGeneric: onNavigateGeneric,
        onBack: onBack,
        isLoading: isLoading,
        shouldFillContainer: shouldFillContainer
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a6FpF.GenericProductSearchInput), {
        ...inputComponentProps
    });
};
const $088dcb4257ca9f76$export$88d712058aeecea7 = ({ features: features, shouldFillContainer: shouldFillContainer, ...rest })=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const { query: query, setQuery: setQuery, isLoading: isLoading } = (0, $2ZIpG.useQuery)();
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { stickySearchEnabled: stickySearchEnabled } = (0, $80L9g.useSessionUserInput)();
    const abTest = (0, $gRazf.useABTest)();
    const theme = (0, $eSS4z.useTheme)();
    const activeProduct = getActiveProduct();
    const intl = (0, $dBxQj.default)();
    if (!abTest) return features?.interactiveSkeleton ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boBbB.ProductSearchInputSkeletonInteractive), {
        theme: theme,
        shouldFillContainer: shouldFillContainer,
        stickySearchEnabled: stickySearchEnabled,
        ...features.interactiveSkeleton
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9lA6g.ProductSearchInputSkeleton), {
        shouldFillContainer: shouldFillContainer,
        theme: theme,
        placeholder: intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder)
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($088dcb4257ca9f76$export$83ddef5d719c74b1, {
        ...rest,
        shouldFillContainer: shouldFillContainer,
        activeProductId: activeProduct?.id,
        query: query,
        setQuery: setQuery,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        isLoading: isLoading
    });
};

});
parcelRegister("9lA6g", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInputSkeleton", () => $40910eaaf86d577d$export$91fb362ea940bd8b);
/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $4smHY = parcelRequire("4smHY");
var $eSS4z = parcelRequire("eSS4z");
parcelRequire("gwFzn");
const $40910eaaf86d577d$export$91fb362ea940bd8b = ({ theme: theme, ...rest })=>{
    if (theme) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eSS4z.ThemeProvider), {
        partialSearchCSS: theme,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4smHY.default), {
            ...rest
        })
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4smHY.default), {
        ...rest
    });
};

});
parcelRegister("4smHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ea4f392138dd417$export$2e2bcd8739ae039);
/*
 * Skeleton consumed by product-search-dialog only,
 * check the comments in packages/product-search-dialog/src/common/product-search-input/product-search-input-skeleton.tsx.
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eSS4z = parcelRequire("eSS4z");

var $fwSxy = parcelRequire("fwSxy");

var $kHWmv = parcelRequire("kHWmv");

var $iSHbD = parcelRequire("iSHbD");

var $1qfLF = parcelRequire("1qfLF");

var $fG2rA = parcelRequire("fG2rA");

var $1jolb = parcelRequire("1jolb");
const $6ea4f392138dd417$var$MAX_INPUT_LENGTH = 500;
const $6ea4f392138dd417$export$9b2f977cfc67f251 = (props)=>{
    const theme = (0, $eSS4z.useTheme)();
    const { forwardRef: forwardRef, features: features, shouldFillContainer: shouldFillContainer, placeholder: nonFeaturesPlaceholder, ariaLabel: ariaLabel, dataSsrPlaceholder: dataSsrPlaceholder } = props;
    const { enabled: enabled, advancedSearchUrl: advancedSearchUrl, placeholder: placeholder, customScriptDataAttributes: customScriptDataAttributes } = features?.interactiveSkeleton || {};
    if (enabled || (0, $fG2rA.getInputSkeletonFocus)()) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1jolb.SSRsearchInput), {
        shouldFillContainer: shouldFillContainer,
        advancedSearchUrl: advancedSearchUrl,
        placeholder: placeholder || nonFeaturesPlaceholder,
        customScriptDataAttributes: customScriptDataAttributes,
        theme: theme
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kHWmv.SearchAnchorWrapper), {
        shouldFillContainer: shouldFillContainer,
        "data-ssr-placeholder": dataSsrPlaceholder,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fwSxy.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: false,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.MobileSearchIconWrapper), {
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                theme: theme,
                                isExpanded: false,
                                size: "medium"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.DesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: false,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                        theme: theme,
                        isExpanded: false
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SearchInputField), {
                    "data-test-id": "search-dialog-search-skeleton",
                    isExpanded: false,
                    placeholder: nonFeaturesPlaceholder || placeholder,
                    ref: forwardRef || undefined,
                    disabled: true,
                    value: "",
                    maxLength: $6ea4f392138dd417$var$MAX_INPUT_LENGTH,
                    onChange: ()=>{},
                    "aria-label": ariaLabel || nonFeaturesPlaceholder || placeholder,
                    ...theme
                })
            ]
        })
    });
};
var $6ea4f392138dd417$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)($6ea4f392138dd417$export$9b2f977cfc67f251, {
        ...props,
        forwardRef: ref
    }));

});
parcelRegister("1jolb", function(module, exports) {

$parcel$export(module.exports, "SSRsearchInput", () => SSRsearchInput);
/* eslint-disable import/extensions */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $fwSxy = parcelRequire("fwSxy");

var $2wQTl = parcelRequire("2wQTl");

var $iSHbD = parcelRequire("iSHbD");
const SSRsearchInput = ({ advancedSearchUrl, placeholder, customScriptDataAttributes, theme, shouldFillContainer })=>{
    const scriptRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useLayoutEffect)(()=>{
        const current = scriptRef?.current;
        if (current) // eslint-disable-next-line
        eval(current.innerHTML);
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRsearchInputWrapper), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            id: "ssr-search-input-popout-container",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRformContainer), {
                id: "ssr-form-container",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("form", {
                    method: "get",
                    action: advancedSearchUrl,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fwSxy.SSRsearchInputContainer), {
                            shouldFillContainer: shouldFillContainer,
                            id: "ssr-input-container",
                            role: "search",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRmobileSearchIconWrapper), {
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false,
                                        size: "medium"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRdesktopSearchIconWrapper), {
                                    id: "ssr-search-icon-wrapper",
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                        theme: theme,
                                        isExpanded: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.SSRsearchInputField), {
                                    id: "ssr-search-input",
                                    name: "text",
                                    placeholder: placeholder,
                                    autoComplete: "off",
                                    "aria-label": placeholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("script", {
                            "data-test-id": "ssr-scripts-init",
                            ref: scriptRef,
                            dangerouslySetInnerHTML: {
                                __html: (0, $2wQTl.script)
                            },
                            ...customScriptDataAttributes
                        })
                    ]
                })
            })
        })
    });
};

});



parcelRegister("a6FpF", function(module, exports) {

$parcel$export(module.exports, "GenericProductSearchInput", () => $e66e5da1711e0ddd$export$372be6d3f9d3f49);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $eaXrL = parcelRequire("eaXrL");

var $bF0iL = parcelRequire("bF0iL");

var $fJRVo = parcelRequire("fJRVo");

var $amrMu = parcelRequire("amrMu");

var $4wMwH = parcelRequire("4wMwH");
const $e66e5da1711e0ddd$var$debounceTime = 250;
const $e66e5da1711e0ddd$var$GenericInputWithIntl = ({ activeProductId: activeProductId, intl: intl, onNavigateGeneric: onNavigateGeneric, query: query, isExpanded: isExpanded, isLoading: isLoading, onOpen: onOpen, forwardRef: forwardRef, onBack: onBack, setQuery: setQuery, shouldFillContainer: shouldFillContainer })=>{
    const { getProduct: getProduct } = (0, $fJRVo.useProductContext)();
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    const hasQueryParamText = queryParams?.hasOwnProperty('text');
    const queryParamText = queryParams?.text?.toString() || '';
    const onNavigateGenericInput = (0, $gwFzn.useCallback)((productId)=>(href, event)=>{
            if (href) onNavigateGeneric(productId, href, event);
        }, [
        onNavigateGeneric
    ]);
    // We're using a ref for setQuery so that we can guarantee the function
    // definition is the same reference between renders.
    const setQueryRef = (0, $gwFzn.useRef)(setQuery);
    (0, $gwFzn.useEffect)(()=>{
        setQueryRef.current = setQuery;
    }, [
        setQuery
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isGriffinNavEnabled && hasQueryParamText) setQueryRef.current(queryParamText);
    }, [
        isGriffinNavEnabled,
        hasQueryParamText,
        queryParamText,
        setQueryRef
    ]);
    const { advancedSearchUrl: advancedSearchUrl, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, onNavigate: onNavigate, actionSubjectId: actionSubjectId, expandedStateInputPlaceholder: // @ts-expect-error
    expandedStateInputPlaceholder } = (()=>{
        if (!activeProductId || !getProduct(activeProductId)) return {
            advancedSearchUrl: '',
            secondaryAdvancedSearchURL: '',
            onNavigate: isGriffinNavEnabled ? onNavigateGenericInput('') : ()=>{},
            actionSubjectId: 'noActiveProduct'
        };
        return {
            advancedSearchUrl: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query) || '',
            secondaryAdvancedSearchURL: getProduct(activeProductId)?.generateAdvancedSearchUrl?.(query, undefined, 'onInputEnterModified') || '',
            expandedStateInputPlaceholder: getProduct(activeProductId)?.expandedStateInputPlaceholder || '',
            onNavigate: onNavigateGenericInput(activeProductId),
            actionSubjectId: activeProductId
        };
    })();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eaXrL.ProductSearchInput), {
        shouldFillContainer: shouldFillContainer,
        forwardRef: forwardRef,
        value: query,
        isExpanded: isExpanded,
        isLoading: isLoading,
        onOpen: onOpen,
        debounceTime: $e66e5da1711e0ddd$var$debounceTime,
        advancedSearchURL: advancedSearchUrl,
        secondaryAdvancedSearchURL: secondaryAdvancedSearchURL,
        actionSubjectId: actionSubjectId,
        onBack: onBack,
        onInput: setQuery,
        expandedPlaceholder: expandedStateInputPlaceholder ? expandedStateInputPlaceholder : intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder),
        collapsedPlaceholder: intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder),
        onNavigate: onNavigate
    });
};
const $e66e5da1711e0ddd$export$372be6d3f9d3f49 = (0, $js7oX.default)($e66e5da1711e0ddd$var$GenericInputWithIntl);

});
parcelRegister("eaXrL", function(module, exports) {

$parcel$export(module.exports, "ProductSearchInput", () => $b16b15c35dd761da$export$1ea4f29215db3ad6);

var $7UHDa = parcelRequire("7UHDa");

var $9jN1i = parcelRequire("9jN1i");
var $fG2rA = parcelRequire("fG2rA");
var $epS7s = parcelRequire("epS7s");
var $1IGQP = parcelRequire("1IGQP");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $dh538 = parcelRequire("dh538");

var $7rlMm = parcelRequire("7rlMm");

var $3S0fp = parcelRequire("3S0fp");
var $2bO3z = parcelRequire("2bO3z");
var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");

var $4ldrV = parcelRequire("4ldrV");

var $bF0iL = parcelRequire("bF0iL");

var $3MlpZ = parcelRequire("3MlpZ");

var $80L9g = parcelRequire("80L9g");

var $gF7Az = parcelRequire("gF7Az");

var $fJRVo = parcelRequire("fJRVo");

var $2ZIpG = parcelRequire("2ZIpG");

var $20N1w = parcelRequire("20N1w");

var $amrMu = parcelRequire("amrMu");

var $4wMwH = parcelRequire("4wMwH");

var $eztGN = parcelRequire("eztGN");

var $hWEfb = parcelRequire("hWEfb");

const $b16b15c35dd761da$var$SearchAIPromptComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("6BCmY")).then(({ SearchAIPrompt: SearchAIPrompt })=>({
            default: SearchAIPrompt
        })));
const $b16b15c35dd761da$var$AskAIButton = ()=>{
    const { query: query } = (0, $2ZIpG.useQuery)();
    const queryHash = (0, $3S0fp.sha256Hash)(query);
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const activeProduct = getActiveProduct();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const { isExpanded: isExpanded, setIsExpanded: setIsExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const handleToggleShowSearchAIDialog = (0, $gwFzn.useCallback)((show)=>{
        if (isGriffinNavEnabled) setIsExpanded(show);
        toggleShowSearchAIDialog(show);
    }, [
        isGriffinNavEnabled,
        setIsExpanded,
        toggleShowSearchAIDialog
    ]);
    return !!activeProduct?.aiSearchConfig || !!showSearchAIDialog && isExpanded || isGriffinNavEnabled ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {}),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($b16b15c35dd761da$var$SearchAIPromptComponent, {
            query: query,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            onToggleShowSearchAIDialog: handleToggleShowSearchAIDialog,
            source: "searchDialog"
        })
    }) : null;
};
const $b16b15c35dd761da$var$getTooltipContent = (message)=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7rlMm.KeyboardShortcutContainer), {
        children: [
            message,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7rlMm.KeyboardShortcut), {
                children: '/'
            })
        ]
    });
class $b16b15c35dd761da$export$f964308946b6123b extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidMount() {
        const { onInput: onInput, stickySearchEnabled: stickySearchEnabled } = this.props;
        const skeletonFocused = (0, $fG2rA.getInputSkeletonFocus)();
        const skeletonQuery = (0, $fG2rA.getInputSkeletonQuery)();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = (0, $fG2rA.getInputSkeletonSelection)();
        const stickySearchQuery = (0, $epS7s.getSessionItem)((0, $epS7s.SEARCH_QUERY_KEY)) || '';
        if (skeletonFocused) {
            this.expand((0, $5dFS9.Trigger).CLICK);
            onInput?.(skeletonQuery);
            if (this.ref) {
                this.ref.value = skeletonQuery;
                this.ref.focus();
                this.ref?.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
            }
        }
        (0, $fG2rA.removeInputSkeletonState)();
        if (stickySearchEnabled && stickySearchQuery) onInput?.(stickySearchQuery);
    }
    render() {
        const { value: value, isExpanded: isExpanded, expandedPlaceholder: expandedPlaceholder, collapsedPlaceholder: collapsedPlaceholder, debounceTime: debounceTime, intl: intl, showAIToggleButton: showAIToggleButton, isQuickFind: isQuickFind, ...rest } = this.props;
        const placeholder = isExpanded ? expandedPlaceholder : collapsedPlaceholder;
        const tooltipContent = $b16b15c35dd761da$var$getTooltipContent(intl.formatMessage((0, $bF0iL.messages).common_search_input_collapsed_placeholder));
        const SearchInputComponent = isQuickFind ? (0, $9jN1i.default) : (0, $1IGQP.default);
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                isExpanded ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2bO3z.default), {
                    query: value,
                    debounceTime: debounceTime
                }) : null,
                /*#__PURE__*/ (0, $7UHDa.jsx)(SearchInputComponent, {
                    ...rest,
                    onClick: this.onInputClick,
                    onInput: this.onInput,
                    ref: this.onRef,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    value: value,
                    onEnter: this.onEnter,
                    onClear: this.onClear,
                    toggleAISearchButton: showAIToggleButton ? /*#__PURE__*/ (0, $7UHDa.jsx)($b16b15c35dd761da$var$AskAIButton, {}) : undefined,
                    tooltipContent: tooltipContent,
                    exitSearchLabel: intl.formatMessage((0, $bF0iL.messages).common_search_input_exit_button_label),
                    clearSearchLabel: intl.formatMessage((0, $bF0iL.messages).common_search_input_clear_button_label),
                    ...isQuickFind && {
                        ariaLabelContent: intl.formatMessage((0, $bF0iL.messages).common_search_input_enlarged_aria_label)
                    }
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.onInput = (value)=>{
            if (value !== this.props.value) {
                this.expand((0, $5dFS9.Trigger).TEXT_ENTERED);
                this.props.onInput?.(value);
            }
        };
        this.expand = (trigger)=>{
            const { isExpanded: isExpanded, onOpen: onOpen, preQueryScreenViewed: preQueryScreenViewed, searchSessionId: searchSessionId } = this.props;
            if (!isExpanded) {
                onOpen();
                preQueryScreenViewed({
                    searchSessionId: searchSessionId,
                    trigger: trigger
                });
            }
        };
        this.close = (e)=>{
            const { isExpanded: isExpanded, onBack: onBack } = this.props;
            if (isExpanded) onBack?.(e);
        };
        this.onInputClick = ()=>{
            setTimeout(()=>this.ref?.focus());
            this.expand((0, $5dFS9.Trigger).CLICK);
        };
        this.onEnter = (event)=>{
            const { isExpanded: isExpanded, onEnter: onEnter } = this.props;
            if (isExpanded) onEnter?.(event);
        };
        this.onClear = ()=>{
            setTimeout(()=>this.ref?.focus());
            this.props.onClear?.();
        };
        this.onRef = (0, $3MlpZ.mergeRefCallback)(this.props.forwardRef, (ref)=>{
            this.ref = ref;
        });
    }
}
const $b16b15c35dd761da$export$b12c0eea3d812057 = (0, $js7oX.default)($b16b15c35dd761da$export$f964308946b6123b);
const $b16b15c35dd761da$export$1ea4f29215db3ad6 = (props)=>{
    const [_ignore, persistRecentSearchOnEnter] = (0, $20N1w.usePersistRecentSearches)();
    const { actionSubjectId: actionSubjectId, advancedSearchURL: advancedSearchURL, secondaryAdvancedSearchURL: secondaryAdvancedSearchURL, isLoading: isLoading, onNavigate: onNavigate, ...rest } = props;
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { stickySearchEnabled: stickySearchEnabled, query: query, resetSearchSession: resetSearchSession, showSearchAIDialog: showSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const { allowChangeExpand: allowChangeExpand } = (0, $gF7Az.useDialogExpansionContext)();
    const { getActiveProduct: getActiveProduct, getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const isRovoCrossProductSearchLinkShown = (0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id);
    const { quickFind: quickFind, isGriffinNavEnabled: isGriffinNavEnabled } = (0, $amrMu.useFeaturesContext)();
    const showSearchOnEnter = !!getActiveProduct()?.showSearchOnEnter;
    const invokePostQuerySearchRef = getActiveProduct()?.invokePostQuerySearchRef;
    const activeProduct = getActiveProduct();
    const showAskAIButton = (0, $gwFzn.useMemo)(()=>{
        if (activeProduct) return !!activeProduct.aiSearchConfig;
        return query.length > 0;
    }, [
        query,
        activeProduct
    ]);
    const aiSearchEnabled = isGriffinNavEnabled ? showAskAIButton : !!getActiveProduct()?.aiSearchConfig || !!showSearchAIDialog;
    const isQuickFind = quickFind?.enabled;
    const { queryParams: queryParams } = (0, $4wMwH.useQueryParams)();
    const onEnter = (0, $gwFzn.useCallback)((event)=>{
        if ((0, $dh538.fg)('psd_stop_propagation_on_enter')) event.stopPropagation();
        persistRecentSearchOnEnter(event);
        if (showSearchAIDialog) return;
        if (showSearchOnEnter && !event?.shiftKey) {
            if (invokePostQuerySearchRef) {
                fireAnalyticsEvent((0, $5dFS9.onNonDebouncedSearchTriggered)());
                invokePostQuerySearchRef.current();
            }
            return;
        }
        const modifierKeyPressed = navigator.userAgent.includes('Mac') ? event.metaKey : event.ctrlKey;
        fireAnalyticsEvent((0, $5dFS9.onAdvancedSearchSelected)({
            actionSubjectId: actionSubjectId,
            isLoading: isLoading,
            newTab: false,
            trigger: modifierKeyPressed ? (0, $5dFS9.Trigger).SHORTCUT_MODIFIED : (0, $5dFS9.Trigger).SHORTCUT,
            // We know the user navigated to Rovo Search in Atlassian Home if the Rovo Search link was shown to them AND they either:
            // 1. navigated when the "All" product tab was selected
            // 2. navigated by using (cmd or ctrl) + enter when any product tab was selected
            isRovoCrossProductSearchLink: isRovoCrossProductSearchLinkShown && (activeProduct?.id === (0, $hWEfb.CROSS_PRODUCT_PRODUCT_ID) || modifierKeyPressed)
        }));
        if (stickySearchEnabled && advancedSearchURL && !isGriffinNavEnabled && !(event.metaKey || event.ctrlKey)) resetSearchSession();
        if (isGriffinNavEnabled) event.currentTarget.blur();
        onNavigate(modifierKeyPressed && secondaryAdvancedSearchURL ? secondaryAdvancedSearchURL : advancedSearchURL, event);
    }, [
        persistRecentSearchOnEnter,
        showSearchAIDialog,
        showSearchOnEnter,
        fireAnalyticsEvent,
        actionSubjectId,
        isLoading,
        stickySearchEnabled,
        advancedSearchURL,
        onNavigate,
        secondaryAdvancedSearchURL,
        invokePostQuerySearchRef,
        resetSearchSession,
        isGriffinNavEnabled,
        isRovoCrossProductSearchLinkShown,
        activeProduct?.id
    ]);
    const onClear = (0, $gwFzn.useCallback)(()=>{
        fireAnalyticsEvent((0, $5dFS9.onXButtonClicked)({
            actionSubjectId: actionSubjectId,
            searchSessionId: searchSessionId
        }));
        resetSearchSession();
        allowChangeExpand(true);
    }, [
        fireAnalyticsEvent,
        actionSubjectId,
        searchSessionId,
        resetSearchSession,
        allowChangeExpand
    ]);
    const onPreQueryScreenViewedCB = (0, $gwFzn.useCallback)((preQueryProps)=>fireAnalyticsEvent({
            ...(0, $5dFS9.onPreQueryScreenViewed)(preQueryProps),
            actionSubject: actionSubjectId
        }), [
        fireAnalyticsEvent,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($b16b15c35dd761da$export$b12c0eea3d812057, {
        ...rest,
        onEnter: onEnter,
        searchSessionId: searchSessionId,
        preQueryScreenViewed: onPreQueryScreenViewedCB,
        onClear: onClear,
        showClearButton: stickySearchEnabled && query !== '',
        allowChangeExpand: allowChangeExpand,
        stickySearchEnabled: stickySearchEnabled,
        showSearchOnEnter: showSearchOnEnter,
        showAIToggleButton: aiSearchEnabled,
        isLoading: isLoading,
        onNavigate: onNavigate,
        isQuickFind: isQuickFind,
        isGriffinNavEnabled: isGriffinNavEnabled,
        queryParams: queryParams
    });
};

});
parcelRegister("9jN1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $701d0a94d5d1fefc$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $3bV1Q = parcelRequire("3bV1Q");

var $1qfLF = parcelRequire("1qfLF");

var $eSS4z = parcelRequire("eSS4z");

var $iSHbD = parcelRequire("iSHbD");

var $fwSxy = parcelRequire("fwSxy");

var $kLFxv = parcelRequire("kLFxv");

var $c4tFX = parcelRequire("c4tFX");

var $6fnsQ = parcelRequire("6fnsQ");
const $701d0a94d5d1fefc$var$MAX_INPUT_LENGTH = 500;
const $701d0a94d5d1fefc$export$33e4ffe00576d3b4 = ({ onInput: onInput, onClick: onClick, onEnter: onEnter, isExpanded: isExpanded, placeholder: placeholder, forwardRef: forwardRef, value: value, theme: theme, tooltipContent: tooltipContent, onBack: onBack, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, exitSearchLabel: exitSearchLabel, clearSearchLabel: clearSearchLabel, shouldFillContainer: shouldFillContainer, onSelect: onSelect, ariaLabelContent: ariaLabelContent })=>{
    const handleInput = (e)=>{
        if (onInput) onInput(e.currentTarget.value);
    };
    const handleClick = (e)=>{
        if (onClick) onClick(e);
    };
    const handleKeyDown = (e)=>{
        if (e.nativeEvent?.isComposing || e.keyCode === 229) return;
        if (!e.defaultPrevented && e.key === 'Enter') {
            e.preventDefault();
            onEnter && onEnter(e);
        }
    };
    const handleSelect = (e)=>{
        if (onSelect) onSelect(e);
    };
    const TooltipComponent = tooltipContent && !isExpanded ? undefined : (0, $fwSxy.HiddenTooltip);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        // NOTE: Types in React 18 have changed, `styled(TooltipPrimitive)` is no longer valid
        component: TooltipComponent,
        position: "bottom",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $fwSxy.SearchInputContainer), {
            ...theme,
            shouldFillContainer: shouldFillContainer,
            isExpanded: isExpanded,
            role: "search",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.MobileSearchIconWrapper), {
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        onClick: handleClick,
                        label: "Search",
                        icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                                theme: theme,
                                isExpanded: isExpanded,
                                size: "small"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kLFxv.EnlargedDesktopSearchIconWrapper), {
                    ...theme,
                    isExpanded: isExpanded,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iSHbD.SearchIcon), {
                        theme: theme,
                        isExpanded: isExpanded,
                        size: isExpanded ? 'medium' : 'small',
                        primaryColor: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
                    })
                }),
                isExpanded && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.ArrowIconWrapper), {
                    ...theme,
                    onClick: onBack,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3bV1Q))), {
                        label: exitSearchLabel || 'Exit Search',
                        LEGACY_size: "large",
                        color: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kLFxv.EnlargedSearchInputField), {
                    "data-test-id": "search-dialog-input",
                    onInput: handleInput,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    onClick: handleClick,
                    onSelect: handleSelect,
                    isExpanded: isExpanded,
                    placeholder: placeholder,
                    ref: forwardRef || undefined,
                    value: value,
                    maxLength: $701d0a94d5d1fefc$var$MAX_INPUT_LENGTH,
                    "aria-label": ariaLabelContent || placeholder,
                    ...theme
                }),
                showClearButton && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4tFX.EnlargedSearchInputOverlay), {
                    theme: theme,
                    showClearButton: showClearButton,
                    onClear: onClear,
                    allowChangeExpand: allowChangeExpand,
                    clearSearchLabel: clearSearchLabel,
                    isExpanded: isExpanded
                })
            ]
        })
    });
};
var $701d0a94d5d1fefc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef((props, ref)=>{
    const theme = (0, $eSS4z.useTheme)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)($701d0a94d5d1fefc$export$33e4ffe00576d3b4, {
        ...props,
        theme: theme,
        forwardRef: ref
    });
});

});
parcelRegister("kLFxv", function(module, exports) {

$parcel$export(module.exports, "EnlargedDesktopSearchIconWrapper", () => $b971e56a6791576d$export$3324ef4e3e3970dc);
$parcel$export(module.exports, "EnlargedClearIconWrapper", () => $b971e56a6791576d$export$68bd88880d49fc5);
$parcel$export(module.exports, "EnlargedSearchInputField", () => $b971e56a6791576d$export$aa34c63c6bd8fcb0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2azjJ = parcelRequire("2azjJ");

var $6fnsQ = parcelRequire("6fnsQ");

var $fwSxy = parcelRequire("fwSxy");

var $gwrgp = parcelRequire("gwrgp");
const $b971e56a6791576d$export$3324ef4e3e3970dc = /*#__PURE__*/ (0, $gwrgp.default)((0, $fwSxy.DesktopSearchIconWrapper), {
    target: "e4mn9mz0"
})("width:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).half().px : (0, $2azjJ.grid).multiple(2).px, ";height:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).half().px : (0, $2azjJ.grid).multiple(2).px, ";top:", (props)=>props.isExpanded ? (0, $2azjJ.grid).multiple(1.5).px : (0, $2azjJ.grid).px, ";left:", (props)=>props.isExpanded ? (0, $2azjJ.grid).multiple(2).px : (0, $2azjJ.grid).px, ";display:flex;align-items:center;");
const $b971e56a6791576d$export$68bd88880d49fc5 = /*#__PURE__*/ (0, $gwrgp.default)((0, $fwSxy.ClearIconWrapper), {
    target: "e4mn9mz1"
})("width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);padding-top:0;padding-bottom:0;padding-left:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-150, 12px)"}` : '0', ";padding-right:", ({ isExpanded: isExpanded })=>isExpanded ? `${"var(--ds-space-200, 16px)"}` : '2px', ";color:", `var(--ds-text-subtle, ${(0, $6fnsQ.N500)})`, ";");
const $b971e56a6791576d$export$aa34c63c6bd8fcb0 = /*#__PURE__*/ (0, $gwrgp.default)((0, $fwSxy.SearchInputField), {
    target: "e4mn9mz2"
})("display:flex;align-items:center;height:", (props)=>props.isExpanded ? (0, $2azjJ.enlargedInputFieldHeight).px : (0, $2azjJ.inputFieldHeight).px, ";border-radius:", (props)=>props.isExpanded ? '8px' : '5px', ";padding:", (props)=>props.isExpanded ? `${"var(--ds-space-150, 12px)"} 52px ${"var(--ds-space-150, 12px)"} 52px` : `0px ${"var(--ds-space-300, 24px)"} 0px 30px`, ";:focus{border:none;box-shadow:", `var(--ds-shadow-overlay, ${'0 ' + (0, $2azjJ.grid).multiple(0.5).px + ' ' + (0, $2azjJ.grid).px + ' ' + (0, $6fnsQ.N50A) + ', 0 0 1px ' + (0, $6fnsQ.N60A)})`, ";}");

});

parcelRegister("c4tFX", function(module, exports) {

$parcel$export(module.exports, "EnlargedSearchInputOverlay", () => $9d7751af5f629de9$export$cfdb69c9b0b1fec);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $fwSxy = parcelRequire("fwSxy");

var $2hj6R = parcelRequire("2hj6R");

var $kLFxv = parcelRequire("kLFxv");
const $9d7751af5f629de9$export$cfdb69c9b0b1fec = ({ theme: theme, showClearButton: showClearButton, onClear: onClear, allowChangeExpand: allowChangeExpand, clearSearchLabel: clearSearchLabel, isExpanded: isExpanded })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fwSxy.InputBoxOverlayRight), {
        children: showClearButton && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kLFxv.EnlargedClearIconWrapper), {
            ...theme,
            role: "button",
            onClick: onClear,
            onMouseEnter: ()=>{
                allowChangeExpand?.(false);
            },
            onMouseLeave: ()=>{
                allowChangeExpand?.(true);
            },
            tabIndex: 0,
            isExpanded: isExpanded,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2hj6R))), {
                color: "currentColor",
                label: clearSearchLabel || 'Clear search session',
                LEGACY_size: "medium",
                spacing: "spacious"
            })
        })
    });
};

});


parcelRegister("7rlMm", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcutContainer", () => $be76b25cc1b2639d$export$e2deb14b255cffa0);
$parcel$export(module.exports, "KeyboardShortcut", () => $be76b25cc1b2639d$export$47a1bf8d9994c680);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $be76b25cc1b2639d$export$e2deb14b255cffa0 = (0, $gwrgp.default)("div", {
    target: "e19ugnpx0"
})({
    name: "xwvfuj",
    styles: "display:flex;line-height:16px;align-items:center;padding-bottom:var(--ds-space-025, 2px);padding-top:var(--ds-space-025, 2px);"
});
const $be76b25cc1b2639d$export$47a1bf8d9994c680 = (0, $gwrgp.default)("div", {
    target: "e19ugnpx1"
})({
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N400)})`,
    border: `1px solid ${`var(--ds-text-inverse, ${(0, $6fnsQ.N400)})`}`,
    borderRadius: '2px',
    marginLeft: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-100, 8px)"}`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});

});

parcelRegister("2bO3z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3576e5ec930ddc0$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $5dFS9 = parcelRequire("5dFS9");

var $lnXRc = parcelRequire("lnXRc");

var $2jjxD = parcelRequire("2jjxD");
class $b3576e5ec930ddc0$export$6cdeb9eeefdb65f3 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    componentDidUpdate(prevProps) {
        const { query: query } = this.props;
        if (prevProps.query !== query) /**
       * Earlier this component was child of [confluence|jira]-search-dialog which ensured that this got fired after the debounced search.
       * Now it will get moved to the wrapper component which will bring this at the same level as [confluence|jira]-search-dialog.
       * This leads to the event handler getting fired in the same tick before the debounced search.
       * Hence, forceful execution in the next tick.
       */ setTimeout(()=>this.textEntered());
    }
    componentWillUnmount() {
        this.textEntered.cancel();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.textEntered = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(()=>{
            const { textEntered: textEntered } = this.props;
            textEntered();
        }, this.props.debounceTime || 0);
    }
}
var $b3576e5ec930ddc0$export$2e2bcd8739ae039 = (0, $lnXRc.withAnalytics)({
    textEntered: (0, $5dFS9.onTextEntered)
})($b3576e5ec930ddc0$export$6cdeb9eeefdb65f3);

});

parcelRegister("hWEfb", function(module, exports) {

$parcel$export(module.exports, "CROSS_PRODUCT_PRODUCT_ID", () => $6bef6d6b7bd7e701$export$6f9668437bcabf4e);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $kmpep = parcelRequire("kmpep");

var $aXg1M = parcelRequire("aXg1M");

var $k5vpy = parcelRequire("k5vpy");

var $ejGzS = parcelRequire("ejGzS");

var $avAUi = parcelRequire("avAUi");

var $4ldrV = parcelRequire("4ldrV");

var $lfOhG = parcelRequire("lfOhG");

var $74Udv = parcelRequire("74Udv");
const $6bef6d6b7bd7e701$export$6f9668437bcabf4e = 'rovo-cross-product';
const $6bef6d6b7bd7e701$var$resultRenderer = (args)=>(0, $ejGzS.defaultResultRenderer)({
        ...args,
        isCollapsed: true
    });
const $6bef6d6b7bd7e701$export$6ca9415334f42abe = ()=>{
    const intl = (0, $dBxQj.default)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const [results, setResults] = (0, $gwFzn.useState)([]);
    const [isQueryResolved, setIsQueryResolved] = (0, $gwFzn.useState)(false);
    const hasFilters = (0, $lfOhG.useCurrentProductHasAppliedFilters)();
    const preQuerySupplier = (0, $gwFzn.useCallback)(async ()=>{
        let currentResults = results;
        if (!isQueryResolved) {
            const response = await (0, $avAUi.fetchRecentActivities)(cloudId || '', searchSessionId || '');
            currentResults = response.filter((result)=>result !== undefined);
            setResults(currentResults);
            setIsQueryResolved(true);
        }
        return {
            size: currentResults.length,
            sections: [
                {
                    id: (0, $aXg1M.CrossProductScope).RECENTS,
                    title: intl.formatMessage((0, $k5vpy.messages).cross_product_recents_section_heading),
                    searchResults: currentResults,
                    resultRenderer: $6bef6d6b7bd7e701$var$resultRenderer
                }
            ]
        };
    }, [
        cloudId,
        intl,
        isQueryResolved,
        results,
        searchSessionId
    ]);
    const postQuerySupplier = (0, $gwFzn.useCallback)(async (args)=>{
        let currentResults = results;
        if (!isQueryResolved) {
            const response = await (0, $avAUi.fetchRecentActivities)(cloudId || '', searchSessionId || '');
            currentResults = response.filter((result)=>result !== undefined);
            setResults(currentResults);
            setIsQueryResolved(true);
        }
        const searchResults = {
            size: currentResults.length,
            sections: [
                {
                    id: (0, $aXg1M.CrossProductScope).RESULTS,
                    title: intl.formatMessage((0, $k5vpy.messages).cross_product_results_section_heading),
                    searchResults: currentResults,
                    resultRenderer: $6bef6d6b7bd7e701$var$resultRenderer
                }
            ]
        };
        return (0, $74Udv.filterFirstSectionItems)(searchResults, args.query, hasFilters ? 0 : 3);
    }, [
        cloudId,
        intl,
        isQueryResolved,
        results,
        searchSessionId,
        hasFilters
    ]);
    return {
        preQuerySupplier: preQuerySupplier,
        postQuerySupplier: postQuerySupplier
    };
};

});
parcelRegister("aXg1M", function(module, exports) {

$parcel$export(module.exports, "CrossProductScope", () => $7a3bb0801b8c1429$export$8b40788ab131f69a);
var $7a3bb0801b8c1429$export$8b40788ab131f69a = /*#__PURE__*/ function(CrossProductScope) {
    CrossProductScope["RECENTS"] = "rovo-cross-product.recents";
    CrossProductScope["RESULTS"] = "rovo-cross-product.results";
    return CrossProductScope;
}({});

});

parcelRegister("k5vpy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $644bc14e6914d1ea$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $644bc14e6914d1ea$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    cross_product_tab_label: {
        id: "product_search_dialog.cross_product.tab_label",
        defaultMessage: "All"
    },
    cross_product_expanded_input_placeholder: {
        id: "product_search_dialog.cross_product.expanded.input-placeholder",
        defaultMessage: "Search All"
    },
    cross_product_recents_section_heading: {
        id: "product_search_dialog.cross_product.recents.section_heading",
        defaultMessage: "Recently viewed"
    },
    cross_product_results_section_heading: {
        id: "product_search_dialog.cross_product.results.section_heading",
        defaultMessage: "Search results"
    },
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    },
    cross_product_empty_state_body: {
        id: "product_search_dialog.cross_product.empty.no_results_body",
        defaultMessage: "<a>Search all content across your organization</a> or try a different term."
    },
    documentLabel: {
        id: "document.label",
        defaultMessage: "Document"
    },
    spreadsheetLabel: {
        id: "spreadsheet.label",
        defaultMessage: "Spreadsheet"
    },
    presentationLabel: {
        id: "presentation.label",
        defaultMessage: "Presentation"
    },
    fileLabel: {
        id: "file.label",
        defaultMessage: "File"
    },
    databaseLabel: {
        id: "database.label",
        defaultMessage: "Database"
    },
    webPageLabel: {
        id: "web-page.label",
        defaultMessage: "Web Page"
    },
    pageLabel: {
        id: "page.label",
        defaultMessage: "Page"
    },
    blogpostLabel: {
        id: "blogpost.label",
        defaultMessage: "Blogpost"
    },
    dashboardLabel: {
        id: "dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoiceLabel: {
        id: "invoice.label",
        defaultMessage: "Invoice"
    },
    designLabel: {
        id: "design.label",
        defaultMessage: "Design"
    },
    dealLabel: {
        id: "deal.label",
        defaultMessage: "Deal"
    },
    videoLabel: {
        id: "video.label",
        defaultMessage: "Video"
    },
    taskLabel: {
        id: "task.label",
        defaultMessage: "Task"
    },
    issueLabel: {
        id: "issue.label",
        defaultMessage: "Issue"
    },
    spaceLabel: {
        id: "space.label",
        defaultMessage: "Space"
    },
    projectLabel: {
        id: "project.label",
        defaultMessage: "Project"
    },
    repositoryLabel: {
        id: "repository.label",
        defaultMessage: "Repository"
    },
    customerOrgLabel: {
        id: "customer-org.label",
        defaultMessage: "Customer Org"
    },
    imageLabel: {
        id: "image.label",
        defaultMessage: "Image"
    },
    archiveLabel: {
        id: "archive.label",
        defaultMessage: "Archive"
    },
    audioLabel: {
        id: "audio.label",
        defaultMessage: "Audio"
    },
    pdfLabel: {
        id: "pdf.label",
        defaultMessage: "PDF"
    },
    codeLabel: {
        id: "code.label",
        defaultMessage: "Code"
    },
    otherLabel: {
        id: "other.label",
        defaultMessage: "Other"
    }
});

});

parcelRegister("avAUi", function(module, exports) {

$parcel$export(module.exports, "fetchRecentActivities", () => $474e7b9761beed17$export$ae65634d024c5427);

var $ja8yA = parcelRequire("ja8yA");

var $hAdPE = parcelRequire("hAdPE");

var $dh538 = parcelRequire("dh538");
const $474e7b9761beed17$export$48de245659972a87 = [
    'confluence',
    'jira',
    'townsquare',
    'graph'
];
const $474e7b9761beed17$export$742b5ce6018da1f4 = [
    'page',
    'blogpost',
    'whiteboard',
    'issue',
    'project',
    'goal',
    'content',
    'document',
    'remote-link'
];
const $474e7b9761beed17$export$ae65634d024c5427 = async (cloudId, searchSessionId)=>{
    return await (0, $ja8yA.recentActivitiesQuery)({
        variables: {
            filteredProducts: $474e7b9761beed17$export$48de245659972a87,
            filteredObjectTypes: (0, $dh538.fg)('smartlinks-qf-recents') ? $474e7b9761beed17$export$742b5ce6018da1f4 : $474e7b9761beed17$export$742b5ce6018da1f4.filter((type)=>type !== 'remote-link'),
            filteredRootContainerIds: [
                `ari:cloud:platform::site/${cloudId}`,
                `ari:cloud:townsquare::site/${cloudId}`
            ],
            itemsLimit: 200
        }
    }).then((response)=>{
        const edges = response.data?.activity?.myActivity?.all?.edges || [];
        try {
            return edges.map((edge)=>(0, $hAdPE.mapRecentActivitiesToSearchResult)(edge, searchSessionId || ''));
        } catch (error) {
            return [];
        }
    }).catch((error)=>{
        throw error;
    });
};

});
parcelRegister("hAdPE", function(module, exports) {

$parcel$export(module.exports, "mapRecentActivitiesToSearchResult", () => $8c4486081ff94342$export$b4f3fd6ea4c72985);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $hWR4v = parcelRequire("hWR4v");
var $6h3V2 = parcelRequire("6h3V2");

var $icWhS = parcelRequire("icWhS");
var $lNtmT = parcelRequire("lNtmT");

var $RTf6z = parcelRequire("RTf6z");

var $hjY9y = parcelRequire("hjY9y");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $k5vpy = parcelRequire("k5vpy");
const $8c4486081ff94342$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $8c4486081ff94342$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $k5vpy.messages).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $k5vpy.messages).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $k5vpy.messages).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $k5vpy.messages).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $k5vpy.messages).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $k5vpy.messages).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $hjY9y.Products).Sharepoint || product === (0, $hjY9y.Products).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $hjY9y.Products).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    return label;
};
const $8c4486081ff94342$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const labelKey = `${subtype}Label`;
    if (labelKey in (0, $k5vpy.messages)) return (0, $k5vpy.messages)[labelKey];
    else return (0, $k5vpy.messages).otherLabel;
};
const $8c4486081ff94342$var$mapConfluenceActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { title: title, space: space, links: links } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: (0, $hjY9y.Products).Confluence
    });
    const spaceName = space?.name || '';
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const urlBase = links?.base;
    const urlWebUi = links?.webUi;
    const url = urlBase && urlWebUi && `${urlBase}${urlWebUi}`;
    if (!title || !url) return undefined;
    return {
        id: id,
        url: url,
        icon: icon,
        type: activity.object.type,
        title: title,
        meta: spaceName,
        containerId: (0, $lNtmT.transformAriToId)(space?.id || 'UNAVAILABLE', 'space'),
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapJiraActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { key: key, fieldsById: fieldsById, webUrl: webUrl } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: (0, $hjY9y.Products).Jira
    });
    const summary = fieldsById?.edges?.[0]?.node?.text;
    const title = key && summary && `${key}: ${summary}`;
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const meta = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: activity.object.type
    });
    if (!title || !webUrl) return undefined;
    return {
        id: id,
        url: webUrl,
        icon: icon,
        type: activity.object.type,
        title: title,
        meta: meta,
        containerId: '',
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapTownsquareActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const id = activity.object.id;
    const { name: name, key: key, url: url } = activity.object.data;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: (0, $hjY9y.Products).Atlas
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    if (!name || !url) return undefined;
    return {
        id: id,
        url: url,
        icon: icon,
        type: activity.object.type,
        title: name,
        meta: key,
        containerId: '',
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapGraphDocumentActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const { type: type, displayName: displayName, parent: parent, url: url } = activity.object.data;
    const id = activity.object.id;
    const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
    const resourceType = resourceOwner.split('.').at(1);
    const product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    if (!Object.values((0, $hjY9y.Products)).includes(product)) return;
    const title = displayName;
    if (!title || !url) return undefined;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: product
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const subtype = type?.category?.toLowerCase();
    const label = $8c4486081ff94342$export$a47c0c6de01249fd({
        product: product,
        subtype: subtype
    });
    const typeLabel = label ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...label
        })
    }) : subtype ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
    }) : null;
    return {
        id: id,
        url: url,
        icon: icon,
        type: type,
        title: title,
        meta: typeLabel,
        containerId: parent?.id || 'UNAVAILABLE',
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapGraphRemoteLinkActivityToSearchResult = (activity)=>{
    if (!activity.object.data) return;
    const { displayName: displayName, category: category, url: url } = activity.object.data;
    const id = activity.object.id;
    const { resourceOwner: resourceOwner } = (0, $6h3V2.parseThirdPartyARI)(id);
    const resourceType = resourceOwner.split('.').at(1);
    const product = resourceType === 'google-drive' ? 'drive' : resourceType || '';
    if (!Object.values((0, $hjY9y.Products)).includes(product)) return;
    const title = displayName;
    if (!title || !url) return undefined;
    const icon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjY9y.ProductIcon), {
        productKey: product
    });
    const timestamp = activity.event.timestamp;
    const eventType = activity.event.eventType;
    const subtype = category?.toLowerCase();
    const label = $8c4486081ff94342$export$19dc2415a5fa9123({
        product: product,
        subtype: subtype
    });
    const typeLabel = label ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...label
        })
    }) : subtype ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $8c4486081ff94342$var$typeLabelContainer,
        children: subtype.charAt(0).toUpperCase() + subtype.substring(1).toLowerCase()
    }) : null;
    return {
        id: id,
        url: url,
        icon: icon,
        type: category,
        title: title,
        meta: typeLabel,
        containerId: 'UNAVAILABLE',
        additionalMeta: timestamp ? (0, $RTf6z.dateFormatter)(timestamp, true, eventType) : ''
    };
};
const $8c4486081ff94342$var$mapGraphActivityToSearchResult = (activity)=>{
    if ((0, $hWR4v.isDocumentActivity)(activity.object)) return $8c4486081ff94342$var$mapGraphDocumentActivityToSearchResult(activity);
    if ((0, $hWR4v.isRemoteLinkActivity)(activity.object) && (0, $dh538.fg)('smartlinks-qf-recents')) return $8c4486081ff94342$var$mapGraphRemoteLinkActivityToSearchResult(activity);
    return undefined;
};
const $8c4486081ff94342$export$b4f3fd6ea4c72985 = (edge, searchSessionId)=>{
    const activity = edge.node;
    const product = activity.object.product;
    const result = (0, $hWR4v.isGraphActivity)(activity.object) ? $8c4486081ff94342$var$mapGraphActivityToSearchResult(activity) : product === 'confluence' ? $8c4486081ff94342$var$mapConfluenceActivityToSearchResult(activity) : product === 'jira' ? $8c4486081ff94342$var$mapJiraActivityToSearchResult(activity) : product === 'townsquare' ? $8c4486081ff94342$var$mapTownsquareActivityToSearchResult(activity) : undefined;
    if (!result) return undefined;
    const urlWithAnalyticsQueryParams = (0, $icWhS.getGenericUrlWithAnalyticsQueryParams)({
        url: result.url,
        searchSessionId: searchSessionId
    });
    return {
        ...result,
        url: urlWithAnalyticsQueryParams
    };
};

});
parcelRegister("hjY9y", function(module, exports) {

$parcel$export(module.exports, "Products", () => $f69e6a05e0e63212$export$92e44ea1079b9ec6);
$parcel$export(module.exports, "ProductIcon", () => $f69e6a05e0e63212$export$1a199e029d5e93d6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lNh9F = parcelRequire("lNh9F");
var $B583h = parcelRequire("B583h");
var $bPE2y = parcelRequire("bPE2y");
var $7skR0 = parcelRequire("7skR0");
var $5aLOH = parcelRequire("5aLOH");
var $eO4W8 = parcelRequire("eO4W8");
var $ijJOq = parcelRequire("ijJOq");
var $c6SIH = parcelRequire("c6SIH");
var $jjaVR = parcelRequire("jjaVR");

var $6LeZx = parcelRequire("6LeZx");

var $dJDhX = parcelRequire("dJDhX");

var $guzTv = parcelRequire("guzTv");

var $eQW47 = parcelRequire("eQW47");

var $g1L9J = parcelRequire("g1L9J");

var $lQxxH = parcelRequire("lQxxH");

var $7MUoO = parcelRequire("7MUoO");

var $foJyA = parcelRequire("foJyA");

var $buthI = parcelRequire("buthI");

var $jFQYg = parcelRequire("jFQYg");

var $ZlCvd = parcelRequire("ZlCvd");

var $aT1C2 = parcelRequire("aT1C2");

var $bKoXw = parcelRequire("bKoXw");

var $cRogp = parcelRequire("cRogp");

var $dpIpE = parcelRequire("dpIpE");

var $2RIXb = parcelRequire("2RIXb");

var $8b6pH = parcelRequire("8b6pH");

var $gNpxn = parcelRequire("gNpxn");

var $fKCBg = parcelRequire("fKCBg");

var $9c5DY = parcelRequire("9c5DY");

var $9dDdC = parcelRequire("9dDdC");

var $9HR5H = parcelRequire("9HR5H");

var $hUGmM = parcelRequire("hUGmM");

var $9eHWZ = parcelRequire("9eHWZ");

var $6mOGj = parcelRequire("6mOGj");

var $xNfJ3 = parcelRequire("xNfJ3");

var $3yTTJ = parcelRequire("3yTTJ");

var $5wHPF = parcelRequire("5wHPF");

var $kVu7G = parcelRequire("kVu7G");

var $9DzSn = parcelRequire("9DzSn");

var $4sX9w = parcelRequire("4sX9w");

var $71zpm = parcelRequire("71zpm");

var $5FlG2 = parcelRequire("5FlG2");

var $2omOh = parcelRequire("2omOh");

var $k6xhg = parcelRequire("k6xhg");

var $i3woo = parcelRequire("i3woo");

var $1lwoS = parcelRequire("1lwoS");

var $gLGvg = parcelRequire("gLGvg");

var $1m0Bz = parcelRequire("1m0Bz");

var $3zUD2 = parcelRequire("3zUD2");

var $gHwiN = parcelRequire("gHwiN");

var $b15lm = parcelRequire("b15lm");

var $iFEkd = parcelRequire("iFEkd");

var $9o6kx = parcelRequire("9o6kx");

var $cegaR = parcelRequire("cegaR");

var $3aDJv = parcelRequire("3aDJv");

var $dgMee = parcelRequire("dgMee");

var $eOwHL = parcelRequire("eOwHL");

var $39NR5 = parcelRequire("39NR5");

var $bIkGo = parcelRequire("bIkGo");

var $8GMEU = parcelRequire("8GMEU");

var $74dAr = parcelRequire("74dAr");

var $dGVh7 = parcelRequire("dGVh7");

var $bndMH = parcelRequire("bndMH");

var $g6dt5 = parcelRequire("g6dt5");

var $fPxww = parcelRequire("fPxww");
const $f69e6a05e0e63212$var$ProductKeys3P = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3'
};
const $f69e6a05e0e63212$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury'
};
const $f69e6a05e0e63212$var$products1PIcons = {
    [$f69e6a05e0e63212$var$ProductKeys1P.Confluence]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $guzTv.ConfluenceIcon), (0, $7skR0.ConfluenceIcon)), 'Confluence'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Atlas]: (0, $fPxww.RovoLogoFromLogo)((0, $lNh9F.AtlassianIcon), 'Home'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Jira]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $g1L9J.JiraIcon), (0, $eO4W8.JiraIcon)), 'Jira'),
    [$f69e6a05e0e63212$var$ProductKeys1P.JiraProductDiscovery]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $lQxxH.JiraProductDiscoveryIcon), (0, $ijJOq.JiraProductDiscoveryIcon)), 'Jira Product Discovery'),
    [$f69e6a05e0e63212$var$ProductKeys1P.JiraServiceManagement]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $7MUoO.JiraServiceManagementIcon), (0, $c6SIH.JiraServiceManagementIcon)), 'Jira Service Management'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Bitbucket]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $6LeZx.BitbucketIcon), (0, $B583h.BitbucketIcon)), 'Bitbucket'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Trello]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $foJyA.TrelloIcon), (0, $jjaVR.TrelloIcon)), 'Trello'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Compass]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $dJDhX.CompassIcon), (0, $bPE2y.CompassIcon)), 'Compass'),
    [$f69e6a05e0e63212$var$ProductKeys1P.Focus]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $eQW47.FocusIcon), (0, $5aLOH.FocusIcon)), 'Focus')
};
const $f69e6a05e0e63212$var$products3PIcons = {
    [$f69e6a05e0e63212$var$ProductKeys3P.AdobeXD]: (0, $fPxww.get3PLogo)((0, $jFQYg.default), 'Adobe XD'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AdobeSign]: (0, $fPxww.get3PLogo)((0, $ZlCvd.default), 'Adobe Sign'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Aha]: (0, $fPxww.get3PLogo)((0, $aT1C2.default), 'Aha'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Airtable]: (0, $fPxww.get3PLogo)((0, $bKoXw.default), 'Airtable'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Amplitude]: (0, $fPxww.get3PLogo)((0, $cRogp.default), 'Amplitude'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Asana]: (0, $fPxww.get3PLogo)((0, $dpIpE.default), 'Asana'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AzureDevops]: (0, $fPxww.get3PLogo)((0, $2RIXb.default), 'Azure Devops'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Box]: (0, $fPxww.get3PLogo)((0, $8b6pH.default), 'Box'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Canva]: (0, $fPxww.get3PLogo)((0, $gNpxn.default), 'Canva'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Docusign]: (0, $fPxww.get3PLogo)((0, $fKCBg.default), 'Docusign'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Dovetail]: (0, $fPxww.get3PLogo)((0, $9c5DY.default), 'Dovetail'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Dropbox]: (0, $fPxww.get3PLogo)((0, $9dDdC.default), 'Dropbox'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Figma]: (0, $fPxww.get3PLogo)((0, $9HR5H.default), 'Figma'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Freshservice]: (0, $fPxww.get3PLogo)((0, $hUGmM.default), 'Freshservice'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Gmail]: (0, $fPxww.get3PLogo)((0, $9eHWZ.default), 'Gmail'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Github]: (0, $fPxww.get3PLogo)((0, $6mOGj.default), 'Github'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Gitlab]: (0, $fPxww.get3PLogo)((0, $xNfJ3.default), 'Gitlab'),
    [$f69e6a05e0e63212$var$ProductKeys3P.GoogleCalendar]: (0, $fPxww.get3PLogo)((0, $3yTTJ.default), 'Google Calendar'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Hubspot]: (0, $fPxww.get3PLogo)((0, $5wHPF.default), 'Hubspot'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Lucid]: (0, $fPxww.get3PLogo)((0, $kVu7G.default), 'Lucid'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Loom]: (0, $fPxww.get3PLogo)((0, $9DzSn.default), 'Loom'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Miro]: (0, $fPxww.get3PLogo)((0, $4sX9w.default), 'Miro'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Monday]: (0, $fPxww.get3PLogo)((0, $71zpm.default), 'Monday'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Mural]: (0, $fPxww.get3PLogo)((0, $5FlG2.default), 'Mural'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Notion]: (0, $fPxww.get3PLogo)((0, $2omOh.default), 'Notion'),
    [$f69e6a05e0e63212$var$ProductKeys3P.OutlookCalendar]: (0, $fPxww.get3PLogo)((0, $k6xhg.default), 'Outlook Calendar'),
    [$f69e6a05e0e63212$var$ProductKeys3P.OutlookMail]: (0, $fPxww.get3PLogo)((0, $i3woo.default), 'Outlook Mail'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Pipedrive]: (0, $fPxww.get3PLogo)((0, $1lwoS.default), 'Pipedrive'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Salesforce]: (0, $fPxww.get3PLogo)((0, $gLGvg.default), 'Salesforce'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Sentry]: (0, $fPxww.get3PLogo)((0, $1m0Bz.default), 'Sentry'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Sharepoint]: (0, $fPxww.get3PLogo)((0, $3zUD2.default), 'Sharepoint'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Slack]: (0, $fPxww.get3PLogo)((0, $gHwiN.default), 'Slack'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Smartsheet]: (0, $fPxww.get3PLogo)((0, $b15lm.default), 'Smartsheet'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Stripe]: (0, $fPxww.get3PLogo)((0, $iFEkd.default), 'Stripe'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Teams]: (0, $fPxww.get3PLogo)((0, $9o6kx.default), 'Teams'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Todoist]: (0, $fPxww.get3PLogo)((0, $cegaR.default), 'Todoist'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Webex]: (0, $fPxww.get3PLogo)((0, $3aDJv.default), 'Webex'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Zeplin]: (0, $fPxww.get3PLogo)((0, $dgMee.default), 'Zeplin'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Zendesk]: (0, $fPxww.get3PLogo)((0, $eOwHL.default), 'Zendesk'),
    [$f69e6a05e0e63212$var$ProductKeys3P.Gitbook]: (0, $fPxww.get3PLogo)((0, $39NR5.default), 'Gitbook'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AtlassianWebCrawler]: (0, $fPxww.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), 'Atlassian Web Crawler'),
    [$f69e6a05e0e63212$var$ProductKeys3P.ConfluenceDC]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $guzTv.ConfluenceIcon), (0, $7skR0.ConfluenceIcon)), 'Confluence'),
    [$f69e6a05e0e63212$var$ProductKeys3P.JiraDC]: (0, $fPxww.RovoLogoFromLogo)((0, $fPxww.getLogoVersion)((0, $g1L9J.JiraIcon), (0, $eO4W8.JiraIcon)), 'Jira'),
    [$f69e6a05e0e63212$var$ProductKeys3P.LaunchDarkly]: (0, $fPxww.get3PLogo)((0, $bIkGo.default), 'LaunchDarkly'),
    [$f69e6a05e0e63212$var$ProductKeys3P.PagerDuty]: (0, $fPxww.get3PLogo)((0, $8GMEU.default), 'PagerDuty'),
    [$f69e6a05e0e63212$var$ProductKeys3P.PowerBI]: (0, $fPxww.get3PLogo)((0, $74dAr.default), 'PowerBI'),
    [$f69e6a05e0e63212$var$ProductKeys3P.ServiceNow]: (0, $fPxww.get3PLogo)((0, $dGVh7.default), 'ServiceNow'),
    [$f69e6a05e0e63212$var$ProductKeys3P.AWSS3]: (0, $fPxww.get3PLogo)((0, $bndMH.default), 'AWSS3'),
    [$f69e6a05e0e63212$var$ProductKeys3P.GoogleDrive]: (0, $fPxww.get3PLogo)((0, $g6dt5.default), 'GoogleDrive')
};
const $f69e6a05e0e63212$var$productIcons = {
    ...$f69e6a05e0e63212$var$products1PIcons,
    ...$f69e6a05e0e63212$var$products3PIcons
};
const $f69e6a05e0e63212$export$92e44ea1079b9ec6 = {
    ...$f69e6a05e0e63212$var$ProductKeys1P,
    ...$f69e6a05e0e63212$var$ProductKeys3P
};
const $f69e6a05e0e63212$export$1a199e029d5e93d6 = ({ productKey: productKey })=>{
    const Icon = $f69e6a05e0e63212$var$productIcons[productKey];
    return Icon ? /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
        label: productKey
    }) : null;
};

});
parcelRegister("jFQYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfe74c44e346a556$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $cfe74c44e346a556$var$AdobeXDIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5802 7.40457L9.75898 12.1789L12.7683 17.2427C12.7871 17.2812 12.7965 17.3198 12.7871 17.3584C12.7777 17.397 12.7401 17.368 12.6836 17.3777H10.5301C10.3796 17.3777 10.2762 17.368 10.2104 17.2716C10.0129 16.8665 9.806 16.471 9.60851 16.0659C9.41103 15.6705 9.19473 15.2654 8.96903 14.8507C8.74334 14.4359 8.51764 14.0212 8.29194 13.5968H8.27313C8.07565 14.0115 7.85935 14.4263 7.64306 14.841C7.42677 15.2558 7.21047 15.6705 7.00359 16.0756C6.78729 16.4807 6.571 16.8954 6.3547 17.2909C6.31709 17.3873 6.24186 17.397 6.13841 17.397H4.06952C4.0319 17.397 4.00369 17.4163 4.00369 17.368C3.99429 17.3295 4.00369 17.2909 4.0225 17.262L6.94716 12.3429L4.09773 7.39492C4.06952 7.35634 4.06011 7.31776 4.07892 7.29847C4.09773 7.26953 4.13535 7.25989 4.17296 7.25989H6.30768C6.3547 7.25989 6.40173 7.26953 6.43934 7.27918C6.47696 7.29847 6.50517 7.3274 6.53338 7.36598C6.71206 7.78073 6.91895 8.19547 7.13524 8.61021C7.36094 9.02496 7.57723 9.43006 7.81233 9.83515C8.03803 10.2403 8.24492 10.6453 8.44241 11.0601H8.46122C8.6587 10.6357 8.86559 10.221 9.07248 9.81586C9.27937 9.41077 9.49566 9.00567 9.71196 8.60057C9.92825 8.19547 10.1351 7.78073 10.342 7.38528C10.3514 7.34669 10.3702 7.30811 10.3985 7.28882C10.4361 7.26953 10.4737 7.25989 10.5207 7.26953H12.505C12.552 7.25989 12.599 7.28882 12.6084 7.33705C12.6178 7.34669 12.599 7.38528 12.5802 7.40457Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.9248 17.5803C16.2289 17.5899 15.533 17.4453 14.9029 17.1463C14.3105 16.8666 13.8215 16.4036 13.4829 15.8345C13.135 15.2462 12.9657 14.5131 12.9657 13.6354C12.9563 12.9217 13.135 12.2176 13.4829 11.6003C13.8403 10.9733 14.3575 10.4525 14.9782 10.1053C15.6364 9.72911 16.4264 9.54585 17.3574 9.54585C17.4044 9.54585 17.4702 9.54585 17.5549 9.5555C17.711 9.5733 17.8464 9.43978 17.8464 9.28259V6.52691C17.8464 6.45939 17.8746 6.42081 17.9404 6.42081H19.791C19.8299 6.42081 19.873 6.41051 19.9052 6.43245C19.9189 6.44186 19.9299 6.45544 19.937 6.4702C19.9425 6.48177 19.9435 6.50762 19.9435 6.50762C19.9435 6.50762 19.9435 6.50762 19.9435 6.50762V15.6898C19.9435 15.8635 19.9529 16.0564 19.9623 16.2686C19.9811 16.4711 19.9905 16.664 19.9999 16.828C19.9999 16.8955 19.9717 16.9534 19.9059 16.9823C19.4169 17.1945 18.8996 17.3488 18.373 17.4453C17.8934 17.5321 17.4138 17.5803 16.9248 17.5803ZM17.5438 15.7015C17.7293 15.7077 17.8464 15.5265 17.8464 15.3409V11.666C17.8464 11.5147 17.7428 11.3763 17.5925 11.3591C17.489 11.3495 17.3856 11.3399 17.2821 11.3399C16.9154 11.3399 16.5486 11.417 16.2195 11.5906C15.8998 11.7546 15.627 11.9957 15.4201 12.3044C15.2133 12.613 15.1098 13.0278 15.1098 13.5293C15.1004 13.8669 15.1568 14.2045 15.2697 14.5228C15.3637 14.7832 15.5048 15.0147 15.6929 15.2076C15.8715 15.3812 16.0878 15.5162 16.3323 15.5934C16.5862 15.6802 16.8496 15.7188 17.1129 15.7188C17.2409 15.7188 17.3612 15.7108 17.4737 15.7022C17.4964 15.7004 17.521 15.7007 17.5438 15.7015Z",
                fill: "#FF61F6"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.90598 4H17.5043C19.1111 4 20.4103 5.29915 20.4103 6.90598V17.094C20.4103 18.7009 19.1111 20 17.5043 20H6.90598C5.29915 20 4 18.7009 4 17.094V6.90598C4 5.29915 5.29915 4 6.90598 4Z",
                fill: "#470137"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.629 8.2051L10.5777 11.5897L12.7658 15.1795C12.7794 15.2068 12.7863 15.2342 12.7794 15.2615C12.7726 15.2889 12.7453 15.2684 12.7042 15.2752H11.1384C11.029 15.2752 10.9538 15.2684 10.9059 15.2C10.7624 14.9128 10.6119 14.6325 10.4683 14.3453C10.3247 14.0649 10.1675 13.7778 10.0034 13.4837C9.83928 13.1897 9.67518 12.8957 9.51107 12.5948H9.4974C9.35381 12.8889 9.19654 13.1829 9.03928 13.4769C8.88201 13.7709 8.72475 14.0649 8.57432 14.3521C8.41706 14.6393 8.25979 14.9333 8.10253 15.2136C8.07518 15.282 8.02047 15.2889 7.94526 15.2889H6.44099C6.41364 15.2889 6.39312 15.3025 6.39312 15.2684C6.38629 15.241 6.39312 15.2136 6.4068 15.1931L8.5333 11.706L6.4615 8.19827C6.44099 8.17092 6.43415 8.14356 6.44783 8.12989C6.4615 8.10938 6.48885 8.10254 6.5162 8.10254H8.06834C8.10253 8.10254 8.13671 8.10938 8.16406 8.11621C8.19142 8.12989 8.21193 8.1504 8.23244 8.17775C8.36236 8.47177 8.51278 8.76579 8.67005 9.0598C8.83415 9.35382 8.99142 9.641 9.16236 9.92818C9.32646 10.2154 9.47688 10.5025 9.62047 10.7966H9.63415C9.77774 10.4957 9.92817 10.2017 10.0786 9.9145C10.229 9.62733 10.3863 9.34015 10.5436 9.05297C10.7008 8.76579 10.8512 8.47177 11.0017 8.19143C11.0085 8.16408 11.0222 8.13673 11.0427 8.12305C11.07 8.10938 11.0974 8.10254 11.1316 8.10938H12.5743C12.6085 8.10254 12.6427 8.12305 12.6495 8.15724C12.6564 8.16408 12.6427 8.19143 12.629 8.2051Z",
                fill: "#FF61F6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.788 15.4188C15.282 15.4256 14.776 15.323 14.3179 15.1111C13.8872 14.9128 13.5316 14.5846 13.2854 14.1812C13.0325 13.7641 12.9094 13.2444 12.9094 12.6222C12.9025 12.1162 13.0325 11.6171 13.2854 11.1794C13.5453 10.735 13.9213 10.3658 14.3726 10.1196C14.8513 9.85295 15.4256 9.72304 16.1025 9.72304C16.1367 9.72304 16.1846 9.72304 16.2461 9.72988C16.3077 9.73671 16.376 9.73671 16.4581 9.74355V7.58287C16.4581 7.53501 16.4786 7.50765 16.5265 7.50765H17.9145C17.9487 7.50082 17.976 7.52817 17.9829 7.55552C17.9829 7.56236 17.9829 7.56919 17.9829 7.56919V14.0786C17.9829 14.2017 17.9897 14.3384 17.9966 14.4889C18.0102 14.6324 18.0171 14.7692 18.0239 14.8854C18.0239 14.9333 18.0034 14.9743 17.9555 14.9948C17.6 15.1453 17.2239 15.2547 16.841 15.323C16.4923 15.3846 16.1436 15.4188 15.788 15.4188ZM16.4581 14.0512V11.0427C16.3966 11.029 16.335 11.0153 16.2735 11.0085C16.1983 11.0017 16.1231 10.9948 16.0478 10.9948C15.7812 10.9948 15.5145 11.0495 15.2752 11.1726C15.0427 11.2889 14.8444 11.4598 14.694 11.6786C14.5436 11.8974 14.4683 12.1914 14.4683 12.547C14.4615 12.7863 14.5025 13.0256 14.5846 13.2512C14.653 13.4359 14.7555 13.6 14.8923 13.7367C15.0222 13.8598 15.1795 13.9555 15.3572 14.0102C15.5419 14.0718 15.7333 14.0991 15.9248 14.0991C16.0273 14.0991 16.1231 14.0923 16.2119 14.0854C16.3008 14.0923 16.376 14.0786 16.4581 14.0512Z",
                fill: "#FF61F6"
            })
        ]
    });
};
var $cfe74c44e346a556$export$2e2bcd8739ae039 = $cfe74c44e346a556$var$AdobeXDIcon;

});

parcelRegister("ZlCvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $5694a8281bd37d8b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5694a8281bd37d8b$var$AdobeSignIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-19.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.7066 18.7523C25.0666 18.0399 23.8399 17.7112 22.0799 17.7112C21.1199 17.7112 20.1066 17.8208 19.1466 17.9852C18.5066 17.3824 17.9732 16.6701 17.4399 15.9578C17.0666 15.4099 16.6932 14.8619 16.3732 14.2592C16.9066 12.725 17.2266 11.0812 17.3332 9.43743C17.3332 7.95802 16.7466 6.36902 15.1466 6.36902C14.6132 6.36902 14.0799 6.69778 13.8132 7.19091C13.1199 8.39636 13.3866 10.8621 14.5066 13.4373C14.1332 14.588 13.7066 15.7386 13.2266 16.9989C12.7999 18.0947 12.3199 19.1358 11.7332 20.1221C10.0799 20.7796 6.61323 22.4234 6.29323 24.2316C6.18656 24.7795 6.34656 25.3274 6.77323 25.6562C7.14656 25.9849 7.6799 26.2041 8.21323 26.1493C10.2932 26.1493 12.3732 23.1905 13.8132 20.6152C14.6132 20.3413 15.4132 20.0673 16.2666 19.8481C17.1732 19.6289 18.0266 19.4098 18.8266 19.2454C21.0666 21.2179 23.0399 21.5467 23.9999 21.5467C25.3332 21.5467 25.8666 20.944 26.0266 20.4508C26.2399 19.8481 26.1332 19.1906 25.7066 18.7523ZM24.2666 19.7933C24.2132 20.1769 23.7866 20.4508 23.2532 20.4508C23.0932 20.4508 22.9332 20.4508 22.7732 20.396C21.7066 20.1221 20.6932 19.5742 19.8399 18.8618C20.5332 18.7523 21.2799 18.6975 21.9732 18.6975C22.4532 18.6975 22.9332 18.7523 23.4132 18.807C23.8932 18.9166 24.4266 19.1358 24.2666 19.7933ZM14.7199 7.68405C14.8266 7.51967 14.9866 7.41009 15.1999 7.35529C15.7332 7.35529 15.8399 7.95802 15.8399 8.50595C15.7866 9.76619 15.5732 10.9716 15.1999 12.1771C14.2932 9.82098 14.3999 8.23198 14.7199 7.68405ZM17.7066 18.2043C17.1199 18.3139 16.5332 18.4783 15.9466 18.6427C15.5199 18.7523 15.0932 18.9166 14.6132 19.0262C14.8266 18.5331 15.0399 18.0399 15.2532 17.6016C15.5199 16.9989 15.7332 16.3962 15.9466 15.7934C16.1599 16.1222 16.3199 16.3962 16.5332 16.6701C16.9066 17.218 17.3332 17.7112 17.7066 18.2043ZM11.2532 21.3823C9.9199 23.574 8.58656 24.9987 7.8399 24.9987C7.73323 24.9987 7.57323 24.9439 7.5199 24.8891C7.3599 24.7795 7.30656 24.5603 7.3599 24.3959C7.46656 23.574 9.01323 22.4234 11.2532 21.3823Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.82667 4H17.1733C18.72 4 20 5.28 20 6.82667V16.7467C20 18.32 18.72 19.5733 17.1733 19.5733H6.82667C5.28 19.6 4 18.32 4 16.7733V6.82667C4 5.28 5.28 4 6.82667 4Z",
                fill: "#584CCC"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.8533 13.0401C16.5333 12.6934 15.92 12.5334 15.04 12.5334C14.56 12.5334 14.0533 12.5868 13.5733 12.6668C13.2533 12.3734 12.9867 12.0268 12.72 11.6801C12.5333 11.4134 12.3467 11.1468 12.1867 10.8534C12.4533 10.1068 12.6133 9.30676 12.6667 8.50676C12.6667 7.78676 12.3733 7.01343 11.5733 7.01343C11.3067 7.01343 11.04 7.17343 10.9067 7.41343C10.56 8.00009 10.6933 9.20009 11.2533 10.4534C11.0667 11.0134 10.8533 11.5734 10.6133 12.1868C10.4 12.7201 10.16 13.2268 9.86668 13.7068C9.04001 14.0268 7.30668 14.8268 7.14668 15.7068C7.09334 15.9734 7.17334 16.2401 7.38668 16.4001C7.57334 16.5601 7.84001 16.6668 8.10668 16.6401C9.14668 16.6401 10.1867 15.2001 10.9067 13.9468C11.3067 13.8134 11.7067 13.6801 12.1333 13.5734C12.5867 13.4668 13.0133 13.3601 13.4133 13.2801C14.5333 14.2401 15.52 14.4001 16 14.4001C16.6667 14.4001 16.9333 14.1068 17.0133 13.8668C17.12 13.5734 17.0667 13.2534 16.8533 13.0401ZM16.1333 13.5468C16.1067 13.7334 15.8933 13.8668 15.6267 13.8668C15.5467 13.8668 15.4667 13.8668 15.3867 13.8401C14.8533 13.7068 14.3467 13.4401 13.92 13.0934C14.2667 13.0401 14.64 13.0134 14.9867 13.0134C15.2267 13.0134 15.4667 13.0401 15.7067 13.0668C15.9467 13.1201 16.2133 13.2268 16.1333 13.5468ZM11.36 7.65343C11.4133 7.57343 11.4933 7.52009 11.6 7.49343C11.8667 7.49343 11.92 7.78676 11.92 8.05343C11.8933 8.66676 11.7867 9.25343 11.6 9.84009C11.1467 8.69343 11.2 7.92009 11.36 7.65343ZM12.8533 12.7734C12.56 12.8268 12.2667 12.9068 11.9733 12.9868C11.76 13.0401 11.5467 13.1201 11.3067 13.1734C11.4133 12.9334 11.52 12.6934 11.6267 12.4801C11.76 12.1868 11.8667 11.8934 11.9733 11.6001C12.08 11.7601 12.16 11.8934 12.2667 12.0268C12.4533 12.2934 12.6667 12.5334 12.8533 12.7734ZM9.62668 14.3201C8.96001 15.3868 8.29334 16.0801 7.92001 16.0801C7.86668 16.0801 7.78668 16.0534 7.76001 16.0268C7.68001 15.9734 7.65334 15.8668 7.68001 15.7868C7.73334 15.3868 8.50668 14.8268 9.62668 14.3201Z",
                fill: "white"
            })
        ]
    });
};
var $5694a8281bd37d8b$export$2e2bcd8739ae039 = $5694a8281bd37d8b$var$AdobeSignIcon;

});

parcelRegister("aT1C2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2925c70e149e0de5$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $2925c70e149e0de5$var$AhaIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5114 14.3589C13.4961 13.9874 13.4858 13.6157 13.4829 13.2439C13.4806 12.9476 13.4822 12.6512 13.4798 12.3549C13.4779 12.1238 13.4776 11.8926 13.4483 11.6628C13.4314 11.5303 13.4041 11.4003 13.3459 11.2789C13.2429 11.0639 13.0729 10.9187 12.8595 10.8216C12.562 10.6863 12.2524 10.6769 11.9374 10.742C11.6833 10.7945 11.4482 10.8957 11.2248 11.0259C11.1582 11.0647 11.0935 11.1066 11.0248 11.1522C11.0248 11.139 11.0248 11.1317 11.0248 11.1242C11.024 10.9117 11.0232 10.6993 11.0223 10.4868C11.0205 10.0525 11.0181 9.61825 11.0083 9.18407C11.0075 9.14589 11.0068 9.1076 11.003 9.06965C10.9985 9.02436 10.9605 8.99346 10.9209 9.00118C10.7482 9.03488 10.5756 9.06898 10.403 9.10296C10.182 9.14651 9.96017 9.18597 9.73703 9.21771C9.63006 9.23294 9.52302 9.24761 9.41605 9.26266C9.40776 9.26384 9.39813 9.26496 9.39433 9.27313C9.38968 9.28299 9.39892 9.28864 9.4053 9.29306C9.41476 9.29956 9.4137 9.30885 9.41498 9.31786C9.43737 9.47365 9.45467 9.63006 9.46883 9.7868C9.49083 10.0299 9.5041 10.2737 9.51339 10.5176C9.52722 10.8799 9.53366 11.2423 9.53607 11.6048C9.54323 12.6756 9.53573 13.7464 9.52577 14.8172C9.52515 14.8822 9.54228 14.8991 9.60722 14.8982C9.9839 14.8933 10.3605 14.8882 10.7372 14.8834C10.8454 14.882 10.9536 14.8819 11.0617 14.88C11.1067 14.8793 11.1419 14.8617 11.1375 14.803C11.1263 14.6534 11.1212 14.5034 11.1135 14.3536C11.0966 14.0279 11.0824 13.7021 11.0754 13.376C11.0725 13.24 11.0686 13.104 11.0675 12.968C11.065 12.6502 11.064 12.3324 11.0619 12.0146C11.0618 12.0001 11.0668 11.9933 11.0802 11.9881C11.1314 11.9683 11.1821 11.9472 11.233 11.9266C11.3449 11.8813 11.4598 11.8553 11.582 11.8677C11.6869 11.8784 11.7678 11.9237 11.8182 12.0183C11.8354 12.0504 11.8491 12.0839 11.8596 12.1188C11.9079 12.2798 11.9208 12.4461 11.9309 12.6124C11.9449 12.8432 11.9481 13.0743 11.9491 13.3054C11.9514 13.8152 11.9454 14.3249 11.943 14.8346C11.9427 14.8967 11.9627 14.9166 12.025 14.9164C12.2432 14.9154 12.4613 14.9063 12.6794 14.9013C12.7968 14.8986 12.9143 14.8968 13.0318 14.9015C13.1743 14.9071 13.3167 14.9164 13.4594 14.9164C13.5133 14.9164 13.5378 14.89 13.5351 14.8365C13.527 14.6775 13.5179 14.5184 13.5113 14.3592L13.5114 14.3589Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9366 9.01969C19.8949 9.01381 19.8552 9.02663 19.8151 9.03307C19.5797 9.07063 19.3445 9.10948 19.1092 9.14766C18.8849 9.18405 18.6607 9.22071 18.4363 9.25626C18.3593 9.26846 18.3278 9.30709 18.335 9.3844C18.3477 9.52166 18.3605 9.65887 18.372 9.79624C18.3901 10.0134 18.4071 10.2308 18.4246 10.448C18.4441 10.6912 18.4592 10.9349 18.473 11.1785C18.4862 11.4092 18.4974 11.64 18.5087 11.8708C18.5253 12.2067 18.5413 12.5427 18.5572 12.8786C18.5601 12.9403 18.5901 12.9699 18.6524 12.9689C18.8259 12.966 18.9992 12.9627 19.1727 12.9596C19.1727 12.959 19.1727 12.9585 19.1727 12.9579C19.2109 12.9579 19.2491 12.9584 19.2874 12.9578C19.4272 12.9557 19.567 12.9535 19.7069 12.9509C19.7598 12.9499 19.7931 12.9184 19.7943 12.8695C19.7981 12.7158 19.8008 12.5621 19.8057 12.4084C19.8128 12.1849 19.8201 11.9614 19.8299 11.7379C19.8428 11.4466 19.8577 11.1554 19.8727 10.8642C19.8815 10.6958 19.8914 10.5274 19.9024 10.3592C19.9159 10.1537 19.9299 9.94834 19.9456 9.74312C19.9583 9.57691 19.9737 9.41088 19.9879 9.24479C19.9923 9.19379 19.9984 9.14279 20 9.09168C20.0016 9.04511 19.9823 9.02619 19.9366 9.01969H19.9366Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.8688 14.1793C19.8688 13.9604 19.8688 13.7414 19.8688 13.5225C19.8688 13.4553 19.8458 13.4339 19.7778 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3336 13.4735 19.0533 13.4827 18.7725 13.4746C18.6672 13.4715 18.562 13.4672 18.4571 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3715 13.5886 18.3713 13.6537 18.3731 13.7185C18.3774 13.8731 18.3778 14.0277 18.3757 14.1823C18.3727 14.4096 18.372 14.6369 18.3711 14.8643C18.3709 14.9132 18.3988 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.695 14.9194C18.9465 14.9041 19.198 14.9013 19.4498 14.9076C19.5653 14.9104 19.6808 14.9132 19.7964 14.9166C19.8276 14.9174 19.8511 14.9065 19.864 14.8775C19.8706 14.8627 19.8688 14.8464 19.8688 14.8306C19.8689 14.6135 19.8688 14.3964 19.8688 14.1793Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.07031 14.2687C8.61418 12.7687 8.15801 11.2688 7.70189 9.76881C7.63667 9.55441 7.57151 9.34 7.50612 9.1256C7.48597 9.05949 7.43526 9.0268 7.36791 9.03771C7.25763 9.05557 7.14763 9.07522 7.03735 9.09313C6.67802 9.15152 6.31852 9.20884 5.96031 9.274C5.86772 9.29085 5.80132 9.34224 5.77154 9.43248C5.18325 11.2134 4.59553 12.9943 4.00768 14.7753C3.98317 14.8496 4.01849 14.8982 4.09703 14.8982C4.53249 14.8982 4.96801 14.8982 5.40348 14.8983C5.42128 14.8983 5.43902 14.8983 5.45593 14.8922C5.47636 14.8849 5.49142 14.8721 5.49635 14.8498C5.51896 14.7472 5.54136 14.6445 5.56425 14.5419C5.6335 14.2314 5.70297 13.921 5.77233 13.6105C5.77546 13.5964 5.77815 13.5867 5.79847 13.587C6.27581 13.5939 6.7532 13.6 7.23054 13.6053C7.25254 13.6055 7.26054 13.6121 7.26508 13.633C7.3552 14.0446 7.446 14.456 7.53669 14.8675C7.54811 14.9193 7.56759 14.935 7.62116 14.9357C7.63141 14.9358 7.64165 14.9352 7.6519 14.9349C7.90072 14.9282 8.14961 14.9214 8.34341 14.9162C8.65494 14.9162 8.91138 14.9165 9.16782 14.9161C9.22923 14.916 9.25593 14.8791 9.2383 14.8211C9.18226 14.6369 9.12623 14.4528 9.07025 14.2686L9.07031 14.2687ZM7.00544 12.4829C6.70517 12.4823 6.4049 12.4822 6.10457 12.483C6.07881 12.4831 6.07909 12.4754 6.08486 12.4548C6.22089 11.9665 6.3497 11.4762 6.47397 10.9849C6.50952 10.8442 6.54289 10.703 6.57737 10.562C6.57866 10.5569 6.58056 10.5518 6.58465 10.5392C6.6816 10.937 6.76787 11.3295 6.85732 11.7211C6.91319 11.966 6.96978 12.2107 7.02739 12.4552C7.03299 12.479 7.02834 12.4829 7.0055 12.4828L7.00544 12.4829Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.6715 14.483C17.6508 14.1846 17.6368 13.8858 17.6337 13.5866C17.6292 13.1505 17.6392 12.7144 17.6459 12.2783C17.6489 12.0854 17.6451 11.8927 17.6116 11.7017C17.5626 11.4229 17.427 11.1973 17.2 11.0277C17.0326 10.9026 16.8409 10.8332 16.6391 10.7888C16.3129 10.7171 15.9826 10.7133 15.6513 10.735C15.4224 10.75 15.1954 10.7808 14.9697 10.822C14.7443 10.8632 14.5215 10.9154 14.3015 10.9796C14.2482 10.9951 14.2304 11.018 14.2279 11.0738C14.225 11.1361 14.2232 11.1986 14.2205 11.2609C14.2138 11.4201 14.2068 11.5793 14.2002 11.7385C14.1971 11.812 14.193 11.8856 14.1925 11.9591C14.192 12.0256 14.2482 12.0552 14.2961 12.0363C14.4737 11.9667 14.6519 11.899 14.8344 11.8434C15.1069 11.7603 15.3843 11.7096 15.6705 11.7156C15.765 11.7175 15.8584 11.726 15.9472 11.7617C16.0354 11.797 16.0909 11.8595 16.1043 11.9553C16.11 11.996 16.1065 12.0371 16.106 12.0781C16.1057 12.1005 16.0979 12.1097 16.0745 12.1129C15.9739 12.127 15.8735 12.1417 15.7735 12.1592C15.4704 12.2122 15.1722 12.2838 14.8841 12.3937C14.6487 12.4835 14.426 12.5963 14.2307 12.7575C14.0093 12.9403 13.8519 13.1654 13.7916 13.4492C13.733 13.7249 13.7543 13.9976 13.8446 14.2642C13.9131 14.4664 14.0269 14.6385 14.1966 14.7708C14.3761 14.9107 14.5826 14.976 14.8076 14.9892C14.8076 14.9907 14.8078 14.9922 14.808 14.9937H14.9647C14.9647 14.9921 14.9647 14.9906 14.9649 14.989C15.0468 14.9825 15.1278 14.9702 15.2076 14.9506C15.5361 14.87 15.8352 14.7248 16.1143 14.5361C16.1279 14.527 16.1412 14.5175 16.1583 14.5057V14.5414C16.1583 14.6448 16.1582 14.7483 16.1584 14.8517C16.1585 14.9143 16.1809 14.9365 16.2426 14.9356C16.3964 14.9334 16.5502 14.9309 16.7041 14.9288C17.0099 14.9245 17.3157 14.9204 17.6215 14.9161C17.6734 14.9154 17.696 14.8915 17.6952 14.8397C17.6951 14.8341 17.6948 14.8285 17.6945 14.823C17.6868 14.7095 17.6793 14.5962 17.6714 14.4828L17.6715 14.483ZM16.1219 13.3558C16.1219 13.4806 16.1214 13.6055 16.1224 13.7302C16.1226 13.7497 16.1161 13.76 16.0995 13.7695C15.9485 13.857 15.7891 13.9147 15.6115 13.9032C15.4004 13.8894 15.2482 13.7607 15.226 13.5542C15.2022 13.3329 15.2951 13.1667 15.5135 13.0711C15.6245 13.0225 15.7419 12.9981 15.861 12.9813C15.9384 12.9704 16.0164 12.9631 16.0939 12.9531C16.1155 12.9503 16.1227 12.9553 16.1224 12.9785C16.1213 13.1043 16.1219 13.2301 16.1219 13.3558Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5116 14.3589C13.4963 13.9874 13.4861 13.6157 13.4831 13.2439C13.4808 12.9476 13.4825 12.6512 13.48 12.3549C13.4781 12.1238 13.4778 11.8926 13.4486 11.6628C13.4316 11.5303 13.4044 11.4003 13.3462 11.2789C13.2432 11.0639 13.0732 10.9187 12.8598 10.8216C12.5623 10.6863 12.2527 10.6769 11.9377 10.742C11.6836 10.7945 11.4485 10.8957 11.225 11.0259C11.1584 11.0647 11.0938 11.1066 11.0251 11.1522C11.0251 11.139 11.0251 11.1317 11.0251 11.1242C11.0242 10.9117 11.0234 10.6993 11.0225 10.4868C11.0208 10.0525 11.0184 9.61825 11.0086 9.18407C11.0077 9.14589 11.007 9.1076 11.0033 9.06965C10.9988 9.02436 10.9607 8.99346 10.9211 9.00118C10.7485 9.03488 10.5759 9.06898 10.4033 9.10296C10.1822 9.14651 9.96041 9.18597 9.73728 9.21771C9.6303 9.23294 9.52327 9.24761 9.41629 9.26266C9.40801 9.26384 9.39838 9.26496 9.39457 9.27313C9.38992 9.28299 9.39916 9.28864 9.40554 9.29306C9.415 9.29956 9.41394 9.30885 9.41523 9.31786C9.43762 9.47365 9.45492 9.63006 9.46908 9.7868C9.49108 10.0299 9.50435 10.2737 9.51364 10.5176C9.52747 10.8799 9.5339 11.2423 9.53631 11.6048C9.54348 12.6756 9.53597 13.7464 9.52601 14.8172C9.52539 14.8822 9.54252 14.8991 9.60746 14.8982C9.98415 14.8933 10.3608 14.8882 10.7375 14.8834C10.8456 14.882 10.9538 14.8819 11.0619 14.88C11.107 14.8793 11.1421 14.8617 11.1377 14.803C11.1265 14.6534 11.1215 14.5034 11.1137 14.3536C11.0969 14.0279 11.0826 13.7021 11.0756 13.376C11.0727 13.24 11.0688 13.104 11.0677 12.968C11.0652 12.6502 11.0642 12.3324 11.0621 12.0146C11.062 12.0001 11.0671 11.9933 11.0804 11.9881C11.1316 11.9683 11.1823 11.9472 11.2332 11.9266C11.3452 11.8813 11.46 11.8553 11.5822 11.8677C11.6871 11.8784 11.768 11.9237 11.8185 12.0183C11.8356 12.0504 11.8494 12.0839 11.8599 12.1188C11.9082 12.2798 11.921 12.4461 11.9311 12.6124C11.9451 12.8432 11.9483 13.0743 11.9493 13.3054C11.9516 13.8152 11.9457 14.3249 11.9432 14.8346C11.9429 14.8967 11.963 14.9166 12.0253 14.9164C12.2435 14.9154 12.4615 14.9063 12.6796 14.9013C12.7971 14.8986 12.9146 14.8968 13.032 14.9015C13.1745 14.9071 13.3169 14.9164 13.4597 14.9164C13.5135 14.9164 13.5381 14.89 13.5353 14.8365C13.5272 14.6775 13.5181 14.5184 13.5116 14.3592L13.5116 14.3589Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9364 9.01981C19.8947 9.01394 19.855 9.02676 19.8149 9.03319C19.5795 9.07075 19.3443 9.1096 19.109 9.14778C18.8847 9.18417 18.6605 9.22084 18.4361 9.25638C18.3591 9.26859 18.3276 9.30721 18.3348 9.38452C18.3475 9.52178 18.3603 9.65899 18.3718 9.79636C18.3899 10.0136 18.4069 10.2309 18.4244 10.4481C18.444 10.6914 18.459 10.935 18.4729 11.1787C18.486 11.4094 18.4972 11.6402 18.5086 11.8709C18.5251 12.2068 18.5411 12.5428 18.557 12.8788C18.5599 12.9404 18.5899 12.97 18.6523 12.969C18.8257 12.9661 18.9991 12.9628 19.1725 12.9597C19.1725 12.9592 19.1725 12.9586 19.1725 12.958C19.2107 12.958 19.249 12.9585 19.2872 12.9579C19.427 12.9558 19.5669 12.9537 19.7067 12.951C19.7597 12.95 19.793 12.9186 19.7941 12.8696C19.7979 12.7159 19.8006 12.5622 19.8055 12.4085C19.8127 12.185 19.8199 11.9615 19.8297 11.7381C19.8426 11.4468 19.8575 11.1555 19.8726 10.8643C19.8813 10.6959 19.8913 10.5276 19.9022 10.3593C19.9157 10.1538 19.9297 9.94846 19.9454 9.74324C19.9581 9.57703 19.9736 9.411 19.9877 9.24491C19.9921 9.19391 19.9982 9.14291 19.9999 9.0918C20.0014 9.04523 19.9821 9.02631 19.9364 9.01981H19.9364Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.8689 14.1793C19.8689 13.9604 19.8689 13.7414 19.8689 13.5225C19.8689 13.4553 19.8459 13.4339 19.7779 13.4396C19.7231 13.4441 19.6685 13.4514 19.6137 13.455C19.3337 13.4735 19.0533 13.4827 18.7726 13.4746C18.6673 13.4715 18.5621 13.4672 18.4572 13.4573C18.4019 13.4521 18.3713 13.4753 18.3714 13.5236C18.3716 13.5886 18.3714 13.6537 18.3732 13.7185C18.3774 13.8731 18.3779 14.0277 18.3758 14.1823C18.3728 14.4096 18.3721 14.6369 18.3712 14.8643C18.3709 14.9132 18.3989 14.9386 18.4468 14.9356C18.5296 14.9305 18.6123 14.9244 18.6951 14.9194C18.9465 14.9041 19.1981 14.9013 19.4498 14.9076C19.5654 14.9104 19.6809 14.9132 19.7965 14.9166C19.8276 14.9174 19.8512 14.9065 19.8641 14.8775C19.8706 14.8627 19.8689 14.8464 19.8689 14.8306C19.8689 14.6135 19.8689 14.3964 19.8689 14.1793Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.07031 14.2689C8.61418 12.7689 8.15801 11.269 7.70189 9.76905C7.63667 9.55465 7.57151 9.34025 7.50612 9.12585C7.48597 9.05973 7.43526 9.02704 7.36791 9.03796C7.25763 9.05582 7.14763 9.07546 7.03735 9.09338C6.67802 9.15176 6.31852 9.20909 5.96031 9.27425C5.86772 9.2911 5.80132 9.34249 5.77154 9.43273C5.18325 11.2136 4.59553 12.9946 4.00768 14.7756C3.98317 14.8498 4.01849 14.8984 4.09703 14.8984C4.53249 14.8984 4.96801 14.8984 5.40348 14.8985C5.42128 14.8985 5.43902 14.8985 5.45593 14.8925C5.47636 14.8851 5.49142 14.8724 5.49635 14.85C5.51896 14.7474 5.54136 14.6448 5.56425 14.5421C5.6335 14.2317 5.70297 13.9212 5.77233 13.6108C5.77546 13.5966 5.77815 13.587 5.79847 13.5872C6.27581 13.5942 6.7532 13.6003 7.23054 13.6056C7.25254 13.6058 7.26054 13.6124 7.26508 13.6332C7.3552 14.0448 7.446 14.4563 7.53669 14.8678C7.54811 14.9195 7.56759 14.9352 7.62116 14.9359C7.63141 14.936 7.64165 14.9354 7.6519 14.9351C7.90072 14.9284 8.14961 14.9217 8.34341 14.9165C8.65494 14.9165 8.91138 14.9167 9.16782 14.9163C9.22923 14.9162 9.25593 14.8793 9.2383 14.8213C9.18226 14.6371 9.12623 14.453 9.07025 14.2689L9.07031 14.2689ZM7.00544 12.4832C6.70517 12.4825 6.4049 12.4824 6.10457 12.4833C6.07881 12.4833 6.07909 12.4757 6.08486 12.455C6.22089 11.9667 6.3497 11.4765 6.47397 10.9851C6.50952 10.8444 6.54289 10.7032 6.57737 10.5623C6.57866 10.5571 6.58056 10.5521 6.58465 10.5394C6.6816 10.9372 6.76787 11.3297 6.85732 11.7214C6.91319 11.9662 6.96978 12.2109 7.02739 12.4554C7.03299 12.4792 7.02834 12.4831 7.0055 12.4831L7.00544 12.4832Z",
                fill: "#0172CE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.6717 14.483C17.6511 14.1846 17.637 13.8858 17.634 13.5866C17.6294 13.1505 17.6394 12.7144 17.6462 12.2783C17.6491 12.0854 17.6453 11.8927 17.6118 11.7017C17.5628 11.4229 17.4273 11.1973 17.2002 11.0277C17.0328 10.9026 16.8412 10.8332 16.6394 10.7888C16.3131 10.7171 15.9828 10.7133 15.6516 10.735C15.4227 10.75 15.1956 10.7808 14.97 10.822C14.7445 10.8632 14.5217 10.9154 14.3018 10.9796C14.2485 10.9951 14.2307 11.018 14.2281 11.0738C14.2253 11.1361 14.2234 11.1986 14.2208 11.2609C14.2141 11.4201 14.2071 11.5793 14.2004 11.7385C14.1973 11.812 14.1932 11.8856 14.1927 11.9591C14.1923 12.0256 14.2484 12.0552 14.2963 12.0363C14.4739 11.9667 14.6521 11.899 14.8346 11.8434C15.1071 11.7603 15.3845 11.7096 15.6707 11.7156C15.7653 11.7175 15.8586 11.726 15.9475 11.7617C16.0357 11.797 16.0911 11.8595 16.1045 11.9553C16.1103 11.996 16.1068 12.0371 16.1062 12.0781C16.1059 12.1005 16.0981 12.1097 16.0747 12.1129C15.9742 12.127 15.8737 12.1417 15.7738 12.1592C15.4707 12.2122 15.1724 12.2838 14.8843 12.3937C14.6489 12.4835 14.4263 12.5963 14.2309 12.7575C14.0095 12.9403 13.8522 13.1654 13.7918 13.4492C13.7332 13.7249 13.7546 13.9976 13.8449 14.2642C13.9133 14.4664 14.0271 14.6385 14.1969 14.7708C14.3763 14.9107 14.5829 14.976 14.8078 14.9892C14.8079 14.9907 14.8081 14.9922 14.8083 14.9937H14.965C14.965 14.9921 14.965 14.9906 14.9652 14.989C15.0471 14.9825 15.128 14.9702 15.2078 14.9506C15.5364 14.87 15.8355 14.7248 16.1146 14.5361C16.1281 14.527 16.1414 14.5175 16.1586 14.5057V14.5414C16.1586 14.6448 16.1584 14.7483 16.1586 14.8517C16.1587 14.9143 16.1811 14.9365 16.2428 14.9356C16.3966 14.9334 16.5505 14.9309 16.7043 14.9288C17.0101 14.9245 17.3159 14.9204 17.6218 14.9161C17.6737 14.9154 17.6963 14.8915 17.6954 14.8397C17.6953 14.8341 17.695 14.8285 17.6947 14.823C17.687 14.7095 17.6795 14.5962 17.6717 14.4828L17.6717 14.483ZM16.1221 13.3558C16.1221 13.4806 16.1217 13.6055 16.1226 13.7302C16.1228 13.7497 16.1163 13.76 16.0998 13.7695C15.9488 13.857 15.7893 13.9147 15.6117 13.9032C15.4006 13.8894 15.2485 13.7607 15.2262 13.5542C15.2024 13.3329 15.2953 13.1667 15.5138 13.0711C15.6247 13.0225 15.7421 12.9981 15.8613 12.9813C15.9387 12.9704 16.0166 12.9631 16.0942 12.9531C16.1157 12.9503 16.1229 12.9553 16.1227 12.9785C16.1215 13.1043 16.1221 13.2301 16.1221 13.3558Z",
                fill: "#0172CE"
            })
        ]
    });
};
var $2925c70e149e0de5$export$2e2bcd8739ae039 = $2925c70e149e0de5$var$AhaIcon;

});

parcelRegister("bKoXw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5642884c1dd34cff$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5642884c1dd34cff$var$AirtableIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.1447 5.16889L5.17945 7.63723C4.84772 7.77451 4.85115 8.24569 5.18496 8.37801L11.1751 10.7535C11.7015 10.9622 12.2876 10.9622 12.8139 10.7535L18.8042 8.37801C19.1379 8.24569 19.1414 7.77451 18.8096 7.63723L12.8445 5.16889C12.3002 4.9437 11.6888 4.9437 11.1447 5.16889Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5259 12.0506V17.9848C12.5259 18.2671 12.8105 18.4603 13.0728 18.3563L19.7477 15.7655C19.9001 15.705 20.0001 15.5578 20.0001 15.3939V9.45974C20.0001 9.17748 19.7155 8.98421 19.4531 9.08821L12.7782 11.6791C12.6259 11.7395 12.5259 11.8867 12.5259 12.0506Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.9672 12.3568L8.98623 13.3133L8.78509 13.4105L4.6034 15.4141C4.33833 15.542 4 15.3488 4 15.0544V9.48465C4 9.37811 4.05462 9.28613 4.12788 9.21686C4.15845 9.1862 4.19309 9.16097 4.22908 9.14098C4.32901 9.08102 4.47155 9.06501 4.59273 9.11295L10.9339 11.6254C11.2562 11.7533 11.2815 12.2049 10.9672 12.3568Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.9672 12.3568L8.98628 13.3133L4.12793 9.21686C4.1585 9.1862 4.19314 9.16097 4.22913 9.14098C4.32906 9.08102 4.4716 9.06501 4.59278 9.11295L10.934 11.6254C11.2563 11.7533 11.2816 12.2049 10.9672 12.3568Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.2515 6.14778L6.03189 8.30757C5.74163 8.4277 5.74464 8.83998 6.03672 8.95576L11.2781 11.0343C11.7387 11.2169 12.2515 11.2169 12.712 11.0343L17.9535 8.95576C18.2455 8.83998 18.2486 8.4277 17.9583 8.30757L12.7388 6.14778C12.2625 5.95074 11.7276 5.95074 11.2515 6.14778Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.4601 12.1693V17.3617C12.4601 17.6087 12.7091 17.7778 12.9387 17.6868L18.7792 15.4198C18.9126 15.3669 19 15.2381 19 15.0947V9.90228C19 9.65531 18.751 9.4862 18.5214 9.5772L12.6809 11.8442C12.5476 11.8971 12.4601 12.0259 12.4601 12.1693Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.0963 12.4372L9.36295 13.2741L9.18695 13.3592L5.52798 15.1124C5.29604 15.2243 5 15.0552 5 14.7976V9.92405C5 9.83083 5.0478 9.75035 5.11189 9.68974C5.13864 9.66291 5.16895 9.64083 5.20045 9.62334C5.28789 9.57088 5.4126 9.55687 5.51864 9.59881L11.0672 11.7972C11.3492 11.9091 11.3714 12.3043 11.0963 12.4372Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.0963 12.4372L9.36293 13.2741L5.11188 9.68974C5.13862 9.66291 5.16893 9.64083 5.20043 9.62334C5.28787 9.57088 5.41258 9.55687 5.51862 9.59881L11.0671 11.7972C11.3492 11.9091 11.3713 12.3043 11.0963 12.4372Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    });
};
var $5642884c1dd34cff$export$2e2bcd8739ae039 = $5642884c1dd34cff$var$AirtableIcon;

});

parcelRegister("cRogp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49fc528719c2d47$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $e49fc528719c2d47$var$AmplitudeIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-507.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.0516 7.60124C11.0073 7.54277 10.9568 7.51208 10.9007 7.51208C10.8545 7.51208 10.8122 7.53281 10.7851 7.55016C10.3591 7.88478 9.77609 9.30229 9.29834 11.1701L9.72131 11.1749C10.5565 11.1844 11.419 11.1942 12.2715 11.2073C12.0468 10.3518 11.8344 9.61843 11.6397 9.02646C11.3552 8.16124 11.1629 7.77393 11.0516 7.60124Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 12.0001C20 16.4183 16.4183 20.0001 12 20.0001C7.58169 20.0001 4 16.4183 4 12.0001C4 7.58181 7.58169 4.00012 12 4.00012C16.4183 4.00012 20 7.58181 20 12.0001ZM17.9088 11.8171C17.9088 11.6117 17.764 11.4404 17.569 11.4014C17.5679 11.4012 17.5667 11.4009 17.5655 11.4006C17.5632 11.4003 17.561 11.3995 17.5587 11.3992L17.5508 11.3984C17.5301 11.395 17.5091 11.3929 17.4876 11.3926L17.4315 11.3873C16.0916 11.2914 14.7131 11.2536 13.4199 11.2278L13.4173 11.2183C12.788 8.85747 12.0018 6.44382 10.9417 6.44382C9.9539 6.44831 9.06345 8.03418 8.29446 11.1584C7.75116 11.1514 7.2559 11.1439 6.78892 11.1359C6.76241 11.1354 6.73863 11.1352 6.71743 11.1352C6.61783 11.1352 6.56916 11.1394 6.54506 11.1426C6.28209 11.1892 6.09124 11.4186 6.09124 11.6883C6.09124 11.9633 6.29655 12.1992 6.56402 12.2377L6.56948 12.2433H8.04257C7.90586 12.8684 7.78602 13.4865 7.68594 14.0821L7.64209 14.3442L7.64161 14.3567C7.64257 14.559 7.80787 14.7235 8.00996 14.7235C8.13815 14.7235 8.2543 14.6567 8.32064 14.5526L8.33108 14.5609L9.05526 12.2433H12.5435C12.81 13.2502 13.0864 14.2899 13.4517 15.2657C13.6471 15.7874 14.1044 17.0094 14.8688 17.0155H14.8774C16.0604 17.0155 16.5214 15.1047 16.8268 13.8398C16.8924 13.5677 16.9491 13.3327 17.0026 13.16L17.0239 13.0886H17.0238C17.0289 13.0719 17.0316 13.0543 17.0316 13.0358C17.0316 12.9346 16.9496 12.8525 16.8484 12.8525C16.7698 12.8525 16.703 12.9018 16.6768 12.9712L16.6765 12.971L16.6508 13.0421C16.5504 13.32 16.4575 13.5828 16.3753 13.8157L16.369 13.8332C15.857 15.2833 15.6233 15.9452 15.1655 15.9453L15.1542 15.9452L15.1478 15.9461L15.1364 15.9458C14.5504 15.9458 13.9986 13.5635 13.7908 12.6668C13.7549 12.5114 13.7219 12.3688 13.6916 12.2433H17.481C17.5521 12.2433 17.6191 12.2255 17.6779 12.1947C17.6784 12.1945 17.6787 12.1943 17.679 12.1942C17.685 12.1911 17.6906 12.1876 17.6964 12.1842C17.7028 12.1805 17.7091 12.1768 17.7152 12.1728C17.7182 12.1709 17.7211 12.1688 17.724 12.1667C17.7332 12.1604 17.742 12.1539 17.7507 12.1468C17.7513 12.1463 17.7518 12.1458 17.7524 12.1453C17.8479 12.0671 17.9088 11.9486 17.9088 11.8171Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.9329 7.05123C10.883 6.98545 10.8263 6.95093 10.7632 6.95093C10.7112 6.95093 10.6636 6.97424 10.6331 6.99376C10.1538 7.37021 9.49798 8.9649 8.96051 11.0662L9.43635 11.0716C10.3759 11.0823 11.3462 11.0933 12.3053 11.1081C12.0525 10.1456 11.8136 9.32057 11.5945 8.6546C11.2745 7.68123 11.0582 7.24551 10.9329 7.05123Z",
                fill: "#007FD2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21 12C21 16.9704 16.9706 21 12 21C7.0294 21 3 16.9704 3 12C3 7.0294 7.0294 3 12 3C16.9706 3 21 7.0294 21 12ZM18.6473 11.7942C18.6473 11.563 18.4845 11.3704 18.2651 11.3264C18.2639 11.3263 18.2626 11.3259 18.2611 11.3255C18.2586 11.3252 18.2561 11.3243 18.2536 11.3239L18.2447 11.323C18.2214 11.3192 18.1977 11.3169 18.1735 11.3165L18.1104 11.3105C16.603 11.2027 15.0522 11.1602 13.5974 11.1311L13.5945 11.1204C12.8864 8.46452 12.002 5.74916 10.8094 5.74916C9.69813 5.75422 8.69639 7.53831 7.83126 11.053C7.22006 11.0452 6.66289 11.0367 6.13753 11.0277C6.10771 11.0272 6.08096 11.027 6.05711 11.027C5.94506 11.027 5.8903 11.0317 5.86319 11.0353C5.56735 11.0877 5.35265 11.3458 5.35265 11.6492C5.35265 11.9586 5.58361 12.2239 5.88452 12.2673L5.89066 12.2736H7.54789C7.3941 12.9768 7.25928 13.6722 7.14669 14.3422L7.09735 14.6371L7.09681 14.6512C7.09789 14.8787 7.28385 15.0638 7.5112 15.0638C7.65542 15.0638 7.78608 14.9886 7.86072 14.8715L7.87247 14.8809L8.68717 12.2736H12.6114C12.9112 13.4064 13.2222 14.576 13.6332 15.6737C13.853 16.2607 14.3675 17.6355 15.2273 17.6423H15.2371C16.568 17.6423 17.0866 15.4927 17.4302 14.0696C17.5039 13.7635 17.5677 13.4991 17.6279 13.3048L17.6519 13.2246H17.6517C17.6575 13.2058 17.6606 13.1859 17.6606 13.1651C17.6606 13.0513 17.5683 12.9589 17.4544 12.9589C17.366 12.9589 17.2908 13.0144 17.2614 13.0925L17.261 13.0923L17.2321 13.1722C17.1192 13.4848 17.0147 13.7805 16.9222 14.0425L16.9151 14.0622C16.3392 15.6936 16.0762 16.4382 15.5611 16.4384L15.5485 16.4382L15.5413 16.4393L15.5284 16.4389C14.8692 16.4389 14.2484 13.7588 14.0147 12.75C13.9742 12.5752 13.9372 12.4148 13.903 12.2736H18.1661C18.2461 12.2736 18.3215 12.2536 18.3877 12.2189C18.3882 12.2187 18.3886 12.2185 18.3889 12.2183C18.3956 12.2149 18.4019 12.2109 18.4084 12.2071C18.4157 12.203 18.4227 12.1988 18.4296 12.1943C18.433 12.1921 18.4363 12.1898 18.4395 12.1874C18.4498 12.1804 18.4598 12.173 18.4695 12.165C18.4702 12.1645 18.4708 12.1639 18.4715 12.1634C18.5789 12.0754 18.6473 11.942 18.6473 11.7942Z",
                fill: "#007FD2"
            })
        ]
    });
};
var $e49fc528719c2d47$export$2e2bcd8739ae039 = $e49fc528719c2d47$var$AmplitudeIcon;

});

parcelRegister("dpIpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd4523c3c0079a21$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $dd4523c3c0079a21$var$AsanaIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#F06A6A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.9553 12.3807C14.2737 12.3807 12.9105 13.7439 12.9105 15.4256C12.9105 17.1072 14.2737 18.4704 15.9553 18.4704C17.6369 18.4704 19 17.1072 19 15.4256C19 13.7439 17.6369 12.3807 15.9553 12.3807ZM8.04475 12.381C6.3632 12.381 5 13.7439 5 15.4256C5 17.1072 6.3632 18.4704 8.04475 18.4704C9.72637 18.4704 11.0896 17.1072 11.0896 15.4256C11.0896 13.7439 9.72637 12.381 8.04475 12.381ZM15.0447 8.57471C15.0447 10.2564 13.6816 11.6197 12 11.6197C10.3184 11.6197 8.95526 10.2564 8.95526 8.57471C8.95526 6.89336 10.3184 5.53003 12 5.53003C13.6816 5.53003 15.0447 6.89336 15.0447 8.57471Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.0853 12.8081C14.9233 12.8081 13.1707 14.5607 13.1707 16.7229C13.1707 18.8849 14.9233 20.6376 17.0853 20.6376C19.2474 20.6376 21 18.8849 21 16.7229C21 14.5607 19.2474 12.8081 17.0853 12.8081ZM6.91468 12.8084C4.75268 12.8084 3 14.5607 3 16.7229C3 18.8849 4.75268 20.6376 6.91468 20.6376C9.07677 20.6376 10.8295 18.8849 10.8295 16.7229C10.8295 14.5607 9.07677 12.8084 6.91468 12.8084ZM15.9146 7.91459C15.9146 10.0768 14.162 11.8296 12 11.8296C9.83793 11.8296 8.08533 10.0768 8.08533 7.91459C8.08533 5.75285 9.83793 4 12 4C14.162 4 15.9146 5.75285 15.9146 7.91459Z",
            fill: "#F06A6A"
        })
    });
};
var $dd4523c3c0079a21$export$2e2bcd8739ae039 = $dd4523c3c0079a21$var$AsanaIcon;

});

parcelRegister("2RIXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $53660837dec24876$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $53660837dec24876$var$AzureDevopsIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.5 7.30929V16.4293L15.75 19.5L9.9375 17.3839V19.4818L6.64714 15.1821L16.2375 15.9321V7.71964L19.5 7.30929ZM16.3029 7.76786L10.9221 4.5V6.64393L5.98071 8.09571L4.5 9.99643V14.3132L6.61929 15.2486V9.71679L16.3029 7.76786Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19 7.622V16.134L15.5 19L10.075 17.025V18.983L7.004 14.97L15.955 15.67V8.005L19 7.622ZM16.016 8.05L10.994 5V7.001L6.382 8.356L5 10.13V14.159L6.978 15.032V9.869L16.016 8.05Z",
                fill: "url(#paint0_linear_24_1001)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                    id: "paint0_linear_24_1001",
                    x1: "12",
                    y1: "18.956",
                    x2: "12",
                    y2: "5.026",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            stopColor: "#0078D4"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.16",
                            stopColor: "#1380DA"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.53",
                            stopColor: "#3C91E5"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "0.82",
                            stopColor: "#559CEC"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                            offset: "1",
                            stopColor: "#5EA0EF"
                        })
                    ]
                })
            })
        ]
    });
};
var $53660837dec24876$export$2e2bcd8739ae039 = $53660837dec24876$var$AzureDevopsIcon;

});

parcelRegister("8b6pH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b4c7485efb04e66$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $7b4c7485efb04e66$var$BoxIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0071F7"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.8589 15.3516C20.0587 15.6312 20.0187 15.9907 19.779 16.1905C19.4994 16.3902 19.0999 16.3502 18.9002 16.1106L17.5021 14.313L16.1439 16.0706C15.9441 16.3502 15.5447 16.3502 15.265 16.1505C14.9854 15.9508 14.9455 15.5913 15.1452 15.3116L16.7431 13.2344L15.1452 11.1571C14.9455 10.8775 15.0254 10.478 15.265 10.2783C15.5447 10.0786 15.9441 10.1585 16.1439 10.3982L17.5021 12.1958L18.9002 10.478C19.0999 10.1984 19.4595 10.1585 19.779 10.3582C20.0587 10.5579 20.0587 10.9574 19.8589 11.237L18.301 13.2743L19.8589 15.3516ZM12.5886 15.1119C11.55 15.1119 10.7111 14.313 10.7111 13.2743C10.7111 12.2757 11.55 11.4368 12.5886 11.4368C13.6272 11.4368 14.4661 12.2757 14.4661 13.2743C14.4261 14.313 13.5873 15.1119 12.5886 15.1119ZM7.07591 15.1119C6.03729 15.1119 5.19841 14.313 5.19841 13.2743C5.19841 12.2757 6.03729 11.4368 7.07591 11.4368C8.11453 11.4368 8.95342 12.2757 8.95342 13.2743C8.95342 14.313 8.11453 15.1119 7.07591 15.1119ZM12.5886 10.2384C11.4301 10.2384 10.3915 10.8775 9.8722 11.8362C9.35289 10.8775 8.31427 10.2384 7.11586 10.2384C6.39682 10.2384 5.75766 10.478 5.23835 10.8376V8.28097C5.23835 7.96139 4.95873 7.68176 4.63915 7.68176C4.27963 7.68176 4 7.96139 4 8.28097V13.3143C4.03995 14.9921 5.39814 16.3103 7.07591 16.3103C8.27432 16.3103 9.31294 15.6312 9.83225 14.6725C10.3516 15.6312 11.3902 16.3103 12.5486 16.3103C14.2664 16.3103 15.6645 14.9521 15.6645 13.2344C15.7045 11.5966 14.3063 10.2384 12.5886 10.2384Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M20.8413 15.6285C21.066 15.9431 21.0211 16.3476 20.7514 16.5723C20.4368 16.797 19.9874 16.752 19.7627 16.4824L18.1898 14.4601L16.6619 16.4375C16.4371 16.752 15.9877 16.752 15.6732 16.5273C15.3586 16.3026 15.3136 15.8982 15.5383 15.5836L17.336 13.2467L15.5383 10.9098C15.3136 10.5952 15.4035 10.1458 15.6732 9.92112C15.9877 9.69642 16.4371 9.7863 16.6619 10.0559L18.1898 12.0783L19.7627 10.1458C19.9874 9.83124 20.3919 9.7863 20.7514 10.011C21.066 10.2357 21.066 10.6851 20.8413 10.9997L19.0886 13.2916L20.8413 15.6285ZM12.6622 15.3589C11.4937 15.3589 10.55 14.4601 10.55 13.2916C10.55 12.1681 11.4937 11.2244 12.6622 11.2244C13.8306 11.2244 14.7744 12.1681 14.7744 13.2916C14.7294 14.4601 13.7857 15.3589 12.6622 15.3589ZM6.4604 15.3589C5.29196 15.3589 4.34821 14.4601 4.34821 13.2916C4.34821 12.1681 5.29196 11.2244 6.4604 11.2244C7.62885 11.2244 8.5726 12.1681 8.5726 13.2916C8.5726 14.4601 7.62885 15.3589 6.4604 15.3589ZM12.6622 9.87618C11.3589 9.87618 10.1904 10.5952 9.60622 11.6738C9.022 10.5952 7.85355 9.87618 6.50534 9.87618C5.69642 9.87618 4.97737 10.1458 4.39315 10.5503V7.6741C4.39315 7.31458 4.07857 7 3.71904 7C3.31458 7 3 7.31458 3 7.6741V13.3366C3.04494 15.2241 4.57291 16.7071 6.4604 16.7071C7.80861 16.7071 8.97706 15.9431 9.56128 14.8646C10.1455 15.9431 11.314 16.7071 12.6172 16.7071C14.5497 16.7071 16.1226 15.1791 16.1226 13.2467C16.1675 11.4041 14.5946 9.87618 12.6622 9.87618Z",
            fill: "#0071F7"
        })
    });
};
var $7b4c7485efb04e66$export$2e2bcd8739ae039 = $7b4c7485efb04e66$var$BoxIcon;

});

parcelRegister("gNpxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8045fbc5fd77557$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a8045fbc5fd77557$var$CanvaIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_1737_5849)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "24",
                        height: "24",
                        rx: "6",
                        fill: "#00C4CC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.0221 14.2091C16.9332 14.2091 16.855 14.2841 16.7737 14.4479C15.8548 16.3111 14.2679 17.6294 12.4314 17.6294C10.308 17.6294 8.993 15.7125 8.993 13.0644C8.993 8.57869 11.4923 5.98516 13.6875 5.98516C14.7133 5.98516 15.3398 6.62979 15.3398 7.65565C15.3398 8.87317 14.6481 9.51781 14.6481 9.94721C14.6481 10.14 14.768 10.2567 15.0057 10.2567C15.9609 10.2567 17.082 9.15909 17.082 7.60853C17.082 6.10509 15.7735 5 13.5783 5C9.95033 5 6.72607 8.36346 6.72607 13.0172C6.72607 16.6195 8.78313 19 11.9571 19C15.3258 19 17.2737 15.6483 17.2737 14.5604C17.2737 14.3194 17.1506 14.2091 17.0221 14.2091Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_1737_5849",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                        fill: "white"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "#7D2AE7"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint0_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint1_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint2_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12 20.025C16.4183 20.025 20 16.4377 20 12.0125C20 7.58732 16.4183 4 12 4C7.58172 4 4 7.58732 4 12.0125C4 16.4377 7.58172 20.025 12 20.025Z",
                fill: "url(#paint3_radial_24_1067)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.4538 13.656C15.3878 13.656 15.3297 13.7118 15.2692 13.8338C14.5864 15.2204 13.4071 16.2016 12.0425 16.2016C10.4645 16.2016 9.48736 14.775 9.48736 12.804C9.48736 9.4655 11.3446 7.53522 12.9759 7.53522C13.7382 7.53522 14.2037 8.015 14.2037 8.77851C14.2037 9.68467 13.6897 10.1645 13.6897 10.484C13.6897 10.6275 13.7788 10.7144 13.9554 10.7144C14.6652 10.7144 15.4983 9.89747 15.4983 8.74344C15.4983 7.62448 14.526 6.802 12.8947 6.802C10.1988 6.802 7.8028 9.30531 7.8028 12.769C7.8028 15.45 9.3314 17.2217 11.69 17.2217C14.1933 17.2217 15.6408 14.7271 15.6408 13.9174C15.6408 13.7381 15.5493 13.656 15.4538 13.656Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint0_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.0906 18.2033) rotate(-49.4602) scale(12.3858 12.3828)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint1_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.23576 5.82176) rotate(54.7452) scale(13.9692 13.962)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint2_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.09053 18.2032) rotate(-45.2401) scale(12.2345 5.62672)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#6420FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#6420FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint3_radial_24_1067",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.5432 6.15916) rotate(66.5525) scale(12.6133 21.1075)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00C4CC",
                                stopOpacity: "0.725916"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.0001",
                                stopColor: "#00C4CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00C4CC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a8045fbc5fd77557$export$2e2bcd8739ae039 = $a8045fbc5fd77557$var$CanvaIcon;

});

parcelRegister("fKCBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cc910e047331ab3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $5cc910e047331ab3$var$DocusignIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-115.5",
                y: "-166.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "32",
                height: "32",
                rx: "8",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "31",
                height: "31",
                rx: "7.5",
                stroke: "#0B1228",
                strokeOpacity: "0.14"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.2568 20.2378V25.1619C20.2568 25.4206 20.0472 25.6295 19.7877 25.6295H6.80236C6.54285 25.6295 6.33325 25.4206 6.33325 25.1619V12.2299C6.33325 11.9712 6.54285 11.7623 6.80236 11.7623H11.733V19.7703C11.733 20.0289 11.9426 20.2378 12.2021 20.2378H20.2568Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.6668 13.2943C25.6668 17.4325 23.2414 20.2278 20.257 20.2378V15.0252C20.257 14.876 20.1971 14.7267 20.0873 14.6273L17.3725 11.9215C17.2627 11.8121 17.123 11.7524 16.9732 11.7524H11.7432V6.83818C11.7432 6.57953 11.9528 6.37063 12.2123 6.37063H19.5284C23.0018 6.36068 25.6668 9.14605 25.6668 13.2943Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.0873 14.6171C20.1971 14.7266 20.257 14.8658 20.257 15.0151V20.2277H12.2123C11.9528 20.2277 11.7432 20.0188 11.7432 19.7601V11.7522H16.9732C17.123 11.7522 17.2727 11.8119 17.3725 11.9213L20.0873 14.6171Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.0826 15.0417V18.6075C15.0826 18.7948 14.9308 18.946 14.7429 18.946H5.3397C5.15178 18.946 5 18.7948 5 18.6075V9.24286C5 9.05557 5.15178 8.9043 5.3397 8.9043H8.91017V14.7031C8.91017 14.8904 9.06195 15.0417 9.24987 15.0417H15.0826Z",
                fill: "#4C00FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19 10.0137C19 13.0104 17.2437 15.0346 15.0826 15.0418V11.2671C15.0826 11.159 15.0393 11.051 14.9598 10.979L12.9938 9.0196C12.9143 8.94036 12.8131 8.89714 12.7047 8.89714H8.91742V5.33859C8.91742 5.15129 9.0692 5.00002 9.25712 5.00002H14.555C17.0702 4.99282 19 7.00981 19 10.0137Z",
                fill: "#FF5252"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.9598 10.9717C15.0393 11.051 15.0826 11.1518 15.0826 11.2599V15.0345H9.25712C9.0692 15.0345 8.91742 14.8832 8.91742 14.6959V8.89709H12.7047C12.8131 8.89709 12.9215 8.94032 12.9938 9.01955L14.9598 10.9717Z",
                fill: "black"
            })
        ]
    });
};
var $5cc910e047331ab3$export$2e2bcd8739ae039 = $5cc910e047331ab3$var$DocusignIcon;

});

parcelRegister("9c5DY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd8c52e47d888b99$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $dd8c52e47d888b99$var$DovetailIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-747.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 13.8484C5.74119 13.8676 5.74119 13.9156 5.77446 13.9349L8.90847 15.7448C8.93934 15.7626 8.95836 15.7956 8.95836 15.8312V19.4501C8.95836 19.4885 8.99997 19.5125 9.03327 19.4933L12.1673 17.6834C12.1981 17.6656 12.2172 17.6326 12.2172 17.597V13.9492C12.2172 13.9136 12.1981 13.8806 12.1672 13.8628L8.95836 12.0106L5.77446 13.8484Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77446 6.32257C5.74119 6.3418 5.74119 6.38983 5.77446 6.40903L8.90847 8.21896C8.93934 8.23681 8.95836 8.26975 8.95836 8.30542V12.0108L12.2172 10.1288V6.42346C12.2172 6.38779 12.1981 6.35482 12.1672 6.33697L9.00828 4.51363C8.97741 4.49578 8.93934 4.49578 8.90847 4.51363L5.77446 6.32257Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.2173 10.1281L15.4261 11.9813C15.457 11.9991 15.4761 12.0321 15.4761 12.0678V15.6866C15.4761 15.7251 15.5177 15.7491 15.5509 15.7299L18.6849 13.9199C18.7158 13.9021 18.7348 13.8691 18.7348 13.8335V10.1858C18.7348 10.1501 18.7158 10.1171 18.6849 10.0993L15.526 8.27594C15.4951 8.25812 15.457 8.25812 15.4261 8.27594L12.2173 10.1281Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.72 4H5.28C4.57308 4 4 4.57308 4 5.28V18.72C4 19.4269 4.57308 20 5.28 20H18.72C19.4269 20 20 19.4269 20 18.72V5.28C20 4.57308 19.4269 4 18.72 4Z",
                fill: "#0C0020"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.8497 13.2323C7.82752 13.2451 7.82752 13.2771 7.8497 13.2899L9.93904 14.4965C9.95962 14.5084 9.9723 14.5304 9.9723 14.5542V16.9667C9.9723 16.9924 10 17.0084 10.0222 16.9955L12.1116 15.7889C12.1321 15.777 12.1448 15.7551 12.1448 15.7313V13.2995C12.1448 13.2757 12.1321 13.2537 12.1115 13.2419L9.9723 12.0071L7.8497 13.2323Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.8497 8.21489C7.82752 8.22771 7.82752 8.25973 7.8497 8.27253L9.93904 9.47915C9.95962 9.49104 9.9723 9.513 9.9723 9.53678V12.007L12.1448 10.7524V8.28214C12.1448 8.25836 12.1321 8.23638 12.1115 8.22449L10.0056 7.00893C9.985 6.99702 9.95962 6.99702 9.93904 7.00893L7.8497 8.21489Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1448 10.7523L14.2841 11.9877C14.3047 11.9996 14.3174 12.0216 14.3174 12.0453V14.4579C14.3174 14.4835 14.3451 14.4995 14.3673 14.4867L16.4566 13.2801C16.4772 13.2682 16.4899 13.2463 16.4899 13.2225V10.7907C16.4899 10.7669 16.4772 10.7449 16.4566 10.733L14.3506 9.51745C14.33 9.50557 14.3047 9.50557 14.2841 9.51745L12.1448 10.7523Z",
                fill: "white"
            })
        ]
    });
};
var $dd8c52e47d888b99$export$2e2bcd8739ae039 = $dd8c52e47d888b99$var$DovetailIcon;

});

parcelRegister("9dDdC", function(module, exports) {

$parcel$export(module.exports, "default", () => $317758376a6d0f17$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $317758376a6d0f17$var$DropboxIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#0061FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.0098 8.48964L8.24219 10.8931L12.0098 13.2965L8.24219 15.7L4.47461 13.2836L8.24219 10.8801L4.47461 8.48964L8.24219 6.08618L12.0098 8.48964ZM8.2227 16.473L11.9903 14.0695L15.7579 16.473L11.9903 18.8765L8.2227 16.473ZM12.0098 13.2836L15.7773 10.8801L12.0098 8.48964L15.7579 6.08618L19.5254 8.48964L15.7579 10.8931L19.5254 13.2965L15.7579 15.7L12.0098 13.2836Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24px",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43 40",
        version: "1.1",
        height: "24px",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
            fill: "#007EE5"
        })
    });
};
var $317758376a6d0f17$export$2e2bcd8739ae039 = $317758376a6d0f17$var$DropboxIcon;

});

parcelRegister("9HR5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ffc72fdfda17ef$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $b8ffc72fdfda17ef$var$FigmaIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 12C12 11.337 12.254 10.7011 12.7061 10.2322C13.1582 9.76339 13.7714 9.5 14.4107 9.5C15.0501 9.5 15.6633 9.76339 16.1153 10.2322C16.5674 10.7011 16.8214 11.337 16.8214 12C16.8214 12.663 16.5674 13.2989 16.1153 13.7678C15.6633 14.2366 15.0501 14.5 14.4107 14.5C13.7714 14.5 13.1582 14.2366 12.7061 13.7678C12.254 13.2989 12 12.663 12 12Z",
                        fill: "#1ABCFE"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.17871 17C7.17871 16.337 7.4327 15.7011 7.88479 15.2322C8.33689 14.7634 8.95006 14.5 9.58943 14.5H12.0001V17C12.0001 17.663 11.7462 18.2989 11.2941 18.7678C10.842 19.2366 10.2288 19.5 9.58943 19.5C8.95006 19.5 8.33689 19.2366 7.88479 18.7678C7.4327 18.2989 7.17871 17.663 7.17871 17V17Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 4.5V9.5H14.4107C15.0501 9.5 15.6633 9.23661 16.1153 8.76777C16.5674 8.29893 16.8214 7.66304 16.8214 7C16.8214 6.33696 16.5674 5.70107 16.1153 5.23223C15.6633 4.76339 15.0501 4.5 14.4107 4.5H12Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.17871 7C7.17871 7.66304 7.4327 8.29893 7.88479 8.76777C8.33689 9.23661 8.95006 9.5 9.58943 9.5H12.0001V4.5H9.58943C8.95006 4.5 8.33689 4.76339 7.88479 5.23223C7.4327 5.70107 7.17871 6.33696 7.17871 7V7Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.17871 12C7.17871 12.663 7.4327 13.2989 7.88479 13.7678C8.33689 14.2366 8.95006 14.5 9.58943 14.5H12.0001V9.5H9.58943C8.95006 9.5 8.33689 9.76339 7.88479 10.2322C7.4327 10.7011 7.17871 11.337 7.17871 12V12Z",
                        fill: "#A259FF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_7_728)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.22776 20C10.6998 20 11.8944 18.8053 11.8944 17.3333V14.6666H9.22776C7.75576 14.6666 6.5611 15.8613 6.5611 17.3333C6.5611 18.8053 7.75576 20 9.22776 20Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.5611 12C6.5611 10.528 7.75576 9.33337 9.22776 9.33337H11.8944V14.6667H9.22776C7.75576 14.6667 6.5611 13.472 6.5611 12Z",
                        fill: "#A259FF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M6.5611 6.66667C6.5611 5.19467 7.75576 4 9.22776 4H11.8944V9.33333H9.22776C7.75576 9.33333 6.5611 8.13867 6.5611 6.66667Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M11.8943 4H14.561C16.033 4 17.2277 5.19467 17.2277 6.66667C17.2277 8.13867 16.033 9.33333 14.561 9.33333H11.8943V4Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.2277 12C17.2277 13.472 16.033 14.6667 14.561 14.6667C13.089 14.6667 11.8943 13.472 11.8943 12C11.8943 10.528 13.089 9.33337 14.561 9.33337C16.033 9.33337 17.2277 10.528 17.2277 12Z",
                        fill: "#1ABCFE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_7_728",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
};
var $b8ffc72fdfda17ef$export$2e2bcd8739ae039 = $b8ffc72fdfda17ef$var$FigmaIcon;

});

parcelRegister("hUGmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a895e192628ab9a7$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a895e192628ab9a7$var$FreshserviceIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#09C6FA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.6954 4.25008C15.7025 4.25008 16.7099 4.25338 17.7183 4.25008C18.2271 4.24619 18.6802 4.38244 19.0651 4.72054C19.4877 5.09067 19.7328 5.55604 19.7349 6.11783C19.7436 8.16046 19.767 10.2037 19.7289 12.2454C19.6945 14.0838 19.0364 15.7066 17.8236 17.091C16.5561 18.5389 14.9606 19.4014 13.0546 19.6709C11.5776 19.8805 10.1533 19.6736 8.79837 19.0498C6.90652 18.179 5.57016 16.7631 4.79229 14.8358C4.32449 13.676 4.16198 12.4628 4.29456 11.2138C4.46875 9.57492 5.09668 8.1346 6.17833 6.89283C7.22587 5.69708 8.52271 4.90171 10.0581 4.49714C10.7129 4.32786 11.3871 4.2451 12.0634 4.25098C12.9401 4.25158 13.8175 4.25128 14.6954 4.25008ZM13.1971 11.1482C12.6063 11.1482 12.0155 11.1464 11.4247 11.15C11.322 11.15 11.2897 11.1323 11.3274 11.0221C11.4729 10.5945 11.6099 10.1642 11.7503 9.73443C11.895 9.29243 12.0394 8.85042 12.1837 8.40841C12.2211 8.29372 12.1837 8.20089 12.084 8.14459C11.9844 8.08829 11.8838 8.10895 11.8087 8.20268C11.7668 8.25509 11.7291 8.31079 11.689 8.36529C11.0002 9.32517 10.3118 10.2847 9.62382 11.244C9.34987 11.6257 9.07501 12.0067 8.79926 12.3868C8.76505 12.4287 8.74371 12.4796 8.73781 12.5334C8.73192 12.5872 8.74172 12.6415 8.76604 12.6898C8.81722 12.8 8.9115 12.842 9.02673 12.8464C9.07581 12.8482 9.1252 12.8479 9.17428 12.8479H12.5042C12.7054 12.8479 12.709 12.8479 12.6449 13.0456C12.3744 13.8747 12.1026 14.7032 11.8296 15.5311C11.7802 15.6809 11.8036 15.7737 11.9113 15.8336C12.0191 15.8935 12.1128 15.8677 12.2106 15.7437C12.2247 15.7264 12.2376 15.7081 12.2507 15.6898C13.2284 14.3369 14.2055 12.9839 15.182 11.6309C15.2554 11.5294 15.2919 11.4237 15.2299 11.3063C15.168 11.1889 15.0626 11.1461 14.9288 11.1467C14.3518 11.1503 13.7745 11.1482 13.1971 11.1482Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M14.7823 4.00008C15.822 4.00008 16.8619 4.00348 17.9027 4.00008C18.428 3.99606 18.8957 4.13672 19.293 4.48571C19.7293 4.86779 19.9823 5.34817 19.9844 5.92808C19.9934 8.0366 20.0175 10.1457 19.9783 12.2533C19.9427 14.151 19.2634 15.8262 18.0115 17.2552C16.7031 18.7499 15.0561 19.6401 13.0887 19.9183C11.564 20.1347 10.0937 19.9211 8.69509 19.2772C6.74221 18.3783 5.36275 16.9168 4.55979 14.9272C4.0769 13.73 3.90914 12.4778 4.046 11.1884C4.22581 9.49669 4.87399 8.00991 5.99053 6.72809C7.07186 5.49376 8.41054 4.67273 9.99546 4.25511C10.6714 4.08037 11.3673 3.99494 12.0654 4.00101C12.9704 4.00163 13.8761 4.00132 14.7823 4.00008ZM13.2357 11.1207C12.6259 11.1207 12.016 11.1189 11.4061 11.1226C11.3002 11.1226 11.2668 11.1043 11.3057 10.9906C11.4559 10.5491 11.5974 10.1049 11.7423 9.66135C11.8916 9.20508 12.0407 8.74882 12.1896 8.29256C12.2282 8.17416 12.1896 8.07833 12.0867 8.02022C11.9839 7.9621 11.8801 7.98343 11.8025 8.08019C11.7593 8.13428 11.7203 8.19178 11.6789 8.24804C10.9679 9.23888 10.2573 10.2294 9.54717 11.2196C9.26438 11.6137 8.98066 12.0069 8.69601 12.3992C8.6607 12.4425 8.63867 12.4951 8.63258 12.5506C8.6265 12.6061 8.63662 12.6622 8.66172 12.7121C8.71455 12.8258 8.81187 12.8691 8.93082 12.8737C8.98148 12.8756 9.03246 12.8753 9.08313 12.8753H12.5205C12.7281 12.8753 12.7318 12.8753 12.6657 13.0793C12.3864 13.9352 12.1059 14.7904 11.8241 15.645C11.7732 15.7996 11.7973 15.8954 11.9085 15.9572C12.0197 16.0191 12.1164 15.9925 12.2174 15.8645C12.232 15.8466 12.2452 15.8277 12.2588 15.8089C13.2681 14.4122 14.2767 13.0156 15.2847 11.619C15.3604 11.5142 15.3981 11.4051 15.3341 11.2839C15.2702 11.1628 15.1614 11.1186 15.0233 11.1192C14.4277 11.1229 13.8317 11.1207 13.2357 11.1207Z",
            fill: "#09C6FA"
        })
    });
};
var $a895e192628ab9a7$export$2e2bcd8739ae039 = $a895e192628ab9a7$var$FreshserviceIcon;

});

parcelRegister("9eHWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebee6edabad8a9c4$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $ebee6edabad8a9c4$var$GmailIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5.52273 17.625H7.90909V11.8295L4.5 9.27271V16.6023C4.5 17.1682 4.95852 17.625 5.52273 17.625Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.0908 17.625H18.4772C19.0431 17.625 19.4999 17.1665 19.4999 16.6023V9.27271L16.0908 11.8295",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.0908 7.3977V11.8295L19.4999 9.2727V7.90906C19.4999 6.64429 18.0562 5.92327 17.0454 6.68179",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.90918 11.8295V7.39771L12.0001 10.4659L16.091 7.39771V11.8295L12.0001 14.8977",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M4.5 7.90931V9.27294L7.90909 11.8298V7.39794L6.95455 6.68203C5.94205 5.92351 4.5 6.64453 4.5 7.90931Z",
                        fill: "#C5221F"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "37 37 115 80",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#4285f4",
                d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#34a853",
                d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#fbbc04",
                d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#ea4335",
                d: "M72 74V48l24 18 24-18v26L96 92"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#c5221f",
                d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
            })
        ]
    });
};
var $ebee6edabad8a9c4$export$2e2bcd8739ae039 = $ebee6edabad8a9c4$var$GmailIcon;

});

parcelRegister("6mOGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $37eb7b587ecd273b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");
const $37eb7b587ecd273b$var$GithubIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0001 4C7.58233 4 4 7.67232 4 12.2025C4 15.8266 6.29226 18.9013 9.47093 19.9859C9.87075 20.0618 10.0175 19.808 10.0175 19.5913C10.0175 19.3957 10.0101 18.7496 10.0067 18.0642C7.78105 18.5604 7.31141 17.0964 7.31141 17.0964C6.9475 16.1483 6.42315 15.8962 6.42315 15.8962C5.6973 15.3871 6.47786 15.3975 6.47786 15.3975C7.28121 15.4554 7.70421 16.2428 7.70421 16.2428C8.41774 17.4968 9.57572 17.1343 10.0322 16.9247C10.104 16.3945 10.3114 16.0327 10.5402 15.8279C8.76324 15.6204 6.8953 14.9171 6.8953 11.7741C6.8953 10.8786 7.20782 10.1469 7.71958 9.57245C7.63651 9.36585 7.36268 8.53158 7.79708 7.40174C7.79708 7.40174 8.46887 7.18129 9.99766 8.24253C10.6358 8.06079 11.3202 7.96965 12.0001 7.96653C12.6799 7.96965 13.3649 8.06079 14.0042 8.24253C15.5311 7.18129 16.202 7.40174 16.202 7.40174C16.6375 8.53158 16.3635 9.36585 16.2804 9.57245C16.7934 10.1469 17.1038 10.8786 17.1038 11.7741C17.1038 14.9246 15.2323 15.6183 13.4508 15.8213C13.7378 16.0759 13.9935 16.5751 13.9935 17.3403C13.9935 18.4378 13.9842 19.3211 13.9842 19.5913C13.9842 19.8096 14.1282 20.0654 14.5337 19.9848C17.7107 18.899 20 15.8254 20 12.2025C20 7.67232 16.4182 4 12.0001 4Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_6309_146339)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M10.0001 0C4.47791 0 0 4.59039 0 10.2532C0 14.7833 2.86533 18.6266 6.83867 19.9824C7.33844 20.0773 7.52192 19.76 7.52192 19.4891C7.52192 19.2446 7.51265 18.437 7.50834 17.5802C4.72631 18.2005 4.13927 16.3705 4.13927 16.3705C3.68437 15.1854 3.02894 14.8702 3.02894 14.8702C2.12163 14.2339 3.09733 14.2469 3.09733 14.2469C4.10151 14.3193 4.63026 15.3035 4.63026 15.3035C5.52217 16.871 6.96965 16.4178 7.5403 16.1559C7.63006 15.4932 7.88921 15.0409 8.1752 14.7848C5.95404 14.5256 3.61912 13.6464 3.61912 9.71766C3.61912 8.59825 4.00977 7.6836 4.64947 6.96556C4.54564 6.70731 4.20335 5.66448 4.74635 4.25218C4.74635 4.25218 5.58609 3.97661 7.49708 5.30317C8.29476 5.07599 9.15024 4.96206 10.0001 4.95816C10.8499 4.96206 11.7061 5.07599 12.5052 5.30317C14.4139 3.97661 15.2525 4.25218 15.2525 4.25218C15.7968 5.66448 15.4544 6.70731 15.3505 6.96556C15.9917 7.6836 16.3797 8.59825 16.3797 9.71766C16.3797 13.6557 14.0403 14.5228 11.8135 14.7767C12.1722 15.0949 12.4918 15.7188 12.4918 16.6754C12.4918 18.0473 12.4802 19.1514 12.4802 19.4891C12.4802 19.762 12.6602 20.0817 13.1671 19.981C17.1383 18.6237 20 14.7818 20 10.2532C20 4.59039 15.5227 0 10.0001 0Z",
                        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_6309_146339",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
                    })
                })
            })
        ]
    });
};
var $37eb7b587ecd273b$export$2e2bcd8739ae039 = $37eb7b587ecd273b$var$GithubIcon;

});

parcelRegister("xNfJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa50a4b50f89009d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $aa50a4b50f89009d$var$GitlabIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-363.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7331 10.3948L19.7115 10.3373L17.5339 4.65705C17.4898 4.54552 17.4114 4.4509 17.31 4.3869C17.2343 4.33846 17.1483 4.30842 17.059 4.29919C16.9696 4.28996 16.8793 4.30179 16.7953 4.33375C16.7113 4.3657 16.636 4.41688 16.5754 4.4832C16.5147 4.54951 16.4705 4.6291 16.4461 4.7156L14.9763 9.21564H9.02381L7.55392 4.7156C7.5294 4.62923 7.48504 4.54979 7.42438 4.4836C7.36371 4.41742 7.28842 4.36632 7.20451 4.3344C7.1206 4.30247 7.03039 4.29059 6.94107 4.2997C6.85175 4.30882 6.7658 4.33868 6.69007 4.3869C6.58865 4.4509 6.51022 4.54552 6.46615 4.65705L4.28957 10.3383L4.26697 10.3948C3.95361 11.2138 3.91501 12.1125 4.15698 12.9553C4.39895 13.7981 4.90838 14.5394 5.60846 15.0674L5.61668 15.0736L5.63517 15.088L8.94779 17.5706L10.5913 18.8125L11.5897 19.5675C11.7068 19.656 11.8496 19.7038 11.9964 19.7038C12.1432 19.7038 12.2861 19.656 12.4032 19.5675L13.4016 18.8125L15.0451 17.5706L18.3813 15.0736L18.3906 15.0664C19.0906 14.5386 19.6001 13.7975 19.8423 12.9549C20.0844 12.1123 20.0461 11.2138 19.7331 10.3948Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7329 10.3948L19.7114 10.3373C18.6504 10.555 17.6507 11.0047 16.7839 11.6541L12.0024 15.2698L15.047 17.5706L18.3832 15.0736L18.3925 15.0664C19.0922 14.5383 19.6012 13.7971 19.843 12.9545C20.0848 12.1119 20.0462 11.2135 19.7329 10.3948Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.94775 17.5708L10.5912 18.8126L11.5896 19.5676C11.7068 19.6561 11.8496 19.7039 11.9964 19.7039C12.1432 19.7039 12.286 19.6561 12.4032 19.5676L13.4016 18.8126L15.045 17.5708L12.0005 15.2699L8.94775 17.5708Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.21598 11.6541C6.34952 11.005 5.35016 10.5556 4.28957 10.3383L4.26697 10.3948C3.95361 11.2137 3.91501 12.1124 4.15698 12.9552C4.39895 13.798 4.90838 14.5393 5.60846 15.0674L5.61668 15.0735L5.63517 15.0879L8.94779 17.5706L11.9944 15.2697L7.21598 11.6541Z",
                fill: "#FC6D26"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7331 11.0987L19.7115 11.0412L17.5339 5.36091C17.4898 5.24937 17.4114 5.15476 17.31 5.09076C17.2343 5.04232 17.1483 5.01228 17.059 5.00304C16.9696 4.99381 16.8793 5.00565 16.7953 5.0376C16.7113 5.06956 16.636 5.12074 16.5754 5.18705C16.5147 5.25337 16.4705 5.33296 16.4461 5.41946L14.9763 9.91949H9.02381L7.55392 5.41946C7.5294 5.33309 7.48504 5.25364 7.42438 5.18746C7.36371 5.12127 7.28842 5.07018 7.20451 5.03825C7.1206 5.00632 7.03039 4.99444 6.94107 5.00356C6.85175 5.01268 6.7658 5.04254 6.69007 5.09076C6.58865 5.15476 6.51023 5.24937 6.46615 5.36091L4.28957 11.0422L4.26697 11.0987C3.95361 11.9177 3.91501 12.8163 4.15698 13.6591C4.39895 14.502 4.90838 15.2433 5.60846 15.7713L5.61668 15.7775L5.63517 15.7918L8.9478 18.2745L10.5913 19.5164L11.5897 20.2713C11.7068 20.3598 11.8496 20.4077 11.9964 20.4077C12.1432 20.4077 12.2861 20.3598 12.4032 20.2713L13.4016 19.5164L15.0451 18.2745L18.3813 15.7775L18.3906 15.7703C19.0906 15.2424 19.6001 14.5014 19.8423 13.6588C20.0844 12.8161 20.0461 11.9176 19.7331 11.0987Z",
                fill: "#E24329"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.7331 11.0987L19.7115 11.0411C18.6505 11.2589 17.6508 11.7085 16.784 12.358L12.0026 15.9736L15.0471 18.2745L18.3833 15.7774L18.3926 15.7702C19.0923 15.2421 19.6014 14.501 19.8431 13.6583C20.0849 12.8157 20.0463 11.9174 19.7331 11.0987Z",
                fill: "#FC6D26"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.94781 18.2745L10.5913 19.5163L11.5897 20.2713C11.7068 20.3598 11.8496 20.4077 11.9965 20.4077C12.1433 20.4077 12.2861 20.3598 12.4032 20.2713L13.4016 19.5163L15.0451 18.2745L12.0006 15.9736L8.94781 18.2745Z",
                fill: "#FCA326"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.21598 12.358C6.34952 11.7089 5.35016 11.2596 4.28957 11.0422L4.26697 11.0987C3.95361 11.9177 3.91501 12.8164 4.15698 13.6592C4.39895 14.502 4.90838 15.2433 5.60846 15.7713L5.61668 15.7775L5.63517 15.7919L8.9478 18.2745L11.9944 15.9737L7.21598 12.358Z",
                fill: "#FC6D26"
            })
        ]
    });
};
var $aa50a4b50f89009d$export$2e2bcd8739ae039 = $aa50a4b50f89009d$var$GitlabIcon;

});

parcelRegister("3yTTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2c5202162d89c8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $1a2c5202162d89c8$var$GoogleCalendarIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-124.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.8208 8.17936L12.3822 7.7973L8.17949 8.17936L7.79736 12.0001L8.17942 15.8207L12.0001 16.2983L15.8208 15.8207L16.2029 11.9046L15.8208 8.17936Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.74654 14.1071C9.46096 13.9142 9.26322 13.6324 9.15527 13.2599L9.81819 12.9867C9.87837 13.216 9.98341 13.3936 10.1334 13.5197C10.2824 13.6458 10.4639 13.7079 10.6759 13.7079C10.8928 13.7079 11.079 13.642 11.2347 13.5101C11.3903 13.3783 11.4687 13.2102 11.4687 13.0068C11.4687 12.7986 11.3866 12.6285 11.2223 12.4967C11.058 12.365 10.8517 12.299 10.6052 12.299H10.2222V11.6428H10.566C10.7781 11.6428 10.9567 11.5856 11.1019 11.4709C11.2471 11.3563 11.3197 11.1997 11.3197 11C11.3197 10.8224 11.2547 10.681 11.1249 10.575C10.995 10.469 10.8306 10.4155 10.631 10.4155C10.4362 10.4155 10.2814 10.4671 10.1668 10.5712C10.0522 10.6753 9.96904 10.8033 9.91655 10.9542L9.26039 10.681C9.34728 10.4346 9.50684 10.2168 9.74081 10.0287C9.97484 9.8405 10.2738 9.74591 10.6367 9.74591C10.9051 9.74591 11.1468 9.79752 11.3608 9.90162C11.5747 10.0057 11.7428 10.15 11.8641 10.3333C11.9854 10.5176 12.0456 10.724 12.0456 10.9532C12.0456 11.1872 11.9893 11.3849 11.8766 11.5473C11.7638 11.7097 11.6253 11.8338 11.461 11.9208V11.9599C11.6779 12.0507 11.8546 12.1892 11.994 12.3754C12.1325 12.5617 12.2022 12.7843 12.2022 13.0441C12.2022 13.3039 12.1363 13.536 12.0045 13.7394C11.8726 13.9429 11.6902 14.1034 11.4591 14.2199C11.227 14.3364 10.9662 14.3956 10.6768 14.3956C10.3416 14.3966 10.0321 14.3001 9.74654 14.1071Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M13.8145 10.8175L13.0905 11.3438L12.7266 10.7917L14.0323 9.84991H14.5328V14.2924H13.8145V10.8175Z",
                        fill: "#1A73E8"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.8208 19.2592L19.2593 15.8206L17.54 15.0565L15.8208 15.8206L15.0566 17.5399L15.8208 19.2592Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.41504 17.54L8.17915 19.2593H15.8205V15.8207H8.17915L7.41504 17.54Z",
                        fill: "#34A853"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5.88689 4.74078C5.25366 4.74078 4.74072 5.25372 4.74072 5.88695V15.8207L6.46001 16.5848L8.17929 15.8207V8.17935H15.8206L16.5847 6.46007L15.8207 4.74078H5.88689Z",
                        fill: "#4285F4"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M4.74072 15.8207V18.1131C4.74072 18.7464 5.25366 19.2593 5.88689 19.2593H8.17929V15.8207H4.74072Z",
                        fill: "#188038"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.8203 8.17945V15.8208H19.2589V8.17945L17.5396 7.41534L15.8203 8.17945Z",
                        fill: "#FBBC04"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M19.2589 8.17929V5.88689C19.2589 5.25359 18.7459 4.74072 18.1127 4.74072H15.8203V8.17929H19.2589Z",
                        fill: "#1967D2"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-label": "Google Calendar",
        viewBox: "50 50 410 410 ",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#4285f4",
                d: "M100 340h74V174h166v-74H137q-37 0-37 35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#1967d2",
                d: "M338 100v76h74v-41q0-35-35-35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#fbbc04",
                d: "M338 174h74v164h-74"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#188038",
                d: "M100 338v39q0 35 35 35h41v-74"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#34a853",
                d: "M174 338h164v74H174"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "#ea4335",
                d: "M338 412v-74h74"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fill: "none",
                stroke: "#4285f4",
                strokeLinejoin: "bevel",
                strokeWidth: 15,
                d: "M204 229a25 22 1 1 1 25 27h-9 9a25 22 1 1 1-25 27m66-52 27-19h4v-7 103"
            })
        ]
    });
};
var $1a2c5202162d89c8$export$2e2bcd8739ae039 = $1a2c5202162d89c8$var$GoogleCalendarIcon;

});

parcelRegister("5wHPF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8fe8259ed5344f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $cf8fe8259ed5344f$var$HubSpotFilterIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FF5C35"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.2949 7.36118V9.2655C18.0986 9.53156 19.5395 10.8388 19.9091 12.5445C20.2788 14.2502 19.4994 15.9955 17.9542 16.9226C16.409 17.8496 14.4229 17.7632 12.9725 16.7059L11.3506 18.2537C11.3927 18.3793 11.4149 18.5101 11.4169 18.6419C11.4169 19.1911 11.0701 19.6864 10.5383 19.8966C10.0065 20.1068 9.39443 19.9906 8.98742 19.6022C8.5804 19.2138 8.45864 18.6296 8.67892 18.1221C8.8992 17.6147 9.41812 17.2837 9.99372 17.2837C10.1318 17.2857 10.2689 17.307 10.4005 17.3469L12.0399 15.7824C11.0063 14.3791 10.9796 12.5146 11.9727 11.0849L6.58545 7.08265C6.32553 7.22716 6.03031 7.30382 5.72949 7.30488C4.77318 7.30379 3.99886 6.56308 4 5.65047C4.00115 4.73785 4.77732 3.99891 5.73363 4C6.68995 4.00109 7.46428 4.7418 7.46314 5.65442C7.4609 5.79367 7.44004 5.93209 7.40104 6.06629L12.8803 10.1347C13.4781 9.67598 14.1922 9.37614 14.9504 9.2655V7.36118C14.4121 7.12126 14.0671 6.60659 14.0644 6.03963V5.99518C14.0667 5.18711 14.7525 4.53257 15.5993 4.5304H15.6459C16.4927 4.53257 17.1785 5.18711 17.1808 5.99518V6.03963C17.1782 6.60659 16.8331 7.12126 16.2949 7.36118ZM13.3789 13.3881C13.3789 14.5707 14.3835 15.5295 15.6228 15.5295C16.8621 15.5295 17.8667 14.5707 17.8667 13.3881C17.8667 12.2055 16.8621 11.2467 15.6228 11.2467C14.3835 11.2467 13.3789 12.2055 13.3789 13.3881Z",
            fill: "#FF5C35"
        })
    });
};
var $cf8fe8259ed5344f$export$2e2bcd8739ae039 = $cf8fe8259ed5344f$var$HubSpotFilterIcon;

});

parcelRegister("kVu7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5f11824900bc125$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6fnsQ = parcelRequire("6fnsQ");
const $a5f11824900bc125$var$LucidIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M6.01072 13.6063C6.01072 11.5924 6.01608 9.57906 6.00429 7.5652C6.00268 7.28018 6.08739 7.12189 6.34258 6.97751C8.00454 6.03689 9.65525 5.07648 11.3097 4.12249C11.6394 3.93212 11.656 3.94067 11.656 4.31286C11.656 8.28657 11.656 12.2603 11.656 16.2345C11.656 16.3148 11.6614 16.3955 11.6555 16.4752C11.641 16.6773 11.7123 16.711 11.8844 16.6099C12.4002 16.3078 12.9197 16.0116 13.4376 15.7132C14.5972 15.0447 15.7568 14.3758 16.917 13.7079C17.192 13.5496 17.2231 13.5672 17.2231 13.8913C17.2241 15.7533 17.2241 17.6158 17.2231 19.4778C17.2231 19.8232 17.2027 19.843 16.8601 19.8436C15.2164 19.8462 13.5727 19.8425 11.9295 19.8543C11.663 19.8564 11.5697 19.7805 11.5751 19.5067C11.5912 18.7227 11.5815 17.9388 11.5804 17.1543C11.5804 16.8746 11.5751 16.8693 11.329 17.011C9.66543 17.9671 8.00347 18.9265 6.33936 19.8821C6.25144 19.9323 6.16191 20.0478 6.05469 19.9783C5.96676 19.9216 6.01126 19.796 6.01126 19.7013C6.00965 17.6698 6.00965 15.6383 6.00965 13.6068L6.01072 13.6063Z",
            fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
        })
    });
};
var $a5f11824900bc125$export$2e2bcd8739ae039 = $a5f11824900bc125$var$LucidIcon;

});

parcelRegister("9DzSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $65126ba42d15d21a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $65126ba42d15d21a$var$LoomIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181644)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
                    fill: "#5753F3"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_271_181644",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
var $65126ba42d15d21a$export$2e2bcd8739ae039 = $65126ba42d15d21a$var$LoomIcon;

});

parcelRegister("4sX9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3865c96b8d866c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $cb3865c96b8d866c$var$MiroIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0122 5.5H13.1097L14.6951 8.28547L11.2073 5.5H9.30491L11.0488 8.90456L7.40244 5.5H5.5L7.40244 9.83362L5.5 18.5H7.40244L11.0488 9.21453L9.30491 18.5H11.2073L14.6951 8.59544L13.1097 18.5H15.0122L18.5 7.6664L15.0122 5.5Z",
                fill: "black"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4 8C4 5.79086 5.79086 4 8 4H16C18.2092 4 20 5.79086 20 8V16C20 18.2091 18.2092 20 16 20H8C5.79086 20 4 18.2091 4 16V8Z",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.6372 7.05002H13.1848L14.3951 9.17662L11.7323 7.05002H10.2799L11.6113 9.64927L8.82744 7.05002H7.375L8.82744 10.3586L7.375 16.975H8.82744L11.6113 9.88592L10.2799 16.975H11.7323L14.3951 9.41327L13.1848 16.975H14.6372L17.3 8.70398L14.6372 7.05002Z",
                fill: "black"
            })
        ]
    });
};
var $cb3865c96b8d866c$export$2e2bcd8739ae039 = $cb3865c96b8d866c$var$MiroIcon;

});

parcelRegister("71zpm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0516226a48c56413$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $0516226a48c56413$var$MondayIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.36594 16.7731C6.03435 16.7738 5.70851 16.6807 5.42172 16.5032C5.13492 16.3257 4.89744 16.0701 4.73354 15.7627C4.57214 15.4574 4.49165 15.111 4.50068 14.7606C4.50972 14.4103 4.60793 14.0691 4.78482 13.7738L8.14648 8.14287C8.31854 7.84024 8.56281 7.59175 8.85436 7.42277C9.14592 7.2538 9.47429 7.1704 9.80595 7.18109C10.1373 7.18956 10.4607 7.2918 10.7429 7.47734C11.0251 7.66289 11.256 7.92507 11.412 8.23707C11.7254 8.86914 11.6862 9.6296 11.3109 10.2229L7.95133 15.8538C7.78097 16.137 7.54634 16.3697 7.2692 16.5304C6.99206 16.6911 6.68137 16.7746 6.36594 16.7731Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1321 16.7728C11.454 16.7728 10.8301 16.3861 10.5025 15.7647C10.3415 15.4602 10.2612 15.1148 10.2702 14.7653C10.2793 14.4159 10.3773 14.0756 10.5538 13.7811L13.9091 8.16313C14.0786 7.85625 14.322 7.60333 14.614 7.43061C14.9061 7.25789 15.2361 7.17165 15.5699 7.18084C16.2537 7.19679 16.8733 7.60475 17.1867 8.2429C17.4979 8.88105 17.4523 9.64607 17.0656 10.2379L13.7111 15.8559C13.5412 16.1378 13.3075 16.3696 13.0316 16.5299C12.7556 16.6901 12.4463 16.7737 12.1321 16.7728Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.7693 16.82C18.7251 16.82 19.4999 16.0108 19.4999 15.0126C19.4999 14.0145 18.7251 13.2053 17.7693 13.2053C16.8134 13.2053 16.0386 14.0145 16.0386 15.0126C16.0386 16.0108 16.8134 16.82 17.7693 16.82Z",
                fill: "#00CA72"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.99034 16.9904C5.63664 16.9912 5.28909 16.8981 4.98317 16.7205C4.67725 16.543 4.42393 16.2875 4.24911 15.98C4.07695 15.6747 3.99109 15.3283 4.00073 14.978C4.01037 14.6276 4.11513 14.2865 4.3038 13.9911L7.88959 8.36021C8.07311 8.05759 8.33368 7.80909 8.64467 7.64012C8.95566 7.47115 9.30592 7.38774 9.65969 7.39843C10.0132 7.40691 10.3581 7.50914 10.6591 7.69469C10.9601 7.88023 11.2064 8.14242 11.3728 8.45442C11.7071 9.08649 11.6653 9.84695 11.2649 10.4403L7.68143 16.0712C7.49971 16.3543 7.24944 16.5871 6.95382 16.7478C6.6582 16.9084 6.3268 16.9919 5.99034 16.9904Z",
                fill: "#F62B54"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1409 16.9902C11.4177 16.9902 10.7522 16.6035 10.4027 15.9821C10.2309 15.6776 10.1453 15.3322 10.1549 14.9827C10.1645 14.6333 10.2691 14.2931 10.4574 13.9985L14.0363 8.38054C14.2172 8.07366 14.4768 7.82074 14.7883 7.64802C15.0998 7.47529 15.4519 7.38906 15.808 7.39825C16.5373 7.4142 17.1982 7.82216 17.5325 8.46031C17.8645 9.09846 17.8159 9.86347 17.4033 10.4553L13.8251 16.0733C13.644 16.3552 13.3947 16.587 13.1004 16.7473C12.806 16.9075 12.476 16.9911 12.1409 16.9902Z",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.154 17.0374C19.1736 17.0374 20.0001 16.2282 20.0001 15.2301C20.0001 14.2319 19.1736 13.4227 18.154 13.4227C17.1344 13.4227 16.3079 14.2319 16.3079 15.2301C16.3079 16.2282 17.1344 17.0374 18.154 17.0374Z",
                fill: "#00CA72"
            })
        ]
    });
};
var $0516226a48c56413$export$2e2bcd8739ae039 = $0516226a48c56413$var$MondayIcon;

});

parcelRegister("5FlG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $39ba9afef184103e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $39ba9afef184103e$var$MuralIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-459.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.6754 16.1763C12.6757 14.0134 12.6843 11.8504 12.6739 9.68758C12.6654 7.94483 13.8929 6.44038 15.5576 6.08234C15.8132 6.02736 16.0709 5.99181 16.3335 6.00416C16.3754 6.06652 16.3699 6.13777 16.3701 6.20736C16.3708 6.83713 16.371 7.46704 16.3698 8.09681C16.3696 8.17062 16.3803 8.24819 16.3276 8.31236C15.8848 8.32742 15.5243 8.50576 15.2565 8.86034C15.089 9.08221 14.9992 9.3339 14.9928 9.61332C14.9914 9.67342 14.9908 9.73352 14.9908 9.79377C14.9908 11.8638 14.9908 13.9339 14.9905 16.0039C14.9905 16.0639 14.9863 16.1238 14.9842 16.1839C14.9391 16.2353 14.8769 16.2339 14.8176 16.2342C14.1625 16.2368 13.5073 16.2368 12.8522 16.2342C12.7888 16.2339 12.7197 16.2401 12.6755 16.1763H12.6754Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.66997C19.997 9.7251 19.9991 9.78023 19.9991 9.83536C19.9992 12.6608 19.9994 15.4861 19.9988 18.3115C19.9988 18.5251 20.0262 18.4962 19.8174 18.4965C19.1651 18.4977 18.5127 18.497 17.8602 18.497C17.8251 18.497 17.7899 18.4955 17.7548 18.497C17.7016 18.4992 17.684 18.4709 17.6862 18.4226C17.6871 18.4025 17.6862 18.3825 17.6862 18.3623C17.6865 15.4716 17.6867 12.5811 17.687 9.69046C17.687 9.68548 17.6874 9.68036 17.6876 9.67539C17.7236 9.6043 17.7918 9.60324 17.8563 9.60294C18.5111 9.59948 19.1658 9.59963 19.8206 9.60249C19.8869 9.60279 19.9509 9.61213 19.9956 9.66982L19.9958 9.66997Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.31589 9.65845C6.31815 9.71343 6.32222 9.76841 6.32222 9.82339C6.32252 12.6568 6.32267 15.4902 6.32222 18.3237C6.32222 18.5291 6.34511 18.5007 6.1493 18.501C5.48729 18.502 4.82529 18.502 4.16344 18.5002C4.11208 18.5002 4.05183 18.5251 4.01025 18.4692C4.02758 18.4151 4.01538 18.3598 4.01538 18.3053C4.01628 15.4761 4.01613 12.6469 4.01613 9.81781C4.01613 9.61688 4.02682 9.60212 4.22535 9.60121C4.85738 9.5985 5.4894 9.59941 6.12143 9.60106C6.19072 9.60121 6.26407 9.59579 6.31604 9.65845H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3296 18.485C11.282 18.508 11.2309 18.499 11.1813 18.4991C10.5242 18.5006 9.86683 18.5014 9.20965 18.5021C9.1845 18.5021 9.15949 18.5029 9.13434 18.502C9.06545 18.4995 9.02985 18.4615 9.02754 18.3881C9.02709 18.373 9.02754 18.358 9.02754 18.3429C9.02754 15.4932 9.02754 12.6434 9.02769 9.79368C9.02769 9.74864 9.03101 9.70361 9.03282 9.65842C9.08463 9.59651 9.15738 9.60103 9.22667 9.60073C9.86141 9.59907 10.4961 9.59907 11.1309 9.60073C11.2003 9.60088 11.2728 9.59711 11.3247 9.65857C11.3267 9.72364 11.3305 9.78871 11.3305 9.85378C11.3308 11.899 11.3306 13.9442 11.3311 15.9892C11.3311 16.0542 11.3234 16.1197 11.3409 16.1837C11.3704 16.2444 11.3702 16.3096 11.3702 16.3748C11.3704 17.0109 11.371 17.647 11.3696 18.283C11.3696 18.3521 11.3782 18.4246 11.3296 18.4847V18.485Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3247 9.65883C10.5607 9.65883 9.79675 9.65883 9.03263 9.65868C9.00822 9.44901 8.97343 9.24296 8.87477 9.05166C8.60861 8.53577 8.0406 8.24174 7.47124 8.32896C6.89584 8.41707 6.43884 8.87166 6.34515 9.45007C6.33401 9.5192 6.32557 9.58879 6.31593 9.65823C5.60302 9.65823 4.89011 9.65793 4.17719 9.65778C4.15716 9.65778 4.13682 9.65944 4.11694 9.65763C4.04795 9.65145 4.01226 9.67751 4.01753 9.75132C4.02039 9.79123 4.01783 9.8316 4.01783 9.87182C4.01783 12.6882 4.01783 15.5048 4.01753 18.3212C4.01753 18.3709 4.01286 18.4206 4.01015 18.4697C3.99267 18.4307 4.00307 18.3902 4.00307 18.351C4.00231 15.501 4.00201 12.6509 4.00277 9.80087C4.00277 9.28513 4.06874 8.77888 4.27389 8.30139C4.8172 7.03749 5.76675 6.26101 7.12404 6.04561C9.03022 5.74301 10.8088 6.97166 11.247 8.85389C11.3084 9.11794 11.3462 9.38605 11.3246 9.65883H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3295 18.4854C11.3295 17.7731 11.3295 17.0608 11.3299 16.3486C11.3299 16.2938 11.3216 16.2382 11.3408 16.1844C11.7857 16.1819 12.2307 16.1793 12.6756 16.1768C12.7253 16.1795 12.7752 16.1844 12.8249 16.1844C13.5447 16.1849 14.2644 16.1846 14.9843 16.1844C14.9865 16.2343 14.9909 16.2843 14.9909 16.3342C14.9913 16.9954 14.9912 17.6568 14.9912 18.3181C14.9912 18.3532 14.99 18.3883 14.9909 18.4232C14.9921 18.4723 14.9705 18.4981 14.9201 18.4975C14.885 18.4972 14.8499 18.4982 14.8149 18.4982C13.7077 18.4982 12.6006 18.4982 11.4933 18.4981C11.4385 18.4981 11.3829 18.5051 11.3296 18.4853L11.3295 18.4854Z",
                fill: "#FFAA00"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.6756 16.1765C12.6759 14.0137 12.6845 11.8507 12.6741 9.68782C12.6657 7.94507 13.8931 6.44062 15.5579 6.08258C15.8135 6.0276 16.0712 5.99206 16.3337 6.00441C16.3756 6.06677 16.3702 6.13801 16.3703 6.2076C16.3711 6.83737 16.3712 7.46729 16.37 8.09706C16.3699 8.17086 16.3806 8.24844 16.3279 8.3126C15.885 8.32766 15.5246 8.50601 15.2568 8.86058C15.0893 9.08245 14.9995 9.33415 14.993 9.61356C14.9916 9.67366 14.991 9.73376 14.991 9.79401C14.991 11.8641 14.991 13.9341 14.9907 16.0042C14.9907 16.0641 14.9865 16.1241 14.9844 16.1842C14.9394 16.2355 14.8772 16.2342 14.8178 16.2345C14.1628 16.237 13.5075 16.237 12.8525 16.2345C12.789 16.2342 12.7199 16.2404 12.6758 16.1765H12.6756Z",
                fill: "#00843F"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.67021C19.997 9.72534 19.9991 9.78047 19.9991 9.8356C19.9992 12.661 19.9994 15.4863 19.9988 18.3118C19.9988 18.5254 20.0262 18.4965 19.8174 18.4968C19.1651 18.498 18.5127 18.4972 17.8602 18.4972C17.8251 18.4972 17.7899 18.4957 17.7548 18.4972C17.7016 18.4995 17.684 18.4712 17.6862 18.4228C17.6871 18.4028 17.6862 18.3827 17.6862 18.3625C17.6865 15.4719 17.6867 12.5814 17.687 9.6907C17.687 9.68573 17.6874 9.68061 17.6876 9.67564C17.7236 9.60454 17.7918 9.60349 17.8563 9.60319C18.5111 9.59972 19.1658 9.59987 19.8206 9.60273C19.8869 9.60303 19.9509 9.61237 19.9956 9.67006L19.9958 9.67021Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.31589 9.65857C6.31815 9.71355 6.32222 9.76853 6.32222 9.82351C6.32252 12.6569 6.32267 15.4904 6.32222 18.3238C6.32222 18.5292 6.34511 18.5008 6.1493 18.5011C5.48729 18.5021 4.82529 18.5021 4.16344 18.5003C4.11208 18.5003 4.05183 18.5252 4.01025 18.4693C4.02758 18.4152 4.01538 18.3599 4.01538 18.3054C4.01628 15.4762 4.01613 12.647 4.01613 9.81794C4.01613 9.617 4.02682 9.60224 4.22535 9.60133C4.85738 9.59862 5.4894 9.59953 6.12143 9.60118C6.19072 9.60133 6.26407 9.59591 6.31604 9.65857H6.31589Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3293 18.4851C11.2817 18.5081 11.2307 18.4991 11.1811 18.4992C10.5239 18.5008 9.86659 18.5015 9.20941 18.5023C9.18425 18.5023 9.15925 18.503 9.13409 18.5021C9.06521 18.4996 9.02961 18.4616 9.0273 18.3882C9.02685 18.3732 9.0273 18.3581 9.0273 18.343C9.0273 15.4933 9.0273 12.6435 9.02745 9.7938C9.02745 9.74877 9.03076 9.70373 9.03257 9.65854C9.08439 9.59663 9.15714 9.60115 9.22643 9.60085C9.86117 9.5992 10.4959 9.5992 11.1306 9.60085C11.2001 9.601 11.2725 9.59724 11.3245 9.65869C11.3265 9.72376 11.3302 9.78883 11.3302 9.8539C11.3305 11.8991 11.3304 13.9443 11.3308 15.9894C11.3308 16.0543 11.3231 16.1198 11.3406 16.1838C11.3701 16.2445 11.37 16.3097 11.37 16.375C11.3701 17.0111 11.3707 17.6472 11.3694 18.2831C11.3694 18.3522 11.378 18.4247 11.3293 18.4848V18.4851Z",
                fill: "#5887FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3247 9.65896C10.5607 9.65896 9.79675 9.65896 9.03263 9.65881C9.00822 9.44913 8.97343 9.24308 8.87477 9.05178C8.60861 8.53589 8.0406 8.24187 7.47124 8.32908C6.89584 8.41719 6.43884 8.87178 6.34515 9.45019C6.33401 9.51933 6.32557 9.58891 6.31593 9.65835C5.60302 9.65835 4.89011 9.65805 4.17719 9.6579C4.15716 9.6579 4.13682 9.65956 4.11694 9.65775C4.04795 9.65158 4.01226 9.67763 4.01753 9.75144C4.02039 9.79136 4.01783 9.83172 4.01783 9.87194C4.01783 12.6883 4.01783 15.5049 4.01753 18.3213C4.01753 18.371 4.01286 18.4207 4.01015 18.4698C3.99267 18.4308 4.00307 18.3903 4.00307 18.3511C4.00231 15.5011 4.00201 12.651 4.00277 9.801C4.00277 9.28525 4.06874 8.779 4.27389 8.30151C4.8172 7.03761 5.76675 6.26113 7.12404 6.04574C9.03022 5.74313 10.8088 6.97179 11.247 8.85401C11.3084 9.11806 11.3462 9.38617 11.3246 9.65896H11.3247Z",
                fill: "#FF4B4B"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9958 9.67086C19.816 9.6689 19.6361 9.66543 19.4563 9.66513C18.9213 9.66438 18.3864 9.66468 17.8514 9.66513C17.7967 9.66513 17.7413 9.65941 17.6878 9.67658C17.6785 9.52701 17.6637 9.37954 17.6171 9.23479C17.4522 8.72221 16.9529 8.33104 16.4019 8.3214C16.377 8.32094 16.3523 8.31612 16.3276 8.31326C16.3303 8.28344 16.3353 8.25361 16.3353 8.22379C16.335 7.48406 16.3343 6.74449 16.3337 6.00492C18.3515 5.97976 20.0257 7.66918 19.9958 9.67101V9.67086Z",
                fill: "#FC83FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.3293 18.4856C11.3293 17.7733 11.3293 17.061 11.3298 16.3489C11.3298 16.294 11.3215 16.2385 11.3406 16.1847C11.7856 16.1821 12.2305 16.1796 12.6755 16.177C12.7252 16.1797 12.775 16.1847 12.8248 16.1847C13.5446 16.1851 14.2643 16.1848 14.9841 16.1847C14.9864 16.2345 14.9908 16.2845 14.9908 16.3344C14.9912 16.9957 14.9911 17.6571 14.9911 18.3183C14.9911 18.3534 14.9899 18.3885 14.9908 18.4234C14.992 18.4725 14.9704 18.4983 14.92 18.4977C14.8849 18.4974 14.8498 18.4985 14.8148 18.4985C13.7076 18.4985 12.6005 18.4985 11.4932 18.4983C11.4384 18.4983 11.3828 18.5054 11.3295 18.4855L11.3293 18.4856Z",
                fill: "#FFAA00"
            })
        ]
    });
};
var $39ba9afef184103e$export$2e2bcd8739ae039 = $39ba9afef184103e$var$MuralIcon;

});

parcelRegister("2omOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $146e6df0b25543ec$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $146e6df0b25543ec$var$NotionIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.375",
                y: "0.375",
                width: "23.25",
                height: "23.25",
                rx: "5.625",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.75"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.72382 5.14736L14.0236 4.53432C15.0431 4.44687 15.305 4.50582 15.9461 4.97186L18.5955 6.83828C19.0325 7.15927 19.178 7.24672 19.178 7.59621V17.8325C19.178 18.474 18.945 18.8535 18.1295 18.9114L8.49127 19.4952C7.87928 19.5241 7.58784 19.4367 7.26729 19.0282L5.31628 16.4912C4.96634 16.0243 4.82129 15.6748 4.82129 15.2662V6.16734C4.82129 5.6428 5.05423 5.20541 5.72382 5.14736Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0236 4.53447L5.72382 5.14751C5.05423 5.20541 4.82129 5.64295 4.82129 6.16734V15.2662C4.82129 15.6746 4.96634 16.0241 5.31628 16.4912L7.26729 19.0281C7.58784 19.4365 7.87928 19.5241 8.49127 19.495L18.1296 18.9115C18.9446 18.8535 19.1781 18.474 19.1781 17.8326V7.59636C19.1781 7.26487 19.0472 7.16932 18.6617 6.88643L15.9461 4.97186C15.3052 4.50582 15.0431 4.44687 14.0236 4.53432V4.53447ZM8.70921 7.42882C7.92218 7.48177 7.74368 7.49377 7.29669 7.13032L6.16031 6.22644C6.04482 6.10944 6.10286 5.96349 6.39386 5.9344L14.3727 5.35136C15.0427 5.29286 15.3916 5.5264 15.6536 5.7304L17.0221 6.72188C17.0806 6.75143 17.2261 6.92588 17.051 6.92588L8.81121 7.42192L8.70921 7.42882ZM7.79168 17.7452V9.05539C7.79168 8.67589 7.90823 8.50085 8.25712 8.47145L17.721 7.91736C18.042 7.88841 18.1871 8.0924 18.1871 8.4713V17.1032C18.1871 17.4827 18.1286 17.8037 17.6046 17.8326L8.54827 18.3576C8.02433 18.3866 7.79183 18.2121 7.79183 17.7452H7.79168ZM16.7315 9.52128C16.7896 9.78377 16.7315 10.0463 16.469 10.0763L16.0325 10.1628V16.5786C15.6535 16.7826 15.3046 16.8992 15.013 16.8992C14.547 16.8992 14.4306 16.7532 14.0815 16.3161L11.2271 11.8252V16.1702L12.13 16.3746C12.13 16.3746 12.13 16.8996 11.4015 16.8996L9.39305 17.0162C9.33455 16.8992 9.39305 16.6077 9.5966 16.5497L10.1211 16.4042V10.6593L9.3932 10.6004C9.3347 10.3379 9.4802 9.95882 9.88819 9.92942L12.0432 9.78437L15.0131 14.3333V10.3089L14.2561 10.2219C14.1976 9.90047 14.4306 9.66692 14.7215 9.63842L16.7315 9.52128Z",
                fill: "#292A2E"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.8801 5.63103L13.9736 5.03323C14.9678 4.94796 15.2232 5.00544 15.8483 5.4599L18.4319 7.27992C18.858 7.59294 18.9999 7.67822 18.9999 8.01902V18.0009C18.9999 18.6265 18.7727 18.9965 17.9774 19.053L8.57877 19.6223C7.98199 19.6505 7.69779 19.5652 7.38521 19.1669L5.48269 16.6929C5.14144 16.2376 5 15.8968 5 15.4983V6.62566C5 6.11416 5.22716 5.68764 5.8801 5.63103Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.9736 5.03338L5.8801 5.63118C5.22716 5.68764 5 6.11431 5 6.62566V15.4983C5 15.8966 5.14144 16.2374 5.48269 16.6929L7.38521 19.1668C7.69779 19.5651 7.98199 19.6505 8.57877 19.6221L17.9776 19.0531C18.7723 18.9965 19 18.6265 19 18.001V8.01917C19 7.69591 18.8723 7.60274 18.4964 7.32688L15.8483 5.4599C15.2233 5.00544 14.9678 4.94796 13.9736 5.03323V5.03338ZM8.7913 7.85579C8.02382 7.90742 7.84976 7.91912 7.41388 7.56471L6.30574 6.68329C6.19312 6.5692 6.24972 6.42688 6.53349 6.39851L14.314 5.82996C14.9674 5.77291 15.3076 6.00066 15.5631 6.19958L16.8975 7.16642C16.9546 7.19524 17.0965 7.36535 16.9258 7.36535L8.89076 7.84906L8.7913 7.85579ZM7.89657 17.9157V9.44193C7.89657 9.07187 8.01022 8.90117 8.35044 8.8725L17.5791 8.33218C17.8922 8.30395 18.0336 8.50288 18.0336 8.87236V17.2897C18.0336 17.6598 17.9766 17.9728 17.4656 18.001L8.63435 18.513C8.12343 18.5412 7.89671 18.3711 7.89671 17.9157H7.89657ZM16.6142 9.89624C16.6708 10.1522 16.6142 10.4082 16.3582 10.4374L15.9326 10.5218V16.7782C15.563 16.9771 15.2227 17.0908 14.9384 17.0908C14.4839 17.0908 14.3704 16.9485 14.0301 16.5222L11.2466 12.1429V16.3799L12.1271 16.5793C12.1271 16.5793 12.1271 17.0912 11.4167 17.0912L9.45814 17.2049C9.40109 17.0908 9.45814 16.8066 9.65662 16.75L10.1681 16.6081V11.006L9.45828 10.9485C9.40124 10.6925 9.54312 10.3229 9.94097 10.2942L12.0424 10.1528L14.9385 14.5887V10.6643L14.2003 10.5795C14.1433 10.266 14.3704 10.0383 14.6542 10.0105L16.6142 9.89624Z",
                fill: "black"
            })
        ]
    });
};
var $146e6df0b25543ec$export$2e2bcd8739ae039 = $146e6df0b25543ec$var$NotionIcon;

});

parcelRegister("k6xhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d08bb2217642b2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $00d08bb2217642b2$var$OutlookCalendarIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7358 17.053C27.8457 16.7078 27.9334 16.3558 27.9983 15.9993C27.9984 15.821 27.903 15.6557 27.7486 15.5666L27.7389 15.5613L27.7358 15.5599L19.6078 10.9297C19.5728 10.907 19.5364 10.8861 19.4991 10.8674C19.1844 10.7114 18.8141 10.7114 18.4994 10.8674C18.4621 10.8861 18.4258 10.9069 18.3906 10.9297L10.2627 15.5599L10.2597 15.5613L10.2498 15.5666C10.0955 15.6557 10.0001 15.821 10.0002 15.9993C10.0652 16.3558 10.1529 16.7078 10.2627 17.053L18.8811 23.3563L27.7358 17.053Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.9988 7.74982H16.7491L15.2334 9.99982L16.7491 12.2496L21.9988 16.7493H26.4985V12.2496L21.9988 7.74982Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 7.74982H16.7493V12.2495H11.4996V7.74982Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 7.74982H26.4986V12.2495H21.9989V7.74982Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.999 16.7492L16.7493 12.2496H11.4996V16.7492L16.7493 21.249L24.8728 22.5749L21.999 16.7492Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7493 12.2496H21.9989V16.7492H16.7493V12.2496Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 16.7493H16.7493V21.2489H11.4996V16.7493Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 16.7493H26.4986V21.2489H21.9989V16.7493Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.1423 22.9124L10.2974 16.4628L10.6678 15.8111C10.6678 15.8111 18.7261 20.4008 18.849 20.4698C18.9509 20.5107 19.0654 20.5075 19.1648 20.4608C19.2795 20.3963 27.3632 15.7886 27.3632 15.7886L27.7352 16.4403L19.1423 22.9124Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7488 16.4321L27.7391 16.4381L27.7368 16.4396L19.6089 21.0699C19.2809 21.2813 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2843C27.8269 26.0732 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1777 27.9047 16.3431 27.7503 16.4321H27.7488Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9985 25.3738V24.8204L20.5117 20.5546L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.8262 26.0723 27.9993 25.7333 27.9993 25.3731L27.9985 25.3738Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9611 25.661L19.7543 20.9858L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.7443 26.1312 27.8954 25.911 27.9618 25.6603L27.9611 25.661Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.2621 16.4419V16.4344H10.2547L10.2321 16.4195C10.0866 16.3299 9.99823 16.1703 9.99965 15.9995V25.3754C9.99965 25.9916 10.5068 26.4988 11.1232 26.4988H26.8737C26.9673 26.4978 27.0606 26.4853 27.1511 26.4613C27.1982 26.4531 27.2437 26.4379 27.2862 26.4163C27.3021 26.4147 27.3174 26.4096 27.3311 26.4013C27.3925 26.3762 27.4505 26.3435 27.5036 26.3037L27.5336 26.2813L10.2621 16.4419Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4992 22.4993V10.2503C17.4976 9.70247 17.0473 9.25225 16.4995 9.25061H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V23.5019V23.4989H16.4995C17.0473 23.4973 17.4976 23.047 17.4992 22.4993Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7493 23.2491V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V24.2519V24.2489H15.7496C16.2973 24.2472 16.7477 23.797 16.7493 23.2491ZM16.7493 21.7493V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H15.7496C16.2973 22.7473 16.7477 22.2971 16.7493 21.7493ZM15.9993 21.7493V11.0002C15.9977 10.4525 15.5475 10.0022 14.9997 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H14.9997C15.5475 22.7473 15.9977 22.2971 15.9993 21.7493Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.90014 14.1005C7.16577 13.5344 7.59472 13.0606 8.13155 12.7401C8.72643 12.3995 9.40377 12.2299 10.089 12.2497C10.7236 12.2357 11.35 12.3966 11.8993 12.7146C12.4163 13.0225 12.8327 13.4741 13.0977 14.0143C13.3864 14.6095 13.5304 15.2645 13.5177 15.9259C13.5318 16.6172 13.3835 17.3023 13.085 17.9261C12.8142 18.4854 12.3852 18.9533 11.8513 19.2715C11.2806 19.5995 10.6308 19.7648 9.97268 19.7492C9.32435 19.7646 8.6841 19.6019 8.12185 19.2789C7.60083 18.9705 7.17941 18.5185 6.90843 17.977C6.61792 17.3903 6.47228 16.7425 6.48395 16.0879C6.47108 15.4025 6.61366 14.7231 6.9009 14.1005H6.90014ZM8.2125 17.2938C8.35421 17.6517 8.59454 17.9623 8.90555 18.1892C9.22203 18.4109 9.60145 18.5252 9.98763 18.5155C10.3991 18.5318 10.8048 18.4138 11.1433 18.1795C11.4505 17.9526 11.6845 17.6404 11.8161 17.2818C11.964 16.8821 12.0369 16.4585 12.0313 16.0324C12.0359 15.6026 11.9674 15.1749 11.8289 14.768C11.7067 14.4017 11.4811 14.0783 11.1793 13.8374C10.8498 13.5913 10.4452 13.4662 10.0342 13.4834C9.63963 13.4731 9.2517 13.5881 8.9265 13.8118C8.6097 14.0395 8.36403 14.3527 8.2185 14.7148C7.89668 15.5438 7.89483 16.4636 8.21326 17.2938H8.2125Z",
                fill: "white"
            })
        ]
    });
};
var $00d08bb2217642b2$export$2e2bcd8739ae039 = $00d08bb2217642b2$var$OutlookCalendarIcon;

});

parcelRegister("i3woo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b09cd2aa9525d4b4$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $b09cd2aa9525d4b4$var$OutlookMailIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-76.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.1963 5.81042H9.67074C9.33358 5.81042 9.05615 6.08496 9.05615 6.4186V7.10989L13.2978 8.40948L17.8109 7.10989V6.4186C17.8109 6.08496 17.5335 5.81042 17.1963 5.81042Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5332 12.4833C18.5973 12.2839 18.6485 12.0806 18.6864 11.8747C18.6864 11.7717 18.6308 11.6762 18.5406 11.6247L18.535 11.6217L18.5332 11.6209L13.7889 8.94645C13.7685 8.93335 13.7473 8.92131 13.7255 8.91047C13.5418 8.82037 13.3257 8.82037 13.142 8.91047C13.1202 8.92131 13.099 8.93328 13.0785 8.94645L8.33435 11.6209L8.33257 11.6217L8.32684 11.6247C8.23674 11.6762 8.18109 11.7717 8.18115 11.8747C8.21904 12.0806 8.27023 12.2839 8.33435 12.4833L13.3648 16.124L18.5332 12.4833Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1842 7.10992H12.1201L11.2354 8.40952L12.1201 9.70898L15.1842 12.308H17.8106V9.70898L15.1842 7.10992Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 7.10999H12.1203V9.70898H9.05615V7.10999Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 7.10999H17.811V9.70898H15.1846V7.10999Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.1845 12.308L12.1203 9.70898H9.05615V12.308L12.1203 14.907L16.8619 15.6729L15.1845 12.308Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.1201 9.70898H15.1843V12.308H12.1201V9.70898Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.05615 12.3081H12.1203V14.9071H9.05615V12.3081Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.1846 12.3081H17.811V14.9071H15.1846V12.3081Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.5172 15.8678L8.35449 12.1426L8.57073 11.7662C8.57073 11.7662 13.2742 14.4171 13.346 14.457C13.4054 14.4806 13.4723 14.4788 13.5303 14.4518C13.5972 14.4145 18.3156 11.7532 18.3156 11.7532L18.5327 12.1296L13.5172 15.8678Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.5407 12.1248L18.535 12.1282L18.5337 12.1291L13.7895 14.8035C13.5981 14.9257 13.3556 14.9406 13.1504 14.8429L14.8028 17.0352L18.4159 17.8136V17.8154C18.5863 17.6935 18.6874 17.4976 18.6873 17.2895V11.8749C18.6874 11.9778 18.6317 12.0734 18.5416 12.1248H18.5407Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6864 17.2894V16.9698L14.3164 14.5059L13.7889 14.803C13.5976 14.9251 13.3551 14.9401 13.1499 14.8424L14.8023 17.0347L18.4154 17.8131V17.8149C18.5858 17.6929 18.6868 17.497 18.6868 17.289L18.6864 17.2894Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M18.6645 17.4555L13.8743 14.7551L13.7889 14.8032C13.5976 14.9253 13.3551 14.9403 13.1499 14.8426L14.8023 17.0349L18.4154 17.8133V17.815C18.538 17.7271 18.6262 17.5999 18.6649 17.4551L18.6645 17.4555Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.33388 12.1304V12.1261H8.32955L8.31637 12.1175C8.23142 12.0657 8.17985 11.9736 8.18067 11.8749V17.2904C8.18067 17.6463 8.4767 17.9393 8.83646 17.9393H18.0299C18.0845 17.9387 18.1389 17.9314 18.1918 17.9176C18.2192 17.9129 18.2458 17.9041 18.2706 17.8916C18.2799 17.8907 18.2888 17.8877 18.2968 17.8829C18.3326 17.8684 18.3665 17.8495 18.3975 17.8266L18.415 17.8136L8.33388 12.1304Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.5581 15.6292V8.55423C12.5571 8.2378 12.2943 7.97775 11.9745 7.97681H9.06976V11.2065L8.33387 11.6215L8.33215 11.6223L8.32648 11.6254C8.23632 11.6769 8.18066 11.7724 8.18066 11.8753V16.2083V16.2065H11.9745C12.2943 16.2057 12.5571 15.9456 12.5581 15.6292Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1204 16.0622V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V16.6414V16.6397H11.5368C11.8566 16.6387 12.1194 16.3787 12.1204 16.0622ZM12.1204 15.1959V8.98728C12.1194 8.6709 11.8566 8.41086 11.5368 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.5368C11.8566 15.7724 12.1194 15.5123 12.1204 15.1959ZM11.6826 15.1959V8.98728C11.6816 8.6709 11.4189 8.41086 11.0991 8.40985H9.06976V11.2064L8.33387 11.6214L8.33215 11.6223L8.32648 11.6253C8.23632 11.6768 8.18066 11.7723 8.18066 11.8752V15.775V15.7733H11.0991C11.4189 15.7724 11.6816 15.5123 11.6826 15.1959Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M5.26223 8.40955H11.0985C11.4186 8.40955 11.6821 8.67016 11.6821 8.98691V14.7624C11.6821 15.0791 11.4186 15.3398 11.0985 15.3398H5.26223C4.94213 15.3398 4.67871 15.0791 4.67871 14.7624V8.98691C4.67871 8.67016 4.94213 8.40955 5.26223 8.40955Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.37132 10.7781C6.52637 10.4511 6.77674 10.1774 7.09008 9.99232C7.4373 9.7956 7.83266 9.69762 8.2326 9.70902C8.603 9.70096 8.96862 9.7939 9.28929 9.97757C9.59104 10.1554 9.83409 10.4163 9.98876 10.7283C10.1572 11.0721 10.2413 11.4504 10.2339 11.8324C10.2421 12.2317 10.1556 12.6274 9.98137 12.9877C9.82327 13.3108 9.5729 13.581 9.26127 13.7648C8.92812 13.9543 8.54887 14.0498 8.16472 14.0407C7.7863 14.0496 7.41259 13.9557 7.08441 13.7691C6.7803 13.591 6.53433 13.3299 6.37616 13.0171C6.20659 12.6783 6.12158 12.304 6.1284 11.926C6.12088 11.5301 6.20411 11.1377 6.37176 10.7781H6.37132ZM7.13733 12.6225C7.22004 12.8292 7.36032 13.0086 7.54185 13.1397C7.72658 13.2677 7.94804 13.3338 8.17345 13.3282C8.41363 13.3375 8.65044 13.2694 8.84802 13.1341C9.02733 13.003 9.16391 12.8227 9.2407 12.6156C9.32705 12.3847 9.36958 12.14 9.36633 11.8939C9.36901 11.6457 9.32902 11.3986 9.24815 11.1636C9.17684 10.952 9.04516 10.7653 8.86903 10.6261C8.67667 10.4839 8.4405 10.4117 8.20064 10.4216C7.97032 10.4157 7.7439 10.4821 7.55408 10.6113C7.36917 10.7428 7.22577 10.9237 7.14083 11.1329C6.95299 11.6117 6.95191 12.143 7.13777 12.6225H7.13733Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7361 17.053C27.8459 16.7078 27.9336 16.3558 27.9985 15.9993C27.9986 15.821 27.9033 15.6557 27.7488 15.5666L27.7391 15.5613L27.7361 15.5599L19.608 10.9297C19.573 10.907 19.5367 10.8861 19.4994 10.8674C19.1846 10.7114 18.8144 10.7114 18.4997 10.8674C18.4623 10.8861 18.426 10.9069 18.3909 10.9297L10.263 15.5599L10.2599 15.5613L10.2501 15.5666C10.0957 15.6557 10.0004 15.821 10.0005 15.9993C10.0654 16.3558 10.1531 16.7078 10.263 17.053L18.8814 23.3563L27.7361 17.053Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.999 7.74976H16.7494L15.2336 9.99976L16.7494 12.2495L21.999 16.7492H26.4987V12.2495L21.999 7.74976Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4995 7.74976H16.7492V12.2494H11.4995V7.74976Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.999 7.74976H26.4987V12.2494H21.999V7.74976Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M21.9989 16.7493L16.7492 12.2496H11.4995V16.7493L16.7492 21.2491L24.8726 22.575L21.9989 16.7493Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7493 12.2496H21.9989V16.7493H16.7493V12.2496Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4995 16.7493H16.7492V21.2489H11.4995V16.7493Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.999 16.7493H26.4987V21.2489H21.999V16.7493Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.1423 22.9124L10.2974 16.4629L10.6678 15.8112C10.6678 15.8112 18.7261 20.4008 18.849 20.4699C18.9509 20.5108 19.0654 20.5075 19.1648 20.4608C19.2795 20.3964 27.3632 15.7887 27.3632 15.7887L27.7352 16.4404L19.1423 22.9124Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.7488 16.4322L27.7391 16.4382L27.7368 16.4397L19.6089 21.0699C19.2809 21.2814 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2844C27.8269 26.0733 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1778 27.9047 16.3431 27.7503 16.4322H27.7488Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9985 25.3739V24.8205L20.5117 20.5547L19.608 21.0692C19.2802 21.2806 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2836C27.8262 26.0724 27.9993 25.7333 27.9993 25.3731L27.9985 25.3739Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M27.9611 25.6612L19.7543 20.986L19.608 21.0692C19.2802 21.2806 18.8648 21.3066 18.5132 21.1374L21.3442 24.933L27.5343 26.2806V26.2836C27.7443 26.1313 27.8954 25.9111 27.9618 25.6604L27.9611 25.6612Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.262 16.442V16.4345H10.2546L10.232 16.4195C10.0865 16.3299 9.99811 16.1703 9.99953 15.9995V25.3754C9.99953 25.9917 10.5067 26.4989 11.1231 26.4989H26.8736C26.9672 26.4979 27.0605 26.4853 27.151 26.4613C27.198 26.4531 27.2435 26.438 27.2861 26.4164C27.302 26.4147 27.3173 26.4096 27.331 26.4013C27.3923 26.3762 27.4504 26.3435 27.5035 26.3038L27.5335 26.2813L10.262 16.442Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4991 22.4994V10.2504C17.4974 9.70259 17.0472 9.25237 16.4994 9.25073H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V23.502V23.499H16.4994C17.0472 23.4975 17.4974 23.0471 17.4991 22.4994Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7492 23.2493V11.0003C16.7475 10.4526 16.2972 10.0024 15.7495 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V24.252V24.249H15.7495C16.2972 24.2473 16.7475 23.7971 16.7492 23.2493ZM16.7492 21.7494V11.0003C16.7475 10.4526 16.2972 10.0024 15.7495 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V22.752V22.7491H15.7495C16.2972 22.7474 16.7475 22.2972 16.7492 21.7494ZM15.9992 21.7494V11.0003C15.9975 10.4526 15.5473 10.0024 14.9996 10.0006H11.5227V14.8423L10.262 15.5608L10.259 15.5623L10.2493 15.5675C10.0949 15.6568 9.99951 15.822 9.99951 16.0002V22.752V22.7491H14.9996C15.5473 22.7474 15.9975 22.2972 15.9992 21.7494Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M6.90014 14.1006C7.16577 13.5345 7.59472 13.0607 8.13155 12.7402C8.72643 12.3996 9.40377 12.23 10.089 12.2497C10.7236 12.2358 11.35 12.3967 11.8993 12.7147C12.4163 13.0225 12.8327 13.4742 13.0977 14.0144C13.3864 14.6096 13.5304 15.2646 13.5177 15.926C13.5318 16.6173 13.3835 17.3024 13.085 17.9262C12.8142 18.4855 12.3852 18.9534 11.8513 19.2716C11.2806 19.5996 10.6308 19.7649 9.97268 19.7493C9.32435 19.7647 8.6841 19.602 8.12185 19.279C7.60083 18.9706 7.17941 18.5185 6.90843 17.9771C6.61792 17.3904 6.47228 16.7425 6.48395 16.088C6.47108 15.4026 6.61366 14.7231 6.9009 14.1006H6.90014ZM8.2125 17.2939C8.35421 17.6518 8.59454 17.9624 8.90555 18.1893C9.22203 18.411 9.60145 18.5253 9.98763 18.5156C10.3991 18.5318 10.8048 18.4139 11.1433 18.1796C11.4505 17.9527 11.6845 17.6404 11.8161 17.2819C11.964 16.8822 12.0369 16.4586 12.0313 16.0324C12.0359 15.6026 11.9674 15.175 11.8289 14.7681C11.7067 14.4018 11.4811 14.0784 11.1793 13.8374C10.8498 13.5913 10.4452 13.4663 10.0342 13.4834C9.63963 13.4732 9.2517 13.5882 8.9265 13.8119C8.6097 14.0396 8.36403 14.3528 8.2185 14.7148C7.89668 15.5438 7.89483 16.4637 8.21326 17.2939H8.2125Z",
                fill: "white"
            })
        ]
    });
};
var $b09cd2aa9525d4b4$export$2e2bcd8739ae039 = $b09cd2aa9525d4b4$var$OutlookMailIcon;

});

parcelRegister("1lwoS", function(module, exports) {

$parcel$export(module.exports, "default", () => $854c18960b2d6ffb$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $854c18960b2d6ffb$var$PipedriveIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-635.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#017737"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.2336 10.1635C10.2336 11.5838 10.9541 13.1159 12.5396 13.1159C13.7154 13.1159 14.9043 12.198 14.9043 10.1427C14.9043 8.34075 13.9697 7.13106 12.5787 7.13106C11.4453 7.13106 10.2336 7.92728 10.2336 10.1635ZM13.1373 4.5C15.9802 4.5 17.8917 6.75159 17.8917 10.1032C17.8917 13.4022 15.878 15.7053 12.9993 15.7053C11.6268 15.7053 10.7476 15.1175 10.2879 14.6919C10.2912 14.7928 10.2933 14.9058 10.2933 15.0264V19.5H7.34834V7.58072C7.34834 7.40743 7.29292 7.3526 7.12122 7.3526H6.1084V4.74238H8.5796C9.71739 4.74238 10.0086 5.32145 10.0641 5.76782C10.5259 5.25017 11.4833 4.5 13.1373 4.5Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M10.4002 10.0411C10.4002 11.556 11.1687 13.1903 12.8599 13.1903C14.1142 13.1903 15.3823 12.2112 15.3823 10.0189C15.3823 8.0968 14.3854 6.80647 12.9017 6.80647C11.6927 6.80647 10.4002 7.65577 10.4002 10.0411ZM13.4975 4C16.5299 4 18.5688 6.4017 18.5688 9.97675C18.5688 13.4957 16.4209 15.9523 13.3503 15.9523C11.8862 15.9523 10.9485 15.3253 10.4582 14.8714C10.4616 14.979 10.4639 15.0995 10.4639 15.2282V20H7.32261V7.2861C7.32261 7.10126 7.26349 7.04278 7.08034 7.04278H6V4.25854H8.63594C9.84959 4.25854 10.1602 4.87621 10.2194 5.35234C10.712 4.80018 11.7332 4 13.4975 4Z",
            fill: "#017737"
        })
    });
};
var $854c18960b2d6ffb$export$2e2bcd8739ae039 = $854c18960b2d6ffb$var$PipedriveIcon;

});

parcelRegister("gLGvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c002cdcd98eda8d3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $c002cdcd98eda8d3$var$SalesforceIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.385264",
                y: "0.385264",
                width: "23.2295",
                height: "23.2295",
                rx: "5.61474",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "5",
                width: "18",
                height: "14",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M3 5.71326H21V18.2868H3V5.71326Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                mask: "url(#mask0_719_13847)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.4738 7.08983C11.0548 6.48497 11.8635 6.11041 12.7569 6.11041C13.9481 6.11041 14.9804 6.77218 15.5363 7.75821C16.0297 7.53763 16.5642 7.42374 17.1047 7.42402C19.2488 7.42402 20.9892 9.17769 20.9892 11.3417C20.9892 13.5056 19.2488 15.2593 17.1047 15.2593C16.8426 15.2593 16.5872 15.233 16.337 15.1832C15.8506 16.0501 14.9209 16.6391 13.862 16.6391C13.431 16.6399 13.0054 16.5422 12.6179 16.3532C12.1249 17.5113 10.9767 18.3253 9.63998 18.3253C8.24366 18.3253 7.0591 17.4451 6.60248 16.2076C6.39925 16.2505 6.1921 16.2721 5.98439 16.2719C4.32336 16.2719 2.97998 14.9087 2.97998 13.2344C2.97998 12.1094 3.58483 11.13 4.48219 10.6006C4.29181 10.1621 4.19382 9.689 4.19432 9.21091C4.19432 7.27856 5.7627 5.7168 7.69505 5.7168C8.82667 5.7168 9.83917 6.25614 10.4745 7.09327",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6037 12.2516C5.59239 12.2812 5.60774 12.2873 5.61138 12.2925C5.64519 12.317 5.67954 12.3348 5.71395 12.3547C5.89792 12.452 6.07131 12.4804 6.25263 12.4804C6.62189 12.4804 6.85153 12.2839 6.85153 11.9675V11.9613C6.85153 11.6688 6.59211 11.5623 6.34991 11.4862L6.31821 11.4759C6.1349 11.4165 5.97674 11.3647 5.97674 11.2443V11.2381C5.97674 11.1349 6.06939 11.0588 6.21233 11.0588C6.37115 11.0588 6.56042 11.1117 6.68152 11.1786C6.68152 11.1786 6.71739 11.2018 6.73042 11.1671C6.7375 11.1484 6.79925 10.9832 6.80586 10.9646C6.81288 10.9453 6.80057 10.9306 6.78793 10.9231C6.64896 10.8384 6.45705 10.7808 6.25852 10.7808L6.22166 10.7809C5.8835 10.7809 5.64725 10.9854 5.64725 11.2779V11.2842C5.64725 11.5926 5.90798 11.6932 6.15151 11.7627L6.19069 11.7748C6.36804 11.8294 6.52157 11.8768 6.52157 12.0012V12.0074C6.52157 12.1219 6.42164 12.2072 6.2615 12.2072C6.19922 12.2072 6.00076 12.2062 5.78569 12.0703C5.75968 12.0551 5.74486 12.0442 5.72481 12.0319C5.71422 12.0255 5.68775 12.0139 5.67623 12.0486L5.60344 12.2511M11.0101 12.2511C10.9987 12.2806 11.0141 12.2868 11.0179 12.292C11.0515 12.3165 11.086 12.3342 11.1204 12.3541C11.3044 12.4514 11.4778 12.4799 11.6591 12.4799C12.0284 12.4799 12.258 12.2833 12.258 11.967V11.9608C12.258 11.6683 11.9993 11.5618 11.7564 11.4856L11.7247 11.4754C11.5414 11.416 11.3832 11.3642 11.3832 11.2438V11.2376C11.3832 11.1344 11.4759 11.0583 11.6188 11.0583C11.7776 11.0583 11.9662 11.1112 12.088 11.1781C12.088 11.1781 12.1239 11.2012 12.137 11.1666C12.144 11.1479 12.2058 10.9826 12.2118 10.9641C12.2188 10.9447 12.2065 10.9301 12.1939 10.9226C12.0549 10.8378 11.863 10.7803 11.6645 10.7803L11.6275 10.7804C11.2894 10.7804 11.0531 10.9849 11.0531 11.2774V11.2837C11.0531 11.5921 11.3139 11.6926 11.5574 11.7621L11.5965 11.7743C11.7745 11.8288 11.9274 11.8762 11.9274 12.0006V12.0069C11.9274 12.1213 11.8275 12.2067 11.6673 12.2067C11.6049 12.2067 11.4059 12.2056 11.1915 12.0697C11.1655 12.0546 11.1503 12.0441 11.1306 12.0314C11.1239 12.0272 11.0927 12.015 11.0821 12.0481L11.0093 12.2506M14.7019 11.6312C14.7019 11.8098 14.6686 11.9508 14.6033 12.0507C14.5382 12.1493 14.4398 12.1976 14.3029 12.1976C14.1659 12.1976 14.0679 12.1497 14.0037 12.0514C13.9391 11.9521 13.9065 11.8105 13.9065 11.6318C13.9065 11.4532 13.9393 11.3129 14.0037 11.2143C14.0678 11.1163 14.1652 11.0693 14.3029 11.0693C14.4405 11.0693 14.5385 11.1168 14.6033 11.2143C14.669 11.3129 14.7019 11.4532 14.7019 11.6318M15.0103 11.3003C14.9799 11.1977 14.9329 11.1077 14.87 11.0323C14.8071 10.9568 14.7277 10.8959 14.6331 10.8523C14.5391 10.8083 14.4279 10.7861 14.3022 10.7861C14.1765 10.7861 14.066 10.8084 13.9713 10.8523C13.8773 10.8962 13.7973 10.9568 13.7344 11.0323C13.6717 11.1077 13.6246 11.1977 13.5941 11.3003C13.564 11.4022 13.5487 11.5134 13.5487 11.6318C13.5487 11.7503 13.564 11.8615 13.5941 11.9634C13.6244 12.0659 13.6715 12.1559 13.7344 12.2314C13.7973 12.3068 13.8773 12.3671 13.9713 12.4101C14.066 12.4529 14.1771 12.4748 14.3022 12.4748C14.4273 12.4748 14.5385 12.4529 14.6324 12.4101C14.7264 12.3672 14.8065 12.3068 14.8693 12.2314C14.9321 12.1559 14.9792 12.0659 15.0096 11.9634C15.0397 11.8615 15.055 11.7503 15.055 11.6318C15.055 11.514 15.0397 11.4022 15.0096 11.3003M17.5442 12.1473C17.5341 12.1174 17.5048 12.1287 17.5048 12.1287C17.46 12.1458 17.4122 12.1617 17.3612 12.1696C17.3099 12.1777 17.2527 12.1818 17.1925 12.1818C17.0436 12.1818 16.9244 12.1374 16.8397 12.0494C16.7544 11.9614 16.7067 11.8198 16.7074 11.6279C16.7078 11.4532 16.7501 11.3221 16.8258 11.2215C16.9006 11.1223 17.0158 11.0707 17.168 11.0707C17.295 11.0707 17.3923 11.0854 17.4942 11.1173C17.4942 11.1173 17.5184 11.1278 17.53 11.096C17.557 11.0212 17.577 10.9676 17.6061 10.8856C17.6143 10.8621 17.5942 10.8521 17.5868 10.8493C17.5468 10.8337 17.4525 10.8081 17.381 10.7973C17.3142 10.7871 17.2367 10.7818 17.1494 10.7818C17.0197 10.7818 16.9045 10.804 16.8059 10.8479C16.7073 10.8918 16.6239 10.9525 16.5578 11.0279C16.4916 11.1033 16.4413 11.1933 16.4075 11.2959C16.3741 11.3978 16.3572 11.5097 16.3572 11.6281C16.3572 11.8836 16.4261 12.0907 16.5624 12.2422C16.6987 12.3944 16.9039 12.4712 17.1712 12.4712C17.3294 12.4712 17.4915 12.4393 17.608 12.3931C17.608 12.3931 17.6302 12.3824 17.6206 12.3565L17.5445 12.1473M18.0838 11.4591C18.0985 11.3598 18.1257 11.2771 18.1685 11.2129C18.2325 11.115 18.33 11.0614 18.467 11.0614C18.6039 11.0614 18.6946 11.1153 18.7595 11.2129C18.8025 11.2775 18.8213 11.3632 18.8283 11.4591L18.0805 11.459L18.0838 11.4591ZM19.1228 11.2407C19.0965 11.1421 19.0314 11.0422 18.9891 10.9965C18.9216 10.9244 18.8561 10.8734 18.7906 10.8457C18.696 10.8054 18.5942 10.7848 18.4914 10.785C18.3611 10.785 18.2426 10.807 18.1467 10.8518C18.0507 10.8969 17.97 10.9584 17.9064 11.0351C17.843 11.1119 17.7953 11.2025 17.7648 11.3064C17.7344 11.409 17.719 11.5215 17.719 11.6393C17.719 11.7598 17.735 11.8716 17.7663 11.9728C17.798 12.0748 17.8491 12.1641 17.9179 12.2382C17.9867 12.313 18.0747 12.3712 18.1806 12.4123C18.2858 12.4529 18.4135 12.4741 18.5598 12.4736C18.8616 12.4726 19.0204 12.4054 19.0852 12.369C19.0968 12.3626 19.1077 12.3514 19.0941 12.3191L19.0259 12.1279C19.0155 12.0994 18.9866 12.1097 18.9866 12.1097C18.9119 12.1376 18.806 12.1878 18.5578 12.1871C18.3957 12.1869 18.2759 12.139 18.2005 12.064C18.1237 11.9873 18.0853 11.8754 18.0794 11.7166L19.1249 11.7174C19.1249 11.7174 19.1525 11.7171 19.1553 11.6903C19.1564 11.6791 19.1911 11.4759 19.1242 11.2409L19.1228 11.2407ZM9.7257 11.4591C9.74046 11.3598 9.76772 11.2771 9.81041 11.2129C9.87447 11.115 9.97188 11.0614 10.1089 11.0614C10.2458 11.0614 10.3365 11.1153 10.4014 11.2129C10.4443 11.2775 10.4631 11.3632 10.4702 11.4591L9.72239 11.459L9.7257 11.4591ZM10.7647 11.2407C10.7385 11.1421 10.6733 11.0422 10.631 10.9965C10.5635 10.9244 10.498 10.8734 10.4325 10.8457C10.3379 10.8054 10.2361 10.7848 10.1333 10.785C10.003 10.785 9.88453 10.807 9.78857 10.8518C9.69261 10.8969 9.61188 10.9584 9.54835 11.0351C9.48502 11.1119 9.43717 11.2025 9.40673 11.3064C9.37636 11.409 9.36107 11.5215 9.36107 11.6393C9.36107 11.7598 9.37689 11.8716 9.40845 11.9728C9.44008 12.0748 9.49117 12.1641 9.55933 12.2382C9.62816 12.313 9.71617 12.3712 9.82206 12.4123C9.92728 12.4529 10.0543 12.4741 10.2012 12.4736C10.503 12.4726 10.6618 12.4054 10.7267 12.369C10.7382 12.3626 10.7492 12.3514 10.7355 12.3191L10.6673 12.1279C10.6568 12.0994 10.628 12.1097 10.628 12.1097C10.5532 12.1376 10.4473 12.1878 10.1991 12.1871C10.0377 12.1869 9.91722 12.139 9.84178 12.064C9.76501 11.9873 9.72663 11.8754 9.72067 11.7166L10.7663 11.7174C10.7663 11.7174 10.7938 11.7171 10.7966 11.6903C10.7978 11.6791 10.8324 11.4759 10.7654 11.2409L10.7647 11.2407ZM7.46908 12.1407C7.42812 12.108 7.42243 12.1 7.40886 12.0788C7.38815 12.0468 7.37756 12.0014 7.37756 11.9431C7.37756 11.8518 7.408 11.7856 7.47087 11.7413C7.47021 11.7414 7.56087 11.6632 7.77396 11.6658C7.86881 11.6675 7.96343 11.6756 8.05719 11.69V12.1645H8.05733C8.05733 12.1645 7.92497 12.193 7.77542 12.202C7.56299 12.2148 7.46902 12.1409 7.46968 12.1411L7.46908 12.1407ZM7.88467 11.4062C7.84232 11.4031 7.78739 11.4015 7.72188 11.4015C7.63254 11.4015 7.54585 11.4127 7.46511 11.4345C7.38372 11.4565 7.31026 11.4905 7.24739 11.5357C7.18435 11.5807 7.1325 11.6396 7.09585 11.7078C7.05886 11.7766 7.04 11.8574 7.04 11.9487C7.04 12.0413 7.05608 12.1214 7.08784 12.1869C7.11897 12.2519 7.16583 12.3081 7.22417 12.3504C7.2822 12.3926 7.35387 12.4238 7.43659 12.4424C7.51865 12.4611 7.6113 12.4706 7.71321 12.4706C7.82042 12.4706 7.92696 12.4616 8.03019 12.4441C8.11812 12.429 8.20571 12.4119 8.29292 12.3931C8.32772 12.3851 8.36637 12.3745 8.36637 12.3745C8.39218 12.368 8.3902 12.3404 8.3902 12.3404L8.3896 11.3874C8.3896 11.1783 8.33375 11.0228 8.2235 10.9269C8.11364 10.8309 7.95283 10.7826 7.74438 10.7826C7.66629 10.7826 7.53989 10.7932 7.46445 10.8083C7.46445 10.8083 7.23681 10.8525 7.14283 10.9261C7.14283 10.9261 7.12219 10.9388 7.13344 10.9676L7.20756 11.1661C7.21675 11.1919 7.24183 11.1831 7.24183 11.1831C7.24183 11.1831 7.24971 11.18 7.25897 11.1745C7.45949 11.0653 7.71361 11.0686 7.71361 11.0686C7.82611 11.0686 7.91346 11.0914 7.97169 11.1361C8.02867 11.1798 8.05772 11.246 8.05772 11.3849V11.4291C7.96839 11.4161 7.88567 11.4086 7.88567 11.4086L7.88467 11.4062ZM16.2891 10.8682C16.2906 10.8647 16.2914 10.8609 16.2914 10.8571C16.2914 10.8533 16.2907 10.8495 16.2892 10.846C16.2878 10.8425 16.2856 10.8394 16.2829 10.8367C16.2802 10.834 16.2769 10.832 16.2734 10.8306C16.2556 10.8238 16.1669 10.8051 16.0987 10.8009C15.9677 10.7926 15.8949 10.8148 15.8294 10.8441C15.7646 10.8733 15.693 10.9202 15.6533 10.9745L15.6532 10.8474C15.6532 10.83 15.6408 10.8159 15.6232 10.8159H15.3559C15.3385 10.8159 15.326 10.83 15.326 10.8474V12.4026C15.326 12.411 15.3293 12.419 15.3353 12.425C15.3412 12.4309 15.3492 12.4343 15.3577 12.4343H15.6316C15.64 12.4343 15.6481 12.4309 15.654 12.425C15.6599 12.419 15.6633 12.411 15.6633 12.4026V11.6217C15.6633 11.5171 15.6748 11.4133 15.6977 11.3477C15.7204 11.2829 15.7511 11.2313 15.7891 11.1942C15.8252 11.1584 15.8695 11.1319 15.9181 11.1168C15.9637 11.1037 16.0109 11.0971 16.0584 11.0971C16.113 11.0971 16.1729 11.1111 16.1729 11.1111C16.193 11.1133 16.2042 11.101 16.211 11.0829C16.2289 11.0352 16.2798 10.8923 16.2897 10.8639",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.1503C13.6961 10.14 13.6616 10.1319 13.6267 10.1258C13.5799 10.118 13.5324 10.1143 13.4849 10.1148C13.2961 10.1148 13.1472 10.1681 13.0427 10.2735C12.939 10.378 12.8684 10.5373 12.833 10.7469L12.8202 10.8177H12.5832C12.5832 10.8177 12.5543 10.8165 12.5482 10.848L12.5093 11.0651C12.5066 11.0859 12.5155 11.0988 12.5433 11.0987H12.774L12.5399 12.4052C12.5216 12.5104 12.5006 12.597 12.4774 12.6626C12.4545 12.7273 12.4321 12.7758 12.4046 12.811C12.3779 12.8451 12.3527 12.8702 12.309 12.8848C12.273 12.8969 12.2316 12.9025 12.1862 12.9025C12.1609 12.9025 12.1273 12.8982 12.1025 12.8933C12.0777 12.8884 12.0648 12.8828 12.0462 12.875C12.0462 12.875 12.0191 12.8647 12.0085 12.8918C11.9998 12.914 11.9383 13.0831 11.931 13.104C11.9236 13.1246 11.934 13.1409 11.9471 13.1456C11.9778 13.1566 12.0007 13.1636 12.0425 13.1735C12.1006 13.1872 12.1496 13.188 12.1954 13.188C12.2915 13.188 12.3791 13.1745 12.4517 13.1483C12.5247 13.1219 12.5883 13.0759 12.6446 13.0137C12.7054 12.9465 12.7436 12.8761 12.7802 12.7802C12.8164 12.6851 12.8473 12.567 12.8719 12.4294L13.1071 11.0987H13.451C13.451 11.0987 13.48 11.0998 13.486 11.0683L13.5249 10.8513C13.5276 10.8305 13.5187 10.8175 13.4908 10.8177H13.1571C13.1587 10.8101 13.1739 10.6927 13.2122 10.5822C13.2286 10.535 13.2593 10.497 13.2854 10.4708C13.3098 10.4459 13.3397 10.4273 13.3728 10.4164C13.4091 10.4052 13.4469 10.3998 13.4849 10.4003C13.5163 10.4003 13.5471 10.4041 13.5706 10.4089C13.603 10.4158 13.6156 10.4195 13.624 10.422C13.6581 10.4324 13.6626 10.4223 13.6693 10.4058L13.7491 10.1867C13.7573 10.1631 13.7373 10.1532 13.7299 10.1503ZM9.0662 12.408C9.0662 12.4255 9.05376 12.4397 9.03629 12.4397H8.75947C8.74193 12.4397 8.72949 12.4255 8.72949 12.408V10.18C8.72949 10.1626 8.74193 10.1485 8.75947 10.1485H9.03629C9.05376 10.1485 9.0662 10.1626 9.0662 10.18V12.408Z",
                fill: "#FFFFFE"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_7_630",
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M3 6H21V18.5735H3V6Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                mask: "url(#mask0_7_630)",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.474 7.37645C11.055 6.77159 11.8637 6.39704 12.7571 6.39704C13.9483 6.39704 14.9806 7.0588 15.5365 8.04483C16.0299 7.82425 16.5644 7.71036 17.1049 7.71064C19.249 7.71064 20.9894 9.46431 20.9894 11.6283C20.9894 13.7923 19.249 15.5459 17.1049 15.5459C16.8428 15.5459 16.5874 15.5196 16.3372 15.4698C15.8508 16.3367 14.921 16.9257 13.8622 16.9257C13.4311 16.9266 13.0056 16.8288 12.6181 16.6398C12.1251 17.7979 10.9769 18.6119 9.64016 18.6119C8.24384 18.6119 7.05928 17.7317 6.60266 16.4942C6.39943 16.5371 6.19228 16.5587 5.98458 16.5586C4.32355 16.5586 2.98016 15.1953 2.98016 13.5211C2.98016 12.3961 3.58502 11.4167 4.48237 10.8872C4.292 10.4487 4.194 9.97562 4.1945 9.49754C4.1945 7.56518 5.76288 6.00342 7.69524 6.00342C8.82686 6.00342 9.83935 6.54276 10.4746 7.37989",
                    fill: "#00A1E0"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.6034 12.5383C5.59208 12.5678 5.60743 12.5739 5.61107 12.5792C5.64489 12.6036 5.67924 12.6214 5.71365 12.6413C5.89762 12.7386 6.071 12.767 6.25232 12.767C6.62159 12.767 6.85122 12.5705 6.85122 12.2542V12.2479C6.85122 11.9554 6.59181 11.8489 6.3496 11.7728L6.3179 11.7625C6.1346 11.7031 5.97643 11.6514 5.97643 11.5309V11.5248C5.97643 11.4215 6.06908 11.3454 6.21202 11.3454C6.37085 11.3454 6.56011 11.3983 6.68121 11.4652C6.68121 11.4652 6.71708 11.4884 6.73012 11.4538C6.7372 11.435 6.79894 11.2698 6.80556 11.2513C6.81257 11.2319 6.80026 11.2172 6.78762 11.2097C6.64865 11.125 6.45674 11.0674 6.25821 11.0674L6.22135 11.0676C5.88319 11.0676 5.64694 11.272 5.64694 11.5645V11.5708C5.64694 11.8792 5.90768 11.9798 6.15121 12.0493L6.19038 12.0615C6.36774 12.116 6.52126 12.1634 6.52126 12.2878V12.294C6.52126 12.4085 6.42134 12.4939 6.26119 12.4939C6.19892 12.4939 6.00046 12.4928 5.78538 12.3569C5.75937 12.3417 5.74455 12.3308 5.7245 12.3186C5.71391 12.3121 5.68744 12.3006 5.67593 12.3352L5.60313 12.5377M11.0097 12.5377C10.9984 12.5672 11.0138 12.5734 11.0176 12.5786C11.0512 12.6031 11.0857 12.6209 11.1201 12.6408C11.3041 12.738 11.4775 12.7665 11.6588 12.7665C12.0281 12.7665 12.2577 12.57 12.2577 12.2536V12.2474C12.2577 11.9549 11.999 11.8484 11.7561 11.7723L11.7244 11.762C11.5411 11.7026 11.3829 11.6508 11.3829 11.5304V11.5242C11.3829 11.421 11.4756 11.3449 11.6185 11.3449C11.7773 11.3449 11.9659 11.3978 12.0877 11.4647C12.0877 11.4647 12.1236 11.4878 12.1367 11.4532C12.1437 11.4345 12.2055 11.2693 12.2114 11.2507C12.2185 11.2313 12.2062 11.2167 12.1936 11.2092C12.0546 11.1245 11.8627 11.0669 11.6642 11.0669L11.6272 11.067C11.2891 11.067 11.0528 11.2715 11.0528 11.564V11.5703C11.0528 11.8787 11.3136 11.9793 11.5571 12.0488L11.5962 12.0609C11.7742 12.1155 11.9271 12.1628 11.9271 12.2873V12.2935C11.9271 12.408 11.8272 12.4933 11.667 12.4933C11.6046 12.4933 11.4056 12.4923 11.1912 12.3563C11.1652 12.3412 11.15 12.3307 11.1303 12.318C11.1236 12.3138 11.0924 12.3016 11.0817 12.3347L11.009 12.5372M14.7016 11.9178C14.7016 12.0965 14.6683 12.2374 14.603 12.3374C14.5379 12.436 14.4395 12.4843 14.3026 12.4843C14.1656 12.4843 14.0676 12.4364 14.0034 12.338C13.9388 12.2387 13.9062 12.0971 13.9062 11.9185C13.9062 11.7398 13.939 11.5995 14.0034 11.5009C14.0675 11.4029 14.1649 11.356 14.3026 11.356C14.4402 11.356 14.5381 11.4034 14.603 11.5009C14.6686 11.5995 14.7016 11.7398 14.7016 11.9185M15.01 11.5869C14.9796 11.4843 14.9326 11.3943 14.8697 11.3189C14.8068 11.2435 14.7274 11.1826 14.6328 11.1389C14.5388 11.0949 14.4276 11.0727 14.3019 11.0727C14.1762 11.0727 14.0656 11.095 13.971 11.1389C13.877 11.1828 13.797 11.2435 13.7341 11.3189C13.6714 11.3943 13.6242 11.4843 13.5938 11.5869C13.5637 11.6888 13.5484 11.8 13.5484 11.9185C13.5484 12.0369 13.5637 12.1481 13.5938 12.25C13.6241 12.3526 13.6712 12.4426 13.7341 12.518C13.797 12.5935 13.877 12.6537 13.971 12.6967C14.0656 12.7396 14.1768 12.7614 14.3019 12.7614C14.427 12.7614 14.5381 12.7396 14.6321 12.6967C14.7261 12.6538 14.8062 12.5935 14.869 12.518C14.9318 12.4426 14.9789 12.3526 15.0093 12.25C15.0394 12.1481 15.0547 12.0369 15.0547 11.9185C15.0547 11.8007 15.0394 11.6888 15.0093 11.5869M17.5439 12.434C17.5338 12.404 17.5045 12.4153 17.5045 12.4153C17.4597 12.4324 17.4119 12.4483 17.3609 12.4563C17.3096 12.4643 17.2524 12.4684 17.1922 12.4684C17.0433 12.4684 16.9241 12.424 16.8394 12.336C16.7541 12.248 16.7064 12.1064 16.7071 11.9145C16.7075 11.7398 16.7498 11.6087 16.8255 11.5082C16.9003 11.4089 17.0155 11.3573 17.1677 11.3573C17.2947 11.3573 17.392 11.372 17.4939 11.4039C17.4939 11.4039 17.5181 11.4145 17.5297 11.3826C17.5567 11.3078 17.5767 11.2542 17.6058 11.1722C17.614 11.1487 17.5938 11.1388 17.5865 11.1359C17.5465 11.1203 17.4522 11.0947 17.3807 11.0839C17.3139 11.0737 17.2364 11.0684 17.1491 11.0684C17.0194 11.0684 16.9042 11.0906 16.8056 11.1345C16.707 11.1784 16.6236 11.2391 16.5575 11.3145C16.4913 11.39 16.441 11.48 16.4072 11.5825C16.3738 11.6845 16.3569 11.7963 16.3569 11.9147C16.3569 12.1702 16.4258 12.3773 16.5621 12.5289C16.6984 12.6811 16.9036 12.7578 17.1709 12.7578C17.3291 12.7578 17.4912 12.7259 17.6077 12.6797C17.6077 12.6797 17.6299 12.669 17.6203 12.6431L17.5441 12.434M18.0835 11.7457C18.0982 11.6465 18.1254 11.5637 18.1682 11.4996C18.2322 11.4016 18.3297 11.348 18.4666 11.348C18.6036 11.348 18.6943 11.4019 18.7591 11.4996C18.8022 11.5641 18.821 11.6498 18.828 11.7457L18.0802 11.7456L18.0835 11.7457ZM19.1225 11.5274C19.0962 11.4287 19.0311 11.3288 18.9888 11.2832C18.9213 11.211 18.8558 11.1601 18.7903 11.1323C18.6957 11.0921 18.5939 11.0714 18.4911 11.0716C18.3608 11.0716 18.2423 11.0936 18.1464 11.1384C18.0504 11.1836 17.9697 11.245 17.9061 11.3217C17.8427 11.3985 17.795 11.4892 17.7645 11.5931C17.7341 11.6956 17.7187 11.8081 17.7187 11.9259C17.7187 12.0464 17.7347 12.1582 17.766 12.2595C17.7977 12.3614 17.8488 12.4507 17.9176 12.5248C17.9864 12.5996 18.0744 12.6578 18.1803 12.6989C18.2855 12.7396 18.4132 12.7607 18.5595 12.7602C18.8613 12.7592 19.0201 12.6921 19.0849 12.6557C19.0965 12.6492 19.1074 12.638 19.0938 12.6058L19.0256 12.4145C19.0152 12.386 18.9863 12.3963 18.9863 12.3963C18.9116 12.4242 18.8057 12.4744 18.5575 12.4737C18.3954 12.4735 18.2756 12.4256 18.2002 12.3507C18.1234 12.2739 18.085 12.162 18.0791 12.0032L19.1246 12.004C19.1246 12.004 19.1522 12.0038 19.155 11.9769C19.1561 11.9658 19.1908 11.7625 19.1238 11.5275L19.1225 11.5274ZM9.7254 11.7457C9.74015 11.6465 9.76742 11.5637 9.8101 11.4996C9.87416 11.4016 9.97157 11.348 10.1086 11.348C10.2455 11.348 10.3362 11.4019 10.4011 11.4996C10.444 11.5641 10.4628 11.6498 10.4699 11.7457L9.72209 11.7456L9.7254 11.7457ZM10.7644 11.5274C10.7382 11.4287 10.673 11.3288 10.6307 11.2832C10.5632 11.211 10.4977 11.1601 10.4322 11.1323C10.3376 11.0921 10.2358 11.0714 10.133 11.0716C10.0027 11.0716 9.88422 11.0936 9.78826 11.1384C9.69231 11.1836 9.61157 11.245 9.54804 11.3217C9.48471 11.3985 9.43687 11.4892 9.40643 11.5931C9.37605 11.6956 9.36076 11.8081 9.36076 11.9259C9.36076 12.0464 9.37658 12.1582 9.40815 12.2595C9.43978 12.3614 9.49087 12.4507 9.55903 12.5248C9.62785 12.5996 9.71587 12.6578 9.82175 12.6989C9.92697 12.7396 10.054 12.7607 10.2009 12.7602C10.5027 12.7592 10.6615 12.6921 10.7264 12.6557C10.7379 12.6492 10.7489 12.638 10.7352 12.6058L10.667 12.4145C10.6565 12.386 10.6276 12.3963 10.6276 12.3963C10.5529 12.4242 10.447 12.4744 10.1988 12.4737C10.0374 12.4735 9.91691 12.4256 9.84147 12.3507C9.76471 12.2739 9.72632 12.162 9.72037 12.0032L10.766 12.004C10.766 12.004 10.7935 12.0038 10.7963 11.9769C10.7975 11.9658 10.8321 11.7625 10.7651 11.5275L10.7644 11.5274ZM7.46878 12.4274C7.42782 12.3947 7.42213 12.3867 7.40856 12.3654C7.38785 12.3334 7.37726 12.288 7.37726 12.2297C7.37726 12.1384 7.4077 12.0722 7.47057 12.0279C7.4699 12.028 7.56057 11.9498 7.77365 11.9525C7.8685 11.9542 7.96313 11.9622 8.05689 11.9766V12.4511H8.05702C8.05702 12.4511 7.92467 12.4796 7.77511 12.4886C7.56268 12.5014 7.46871 12.4275 7.46938 12.4277L7.46878 12.4274ZM7.88437 11.6928C7.84201 11.6897 7.78709 11.6882 7.72157 11.6882C7.63224 11.6882 7.54554 11.6993 7.46481 11.7211C7.38341 11.7431 7.30996 11.7771 7.24709 11.8224C7.18405 11.8673 7.1322 11.9262 7.09554 11.9944C7.05855 12.0632 7.03969 12.144 7.03969 12.2353C7.03969 12.328 7.05577 12.408 7.08754 12.4735C7.11866 12.5385 7.16552 12.5947 7.22386 12.637C7.2819 12.6792 7.35357 12.7105 7.43629 12.729C7.51835 12.7477 7.61099 12.7572 7.7129 12.7572C7.82011 12.7572 7.92665 12.7482 8.02989 12.7308C8.11782 12.7156 8.20541 12.6986 8.29261 12.6797C8.32742 12.6717 8.36607 12.6612 8.36607 12.6612C8.39188 12.6546 8.38989 12.627 8.38989 12.627L8.38929 11.6741C8.38929 11.4649 8.33344 11.3094 8.22319 11.2135C8.11334 11.1175 7.95253 11.0692 7.74407 11.0692C7.66599 11.0692 7.53959 11.0798 7.46415 11.095C7.46415 11.095 7.2365 11.1392 7.14253 11.2127C7.14253 11.2127 7.12188 11.2255 7.13313 11.2542L7.20725 11.4528C7.21645 11.4785 7.24153 11.4697 7.24153 11.4697C7.24153 11.4697 7.2494 11.4666 7.25867 11.4611C7.45918 11.3519 7.7133 11.3552 7.7133 11.3552C7.8258 11.3552 7.91315 11.3781 7.97139 11.4227C8.02837 11.4665 8.05742 11.5326 8.05742 11.6715V11.7157C7.96808 11.7027 7.88536 11.6952 7.88536 11.6952L7.88437 11.6928ZM16.2888 11.1548C16.2903 11.1513 16.2911 11.1475 16.2911 11.1437C16.2911 11.1399 16.2904 11.1362 16.2889 11.1327C16.2874 11.1291 16.2853 11.126 16.2826 11.1233C16.2799 11.1207 16.2766 11.1186 16.2731 11.1172C16.2553 11.1104 16.1666 11.0917 16.0984 11.0875C15.9674 11.0793 15.8946 11.1014 15.8291 11.1308C15.7643 11.1599 15.6927 11.2069 15.653 11.2611L15.6529 11.1341C15.6529 11.1166 15.6405 11.1025 15.6229 11.1025H15.3556C15.3382 11.1025 15.3256 11.1166 15.3256 11.1341V12.6892C15.3257 12.6976 15.329 12.7057 15.335 12.7116C15.3409 12.7175 15.3489 12.7209 15.3573 12.7209H15.6313C15.6397 12.7209 15.6478 12.7175 15.6537 12.7116C15.6596 12.7057 15.6629 12.6976 15.6629 12.6892V11.9083C15.6629 11.8038 15.6745 11.6999 15.6974 11.6344C15.7201 11.5696 15.7508 11.5179 15.7888 11.4808C15.8249 11.445 15.8692 11.4185 15.9178 11.4034C15.9634 11.3903 16.0106 11.3837 16.0581 11.3837C16.1127 11.3837 16.1726 11.3977 16.1726 11.3977C16.1927 11.4 16.2039 11.3877 16.2107 11.3695C16.2286 11.3218 16.2795 11.1789 16.2894 11.1505",
                fill: "#FFFFFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.7299 10.437C13.6961 10.4268 13.6616 10.4186 13.6267 10.4125C13.5799 10.4047 13.5324 10.401 13.4849 10.4015C13.2961 10.4015 13.1472 10.4549 13.0427 10.5602C12.939 10.6648 12.8684 10.8241 12.833 11.0337L12.8202 11.1044H12.5832C12.5832 11.1044 12.5543 11.1032 12.5482 11.1348L12.5093 11.3518C12.5066 11.3726 12.5155 11.3856 12.5433 11.3854H12.774L12.5399 12.692C12.5216 12.7972 12.5006 12.8837 12.4774 12.9493C12.4545 13.0141 12.4321 13.0626 12.4046 13.0978C12.3779 13.1318 12.3527 13.1569 12.309 13.1716C12.273 13.1837 12.2316 13.1892 12.1862 13.1892C12.1609 13.1892 12.1273 13.185 12.1025 13.18C12.0777 13.1751 12.0648 13.1696 12.0462 13.1618C12.0462 13.1618 12.0191 13.1514 12.0085 13.1786C11.9998 13.2007 11.9383 13.3698 11.931 13.3907C11.9236 13.4114 11.934 13.4277 11.9471 13.4324C11.9778 13.4433 12.0007 13.4504 12.0425 13.4602C12.1006 13.4739 12.1496 13.4748 12.1954 13.4748C12.2915 13.4748 12.3791 13.4613 12.4517 13.4351C12.5247 13.4087 12.5883 13.3627 12.6446 13.3004C12.7054 13.2332 12.7436 13.1629 12.7802 13.0669C12.8164 12.9718 12.8473 12.8538 12.8719 12.7162L13.1071 11.3854H13.451C13.451 11.3854 13.48 11.3865 13.486 11.3551L13.5249 11.138C13.5276 11.1172 13.5187 11.1043 13.4908 11.1044H13.1571C13.1587 11.0969 13.1739 10.9795 13.2122 10.8689C13.2286 10.8218 13.2593 10.7837 13.2854 10.7576C13.3098 10.7327 13.3397 10.714 13.3728 10.7032C13.4091 10.692 13.4469 10.6865 13.4849 10.687C13.5163 10.687 13.5471 10.6908 13.5706 10.6957C13.603 10.7026 13.6156 10.7062 13.624 10.7087C13.6581 10.7191 13.6626 10.7091 13.6693 10.6926L13.7491 10.4734C13.7573 10.4498 13.7373 10.4399 13.7299 10.437ZM9.0662 12.6948C9.0662 12.7122 9.05376 12.7264 9.03629 12.7264H8.75947C8.74193 12.7264 8.72949 12.7122 8.72949 12.6948V10.4667C8.72949 10.4493 8.74193 10.4352 8.75947 10.4352H9.03629C9.05376 10.4352 9.0662 10.4493 9.0662 10.4667V12.6948Z",
                fill: "#FFFFFE"
            })
        ]
    });
};
var $c002cdcd98eda8d3$export$2e2bcd8739ae039 = $c002cdcd98eda8d3$var$SalesforceIcon;

});

parcelRegister("1m0Bz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9335974b50c62609$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9335974b50c62609$var$SentryIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-779.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M13.2634 5.12647C13.1313 4.90729 12.9448 4.72597 12.722 4.6001C12.4992 4.47423 12.2477 4.40808 11.9918 4.40808C11.7359 4.40808 11.4844 4.47423 11.2616 4.6001C11.0388 4.72597 10.8523 4.90729 10.7202 5.12647L8.62849 8.70913C10.2265 9.50694 11.588 10.7089 12.5779 12.1956C13.5677 13.6823 14.1514 15.4021 14.2711 17.1842H12.8024C12.683 15.6566 12.1667 14.1867 11.3047 12.9199C10.4427 11.6531 9.26492 10.6334 7.8878 9.96162L5.95183 13.309C6.726 13.6562 7.40046 14.1925 7.91318 14.8686C8.4259 15.5446 8.76042 16.3387 8.88598 17.1778H5.51314C5.47313 17.175 5.43447 17.1622 5.40062 17.1407C5.36677 17.1192 5.33881 17.0896 5.31926 17.0546C5.2997 17.0196 5.28917 16.9803 5.28861 16.9402C5.28805 16.9001 5.29747 16.8605 5.31604 16.8249L6.25065 15.2355C5.93401 14.9713 5.57212 14.7667 5.18253 14.6315L4.25746 16.2209C4.16115 16.3861 4.09863 16.5688 4.07353 16.7584C4.04842 16.9479 4.06124 17.1406 4.11122 17.3251C4.16121 17.5097 4.24737 17.6825 4.3647 17.8335C4.48203 17.9844 4.62819 18.1106 4.7947 18.2046C5.01407 18.3282 5.26134 18.3938 5.51314 18.3953H10.1321C10.2179 17.3368 10.0289 16.274 9.58332 15.3099C9.13777 14.3459 8.45081 13.5132 7.58898 12.8926L8.32331 11.621C9.41096 12.3681 10.285 13.3858 10.8592 14.5738C11.4334 15.7618 11.6879 17.0789 11.5976 18.3953H15.5109C15.602 16.4012 15.1682 14.418 14.2528 12.6441C13.3373 10.8701 11.9724 9.36748 10.2943 8.28633L11.7788 5.74318C11.8119 5.68775 11.8655 5.64764 11.928 5.63156C11.9906 5.61549 12.0569 5.62476 12.1126 5.65735C12.2811 5.74954 18.5627 16.7105 18.6803 16.8377C18.701 16.8748 18.7115 16.9168 18.7108 16.9593C18.7101 17.0019 18.6982 17.0435 18.6763 17.0799C18.6543 17.1164 18.6232 17.1464 18.5859 17.1669C18.5487 17.1874 18.5066 17.1978 18.4641 17.1969H16.9509C16.97 17.6017 16.97 18.0054 16.9509 18.4081H18.4705C18.6634 18.4093 18.8547 18.3723 19.0333 18.2991C19.2118 18.226 19.3741 18.1181 19.5107 17.9818C19.6473 17.8455 19.7554 17.6835 19.829 17.5051C19.9025 17.3267 19.94 17.1355 19.9391 16.9426C19.9393 16.6877 19.8713 16.4374 19.742 16.2178L13.2634 5.12647Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M13.273 5.71839C13.1399 5.49921 12.952 5.31788 12.7275 5.19201C12.503 5.06614 12.2495 5 11.9916 5C11.7338 5 11.4803 5.06614 11.2558 5.19201C11.0313 5.31788 10.8434 5.49921 10.7103 5.71839L8.60252 9.30104C10.2128 10.0989 11.5848 11.3008 12.5822 12.7875C13.5796 14.2742 14.1679 15.994 14.2884 17.7761H12.8085C12.6881 16.2485 12.1679 14.7786 11.2993 13.5118C10.4307 12.2451 9.24383 11.2253 7.85614 10.5535L5.90531 13.901C6.68543 14.2482 7.36506 14.7844 7.88171 15.4605C8.39837 16.1365 8.73546 16.9306 8.86199 17.7697H5.46325C5.42294 17.7669 5.38397 17.7542 5.34987 17.7326C5.31576 17.7111 5.28758 17.6815 5.26788 17.6465C5.24817 17.6115 5.23756 17.5722 5.23699 17.5321C5.23643 17.492 5.24593 17.4524 5.26464 17.4169L6.20642 15.8274C5.88735 15.5632 5.52269 15.3586 5.1301 15.2234L4.19793 16.8129C4.10089 16.978 4.03789 17.1607 4.01259 17.3503C3.98729 17.5398 4.0002 17.7325 4.05057 17.917C4.10094 18.1016 4.18776 18.2744 4.30599 18.4254C4.42423 18.5764 4.57151 18.7025 4.73929 18.7965C4.96035 18.9201 5.20952 18.9858 5.46325 18.9873H10.1177C10.2041 17.9287 10.0136 16.8659 9.56468 15.9018C9.11571 14.9378 8.42348 14.1051 7.55503 13.4845L8.295 12.2129C9.391 12.96 10.2718 13.9777 10.8504 15.1657C11.429 16.3537 11.6854 17.6709 11.5944 18.9873H15.5377C15.6296 16.9931 15.1924 15.01 14.27 13.236C13.3475 11.462 11.9721 9.9594 10.2811 8.87825L11.777 6.3351C11.8104 6.27967 11.8644 6.23956 11.9274 6.22348C11.9904 6.20741 12.0572 6.21667 12.1134 6.24927C12.2831 6.34146 18.6129 17.3024 18.7315 17.4296C18.7523 17.4667 18.763 17.5087 18.7623 17.5512C18.7616 17.5938 18.7495 17.6354 18.7274 17.6718C18.7053 17.7083 18.6739 17.7383 18.6364 17.7588C18.5988 17.7794 18.5565 17.7897 18.5136 17.7888H16.9889C17.0081 18.1936 17.0081 18.5973 16.9889 19H18.52C18.7145 19.0012 18.9072 18.9642 19.0872 18.8911C19.2671 18.8179 19.4306 18.71 19.5682 18.5737C19.7059 18.4375 19.8149 18.2754 19.889 18.097C19.9631 17.9186 20.0008 17.7274 20 17.5345C20.0002 17.2796 19.9316 17.0294 19.8014 16.8097L13.273 5.71839Z",
            fill: "#362D59"
        })
    });
};
var $9335974b50c62609$export$2e2bcd8739ae039 = $9335974b50c62609$var$SentryIcon;

});

parcelRegister("3zUD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c57db68586008b59$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $c57db68586008b59$var$SharePointIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-650.5",
                y: "-28.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#0B1228",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.1863 13.1429C14.6523 13.1429 16.6514 11.0962 16.6514 8.57143C16.6514 6.0467 14.6523 4 12.1863 4C9.72029 4 7.72119 6.0467 7.72119 8.57143C7.72119 11.0962 9.72029 13.1429 12.1863 13.1429Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.907 16.9525C18.1675 16.9525 20 15.0763 20 12.762C20 10.4477 18.1675 8.57153 15.907 8.57153C13.6465 8.57153 11.814 10.4477 11.814 12.762C11.814 15.0763 13.6465 16.9525 15.907 16.9525Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.7443 20.0001C14.4911 20.0001 15.9071 18.5504 15.9071 16.762C15.9071 14.9737 14.4911 13.5239 12.7443 13.5239C10.9976 13.5239 9.58154 14.9737 9.58154 16.762C9.58154 18.5504 10.9976 20.0001 12.7443 20.0001Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.9302 8.12585V16.2554C12.9283 16.5379 12.7611 16.7916 12.506 16.8992C12.4248 16.9344 12.3374 16.9525 12.2492 16.9525H9.58506C9.58134 16.8878 9.58134 16.8268 9.58134 16.762C9.5801 16.6984 9.58258 16.6348 9.58878 16.5716C9.65688 15.3538 10.3896 14.2794 11.4827 13.7944V13.0858C9.04996 12.6911 7.39032 10.3521 7.77583 7.86137C7.77851 7.84412 7.78127 7.82688 7.78414 7.80966C7.80266 7.68118 7.82876 7.55396 7.86228 7.42871H12.2493C12.6247 7.43017 12.9287 7.74144 12.9302 8.12585Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78421C7.37074 10.2958 9.00415 12.6544 11.4325 13.0777C11.5061 13.0906 11.5799 13.1015 11.654 13.1105C10.5005 13.6705 9.65993 15.261 9.58849 16.5715C9.5823 16.6348 9.57981 16.6984 9.58104 16.7619C9.58104 16.8267 9.58104 16.8877 9.58476 16.9524C9.59147 17.0805 9.60765 17.2078 9.63313 17.3334H11.8769C12.1528 17.3315 12.4006 17.1603 12.5057 16.8991C12.54 16.8159 12.5578 16.7265 12.5578 16.6362V8.50671C12.5564 8.12245 12.2526 7.81125 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8772 7.80957H7.78418C7.37079 10.296 9.00445 12.6548 11.4331 13.078C11.4828 13.0867 11.5326 13.0945 11.5825 13.1014C10.4662 13.7018 9.65879 15.2884 9.58883 16.5715H11.8772C12.2521 16.5686 12.5553 16.2581 12.5581 15.8743V8.50671C12.5567 8.1223 12.2527 7.81103 11.8772 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.505 7.80957H7.78405C7.39371 10.1568 8.8303 12.4172 11.0845 13.0027C10.231 14.0012 9.70744 15.2502 9.58871 16.5715H11.505C11.8805 16.57 12.1845 16.2587 12.1859 15.8743V8.50671C12.1857 8.12178 11.881 7.80978 11.505 7.80957Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M4.68205 7.80957H11.504C11.8807 7.80957 12.186 8.1222 12.186 8.50786V15.4922C12.186 15.8779 11.8807 16.1905 11.504 16.1905H4.68205C4.30536 16.1905 4 15.8779 4 15.4922V8.50786C4 8.1222 4.30536 7.80957 4.68205 7.80957Z",
                        fill: "#026D71"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.04621 11.9147C6.88638 11.8062 6.75286 11.6617 6.65588 11.4922C6.56192 11.3151 6.51508 11.1158 6.52007 10.9143C6.5117 10.6415 6.60162 10.3751 6.77272 10.1658C6.95251 9.95618 7.1849 9.80099 7.44472 9.717C7.74082 9.61722 8.05096 9.56805 8.36267 9.57148C8.77258 9.55614 9.18193 9.61482 9.57197 9.74481V10.621C9.40249 10.5159 9.21791 10.4388 9.02499 10.3924C8.81567 10.3399 8.60088 10.3135 8.38536 10.314C8.15809 10.3054 7.93227 10.3544 7.72787 10.4564C7.57007 10.5261 7.46774 10.6851 7.46741 10.861C7.46677 10.9677 7.50682 11.0705 7.57904 11.1475C7.66434 11.2382 7.76525 11.3121 7.87672 11.3654C8.00074 11.4286 8.18679 11.5127 8.43485 11.6176C8.46217 11.6264 8.48879 11.6374 8.51448 11.6504C8.75862 11.748 8.99415 11.867 9.21848 12.0058C9.38837 12.113 9.53095 12.26 9.63449 12.4347C9.74064 12.6328 9.79209 12.8566 9.78332 13.0824C9.79544 13.3624 9.71174 13.6381 9.54667 13.8618C9.38213 14.0674 9.16216 14.219 8.91411 14.2976C8.62236 14.3912 8.31786 14.4365 8.01215 14.4317C7.73787 14.433 7.46399 14.41 7.19355 14.3631C6.96521 14.3249 6.74237 14.2578 6.53011 14.1635V13.2397C6.733 13.388 6.95967 13.4989 7.19988 13.5673C7.43928 13.6437 7.68814 13.6845 7.93886 13.6884C8.17091 13.7035 8.40255 13.6532 8.60863 13.5429C8.75299 13.4595 8.84079 13.3015 8.83709 13.1319C8.83806 13.0138 8.79244 12.9004 8.71058 12.8172C8.60879 12.7149 8.49093 12.6308 8.36194 12.5684C8.2131 12.4922 7.99393 12.3918 7.70445 12.2671C7.47415 12.1723 7.25365 12.0543 7.04621 11.9147Z",
                        fill: "white"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181641)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_271_181641)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
                            fill: "#036C70"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
                            fill: "#1A9BA1"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
                            fill: "#37C6D0"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.1",
                            d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
                            fill: "#04868B"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_271_181641",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_271_181641",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    })
                ]
            })
        ]
    });
};
var $c57db68586008b59$export$2e2bcd8739ae039 = $c57db68586008b59$var$SharePointIcon;

});

parcelRegister("gHwiN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59be1161c1b0258$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $f59be1161c1b0258$var$SlackIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-603.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M7.71235 13.9487C7.71235 14.8109 7.0155 15.5078 6.15329 15.5078C5.29109 15.5078 4.59424 14.8109 4.59424 13.9487C4.59424 13.0865 5.29109 12.3896 6.15329 12.3896H7.71235V13.9487ZM8.49188 13.9487C8.49188 13.0865 9.18873 12.3896 10.0509 12.3896C10.9131 12.3896 11.61 13.0865 11.61 13.9487V17.8463C11.61 18.7085 10.9131 19.4054 10.0509 19.4054C9.18873 19.4054 8.49188 18.7085 8.49188 17.8463V13.9487Z",
                        fill: "#E01E5A"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M10.051 7.68879C9.18882 7.68879 8.49197 6.99194 8.49197 6.12973C8.49197 5.26753 9.18882 4.57068 10.051 4.57068C10.9132 4.57068 11.6101 5.26753 11.6101 6.12973V7.68879H10.051ZM10.051 8.48013C10.9132 8.48013 11.6101 9.17698 11.6101 10.0392C11.6101 10.9014 10.9132 11.5982 10.051 11.5982H6.14157C5.27937 11.5982 4.58252 10.9014 4.58252 10.0392C4.58252 9.17698 5.27937 8.48013 6.14157 8.48013H10.051Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M16.299 10.0392C16.299 9.17698 16.9959 8.48013 17.8581 8.48013C18.7203 8.48013 19.4171 9.17698 19.4171 10.0392C19.4171 10.9014 18.7203 11.5982 17.8581 11.5982H16.299V10.0392ZM15.5195 10.0392C15.5195 10.9014 14.8226 11.5982 13.9604 11.5982C13.0982 11.5982 12.4014 10.9014 12.4014 10.0392V6.12973C12.4014 5.26753 13.0982 4.57068 13.9604 4.57068C14.8226 4.57068 15.5195 5.26753 15.5195 6.12973V10.0392Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M13.9604 16.2873C14.8226 16.2873 15.5195 16.9841 15.5195 17.8463C15.5195 18.7085 14.8226 19.4054 13.9604 19.4054C13.0982 19.4054 12.4014 18.7085 12.4014 17.8463V16.2873H13.9604ZM13.9604 15.5078C13.0982 15.5078 12.4014 14.8109 12.4014 13.9487C12.4014 13.0865 13.0982 12.3896 13.9604 12.3896H17.8699C18.7321 12.3896 19.4289 13.0865 19.4289 13.9487C19.4289 14.8109 18.7321 15.5078 17.8699 15.5078H13.9604Z",
                        fill: "#ECB22E"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};
var $f59be1161c1b0258$export$2e2bcd8739ae039 = $f59be1161c1b0258$var$SlackIcon;

});

parcelRegister("b15lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d739a59c58974af2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $d739a59c58974af2$var$SmartsheetIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-171.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.2708 12.9524C12.0781 12.5707 11.8938 12.2011 11.6762 11.8499C11.4003 11.4042 11.1009 10.9773 10.6919 10.6414C10.3847 10.3891 10.0444 10.2293 9.63382 10.2899C9.27961 10.3422 8.99393 10.5287 8.73676 10.7652C8.60099 10.8901 8.47697 11.0271 8.36318 11.1923C8.42475 11.2006 8.47588 11.2054 8.52636 11.2146C8.8921 11.2813 9.17343 11.4943 9.4269 11.7487C9.85292 12.1767 10.1699 12.6838 10.4539 13.2121C11.0905 14.3964 11.5574 15.6505 11.9569 16.9316C11.9608 16.944 11.9643 16.9564 11.9732 16.9859C13.5754 13.1534 15.383 9.45358 17.8734 6.12915L17.9021 6.13874C17.9021 6.22486 17.9021 6.31098 17.9021 6.39688C17.9021 9.19064 17.9052 11.9844 17.9002 14.7784C17.8986 15.6202 17.8858 16.4624 17.8233 17.3027C17.8027 17.5811 17.7742 17.8593 17.6754 18.1242C17.5601 18.4333 17.3395 18.5127 17.0594 18.338C16.8218 18.1898 16.6373 17.9825 16.4822 17.754C16.1504 17.2654 15.831 16.7687 15.6093 16.2167C15.5952 16.1814 15.5917 16.1009 15.5142 16.1761C15.009 16.6673 14.4222 17.0471 13.8187 17.4003C12.0839 18.4152 10.2293 19.1317 8.28355 19.6187C7.58535 19.7934 6.88193 19.9416 6.1735 20.0672C6.10497 20.0794 6.08734 20.0753 6.10192 19.997C6.19656 19.4857 6.23986 18.9697 6.23986 18.449C6.23856 14.0349 6.23964 9.6208 6.23638 5.20669C6.23638 5.09615 6.26314 5.07239 6.37128 5.07239C10.1708 5.07544 13.9701 5.075 17.7696 5.075H17.9017C15.5708 7.38279 13.6026 9.93061 12.2715 12.9526L12.2708 12.9524Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M12.2752 13.0096C12.0792 12.6216 11.8919 12.246 11.6708 11.8889C11.3903 11.436 11.086 11.0021 10.6703 10.6606C10.358 10.4042 10.0121 10.2417 9.59481 10.3033C9.23477 10.3565 8.9444 10.546 8.68299 10.7864C8.54499 10.9134 8.41894 11.0526 8.30327 11.2206C8.36586 11.229 8.41783 11.2339 8.46914 11.2432C8.8409 11.311 9.12685 11.5275 9.38449 11.7861C9.81751 12.2211 10.1397 12.7366 10.4283 13.2736C11.0754 14.4773 11.55 15.752 11.9561 17.0542C11.96 17.0668 11.9636 17.0795 11.9726 17.1094C13.6012 13.2139 15.4386 9.45323 17.9699 6.07414L17.9991 6.08389C17.9991 6.17142 17.9991 6.25896 17.9991 6.34627C17.9991 9.18597 18.0022 12.0257 17.9971 14.8656C17.9955 15.7212 17.9825 16.5773 17.919 17.4314C17.898 17.7144 17.869 17.9971 17.7686 18.2664C17.6514 18.5806 17.4272 18.6613 17.1425 18.4838C16.901 18.3331 16.7135 18.1224 16.5558 17.8901C16.2186 17.3935 15.8939 16.8887 15.6686 16.3275C15.6542 16.2916 15.6506 16.2099 15.5719 16.2863C15.0584 16.7856 14.4619 17.1717 13.8485 17.5307C12.0852 18.5623 10.2001 19.2905 8.22233 19.7855C7.51265 19.963 6.79766 20.1137 6.07759 20.2414C6.00793 20.2538 5.99001 20.2496 6.00483 20.17C6.10103 19.6504 6.14504 19.1258 6.14504 18.5966C6.14371 14.1099 6.14482 9.62321 6.1415 5.13651C6.1415 5.02415 6.1687 5 6.27862 5C10.1406 5.0031 14.0024 5.00266 17.8644 5.00266H17.9986C15.6294 7.34839 13.6289 9.93811 12.2758 13.0098L12.2752 13.0096Z",
            fill: "#143158"
        })
    });
};
var $d739a59c58974af2$export$2e2bcd8739ae039 = $d739a59c58974af2$var$SmartsheetIcon;

});

parcelRegister("iFEkd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9affea886ceab4a6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9affea886ceab4a6$var$StripeIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.0639 9.32966C11.0639 8.76566 11.5259 8.54366 12.2939 8.54366C13.3979 8.54366 14.7899 8.87966 15.8939 9.47366V6.06566C14.6879 5.58566 13.4999 5.39966 12.2999 5.39966C9.35395 5.39966 7.39795 6.93566 7.39795 9.50366C7.39795 13.5057 12.9119 12.8697 12.9119 14.5977C12.9119 15.2637 12.3299 15.4797 11.5199 15.4797C10.3139 15.4797 8.77795 14.9877 7.55995 14.3217V17.7717C8.90995 18.3537 10.2719 18.5997 11.5199 18.5997C14.5379 18.5997 16.6139 17.1057 16.6139 14.5077C16.5899 10.1877 11.0639 10.9557 11.0639 9.32966Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 5H19V19H5V5Z",
                fill: "#635BFF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4541 10.4422C11.4541 10.1132 11.7236 9.98366 12.1716 9.98366C12.8156 9.98366 13.6276 10.1797 14.2716 10.5262V8.53816C13.5681 8.25816 12.8751 8.14966 12.1751 8.14966C10.4566 8.14966 9.31555 9.04566 9.31555 10.5437C9.31555 12.8782 12.5321 12.5072 12.5321 13.5152C12.5321 13.9037 12.1926 14.0297 11.7201 14.0297C11.0166 14.0297 10.1206 13.7427 9.41005 13.3542V15.3667C10.1976 15.7062 10.9921 15.8497 11.7201 15.8497C13.4806 15.8497 14.6916 14.9782 14.6916 13.4627C14.6776 10.9427 11.4541 11.3907 11.4541 10.4422Z",
                fill: "white"
            })
        ]
    });
};
var $9affea886ceab4a6$export$2e2bcd8739ae039 = $9affea886ceab4a6$var$StripeIcon;

});

parcelRegister("9o6kx", function(module, exports) {

$parcel$export(module.exports, "default", () => $21498f2ed987f6e9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $21498f2ed987f6e9$var$TeamsIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-506.5",
                y: "-603.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14.4626 10.3286H18.3371C18.7032 10.3286 18.9999 10.6308 18.9999 11.0036V14.5978C18.9999 15.9679 17.9093 17.0786 16.564 17.0786H16.5525C15.2072 17.0788 14.1164 15.9682 14.1162 14.5981C14.1162 14.598 14.1162 14.5979 14.1162 14.5978V10.6814C14.1162 10.4866 14.2713 10.3286 14.4626 10.3286Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.0815 9.61849C17.9484 9.61849 18.6512 8.90274 18.6512 8.01982C18.6512 7.13689 17.9484 6.42114 17.0815 6.42114C16.2145 6.42114 15.5117 7.13689 15.5117 8.01982C15.5117 8.90274 16.2145 9.61849 17.0815 9.61849Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M12.1976 9.61839C13.4499 9.61839 14.465 8.58453 14.465 7.3092C14.465 6.03386 13.4499 5 12.1976 5C10.9453 5 9.93018 6.03386 9.93018 7.3092C9.93018 8.58453 10.9453 9.61839 12.1976 9.61839Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M15.2211 10.3286H8.82556C8.46387 10.3377 8.17775 10.6434 8.18614 11.0118V15.1111C8.13564 17.3217 9.85286 19.156 12.0233 19.2101C14.1938 19.156 15.911 17.3217 15.8605 15.1111V11.0118C15.8689 10.6434 15.5828 10.3377 15.2211 10.3286Z",
                fill: "#7B83EB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M12.3718 10.3286V16.0732C12.37 16.3366 12.2133 16.5733 11.9741 16.6736C11.8979 16.7064 11.8161 16.7233 11.7334 16.7233H8.49271C8.44736 16.6061 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.3718Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V16.4284C12.0229 16.5127 12.0063 16.596 11.9741 16.6736C11.8756 16.9172 11.6432 17.0768 11.3846 17.0786H8.65666C8.59736 16.9613 8.54154 16.8441 8.49271 16.7233C8.44387 16.6025 8.4055 16.4888 8.37061 16.368C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0229 10.3286V15.7179C12.0203 16.0759 11.736 16.3653 11.3845 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H12.0229Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M11.6741 10.3286V15.7179C11.6714 16.0759 11.3872 16.3653 11.0357 16.368H8.37061C8.2485 15.9604 8.1862 15.5366 8.18573 15.1104V11.0107C8.17734 10.6429 8.46299 10.3377 8.82409 10.3286H11.6741Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.1",
                d: "M12.3722 8.49216V9.61123C12.3129 9.61478 12.2571 9.61834 12.1978 9.61834C12.1385 9.61834 12.0827 9.61479 12.0234 9.61123C11.9056 9.60328 11.7889 9.58425 11.6746 9.55439C10.9682 9.38403 10.3846 8.8795 10.1048 8.1973C10.0567 8.08274 10.0193 7.96378 9.99316 7.84204H11.7338C12.0859 7.8434 12.3709 8.13367 12.3722 8.49216Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M12.0231 8.84739V9.6112C11.9053 9.60324 11.7886 9.58422 11.6742 9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.3847C11.7367 8.19862 12.0217 8.4889 12.0231 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                opacity: "0.2",
                d: "M11.6742 8.84739V9.55436C10.9679 9.38399 10.3843 8.87946 10.1045 8.19727H11.0359C11.3879 8.19863 11.6729 8.48891 11.6742 8.84739Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M4.63941 8.19727H11.0349C11.3881 8.19727 11.6744 8.48882 11.6744 8.84846V15.3618C11.6744 15.7214 11.3881 16.013 11.0349 16.013H4.63941C4.28627 16.013 4 15.7214 4 15.3618V8.84846C4 8.48882 4.28628 8.19727 4.63941 8.19727Z",
                fill: "#5059C9"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.51986 10.6761H8.24137V14.2216H7.42685V10.6761H6.1543V9.98828H9.51986V10.6761Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "1 1 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_3561_46629)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.0321 10H19.4879C19.9088 10 20.2501 10.3403 20.2501 10.76V14.8068C20.2501 16.3494 18.9959 17.6 17.4488 17.6H17.4355C15.8884 17.6002 14.634 16.3498 14.6338 14.8072C14.6338 14.8071 14.6338 14.8069 14.6338 14.8068V10.3972C14.6338 10.1778 14.8121 10 15.0321 10Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.0435 9.19961C19.0405 9.19961 19.8487 8.39372 19.8487 7.39961C19.8487 6.4055 19.0405 5.59961 18.0435 5.59961C17.0465 5.59961 16.2383 6.4055 16.2383 7.39961C16.2383 8.39372 17.0465 9.19961 18.0435 9.19961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12.4274 9.20001C13.8675 9.20001 15.0349 8.03594 15.0349 6.6C15.0349 5.16406 13.8675 4 12.4274 4C10.9873 4 9.81982 5.16406 9.81982 6.6C9.81982 8.03594 10.9873 9.20001 12.4274 9.20001Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M15.904 10H8.54908C8.13313 10.0103 7.8041 10.3545 7.81375 10.7692V15.3848C7.75566 17.8737 9.73048 19.9391 12.2265 20C14.7226 19.9391 16.6974 17.8737 16.6393 15.3848V10.7692C16.649 10.3545 16.3199 10.0103 15.904 10Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.6276 10V16.468C12.6256 16.7646 12.4454 17.0311 12.1703 17.144C12.0827 17.1809 11.9886 17.2 11.8935 17.2H8.16671C8.11456 17.068 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.6276Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.868C12.2265 16.9628 12.2074 17.0567 12.1703 17.144C12.0571 17.4183 11.7898 17.598 11.4924 17.6H8.35526C8.28706 17.468 8.22288 17.336 8.16671 17.2C8.11055 17.064 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.068C12.2234 16.471 11.8965 16.797 11.4923 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8253 10V16.068C11.8223 16.471 11.4954 16.797 11.0912 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H11.8253Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.628 7.93121V9.19121C12.5598 9.19521 12.4956 9.19921 12.4274 9.19921C12.3592 9.19921 12.2951 9.19522 12.2269 9.19121C12.0914 9.18225 11.9572 9.16083 11.8257 9.12721C11.0133 8.93539 10.3422 8.36732 10.0205 7.59922C9.9651 7.47023 9.92213 7.33629 9.89209 7.19922H11.8939C12.2987 7.20075 12.6265 7.52757 12.628 7.93121Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8257 8.33161V9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.0916C11.4964 7.60115 11.8242 7.92798 11.8257 8.33161Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M3.73533 7.59961H11.0902C11.4964 7.59961 11.8256 7.92788 11.8256 8.33281V15.6664C11.8256 16.0713 11.4963 16.3996 11.0902 16.3996H3.73533C3.32921 16.3996 3 16.0713 3 15.6664V8.33281C3 7.92788 3.32922 7.59961 3.73533 7.59961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M9.34796 10.3916H7.87769V14.3836H6.94098V10.3916H5.47754V9.61719H9.34796V10.3916Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_3561_46629",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "17.25",
                        height: "16",
                        fill: "white",
                        transform: "translate(3 4)"
                    })
                })
            })
        ]
    });
};
var $21498f2ed987f6e9$export$2e2bcd8739ae039 = $21498f2ed987f6e9$var$TeamsIcon;

});

parcelRegister("cegaR", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f411dca8ce7b46$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $31f411dca8ce7b46$var$TodoistIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-731.5",
                y: "-268.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M16.7653 5.01575H7.2667C6.03236 5.01575 5.03174 6.01638 5.03174 7.25072V16.7493C5.03174 17.9837 6.03236 18.9843 7.2667 18.9843H16.7653C17.9996 18.9843 19.0002 17.9837 19.0002 16.7493V7.25072C19.0002 6.01638 17.9996 5.01575 16.7653 5.01575Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.98402 11.5604L10.7664 9.9593L10.7699 9.95712L13.6369 8.30708C13.7578 8.23724 13.7635 8.02335 13.6282 7.94565L13.5334 7.89152C13.3951 7.81295 13.2161 7.7108 13.1397 7.66628C13.0728 7.62983 12.9976 7.61118 12.9214 7.61209C12.8452 7.61301 12.7705 7.63347 12.7045 7.67151C12.6368 7.7108 8.12065 10.3072 7.96961 10.3932C7.88062 10.4441 7.77988 10.4708 7.67737 10.4708C7.57485 10.4708 7.47412 10.4441 7.38512 10.3932L5 9.00726V10.1854L5.02444 10.1994C5.61985 10.5464 7.02892 11.3671 7.37377 11.5613C7.58286 11.6792 7.78278 11.6766 7.98402 11.5604Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.98402 13.9142L10.7629 12.3148L10.7734 12.3087L13.6369 10.6608C13.7578 10.591 13.7635 10.3767 13.6282 10.2994L13.5334 10.2453C13.3955 10.1667 13.2161 10.0646 13.1397 10.02C13.0728 9.98359 12.9976 9.96494 12.9214 9.96585C12.8452 9.96677 12.7705 9.98723 12.7045 10.0253C12.6368 10.0641 8.12065 12.661 7.96961 12.7465C7.88062 12.7974 7.77988 12.8242 7.67737 12.8242C7.57485 12.8242 7.47412 12.7974 7.38512 12.7465C7.24282 12.6645 5 11.361 5 11.361V12.5387L5.02444 12.5531C5.62029 12.9002 7.02892 13.7204 7.37377 13.9151C7.58286 14.0329 7.78278 14.0303 7.98402 13.9142Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.7668 14.6663L7.98402 16.2679C7.78279 16.384 7.58242 16.3866 7.37377 16.2688C7.02892 16.0741 5.62029 15.2539 5.02444 14.9069L5 14.8924V13.7147L7.38512 15.1002C7.5654 15.2046 7.7889 15.2032 7.96961 15.1002C8.12065 15.0147 12.6368 12.4178 12.7045 12.3785C12.7705 12.3405 12.8452 12.32 12.9214 12.3191C12.9976 12.3182 13.0728 12.3369 13.1397 12.3733C13.3022 12.4673 13.4652 12.5604 13.6286 12.6527C13.7639 12.7304 13.7578 12.9447 13.6369 13.0146L10.7668 14.6663Z",
                fill: "#DE483A"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4458 4H6.59025C5.17958 4 4.03601 5.14358 4.03601 6.55425V17.4098C4.03601 18.8205 5.17958 19.9641 6.59025 19.9641H17.4458C18.8564 19.9641 20 18.8205 20 17.4098V6.55425C20 5.14358 18.8564 4 17.4458 4Z",
                fill: "#DE483A"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.41031 11.4797L10.5901 9.64985L10.5941 9.64735L13.8707 7.7616C14.0089 7.68178 14.0154 7.43733 13.8608 7.34853L13.7525 7.28667C13.5944 7.19687 13.3898 7.08013 13.3025 7.02924C13.226 6.9876 13.1401 6.96627 13.053 6.96732C12.966 6.96837 12.8806 6.99175 12.8051 7.03523C12.7278 7.08013 7.56645 10.0475 7.39384 10.1457C7.29213 10.2039 7.17701 10.2345 7.05985 10.2345C6.94269 10.2345 6.82756 10.2039 6.72585 10.1457L4 8.5618V9.90827L4.02794 9.92423C4.7084 10.3208 6.31877 11.2587 6.71288 11.4807C6.95184 11.6154 7.18033 11.6124 7.41031 11.4797Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.41031 14.1697L10.5861 12.3418L10.5981 12.3348L13.8707 10.4515C14.0089 10.3717 14.0154 10.1268 13.8608 10.0385L13.7525 9.97661C13.5949 9.88681 13.3898 9.77007 13.3025 9.71919C13.226 9.67754 13.1401 9.65622 13.053 9.65726C12.966 9.65831 12.8806 9.68169 12.8051 9.72517C12.7278 9.76957 7.56645 12.7374 7.39384 12.8352C7.29213 12.8933 7.17701 12.9239 7.05985 12.9239C6.94269 12.9239 6.82756 12.8933 6.72585 12.8352C6.56322 12.7414 4 11.2517 4 11.2517V12.5977L4.02794 12.6142C4.7089 13.0108 6.31877 13.9482 6.71288 14.1707C6.95184 14.3054 7.18033 14.3024 7.41031 14.1697Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.5906 15.0292L7.41031 16.8596C7.18033 16.9923 6.95134 16.9953 6.71288 16.8606C6.31877 16.6381 4.7089 15.7007 4.02794 15.3041L4 15.2877V13.9417L6.72585 15.5251C6.93189 15.6444 7.18731 15.6429 7.39384 15.5251C7.56645 15.4273 12.7278 12.4595 12.8051 12.4146C12.8806 12.3711 12.966 12.3478 13.053 12.3467C13.1401 12.3457 13.226 12.367 13.3025 12.4086C13.4882 12.516 13.6745 12.6225 13.8613 12.7279C14.0159 12.8167 14.0089 13.0617 13.8707 13.1415L10.5906 15.0292Z",
                fill: "white"
            })
        ]
    });
};
var $31f411dca8ce7b46$export$2e2bcd8739ae039 = $31f411dca8ce7b46$var$TodoistIcon;

});

parcelRegister("3aDJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $80a9ca5eb54c4f1b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $80a9ca5eb54c4f1b$var$WebexIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-554.5",
                y: "-363.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_719_13847",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    maskType: 'luminance'
                },
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "6",
                width: "18",
                height: "13",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M20.5 6.177H3.5V18.551H20.5V6.177Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                mask: "url(#mask0_719_13847)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.77473 18.5019C5.62694 18.5019 4.55554 14.5209 4.31548 13.7465C3.71261 11.8018 3.52935 10.05 3.50994 9.86618C3.39799 8.80539 4.24877 8.06718 5.18252 8.06718C5.8895 8.06718 6.71005 8.49041 6.81877 9.51726C6.83761 9.68995 6.98136 11.1795 7.48984 12.8026C8.02049 14.4964 8.58341 15.1479 8.98879 15.1479C9.64347 15.1479 10.0429 13.4664 10.396 11.8653C10.6562 10.6857 10.9374 9.49712 11.4926 8.44128C12.4585 6.60445 13.9181 6.177 15.1791 6.177C17.944 6.177 19.3278 9.38049 19.3278 10.2105C19.3278 11.5975 18.1965 11.9513 17.7062 11.9513C16.6338 11.9513 16.2703 11.2327 15.9643 10.6029C15.689 10.0363 15.4016 9.56515 15.0299 9.56515C14.9078 9.56515 14.7946 9.62698 14.69 9.73341C13.7662 10.6723 13.4565 15.584 11.6095 17.4612C10.5856 18.5019 9.47152 18.5019 8.77473 18.5019Z",
                        fill: "#00BBFF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.8181 8.06718C18.6934 8.06718 18.5681 8.07894 18.4451 8.1032C19.0296 8.94596 19.3221 9.82891 19.3221 10.2104C19.3221 11.5975 18.1907 11.9512 17.7004 11.9512C17.3178 11.9512 17.0254 11.8597 16.7937 11.7134C16.7916 11.7221 16.7895 11.7307 16.7873 11.7394C16.7184 12.0147 16.664 12.3159 16.5698 12.6092C16.3888 13.1729 16.1446 13.8168 15.8839 14.3151C15.6028 14.8523 15.3246 15.1666 14.9929 15.1501C14.6157 15.1314 14.3099 14.6452 13.9298 13.2711C13.8072 12.8281 13.6937 12.3423 13.5885 11.8653C13.3276 10.6822 13.0074 9.49254 12.4598 8.44128C11.5653 6.72426 10.0396 6.177 8.82156 6.177C7.69192 6.177 6.84795 6.71182 6.18495 7.3857C6.00175 7.57192 5.80158 7.82283 5.60059 8.11766C6.17886 8.25694 6.72565 8.69224 6.81293 9.51716C6.83015 9.67444 6.95085 10.9237 7.35628 12.3714C7.4726 12.0084 7.64222 11.4709 8.03625 10.6029C8.22939 10.2054 8.40369 9.94325 8.56092 9.78348C8.70514 9.63686 8.83499 9.57634 8.95193 9.57634C9.07804 9.57634 9.50861 9.69177 9.92778 11.1628C10.4477 12.9869 10.8346 15.8898 12.3086 17.4312C12.9587 18.1111 13.8685 18.551 15.1294 18.551C16.2358 18.551 17.1582 18.0637 17.8159 17.3859C18.8973 16.2712 19.4898 14.4284 19.7011 13.7465C20.3026 11.8064 20.4711 10.0518 20.4907 9.86618C20.6026 8.80539 19.709 8.06718 18.8181 8.06718Z",
                        fill: "#316AFF"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("mask", {
                id: "mask0_647_117",
                maskUnits: "userSpaceOnUse",
                x: "4",
                y: "6",
                width: "16",
                height: "12",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    d: "M20 6H4V17.6461H20V6Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                mask: "url(#mask0_647_117)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint0_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint1_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint2_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint3_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint4_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint5_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint6_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint7_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint8_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.9922 6C13.8054 6 12.4317 6.4023 11.5225 8.13109C11 9.12482 10.7353 10.2435 10.4905 11.3537C10.4099 11.719 10.3267 12.0888 10.2382 12.4394V17.4624C10.6873 17.3353 11.1697 17.0908 11.6326 16.6205C13.3709 14.8536 13.6625 10.2308 14.5319 9.34721C14.6303 9.24703 14.7369 9.18884 14.8518 9.18884C15.2016 9.18884 15.4722 9.63224 15.7312 10.1655C16.0192 10.7583 16.3613 11.4346 17.3707 11.4346C17.8322 11.4346 18.8969 11.1017 18.8969 9.79624C18.8969 9.01505 17.5945 6 14.9922 6Z",
                        fill: "url(#paint9_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint10_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint11_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint12_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint13_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14128 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint14_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "#316AFF"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint15_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint16_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint17_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint18_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint19_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint20_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint21_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint22_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint23_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M18.4171 7.77899C18.2997 7.77899 18.1817 7.79006 18.066 7.81289C18.6161 8.60608 18.8914 9.43709 18.8914 9.79614C18.8914 11.1016 17.8266 11.4346 17.3651 11.4346C17.005 11.4346 16.7299 11.3484 16.5118 11.2107C16.5097 11.2189 16.5078 11.227 16.5057 11.2352C16.4409 11.4943 16.3897 11.7778 16.3011 12.0538C16.1307 12.5843 15.9009 13.1904 15.6555 13.6594C15.3909 14.165 15.129 14.4608 14.8169 14.4453C14.4619 14.4277 14.174 13.97 13.8163 12.6768C13.701 12.2598 13.5941 11.8026 13.4951 11.3537C13.2496 10.2402 12.9481 9.12051 12.4328 8.13109C11.5909 6.51506 10.155 6 9.00856 6C7.94536 6 7.15104 6.50336 6.52704 7.1376C6.35462 7.31286 6.16623 7.54901 5.97705 7.82651C6.52131 7.95759 7.03593 8.36729 7.11808 9.14368C7.13429 9.29171 7.24788 10.4675 7.62947 11.83C7.73895 11.4884 7.89859 10.9825 8.26944 10.1655C8.45122 9.79144 8.61527 9.54471 8.76325 9.39433C8.89898 9.25634 9.02119 9.19937 9.13126 9.19937C9.24995 9.19937 9.65519 9.30802 10.0497 10.6925C10.539 12.4093 10.9031 15.1415 12.2905 16.5921C12.9023 17.2321 13.7586 17.6461 14.9454 17.6461C15.9867 17.6461 16.8548 17.1874 17.4738 16.5495C18.4916 15.5004 19.0492 13.766 19.2482 13.1242C19.8142 11.2983 19.9728 9.64689 19.9913 9.47216C20.0966 8.47378 19.2555 7.77899 18.4171 7.77899Z",
                        fill: "url(#paint24_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint25_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint26_radial_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint27_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint28_linear_647_117)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M8.96446 17.5999C6.00182 17.5999 4.99345 13.8531 4.76751 13.1242C4.20011 11.2939 4.02762 9.64517 4.00936 9.47216C3.90399 8.47378 4.70473 7.77899 5.58355 7.77899C6.24894 7.77899 7.02122 8.17733 7.12355 9.14378C7.14133 9.3063 7.27657 10.7083 7.75515 12.2358C8.25458 13.8301 8.78439 14.4432 9.16593 14.4432C9.78209 14.4432 10.158 12.8606 10.4903 11.3537C10.7352 10.2435 10.9999 9.12482 11.5224 8.13109C12.4315 6.4023 13.8053 6 14.9921 6C17.5944 6 18.8968 9.01505 18.8968 9.79624C18.8968 11.1017 17.832 11.4346 17.3706 11.4346C16.3612 11.4346 16.0191 10.7583 15.7311 10.1655C15.472 9.63224 15.2015 9.18884 14.8517 9.18884C14.7368 9.18884 14.6303 9.24703 14.5318 9.34721C13.6623 10.2308 13.3708 14.8536 11.6325 16.6205C10.6688 17.5999 9.62025 17.5999 8.96446 17.5999Z",
                        fill: "url(#paint29_radial_647_117)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_647_117",
                        x1: "17.2757",
                        y1: "9.40344",
                        x2: "6.80986",
                        y2: "12.8357",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5CEE64"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00BBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint1_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(10.09 12.186) rotate(-120.86) scale(6.85625 5.75574)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#007383"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#00717E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint2_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(14.5948 10.9103) rotate(-126.734) scale(5.59154 3.67393)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#218970"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.459527",
                                stopColor: "#267E6A"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#026C51",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint3_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(9.6952 12.5099) rotate(-107.468) scale(4.554 2.37251)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#178697"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#17838F",
                                stopOpacity: "0.79"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#007281",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint4_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(11.7199 12.4856) rotate(-120.86) scale(11.5648 3.56733)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#25342F",
                                stopOpacity: "0.3"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#25342F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint5_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.7828 11.0371) rotate(85.0979) scale(4.35562 2.47045)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#056D4F"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.232593",
                                stopColor: "#056C4E",
                                stopOpacity: "0.75"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.598902",
                                stopColor: "#056C4E",
                                stopOpacity: "0.300824"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.874482",
                                stopColor: "#056C4F",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint6_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(13.9754 3.99288) rotate(57.0774) scale(5.12012 2.6855)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#22B67B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.407867",
                                stopColor: "#24BE82"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#24BE82",
                                stopOpacity: "0.07"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint7_linear_647_117",
                        x1: "0.0633092",
                        y1: "11.6988",
                        x2: "7.4802",
                        y2: "11.7598",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint8_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(1.65669 5.0183) rotate(49.6506) scale(6.68716 6.67046)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint9_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.01337 1.6515) rotate(48.0118) scale(13.5629 13.5415)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00B8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.745423",
                                stopColor: "#00B9FC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint10_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.73139 11.8243) rotate(-107.468) scale(6.53747 4.52974)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint11_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.6701 9.34133) rotate(-129.551) scale(4.62291 3.23649)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5FEC50"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#3CC08E",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint12_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.0084 12.3189) rotate(-79.0944) scale(1.39957 0.968007)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint13_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.941 12.2159) rotate(-77.8798) scale(1.15379 1.61246)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#28855B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#14795C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint14_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(18.3155 10.1373) rotate(-132.79) scale(3.82739 2.68878)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#5FF05B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.813285",
                                stopColor: "#5DE955",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint15_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.1186 11.2367) rotate(37.4559) scale(3.40381 4.73123)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.966119",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint16_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.2718 11.6203) rotate(8.48611) scale(4.01618 5.99473)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint17_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.5977 12.1185) rotate(24.6631) scale(3.43068 6.11312)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.756788",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint18_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(16.1948 12.3217) rotate(95.8028) scale(6.16725 3.37972)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.592487",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint19_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(17.1186 9.59893) rotate(93.6671) scale(7.42211 2.64877)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint20_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.70726 11.1422) rotate(84.8296) scale(3.93849 2.08658)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint21_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.70442 11.2481) rotate(87.2504) scale(4.11044 3.39354)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.884611",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint22_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(9.63961 15.1104) rotate(-23.1725) scale(4.58388 8.95991)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#123AA8"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint23_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(8.00865 10.2431) rotate(-159.526) scale(3.03689 5.19997)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#1A3DA0"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.708977",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint24_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(5.33541 11.2767) rotate(16.749) scale(5.79218 5.84719)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#1E3882"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.761404",
                                stopColor: "#123AA8",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint25_linear_647_117",
                        x1: "3.51831",
                        y1: "8.07299",
                        x2: "9.22598",
                        y2: "11.7159",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.229329",
                                stopColor: "#1DC4FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1CC1FF",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint26_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(1.65635 5.01803) rotate(49.6506) scale(6.68716 6.67046)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#09F8FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint27_linear_647_117",
                        x1: "3.8338",
                        y1: "8.25908",
                        x2: "5.43479",
                        y2: "9.71047",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint28_linear_647_117",
                        x1: "3.40845",
                        y1: "9.36998",
                        x2: "5.62288",
                        y2: "9.52796",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#26FBFF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.637346",
                                stopColor: "#0BF7F9",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("radialGradient", {
                        id: "paint29_radial_647_117",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(7.73119 11.8243) rotate(-107.468) scale(6.53747 4.52974)",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#00BCFF",
                                stopOpacity: "0.76"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.57273",
                                stopColor: "#00BAFC",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $80a9ca5eb54c4f1b$export$2e2bcd8739ae039 = $80a9ca5eb54c4f1b$var$WebexIcon;

});

parcelRegister("dgMee", function(module, exports) {

$parcel$export(module.exports, "default", () => $17bdaf6b639eb088$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $17bdaf6b639eb088$var$ZeplinIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-555.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0.385264 6C0.385264 2.89907 2.89907 0.385264 6 0.385264H18C21.1009 0.385264 23.6147 2.89907 23.6147 6V18C23.6147 21.1009 21.1009 23.6147 18 23.6147H6C2.89907 23.6147 0.385264 21.1009 0.385264 18V6Z",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.770528"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.77432 14.5822L4.83263 14.9145L4.78223 17.6201L8.0417 16.4703C6.92361 16.1075 6.10732 15.4691 5.77432 14.5822Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.26698 11.7203L3 12.873L4.83299 14.9145L5.77438 14.5821C5.44228 13.6977 5.64688 12.6983 6.26698 11.7203Z",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.7655 7.81617C7.60483 9.28414 4.92255 12.3134 5.77454 14.5823L20.8407 9.26618C19.9887 6.99727 15.9259 6.34819 11.7655 7.81617Z",
                fill: "#FECF33"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.8498 16.0323C19.0101 14.564 21.6972 11.5483 20.8407 9.26611L5.77393 14.5822C6.63072 16.8645 10.6891 17.5002 14.8498 16.0323Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8407 9.26611L5.77393 14.5822C6.06882 15.3681 7.19412 15.7552 8.7724 15.7552C10.3114 15.7552 12.2815 15.3875 14.3353 14.6628C18.4956 13.1948 21.4227 10.8178 20.8401 9.26611",
                fill: "#F69833"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8418 8.09302C16.3028 8.09302 14.3327 8.46074 12.2789 9.18545C8.11857 10.6534 5.19149 13.0301 5.77408 14.5821L20.8403 9.26601C20.5454 8.48015 19.4204 8.09302 17.8418 8.09302Z",
                fill: "#FDBD39"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.0099 17.7638C16.5665 17.7638 15.9128 17.377 15.0659 16.6143C14.0648 15.712 12.9176 14.3903 11.8359 12.8925C10.7544 11.3953 9.86547 9.89801 9.33327 8.67692C8.75368 7.34629 8.67088 6.52827 9.08757 6.24516C9.17907 6.18315 9.28917 6.15186 9.41517 6.15186C9.75417 6.15186 10.4148 6.39555 11.6361 7.55724L11.6631 7.58245L11.6592 7.61867C11.6508 7.70213 11.6433 7.78645 11.6364 7.86904L11.6229 8.03305L11.5029 7.91656C10.1868 6.63577 9.60747 6.49755 9.41937 6.49755C9.36567 6.49755 9.32307 6.50798 9.29247 6.52885C9.11157 6.65142 9.09987 7.2524 9.66207 8.54217C10.185 9.74153 11.0607 11.2159 12.1281 12.694C13.196 14.1724 14.3255 15.4746 15.3092 16.3608C16.3697 17.3164 16.8476 17.4196 17.0042 17.4196C17.0582 17.4196 17.1017 17.4086 17.1344 17.3863C17.3249 17.257 17.3252 16.6132 16.6982 15.2246L16.6694 15.1611L16.7324 15.1278C16.7954 15.0945 16.8566 15.0617 16.9136 15.0304L16.9892 14.989L17.024 15.0658C17.4683 16.0496 17.8838 17.2999 17.339 17.6699C17.2472 17.7323 17.1365 17.7638 17.0099 17.7638Z",
                fill: "#EE6723"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.9505 15.9908L14.9445 16.0662C14.8392 17.3235 14.562 18.8346 13.8399 18.8961C13.8255 18.8972 13.8105 18.8978 13.7955 18.8978C13.3048 18.8978 12.8407 18.2189 12.4162 16.8801C12.0142 15.6133 11.7022 13.9129 11.5381 12.0911C11.3737 10.2702 11.3761 8.54257 11.545 7.2273C11.7289 5.7938 12.0793 5.04533 12.5863 5.00215C12.6013 5.00099 12.6169 5.00012 12.6322 5.00012C12.988 5.00012 13.5244 5.38957 14.0733 7.20238L13.7148 7.26903C13.5316 6.66341 13.3318 6.1708 13.1335 5.83176C12.9499 5.51881 12.7717 5.3464 12.6313 5.3464C12.6265 5.3464 12.622 5.3464 12.6172 5.34698C12.3976 5.36552 12.0775 5.88045 11.8993 7.2699C11.7334 8.56169 11.7313 10.2632 11.8933 12.061C12.0559 13.859 12.3625 15.5344 12.7573 16.7784C12.934 17.3354 13.1278 17.7947 13.318 18.1062C13.4932 18.3936 13.6627 18.5518 13.7952 18.5518C13.7997 18.5518 13.8042 18.5518 13.809 18.5512C14.019 18.5336 14.4153 17.9978 14.5821 16.1128L14.9505 15.9908Z",
                fill: "#EE6723"
            })
        ]
    });
};
var $17bdaf6b639eb088$export$2e2bcd8739ae039 = $17bdaf6b639eb088$var$ZeplinIcon;

});

parcelRegister("eOwHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bcd7036eebc7598$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9bcd7036eebc7598$var$ZendeskIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-491.5",
                y: "-219.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#03363D"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M11.6092 9.34881V17.3365H4.99316L11.6092 9.34881ZM11.6092 6.48242C11.6092 7.35976 11.2607 8.20117 10.6403 8.82155C10.0199 9.44192 9.17853 9.79044 8.30119 9.79044C7.42384 9.79044 6.58244 9.44192 5.96206 8.82155C5.34169 8.20117 4.99316 7.35976 4.99316 6.48242H11.6092ZM12.6991 17.3372C12.6991 16.4598 13.0477 15.6184 13.668 14.9981C14.2884 14.3777 15.1298 14.0292 16.0072 14.0292C16.8845 14.0292 17.7259 14.3777 18.3463 14.9981C18.9667 15.6184 19.3152 16.4598 19.3152 17.3372H12.6991ZM12.6991 14.4708V6.48242H19.3166L12.6991 14.4701V14.4708Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M11.4666 9.80166V17.609H5L11.4666 9.80166ZM11.4666 7C11.4666 7.85753 11.126 8.67994 10.5196 9.2863C9.91326 9.89267 9.09085 10.2333 8.23332 10.2333C7.37579 10.2333 6.55338 9.89267 5.94702 9.2863C5.34065 8.67994 5 7.85753 5 7H11.4666ZM12.532 17.6096C12.532 16.7521 12.8726 15.9297 13.479 15.3233C14.0854 14.717 14.9078 14.3763 15.7653 14.3763C16.6228 14.3763 17.4452 14.717 18.0516 15.3233C18.658 15.9297 18.9986 16.7521 18.9986 17.6096H12.532ZM12.532 14.808V7H19L12.532 14.8073V14.808Z",
            fill: "#03363D"
        })
    });
};
var $9bcd7036eebc7598$export$2e2bcd8739ae039 = $9bcd7036eebc7598$var$ZendeskIcon;

});

parcelRegister("39NR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $73cf90867809d07b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6fnsQ = parcelRequire("6fnsQ");
const $73cf90867809d07b$var$GitbookIcon = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M10.802 17.77a.703.703 0 1 1-.002 1.406.703.703 0 0 1 .002-1.406m11.024-4.347a.703.703 0 1 1 .001-1.406.703.703 0 0 1-.001 1.406m0-2.876a2.176 2.176 0 0 0-2.174 2.174c0 .233.039.465.115.691l-7.181 3.823a2.165 2.165 0 0 0-1.784-.937c-.829 0-1.584.475-1.95 1.216l-6.451-3.402c-.682-.358-1.192-1.48-1.138-2.502.028-.533.212-.947.493-1.107.178-.1.392-.092.62.027l.042.023c1.71.9 7.304 3.847 7.54 3.956.363.169.565.237 1.185-.057l11.564-6.014c.17-.064.368-.227.368-.474 0-.342-.354-.477-.355-.477-.658-.315-1.669-.788-2.655-1.25-2.108-.987-4.497-2.105-5.546-2.655-.906-.474-1.635-.074-1.765.006l-.252.125C7.78 6.048 1.46 9.178 1.1 9.397.457 9.789.058 10.57.006 11.539c-.08 1.537.703 3.14 1.824 3.727l6.822 3.518a2.175 2.175 0 0 0 2.15 1.862 2.177 2.177 0 0 0 2.173-2.14l7.514-4.073c.38.298.853.461 1.337.461A2.176 2.176 0 0 0 24 12.72a2.176 2.176 0 0 0-2.174-2.174"
        })
    });
var $73cf90867809d07b$export$2e2bcd8739ae039 = $73cf90867809d07b$var$GitbookIcon;

});

parcelRegister("bIkGo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3698078ac83fd1c3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $3698078ac83fd1c3$var$LaunchDarklyIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-683.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M20.0232 12.0808C20.0002 12.2346 19.9148 12.3512 19.8075 12.4584C17.3508 14.9147 14.895 17.3719 12.4389 19.8288C12.4116 19.8561 12.3853 19.8845 12.3562 19.9098C12.2424 20.0088 12.113 20.0247 11.9781 19.9655C11.845 19.9072 11.7732 19.798 11.7632 19.6539C11.7574 19.5702 11.7891 19.4944 11.8388 19.4264C11.9362 19.2931 12.0329 19.1593 12.13 19.0257C12.7486 18.1738 13.3672 17.3218 13.9859 16.47C14.3904 15.913 14.795 15.3562 15.1995 14.7994C15.3066 14.6519 15.4141 14.5047 15.5208 14.357C15.5315 14.3423 15.5483 14.3295 15.5454 14.3065C15.5243 14.3004 15.5082 14.3131 15.4912 14.32C14.8996 14.5611 14.308 14.8024 13.7166 15.0438C13.2263 15.2439 12.7362 15.4442 12.246 15.6446C11.1843 16.0784 10.1224 16.5119 9.06106 16.9467C8.97552 16.9817 8.88978 17.0024 8.79819 16.9813C8.65305 16.9479 8.54691 16.8331 8.52155 16.684C8.49883 16.5505 8.56326 16.4093 8.68877 16.3339C8.9313 16.1881 9.17582 16.0455 9.41951 15.9016C10.289 15.3879 11.1584 14.8742 12.028 14.3607C12.7979 13.9061 13.568 13.4519 14.338 12.9974C14.3655 12.9812 14.3924 12.9642 14.4339 12.9389C14.3588 12.9323 14.2988 12.9253 14.2387 12.922C13.9713 12.9073 13.7038 12.894 13.4363 12.8793C13.2181 12.8673 13 12.8547 12.7819 12.8415C12.5296 12.8261 12.2774 12.8095 12.0251 12.7943C11.9225 12.788 11.8197 12.7846 11.717 12.7786C11.5224 12.7673 11.3279 12.7548 11.1333 12.7432C11.0542 12.7385 10.975 12.7358 10.8959 12.7303C10.7057 12.7172 10.515 12.711 10.3246 12.6999C10.0723 12.6852 9.82012 12.6679 9.56774 12.6531C9.48432 12.6482 9.40084 12.6449 9.31742 12.6397C9.0523 12.6232 8.78686 12.6112 8.52161 12.5966C8.29917 12.5844 8.07679 12.5711 7.85434 12.5583C7.62765 12.5453 7.40082 12.5335 7.17426 12.519C6.95188 12.5048 6.72956 12.4913 6.50699 12.4805C6.28229 12.4696 6.05785 12.4551 5.83328 12.4422C5.61083 12.4294 5.38845 12.4166 5.166 12.4038C4.94356 12.391 4.72111 12.3791 4.49873 12.3648C4.43675 12.3608 4.37431 12.3592 4.31284 12.3523C4.16358 12.3353 4.05918 12.256 4.00602 12.1135C3.99707 12.0894 3.99243 12.0637 3.97705 12.0422V11.9393C3.99733 11.9207 3.99932 11.8936 4.0091 11.8701C4.06504 11.736 4.16332 11.6549 4.30917 11.6409C4.4307 11.6293 4.5528 11.6239 4.67464 11.6167C4.89921 11.6034 5.12378 11.5908 5.34835 11.5778C5.5708 11.565 5.79318 11.5517 6.01569 11.5395C6.28312 11.5249 6.55069 11.513 6.818 11.4964C6.89929 11.4914 6.98058 11.4877 7.06188 11.483C7.24364 11.4725 7.42528 11.4591 7.60705 11.4487C7.79532 11.438 7.98384 11.432 8.17185 11.4184C8.25315 11.4125 8.33451 11.4106 8.4158 11.4056C8.60606 11.3938 8.79639 11.3816 8.98672 11.3705C9.08938 11.3644 9.19223 11.3612 9.2949 11.355C9.54721 11.3397 9.79945 11.3229 10.0518 11.3077C10.2741 11.2942 10.4967 11.282 10.7191 11.2693C10.9458 11.2563 11.1726 11.2433 11.3993 11.2303C11.6196 11.2176 11.8398 11.2048 12.0602 11.1922C12.2847 11.1792 12.5093 11.1658 12.7339 11.1535C13.0014 11.1389 13.2689 11.127 13.5362 11.1105C13.6175 11.1055 13.6988 11.1016 13.7801 11.0971C13.9812 11.0858 14.1821 11.0732 14.3832 11.0609C14.3985 11.0599 14.4156 11.0646 14.4308 11.0529C14.4137 11.033 14.3934 11.0251 14.3751 11.0143C13.5146 10.5062 12.654 9.99844 11.7936 9.49047C10.898 8.96178 10.0024 8.43308 9.10689 7.90432C8.96837 7.82258 8.82909 7.74206 8.69192 7.65813C8.56776 7.58211 8.50449 7.44392 8.52374 7.31442C8.55817 7.0829 8.80701 6.93975 9.02933 7.03359C9.54483 7.25121 10.0641 7.45969 10.5821 7.67152C11.5167 8.05372 12.4516 8.43553 13.3863 8.81767C14.0887 9.10486 14.7912 9.39225 15.4938 9.679C15.5099 9.68556 15.5262 9.70217 15.5467 9.68743C15.5473 9.66503 15.5315 9.65177 15.5205 9.63665C15.1123 9.07442 14.7037 8.51251 14.2954 7.95041C13.7824 7.24426 13.2698 6.53792 12.7569 5.8317C12.4532 5.41352 12.1522 4.99341 11.8443 4.57832C11.679 4.35536 11.8105 4.07621 12.0167 4.01719C12.031 4.01313 12.0443 4.00579 12.0581 4C12.101 4 12.1439 4 12.1868 4C12.282 4.02349 12.354 4.08136 12.4221 4.14939C14.8857 6.61367 17.3497 9.07744 19.8147 11.5404C19.9208 11.6464 20.0037 11.7613 20.0233 11.9138V12.081L20.0232 12.0808Z",
                fill: "white"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            d: "M19.9999 12.0808C19.977 12.2346 19.8919 12.3512 19.7849 12.4584C17.3353 14.9147 14.8865 17.3719 12.4375 19.8288C12.4103 19.8561 12.384 19.8845 12.355 19.9098C12.2415 20.0088 12.1125 20.0247 11.978 19.9655C11.8453 19.9072 11.7737 19.798 11.7638 19.6539C11.758 19.5702 11.7896 19.4944 11.8391 19.4264C11.9362 19.2931 12.0327 19.1593 12.1295 19.0257C12.7463 18.1738 13.3631 17.3218 13.98 16.47C14.3833 15.913 14.7867 15.3562 15.1901 14.7994C15.2969 14.6519 15.4041 14.5047 15.5105 14.357C15.5212 14.3423 15.5379 14.3295 15.535 14.3065C15.514 14.3004 15.4979 14.3131 15.481 14.32C14.891 14.5611 14.3012 14.8024 13.7115 15.0438C13.2226 15.2439 12.7339 15.4442 12.2451 15.6446C11.1865 16.0784 10.1277 16.5119 9.06936 16.9467C8.98407 16.9817 8.89858 17.0024 8.80725 16.9813C8.66253 16.9479 8.55669 16.8331 8.53141 16.684C8.50875 16.5505 8.573 16.4093 8.69815 16.3339C8.93998 16.1881 9.18379 16.0455 9.42678 15.9016C10.2938 15.3879 11.1607 14.8742 12.0278 14.3607C12.7954 13.9061 13.5634 13.4519 14.3311 12.9974C14.3585 12.9812 14.3854 12.9642 14.4267 12.9389C14.3518 12.9323 14.292 12.9253 14.232 12.922C13.9654 12.9073 13.6987 12.894 13.432 12.8793C13.2145 12.8673 12.997 12.8547 12.7795 12.8415C12.5279 12.8261 12.2765 12.8095 12.0249 12.7943C11.9225 12.788 11.82 12.7846 11.7177 12.7786C11.5237 12.7673 11.3296 12.7548 11.1356 12.7432C11.0568 12.7385 10.9777 12.7358 10.8989 12.7303C10.7092 12.7172 10.5191 12.711 10.3293 12.6999C10.0777 12.6852 9.82623 12.6679 9.57458 12.6531C9.49141 12.6482 9.40817 12.6449 9.32499 12.6397C9.06063 12.6232 8.79596 12.6112 8.53147 12.5966C8.30967 12.5844 8.08793 12.5711 7.86612 12.5583C7.64008 12.5453 7.41391 12.5335 7.188 12.519C6.96626 12.5048 6.74458 12.4913 6.52265 12.4805C6.2986 12.4696 6.0748 12.4551 5.85088 12.4422C5.62907 12.4294 5.40733 12.4166 5.18553 12.4038C4.96372 12.391 4.74192 12.3791 4.52018 12.3648C4.45837 12.3608 4.39612 12.3592 4.33483 12.3523C4.18599 12.3353 4.08189 12.256 4.02888 12.1135C4.01996 12.0894 4.01534 12.0637 4 12.0422V11.9393C4.02022 11.9207 4.02221 11.8936 4.03196 11.8701C4.08773 11.736 4.18574 11.6549 4.33117 11.6409C4.45234 11.6293 4.57409 11.6239 4.69558 11.6167C4.9195 11.6034 5.14343 11.5908 5.36735 11.5778C5.58915 11.565 5.81089 11.5517 6.03276 11.5395C6.29943 11.5249 6.56623 11.513 6.83276 11.4964C6.91382 11.4914 6.99488 11.4877 7.07594 11.483C7.25718 11.4725 7.4383 11.4591 7.61954 11.4487C7.80727 11.438 7.99525 11.432 8.18272 11.4184C8.26378 11.4125 8.3449 11.4106 8.42596 11.4056C8.61568 11.3938 8.80546 11.3816 8.99523 11.3705C9.0976 11.3644 9.20016 11.3612 9.30253 11.355C9.55411 11.3397 9.80563 11.3229 10.0572 11.3077C10.279 11.2942 10.5008 11.282 10.7226 11.2693C10.9487 11.2563 11.1748 11.2433 11.4008 11.2303C11.6205 11.2176 11.8401 11.2048 12.0598 11.1922C12.2837 11.1792 12.5077 11.1658 12.7316 11.1535C12.9983 11.1389 13.2651 11.127 13.5316 11.1105C13.6127 11.1055 13.6938 11.1016 13.7748 11.0971C13.9753 11.0858 14.1757 11.0732 14.3761 11.0609C14.3914 11.0599 14.4085 11.0646 14.4236 11.0529C14.4066 11.033 14.3863 11.0251 14.3681 11.0143C13.5101 10.5062 12.652 9.99844 11.794 9.49047C10.901 8.96178 10.008 8.43308 9.11506 7.90432C8.97694 7.82258 8.83806 7.74206 8.70129 7.65813C8.57749 7.58211 8.5144 7.44392 8.53359 7.31442C8.56793 7.0829 8.81604 6.93975 9.03772 7.03359C9.55174 7.25121 10.0695 7.45969 10.586 7.67152C11.5179 8.05372 12.4501 8.43553 13.3821 8.81767C14.0826 9.10486 14.783 9.39225 15.4836 9.679C15.4996 9.68556 15.5159 9.70217 15.5363 9.68743C15.5369 9.66503 15.5212 9.65177 15.5102 9.63665C15.1032 9.07442 14.6957 8.51251 14.2886 7.95041C13.7771 7.24426 13.2659 6.53792 12.7546 5.8317C12.4518 5.41352 12.1516 4.99341 11.8446 4.57832C11.6797 4.35536 11.8109 4.07621 12.0165 4.01719C12.0307 4.01313 12.044 4.00579 12.0578 4C12.1005 4 12.1433 4 12.1861 4C12.281 4.02349 12.3529 4.08136 12.4207 4.14939C14.8772 6.61367 17.3341 9.07744 19.792 11.5404C19.8978 11.6464 19.9805 11.7613 20 11.9138V12.081L19.9999 12.0808Z",
            fill: "black"
        })
    });
};
var $3698078ac83fd1c3$export$2e2bcd8739ae039 = $3698078ac83fd1c3$var$LaunchDarklyIcon;

});

parcelRegister("8GMEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db123cd7b504f9e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $9db123cd7b504f9e$var$PagerDutyIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-731.5",
                y: "-652.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.33974 9.0588C7.33988 9.05866 7.33996 9.05847 7.33996 9.05827C7.33996 7.60876 7.34084 6.15925 7.3382 4.70974C7.3382 4.5796 7.33644 4.4987 7.51495 4.50002C9.30876 4.51057 11.1026 4.49738 12.8964 4.51892C13.9116 4.53123 14.8801 4.77262 15.7546 5.30858C16.8256 5.96414 17.4222 6.94066 17.6117 8.16868C17.8148 9.48551 17.6012 10.7206 16.7918 11.8057C16.1033 12.7294 15.1439 13.2175 14.0285 13.4329C13.3347 13.567 12.6326 13.5846 11.9309 13.5899C10.4668 13.6013 9.00231 13.5912 7.53781 13.5991C7.36414 13.6 7.33557 13.5411 7.33645 13.3859C7.34172 11.9438 7.33952 10.5014 7.33952 9.05933C7.33952 9.05913 7.3396 9.05894 7.33974 9.0588Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.35232 17.4818C7.35232 16.8821 7.35539 16.2819 7.34968 15.6822C7.34836 15.5516 7.36463 15.4905 7.52246 15.4931C8.14414 15.5037 8.76626 15.5024 9.38794 15.4931C9.53215 15.4909 9.55281 15.5415 9.55237 15.6681C9.54798 16.89 9.5471 18.1118 9.55325 19.3333C9.55413 19.4753 9.50841 19.5003 9.37959 19.499C8.75791 19.4929 8.13579 19.4911 7.51411 19.4999C7.3699 19.5021 7.34836 19.452 7.34968 19.3249C7.35583 18.7102 7.35232 18.096 7.35232 17.4813V17.4818Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M9.54312 8.99636C9.54312 8.1834 9.54488 7.37088 9.54093 6.55791C9.54049 6.43788 9.55148 6.37589 9.70184 6.37677C10.7051 6.38424 11.7084 6.36446 12.7113 6.38776C13.2833 6.40095 13.8408 6.53021 14.3464 6.81996C15.0103 7.20028 15.3295 7.79604 15.3967 8.54042C15.4464 9.09221 15.4223 9.63697 15.1853 10.1514C14.8072 10.9723 14.1037 11.3416 13.2675 11.521C12.8942 11.601 12.5143 11.6195 12.1332 11.6195C11.3422 11.619 10.5513 11.612 9.76075 11.6247C9.56818 11.6278 9.53697 11.565 9.53917 11.3913C9.5484 10.5933 9.54312 9.79481 9.54312 8.9968V8.99636Z",
                fill: "#04AB38"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M19.9969 11.9995C19.9969 14.6225 19.9963 17.2458 19.9997 19.8688C19.9997 19.9713 19.985 19.9991 19.8741 19.9987C14.6273 19.995 9.38021 19.995 4.13343 19.9987C4.01562 19.9991 4 19.9684 4 19.8609C4.00312 14.62 4.00312 9.37906 4 4.13812C4 4.03094 4.015 4 4.13343 4C9.37521 4.00406 14.6167 4.00406 19.8584 4C19.98 4 20 4.03187 20 4.14562C19.9966 6.76359 19.9972 9.38125 19.9972 11.9992L19.9969 11.9995Z",
                fill: "#04AB38"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.67927 9.89217C8.67927 8.86191 8.6799 7.83166 8.67802 6.80141C8.67802 6.70891 8.67677 6.65142 8.80364 6.65236C10.0786 6.65985 11.3536 6.65048 12.6286 6.66579C13.3501 6.67454 14.0385 6.84609 14.6601 7.22701C15.4213 7.69292 15.8454 8.38694 15.9801 9.2597C16.1244 10.1956 15.9726 11.0733 15.3973 11.8446C14.9079 12.5011 14.226 12.8479 13.4332 13.001C12.9401 13.0964 12.4411 13.1089 11.9423 13.1126C10.9017 13.1207 9.86081 13.1135 8.81989 13.1192C8.69646 13.1198 8.67615 13.0779 8.67677 12.9676C8.68052 11.9427 8.67896 10.9174 8.67896 9.89248L8.67927 9.89217Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.68845 15.8778C8.68845 15.4515 8.69063 15.025 8.68657 14.5988C8.68563 14.506 8.6972 14.4625 8.80938 14.4644C9.25125 14.4719 9.69343 14.471 10.1353 14.4644C10.2378 14.4629 10.2525 14.4988 10.2522 14.5888C10.249 15.4572 10.2484 16.3256 10.2528 17.1936C10.2534 17.2946 10.2209 17.3124 10.1294 17.3114C9.68749 17.3071 9.24531 17.3058 8.80345 17.3121C8.70095 17.3136 8.68563 17.278 8.68657 17.1877C8.69095 16.7508 8.68845 16.3143 8.68845 15.8775V15.8778Z",
                fill: "#FEFEFE"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M10.2451 9.89333C10.2451 9.31556 10.2463 8.73809 10.2435 8.16031C10.2432 8.075 10.251 8.03094 10.3579 8.03157C11.071 8.03688 11.7841 8.02282 12.4969 8.03938C12.9035 8.04876 13.2997 8.14062 13.6591 8.34655C14.1309 8.61685 14.3578 9.04026 14.4056 9.56929C14.4409 9.96146 14.4237 10.3486 14.2553 10.7142C13.9866 11.2976 13.4866 11.5601 12.8922 11.6876C12.6269 11.7445 12.3569 11.7576 12.086 11.7576C11.5238 11.7573 10.9616 11.7523 10.3998 11.7613C10.2629 11.7635 10.2407 11.7189 10.2423 11.5954C10.2488 11.0283 10.2451 10.4608 10.2451 9.89365V9.89333Z",
                fill: "#04AB38"
            })
        ]
    });
};
var $9db123cd7b504f9e$export$2e2bcd8739ae039 = $9db123cd7b504f9e$var$PagerDutyIcon;

});

parcelRegister("74dAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2db9f138882b352$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $a2db9f138882b352$var$PowerBIIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-602.5",
                y: "-507.5",
                width: "2060",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4031 4H13.1618C12.7971 4 12.5015 4.29563 12.5015 4.66032V19.3397C12.5015 19.7044 12.7971 20 13.1618 20H17.4031C17.7677 20 18.0634 19.7044 18.0634 19.3397V4.66032C18.0634 4.29563 17.7677 4 17.4031 4Z",
                fill: "#B25400"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.787 19.3394V19.9998H9.88542C9.52072 19.9998 9.2251 19.7041 9.2251 19.3394V8.64738C9.2251 8.28268 9.52072 7.98706 9.88542 7.98706H14.1267C14.4914 7.98706 14.787 8.28268 14.787 8.64738V19.3394Z",
                fill: "#DE9800"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3394V19.9998H6.66032C6.29562 19.9998 6 19.7041 6 19.3394V12.6601C6 12.2954 6.29562 11.9998 6.66032 11.9998H10.9016C11.2663 11.9998 11.5619 12.2954 11.5619 12.6601V19.3394Z",
                fill: "#F3CD32"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M17.4032 4H13.1619C12.7972 4 12.5016 4.29563 12.5016 4.66032V19.3397C12.5016 19.7044 12.7972 20 13.1619 20H17.4032C17.7679 20 18.0635 19.7044 18.0635 19.3397V4.66032C18.0635 4.29563 17.7679 4 17.4032 4Z",
                fill: "url(#paint0_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7873 19.3397V20H9.88572C9.52102 20 9.2254 19.7044 9.2254 19.3397V8.64762C9.2254 8.28292 9.52102 7.9873 9.88572 7.9873H14.127C14.4917 7.9873 14.7873 8.28292 14.7873 8.64762V19.3397Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.7873 19.3397V20H9.88572C9.52102 20 9.2254 19.7044 9.2254 19.3397V8.64762C9.2254 8.28292 9.52102 7.9873 9.88572 7.9873H14.127C14.4917 7.9873 14.7873 8.28292 14.7873 8.64762V19.3397Z",
                fill: "url(#paint1_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.5619 19.3397V20H6.66032C6.29562 20 6 19.7044 6 19.3397V12.6603C6 12.2956 6.29562 12 6.66032 12H10.9016C11.2663 12 11.5619 12.2956 11.5619 12.6603V19.3397Z",
                fill: "url(#paint2_linear_384_141)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_384_141",
                        x1: "15.2561",
                        y1: "3.97968",
                        x2: "15.2561",
                        y2: "19.9797",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#EBBB14"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B25400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint1_linear_384_141",
                        x1: "11.9799",
                        y1: "7.93778",
                        x2: "11.9799",
                        y2: "19.9505",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#F9E583"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#DE9800"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint2_linear_384_141",
                        x1: "8.75454",
                        y1: "11.9797",
                        x2: "8.75454",
                        y2: "19.9797",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#F9E68B"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F3CD32"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $a2db9f138882b352$export$2e2bcd8739ae039 = $a2db9f138882b352$var$PowerBIIcon;

});

parcelRegister("dGVh7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad198126728ea2d1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $ad198126728ea2d1$var$ServiceNowIcon = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-539.5",
                y: "-411.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "#292A2E"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0473 4.00178C10.4382 3.99842 8.86528 4.4785 7.53234 5.37978C6.19941 6.28105 5.16796 7.56197 4.57171 9.05646C3.97546 10.5509 3.84191 12.1901 4.18837 13.7614C4.53483 15.3327 5.34532 16.7637 6.51478 17.8688C6.78908 18.13 7.14782 18.2844 7.52608 18.3041C7.90434 18.3237 8.27713 18.2073 8.57701 17.9759C9.56641 17.2396 10.7668 16.842 12.0001 16.842C13.2334 16.842 14.4339 17.2396 15.4233 17.9759C15.726 18.2078 16.1021 18.3232 16.4828 18.301C16.8635 18.2788 17.2236 18.1205 17.4973 17.8549C18.6576 16.7539 19.4626 15.3314 19.8092 13.7698C20.1558 12.2082 20.0282 10.5787 19.4426 9.09017C18.8571 7.60161 17.8404 6.32184 16.5228 5.41488C15.2052 4.50793 13.6467 4.01512 12.0473 3.99963M12.0001 16.0379C11.4713 16.0522 10.9451 15.9586 10.4536 15.7628C9.96216 15.567 9.51573 15.2731 9.1416 14.8991C8.76746 14.525 8.47347 14.0787 8.27754 13.5873C8.08161 13.0959 7.98787 12.5697 8.00202 12.0408C8.00202 10.9805 8.42326 9.96353 9.17305 9.21374C9.92284 8.46395 10.9398 8.04272 12.0001 8.04272C13.0605 8.04272 14.0774 8.46395 14.8272 9.21374C15.577 9.96353 15.9983 10.9805 15.9983 12.0408C16.0124 12.5697 15.9187 13.0959 15.7227 13.5873C15.5268 14.0787 15.2328 14.525 14.8587 14.8991C14.4846 15.2731 14.0381 15.567 13.5467 15.7628C13.0552 15.9586 12.529 16.0522 12.0001 16.0379Z",
                fill: "#62D84E"
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.0473 5.00214C10.4382 4.99878 8.86528 5.47886 7.53234 6.38014C6.19941 7.28142 5.16796 8.56233 4.57171 10.0568C3.97546 11.5513 3.84191 13.1905 4.18837 14.7618C4.53483 16.333 5.34532 17.764 6.51478 18.8692C6.78908 19.1304 7.14782 19.2848 7.52608 19.3044C7.90434 19.3241 8.27713 19.2077 8.57701 18.9763C9.56641 18.24 10.7668 17.8423 12.0001 17.8423C13.2334 17.8423 14.4339 18.24 15.4233 18.9763C15.726 19.2082 16.1021 19.3236 16.4828 19.3013C16.8635 19.2791 17.2236 19.1208 17.4973 18.8553C18.6576 17.7542 19.4626 16.3317 19.8092 14.7702C20.1558 13.2086 20.0282 11.5791 19.4426 10.0905C18.8571 8.60198 17.8404 7.3222 16.5228 6.41525C15.2052 5.50829 13.6467 5.01549 12.0473 5M12.0001 17.0382C11.4713 17.0525 10.9451 16.9589 10.4536 16.7631C9.96216 16.5674 9.51573 16.2735 9.1416 15.8994C8.76746 15.5254 8.47347 15.0791 8.27754 14.5876C8.08161 14.0962 7.98787 13.57 8.00202 13.0412C8.00202 11.9808 8.42326 10.9639 9.17305 10.2141C9.92284 9.46432 10.9398 9.04309 12.0001 9.04309C13.0605 9.04309 14.0774 9.46432 14.8272 10.2141C15.577 10.9639 15.9983 11.9808 15.9983 13.0412C16.0124 13.57 15.9187 14.0962 15.7227 14.5876C15.5268 15.0791 15.2328 15.5254 14.8587 15.8994C14.4846 16.2735 14.0381 16.5674 13.5467 16.7631C13.0552 16.9589 12.529 17.0525 12.0001 17.0382Z",
            fill: "#62D84E"
        })
    });
};
var $ad198126728ea2d1$export$2e2bcd8739ae039 = $ad198126728ea2d1$var$ServiceNowIcon;

});

parcelRegister("bndMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab446c4f11477054$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $ab446c4f11477054$var$AWSS3Icon = ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("title", {
                children: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                id: "Icon-Architecture/64/Arch_Amazon-Simple-Storage-Service_64",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                width: "24",
                height: "24",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        id: "Icon-Architecture-BG/64/Storage",
                        fill: "#7AA116",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            id: "Rectangle",
                            x: "0",
                            y: "0",
                            width: "24",
                            height: "24"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                        id: "Icon-Service/64/Amazon-Simple-Storage-Service_64",
                        transform: "scale(0.3) translate(12.999900, 11.999600)",
                        fill: "#FFFFFF",
                        width: "24",
                        height: "24",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                            d: "M47.836,30.893 L48.22,28.189 C51.761,30.31 51.807,31.186 51.8060132,31.21 C51.8,31.215 51.196,31.719 47.836,30.893 L47.836,30.893 Z M45.893,30.353 C39.773,28.501 31.25,24.591 27.801,22.961 C27.801,22.947 27.805,22.934 27.805,22.92 C27.805,21.595 26.727,20.517 25.401,20.517 C24.077,20.517 22.999,21.595 22.999,22.92 C22.999,24.245 24.077,25.323 25.401,25.323 C25.983,25.323 26.511,25.106 26.928,24.761 C30.986,26.682 39.443,30.535 45.608,32.355 L43.17,49.561 C43.163,49.608 43.16,49.655 43.16,49.702 C43.16,51.217 36.453,54 25.494,54 C14.419,54 7.641,51.217 7.641,49.702 C7.641,49.656 7.638,49.611 7.632,49.566 L2.538,12.359 C6.947,15.394 16.43,17 25.5,17 C34.556,17 44.023,15.4 48.441,12.374 L45.893,30.353 Z M2,8.478 C2.072,7.162 9.634,2 25.5,2 C41.364,2 48.927,7.161 49,8.478 L49,8.927 C48.13,11.878 38.33,15 25.5,15 C12.648,15 2.843,11.868 2,8.913 L2,8.478 Z M51,8.5 C51,5.035 41.066,0 25.5,0 C9.934,0 0,5.035 0,8.5 L0.094,9.254 L5.642,49.778 C5.775,54.31 17.861,56 25.494,56 C34.966,56 45.029,53.822 45.159,49.781 L47.555,32.884 C48.888,33.203 49.985,33.366 50.866,33.366 C52.049,33.366 52.849,33.077 53.334,32.499 C53.732,32.025 53.884,31.451 53.77,30.84 C53.511,29.456 51.868,27.964 48.522,26.055 L50.898,9.293 L51,8.5 Z",
                            id: "Amazon-Simple-Storage-Service-Icon_64_Squid"
                        })
                    })
                ]
            })
        ]
    });
var $ab446c4f11477054$export$2e2bcd8739ae039 = $ab446c4f11477054$var$AWSS3Icon;

});

parcelRegister("g6dt5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e09550576c833cf$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $6e09550576c833cf$export$e16bd899bb4eebf9 = ()=>{
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "-587.5",
                y: "-28.5",
                width: "1941",
                height: "891",
                rx: "4.5",
                stroke: "#9747FF",
                strokeDasharray: "10 5"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                width: "24",
                height: "24",
                rx: "6",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "0.381243",
                y: "0.381243",
                width: "23.2375",
                height: "23.2375",
                rx: "5.61876",
                stroke: "#0B1228",
                strokeOpacity: "0.14",
                strokeWidth: "0.762486"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M5.20962 17.0782L5.91523 18.2907C6.06186 18.546 6.27262 18.7466 6.52005 18.8925L9.04009 14.5529H4C4 14.8355 4.07331 15.1181 4.21993 15.3734L5.20962 17.0782Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 9.44751L9.47995 5.10791C9.23253 5.25378 9.02176 5.45435 8.87514 5.70962L4.21993 13.7324C4.07601 13.9822 4.00019 14.265 4 14.5529H9.04009L12 9.44751Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.4799 18.8925C17.7273 18.7466 17.9381 18.546 18.0847 18.2907L18.3779 17.7893L19.78 15.3734C19.9266 15.1181 19.9999 14.8355 19.9999 14.5529H14.9595L16.032 16.6497L17.4799 18.8925Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M12 9.4475L14.5201 5.1079C14.2726 4.96203 13.9886 4.8891 13.6953 4.8891H10.3047C10.0115 4.8891 9.7274 4.97115 9.47998 5.1079L12 9.4475Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M14.9594 14.5529H9.03958L6.51953 18.8925C6.76695 19.0383 7.05103 19.1113 7.34427 19.1113H16.6547C16.9479 19.1113 17.232 19.0292 17.4794 18.8925L14.9594 14.5529Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        d: "M17.4525 9.72101L15.1249 5.70962C14.9782 5.45435 14.7675 5.25378 14.52 5.10791L12 9.44751L14.9599 14.5529H19.9908C19.9908 14.2703 19.9175 13.9877 19.7709 13.7324L17.4525 9.72101Z",
                        fill: "#FFBA00"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("g", {
                clipPath: "url(#clip0_271_181643)",
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                    clipPath: "url(#clip1_271_181643)",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white",
                            fillOpacity: "0.01"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                            clipPath: "url(#clip2_271_181643)",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
                                    fill: "#0066DA"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
                                    fill: "#00AC47"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
                                    fill: "#EA4335"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
                                    fill: "#00832D"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
                                    fill: "#2684FC"
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                                    d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
                                    fill: "#FFBA00"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip0_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip1_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                        id: "clip2_271_181643",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                            width: "20",
                            height: "18.3333",
                            fill: "white",
                            transform: "translate(2 2.83325)"
                        })
                    })
                ]
            })
        ]
    });
};
var $6e09550576c833cf$export$2e2bcd8739ae039 = $6e09550576c833cf$export$e16bd899bb4eebf9;

});

parcelRegister("fPxww", function(module, exports) {

$parcel$export(module.exports, "getLogoVersion", () => $9dca3af2d039b729$export$f2e275790a265e16);
$parcel$export(module.exports, "get3PLogo", () => $9dca3af2d039b729$export$fab9faef3411dc6c);
$parcel$export(module.exports, "RovoLogoFromLogo", () => $9dca3af2d039b729$export$32db889b380fa03c);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $id7ja = parcelRequire("id7ja");
const $9dca3af2d039b729$var$iconContainerStyles = {
    small: (0, $ecnYn.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $ecnYn.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $ecnYn.xcss)({
        width: '40px',
        height: '40px'
    }),
    xlarge: (0, $ecnYn.xcss)({
        width: '48px',
        height: '48px'
    })
};
const $9dca3af2d039b729$var$t25IconContainerStyles = {
    small: (0, $ecnYn.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $ecnYn.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $ecnYn.xcss)({
        width: '32px',
        height: '32px'
    }),
    //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
    xlarge: (0, $ecnYn.xcss)({
        width: '32x',
        height: '32px'
    })
};
const $9dca3af2d039b729$var$iconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
function $9dca3af2d039b729$export$f2e275790a265e16(t25LogoComponent, LogoComponent) {
    return (0, $dh538.fg)('platform-team25-app-icon-tiles') ? t25LogoComponent : LogoComponent;
}
function $9dca3af2d039b729$export$fab9faef3411dc6c(iconGlyph, iconLabel) {
    return (0, $dh538.fg)('rovo_search_custom_icon_component') ? $9dca3af2d039b729$export$dae027fade2c6d1d(iconGlyph, iconLabel) : $9dca3af2d039b729$export$7b66a86355afbb91(iconGlyph, iconLabel);
}
const $9dca3af2d039b729$export$1776e6671850176d = ({ glyph: SVG, label: label, size: size })=>{
    const useT25Styles = (0, $dh538.fg)('platform-team25-app-icon-tiles');
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: [
            useT25Styles ? $9dca3af2d039b729$var$t25IconContainerStyles[size] : $9dca3af2d039b729$var$iconContainerStyles[size],
            $9dca3af2d039b729$var$iconStyles
        ],
        "aria-label": label,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(SVG, {})
    });
};
const $9dca3af2d039b729$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: "small",
            appearance: "brand"
        });
    };
};
const $9dca3af2d039b729$export$dae027fade2c6d1d = (glyph, defaultLabel = '')=>{
    return ({ label: label = defaultLabel })=>/*#__PURE__*/ (0, $7UHDa.jsx)($9dca3af2d039b729$export$1776e6671850176d, {
            label: label,
            glyph: glyph,
            size: "medium"
        });
};
const $9dca3af2d039b729$export$7b66a86355afbb91 = (glyph, defaultLabel = '')=>{
    return ({ label: label = defaultLabel, testId: testId })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
            label: label,
            testId: testId,
            glyph: glyph,
            size: "medium"
        });
    };
};

});




parcelRegister("lfOhG", function(module, exports) {

$parcel$export(module.exports, "useCurrentProductHasFilters", () => $22c6390f7332d66f$export$7fe06de49ac4bced);
$parcel$export(module.exports, "useGetCurrentProductFilters", () => $22c6390f7332d66f$export$1f8e3e68f7016027);
$parcel$export(module.exports, "useCurrentProductHasAppliedFilters", () => $22c6390f7332d66f$export$75dfe0d9a43fb0ea);
$parcel$export(module.exports, "useCurrentProductGenericSelectedFilterCount", () => $22c6390f7332d66f$export$b5ddd6b67ba52fed);

var $fJRVo = parcelRequire("fJRVo");

var $cgH2x = parcelRequire("cgH2x");

var $88j1D = parcelRequire("88j1D");
const $22c6390f7332d66f$export$7fe06de49ac4bced = ()=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    return !!(product && filterDefinitions[product.id]?.length > 0);
};
const $22c6390f7332d66f$export$1f8e3e68f7016027 = ()=>{
    const { getActiveProduct: getActiveProduct } = (0, $fJRVo.useProductContext)();
    const product = getActiveProduct();
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    return product && filterDefinitions[product.id] || [];
};
const $22c6390f7332d66f$export$75dfe0d9a43fb0ea = ()=>{
    const filters = $22c6390f7332d66f$export$1f8e3e68f7016027();
    let hasFilters = false;
    filters.forEach((filter)=>{
        filter.store.availableFilters.forEach((option)=>{
            if (option.isChecked && option.id !== (0, $88j1D.DEFAULT_OPTION)) hasFilters = true;
        });
    });
    return hasFilters;
};
const $22c6390f7332d66f$export$b5ddd6b67ba52fed = ()=>{
    const filters = $22c6390f7332d66f$export$1f8e3e68f7016027();
    const genericFilters = filters.filter((filter)=>filter['@type'] !== (0, $88j1D.SITE_FILTER_TYPE_NAME));
    return genericFilters.reduce((filterCount, nextFilter)=>nextFilter.store.availableFilters.filter((f)=>f.isChecked).length + filterCount, 0);
};

});


parcelRegister("6BCmY", function(module, exports) {

let $4cf3f630ee6ca913$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4cf3f630ee6ca913$var$load("1Ojgx").then(()=>parcelRequire('4E1b5'));

});




parcelRegister("48BnN", function(module, exports) {

$parcel$export(module.exports, "useAppliedFilters", () => $20c4d524183fb4e9$export$51b04ed1f44b6aaf);

var $88j1D = parcelRequire("88j1D");

var $cgH2x = parcelRequire("cgH2x");
const $20c4d524183fb4e9$export$51b04ed1f44b6aaf = (activeProductId)=>{
    const { filterDefinitions: filterDefinitions } = (0, $cgH2x.useGenericFilters)();
    let appliedFilters = [];
    // Find all of the filters that apply to the current product
    const filters = filterDefinitions[activeProductId];
    if (filters !== undefined) filters.forEach((filter)=>{
        // filters with specified value mapping logic should implement it, else use generic logic
        if (filter.mapSelectionToAppliedValue) {
            const valueToApply = filter.mapSelectionToAppliedValue();
            !!valueToApply && appliedFilters.push(valueToApply);
        } else {
            let applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.id);
            // if no site filters are applied, the search should use the top 3 available sites
            if (filter['@type'] === (0, $88j1D.SITE_FILTER_TYPE_NAME) && applied.length === 0) applied = filter.store.availableFilters.slice(0, 3).map((filter)=>filter.id);
            if (filter['@type'] === 'spaces') applied = filter.store.availableFilters.filter((option)=>option.isChecked).map((filter)=>filter.spaceKey || '');
            if (applied.length > 0) appliedFilters.push({
                '@type': filter['@type'],
                [filter.fieldName]: applied
            });
        }
    });
    return appliedFilters;
};

});

parcelRegister("gMIQ9", function(module, exports) {

$parcel$export(module.exports, "ActiveProductProvider", () => $08c163fce83bd841$export$8cce9f9e667fae48);

var $gwFzn = parcelRequire("gwFzn");

var $fJRVo = parcelRequire("fJRVo");

var $80L9g = parcelRequire("80L9g");
const $08c163fce83bd841$export$8cce9f9e667fae48 = ({ children: children })=>{
    const { getActiveProduct: getActiveProduct, getDefaultAIConfig: getDefaultAIConfig } = (0, $fJRVo.useProductContext)();
    const { showSearchAIDialog: showSearchAIDialog, toggleShowSearchAIDialog: toggleShowSearchAIDialog } = (0, $80L9g.useSessionUserInput)();
    const onCloseAIDialog = (0, $gwFzn.useCallback)(()=>{
        toggleShowSearchAIDialog(false);
    }, [
        toggleShowSearchAIDialog
    ]);
    const defaultAIConfig = getDefaultAIConfig();
    return children({
        activeProduct: getActiveProduct(),
        showSearchAIDialog: showSearchAIDialog,
        onCloseAIDialog: onCloseAIDialog,
        defaultAIConfig: defaultAIConfig
    });
};

});

parcelRegister("64EAe", function(module, exports) {

$parcel$export(module.exports, "ProductSearchDialogWrapper", () => $51e1c9118342ae7a$export$99f979ec765e5f8f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $7DA0P = parcelRequire("7DA0P");

var $gF7Az = parcelRequire("gF7Az");

var $amrMu = parcelRequire("amrMu");
const $51e1c9118342ae7a$export$99f979ec765e5f8f = ({ children: children, shouldFillContainer: shouldFillContainer })=>{
    const { isExpanded: isExpanded } = (0, $gF7Az.useDialogExpansionContext)();
    const { quickFind: quickFind } = (0, $amrMu.useFeaturesContext)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7DA0P.SearchDialog), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        style: {
            boxShadow: isExpanded ? undefined : 'none',
            borderRadius: quickFind?.enabled ? "var(--ds-space-100, 8px)" : undefined
        },
        children: children
    });
};

});

parcelRegister("9tyGI", function(module, exports) {

let $6e61bacfd23691e1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6e61bacfd23691e1$var$load("900yZ"),
    $6e61bacfd23691e1$var$load("ej4rO"),
    $6e61bacfd23691e1$var$load("c7DhJ"),
    $6e61bacfd23691e1$var$load("kg7uf"),
    $6e61bacfd23691e1$var$load("6BjKx"),
    $6e61bacfd23691e1$var$load("63hQz"),
    $6e61bacfd23691e1$var$load("b886X"),
    $6e61bacfd23691e1$var$load("9jfSP"),
    $6e61bacfd23691e1$var$load("7JX0n"),
    $6e61bacfd23691e1$var$load("3oVYt"),
    $6e61bacfd23691e1$var$load("9aAXz"),
    $6e61bacfd23691e1$var$load("42Txt"),
    $6e61bacfd23691e1$var$load("1LhCD"),
    $6e61bacfd23691e1$var$load("3zuUe"),
    $6e61bacfd23691e1$var$load("griel"),
    $6e61bacfd23691e1$var$load("hWdy3"),
    $6e61bacfd23691e1$var$load("e65TP"),
    $6e61bacfd23691e1$var$load("8oWxD"),
    $6e61bacfd23691e1$var$load("eruLw"),
    $6e61bacfd23691e1$var$load("laQtb"),
    $6e61bacfd23691e1$var$load("lN5yU"),
    $6e61bacfd23691e1$var$load("3JJHk"),
    $6e61bacfd23691e1$var$load("iRpFz"),
    $6e61bacfd23691e1$var$load("awc2s"),
    $6e61bacfd23691e1$var$load("boDjZ"),
    $6e61bacfd23691e1$var$load("iabhK"),
    $6e61bacfd23691e1$var$load("1phY7"),
    $6e61bacfd23691e1$var$load("26Id4"),
    $6e61bacfd23691e1$var$load("cKARL"),
    $6e61bacfd23691e1$var$load("jr5ZC"),
    $6e61bacfd23691e1$var$load("deN0E"),
    $6e61bacfd23691e1$var$load("hwHcA"),
    $6e61bacfd23691e1$var$load("bku9v"),
    $6e61bacfd23691e1$var$load("jCu7l"),
    $6e61bacfd23691e1$var$load("7orLM"),
    $6e61bacfd23691e1$var$load("jmPIf"),
    $6e61bacfd23691e1$var$load("hqRk3"),
    $6e61bacfd23691e1$var$load("2KkrK"),
    $6e61bacfd23691e1$var$load("hYWtF"),
    $6e61bacfd23691e1$var$load("b0HBF"),
    $6e61bacfd23691e1$var$load("emd3r"),
    $6e61bacfd23691e1$var$load("kQvbt"),
    $6e61bacfd23691e1$var$load("he20F"),
    $6e61bacfd23691e1$var$load("f96v0"),
    $6e61bacfd23691e1$var$load("6Nh0d"),
    $6e61bacfd23691e1$var$load("gQSWJ"),
    $6e61bacfd23691e1$var$load("ekztv"),
    $6e61bacfd23691e1$var$load("dUEf9"),
    $6e61bacfd23691e1$var$load("hGmYF"),
    $6e61bacfd23691e1$var$load("3NE3l"),
    $6e61bacfd23691e1$var$load("hoUEM"),
    $6e61bacfd23691e1$var$load("g7pmM"),
    $6e61bacfd23691e1$var$load("iDzuf"),
    $6e61bacfd23691e1$var$load("i8IR3"),
    $6e61bacfd23691e1$var$load("15APZ"),
    $6e61bacfd23691e1$var$load("bzjLG"),
    $6e61bacfd23691e1$var$load("2w2Fa"),
    $6e61bacfd23691e1$var$load("9QvHa"),
    $6e61bacfd23691e1$var$load("3ooAX"),
    $6e61bacfd23691e1$var$load("4lfDj"),
    $6e61bacfd23691e1$var$load("dTsOE"),
    $6e61bacfd23691e1$var$load("hlqS1"),
    $6e61bacfd23691e1$var$load("l42ar"),
    $6e61bacfd23691e1$var$load("abVVB"),
    $6e61bacfd23691e1$var$load("8Xuep"),
    $6e61bacfd23691e1$var$load("b1gz4"),
    $6e61bacfd23691e1$var$load("3c6qD"),
    $6e61bacfd23691e1$var$load("fKONs"),
    $6e61bacfd23691e1$var$load("j2OLf"),
    $6e61bacfd23691e1$var$load("f28kH"),
    $6e61bacfd23691e1$var$load("47wm8"),
    $6e61bacfd23691e1$var$load("dzfxi"),
    $6e61bacfd23691e1$var$load("7OtNC"),
    $6e61bacfd23691e1$var$load("k6H7B"),
    $6e61bacfd23691e1$var$load("bZO0a"),
    $6e61bacfd23691e1$var$load("4x0L6"),
    $6e61bacfd23691e1$var$load("eHVyt"),
    $6e61bacfd23691e1$var$load("7jSfd"),
    $6e61bacfd23691e1$var$load("4HZlX"),
    $6e61bacfd23691e1$var$load("dPdkf"),
    $6e61bacfd23691e1$var$load("icyPI"),
    $6e61bacfd23691e1$var$load("kDqHr"),
    $6e61bacfd23691e1$var$load("aTu7U"),
    $6e61bacfd23691e1$var$load("cMkgU"),
    $6e61bacfd23691e1$var$load("9Rd6U"),
    $6e61bacfd23691e1$var$load("2S1L6"),
    $6e61bacfd23691e1$var$load("g9CVe"),
    $6e61bacfd23691e1$var$load("410C5"),
    $6e61bacfd23691e1$var$load("5wcLJ"),
    $6e61bacfd23691e1$var$load("6UnNI"),
    $6e61bacfd23691e1$var$load("U7y88"),
    $6e61bacfd23691e1$var$load("fEx3B"),
    $6e61bacfd23691e1$var$load("dJQEi"),
    $6e61bacfd23691e1$var$load("6qah4"),
    $6e61bacfd23691e1$var$load("4aLlP"),
    $6e61bacfd23691e1$var$load("c6MKV"),
    $6e61bacfd23691e1$var$load("aZinD"),
    $6e61bacfd23691e1$var$load("6Z8WE"),
    $6e61bacfd23691e1$var$load("fiCwF")
]).then(()=>parcelRequire('bDy3t'));

});


parcelRegister("2evZZ", function(module, exports) {

$parcel$export(module.exports, "OpsgenieTab", () => $6cbf2f1ae9737b11$export$7571e7fdcc46c96b);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $5CiaV = parcelRequire("5CiaV");

var $bF0iL = parcelRequire("bF0iL");

var $6GxJO = parcelRequire("6GxJO");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $iWkic = parcelRequire("iWkic");

var $cYpQr = parcelRequire("cYpQr");

var $crAJ1 = parcelRequire("crAJ1");

var $eztGN = parcelRequire("eztGN");

var $iEwUU = parcelRequire("iEwUU");

var $3Z7LN = parcelRequire("3Z7LN");

var $4mZlP = parcelRequire("4mZlP");

var $4mZlP = parcelRequire("4mZlP");
const $6cbf2f1ae9737b11$var$OPSGENIE_PRODUCT_ID = 'opsgenie';
const $6cbf2f1ae9737b11$export$864cff1b26c75e89 = (alert)=>{
    return {
        title: alert.message,
        id: alert.id,
        meta: alert.status.charAt(0).toUpperCase() + alert.status.slice(1),
        url: alert.link,
        iconUrl: alert.iconURI,
        containerId: '' // no conatiner
    };
};
const $6cbf2f1ae9737b11$export$527d10d7fdeeea4e = ({ intl: intl, cloudId: cloudId, generateAdvancedSearchUrl: overriddenGenerateAdvancedSearchUrl, hostUrl: hostUrl, postQueryItemSupplier: postQueryItemSupplier, preQueryItemSupplier: preQueryItemSupplier, ...rest })=>{
    const urlGeneratorArguments = (0, $gwFzn.useMemo)(()=>({
            cloudId: cloudId,
            hostUrl: hostUrl
        }), [
        cloudId,
        hostUrl
    ]);
    const { viewAllLinkGenerator: viewAllLinkGenerator, urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen } = (0, $cYpQr.useOpsgenieURLGenerators)(urlGeneratorArguments);
    const sections = [
        {
            id: (0, $iWkic.OpsgenieScope).OpsgenieAlert,
            title: intl.formatMessage((0, $6GxJO.messages).opsgenie_alerts_heading),
            scope: (0, $iWkic.OpsgenieScope).OpsgenieAlert,
            showResultCount: true,
            viewAllLinkGenerator: viewAllLinkGenerator,
            resultMapper: ({ results: results })=>results.map((value)=>$6cbf2f1ae9737b11$export$864cff1b26c75e89(value))
        }
    ];
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)($6cbf2f1ae9737b11$var$OPSGENIE_PRODUCT_ID, sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const preQuerySectionTitleGenerator = (0, $gwFzn.useCallback)((section)=>section.id === (0, $iWkic.OpsgenieScope).OpsgenieAlert ? intl.formatMessage((0, $6GxJO.messages).opsgenie_recent_alerts) : '', [
        intl
    ]);
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink && orgId) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return overriddenGenerateAdvancedSearchUrl?.(query, baseUrl, usage) || viewAllLinkGenerator(query);
    }, [
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id,
        overriddenGenerateAdvancedSearchUrl,
        viewAllLinkGenerator
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        expandedStateInputPlaceholder: intl.formatMessage((0, $6GxJO.messages).opsgenie_expanded_input_placeholder),
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        id: $6cbf2f1ae9737b11$var$OPSGENIE_PRODUCT_ID,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        sections: sections,
        title: intl.formatMessage((0, $bF0iL.messages).opsgenie_tab_label),
        urlGeneratorForNoResultsScreen: urlGeneratorForNoResultsScreen,
        ...rest,
        ...itemSuppliers,
        children: ()=>{
            return {
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                                    ...rest,
                                    searchFooterLabel: intl.formatMessage((0, $6GxJO.messages).opsgenie_advanced_search),
                                    returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {}) : undefined
                                })
                            }),
                            showAtlassianHomeSearchLink && orgId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                    orgId: orgId,
                                    cloudId: cloudId,
                                    showModifierIcon: true
                                })
                            })
                        ]
                    })
            };
        }
    });
};
const $6cbf2f1ae9737b11$export$7571e7fdcc46c96b = (0, $js7oX.default)($6cbf2f1ae9737b11$export$527d10d7fdeeea4e);

});
parcelRegister("6GxJO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8b3e3400ae6f3971$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $8b3e3400ae6f3971$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /*
   * Opsgenie
   */ opsgenie_expanded_input_placeholder: {
        id: "product_search_dialog.opsgenie.expanded.input-placeholder",
        defaultMessage: "Search Opsgenie"
    },
    opsgenie_recent_alerts: {
        id: "product_search_dialog.opsgenie.opsgenie_recent_alerts",
        defaultMessage: "Recent Alerts"
    },
    opsgenie_alerts_heading: {
        id: "product_search_dialog.opsgenie.alert_heading",
        defaultMessage: "Alerts"
    },
    opsgenie_advanced_search: {
        id: "product_search_dialog.opsgenie.advanced_search",
        defaultMessage: "Advanced alert search"
    }
});

});

parcelRegister("iWkic", function(module, exports) {

$parcel$export(module.exports, "OpsgenieScope", () => $57b4f9c3ea98ed8b$export$dc14148e3ded2998);
var $57b4f9c3ea98ed8b$export$dc14148e3ded2998 = /*#__PURE__*/ function(OpsgenieScope) {
    OpsgenieScope["OpsgenieAlert"] = "opsgenie.alert";
    return OpsgenieScope;
}({});

});

parcelRegister("cYpQr", function(module, exports) {

$parcel$export(module.exports, "useOpsgenieURLGenerators", () => $ddbd2b3a958b61d9$export$c78c65c0f344862e);

var $gwFzn = parcelRequire("gwFzn");
const $ddbd2b3a958b61d9$var$getOpsgenieAggregatorRedirectUrl = ({ cloudId: cloudId, hostUrl: hostUrl = '' })=>{
    return `${hostUrl}/gateway/api/xpsearch-aggregator/redirect/advanced/opsgenie/${cloudId}`;
};
const $ddbd2b3a958b61d9$export$c78c65c0f344862e = (arg)=>{
    const opsgenieAggregatorRedirector = (0, $gwFzn.useCallback)((query)=>`${$ddbd2b3a958b61d9$var$getOpsgenieAggregatorRedirectUrl(arg)}?query=${query}`, [
        arg
    ]);
    return {
        viewAllLinkGenerator: opsgenieAggregatorRedirector,
        urlGeneratorForNoResultsScreen: opsgenieAggregatorRedirector
    };
};

});


parcelRegister("29ccb", function(module, exports) {

$parcel$export(module.exports, "TownsquareTab", () => $3dc7d02d49b2e18c$export$b2c9c8ae315d8935);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $acrNX = parcelRequire("acrNX");

var $lF5IG = parcelRequire("lF5IG");

var $3hux3 = parcelRequire("3hux3");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $cgH2x = parcelRequire("cgH2x");

var $9zyYG = parcelRequire("9zyYG");

var $1rta3 = parcelRequire("1rta3");

var $cqziK = parcelRequire("cqziK");

var $lzcvT = parcelRequire("lzcvT");

var $c6GJD = parcelRequire("c6GJD");

var $crAJ1 = parcelRequire("crAJ1");

var $eztGN = parcelRequire("eztGN");

var $iEwUU = parcelRequire("iEwUU");

var $3Z7LN = parcelRequire("3Z7LN");

var $kmpep = parcelRequire("kmpep");
const $3dc7d02d49b2e18c$var$defaultPermissionsSupplier = ()=>{
    const response = Object.values((0, $cqziK.TownsquareScope));
    return Promise.resolve(response);
};
const $3dc7d02d49b2e18c$export$e502dfe73eec1c84 = ({ intl: intl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, userTeamConfig: userTeamConfig, workspaces: workspaces, atlasClientBaseUrlOverride: atlasClientBaseUrlOverride, organizationId: organizationId, ...rest })=>{
    const [isGlobalExperienceWorkspace, setGlobalExperienceWorkspace] = (0, $gwFzn.useState)();
    const { atlasWorkspaces: atlasWorkspaces } = (0, $lF5IG.useSearchConfigContext)();
    if (!workspaces) workspaces = atlasWorkspaces;
    const siteFilterDefinition = (0, $cgH2x.useSiteFilterDefinition)(workspaces, (0, $1rta3.TOWNSQUARE_PRODUCT_ID));
    const { preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams, postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams, preQuerySectionTitleGenerator: preQuerySectionTitleGenerator } = (0, $1rta3.useTownsquareSuppliers)({
        userTeamConfig: userTeamConfig,
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier,
        workspaces: workspaces,
        isGlobalExperienceWorkspace: isGlobalExperienceWorkspace
    });
    const { defineFilters: defineFilters } = (0, $cgH2x.useGenericFilters)();
    defineFilters((0, $1rta3.TOWNSQUARE_PRODUCT_ID), siteFilterDefinition);
    (0, $gwFzn.useEffect)(()=>{
        (0, $acrNX.isGlobalExperienceWorkspaceForCloudId)(userTeamConfig?.context.siteId, atlasClientBaseUrlOverride).then((result)=>{
            setGlobalExperienceWorkspace(result);
        }).catch(()=>{
            setGlobalExperienceWorkspace(false);
        });
    }, [
        atlasClientBaseUrlOverride,
        userTeamConfig?.context.siteId
    ]);
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const generateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, _, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return '';
    }, [
        orgId,
        cloudId,
        showAtlassianHomeSearchLink,
        primaryProduct?.id
    ]);
    let permissionSupplier = workspaces && workspaces.length > 0 || isGlobalExperienceWorkspace ? $3dc7d02d49b2e18c$var$defaultPermissionsSupplier : rest.permissionSupplier;
    if (isGlobalExperienceWorkspace === undefined) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        ...rest,
        id: (0, $1rta3.TOWNSQUARE_PRODUCT_ID),
        expandedStateInputPlaceholder: intl.formatMessage(isGlobalExperienceWorkspace ? (0, $3hux3.messages).townsquare_search_input_expanded_placeholder : (0, $3hux3.messages).atlas_search_input_expanded_placeholder),
        sections: (0, $9zyYG.getSections)(intl, workspaces, isGlobalExperienceWorkspace, userTeamConfig?.context.organizationId),
        title: intl.formatMessage(isGlobalExperienceWorkspace ? (0, $3hux3.messages).townsquare_globex_tab_label : (0, $3hux3.messages).townsquare_tab_label),
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        workspaces: workspaces,
        permissionSupplier: permissionSupplier,
        generateAdvancedSearchUrl: generateAdvancedSearchUrl,
        children: ()=>{
            return {
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                        children: showAtlassianHomeSearchLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                                orgId: orgId,
                                cloudId: cloudId,
                                showModifierIcon: true
                            })
                        })
                    })
            };
        }
    });
};
const $3dc7d02d49b2e18c$export$485492c388dcd81e = (props)=>{
    if ((0, $c6GJD.default).initializeCompleted() && (0, $c6GJD.default).checkGate('ignore_atlas_product_search_dialog_on_fedramp') && (0, $lzcvT.isFedRamp)()) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($3dc7d02d49b2e18c$export$e502dfe73eec1c84, {
        ...props
    });
};
const $3dc7d02d49b2e18c$export$b2c9c8ae315d8935 = (0, $js7oX.default)($3dc7d02d49b2e18c$export$485492c388dcd81e);

});
parcelRegister("acrNX", function(module, exports) {

$parcel$export(module.exports, "isGlobalExperienceWorkspaceForCloudId", () => $b276001131c7a99f$export$d39036e5b47a0af);
function $b276001131c7a99f$var$getServiceUrl(cloudId, baseUrlOverride) {
    const path = `/gateway/api/townsquare/s/${cloudId}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`;
    if (baseUrlOverride) return `${baseUrlOverride}${path}`;
    return path;
}
async function $b276001131c7a99f$export$d39036e5b47a0af(cloudId, baseUrlOverride) {
    if (cloudId === undefined) return false;
    try {
        const response = await fetch($b276001131c7a99f$var$getServiceUrl(cloudId, baseUrlOverride), {
            credentials: 'include'
        });
        if (response.ok) {
            const workspaceType = await response.text();
            return workspaceType === 'GLOBAL_EXPERIENCE';
        }
        return false;
    } catch (err) {
        return false;
    }
}

});

parcelRegister("3hux3", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea6f0aa982c7afdb$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $ea6f0aa982c7afdb$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /*
   * Atlas, formerly known as Team Central or Townsquare
   */ atlas_search_input_expanded_placeholder: {
        id: "product_search_dialog.atlas.search_input_expanded_placeholder",
        defaultMessage: "Search Atlas"
    },
    townsquare_search_input_expanded_placeholder: {
        id: "product_search_dialog.townsquare.search_input_expanded_placeholder",
        defaultMessage: "Search Home"
    },
    townsquare_tab_label: {
        id: "cross_product_search_dialog.townsquare_tab_label",
        defaultMessage: "Atlas"
    },
    townsquare_globex_tab_label: {
        id: "cross_product_search_dialog.townsquare_globex_tab_label",
        defaultMessage: "Home"
    },
    townsquare_recent_projects: {
        id: "cross_product_search_dialog.townsquare_recent_projects",
        defaultMessage: "Recent Projects"
    },
    townsquare_recent_goals: {
        id: "cross_product_search_dialog.townsquare_recent_goals",
        defaultMessage: "Recent Goals"
    },
    townsquare_recent_help_links: {
        id: "cross_product_search_dialog.townsquare_recent_help_links",
        defaultMessage: "Recent Help Links"
    },
    townsquare_recent_learnings_risks_decisions: {
        id: "cross_product_search_dialog.townsquare_recent_learnings_risks_decisions",
        defaultMessage: "Recent Learnings, Risks and Decisions"
    },
    townsquare_recent_topics: {
        id: "product_search_dialog.townsquare_recent_topics",
        defaultMessage: "Recent Topics"
    },
    townsquare_recent_people: {
        id: "product_search_dialog.townsquare_recent_people",
        defaultMessage: "Recent People"
    },
    townsquare_projects_heading: {
        id: "product_search_dialog.townsquare_projects_heading",
        defaultMessage: "Projects"
    },
    townsquare_projects_view_all: {
        id: "product_search_dialog.townsquare_projects_view_all",
        defaultMessage: "Search all projects"
    },
    townsquare_goals_heading: {
        id: "product_search_dialog.townsquare_goals_heading",
        defaultMessage: "Goals"
    },
    townsquare_goals_view_all: {
        id: "product_search_dialog.townsquare_goals_view_all",
        defaultMessage: "Search all goals"
    },
    townsquare_help_links_heading: {
        id: "product_search_dialog.townsquare_help_links_heading",
        defaultMessage: "Help Links"
    },
    townsquare_topics_heading: {
        id: "product_search_dialog.townsquare_topics_heading",
        defaultMessage: "Topics"
    },
    townsquare_topics_view_all: {
        id: "product_search_dialog.townsquare_topics_view_all",
        defaultMessage: "Search all topics"
    },
    townsquare_learnings_risks_decisions_heading: {
        id: "product_search_dialog.townsquare_learnings_risks_decisions_heading",
        defaultMessage: "Learnings, Risks and Decisions"
    },
    townsquare_people_heading: {
        id: "product_search_dialog.townsquare_people_heading",
        defaultMessage: "People"
    },
    townsquare_people_view_all: {
        id: "product_search_dialog.townsquare_people_view_all",
        defaultMessage: "Search all people"
    },
    townsquare_teams_heading: {
        id: "product_search_dialog.townsquare_teams_heading",
        defaultMessage: "Teams"
    },
    townsquare_teams_view_all: {
        id: "product_search_dialog.townsquare_teams_view_all",
        defaultMessage: "Search all teams"
    }
});

});

parcelRegister("9zyYG", function(module, exports) {

$parcel$export(module.exports, "MAX_ITEMS_PER_SECTION", () => $ad01931f226af666$export$ece7c64a85a33d85);
$parcel$export(module.exports, "getSections", () => $ad01931f226af666$export$ddbcae0b0bd6b092);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $3hux3 = parcelRequire("3hux3");

var $cqziK = parcelRequire("cqziK");

var $fjD79 = parcelRequire("fjD79");
let $ad01931f226af666$var$defaultTownsquareResultMapper = ({ results: results })=>results.map((value)=>$ad01931f226af666$var$mapAggregatorResponseToSearchItem(value)).slice(0, $ad01931f226af666$export$ece7c64a85a33d85);
const $ad01931f226af666$export$ece7c64a85a33d85 = 3;
const $ad01931f226af666$var$mapAggregatorResponseToSearchItem = (response)=>{
    if ('account_id' in response) return {
        title: response.name,
        id: response.account_id,
        meta: '',
        url: response.absoluteUrl || '',
        iconUrl: response.picture,
        containerId: '' // no container
    };
    else return {
        title: response.title,
        id: response.id,
        meta: '',
        url: response.url,
        iconUrl: response.iconUrl,
        containerId: '' // no container
    };
};
const $ad01931f226af666$export$ddbcae0b0bd6b092 = (intl, workspaces, isGlobalExperienceWorkspace, orgId)=>[
        {
            id: (0, $cqziK.TownsquareScope).TownsquareProject,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_projects_heading),
            showResultCount: false,
            scope: (0, $cqziK.TownsquareScope).TownsquareProject,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>{
                return (0, $fjD79.default)('projects', query, workspaces, isGlobalExperienceWorkspace, orgId);
            },
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_projects_view_all
                })
        },
        {
            id: (0, $cqziK.TownsquareScope).TownsquareGoal,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_goals_heading),
            scope: (0, $cqziK.TownsquareScope).TownsquareGoal,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>(0, $fjD79.default)('goals', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_goals_view_all
                })
        },
        {
            id: (0, $cqziK.TownsquareScope).TownsquareHelpLink,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_help_links_heading),
            scope: (0, $cqziK.TownsquareScope).TownsquareHelpLink,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper
        },
        {
            id: (0, $cqziK.TownsquareScope).TownsquareTag,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_topics_heading),
            scope: (0, $cqziK.TownsquareScope).TownsquareTag,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper,
            viewAllLinkGenerator: (query)=>(0, $fjD79.default)('topics', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_topics_view_all
                })
        },
        {
            id: (0, $cqziK.TownsquareScope).TownsquareLearning,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_learnings_risks_decisions_heading),
            scope: (0, $cqziK.TownsquareScope).TownsquareLearning,
            resultMapper: $ad01931f226af666$var$defaultTownsquareResultMapper
        }
    ];

});
parcelRegister("cqziK", function(module, exports) {

$parcel$export(module.exports, "TownsquareScope", () => $7175e1aafd675626$export$fca43c5c12a4e3fa);
var $7175e1aafd675626$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});

});


parcelRegister("1rta3", function(module, exports) {

$parcel$export(module.exports, "TOWNSQUARE_PRODUCT_ID", () => $f4a2ff59ef026569$export$dac5be8ec1b3ddb1);
$parcel$export(module.exports, "useTownsquareSuppliers", () => $f4a2ff59ef026569$export$a0d26d0ba1e6d87a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $3coNb = parcelRequire("3coNb");

var $3hux3 = parcelRequire("3hux3");

var $5CiaV = parcelRequire("5CiaV");

var $9zyYG = parcelRequire("9zyYG");

var $cqziK = parcelRequire("cqziK");

var $fjD79 = parcelRequire("fjD79");
const $f4a2ff59ef026569$export$dac5be8ec1b3ddb1 = 'townsquare';
const $f4a2ff59ef026569$var$sectionSortOrder = [
    (0, $cqziK.TownsquareScope).TownsquareProject,
    (0, $cqziK.TownsquareScope).TownsquareGoal,
    (0, $cqziK.TownsquareScope).People,
    (0, $cqziK.TownsquareScope).Teams,
    (0, $cqziK.TownsquareScope).TownsquareTag,
    (0, $cqziK.TownsquareScope).TownsquareHelpLink,
    (0, $cqziK.TownsquareScope).TownsquareLearning
];
/**
 * Sorting sections to match the order defined in the array {sectionSortOrder}
 * While this should not happen, if the section is not part of the array, it is considered to be at the end.
 */ const $f4a2ff59ef026569$var$sortSections = (sectionA, sectionB)=>{
    const indexA = $f4a2ff59ef026569$var$sectionSortOrder.indexOf(sectionA.id);
    const indexB = $f4a2ff59ef026569$var$sectionSortOrder.indexOf(sectionB.id);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
};
const $f4a2ff59ef026569$export$a0d26d0ba1e6d87a = ({ userTeamConfig: userTeamConfig, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, workspaces: workspaces, organizationId: organizationId, isGlobalExperienceWorkspace: isGlobalExperienceWorkspace })=>{
    const intl = (0, $dBxQj.default)();
    const orgId = organizationId ?? userTeamConfig?.context.organizationId;
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)($f4a2ff59ef026569$export$dac5be8ec1b3ddb1, (0, $9zyYG.getSections)(intl, workspaces, isGlobalExperienceWorkspace, orgId), {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    // If we are in a global experience workspace, we need to set the product key to 'people'
    if (userTeamConfig) userTeamConfig.context.productKey = isGlobalExperienceWorkspace ? 'people' : userTeamConfig?.context.productKey;
    const peopleAndTeamSupplier = (0, $3coNb.usePeopleAndTeamsQuery)({
        people: {
            id: (0, $cqziK.TownsquareScope).People,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_people_heading),
            viewAllLinkGenerator: (query)=>(0, $fjD79.default)('people', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_people_view_all
                })
        },
        teams: {
            id: (0, $cqziK.TownsquareScope).Teams,
            title: intl.formatMessage((0, $3hux3.messages).townsquare_teams_heading),
            viewAllLinkGenerator: (query)=>(0, $fjD79.default)('teams', query, workspaces, isGlobalExperienceWorkspace, orgId),
            viewAllLinkRenderer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $3hux3.messages).townsquare_teams_view_all
                })
        }
    }, (0, $9zyYG.MAX_ITEMS_PER_SECTION));
    const preQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await itemSuppliers.preQueryItemSupplier(args);
        const people = userTeamConfig ? await peopleAndTeamSupplier('', {
            resolveUserUrl: (userId)=>(0, $fjD79.createProfileLink)(userId, isGlobalExperienceWorkspace, orgId),
            resolveTeamUrl: (teamId)=>(0, $fjD79.createTeamProfileLink)(teamId, isGlobalExperienceWorkspace, orgId),
            ...userTeamConfig
        }) : null;
        const unsortedSections = [
            ...existingSections.sections,
            ...people?.sections ?? []
        ];
        return {
            size: unsortedSections.length,
            sections: unsortedSections.sort($f4a2ff59ef026569$var$sortSections)
        };
    };
    const postQueryItemSupplierWithPeopleAndTeams = async (args)=>{
        const existingSections = await itemSuppliers.postQueryItemSupplier(args);
        const { filters: filters } = args;
        const selectedWorkspace = filters.filter((filter)=>filter['@type'] === 'sites').map((filter)=>filter.values[0]).filter((val)=>val).shift();
        const people = userTeamConfig ? await peopleAndTeamSupplier(args.query, {
            resolveUserUrl: (userId)=>(0, $fjD79.createProfileLink)(userId, isGlobalExperienceWorkspace, orgId),
            resolveTeamUrl: (teamId)=>(0, $fjD79.createTeamProfileLink)(teamId, isGlobalExperienceWorkspace, orgId),
            ...userTeamConfig,
            context: {
                ...userTeamConfig.context,
                siteId: selectedWorkspace || userTeamConfig.context.siteId
            }
        }) : null;
        const unsortedSections = [
            ...existingSections.sections,
            ...people?.sections ?? []
        ];
        return {
            size: unsortedSections.length,
            sections: unsortedSections.sort($f4a2ff59ef026569$var$sortSections)
        };
    };
    const preQuerySectionTitleGenerator = (section)=>{
        switch(section.id){
            case (0, $cqziK.TownsquareScope).TownsquareProject:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_projects);
            case (0, $cqziK.TownsquareScope).TownsquareGoal:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_goals);
            case (0, $cqziK.TownsquareScope).TownsquareHelpLink:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_help_links);
            case (0, $cqziK.TownsquareScope).TownsquareTag:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_topics);
            case (0, $cqziK.TownsquareScope).TownsquareLearning:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_learnings_risks_decisions);
            case (0, $cqziK.TownsquareScope).People:
                return intl.formatMessage((0, $3hux3.messages).townsquare_recent_people);
            default:
                return '';
        }
    };
    return {
        preQueryItemSupplier: preQueryItemSupplierWithPeopleAndTeams,
        postQueryItemSupplier: postQueryItemSupplierWithPeopleAndTeams,
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator
    };
};

});


parcelRegister("2WIYs", function(module, exports) {

$parcel$export(module.exports, "TrelloTab", () => $ab7ced8b5c4b8113$export$78fe0655c043c20);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $bF0iL = parcelRequire("bF0iL");

var $6la50 = parcelRequire("6la50");

var $a5cba = parcelRequire("a5cba");
var $fJRVo = parcelRequire("fJRVo");

var $5CiaV = parcelRequire("5CiaV");

var $tFil7 = parcelRequire("tFil7");

var $buUFy = parcelRequire("buUFy");

var $3Oi7g = parcelRequire("3Oi7g");

var $aJ5e0 = parcelRequire("aJ5e0");

var $46uIy = parcelRequire("46uIy");

var $4ldrV = parcelRequire("4ldrV");

var $2OcMi = parcelRequire("2OcMi");

var $eztGN = parcelRequire("eztGN");

var $3Z7LN = parcelRequire("3Z7LN");

var $iEwUU = parcelRequire("iEwUU");

var $kmpep = parcelRequire("kmpep");

const $ab7ced8b5c4b8113$var$TrelloBodyAsync = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("b5eQ2")).then(({ TrelloBody: TrelloBody })=>({
            default: TrelloBody
        })));
const $ab7ced8b5c4b8113$export$78fe0655c043c20 = ({ feedbackUrl: feedbackUrl, preQueryItemSupplier: preQueryItemSupplier, postQueryItemSupplier: postQueryItemSupplier, generateAdvancedSearchUrl: generateAdvancedSearchUrl, features: features, resultOnClick: resultOnClick, ...rest })=>{
    const searchSessionId = (0, $4ldrV.useSearchSessionId)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { getPrimaryProduct: getPrimaryProduct } = (0, $fJRVo.useProductContext)();
    const primaryProduct = getPrimaryProduct();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    const showAtlassianHomeSearchLink = !!((0, $eztGN.useShowAtlassianHomeSearchLink)(primaryProduct?.id) && orgId && cloudId);
    const trelloGenerateAdvancedSearchUrl = (0, $gwFzn.useCallback)((query, baseUrl, usage)=>{
        if (usage === 'onInputEnterModified' && showAtlassianHomeSearchLink) return (0, $3Z7LN.getAtlassianHomeSearchUrl)(orgId, cloudId, query, primaryProduct?.id);
        return (0, $2OcMi.addQueryParams)((0, $46uIy.viewAllLinkGenerator)(query), {
            search_id: searchSessionId
        });
    }, [
        searchSessionId,
        showAtlassianHomeSearchLink,
        orgId,
        cloudId,
        primaryProduct?.id
    ]);
    const boardSection = (0, $gwFzn.useMemo)(()=>{
        return {
            id: (0, $3Oi7g.TrelloScope).Board,
            title: formatMessage((0, $6la50.messages).trello_boards_heading),
            scope: (0, $3Oi7g.TrelloScope).Board,
            showResultCount: false,
            resultMapper: ({ results: results })=>results.map((board)=>({
                        id: board.id,
                        title: board.name,
                        meta: board.organization?.displayName ?? '',
                        closed: board.closed,
                        url: board.url,
                        prefs: board.prefs,
                        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aJ5e0.BoardIcon), {
                            ...board
                        }),
                        containerId: board.idOrganization ?? undefined
                    })),
            resultRenderer: (args)=>{
                const { id: id, title: title, meta: meta, closed: closed, url: url, prefs: prefs } = args?.searchResult;
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $tFil7.TrelloSearchResultComponent), {
                    id: id,
                    title: title,
                    meta: {
                        title: formatMessage((0, $6la50.messages).trello_workspace),
                        value: meta
                    },
                    closed: closed,
                    url: url,
                    prefs: prefs,
                    isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                    isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                    screen: args?.screen,
                    onResultClick: resultOnClick
                });
            }
        };
    }, [
        features?.isColorBlindModeEnabled,
        features?.isPreviewOnTrelloSearchResultsEnabled,
        formatMessage,
        resultOnClick
    ]);
    const cardSection = (0, $gwFzn.useMemo)(()=>{
        return {
            id: (0, $3Oi7g.TrelloScope).Card,
            title: formatMessage((0, $6la50.messages).trello_cards_heading),
            scope: (0, $3Oi7g.TrelloScope).Card,
            showResultCount: false,
            resultMapper: ({ results: results })=>results.map((card)=>({
                        id: card.id,
                        title: card.name,
                        meta: card.board.name,
                        additionalMeta: card.list.name,
                        closed: card.closed,
                        url: card.url,
                        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aJ5e0.CardIcon), {}),
                        containerId: card.idBoard
                    })),
            resultRenderer: (args)=>{
                const { id: id, title: title, meta: meta, additionalMeta: additionalMeta, url: url, closed: closed } = args?.searchResult;
                return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $tFil7.TrelloSearchResultComponent), {
                    id: id,
                    title: title,
                    meta: {
                        title: formatMessage((0, $6la50.messages).trello_board),
                        value: meta
                    },
                    additionalMeta: {
                        title: formatMessage((0, $6la50.messages).trello_list),
                        value: additionalMeta
                    },
                    closed: closed,
                    url: url,
                    isPreviewOnTrelloSearchResultsEnabled: features?.isPreviewOnTrelloSearchResultsEnabled,
                    isColorBlindModeEnabled: features?.isColorBlindModeEnabled,
                    screen: args?.screen,
                    onResultClick: resultOnClick
                });
            }
        };
    }, [
        features?.isColorBlindModeEnabled,
        features?.isPreviewOnTrelloSearchResultsEnabled,
        formatMessage,
        resultOnClick
    ]);
    const sections = (0, $gwFzn.useMemo)(()=>{
        return features?.isCardResultsSectionFirst ? [
            cardSection,
            {
                ...boardSection,
                viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
            }
        ] : [
            boardSection,
            {
                ...cardSection,
                viewAllLinkGenerator: trelloGenerateAdvancedSearchUrl
            }
        ];
    }, [
        boardSection,
        cardSection,
        features?.isCardResultsSectionFirst,
        trelloGenerateAdvancedSearchUrl
    ]);
    const itemSuppliers = (0, $5CiaV.useDefaultSuppliers)((0, $3Oi7g.TRELLO_PRODUCT_ID), sections, {
        preQueryItemSupplier: preQueryItemSupplier,
        postQueryItemSupplier: postQueryItemSupplier
    });
    const preQuerySectionTitleGenerator = (0, $gwFzn.useCallback)((section)=>section.id === (0, $3Oi7g.TrelloScope).Board ? formatMessage((0, $6la50.messages).trello_recent_boards_heading) : '', [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a5cba.SearchDialogProduct), {
        id: (0, $3Oi7g.TRELLO_PRODUCT_ID),
        expandedStateInputPlaceholder: formatMessage((0, $6la50.messages).trello_expanded_input_placeholder),
        preQuerySectionTitleGenerator: preQuerySectionTitleGenerator,
        generateAdvancedSearchUrl: trelloGenerateAdvancedSearchUrl,
        sections: sections,
        title: formatMessage((0, $bF0iL.messages).trello_tab_label),
        ...rest,
        ...itemSuppliers,
        children: (props)=>{
            return features?.isCardResultsSectionFirst ? {
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $buUFy.TrelloFooter), {
                        feedbackUrl: feedbackUrl,
                        urlGeneratorForNoResultsScreen: trelloGenerateAdvancedSearchUrl,
                        linkComponent: props.linkComponent,
                        showAtlassianHomeSearchLink: !!showAtlassianHomeSearchLink
                    }),
                Body: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($ab7ced8b5c4b8113$var$TrelloBodyAsync, {
                        ...props
                    })
            } : {
                Footer: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $buUFy.TrelloFooter), {
                        feedbackUrl: feedbackUrl,
                        urlGeneratorForNoResultsScreen: trelloGenerateAdvancedSearchUrl,
                        linkComponent: props.linkComponent,
                        showAtlassianHomeSearchLink: !!showAtlassianHomeSearchLink
                    })
            };
        }
    });
};

});
parcelRegister("6la50", function(module, exports) {

$parcel$export(module.exports, "messages", () => $97d7736b9ea01187$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $97d7736b9ea01187$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Trello
   */ trello_archived: {
        id: "product_search_dialog.trello.archived",
        defaultMessage: "Archived"
    },
    trello_archived_card_hover: {
        id: "product_search_dialog.trello.archived.card-hover",
        defaultMessage: "This card is archived"
    },
    trello_board: {
        id: "product_search_dialog.trello.board",
        defaultMessage: "Board"
    },
    trello_closed: {
        id: "product_search_dialog.trello.closed",
        defaultMessage: "Closed"
    },
    trello_closed_board_hover: {
        id: "product_search_dialog.trello.closed.board-hover",
        defaultMessage: "This board is closed"
    },
    trello_list: {
        id: "product_search_dialog.trello.list",
        defaultMessage: "List"
    },
    trello_workspace: {
        id: "product_search_dialog.trello.workspace",
        defaultMessage: "Workspace"
    },
    trello_private_workspace: {
        id: "product_search_dialog.trello.private_workspace",
        defaultMessage: "Private Workspace"
    },
    trello_expanded_input_placeholder: {
        id: "product_search_dialog.trello.expanded.input-placeholder",
        defaultMessage: "Search Trello"
    },
    trello_recent_boards_heading: {
        id: "product_search_dialog.trello.recent_boards_heading",
        defaultMessage: "Recent boards"
    },
    trello_boards_heading: {
        id: "product_search_dialog.trello.boards_heading",
        defaultMessage: "Boards"
    },
    trello_cards_heading: {
        id: "product_search_dialog.trello.cards_heading",
        defaultMessage: "Cards"
    },
    trello_feedback_link: {
        id: "product_search_dialog.trello.feedback_link",
        defaultMessage: "Help us improve your search results!"
    }
});

});

parcelRegister("tFil7", function(module, exports) {

$parcel$export(module.exports, "TrelloSearchResultComponent", () => $bdbfd4cb99d517f5$export$995a33bac606d212);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $5tPRL = parcelRequire("5tPRL");

var $6la50 = parcelRequire("6la50");

var $7dypi = parcelRequire("7dypi");

var $aJ5e0 = parcelRequire("aJ5e0");

var $2Loy2 = parcelRequire("2Loy2");
const $bdbfd4cb99d517f5$export$995a33bac606d212 = ({ id: id, title: title, url: url, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, isColorBlindModeEnabled: isColorBlindModeEnabled, screen: screen, onResultClick: onResultClick })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isBoard = Boolean(prefs);
    const type = (0, $gwFzn.useMemo)(()=>isBoard ? 'board' : 'card', [
        isBoard
    ]);
    const metaValue = (0, $gwFzn.useMemo)(()=>isBoard && !meta.value ? formatMessage((0, $6la50.messages).trello_private_workspace) : meta.value, [
        formatMessage,
        isBoard,
        meta.value
    ]);
    const resultContentWrapperOnClick = (0, $gwFzn.useCallback)(()=>{
        if (onResultClick !== undefined) onResultClick();
    }, [
        onResultClick
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Loy2.HoverPreviewsResultWrapper), {
        id: id,
        title: title,
        url: url,
        prefs: prefs,
        meta: meta,
        additionalMeta: additionalMeta,
        closed: closed,
        type: type,
        isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled,
        isColorBlindModeEnabled: isColorBlindModeEnabled,
        screen: screen,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.ResultContentWrapper), {
            isCollapsed: true,
            onClick: resultContentWrapperOnClick,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.IconContainer), {
                    children: isBoard && prefs ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aJ5e0.BoardIcon), {
                        id: id,
                        name: title,
                        url: url,
                        prefs: prefs
                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aJ5e0.CardIcon), {})
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $5tPRL.CollapsedResultContentWrapper), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5tPRL.ResultTitleContainer), {
                            isCollapsed: true,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                                title: !isPreviewOnTrelloSearchResultsEnabled ? title : undefined,
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7dypi.CollapsedResultDetailWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7dypi.BoardAndListCol), {
                                    children: [
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7dypi.BoardAndListDetail), {
                                            title: !isPreviewOnTrelloSearchResultsEnabled ? `${meta.title}: ${metaValue}` : undefined,
                                            children: metaValue
                                        }),
                                        additionalMeta ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7dypi.BoardAndListDetail), {
                                            title: !isPreviewOnTrelloSearchResultsEnabled ? `${additionalMeta.title}: ${additionalMeta.value}` : undefined,
                                            children: [
                                                ": ",
                                                additionalMeta.value
                                            ]
                                        }) : null
                                    ]
                                }),
                                closed ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7dypi.ArchivedCol), {
                                    title: !isPreviewOnTrelloSearchResultsEnabled ? isBoard ? formatMessage((0, $6la50.messages).trello_closed_board_hover) : formatMessage((0, $6la50.messages).trello_archived_card_hover) : undefined,
                                    children: [
                                        "\u2022 ",
                                        isBoard ? formatMessage((0, $6la50.messages).trello_closed) : formatMessage((0, $6la50.messages).trello_archived)
                                    ]
                                }) : null
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("7dypi", function(module, exports) {

$parcel$export(module.exports, "BoardAndListCol", () => $c143c0027bdf6a89$export$14ccea95a01eec04);
$parcel$export(module.exports, "BoardAndListDetail", () => $c143c0027bdf6a89$export$67495cfd95013c39);
$parcel$export(module.exports, "ArchivedCol", () => $c143c0027bdf6a89$export$cd22da1a99fcf7b1);
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $c143c0027bdf6a89$export$43a2b5c94cb85d9c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $c143c0027bdf6a89$export$14ccea95a01eec04 = (0, $gwrgp.default)("div", {
    target: "e1rjmdl20"
})({
    name: "s88hxx",
    styles: "display:flex;overflow:hidden;"
});
const $c143c0027bdf6a89$export$67495cfd95013c39 = (0, $gwrgp.default)("div", {
    target: "e1rjmdl21"
})({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: '5%',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $c143c0027bdf6a89$export$cd22da1a99fcf7b1 = (0, $gwrgp.default)("div", {
    target: "e1rjmdl22"
})({
    marginLeft: "var(--ds-space-050, 4px)",
    flexShrink: 0,
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    color: `var(--ds-text-subtlest, ${(0, $6fnsQ.N200)})`
});
const $c143c0027bdf6a89$export$43a2b5c94cb85d9c = (0, $gwrgp.default)("div", {
    target: "e1rjmdl23"
})({
    name: "k008qs",
    styles: "display:flex;"
});

});

parcelRegister("aJ5e0", function(module, exports) {

$parcel$export(module.exports, "getCardIconUrl", () => $d7612f6af24b36cb$export$d00fcd959e6e6c2b);
$parcel$export(module.exports, "getBoardIconUrl", () => $d7612f6af24b36cb$export$419622b78ee4bd67);
$parcel$export(module.exports, "BoardIcon", () => $d7612f6af24b36cb$export$2f9da8868573b55d);
$parcel$export(module.exports, "CardIcon", () => $d7612f6af24b36cb$export$f4619d70a16e5ea0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $dTk3A = parcelRequire("dTk3A");

var $6fnsQ = parcelRequire("6fnsQ");

var $1To4a = parcelRequire("1To4a");

var $gwrgp = parcelRequire("gwrgp");
const $d7612f6af24b36cb$var$baseStyle = {
    display: 'flex',
    // hack around IconContainer styles
    flexShrink: 0,
    // hack around IconContainer styles
    borderRadius: '2px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
};
const $d7612f6af24b36cb$export$d00fcd959e6e6c2b = ()=>{
    const iconColor = (0, $1To4a.default)('color.icon', (0, $6fnsQ.N800));
    return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.66667 0C1.19391 0 0 1.19391 0 2.66667V16C0 17.4728 1.19391 18.6667 2.66667 18.6667H21.3333C22.8061 18.6667 24 17.4728 24 16V2.66667C24 1.19391 22.8061 0 21.3333 0H2.66667ZM21.3333 2.66667H2.66667V10.6667H21.3333V2.66667ZM18.6667 14.6667C18.6667 15.403 19.2636 16 20 16C20.7364 16 21.3333 15.403 21.3333 14.6667C21.3333 13.9303 20.7364 13.3333 20 13.3333C19.2636 13.3333 18.6667 13.9303 18.6667 14.6667ZM4 16C3.26362 16 2.66667 15.403 2.66667 14.6667C2.66667 13.9303 3.26362 13.3333 4 13.3333H9.33333C10.0697 13.3333 10.6667 13.9303 10.6667 14.6667C10.6667 15.403 10.0697 16 9.33333 16H4Z" fill="${iconColor}"/></svg>`)}`;
};
const $d7612f6af24b36cb$export$419622b78ee4bd67 = ()=>{
    const iconColor = (0, $1To4a.default)('color.icon', (0, $6fnsQ.N800));
    return `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.77778C0 0.795938 0.795938 0 1.77778 0H14.2222C15.2041 0 16 0.795938 16 1.77778V14.2222C16 15.2041 15.2041 16 14.2222 16H1.77778C0.795938 16 0 15.2041 0 14.2222V1.77778ZM1.77778 2.66667C1.77778 2.17575 2.17575 1.77778 2.66667 1.77778H6.22222C6.71314 1.77778 7.11111 2.17575 7.11111 2.66667V11.5556C7.11111 12.0465 6.71314 12.4444 6.22222 12.4444H2.66667C2.17575 12.4444 1.77778 12.0465 1.77778 11.5556V2.66667ZM9.77778 1.77778C9.28686 1.77778 8.88889 2.17575 8.88889 2.66667V8C8.88889 8.49092 9.28686 8.88889 9.77778 8.88889H13.3333C13.8243 8.88889 14.2222 8.49092 14.2222 8V2.66667C14.2222 2.17575 13.8243 1.77778 13.3333 1.77778H9.77778Z" fill="${iconColor}"/></svg>`)}`;
};
const $d7612f6af24b36cb$export$2f9da8868573b55d = (0, $gwrgp.default)("span", {
    target: "est758s0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ prefs: { backgroundImageScaled: backgroundImageScaled, backgroundImage: backgroundImage, backgroundColor: backgroundColor } })=>{
    const boardUrl = backgroundImageScaled?.[0]?.url || backgroundImage;
    if (boardUrl) return {
        ...$d7612f6af24b36cb$var$baseStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${(0, $dTk3A.gridSize)() * 3}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        width: `${(0, $dTk3A.gridSize)() * 3}px`,
        backgroundImage: `url(${boardUrl})`
    };
    return {
        ...$d7612f6af24b36cb$var$baseStyle,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${(0, $dTk3A.gridSize)() * 3}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        width: `${(0, $dTk3A.gridSize)() * 3}px`,
        backgroundColor: backgroundColor || `var(--ds-background-neutral, ${0, $6fnsQ.N40})`
    };
});
const $d7612f6af24b36cb$export$f4619d70a16e5ea0 = (0, $gwrgp.default)("span", {
    target: "est758s1"
})(()=>{
    return {
        ...$d7612f6af24b36cb$var$baseStyle,
        height: `19px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        width: `${(0, $dTk3A.gridSize)() * 3}px`,
        marginBottom: "var(--ds-space-100, 8px)",
        backgroundImage: `url(${$d7612f6af24b36cb$export$d00fcd959e6e6c2b()})`
    };
});

});

parcelRegister("2Loy2", function(module, exports) {

$parcel$export(module.exports, "HoverPreviewsResultWrapper", () => $d89a9a3c06a88b05$export$5662bd1eb353c490);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $k51fz = parcelRequire("k51fz");

const $d89a9a3c06a88b05$var$TrelloPopperAsync = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).lazy(()=>(parcelRequire("lLdkS")).then(({ TrelloPopper: TrelloPopper })=>({
            default: TrelloPopper
        })));
const $d89a9a3c06a88b05$export$5662bd1eb353c490 = ({ id: id, title: title, prefs: prefs, meta: meta, additionalMeta: additionalMeta, closed: closed, type: type, children: children, isColorBlindModeEnabled: isColorBlindModeEnabled, isPreviewOnTrelloSearchResultsEnabled: isPreviewOnTrelloSearchResultsEnabled, screen: screen })=>{
    const { getCard: getCard } = (0, $k51fz.useTrelloCard)();
    const [result, setResult] = (0, $gwFzn.useState)();
    const onFetchCard = (0, $gwFzn.useCallback)(async ()=>{
        const card = await getCard(id);
        if (card) setResult({
            ...card,
            type: 'card',
            id: id,
            title: title,
            closed: closed,
            meta: meta,
            additionalMeta: additionalMeta,
            screen: screen
        });
    }, [
        getCard,
        id,
        title,
        closed,
        meta,
        screen,
        additionalMeta
    ]);
    const onFetchBoard = (0, $gwFzn.useCallback)(()=>{
        if (prefs) setResult({
            type: 'board',
            id: id,
            title: title,
            prefs: prefs,
            meta: meta,
            closed: closed,
            screen: screen
        });
    }, [
        id,
        title,
        prefs,
        meta,
        closed,
        screen
    ]);
    if (!isPreviewOnTrelloSearchResultsEnabled) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($d89a9a3c06a88b05$var$TrelloPopperAsync, {
            type: type,
            result: result,
            onFetchCard: onFetchCard,
            onFetchBoard: onFetchBoard,
            isColorBlindModeEnabled: isColorBlindModeEnabled,
            screen: screen,
            children: children
        })
    });
};

});
parcelRegister("k51fz", function(module, exports) {

$parcel$export(module.exports, "useTrelloCard", () => $2ab6392a5ef0ce9c$export$167729b86606a89e);

var $gwFzn = parcelRequire("gwFzn");

var $6dP89 = parcelRequire("6dP89");

var $5dFS9 = parcelRequire("5dFS9");
const $2ab6392a5ef0ce9c$var$cards = new Map();
const $2ab6392a5ef0ce9c$export$167729b86606a89e = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $6dP89.useAnalytics)();
    const loadCard = (0, $gwFzn.useCallback)(async (cardId)=>{
        try {
            const response = await fetch(`/1/card/${cardId}?fields=name,closed,url,cover,labels,idAttachmentCover&attachments=cover`);
            if (response.ok) {
                const cardResponse = await response.json();
                $2ab6392a5ef0ce9c$var$cards.set(cardId, cardResponse);
                return cardResponse;
            } else throw new Error(`Invalid response: ${response?.status}`);
        } catch (e) {
            if (e instanceof Error) fireAnalyticsEvent({
                ...(0, $5dFS9.onCardRequestFailed)({
                    attributes: {
                        errorMsg: e?.message,
                        errorName: e?.name
                    }
                })
            });
        }
    }, [
        fireAnalyticsEvent
    ]);
    const getCard = (0, $gwFzn.useCallback)(async (cardId)=>{
        return $2ab6392a5ef0ce9c$var$cards.get(cardId) ? Promise.resolve($2ab6392a5ef0ce9c$var$cards.get(cardId)) : loadCard(cardId);
    }, [
        loadCard
    ]);
    return {
        getCard: getCard
    };
};

});

parcelRegister("lLdkS", function(module, exports) {

let $fd7854fa35af28a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fd7854fa35af28a9$var$load("2exA8").then(()=>parcelRequire('iiIdc'));

});



parcelRegister("buUFy", function(module, exports) {

$parcel$export(module.exports, "TrelloFooter", () => $24ad7b08697a57d9$export$c139d851a817966);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $crAJ1 = parcelRequire("crAJ1");

var $6la50 = parcelRequire("6la50");

var $4mZlP = parcelRequire("4mZlP");

var $aGmCb = parcelRequire("aGmCb");

var $iEwUU = parcelRequire("iEwUU");

var $3Z7LN = parcelRequire("3Z7LN");

var $4mZlP = parcelRequire("4mZlP");

var $kmpep = parcelRequire("kmpep");
const $24ad7b08697a57d9$export$c139d851a817966 = ({ feedbackUrl: feedbackUrl, showAtlassianHomeSearchLink: showAtlassianHomeSearchLink, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { orgId: orgId } = (0, $iEwUU.useUserContext)();
    const aggregatorClient = (0, $kmpep.useTypedAggregatorClient)();
    const cloudId = aggregatorClient?.getAggregatorConfig().cloudId;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aGmCb.SearchFooterWrapper), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.AdvancedSearchFooter), {
                ...rest,
                returnKeyIconComponent: showAtlassianHomeSearchLink ? ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $4mZlP.ReturnIconWithModifier), {}) : undefined
            }),
            showAtlassianHomeSearchLink && orgId && cloudId && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $crAJ1.SearchFooter), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Z7LN.AtlassianHomeSearchLink), {
                    orgId: orgId,
                    cloudId: cloudId,
                    showModifierIcon: true
                })
            }),
            feedbackUrl && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aGmCb.FeedbackLinkWrapper), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aGmCb.FeedbackLink), {
                    appearance: "subtle-link",
                    href: feedbackUrl,
                    target: "_blank",
                    children: formatMessage((0, $6la50.messages).trello_feedback_link)
                })
            })
        ]
    });
};

});
parcelRegister("aGmCb", function(module, exports) {

$parcel$export(module.exports, "FeedbackLinkWrapper", () => $7ef4a4349ad50bfd$export$b68f382ed631ffe5);
$parcel$export(module.exports, "FeedbackLink", () => $7ef4a4349ad50bfd$export$4d44d7534024e0b6);
$parcel$export(module.exports, "SearchFooterWrapper", () => $7ef4a4349ad50bfd$export$a6be8d069f8a5fb4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $crAJ1 = parcelRequire("crAJ1");

var $eEA8O = parcelRequire("eEA8O");

var $6fnsQ = parcelRequire("6fnsQ");

var $gwrgp = parcelRequire("gwrgp");
const $7ef4a4349ad50bfd$export$b68f382ed631ffe5 = (0, $gwrgp.default)("div", {
    target: "evrkq7c0"
})({
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`,
    padding: `${"var(--ds-space-050, 4px)"} 0`
});
const $7ef4a4349ad50bfd$export$4d44d7534024e0b6 = /*#__PURE__*/ (0, $gwrgp.default)((0, $eEA8O.default), {
    target: "evrkq7c1"
})("&&{text-decoration:underline;&:hover{color:", `var(--ds-link-pressed, ${(0, $6fnsQ.N900)})`, " !important;}}");
const $7ef4a4349ad50bfd$export$a6be8d069f8a5fb4 = /*#__PURE__*/ (0, $gwrgp.default)((0, $crAJ1.SearchFooter), {
    target: "evrkq7c2"
})({
    name: "1g4yje1",
    styles: "display:flex;flex-direction:column;height:100%;"
});

});


parcelRegister("3Oi7g", function(module, exports) {

$parcel$export(module.exports, "TRELLO_PRODUCT_ID", () => $f671aeb58cfbd736$export$4788c0ef19dba72f);
$parcel$export(module.exports, "TrelloScope", () => $f671aeb58cfbd736$export$1f420d5694f8d5b3);
const $f671aeb58cfbd736$export$4788c0ef19dba72f = 'trello';
var $f671aeb58cfbd736$export$1f420d5694f8d5b3 = /*#__PURE__*/ function(TrelloScope) {
    TrelloScope["Board"] = "trello.board";
    TrelloScope["Card"] = "trello.card";
    return TrelloScope;
}({});

});

parcelRegister("46uIy", function(module, exports) {

$parcel$export(module.exports, "viewAllLinkGenerator", () => $8cadf475bb862c29$export$28a2ffcf7191490b);
const $8cadf475bb862c29$var$getBaseUrl = ()=>{
    const hostname = window?.location?.hostname;
    if (hostname?.includes('jira-dev.com') || hostname?.startsWith('trellis.coffee') || hostname?.startsWith('localhost') || hostname?.startsWith('team.stg')) return 'https://trellis.coffee';
    return 'https://trello.com';
};
const $8cadf475bb862c29$export$28a2ffcf7191490b = (query)=>query ? `${$8cadf475bb862c29$var$getBaseUrl()}/search?q=${encodeURIComponent(query)}` : `${$8cadf475bb862c29$var$getBaseUrl()}/search`;

});

parcelRegister("b5eQ2", function(module, exports) {

let $811babe61bfc5824$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $811babe61bfc5824$var$load("eVnxm").then(()=>parcelRequire('5MSS3'));

});


parcelRegister("4pEo5", function(module, exports) {

$parcel$export(module.exports, "ConfluenceQuickFind", () => $86415052597ff71d$export$2c1361e70d618a59);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $OjoBn = parcelRequire("OjoBn");

var $7Sm4c = parcelRequire("7Sm4c");

var $jlIaF = parcelRequire("jlIaF");
const $86415052597ff71d$export$2c1361e70d618a59 = ({ cloudId: cloudId, orgId: orgId, theme: theme, isExpanded: isExpanded, setIsExpanded: setIsExpanded, aggregatorUrl: aggregatorUrl, user: user, forwardRef: forwardRef, onNavigateGeneric: onNavigateGeneric, linkComponent: linkComponent, shouldFillContainer: shouldFillContainer, isRovoEnabled: isRovoEnabled, isGriffinNavEnabled: isGriffinNavEnabled, queryParams: queryParams })=>{
    const confCloudClient = (0, $diswb.useApolloClient)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $OjoBn.QuickFind), {
        theme: theme,
        linkComponent: linkComponent,
        isExpanded: isExpanded,
        setIsExpanded: setIsExpanded,
        abTestCloudId: cloudId,
        aggregatorUrl: aggregatorUrl,
        user: user,
        forwardRef: forwardRef,
        onNavigateGeneric: onNavigateGeneric,
        recentClientConfig: {
            url: (0, $jlIaF.CONTEXT_PATH),
            cloudId: cloudId,
            isCollaborationGraphEnabled: false,
            collaborationGraphUrl: '/gateway/api/collaboration',
            isUserAnonymous: !user?.id
        },
        confCloudClient: confCloudClient,
        onPreQueryErrorCallback: (0, $7Sm4c.markErrorAsHandled),
        cloudId: cloudId,
        orgId: orgId,
        primaryProduct: "confluence",
        shouldFillContainer: shouldFillContainer,
        isRovoEnabled: isRovoEnabled,
        dialogFeatures: {
            isGriffinNavEnabled: isGriffinNavEnabled
        },
        queryParams: queryParams
    });
};

});
parcelRegister("OjoBn", function(module, exports) {

$parcel$export(module.exports, "QuickFind", () => $5b7db3266f705bf2$export$7d842d92e2721710);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $k19N9 = parcelRequire("k19N9");

var $f0f3d = parcelRequire("f0f3d");
const $5b7db3266f705bf2$export$7d842d92e2721710 = ({ dialogFeatures: dialogFeatures, postQueryDisabled: postQueryDisabled, ...rest })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $k19N9.MultiProductDialog), {
        dialogFeatures: {
            ...dialogFeatures,
            quickFind: {
                enabled: true,
                postQueryDisabled: postQueryDisabled
            }
        },
        ...rest,
        children: ({ onRetry: onRetry })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $f0f3d.QuickFindConfluence), {
                ...rest,
                onRetry: onRetry
            })
    });
};

});


parcelRegister("2VPmd", function(module, exports) {

$parcel$export(module.exports, "ConfluenceResultRenderer", () => $7b25068d4e2f79dd$export$bba16a2668c13d43);

var $dBxQj = parcelRequire("dBxQj");

var $ejGzS = parcelRequire("ejGzS");

var $fib1y = parcelRequire("fib1y");

var $g0lm5 = parcelRequire("g0lm5");
const $7b25068d4e2f79dd$export$bba16a2668c13d43 = ({ searchResult: searchResult, ...rest })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { productState: productState } = rest;
    // REST API stores recent content type as meta data
    const contentType = searchResult.additionalMeta && typeof searchResult.additionalMeta === 'string' ? searchResult.additionalMeta || '' : searchResult.icon || '';
    // AFE does not return newer content type icons (i.e whiteboard/database) so we render it here
    const renderContentIcon = ()=>{
        if (searchResult?.type === 'whiteboard' || searchResult.icon === 'whiteboard') return (0, $g0lm5.ContentIconRenderer)({
            type: 'whiteboard',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'database' || searchResult.icon === 'database') return (0, $g0lm5.ContentIconRenderer)({
            type: 'database',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'embed' || searchResult.icon === 'embed') return (0, $g0lm5.ContentIconRenderer)({
            type: 'embed',
            title: searchResult.title
        }) || '';
        if (searchResult?.type === 'folder' || searchResult.icon === 'folder') return (0, $g0lm5.ContentIconRenderer)({
            type: 'folder',
            title: searchResult.title
        }) || '';
        return searchResult.icon;
    };
    if (productState === 'PreQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: undefined,
            icon: (0, $g0lm5.ContentIconRenderer)({
                type: contentType,
                title: searchResult.title || '',
                size: 'small'
            })
        }
    });
    if (productState === 'PostQueryTyping' || productState === 'PostQueryLoading' || productState === 'PostQuerySuccess') return (0, $ejGzS.defaultResultRenderer)({
        ...rest,
        searchResult: {
            ...searchResult,
            additionalMeta: !!searchResult.isRecentResult ? formatMessage((0, $fib1y.i18n).recentlyViewed) : searchResult.additionalMeta,
            icon: !!searchResult.isRecentResult ? (0, $g0lm5.ContentIconRenderer)({
                type: contentType,
                title: searchResult.title || ''
            }) : renderContentIcon()
        }
    });
    return (0, $ejGzS.defaultResultRenderer)({
        searchResult: searchResult,
        ...rest
    });
};

});
parcelRegister("fib1y", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $a33223da5daebf45$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $a33223da5daebf45$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    recentlyWorkedOn: {
        id: "navigation-search-dialog.suppliers.recentlyWorkedOn",
        defaultMessage: "Recently worked on"
    },
    recentlyViewed: {
        id: "navigation-search-dialog.suppliers.recentlyViewed",
        defaultMessage: "Recently viewed"
    },
    contents: {
        id: "navigation-search-dialog.suppliers.contents",
        defaultMessage: "Content"
    },
    spaces: {
        id: "navigation-search-dialog.suppliers.spaces",
        defaultMessage: "Spaces"
    },
    people: {
        id: "navigation-search-dialog.suppliers.people",
        defaultMessage: "People"
    },
    confluenceSpace: {
        id: "navigation-search-dialog.quickfind.confluenceSpace",
        defaultMessage: "Confluence Space"
    },
    team: {
        id: "navigation-search-dialog.team",
        defaultMessage: "Team"
    }
});

});

parcelRegister("g0lm5", function(module, exports) {

$parcel$export(module.exports, "ContentIconRenderer", () => $6460b69e49ab179f$export$bf56fa242f0fc37d);
$parcel$export(module.exports, "GenericIconRenderer", () => $6460b69e49ab179f$export$e5d849fb708254a9);
/* IconRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $gj7hi = parcelRequire("gj7hi");

var $esRft = parcelRequire("esRft");

var $13WX1 = parcelRequire("13WX1");

var $5yCDo = parcelRequire("5yCDo");

var $hxQwS = parcelRequire("hxQwS");

var $bueVT = parcelRequire("bueVT");

var $8DZd1 = parcelRequire("8DZd1");

var $djgQ6 = parcelRequire("djgQ6");

var $2v58P = parcelRequire("2v58P");

var $8WOej = parcelRequire("8WOej");

var $33kwL = parcelRequire("33kwL");
const $6460b69e49ab179f$var$NegativeMargin = null;
const $6460b69e49ab179f$export$bf56fa242f0fc37d = ({ type: type, title: title, iconCssClass: iconCssClass, size: size = 'medium', imageSrc: imageSrc })=>{
    if (type === 'page' || type === 'confluence-page' || type === 'content') {
        const Icon = size === 'medium' ? (0, $5yCDo.default) : (0, $13WX1.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
            label: type
        });
    } else if (type === 'blogpost' || type === 'confluence-blogpost') {
        const Icon = size === 'medium' ? (0, $bueVT.default) : (0, $hxQwS.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
            label: type
        });
    } else if (type === 'whiteboard') // CTIA-142 - This will be swapped out when AK supports the whiteboard icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $33kwL.LegacyContentIcon), {
        size: size,
        type: "whiteboard",
        label: type
    });
    else if (type === 'database') // CTIA-142 - This will be swapped out when AK supports the database icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $33kwL.LegacyContentIcon), {
        size: size,
        type: "database",
        label: type
    });
    else if (type === 'embed') // CTIA-142 - This will be swapped out when AK supports the embed icon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $33kwL.LegacyContentIcon), {
        size: size,
        type: "embed",
        label: type
    });
    else if (type === 'folder') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $33kwL.LegacyContentIcon), {
        size: size,
        type: "folder",
        label: type
    });
    else if (type === 'jira') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2v58P.default), {
        label: type
    });
    else if (type === 'atlas') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        src: imageSrc || '',
        "aria-label": type,
        alt: type,
        width: "24px",
        height: "24px"
    });
    else if (type === 'attachment') {
        if (!iconCssClass) {
            const Icon = size === 'medium' ? (0, (/*@__PURE__*/$parcel$interopDefault($djgQ6))) : (0, (/*@__PURE__*/$parcel$interopDefault($8DZd1)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
                label: type
            });
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8WOej.AttachmentIcon), {
            mediaType: iconCssClass,
            title: title,
            size: size,
            label: type
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null);
};
const $6460b69e49ab179f$export$e5d849fb708254a9 = ({ iconUrl: iconUrl, size: size = 'small', appearance: appearance = 'square' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_18s81i6y _1e0c1txw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
        size: size,
        borderColor: "transparent",
        src: iconUrl,
        appearance: appearance,
        testId: "result-avatar"
    }));

});


parcelRegister("bB6dC", function(module, exports) {

$parcel$export(module.exports, "ActivitiesObjectType", () => $df938f5c6250aebc$export$4edf00fad4b97379);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $df938f5c6250aebc$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    return ActivitiesObjectType;
}({});

});

parcelRegister("2qgZ5", function(module, exports) {

$parcel$export(module.exports, "useConfluenceItemSuppliers", () => $38ca96c4d9c67f5e$export$4c9ff87550df51de);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $g9GR5 = parcelRequire("g9GR5");
var $cvntw = parcelRequire("cvntw");

var $91yhh = parcelRequire("91yhh");

var $9wGTI = parcelRequire("9wGTI");

var $gKr8t = parcelRequire("gKr8t");
var $7Sm4c = parcelRequire("7Sm4c");

var $jlIaF = parcelRequire("jlIaF");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $1HFOS = parcelRequire("1HFOS");

var $g0lm5 = parcelRequire("g0lm5");

var $2VPmd = parcelRequire("2VPmd");

var $e7whT = parcelRequire("e7whT");

var $fib1y = parcelRequire("fib1y");

var $9CKbz = parcelRequire("9CKbz");
const $38ca96c4d9c67f5e$var$RECENT_CONTENTS_FETCH_LIMIT = 100;
const $38ca96c4d9c67f5e$var$RECENT_SPACE_FETCH_LIMIT = 10;
const $38ca96c4d9c67f5e$var$MAX_RESULTS_CONTENTS = 10;
const $38ca96c4d9c67f5e$var$MAX_RESULTS_SPACES = 3;
const $38ca96c4d9c67f5e$var$recentContentsCCResultMapper = (edge)=>{
    const item = edge?.node?.object?.content;
    return {
        id: item?.id || '',
        title: item?.title || '',
        type: item?.type || '',
        url: `${0, $jlIaF.CONTEXT_PATH}${item?.links?.webui || ''}`,
        meta: item?.space?.name || '',
        additionalMeta: item?.type || '',
        containerId: item?.space?.id || '',
        icon: item?.type || '',
        isRecentResult: true
    };
};
const $38ca96c4d9c67f5e$var$recentSpaceCCResultMapper = (item)=>({
        id: item?.id || '',
        title: item?.name || '',
        type: 'space',
        meta: '',
        url: `${0, $jlIaF.CONTEXT_PATH}${item?.links?.webui || ''}`,
        containerId: item?.id || undefined,
        icon: (0, $g0lm5.GenericIconRenderer)({
            iconUrl: `${(0, $jlIaF.CONTEXT_PATH)}${item?.icon?.path || ''}`,
            size: 'xsmall'
        }),
        isRecentResult: true
    });
const $38ca96c4d9c67f5e$export$4c9ff87550df51de = ({ cloudId: cloudId, userId: userId, principalId: principalId = 'context', autocorrectEnabled: autocorrectEnabled = false, isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled, isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled, objectTypes: objectTypes })=>{
    const intl = (0, $dBxQj.default)();
    const confCloudClient = (0, $diswb.useApolloClient)();
    const aggClient = (0, $gKr8t.getAGGClient)();
    const workedOnAPIEnabled = false;
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const contentEntities = (0, $gwFzn.useMemo)(()=>[
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost',
            'ati:cloud:confluence:attachment',
            'ati:cloud:confluence:embed',
            'ati:cloud:confluence:folder',
            ...isQuickSearchForWhiteboardsEnabled ? [
                'ati:cloud:confluence:whiteboard'
            ] : [],
            ...isQuickSearchForDatabasesEnabled ? [
                'ati:cloud:confluence:database'
            ] : []
        ], [
        isQuickSearchForWhiteboardsEnabled,
        isQuickSearchForDatabasesEnabled
    ]);
    const preQueryItemSupplier = (0, $gwFzn.useCallback)(async ()=>{
        experienceTracker.start({
            name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY)
        });
        const { recentContents: recentContents, recentSpaces: recentSpaces } = !userId ? {
            recentContents: [],
            recentSpaces: []
        } : await confCloudClient.query({
            query: (0, $e7whT.RecentQuickSearchQuery),
            variables: {
                cloudId: cloudId,
                contentItemsLimit: $38ca96c4d9c67f5e$var$RECENT_CONTENTS_FETCH_LIMIT,
                spaceLimit: $38ca96c4d9c67f5e$var$RECENT_SPACE_FETCH_LIMIT,
                objectTypes: objectTypes,
                workedOnAPIEnabled: workedOnAPIEnabled
            }
        }).then((response)=>{
            const rawSpaces = response.data?.myVisitedSpaces?.nodes?.spaces;
            const rawContent = workedOnAPIEnabled ? response.data.activities?.myActivities?.workedOn?.edges : response.data.activities?.myActivities?.viewed?.edges;
            const filteredRawContent = rawContent && rawContent.filter(// #help-work-platform suggested handling null content in FE while they investigate why some results are being returned null
            (edge)=>!(edge?.node?.object?.content?.status === 'trashed') && !(edge?.node?.object?.content === null));
            return {
                recentContents: filteredRawContent?.map($38ca96c4d9c67f5e$var$recentContentsCCResultMapper) || [],
                recentSpaces: rawSpaces?.map($38ca96c4d9c67f5e$var$recentSpaceCCResultMapper) || []
            };
        }).catch((error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY),
                error: error
            });
            // error is handled by the platform PSD component
            (0, $7Sm4c.markErrorAsHandled)(error);
            // The error will bubble up and the parent component will catch the error and handle it
            throw error;
        });
        experienceTracker.succeed({
            name: (0, $irVI7.QUICK_SEARCH_PRE_QUERY)
        });
        return {
            sections: [
                {
                    id: 'recent-confluence-items',
                    title: workedOnAPIEnabled ? intl.formatMessage((0, $fib1y.i18n).recentlyWorkedOn) : intl.formatMessage((0, $fib1y.i18n).recentlyViewed),
                    searchResults: recentContents,
                    resultLimit: $38ca96c4d9c67f5e$var$MAX_RESULTS_CONTENTS,
                    titleRenderer: (0, $9CKbz.ConfluenceTitleRenderer)(autocorrectEnabled, workedOnAPIEnabled, intl.formatMessage),
                    resultRenderer: (0, $2VPmd.ConfluenceResultRenderer)
                },
                {
                    id: 'recent-confluence-spaces',
                    title: intl.formatMessage((0, $fib1y.i18n).spaces),
                    searchResults: recentSpaces,
                    resultLimit: $38ca96c4d9c67f5e$var$MAX_RESULTS_SPACES
                }
            ]
        };
    }, [
        confCloudClient,
        cloudId,
        userId,
        intl,
        autocorrectEnabled,
        experienceTracker,
        workedOnAPIEnabled,
        objectTypes
    ]);
    const { backendExperiment: staticBackendExperiment } = (0, $91yhh.useExperiments)();
    const { backendExperiment: dynamicBackendExperiment } = (0, $1HFOS.useDynamicBackendExperiment)({
        cloudId: cloudId,
        entities: contentEntities,
        userId: userId || undefined,
        experience: 'quick-search'
    }) || {};
    const backendExperiment = (0, $9wGTI.fg)('confluence_search-scalable-statsig-layers') ? dynamicBackendExperiment : staticBackendExperiment;
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const searchClientConfig = {
        graphQLEnabled: true,
        graphQLPromise: (args)=>aggClient.query({
                query: (0, $cvntw.ConfluenceQuickSearchQuery),
                variables: (0, $g9GR5.confluenceGraphQLSearchVariablesMapper)({
                    ...args,
                    cloudId: cloudId,
                    contentEntities: contentEntities,
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                            name: name,
                            layerId: layerId,
                            shadowId: shadowId,
                            definitions: definitions
                        })),
                    isLivePagesEnabled: (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in')
                })
            }).then((response)=>response.data),
        cloudId: cloudId,
        userId: principalId
    };
    return {
        experimentLayers: !(0, $9wGTI.fg)('confluence_search-scalable-statsig-layers') ? undefined : backendExperiment?.experimentLayers?.map((layer)=>{
            const { analyticsDefinitions: analyticsDefinitions, definitions: definitions, ...rest } = layer;
            return {
                ...rest,
                definitions: analyticsDefinitions
            };
        }),
        preQueryItemSupplier: preQueryItemSupplier,
        searchClientConfig: searchClientConfig
    };
};

});
parcelRegister("g9GR5", function(module, exports) {

$parcel$export(module.exports, "hasCheckedFilters", () => $448834a0f6f65d76$export$74c39e342047d9d1);
$parcel$export(module.exports, "confluenceGraphQLSearchVariablesMapper", () => $448834a0f6f65d76$export$76ca4f6f223de78a);

var $1U1CQ = parcelRequire("1U1CQ");
const $448834a0f6f65d76$var$CONFLUENCE_ARI_PREFIX = 'ari:cloud:confluence::site/';
const $448834a0f6f65d76$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS = 10;
const $448834a0f6f65d76$var$MAX_RESULTS_SPACES = 3;
const $448834a0f6f65d76$export$71fb3a6d48f3d84f = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment'
];
const $448834a0f6f65d76$var$graphQLFilterMapper = (filters)=>{
    const confluenceFilters = {};
    filters.forEach((filter)=>{
        switch(filter['@type']){
            case 'spaces':
                confluenceFilters['spacesFilter'] = filter.spaceKeys;
                break;
            case 'verified':
                confluenceFilters['isVerified'] = filter.verified;
                break;
            case 'contributors':
                confluenceFilters['contributorsFilter'] = filter.accountIds;
                break;
            case 'lastModified':
                confluenceFilters['range'] = {
                    field: (0, $1U1CQ.ConfluenceGraphQLDateFilterFieldType).LASTMODIFIED,
                    gt: filter.from,
                    lt: filter.to
                };
                break;
            case 'titleMatchOnly':
                confluenceFilters['titleMatchOnly'] = filter.enabled;
                break;
            case 'pageStatus':
                confluenceFilters['pageStatus'] = filter.pageStatus;
                break;
            default:
                break;
        }
    });
    return confluenceFilters;
};
const $448834a0f6f65d76$export$74c39e342047d9d1 = (filters)=>filters.some((filter)=>{
        if (filter['@type'] === 'spaces' && filter.spaceKeys && filter.spaceKeys.length > 0) return true;
        else if (filter['@type'] === 'contributors' && filter.accountIds && filter.accountIds.length > 0) return true;
        else if (filter['@type'] === 'lastModified' && filter.from && filter.to) return true;
        return false;
    });
const $448834a0f6f65d76$export$76ca4f6f223de78a = ({ query: query, filters: filters, contentEntities: contentEntities = $448834a0f6f65d76$export$71fb3a6d48f3d84f, analyticsInfo: analyticsInfo, cloudId: cloudId, pageBlogAttachmentLimit: pageBlogAttachmentLimit = $448834a0f6f65d76$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS, spaceLimit: spaceLimit = $448834a0f6f65d76$var$MAX_RESULTS_SPACES, includeAncestors: includeAncestors = false, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, isLivePagesEnabled: isLivePagesEnabled = false })=>{
    return {
        query: query,
        cloudIdARI: `${$448834a0f6f65d76$var$CONFLUENCE_ARI_PREFIX}${cloudId}`,
        pageBlogAttachmentLimit: pageBlogAttachmentLimit,
        spaceLimit: spaceLimit,
        includeAncestors: includeAncestors,
        contentEntities: contentEntities,
        confluenceFilters: $448834a0f6f65d76$var$graphQLFilterMapper(filters),
        searchSessionId: analyticsInfo?.searchSessionId,
        queryVersion: analyticsInfo?.queryVersion,
        includeSpaces: !$448834a0f6f65d76$export$74c39e342047d9d1(filters),
        isLivePagesEnabled: isLivePagesEnabled,
        experimentContext: {
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers
        }
    };
};

});
parcelRegister("1U1CQ", function(module, exports) {

$parcel$export(module.exports, "ConfluenceGraphQLDateFilterFieldType", () => $d70deb832e9cbf50$export$c23e925a9f49ee3c);
var $d70deb832e9cbf50$export$c23e925a9f49ee3c = /*#__PURE__*/ function(ConfluenceGraphQLDateFilterFieldType) {
    ConfluenceGraphQLDateFilterFieldType["LASTMODIFIED"] = "LASTMODIFIED";
    ConfluenceGraphQLDateFilterFieldType["CREATED"] = "CREATED,";
    return ConfluenceGraphQLDateFilterFieldType;
}({});

});


parcelRegister("cvntw", function(module, exports) {

$parcel$export(module.exports, "ConfluenceQuickSearchQuery", () => $701861e6cdd6ef14$export$913ed806993df47d);

var $d2LG0 = parcelRequire("d2LG0");
const $701861e6cdd6ef14$export$913ed806993df47d = (0, $d2LG0.default)`query ConfluenceQuickSearchQuery($query:String!$cloudIdARI:String!$pageBlogAttachmentLimit:Int!$spaceLimit:Int!$contentEntities:[String!]!$confluenceFilters:SearchConfluenceFilter$queryVersion:Int$searchSessionId:String$includeSpaces:Boolean!$includeAncestors:Boolean!$experimentContext:SearchExperimentContextInput$isLivePagesEnabled:Boolean!){search{pageBlogAttachments:search(experience:"product-search-dialog" query:$query first:$pageBlogAttachmentLimit filters:{entities:$contentEntities locations:[$cloudIdARI]confluenceFilters:$confluenceFilters}analytics:{queryVersion:$queryVersion searchSessionId:$searchSessionId}experimentContext:$experimentContext){edges{node{...on SearchConfluencePageBlogAttachment{id title type url lastModified iconCssClass space{id name}confluenceEntity{...on ConfluencePage{id subtype@include(if:$isLivePagesEnabled)ancestors@include(if:$includeAncestors){id title}}}}}}abTest{abTestId controlId experimentId}totalCount}spaces:search(experience:"searchDialog" query:$query first:$spaceLimit filters:{entities:["ati:cloud:confluence:space"]locations:[$cloudIdARI]}analytics:{queryVersion:$queryVersion searchSessionId:$searchSessionId})@include(if:$includeSpaces){edges{node{...on SearchConfluenceSpace{id key title type url iconPath}}}}}}`;

});

parcelRegister("e7whT", function(module, exports) {

$parcel$export(module.exports, "RecentQuickSearchQuery", () => $6a84866f2cdf6d7e$export$b4cc117e80f3c39f);

var $d2LG0 = parcelRequire("d2LG0");
const $6a84866f2cdf6d7e$export$b4cc117e80f3c39f = (0, $d2LG0.default)`query RecentQuickSearchQuery($cloudId:ID!$contentItemsLimit:Int!$spaceLimit:Int!$objectTypes:[ActivitiesObjectType!]$workedOnAPIEnabled:Boolean!){activities{myActivities{viewed(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]}}]first:$contentItemsLimit)@skip(if:$workedOnAPIEnabled){edges{node{id object{id content{id title links{webui}type space{id name}status}}}}}workedOn(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]}}]first:$contentItemsLimit)@include(if:$workedOnAPIEnabled){edges{node{id object{id content{id title links{webui}type space{id name}status}}}}}}}myVisitedSpaces(limit:$spaceLimit){nodes{spaces{id key name icon{path}links{webui}}}}}`;

});

parcelRegister("9CKbz", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTitleRenderer", () => $f5220b530c5db4b0$export$b25447981a133bbe);

var $gwFzn = parcelRequire("gwFzn");

var $21MH9 = parcelRequire("21MH9");
var $eEbYb = parcelRequire("eEbYb");

var $fib1y = parcelRequire("fib1y");
const $f5220b530c5db4b0$export$b25447981a133bbe = (autocorrectEnabled, workedOnAPIEnabled, formatMessage)=>({ productState: productState })=>{
        const recentlyViewedTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, workedOnAPIEnabled ? formatMessage((0, $fib1y.i18n).recentlyWorkedOn) : formatMessage((0, $fib1y.i18n).recentlyViewed));
        const pageBlogAttachmentTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, formatMessage((0, $fib1y.i18n).contents));
        if (productState === 'PreQuerySuccess') return recentlyViewedTitle;
        if (autocorrectEnabled) {
            if (productState === 'PostQueryLoading') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEbYb.LoadingSkeleton), {
                "data-testid": "autocorrection-loading-skeleton"
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $21MH9.AutocorrectAsyncWrapper), {
                fallback: pageBlogAttachmentTitle
            });
        }
        return pageBlogAttachmentTitle;
    };

});


parcelRegister("4XEM3", function(module, exports) {

$parcel$export(module.exports, "useConfluenceScopes", () => $0508fd4bbb3caedf$export$303ed8cbfd5b717a);
const $0508fd4bbb3caedf$export$303ed8cbfd5b717a = ({ isQuickSearchForWhiteboardsEnabled: isQuickSearchForWhiteboardsEnabled, isQuickSearchForDatabasesEnabled: isQuickSearchForDatabasesEnabled })=>{
    let contentScope = 'confluence.page,blogpost,attachment,embed,folder';
    const spaceAndUserScope = [
        'confluence.space',
        'urs.user-confluence'
    ];
    if (isQuickSearchForWhiteboardsEnabled) contentScope = `${contentScope},whiteboard`;
    if (isQuickSearchForDatabasesEnabled) contentScope = `${contentScope},database`;
    return {
        contentScope: contentScope,
        extensibleScopes: [
            contentScope,
            ...spaceAndUserScope
        ]
    };
};

});

parcelRegister("5jHnK", function(module, exports) {

$parcel$export(module.exports, "ExperimentLayersAnalyticsListener", () => $4875423f526257e1$export$4f8d571a44f08abe);

var $gwFzn = parcelRequire("gwFzn");

var $3pfAb = parcelRequire("3pfAb");

var $kDuN4 = parcelRequire("kDuN4");

var $9wGTI = parcelRequire("9wGTI");
const $4875423f526257e1$export$4f8d571a44f08abe = ({ experimentLayers: experimentLayers, children: children })=>{
    const handleEvent = (0, $gwFzn.useCallback)((event)=>{
        // Do not update the event if dynamic config is not being used
        if (!(0, $9wGTI.fg)('confluence_search-scalable-statsig-layers')) return;
        const action = event.payload.action;
        const actionSubject = event.payload.actionSubject;
        const actionSubjectId = event.payload.actionSubjectId;
        const isQuickFind = event.payload.attributes?.isQuickFind;
        // Do not update the event if its not a searchResults shown event on Quick Search
        if (actionSubject !== 'searchResults' || action !== 'shown' || actionSubjectId !== 'postQuerySearchResults' || isQuickFind) return;
        event.update((payload)=>{
            return {
                ...payload,
                attributes: {
                    ...payload.attributes,
                    backendExperiments: {
                        experimentLayers: experimentLayers
                    },
                    abTest: undefined
                }
            };
        });
    }, [
        experimentLayers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $3pfAb.FabricChannel).elements
    }, children);
};

});




//# sourceMappingURL=SearchComponent.d116034e.js.map
